// Generated by scripts/sync-catalog-sitemap.mjs - do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
// Keys are `{providerSlug}/{gameSlug}` - game slugs are not unique across providers.
export const gamesSlugMap = {
    "1x2gaming/420_blaze_it": {
        slug: "420_blaze_it",
        name: "420 Blaze It",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/arctic_fruits": {
        slug: "arctic_fruits",
        name: "Arctic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/asgard_warriors": {
        slug: "asgard_warriors",
        name: "Asgard Warriors",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/battle_maidens_cleopatra": {
        slug: "battle_maidens_cleopatra",
        name: "Battle Maidens: Cleopatra",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/battle_maidens_cleopatra_no_buy_feature": {
        slug: "battle_maidens_cleopatra_no_buy_feature",
        name: "Battle Maidens Cleopatra (No buy feature)",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blazing_777": {
        slug: "blazing_777",
        name: "Blazing 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/blood_rage": {
        slug: "blood_rage",
        name: "Blood Rage",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/candycash": {
        slug: "candycash",
        name: "CandyCash",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/classic_fruits": {
        slug: "classic_fruits",
        name: "Classic Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/disco_777": {
        slug: "disco_777",
        name: "Disco 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fields_of_clover": {
        slug: "fields_of_clover",
        name: "Fields of clover",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/football_3x3": {
        slug: "football_3x3",
        name: "Football 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fruit_snapz": {
        slug: "fruit_snapz",
        name: "Fruit Snapz",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/fruity_3x3": {
        slug: "fruity_3x3",
        name: "Fruity 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/gingerbread_joy": {
        slug: "gingerbread_joy",
        name: "Gingerbread Joy",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/ice_queen": {
        slug: "ice_queen",
        name: "Ice Queen",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/italia_3x3": {
        slug: "italia_3x3",
        name: "Italia 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jackpot_3x3": {
        slug: "jackpot_3x3",
        name: "Jackpot 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jesters_wilds": {
        slug: "jesters_wilds",
        name: "Jesters Wilds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/jewel_of_athena": {
        slug: "jewel_of_athena",
        name: "Jewel of Athena",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/leprechaun_charms": {
        slug: "leprechaun_charms",
        name: "Leprechaun Charms",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/lucky_streaks": {
        slug: "lucky_streaks",
        name: "Lucky Streaks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/medieval_mania": {
        slug: "medieval_mania",
        name: "Medieval Mania",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/megablox_777": {
        slug: "megablox_777",
        name: "MegaBlox 777",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/megablox_pyramids": {
        slug: "megablox_pyramids",
        name: "Megablox Pyramids",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/phoenix_inferno": {
        slug: "phoenix_inferno",
        name: "Phoenix Inferno",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/pirate_armada": {
        slug: "pirate_armada",
        name: "Pirate Armada",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/plinko_go": {
        slug: "plinko_go",
        name: "Plinko Go",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/puppy_payday": {
        slug: "puppy_payday",
        name: "Puppy Payday",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/queen_of_embers": {
        slug: "queen_of_embers",
        name: "Queen of Embers",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/rainbow_3x3": {
        slug: "rainbow_3x3",
        name: "Rainbow 3X3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/reel_diamonds": {
        slug: "reel_diamonds",
        name: "Reel Diamonds",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/reel_fruits": {
        slug: "reel_fruits",
        name: "Reel Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits": {
        slug: "smoking_hot_fruits",
        name: "Smoking Hot Fruits",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_20_lines": {
        slug: "smoking_hot_fruits_20_lines",
        name: "Smoking Hot Fruits 20 Lines",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_stacks": {
        slug: "smoking_hot_fruits_stacks",
        name: "Smoking Hot Fruits Stacks",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/smoking_hot_fruits_wild_respins": {
        slug: "smoking_hot_fruits_wild_respins",
        name: "Smoking Hot Fruits Wild Respins",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/sparkling_777s": {
        slug: "sparkling_777s",
        name: "Sparkling 777s",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/spino_cricket": {
        slug: "spino_cricket",
        name: "Spino Cricket",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/stellar_ways": {
        slug: "stellar_ways",
        name: "Stellar Ways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/super_rainbow_megaways": {
        slug: "super_rainbow_megaways",
        name: "Super Rainbow Megaways",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/theseus_rises": {
        slug: "theseus_rises",
        name: "Theseus Rises",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/trawler_fishin": {
        slug: "trawler_fishin",
        name: "Trawler Fishin'",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/triple_bar": {
        slug: "triple_bar",
        name: "Triple Bar",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/van_helsings_book_of_the_undead": {
        slug: "van_helsings_book_of_the_undead",
        name: "Van Helsing's Book Of The Undead",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/virtual_football_pro": {
        slug: "virtual_football_pro",
        name: "Virtual Football Pro",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/virtual_soccer": {
        slug: "virtual_soccer",
        name: "Virtual Soccer",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/whisker_jones": {
        slug: "whisker_jones",
        name: "Whisker jones",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/xmas_3x3": {
        slug: "xmas_3x3",
        name: "Xmas 3x3",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "1x2gaming/xwild": {
        slug: "xwild",
        name: "X-Wild",
        provider: "1X2gaming",
        providerSlug: "1x2gaming"
    },
    "4theplayer/100_bit_dice": {
        slug: "100_bit_dice",
        name: "100 Bit Dice",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000_bc_2_doublemax": {
        slug: "10000_bc_2_doublemax",
        name: "10000 BC 2 Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000_bc_doublemax": {
        slug: "10000_bc_doublemax",
        name: "10000 BC Doublemax",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000x_gold": {
        slug: "10000x_gold",
        name: "10000x Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10000x_gold_2": {
        slug: "10000x_gold_2",
        name: "10000X Gold 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/1000x_busta": {
        slug: "1000x_busta",
        name: "1000x Busta",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/10x_rewind": {
        slug: "10x_rewind",
        name: "10X Rewind",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/12_trojan_mysteries": {
        slug: "12_trojan_mysteries",
        name: "12 Trojan Mysteries",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/123_boom": {
        slug: "123_boom",
        name: "123 Boom",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/2_sweet_4_u": {
        slug: "2_sweet_4_u",
        name: "2 Sweet 4 U",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/21_thor_lightning_ways": {
        slug: "21_thor_lightning_ways",
        name: "21 Thor Lightning Ways",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_lucky_leprechauns": {
        slug: "3_lucky_leprechauns",
        name: "3 Lucky Leprechauns",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_lucky_witches": {
        slug: "3_lucky_witches",
        name: "3 Lucky Witches",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/3_secret_cities": {
        slug: "3_secret_cities",
        name: "3 Secret Cities",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_deals_with_the_devil": {
        slug: "4_deals_with_the_devil",
        name: "4 Deals With The Devil",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish": {
        slug: "4_fantastic_fish",
        name: "4 Fantastic Fish",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_amazon_adventure": {
        slug: "4_fantastic_fish_amazon_adventure",
        name: "4 Fantastic Fish Amazon Adventure",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_gigablox": {
        slug: "4_fantastic_fish_gigablox",
        name: "4 Fantastic Fish Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_gold": {
        slug: "4_fantastic_fish_gold",
        name: "4 Fantastic Fish Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_fish_in_egypt": {
        slug: "4_fantastic_fish_in_egypt",
        name: "4 Fantastic Fish in Egypt",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_vikings_go_fishing": {
        slug: "4_fantastic_vikings_go_fishing",
        name: "4 Fantastic Vikings Go Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_fantastic_vikings_go_ice_fishing": {
        slug: "4_fantastic_vikings_go_ice_fishing",
        name: "4 Fantastic Vikings Go Ice Fishing",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_pirate_chests": {
        slug: "4_pirate_chests",
        name: "4 Pirate Chests",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4_secret_pyramids": {
        slug: "4_secret_pyramids",
        name: "4 Secret Pyramids",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4k_ultra_gold": {
        slug: "4k_ultra_gold",
        name: "4K Ultra Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_book_of_africra": {
        slug: "4tp_book_of_africra",
        name: "4TP Book of AfricRa",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_guns_n_gold": {
        slug: "4tp_guns_n_gold",
        name: "4TP Guns N Gold",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/4tp_railroad_robbery": {
        slug: "4tp_railroad_robbery",
        name: "4TP Railroad Robbery",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_doggy_dollars": {
        slug: "5_doggy_dollars",
        name: "5 Doggy Dollars",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo": {
        slug: "5_wild_buffalo",
        name: "5 Wild Buffalo",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo_2": {
        slug: "5_wild_buffalo_2",
        name: "5 Wild Buffalo 2",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo_3": {
        slug: "5_wild_buffalo_3",
        name: "5 Wild Buffalo 3",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_buffalo_dream_drop": {
        slug: "5_wild_buffalo_dream_drop",
        name: "5 Wild Buffalo Dream Drop",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5_wild_wolves": {
        slug: "5_wild_wolves",
        name: "5 Wild Wolves",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/5k_gold_mine": {
        slug: "5k_gold_mine",
        name: "5K Gold Mine",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/6_wild_sharks": {
        slug: "6_wild_sharks",
        name: "6 Wild Sharks",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/60_second_heist": {
        slug: "60_second_heist",
        name: "60 Second Heist",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_elements": {
        slug: "7_elements",
        name: "7 Elements",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_gold_fruits": {
        slug: "7_gold_fruits",
        name: "7 Gold Fruits",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7_gold_gigablox": {
        slug: "7_gold_gigablox",
        name: "7 Gold Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7x7_thor": {
        slug: "7x7_thor",
        name: "7x7 Thor",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7x7_zeus": {
        slug: "7x7_zeus",
        name: "7x7 Zeus",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/7x7_zeus_max": {
        slug: "7x7_zeus_max",
        name: "7x7 Zeus Max",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/8k_ultra_gold_ultimate": {
        slug: "8k_ultra_gold_ultimate",
        name: "8K Ultra Gold Ultimate",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/90k_yeti_gigablox": {
        slug: "90k_yeti_gigablox",
        name: "90k Yeti Gigablox",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/9k_kong_in_vegas": {
        slug: "9k_kong_in_vegas",
        name: "9k Kong In Vegas",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/9k_wild_yeti_dream_drop": {
        slug: "9k_wild_yeti_dream_drop",
        name: "9K Wild Yeti Dream Drop",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "4theplayer/9k_yeti": {
        slug: "9k_yeti",
        name: "9k Yeti",
        provider: "4ThePlayer",
        providerSlug: "4theplayer"
    },
    "adlunam/coinsweeper": {
        slug: "coinsweeper",
        name: "Coinsweeper",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/flip_n_spin": {
        slug: "flip_n_spin",
        name: "Flip n Spin",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/maverick": {
        slug: "maverick",
        name: "Maverick",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/maverick_x": {
        slug: "maverick_x",
        name: "Maverick X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/pin_rush_x": {
        slug: "pin_rush_x",
        name: "Pin Rush X",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "adlunam/rock_paper_scissors_draw": {
        slug: "rock_paper_scissors_draw",
        name: "Rock Paper Scissors Draw",
        provider: "AdLunam",
        providerSlug: "adlunam"
    },
    "avatarux/10_power_joker": {
        slug: "10_power_joker",
        name: "10 Power Joker",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/20_power_joker": {
        slug: "20_power_joker",
        name: "20 Power Joker",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_builder_piggies": {
        slug: "3_builder_piggies",
        name: "3 Builder Piggies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_chili_charms": {
        slug: "3_chili_charms",
        name: "3 Chili Charms",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_jungle_beats": {
        slug: "3_jungle_beats",
        name: "3 Jungle Beats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_bears": {
        slug: "3_power_bears",
        name: "3 Power Bears",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_dragons": {
        slug: "3_power_dragons",
        name: "3 Power Dragons",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_power_genies": {
        slug: "3_power_genies",
        name: "3 Power Genies",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/3_rockin_penguins": {
        slug: "3_rockin_penguins",
        name: "3 Rockin Penguins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/40_power_joker": {
        slug: "40_power_joker",
        name: "40 Power Joker",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/5_power_joker": {
        slug: "5_power_joker",
        name: "5 Power Joker",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/7_lucky_gods": {
        slug: "7_lucky_gods",
        name: "7 Lucky Gods",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/80spop": {
        slug: "80spop",
        name: "80sPOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/animals_strike": {
        slug: "animals_strike",
        name: "Animals Strike",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/arcanapop": {
        slug: "arcanapop",
        name: "ArcanaPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/astropop": {
        slug: "astropop",
        name: "AstroPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/beastly_burglars": {
        slug: "beastly_burglars",
        name: "Beastly Burglars",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/big_catch_craze": {
        slug: "big_catch_craze",
        name: "Big Catch Craze",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/big_catch_xmas": {
        slug: "big_catch_xmas",
        name: "Big Catch Xmas",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/blessings_of_caishen": {
        slug: "blessings_of_caishen",
        name: "Blessings of Caishen",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/blondes_and_beers": {
        slug: "blondes_and_beers",
        name: "Blondes and Beers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/bounty_pop": {
        slug: "bounty_pop",
        name: "Bounty Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/canyon_riches": {
        slug: "canyon_riches",
        name: "Canyon Riches",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/captain_moregain": {
        slug: "captain_moregain",
        name: "Captain More'gain",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/carioca_vibes": {
        slug: "carioca_vibes",
        name: "Carioca Vibes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherry_pop": {
        slug: "cherry_pop",
        name: "Cherry Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherry_pop_deluxe": {
        slug: "cherry_pop_deluxe",
        name: "Cherry Pop Deluxe",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cherrypop_burst": {
        slug: "cherrypop_burst",
        name: "CherryPop Burst",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/corpse_cart": {
        slug: "corpse_cart",
        name: "Corpse Cart",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/cosmic_jokers": {
        slug: "cosmic_jokers",
        name: "Cosmic Jokers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/coyote_gold": {
        slug: "coyote_gold",
        name: "Coyote Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crazy_mart_bonanza": {
        slug: "crazy_mart_bonanza",
        name: "Crazy Mart Bonanza",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/critter_pop": {
        slug: "critter_pop",
        name: "Critter Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_bro": {
        slug: "crypto_bro",
        name: "Crypto Bro",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_10": {
        slug: "crypto_crown_10",
        name: "Crypto Crown 10",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_20": {
        slug: "crypto_crown_20",
        name: "Crypto Crown 20",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_40": {
        slug: "crypto_crown_40",
        name: "Crypto Crown 40",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/crypto_crown_5": {
        slug: "crypto_crown_5",
        name: "Crypto Crown 5",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/depths_of_fortune": {
        slug: "depths_of_fortune",
        name: "Depths of Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/depths_of_fortune_2": {
        slug: "depths_of_fortune_2",
        name: "Depths of Fortune 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/diamond_dez": {
        slug: "diamond_dez",
        name: "Diamond Dez",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/donkey_and_the_goats": {
        slug: "donkey_and_the_goats",
        name: "Donkey & The Goats",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/duck_hunt_500": {
        slug: "duck_hunt_500",
        name: "Duck Hunt 500",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/dyna_mule": {
        slug: "dyna_mule",
        name: "Dyna Mule",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/electric_rush": {
        slug: "electric_rush",
        name: "Electric Rush",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/electro_cubes": {
        slug: "electro_cubes",
        name: "Electro Cubes",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/floridaman": {
        slug: "floridaman",
        name: "Floridaman",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/fruitillionaire": {
        slug: "fruitillionaire",
        name: "Fruitillionaire",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/gempops": {
        slug: "gempops",
        name: "GemPOPs",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/gods_gone_wild": {
        slug: "gods_gone_wild",
        name: "Gods Gone Wild",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/heliopopolis": {
        slug: "heliopopolis",
        name: "HelioPOPolis",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/hiphop_pop": {
        slug: "hiphop_pop",
        name: "Hip-Hop Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/hippo_pop": {
        slug: "hippo_pop",
        name: "Hippo Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/imperial_coins": {
        slug: "imperial_coins",
        name: "Imperial Coins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/jinglepop": {
        slug: "jinglepop",
        name: "JinglePOP",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/juicypop": {
        slug: "juicypop",
        name: "JuicyPop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/king_of_samba": {
        slug: "king_of_samba",
        name: "King of Samba",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/kittypopins": {
        slug: "kittypopins",
        name: "KittyPOPins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/kokeshi_pop": {
        slug: "kokeshi_pop",
        name: "Kokeshi Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/lolli_pop": {
        slug: "lolli_pop",
        name: "Lolli Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/looney_pop": {
        slug: "looney_pop",
        name: "Looney Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/majestic_meow": {
        slug: "majestic_meow",
        name: "Majestic Meow",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/midnight_hunt": {
        slug: "midnight_hunt",
        name: "Midnight Hunt",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/monkey_pop": {
        slug: "monkey_pop",
        name: "Monkey Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/monkeypop_2": {
        slug: "monkeypop_2",
        name: "MonkeyPop 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/nugget": {
        slug: "nugget",
        name: "Nugget",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/papaya_pop": {
        slug: "papaya_pop",
        name: "Papaya Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggy_pop": {
        slug: "piggy_pop",
        name: "Piggy Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggy_pop_grand_affair_2": {
        slug: "piggy_pop_grand_affair_2",
        name: "Piggy Pop Grand Affair 2",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/piggypop_grand_affair": {
        slug: "piggypop_grand_affair",
        name: "PiggyPop Grand Affair",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pixel_paws": {
        slug: "pixel_paws",
        name: "Pixel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pixiepop": {
        slug: "pixiepop",
        name: "PixiePop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_noir": {
        slug: "pop_noir",
        name: "Pop Noir",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_ogold": {
        slug: "pop_ogold",
        name: "Pop o'Gold",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pop_rocks": {
        slug: "pop_rocks",
        name: "Pop Rocks",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pots_of_power_dragons_blessing": {
        slug: "pots_of_power_dragons_blessing",
        name: "Pots of Power: Dragon’s Blessing",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pots_of_power_mummys_treasure": {
        slug: "pots_of_power_mummys_treasure",
        name: "Pots of Power: Mummy's Treasure",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/pots_of_power_zeus": {
        slug: "pots_of_power_zeus",
        name: "Pots of Power Zeus",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/prince_of_purrwood": {
        slug: "prince_of_purrwood",
        name: "Prince of Purrwood",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/raging_pop": {
        slug: "raging_pop",
        name: "Raging Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/rebel_paws": {
        slug: "rebel_paws",
        name: "Rebel Paws",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/reef_pop": {
        slug: "reef_pop",
        name: "Reef Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/reel_warriors": {
        slug: "reel_warriors",
        name: "Reel Warriors",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/shippy_d_pop": {
        slug: "shippy_d_pop",
        name: "Shippy D Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/silicon_spinners": {
        slug: "silicon_spinners",
        name: "Silicon Spinners",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/sphinx_treasure": {
        slug: "sphinx_treasure",
        name: "Sphinx Treasure",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/spinfection": {
        slug: "spinfection",
        name: "Spinfection",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/spinxiety": {
        slug: "spinxiety",
        name: "Spinxiety",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/sweet_gummy": {
        slug: "sweet_gummy",
        name: "Sweet Gummy",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/the_vault_chase": {
        slug: "the_vault_chase",
        name: "The Vault Chase",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tik_talkers": {
        slug: "tik_talkers",
        name: "Tik Talkers",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tiki_pop": {
        slug: "tiki_pop",
        name: "Tiki Pop",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/tikipop_spooky_temples": {
        slug: "tikipop_spooky_temples",
        name: "TikiPop Spooky Temples",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/toads_bounty": {
        slug: "toads_bounty",
        name: "Toad's Bounty",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/vegas_fortune": {
        slug: "vegas_fortune",
        name: "Vegas Fortune",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/wild_pops": {
        slug: "wild_pops",
        name: "Wild Pops",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/witchy_poppins": {
        slug: "witchy_poppins",
        name: "Witchy POPpins",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/worms_of_valor": {
        slug: "worms_of_valor",
        name: "Worms of Valor",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/xmas_pop_delight": {
        slug: "xmas_pop_delight",
        name: "Xmas Pop Delight",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "avatarux/zombie_apopalypse": {
        slug: "zombie_apopalypse",
        name: "Zombie aPOPalypse",
        provider: "AvatarUX",
        providerSlug: "avatarux"
    },
    "aviator/aviator": {
        slug: "aviator",
        name: "Aviator",
        provider: "Aviator",
        providerSlug: "aviator"
    },
    "aviatrix/aviatrix_fortunes": {
        slug: "aviatrix_fortunes",
        name: "Aviatrix Fortunes",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/aviatrix_fruits": {
        slug: "aviatrix_fruits",
        name: "Aviatrix Fruits",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/aviatrix_mines": {
        slug: "aviatrix_mines",
        name: "Aviatrix Mines",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/nft_aviatrix": {
        slug: "nft_aviatrix",
        name: "NFT Aviatrix",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "aviatrix/second_chance": {
        slug: "second_chance",
        name: "Second Chance",
        provider: "Aviatrix",
        providerSlug: "aviatrix"
    },
    "bang-bang-games/almighty_thunder_ultrahitz_gigablox": {
        slug: "almighty_thunder_ultrahitz_gigablox",
        name: "Almighty Thunder UltraHitz Gigablox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/ancient_eclipse": {
        slug: "ancient_eclipse",
        name: "Ancient Eclipse",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/arctic_catch": {
        slug: "arctic_catch",
        name: "Arctic Catch",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/caribbean_crush": {
        slug: "caribbean_crush",
        name: "Caribbean Crush",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/chilli_champions_ultrahitz": {
        slug: "chilli_champions_ultrahitz",
        name: "Chilli Champions UltraHitz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/fiesta_explosiva_duomax": {
        slug: "fiesta_explosiva_duomax",
        name: "Fiesta Explosiva DuoMax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/fire_wilds": {
        slug: "fire_wilds",
        name: "Fire Wilds",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jekyllz_wild_ultranudge": {
        slug: "jekyllz_wild_ultranudge",
        name: "Jekyllz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jokrz_wild_ultranudge": {
        slug: "jokrz_wild_ultranudge",
        name: "Jokrz Wild UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jokrz_wild_ultranudge_gigablox": {
        slug: "jokrz_wild_ultranudge_gigablox",
        name: "Jokrz Wild Ultranudge GigaBlox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/jumbo_jellies": {
        slug: "jumbo_jellies",
        name: "Jumbo Jellies",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/mutant_trawlers": {
        slug: "mutant_trawlers",
        name: "Mutant Trawlers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pharaohs_gaze_doublemax": {
        slug: "pharaohs_gaze_doublemax",
        name: "Pharaoh's Gaze Doublemax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pharaohs_rage_ultraspinz": {
        slug: "pharaohs_rage_ultraspinz",
        name: "Pharaoh's Rage Ultraspinz",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/pulled_from_the_deep_ultranudge": {
        slug: "pulled_from_the_deep_ultranudge",
        name: "Pulled from the Deep Ultranudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/rainbow_power_potz_ultranudge": {
        slug: "rainbow_power_potz_ultranudge",
        name: "Rainbow Power Potz UltraNudge",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/shadow_raiders_multimax": {
        slug: "shadow_raiders_multimax",
        name: "Shadow Raiders Multimax",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/super_cash_drop_giga_blox": {
        slug: "super_cash_drop_giga_blox",
        name: "Super Cash Drop Giga Blox",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/the_hot_offer": {
        slug: "the_hot_offer",
        name: "The Hot Offer",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "bang-bang-games/the_runemakers": {
        slug: "the_runemakers",
        name: "The Runemakers",
        provider: "Bang Bang Games",
        providerSlug: "bang-bang-games"
    },
    "betgames/3_dragon_boosters": {
        slug: "3_dragon_boosters",
        name: "3 Dragon Boosters",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/all_in_baccarat": {
        slug: "all_in_baccarat",
        name: "All in Baccarat",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/bad_baboons": {
        slug: "bad_baboons",
        name: "Bad Baboons",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/bad_rhinos": {
        slug: "bad_rhinos",
        name: "Bad Rhinos",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_6_poker": {
        slug: "betgames_6_poker",
        name: "BetGames 6+ Poker",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_bet_on_baccarat": {
        slug: "betgames_bet_on_baccarat",
        name: "BetGames Bet On Baccarat",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_bet_on_poker": {
        slug: "betgames_bet_on_poker",
        name: "BetGames Bet on Poker",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_classic_wheel": {
        slug: "betgames_classic_wheel",
        name: "BetGames Classic Wheel",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_combination_bet": {
        slug: "betgames_combination_bet",
        name: "BetGames Combination Bet",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_dice_duel": {
        slug: "betgames_dice_duel",
        name: "BetGames Dice Duel",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_football_grid": {
        slug: "betgames_football_grid",
        name: "BetGames Football Grid",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_lobby": {
        slug: "betgames_lobby",
        name: "BetGames Lobby",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_lucky_5": {
        slug: "betgames_lucky_5",
        name: "BetGames Lucky 5",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_lucky_6": {
        slug: "betgames_lucky_6",
        name: "BetGames Lucky 6",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_lucky_7": {
        slug: "betgames_lucky_7",
        name: "BetGames Lucky 7",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_war_of_bets": {
        slug: "betgames_war_of_bets",
        name: "BetGames War of Bets",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/betgames_wheel_of_fortune": {
        slug: "betgames_wheel_of_fortune",
        name: "BetGames Wheel of Fortune",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/candy_coins": {
        slug: "candy_coins",
        name: "Candy Coins",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/chili_cash": {
        slug: "chili_cash",
        name: "Chili Cash",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/citrus_splash": {
        slug: "citrus_splash",
        name: "Citrus Splash",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/citrus_splash_deluxe": {
        slug: "citrus_splash_deluxe",
        name: "Citrus Splash Deluxe",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/classic_roulette": {
        slug: "classic_roulette",
        name: "Classic Roulette",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/crypt_of_giza": {
        slug: "crypt_of_giza",
        name: "Crypt of Giza",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/crypt_of_giza_deluxe": {
        slug: "crypt_of_giza_deluxe",
        name: "Crypt of Giza Deluxe",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/crypt_of_giza_secrets_unveiled": {
        slug: "crypt_of_giza_secrets_unveiled",
        name: "Crypt of Giza Secrets Unveiled",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/dozen_jackpots": {
        slug: "dozen_jackpots",
        name: "Dozen Jackpots",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/dragons_fate": {
        slug: "dragons_fate",
        name: "Dragon's Fate",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/flash_roulette": {
        slug: "flash_roulette",
        name: "Flash Roulette",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/forest_frenzy": {
        slug: "forest_frenzy",
        name: "Forest Frenzy",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/gold_adventure": {
        slug: "gold_adventure",
        name: "Gold Adventure",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/gold_raid": {
        slug: "gold_raid",
        name: "Gold Raid",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/immortal_blackjack": {
        slug: "immortal_blackjack",
        name: "Immortal Blackjack",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/instant_lucky_7": {
        slug: "instant_lucky_7",
        name: "Instant Lucky 7",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/instant_roulette": {
        slug: "instant_roulette",
        name: "Instant Roulette",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/live_roulette": {
        slug: "live_roulette",
        name: "Live Roulette",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/lotus_wealth_wonders": {
        slug: "lotus_wealth_wonders",
        name: "Lotus Wealth Wonders",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/lotus_wealth_wonders_deluxe": {
        slug: "lotus_wealth_wonders_deluxe",
        name: "Lotus Wealth Wonders Deluxe",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/lucky_kicks": {
        slug: "lucky_kicks",
        name: "Lucky Kicks",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/lucky_lennys_jetpack": {
        slug: "lucky_lennys_jetpack",
        name: "Lucky Lenny's Jetpack",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/lucky_loki": {
        slug: "lucky_loki",
        name: "Lucky Loki",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/olympus_gold": {
        slug: "olympus_gold",
        name: "Olympus Gold",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/penguin_rush": {
        slug: "penguin_rush",
        name: "Penguin Rush",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/respin_riches": {
        slug: "respin_riches",
        name: "Respin Riches",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/skyward": {
        slug: "skyward",
        name: "Skyward",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/skyward_deluxe": {
        slug: "skyward_deluxe",
        name: "Skyward Deluxe",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/skyward_storm": {
        slug: "skyward_storm",
        name: "Skyward Storm",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betgames/starzle": {
        slug: "starzle",
        name: "Starzle",
        provider: "BetGames",
        providerSlug: "betgames"
    },
    "betnow/betnow": {
        slug: "betnow",
        name: "BetNow",
        provider: "BetNow",
        providerSlug: "betnow"
    },
    "bgaming/3_kings_scratch": {
        slug: "3_kings_scratch",
        name: "3 Kings Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/3_lucky_monkeys_hold_and_win": {
        slug: "3_lucky_monkeys_hold_and_win",
        name: "3 Lucky Monkeys Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/3_lucky_monkeys_hold_win": {
        slug: "3_lucky_monkeys_hold_win",
        name: "3 Lucky Monkeys Hold  Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alice_wonderluck": {
        slug: "alice_wonderluck",
        name: "Alice Wonderluck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits": {
        slug: "alien_fruits",
        name: "Alien Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits_2": {
        slug: "alien_fruits_2",
        name: "Alien Fruits 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/alien_fruits_3": {
        slug: "alien_fruits_3",
        name: "Alien Fruits 3",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/all_star_fruits": {
        slug: "all_star_fruits",
        name: "All Star Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aloha_king_elvis": {
        slug: "aloha_king_elvis",
        name: "Aloha King Elvis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/always_up": {
        slug: "always_up",
        name: "Always Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/always_up_x10000": {
        slug: "always_up_x10000",
        name: "Always Up x10000",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/arrow_game": {
        slug: "arrow_game",
        name: "Arrow Game",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/arrow_slot": {
        slug: "arrow_slot",
        name: "Arrow Slot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/avalon_the_lost_kingdom": {
        slug: "avalon_the_lost_kingdom",
        name: "Avalon: The Lost Kingdom",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters": {
        slug: "aviamasters",
        name: "Aviamasters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters_2": {
        slug: "aviamasters_2",
        name: "Aviamasters 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aviamasters_xmas": {
        slug: "aviamasters_xmas",
        name: "Aviamasters Xmas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_clusters": {
        slug: "aztec_clusters",
        name: "Aztec Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_bonanza": {
        slug: "aztec_magic_bonanza",
        name: "Aztec Magic Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_deluxe": {
        slug: "aztec_magic_deluxe",
        name: "Aztec Magic Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztec_magic_megaways": {
        slug: "aztec_magic_megaways",
        name: "Aztec Magic Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/aztecs_claw_wild_dice": {
        slug: "aztecs_claw_wild_dice",
        name: "Aztec's Claw Wild Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/balloon_mania": {
        slug: "balloon_mania",
        name: "Balloon Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/beast_band": {
        slug: "beast_band",
        name: "Beast Band",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/beer_bonanza": {
        slug: "beer_bonanza",
        name: "Beer Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/big_atlantis_frenzy": {
        slug: "big_atlantis_frenzy",
        name: "Big Atlantis Frenzy",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/big_boat_big_catch": {
        slug: "big_boat_big_catch",
        name: "Big Boat Big Catch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/blackbeards_bounty": {
        slug: "blackbeards_bounty",
        name: "Blackbeard's Bounty",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/blazing_fire_pots_hold_and_spin": {
        slug: "blazing_fire_pots_hold_and_spin",
        name: "Blazing Fire Pots Hold and Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bling_blitz_diamond_drop": {
        slug: "bling_blitz_diamond_drop",
        name: "Bling Blitz Diamond Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_billion": {
        slug: "bonanza_billion",
        name: "Bonanza Billion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_billion_merge_up": {
        slug: "bonanza_billion_merge_up",
        name: "Bonanza Billion Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_billion_xtreme": {
        slug: "bonanza_billion_xtreme",
        name: "Bonanza Billion Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bonanza_trillion": {
        slug: "bonanza_trillion",
        name: "Bonanza Trillion",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/bone_bonanza": {
        slug: "bone_bonanza",
        name: "Bone Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_cats": {
        slug: "book_of_cats",
        name: "Book of Cats",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_cats_megaways": {
        slug: "book_of_cats_megaways",
        name: "Book of Cats Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_hidden_tombs": {
        slug: "book_of_hidden_tombs",
        name: "Book of Hidden Tombs",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_kemet": {
        slug: "book_of_kemet",
        name: "Book of Kemet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_panda_megaways": {
        slug: "book_of_panda_megaways",
        name: "Book of Panda Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/book_of_pyramids": {
        slug: "book_of_pyramids",
        name: "Book of Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/burning_chilli_243": {
        slug: "burning_chilli_243",
        name: "Burning Chilli 243",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/burning_chilli_x": {
        slug: "burning_chilli_x",
        name: "Burning Chilli X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/candy_monsta": {
        slug: "candy_monsta",
        name: "Candy Monsta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_green": {
        slug: "capymania_green",
        name: "Capymania Green",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_orange": {
        slug: "capymania_orange",
        name: "Capymania Orange",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/capymania_yellow": {
        slug: "capymania_yellow",
        name: "Capymania Yellow",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/carnival_bonanza": {
        slug: "carnival_bonanza",
        name: "Carnival Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/catch_the_gold_hold_and_win": {
        slug: "catch_the_gold_hold_and_win",
        name: "Catch the Gold Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/catdiana": {
        slug: "catdiana",
        name: "Catdiana",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/cats_love_yummy": {
        slug: "cats_love_yummy",
        name: "Cats Love Yummy",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/cats_soup": {
        slug: "cats_soup",
        name: "Cat's Soup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_fire": {
        slug: "chicken_fire",
        name: "Chicken Fire",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_rush": {
        slug: "chicken_rush",
        name: "Chicken Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_rush_2": {
        slug: "chicken_rush_2",
        name: "Chicken Rush 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/chicken_shot": {
        slug: "chicken_shot",
        name: "Chicken Shot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clash_of_gods_anubis_vs_hades": {
        slug: "clash_of_gods_anubis_vs_hades",
        name: "Clash of Gods Anubis vs Hades",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/classic_baccarat": {
        slug: "classic_baccarat",
        name: "Classic Baccarat",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/classic_multihand_blackjack": {
        slug: "classic_multihand_blackjack",
        name: "Classic Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clover_bonanza": {
        slug: "clover_bonanza",
        name: "Clover Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/clucking_hell": {
        slug: "clucking_hell",
        name: "Clucking Hell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/crystal_clusters": {
        slug: "crystal_clusters",
        name: "Crystal Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/deep_sea": {
        slug: "deep_sea",
        name: "Deep Sea",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/derby_rush": {
        slug: "derby_rush",
        name: "Derby Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/diamond_of_jungle": {
        slug: "diamond_of_jungle",
        name: "Diamond of Jungle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dice_bonanza": {
        slug: "dice_bonanza",
        name: "Dice Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dice_million": {
        slug: "dice_million",
        name: "Dice Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dig_dig_digger": {
        slug: "dig_dig_digger",
        name: "Dig Dig Digger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/disco_party": {
        slug: "disco_party",
        name: "Disco Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/divine_queen_heart_of_ice": {
        slug: "divine_queen_heart_of_ice",
        name: "Divine Queen Heart of Ice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/divine_queen_power_of_sun": {
        slug: "divine_queen_power_of_sun",
        name: "Divine Queen: Power of Sun",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/domnitors_treasure": {
        slug: "domnitors_treasure",
        name: "Domnitor's Treasure",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/doomsday_saloon": {
        slug: "doomsday_saloon",
        name: "Doomsday Saloon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragon_age_hold_and_win_dragon_age": {
        slug: "dragon_age_hold_and_win_dragon_age",
        name: "Dragon Age Hold and Win (Dragon Age)",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragon_queens_megaways": {
        slug: "dragon_queens_megaways",
        name: "Dragon Queens Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragons_crash": {
        slug: "dragons_crash",
        name: "Dragon's Crash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dragons_gold_100": {
        slug: "dragons_gold_100",
        name: "Dragon's Gold 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/dusty_duel": {
        slug: "dusty_duel",
        name: "Dusty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/easter_heist": {
        slug: "easter_heist",
        name: "Easter Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/easter_plinko": {
        slug: "easter_plinko",
        name: "Easter Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elements_of_power": {
        slug: "elements_of_power",
        name: "Elements of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elvis_frog_in_vegas": {
        slug: "elvis_frog_in_vegas",
        name: "Elvis Frog in Vegas",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/elvis_frog_trueways": {
        slug: "elvis_frog_trueways",
        name: "Elvis Frog TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/face_off": {
        slug: "face_off",
        name: "Face Off",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fashiontv_diamonds": {
        slug: "fashiontv_diamonds",
        name: "FashionTV Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fiesta_clusters": {
        slug: "fiesta_clusters",
        name: "Fiesta Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fire_lightning": {
        slug: "fire_lightning",
        name: "Fire Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_club": {
        slug: "fishing_club",
        name: "Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_club_2": {
        slug: "fishing_club_2",
        name: "Fishing Club 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fishing_time": {
        slug: "fishing_time",
        name: "Fishing Time",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/football_plinko": {
        slug: "football_plinko",
        name: "Football Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/forgotten": {
        slug: "forgotten",
        name: "Forgotten",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortuna_trueways": {
        slug: "fortuna_trueways",
        name: "Fortuna TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_bells": {
        slug: "fortune_bells",
        name: "Fortune Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_red_packets": {
        slug: "fortune_red_packets",
        name: "Fortune Red Packets",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_spin": {
        slug: "fortune_spin",
        name: "Fortune Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fortune_trio_minions_of_fu": {
        slug: "fortune_trio_minions_of_fu",
        name: "Fortune Trio: Minions of Fu",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/forty_fruity_million": {
        slug: "forty_fruity_million",
        name: "Forty Fruity Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/four_lucky_clover": {
        slug: "four_lucky_clover",
        name: "Four Lucky Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/four_lucky_diamonds": {
        slug: "four_lucky_diamonds",
        name: "Four Lucky Diamonds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/french_roulette": {
        slug: "french_roulette",
        name: "French Roulette",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/frenzy_clusters": {
        slug: "frenzy_clusters",
        name: "Frenzy Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/frozen_fruit": {
        slug: "frozen_fruit",
        name: "Frozen Fruit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fruit_million": {
        slug: "fruit_million",
        name: "Fruit Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/fruit_million_respin": {
        slug: "fruit_million_respin",
        name: "Fruit Million Respin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gangsterz": {
        slug: "gangsterz",
        name: "Gangsterz",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gates_of_power": {
        slug: "gates_of_power",
        name: "Gates of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemhalla": {
        slug: "gemhalla",
        name: "Gemhalla",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemhalla_xtreme": {
        slug: "gemhalla_xtreme",
        name: "Gemhalla Xtreme",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gemza": {
        slug: "gemza",
        name: "Gemza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gift_rush": {
        slug: "gift_rush",
        name: "Gift Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gift_x": {
        slug: "gift_x",
        name: "Gift X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/god_of_wealth_hold_and_win": {
        slug: "god_of_wealth_hold_and_win",
        name: "God of Wealth Hold And Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_magnate": {
        slug: "gold_magnate",
        name: "Gold Magnate",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_of_minos": {
        slug: "gold_of_minos",
        name: "Gold of Minos",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/gold_rush_with_johnny_cash": {
        slug: "gold_rush_with_johnny_cash",
        name: "Gold Rush with Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_avalon_hold_and_win": {
        slug: "golden_avalon_hold_and_win",
        name: "Golden Avalon Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_paw_hold_and_win": {
        slug: "golden_paw_hold_and_win",
        name: "Golden Paw Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_pinata_hold_and_win": {
        slug: "golden_pinata_hold_and_win",
        name: "Golden Pinata Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/golden_pride": {
        slug: "golden_pride",
        name: "Golden Pride",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_buffalo_hold_and_win": {
        slug: "grand_buffalo_hold_and_win",
        name: "Grand Buffalo Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_mustang": {
        slug: "grand_mustang",
        name: "Grand Mustang",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/grand_patron": {
        slug: "grand_patron",
        name: "Grand Patron",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/halloween_bonanza": {
        slug: "halloween_bonanza",
        name: "Halloween Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/haunted_reels": {
        slug: "haunted_reels",
        name: "Haunted Reels",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heads_and_tails": {
        slug: "heads_and_tails",
        name: "Heads and Tails",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heads_and_tails_xy": {
        slug: "heads_and_tails_xy",
        name: "Heads and Tails XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/heart_of_tiki": {
        slug: "heart_of_tiki",
        name: "Heart of Tiki",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hit_the_route": {
        slug: "hit_the_route",
        name: "Hit The Route",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_chilli_bells": {
        slug: "hot_chilli_bells",
        name: "Hot Chilli Bells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_chilli_bells_100": {
        slug: "hot_chilli_bells_100",
        name: "Hot Chilli Bells 100",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hot_rocket_5x_3x_2x": {
        slug: "hot_rocket_5x_3x_2x",
        name: "Hot Rocket 5x 3x 2x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/hottest_666": {
        slug: "hottest_666",
        name: "Hottest 666",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_bronze": {
        slug: "ice_scratch_bronze",
        name: "Ice Scratch Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_gold": {
        slug: "ice_scratch_gold",
        name: "Ice Scratch Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ice_scratch_silver": {
        slug: "ice_scratch_silver",
        name: "Ice Scratch Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/infinity_pull": {
        slug: "infinity_pull",
        name: "Infinity Pull",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jewel_boom_super_drop": {
        slug: "jewel_boom_super_drop",
        name: "Jewel Boom Super Drop",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jogo_do_bicho": {
        slug: "jogo_do_bicho",
        name: "Jogo Do Bicho",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jogo_do_bicho_simple": {
        slug: "jogo_do_bicho_simple",
        name: "Jogo Do Bicho Simple",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/johnny_cash": {
        slug: "johnny_cash",
        name: "Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/johnny_vs_chicken": {
        slug: "johnny_vs_chicken",
        name: "Johnny vs Chicken",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_queen": {
        slug: "joker_queen",
        name: "Joker Queen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_vs_joker": {
        slug: "joker_vs_joker",
        name: "Joker vs Joker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/joker_x_love": {
        slug: "joker_x_love",
        name: "Joker X Love",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/jokers_million": {
        slug: "jokers_million",
        name: "Joker's Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/keepers_of_the_secret": {
        slug: "keepers_of_the_secret",
        name: "Keepers Of The Secret",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/kicker_mania": {
        slug: "kicker_mania",
        name: "Kicker Mania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/krakens_hunger": {
        slug: "krakens_hunger",
        name: "Kraken's Hunger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_lucky_gun": {
        slug: "lady_lucky_gun",
        name: "Lady Lucky Gun",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_wolf_moon": {
        slug: "lady_wolf_moon",
        name: "Lady Wolf Moon",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lady_wolf_moon_megaways": {
        slug: "lady_wolf_moon_megaways",
        name: "Lady Wolf Moon Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/limbo_xy": {
        slug: "limbo_xy",
        name: "Limbo XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/loki_loot": {
        slug: "loki_loot",
        name: "Loki Loot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/luck_and_magic": {
        slug: "luck_and_magic",
        name: "Luck & Magic",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/luck_and_magic_scratch": {
        slug: "luck_and_magic_scratch",
        name: "Luck and Magic Scratch",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_8_merge_up": {
        slug: "lucky_8_merge_up",
        name: "Lucky 8 Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_birds": {
        slug: "lucky_birds",
        name: "Lucky Birds",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_crew": {
        slug: "lucky_crew",
        name: "Lucky Crew",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_dama_muerta": {
        slug: "lucky_dama_muerta",
        name: "Lucky Dama Muerta",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_dragon_multidice_x": {
        slug: "lucky_dragon_multidice_x",
        name: "Lucky Dragon MultiDice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_ducky": {
        slug: "lucky_ducky",
        name: "Lucky Ducky",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_farm_bonanza": {
        slug: "lucky_farm_bonanza",
        name: "Lucky Farm Bonanza",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_ladys_clover": {
        slug: "lucky_ladys_clover",
        name: "Lucky Lady's Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_lager_x9990": {
        slug: "lucky_lager_x9990",
        name: "Lucky Lager X9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_lu": {
        slug: "lucky_lu",
        name: "Lucky Lu",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_oak": {
        slug: "lucky_oak",
        name: "Lucky Oak",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_pack_2026_cup": {
        slug: "lucky_pack_2026_cup",
        name: "Lucky Pack 2026 Cup",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/lucky_pinball": {
        slug: "lucky_pinball",
        name: "Lucky Pinball",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/magic_mummy_megaways": {
        slug: "magic_mummy_megaways",
        name: "Magic Mummy Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/maneki_88_fortunes": {
        slug: "maneki_88_fortunes",
        name: "Maneki 88 Fortunes",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/maneki_88_gold": {
        slug: "maneki_88_gold",
        name: "Maneki 88 Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mechanical_clover": {
        slug: "mechanical_clover",
        name: "Mechanical Clover",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/merge_up": {
        slug: "merge_up",
        name: "Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/merge_up_2": {
        slug: "merge_up_2",
        name: "Merge Up 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mice_and_magic_wonder_spin": {
        slug: "mice_and_magic_wonder_spin",
        name: "Mice and Magic Wonder Spin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mine_gems": {
        slug: "mine_gems",
        name: "Mine Gems",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/minesweeper": {
        slug: "minesweeper",
        name: "Minesweeper",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/minesweeper_xy": {
        slug: "minesweeper_xy",
        name: "Minesweeper XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/miss_cherry_fruits": {
        slug: "miss_cherry_fruits",
        name: "Miss Cherry Fruits",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/miss_cherry_fruits_jackpot_party": {
        slug: "miss_cherry_fruits_jackpot_party",
        name: "Miss Cherry Fruits Jackpot Party",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/miss_cherry_wild_frames": {
        slug: "miss_cherry_wild_frames",
        name: "Miss Cherry Wild Frames",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/money_maker": {
        slug: "money_maker",
        name: "Money Maker",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/monster_hunt": {
        slug: "monster_hunt",
        name: "Monster Hunt",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multi_rush": {
        slug: "multi_rush",
        name: "Multi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack": {
        slug: "multihand_blackjack",
        name: "Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack_pro": {
        slug: "multihand_blackjack_pro",
        name: "Multihand Blackjack Pro",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/multihand_blackjack_pro_2": {
        slug: "multihand_blackjack_pro_2",
        name: "Multihand Blackjack Pro 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mummys_gold": {
        slug: "mummys_gold",
        name: "Mummy's Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mystery_garden": {
        slug: "mystery_garden",
        name: "Mystery Garden",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mystery_heist": {
        slug: "mystery_heist",
        name: "Mystery Heist",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/mystic_reels": {
        slug: "mystic_reels",
        name: "Mystic Reels",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/olympus_trueways": {
        slug: "olympus_trueways",
        name: "Olympus Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/oof_the_goldmine_planet": {
        slug: "oof_the_goldmine_planet",
        name: "OOF The Goldmine Planet",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/open_it": {
        slug: "open_it",
        name: "Open It",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/panda_luck": {
        slug: "panda_luck",
        name: "Panda Luck",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penalty_duel": {
        slug: "penalty_duel",
        name: "Penalty Duel",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penalty_duel_with_julio_cesar": {
        slug: "penalty_duel_with_julio_cesar",
        name: "Penalty Duel with Julio Cesar",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/penny_pelican": {
        slug: "penny_pelican",
        name: "Penny Pelican",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/piggy_bank_hold_and_win": {
        slug: "piggy_bank_hold_and_win",
        name: "Piggy Bank Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/platinum_lightning": {
        slug: "platinum_lightning",
        name: "Platinum Lightning",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/platinum_lightning_deluxe": {
        slug: "platinum_lightning_deluxe",
        name: "Platinum Lightning Deluxe",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_2": {
        slug: "plinko_2",
        name: "Plinko 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_2_halloween": {
        slug: "plinko_2_halloween",
        name: "Plinko 2 Halloween",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/plinko_xy": {
        slug: "plinko_xy",
        name: "Plinko XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/pop_zen": {
        slug: "pop_zen",
        name: "Pop Zen",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/potion_spells": {
        slug: "potion_spells",
        name: "Potion Spells",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/recycle_riches": {
        slug: "recycle_riches",
        name: "Recycle Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/red_hot_chilli_chickens": {
        slug: "red_hot_chilli_chickens",
        name: "Red Hot Chilli Chickens",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/reel_of_ra": {
        slug: "reel_of_ra",
        name: "Reel of Ra",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/retro_trader": {
        slug: "retro_trader",
        name: "Retro Trader",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/road_2_riches": {
        slug: "road_2_riches",
        name: "Road 2 Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/robospin": {
        slug: "robospin",
        name: "Robospin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_dice": {
        slug: "rocket_dice",
        name: "Rocket Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_dice_xy": {
        slug: "rocket_dice_xy",
        name: "Rocket Dice XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rocket_eruption_triple_blast": {
        slug: "rocket_eruption_triple_blast",
        name: "Rocket Eruption Triple Blast",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/rotating_element": {
        slug: "rotating_element",
        name: "Rotating Element",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_beellion_hold_and_win": {
        slug: "royal_beellion_hold_and_win",
        name: "Royal Beellion Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_easter": {
        slug: "royal_easter",
        name: "Royal Easter",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_fruits_multilines": {
        slug: "royal_fruits_multilines",
        name: "Royal Fruits MultiLines",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_highroad": {
        slug: "royal_highroad",
        name: "Royal High-Road",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/royal_roulette_500x": {
        slug: "royal_roulette_500x",
        name: "Royal Roulette 500x",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sakura_riches_60": {
        slug: "sakura_riches_60",
        name: "Sakura Riches 60",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/savage_buffalo_spirit": {
        slug: "savage_buffalo_spirit",
        name: "Savage Buffalo Spirit",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/savage_buffalo_spirit_megaways": {
        slug: "savage_buffalo_spirit_megaways",
        name: "Savage Buffalo Spirit Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_bronze": {
        slug: "scratch_alpaca_bronze",
        name: "Scratch Alpaca Bronze",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_gold": {
        slug: "scratch_alpaca_gold",
        name: "Scratch Alpaca Gold",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_alpaca_silver": {
        slug: "scratch_alpaca_silver",
        name: "Scratch Alpaca Silver",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/scratch_dice": {
        slug: "scratch_dice",
        name: "Scratch Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/secret_bar_multidice_x": {
        slug: "secret_bar_multidice_x",
        name: "Secret Bar Multidice X",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/shark_and_spark_hold_and_win": {
        slug: "shark_and_spark_hold_and_win",
        name: "Shark and Spark Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/slot_machine": {
        slug: "slot_machine",
        name: "Slot Machine",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/snoop_dogg_dollars": {
        slug: "snoop_dogg_dollars",
        name: "Snoop Dogg Dollars",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/soccermania": {
        slug: "soccermania",
        name: "Soccermania",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/space_xy": {
        slug: "space_xy",
        name: "Space XY",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/spin_and_spell": {
        slug: "spin_and_spell",
        name: "Spin And Spell",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/st_patricks_pots_hold_and_win": {
        slug: "st_patricks_pots_hold_and_win",
        name: "St. Patrick's Pots Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/star_trek_the_next_generation": {
        slug: "star_trek_the_next_generation",
        name: "Star Trek The Next Generation",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/street_power": {
        slug: "street_power",
        name: "Street Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sugar_merge_up": {
        slug: "sugar_merge_up",
        name: "Sugar Merge Up",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sugar_mix": {
        slug: "sugar_mix",
        name: "Sugar Mix",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sugar_plinko": {
        slug: "sugar_plinko",
        name: "Sugar Plinko",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/surrender_multihand_blackjack": {
        slug: "surrender_multihand_blackjack",
        name: "Surrender Multihand Blackjack",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sweet_rush_megaways": {
        slug: "sweet_rush_megaways",
        name: "Sweet Rush Megaways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/sweet_samurai": {
        slug: "sweet_samurai",
        name: "Sweet Samurai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/the_godfather_3_pillars_of_power": {
        slug: "the_godfather_3_pillars_of_power",
        name: "The Godfather: 3 Pillars of Power",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tile_master": {
        slug: "tile_master",
        name: "Tile Master",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/top_eagle": {
        slug: "top_eagle",
        name: "Top Eagle",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/totally_hot": {
        slug: "totally_hot",
        name: "Totally Hot",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_heist_johnny_cash": {
        slug: "train_heist_johnny_cash",
        name: "Train Heist Johnny Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_heist_johnny_coin": {
        slug: "train_heist_johnny_coin",
        name: "Train Heist Johnny Coin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/train_to_rio_grande": {
        slug: "train_to_rio_grande",
        name: "Train to Rio Grande",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tramp_day": {
        slug: "tramp_day",
        name: "Tramp Day",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/tramp_day_trueways": {
        slug: "tramp_day_trueways",
        name: "Tramp Day Trueways",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/treasure_explorer": {
        slug: "treasure_explorer",
        name: "Treasure Explorer",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/treasure_of_anubis": {
        slug: "treasure_of_anubis",
        name: "Treasure of Anubis",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/triple_nipple": {
        slug: "triple_nipple",
        name: "Triple Nipple",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ufo_pyramids": {
        slug: "ufo_pyramids",
        name: "UFO Pyramids",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/ultras": {
        slug: "ultras",
        name: "Ultras",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/voodoo_people": {
        slug: "voodoo_people",
        name: "Voodoo People",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wbc_ring_of_riches": {
        slug: "wbc_ring_of_riches",
        name: "WBC Ring Of Riches",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/west_town": {
        slug: "west_town",
        name: "West Town",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash": {
        slug: "wild_cash",
        name: "Wild Cash",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash_dice": {
        slug: "wild_cash_dice",
        name: "Wild Cash Dice",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_cash_x9990": {
        slug: "wild_cash_x9990",
        name: "Wild Cash x9990",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_chicago": {
        slug: "wild_chicago",
        name: "Wild Chicago",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_clusters": {
        slug: "wild_clusters",
        name: "Wild Clusters",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_coin": {
        slug: "wild_coin",
        name: "Wild Coin",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_heart": {
        slug: "wild_heart",
        name: "Wild Heart",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_million": {
        slug: "wild_million",
        name: "Wild Million",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_moon_thieves": {
        slug: "wild_moon_thieves",
        name: "Wild Moon Thieves",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_tiger": {
        slug: "wild_tiger",
        name: "Wild Tiger",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_tiger_2": {
        slug: "wild_tiger_2",
        name: "Wild Tiger 2",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_west_trueways": {
        slug: "wild_west_trueways",
        name: "Wild West TRUEWAYS",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wild_wick": {
        slug: "wild_wick",
        name: "Wild Wick",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/wincent_wolf": {
        slug: "wincent_wolf",
        name: "Wincent Wolf",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/winter_fishing_club": {
        slug: "winter_fishing_club",
        name: "Winter Fishing Club",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/winter_trophy_hold_and_win": {
        slug: "winter_trophy_hold_and_win",
        name: "Winter Trophy Hold and Win",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/yokai": {
        slug: "yokai",
        name: "Yokai",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/yommi_rush": {
        slug: "yommi_rush",
        name: "Yommi Rush",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bgaming/zeus_goes_wild": {
        slug: "zeus_goes_wild",
        name: "Zeus Goes Wild",
        provider: "BGaming",
        providerSlug: "bgaming"
    },
    "bigpot-gaming/aero_adventure": {
        slug: "aero_adventure",
        name: "Aero Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/amazing_soda_rush": {
        slug: "amazing_soda_rush",
        name: "Amazing Soda Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/ancient_blocks": {
        slug: "ancient_blocks",
        name: "Ancient Blocks",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/ancient_stones": {
        slug: "ancient_stones",
        name: "Ancient Stones",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/astro_luck": {
        slug: "astro_luck",
        name: "Astro Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_classic": {
        slug: "baccarat_classic",
        name: "Baccarat Classic",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_private": {
        slug: "baccarat_private",
        name: "Baccarat Private",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/baccarat_supersix": {
        slug: "baccarat_supersix",
        name: "Baccarat SuperSix",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/big_pot_gaming_table_lobby": {
        slug: "big_pot_gaming_table_lobby",
        name: "Big Pot Gaming Table Lobby",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/big_sevens_jackpot": {
        slug: "big_sevens_jackpot",
        name: "Big Sevens Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/bigbang_spin": {
        slug: "bigbang_spin",
        name: "BigBang Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/bonanza_coins": {
        slug: "bonanza_coins",
        name: "Bonanza Coins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/book_of_pharaoh": {
        slug: "book_of_pharaoh",
        name: "Book of Pharaoh",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/book_of_pharaoh_777jackpot": {
        slug: "book_of_pharaoh_777jackpot",
        name: "Book of Pharaoh 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/buffalo_begins": {
        slug: "buffalo_begins",
        name: "Buffalo Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/celestial_goddess": {
        slug: "celestial_goddess",
        name: "Celestial Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/chans_treasure": {
        slug: "chans_treasure",
        name: "Chan's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/cherry_bell": {
        slug: "cherry_bell",
        name: "Cherry Bell",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/cleos_fortune": {
        slug: "cleos_fortune",
        name: "Cleo’s Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/crash_wonder_blonde": {
        slug: "crash_wonder_blonde",
        name: "Crash Wonder Blonde",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/creature_of_mythology": {
        slug: "creature_of_mythology",
        name: "Creature of Mythology",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/detectives_dream": {
        slug: "detectives_dream",
        name: "Detective’s Dream",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/diamond_mask": {
        slug: "diamond_mask",
        name: "Diamond Mask",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/double_race": {
        slug: "double_race",
        name: "Double Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/dragontiger": {
        slug: "dragontiger",
        name: "DragonTiger",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/drfrankens_lab": {
        slug: "drfrankens_lab",
        name: "Dr.Franken’s Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/drfrankens_lab_777jackpot": {
        slug: "drfrankens_lab_777jackpot",
        name: "Dr.Franken’s Lab 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/elizabeths_lab": {
        slug: "elizabeths_lab",
        name: "Elizabeth's Lab",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fantastic_fairies": {
        slug: "fantastic_fairies",
        name: "Fantastic Fairies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/festival_of_the_dead": {
        slug: "festival_of_the_dead",
        name: "Festival of the Dead",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fiesta_frenzy": {
        slug: "fiesta_frenzy",
        name: "Fiesta Frenzy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/frozen_blade": {
        slug: "frozen_blade",
        name: "Frozen Blade",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/fury_fighters": {
        slug: "fury_fighters",
        name: "Fury Fighters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_dragon": {
        slug: "gold_dragon",
        name: "Gold Dragon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_mine_rush": {
        slug: "gold_mine_rush",
        name: "Gold Mine Rush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/gold_of_the_king": {
        slug: "gold_of_the_king",
        name: "Gold of the King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/golden_kitty": {
        slug: "golden_kitty",
        name: "Golden Kitty",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/golden_panda": {
        slug: "golden_panda",
        name: "Golden Panda",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/halloween_ghost": {
        slug: "halloween_ghost",
        name: "Halloween Ghost",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hidden_city": {
        slug: "hidden_city",
        name: "Hidden City",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/high_low": {
        slug: "high_low",
        name: "High Low",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hit_mahjong_wins": {
        slug: "hit_mahjong_wins",
        name: "Hit Mahjong Wins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/holy_knight": {
        slug: "holy_knight",
        name: "Holy Knight",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hot_safari_run": {
        slug: "hot_safari_run",
        name: "Hot Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hotties_paradise": {
        slug: "hotties_paradise",
        name: "Hottie's Paradise",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/hotties_vacation": {
        slug: "hotties_vacation",
        name: "Hottie's Vacation",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/jam_crush": {
        slug: "jam_crush",
        name: "Jam Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/jewelry_spin": {
        slug: "jewelry_spin",
        name: "Jewelry Spin",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/journey_to_the_abyss": {
        slug: "journey_to_the_abyss",
        name: "Journey to the Abyss",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/king_of_the_pig": {
        slug: "king_of_the_pig",
        name: "King of the Pig",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/last_valkyrie": {
        slug: "last_valkyrie",
        name: "Last Valkyrie",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/legacy_of_midas": {
        slug: "legacy_of_midas",
        name: "Legacy of Midas",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/legend_of_tarzan": {
        slug: "legend_of_tarzan",
        name: "Legend of Tarzan",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/little_witch_fortune": {
        slug: "little_witch_fortune",
        name: "Little Witch Fortune",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lost_treasure": {
        slug: "lost_treasure",
        name: "Lost Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/luck_of_amazon": {
        slug: "luck_of_amazon",
        name: "Luck of Amazon",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_fifth": {
        slug: "lucky_fifth",
        name: "Lucky Fifth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_goldbar": {
        slug: "lucky_goldbar",
        name: "Lucky Goldbar",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_rocket": {
        slug: "lucky_rocket",
        name: "Lucky Rocket",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/lucky_waterfalls": {
        slug: "lucky_waterfalls",
        name: "Lucky Waterfalls",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/magic_candy_factory": {
        slug: "magic_candy_factory",
        name: "Magic Candy Factory",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/magic_fire": {
        slug: "magic_fire",
        name: "Magic Fire",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mahjong_super_wins": {
        slug: "mahjong_super_wins",
        name: "Mahjong Super Wins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/maze_adventure": {
        slug: "maze_adventure",
        name: "Maze Adventure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/medusa_blessing": {
        slug: "medusa_blessing",
        name: "Medusa Blessing",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mega_cave": {
        slug: "mega_cave",
        name: "Mega Cave",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mega_sevens": {
        slug: "mega_sevens",
        name: "Mega Sevens",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mega_sevens_2": {
        slug: "mega_sevens_2",
        name: "Mega Sevens 2",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/miracle_ring": {
        slug: "miracle_ring",
        name: "Miracle Ring",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/monkey_king": {
        slug: "monkey_king",
        name: "Monkey King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/monkey_king_777jackpot": {
        slug: "monkey_king_777jackpot",
        name: "Monkey King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/moonlight_cats": {
        slug: "moonlight_cats",
        name: "Moonlight Cats",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mountain_spirit": {
        slug: "mountain_spirit",
        name: "Mountain Spirit",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/mystery_wind": {
        slug: "mystery_wind",
        name: "Mystery Wind",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/olympus_legend": {
        slug: "olympus_legend",
        name: "Olympus Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/oriental_treasures": {
        slug: "oriental_treasures",
        name: "Oriental Treasures",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pandas_jackpot": {
        slug: "pandas_jackpot",
        name: "Panda’s Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pirates_treasure": {
        slug: "pirates_treasure",
        name: "Pirate's Treasure",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/pop_popcorns": {
        slug: "pop_popcorns",
        name: "Pop Popcorns",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/queens_bow": {
        slug: "queens_bow",
        name: "Queen's Bow",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/quests_of_olympus": {
        slug: "quests_of_olympus",
        name: "Quests of Olympus",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/reel_bass_family": {
        slug: "reel_bass_family",
        name: "Reel Bass Family",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/rhino_king": {
        slug: "rhino_king",
        name: "Rhino King",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/rhino_king_777jackpot": {
        slug: "rhino_king_777jackpot",
        name: "Rhino King 777Jackpot",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/royal_princess": {
        slug: "royal_princess",
        name: "Royal Princess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/safari_race": {
        slug: "safari_race",
        name: "Safari Race",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/safari_run": {
        slug: "safari_run",
        name: "Safari Run",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/santa_in_the_summer": {
        slug: "santa_in_the_summer",
        name: "Santa in the Summer",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_ball": {
        slug: "secret_ball",
        name: "Secret Ball",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_of_earth": {
        slug: "secret_of_earth",
        name: "Secret of Earth",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/secret_of_goddess": {
        slug: "secret_of_goddess",
        name: "Secret of Goddess",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/shoot_piggy": {
        slug: "shoot_piggy",
        name: "Shoot Piggy",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/skull_lord": {
        slug: "skull_lord",
        name: "Skull Lord",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/sugar_crush": {
        slug: "sugar_crush",
        name: "Sugar Crush",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/sword_master": {
        slug: "sword_master",
        name: "Sword Master",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/the_fates_of_sisters": {
        slug: "the_fates_of_sisters",
        name: "The Fates of Sisters",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/three_zombies": {
        slug: "three_zombies",
        name: "Three Zombies",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/tiger_train": {
        slug: "tiger_train",
        name: "Tiger Train",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/tiggy_luck": {
        slug: "tiggy_luck",
        name: "Tiggy Luck",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/toy_of_legend": {
        slug: "toy_of_legend",
        name: "Toy of Legend",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/western_sheriff": {
        slug: "western_sheriff",
        name: "Western Sheriff",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/wolf_begins": {
        slug: "wolf_begins",
        name: "Wolf Begins",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "bigpot-gaming/yummy_kitchen": {
        slug: "yummy_kitchen",
        name: "Yummy Kitchen",
        provider: "Bigpot Gaming",
        providerSlug: "bigpot-gaming"
    },
    "blueprint-gaming/almighty_mustang_express": {
        slug: "almighty_mustang_express",
        name: "Almighty Mustang Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/almighty_mustang_express_white_bison": {
        slug: "almighty_mustang_express_white_bison",
        name: "Almighty Mustang Express White Bison",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bankin_bacon": {
        slug: "bankin_bacon",
        name: "Bankin' Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bankin_more_bacon": {
        slug: "bankin_more_bacon",
        name: "Bankin' More Bacon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/barx_safecracker_megaways": {
        slug: "barx_safecracker_megaways",
        name: "Bar-X Safecracker Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_cat_gold": {
        slug: "big_cat_gold",
        name: "Big Cat Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_bass_fishing_megaways": {
        slug: "big_catch_bass_fishing_megaways",
        name: "Big Catch Bass Fishing Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_even_bigger_bass_2": {
        slug: "big_catch_even_bigger_bass_2",
        name: "Big Catch Even Bigger Bass 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_catch_even_bigger_bass_3_megaways": {
        slug: "big_catch_even_bigger_bass_3_megaways",
        name: "Big Catch Even Bigger Bass 3 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/big_money_frenzy_cash_gains": {
        slug: "big_money_frenzy_cash_gains",
        name: "Big Money Frenzy Cash Gains",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_bonanza": {
        slug: "bison_bonanza",
        name: "Bison Bonanza",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_gold_strike": {
        slug: "bison_rising_gold_strike",
        name: "Bison Rising Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_megaways": {
        slug: "bison_rising_megaways",
        name: "Bison Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bison_rising_reloaded_megaways": {
        slug: "bison_rising_reloaded_megaways",
        name: "Bison Rising Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/bounty_hunter_unchained": {
        slug: "bounty_hunter_unchained",
        name: "Bounty Hunter Unchained",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike": {
        slug: "cash_strike",
        name: "Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper": {
        slug: "cash_strike_hotstepper",
        name: "Cash Strike Hotstepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper_2": {
        slug: "cash_strike_hotstepper_2",
        name: "Cash Strike Hotstepper 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_hotstepper_megaways": {
        slug: "cash_strike_hotstepper_megaways",
        name: "Cash Strike Hotstepper Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_5": {
        slug: "cash_strike_power_5",
        name: "Cash Strike Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_force_5": {
        slug: "cash_strike_power_force_5",
        name: "Cash Strike Power Force 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_force_5_megaways": {
        slug: "cash_strike_power_force_5_megaways",
        name: "Cash Strike Power force 5 Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_power_up": {
        slug: "cash_strike_power_up",
        name: "Cash Strike Power Up",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_triple_fire": {
        slug: "cash_strike_triple_fire",
        name: "Cash Strike Triple Fire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_win_boost": {
        slug: "cash_strike_win_boost",
        name: "Cash Strike Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cash_strike_xcash": {
        slug: "cash_strike_xcash",
        name: "Cash Strike X-Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/cashpots_blazinator": {
        slug: "cashpots_blazinator",
        name: "Cashpots Blazinator",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/chilli_picante_megaways": {
        slug: "chilli_picante_megaways",
        name: "Chilli Picante Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_cash_extra_big_splash": {
        slug: "crabbin_for_cash_extra_big_splash",
        name: "Crabbin For Cash Extra Big Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_cash_megaways": {
        slug: "crabbin_for_cash_megaways",
        name: "Crabbin' For Cash Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/crabbin_for_christmas": {
        slug: "crabbin_for_christmas",
        name: "Crabbin For Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/diamond_mine_extra_gold": {
        slug: "diamond_mine_extra_gold",
        name: "Diamond Mine Extra Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/diamond_mine_megaways": {
        slug: "diamond_mine_megaways",
        name: "Diamond Mine Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/divine_links": {
        slug: "divine_links",
        name: "Divine Links",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/dragonfall": {
        slug: "dragonfall",
        name: "Dragonfall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eagle_storm": {
        slug: "eagle_storm",
        name: "Eagle Storm",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/el_jackpotto": {
        slug: "el_jackpotto",
        name: "El Jackpotto",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/eternal_phoenix_megaways": {
        slug: "eternal_phoenix_megaways",
        name: "Eternal Phoenix Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fat_stacks_miami_cash": {
        slug: "fat_stacks_miami_cash",
        name: "Fat Stacks Miami Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fishin_frenzy_power_4_slots": {
        slug: "fishin_frenzy_power_4_slots",
        name: "Fishin Frenzy Power 4 Slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/frankensteins_fortune": {
        slug: "frankensteins_fortune",
        name: "Frankenstein's Fortune",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/fruitopolis_fortune_play": {
        slug: "fruitopolis_fortune_play",
        name: "Fruitopolis Fortune Play",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/full_moon_fever": {
        slug: "full_moon_fever",
        name: "Full Moon Fever",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/funky_buddha": {
        slug: "funky_buddha",
        name: "Funky Buddha",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/genie_jackpot_combo_frenzy": {
        slug: "genie_jackpot_combo_frenzy",
        name: "Genie Jackpot Combo Frenzy",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/genie_jackpots_wishmaker": {
        slug: "genie_jackpots_wishmaker",
        name: "Genie Jackpots Wishmaker",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike": {
        slug: "gold_strike",
        name: "Gold Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike_2": {
        slug: "gold_strike_2",
        name: "Gold Strike 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/gold_strike_express": {
        slug: "gold_strike_express",
        name: "Gold Strike Express",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/house_of_the_dragon": {
        slug: "house_of_the_dragon",
        name: "House of the Dragon",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/jungle_fortune_build_your_bonus": {
        slug: "jungle_fortune_build_your_bonus",
        name: "Jungle Fortune Build Your Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash": {
        slug: "king_kong_cash",
        name: "King Kong Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_dj_prime8": {
        slug: "king_kong_cash_dj_prime8",
        name: "King Kong Cash DJ Prime8",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas": {
        slug: "king_kong_cash_even_bigger_bananas",
        name: "King Kong Cash Even Bigger Bananas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas_2": {
        slug: "king_kong_cash_even_bigger_bananas_2",
        name: "King Kong Cash Even Bigger Bananas 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_cash_even_bigger_bananas_4": {
        slug: "king_kong_cash_even_bigger_bananas_4",
        name: "King Kong Cash Even Bigger Bananas 4",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_kong_splash": {
        slug: "king_kong_splash",
        name: "King Kong Splash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/king_of_the_west": {
        slug: "king_of_the_west",
        name: "King of the West",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_3_even_bigger_bonus": {
        slug: "kong_3_even_bigger_bonus",
        name: "Kong 3 Even Bigger Bonus",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_even_bigger_balls": {
        slug: "kong_even_bigger_balls",
        name: "Kong Even Bigger Balls",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/kong_even_bigger_christmas": {
        slug: "kong_even_bigger_christmas",
        name: "Kong Even Bigger Christmas",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/legacy_of_gods_megaways": {
        slug: "legacy_of_gods_megaways",
        name: "Legacy of Gods Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/legacy_of_ra_megaways": {
        slug: "legacy_of_ra_megaways",
        name: "Legacy Of Ra Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lion_thunder": {
        slug: "lion_thunder",
        name: "Lion Thunder",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/loti_fortune_spins": {
        slug: "loti_fortune_spins",
        name: "LOTI Fortune Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/loti_gold_spins": {
        slug: "loti_gold_spins",
        name: "LOTI Gold Spins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lucky_fire_blitz_megaways": {
        slug: "lucky_fire_blitz_megaways",
        name: "Lucky Fire Blitz Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/lucky_fire_blitz_win_boost": {
        slug: "lucky_fire_blitz_win_boost",
        name: "Lucky Fire Blitz Win Boost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_megaways": {
        slug: "majestic_fury_megaways",
        name: "Majestic Fury Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_megaways_unleashed": {
        slug: "majestic_fury_megaways_unleashed",
        name: "Majestic Fury Megaways Unleashed",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_power_5": {
        slug: "majestic_fury_power_5",
        name: "Majestic Fury Power 5",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/majestic_fury_win_stepper": {
        slug: "majestic_fury_win_stepper",
        name: "Majestic Fury Win Stepper",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona": {
        slug: "maradona",
        name: "Maradona",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona_el_diez": {
        slug: "maradona_el_diez",
        name: "Maradona El Diez",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/maradona_el_pibe_de_oro": {
        slug: "maradona_el_pibe_de_oro",
        name: "Maradona: El Pibe De Oro",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/mega_charged_cash": {
        slug: "mega_charged_cash",
        name: "Mega Charged Cash",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/midas_king_of_gold": {
        slug: "midas_king_of_gold",
        name: "Midas King Of Gold",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_2_fat_stacks": {
        slug: "napoleon_2_fat_stacks",
        name: "Napoleon 2 Fat Stacks",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_deluxe": {
        slug: "napoleon_deluxe",
        name: "Napoleon Deluxe",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/napoleon_rise_of_an_empire": {
        slug: "napoleon_rise_of_an_empire",
        name: "Napoleon: Rise of an Empire",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/pig_wizard_cash_lock": {
        slug: "pig_wizard_cash_lock",
        name: "Pig Wizard Cash Lock",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/plenty_o_fish": {
        slug: "plenty_o_fish",
        name: "Plenty o' Fish",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/primal_megaways": {
        slug: "primal_megaways",
        name: "Primal Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_catch": {
        slug: "red_hot_catch",
        name: "Red Hot Catch",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_chilli": {
        slug: "red_hot_chilli",
        name: "Red Hot Chilli",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/red_hot_eruption": {
        slug: "red_hot_eruption",
        name: "Red Hot Eruption",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/return_of_kong_megaways": {
        slug: "return_of_kong_megaways",
        name: "Return of Kong Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rhino_rampage": {
        slug: "rhino_rampage",
        name: "Rhino Rampage",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rise_of_atlantis": {
        slug: "rise_of_atlantis",
        name: "Rise of Atlantis",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/rise_of_atlantis_2": {
        slug: "rise_of_atlantis_2",
        name: "Rise of Atlantis 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/safari_gold_megaways": {
        slug: "safari_gold_megaways",
        name: "Safari Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/saint_nicked_2": {
        slug: "saint_nicked_2",
        name: "Saint Nicked 2",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/saint_nicked_3_present_tense": {
        slug: "saint_nicked_3_present_tense",
        name: "Saint Nicked 3 Present Tense",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/scarab_rising_megaways": {
        slug: "scarab_rising_megaways",
        name: "Scarab Rising Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/spirit_wolf_wins": {
        slug: "spirit_wolf_wins",
        name: "Spirit Wolf Wins",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/stickermania_wild_rumble": {
        slug: "stickermania_wild_rumble",
        name: "Stickermania Wild Rumble",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/super_7_winner": {
        slug: "super_7_winner",
        name: "Super 7 Winner",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/super_wild_diamonds": {
        slug: "super_wild_diamonds",
        name: "Super Wild Diamonds",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/sweet_success_megaways": {
        slug: "sweet_success_megaways",
        name: "Sweet Success Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/tasty_trailz": {
        slug: "tasty_trailz",
        name: "Tasty Trailz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/temple_of_treasures_megaways": {
        slug: "temple_of_treasures_megaways",
        name: "Temple of Treasures Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/the_goat": {
        slug: "the_goat",
        name: "The G.O.A.T",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/tomb_of_dead_power_4_slots": {
        slug: "tomb_of_dead_power_4_slots",
        name: "Tomb of Dead: Power 4 slots",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/trailblazer": {
        slug: "trailblazer",
        name: "Trailblazer",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/treasures_of_the_dead": {
        slug: "treasures_of_the_dead",
        name: "Treasures of the Dead",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/triple_action_cash_strike": {
        slug: "triple_action_cash_strike",
        name: "Triple Action Cash Strike",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/valletta_megaways": {
        slug: "valletta_megaways",
        name: "Valletta Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/viking_fall": {
        slug: "viking_fall",
        name: "Viking Fall",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/vikings_unleashed_megaways": {
        slug: "vikings_unleashed_megaways",
        name: "Vikings Unleashed Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/vikings_unleashed_reloaded_megaways": {
        slug: "vikings_unleashed_reloaded_megaways",
        name: "Vikings Unleashed Reloaded Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_cashpot": {
        slug: "wish_upon_a_cashpot",
        name: "Wish Upon a Cashpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_jackpot": {
        slug: "wish_upon_a_jackpot",
        name: "Wish Upon a Jackpot",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wish_upon_a_jackpot_megaways": {
        slug: "wish_upon_a_jackpot_megaways",
        name: "Wish Upon a Jackpot Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_fury_fire_blitz": {
        slug: "wolf_fury_fire_blitz",
        name: "Wolf Fury Fire Blitz",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_gold_megaways": {
        slug: "wolf_legend_gold_megaways",
        name: "Wolf Legend Gold Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_megaways": {
        slug: "wolf_legend_megaways",
        name: "Wolf Legend Megaways",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "blueprint-gaming/wolf_legend_spinboost": {
        slug: "wolf_legend_spinboost",
        name: "Wolf Legend Spinboost",
        provider: "Blueprint Gaming",
        providerSlug: "blueprint-gaming"
    },
    "boominggames/64_gold_coins_hold_and_win_20000": {
        slug: "64_gold_coins_hold_and_win_20000",
        name: "64 Gold Coins Hold and Win 20000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_nuggets_hold_and_win": {
        slug: "64_nuggets_hold_and_win",
        name: "64 Nuggets Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/64_presents_hold_and_win": {
        slug: "64_presents_hold_and_win",
        name: "64 Presents Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bamboo_wilds": {
        slug: "bamboo_wilds",
        name: "Bamboo Wilds",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/berserkin_buffalo_power_hit": {
        slug: "berserkin_buffalo_power_hit",
        name: "Berserkin Buffalo Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/black_friday_cart_craze": {
        slug: "black_friday_cart_craze",
        name: "Black Friday Cart Craze",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/blazin_bonus": {
        slug: "blazin_bonus",
        name: "Blazin' Bonus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/blazing_bullets_hold_and_win": {
        slug: "blazing_bullets_hold_and_win",
        name: "Blazing Bullets: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bonza_bucks_hold_and_win_extreme_10000": {
        slug: "bonza_bucks_hold_and_win_extreme_10000",
        name: "Bonza Bucks Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_buffalo_hold_and_win_extreme_25000": {
        slug: "booming_buffalo_hold_and_win_extreme_25000",
        name: "Booming Buffalo Hold and Win Extreme 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_seven_deluxe": {
        slug: "booming_seven_deluxe",
        name: "Booming Seven Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/booming_seven_deluxe_legacy": {
        slug: "booming_seven_deluxe_legacy",
        name: "Booming Seven Deluxe Legacy",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/boomstick_blast_link_and_loot": {
        slug: "boomstick_blast_link_and_loot",
        name: "Boomstick Blast: Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/bubble_works": {
        slug: "bubble_works",
        name: "Bubble Works",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win": {
        slug: "buffalo_hold_and_win",
        name: "Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win_extreme": {
        slug: "buffalo_hold_and_win_extreme",
        name: "Buffalo Hold and Win Extreme",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/buffalo_hold_and_win_extreme_10000": {
        slug: "buffalo_hold_and_win_extreme_10000",
        name: "Buffalo Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classic_2": {
        slug: "burning_classic_2",
        name: "Burning Classic 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics": {
        slug: "burning_classics",
        name: "Burning Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_5000": {
        slug: "burning_classics_5000",
        name: "Burning Classics 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_go_wild": {
        slug: "burning_classics_go_wild",
        name: "Burning Classics Go Wild",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_classics_royal_edition": {
        slug: "burning_classics_royal_edition",
        name: "Burning Classics \nRoyal Edition",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/burning_love": {
        slug: "burning_love",
        name: "Burning Love",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig": {
        slug: "cash_pig",
        name: "Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig_2": {
        slug: "cash_pig_2",
        name: "Cash Pig 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/cash_pig_2_15000": {
        slug: "cash_pig_2_15000",
        name: "Cash Pig 2 15000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/chief_hawks_spirit_walk": {
        slug: "chief_hawks_spirit_walk",
        name: "Chief Hawks Spirit Walk",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/classico": {
        slug: "classico",
        name: "Classico",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/coin_crusher_hold_and_win": {
        slug: "coin_crusher_hold_and_win",
        name: "Coin Crusher Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/crack_the_bank_hold_and_win": {
        slug: "crack_the_bank_hold_and_win",
        name: "Crack the Bank Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_forge_link_and_loot": {
        slug: "diamond_forge_link_and_loot",
        name: "Diamond Forge Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_hits": {
        slug: "diamond_hits",
        name: "Diamond Hits",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_hits_trio_instastrike": {
        slug: "diamond_hits_trio_instastrike",
        name: "Diamond Hits Trio Instastrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamond_riches": {
        slug: "diamond_riches",
        name: "Diamond Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamonds_diamonds_diamonds_hold_and_win": {
        slug: "diamonds_diamonds_diamonds_hold_and_win",
        name: "Diamonds Diamonds Diamonds Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/diamonds_of_liberty": {
        slug: "diamonds_of_liberty",
        name: "Diamonds of Liberty",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/dynamite_trio": {
        slug: "dynamite_trio",
        name: "Dynamite Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/easter_classics": {
        slug: "easter_classics",
        name: "Easter Classics",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_colossal_catch_link_and_loot": {
        slug: "fish_tales_colossal_catch_link_and_loot",
        name: "Fish Tales Colossal Catch Link and Loot",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_double_catch": {
        slug: "fish_tales_double_catch",
        name: "Fish Tales Double Catch",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_double_catch_max_scatter": {
        slug: "fish_tales_double_catch_max_scatter",
        name: "Fish Tales: Double Catch Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_halloween": {
        slug: "fish_tales_halloween",
        name: "Fish Tales Halloween",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_monster_bass": {
        slug: "fish_tales_monster_bass",
        name: "Fish Tales Monster Bass",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fish_tales_monster_bass_10000": {
        slug: "fish_tales_monster_bass_10000",
        name: "Fish Tales Monster Bass 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fly_on": {
        slug: "fly_on",
        name: "Fly On!",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/forbidden_temple_power_hit": {
        slug: "forbidden_temple_power_hit",
        name: "Forbidden Temple Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fortune_paw": {
        slug: "fortune_paw",
        name: "Fortune Paw",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/fortune_surge": {
        slug: "fortune_surge",
        name: "Fortune Surge",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gates_of_hercules_10000": {
        slug: "gates_of_hercules_10000",
        name: "Gates of Hercules 10,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_and_glamour_hold_and_win": {
        slug: "gold_and_glamour_hold_and_win",
        name: "Gold and Glamour Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold": {
        slug: "gold_gold_gold",
        name: "Gold Gold Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold_5000": {
        slug: "gold_gold_gold_5000",
        name: "Gold Gold Gold 5000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/gold_gold_gold_hold_and_win": {
        slug: "gold_gold_gold_hold_and_win",
        name: "Gold Gold Gold Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greedy_for_gold_hold_and_win": {
        slug: "greedy_for_gold_hold_and_win",
        name: "Greedy for Gold: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greedy_for_gold_power_hit": {
        slug: "greedy_for_gold_power_hit",
        name: "Greedy for Gold Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greedy_for_gold_power_hit_10000": {
        slug: "greedy_for_gold_power_hit_10000",
        name: "Greedy for Gold: Power Hit 10,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/greek_legends": {
        slug: "greek_legends",
        name: "Greek Legends",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/henhouse_hustle_hold_and_win": {
        slug: "henhouse_hustle_hold_and_win",
        name: "Henhouse Hustle: Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/holly_jolly_bonanza_2": {
        slug: "holly_jolly_bonanza_2",
        name: "Holly Jolly Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/holly_jolly_cash_pig": {
        slug: "holly_jolly_cash_pig",
        name: "Holly Jolly Cash Pig",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/hot_charge": {
        slug: "hot_charge",
        name: "Hot Charge",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/howling_for_gold": {
        slug: "howling_for_gold",
        name: "Howling for Gold",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/inferno_fortune_instastrike": {
        slug: "inferno_fortune_instastrike",
        name: "Inferno Fortune InstaStrike",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/inferno_fortune_power_hit": {
        slug: "inferno_fortune_power_hit",
        name: "Inferno Fortune Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/jesters_bells_bonanza": {
        slug: "jesters_bells_bonanza",
        name: "Jester's Bells Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/king_cobra": {
        slug: "king_cobra",
        name: "King Cobra",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/liberty_and_freedom_hold_and_win_extreme_10000": {
        slug: "liberty_and_freedom_hold_and_win_extreme_10000",
        name: "Liberty and Freedom Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/lucky_charms_trio": {
        slug: "lucky_charms_trio",
        name: "Lucky Charms Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/lucky_charms_trio_10000": {
        slug: "lucky_charms_trio_10000",
        name: "Lucky Charms Trio 10,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_hold_and_win": {
        slug: "mr_oinksters_hold_and_win",
        name: "Mr. Oinksters Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_hold_and_win_10000": {
        slug: "mr_oinksters_hold_and_win_10000",
        name: "Mr. Oinkster's Hold and Win 10,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_key_to_riches": {
        slug: "mr_oinksters_key_to_riches",
        name: "Mr. Oinkster's Key to Riches",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mr_oinksters_power_hit": {
        slug: "mr_oinksters_power_hit",
        name: "Mr. Oinkster's Power Hit",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mustang_hold_and_win": {
        slug: "mustang_hold_and_win",
        name: "Mustang Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/mustangs_and_stallions": {
        slug: "mustangs_and_stallions",
        name: "Mustangs and Stallions",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/polar_buffalo_extreme_hold_and_win_25000": {
        slug: "polar_buffalo_extreme_hold_and_win_25000",
        name: "Polar Buffalo Extreme Hold and Win 25,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_atlantis_trio": {
        slug: "power_of_atlantis_trio",
        name: "Power of Atlantis Trio",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_hercules_bonanza": {
        slug: "power_of_hercules_bonanza",
        name: "Power of Hercules Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/power_of_olympus": {
        slug: "power_of_olympus",
        name: "Power of Olympus",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/primal_buffalo_powergrid": {
        slug: "primal_buffalo_powergrid",
        name: "Primal Buffalo PowerGrid",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/raccoon_raiders": {
        slug: "raccoon_raiders",
        name: "Raccoon Raiders",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ras_relics_bonanza": {
        slug: "ras_relics_bonanza",
        name: "Ra's Relics Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/reels_paradise": {
        slug: "reels_paradise",
        name: "Reels Paradise",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/regal_coins_hold_and_win": {
        slug: "regal_coins_hold_and_win",
        name: "Regal Coins Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ronaldinhos_streetball_bonanza": {
        slug: "ronaldinhos_streetball_bonanza",
        name: "Ronaldinho's Streetball Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/sacred_buffalo": {
        slug: "sacred_buffalo",
        name: "Sacred Buffalo",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/santa_in_vegas": {
        slug: "santa_in_vegas",
        name: "Santa in Vegas",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/santas_snowball_smash_instant_win": {
        slug: "santas_snowball_smash_instant_win",
        name: "Santas Snowball Smash Instant Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/shields_of_gold_valkyrie_hold_and_win": {
        slug: "shields_of_gold_valkyrie_hold_and_win",
        name: "Shields of Gold Valkyrie Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/spooktacular_bonanza": {
        slug: "spooktacular_bonanza",
        name: "Spooktacular Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/super_duper": {
        slug: "super_duper",
        name: "Super Duper",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza": {
        slug: "tasty_bonanza",
        name: "Tasty Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza_1000": {
        slug: "tasty_bonanza_1000",
        name: "Tasty Bonanza 1,000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_bonanza_max_scatter": {
        slug: "tasty_bonanza_max_scatter",
        name: "Tasty Bonanza Max Scatter",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tasty_rush_sweet_spots": {
        slug: "tasty_rush_sweet_spots",
        name: "Tasty Rush Sweet Spots",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_mighty_toro": {
        slug: "the_mighty_toro",
        name: "The Mighty Toro",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_wild_wings_of_phoenix": {
        slug: "the_wild_wings_of_phoenix",
        name: "The Wild Wings of Phoenix",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/the_wild_wings_of_phoenix_deluxe": {
        slug: "the_wild_wings_of_phoenix_deluxe",
        name: "The Wild Wings of Phoenix Deluxe",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/thunder_eagle_hold_and_win_10000": {
        slug: "thunder_eagle_hold_and_win_10000",
        name: "Thunder Eagle Hold and Win 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tnt_bonanza": {
        slug: "tnt_bonanza",
        name: "TNT Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/tnt_bonanza_2": {
        slug: "tnt_bonanza_2",
        name: "TNT Bonanza 2",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/treasure_vault": {
        slug: "treasure_vault",
        name: "Treasure Vault",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/trollfufu_bonanza": {
        slug: "trollfufu_bonanza",
        name: "Trollfufu Bonanza",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/twin_buffalo_hold_and_win": {
        slug: "twin_buffalo_hold_and_win",
        name: "Twin Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/ultra_buffalo_hold_and_win": {
        slug: "ultra_buffalo_hold_and_win",
        name: "Ultra Buffalo Hold and Win",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/vampires_blood_moon": {
        slug: "vampires_blood_moon",
        name: "Vampires: Blood Moon",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/way_of_the_wolf_hold_and_win_extreme_10000": {
        slug: "way_of_the_wolf_hold_and_win_extreme_10000",
        name: "Way of the Wolf Hold and Win Extreme 10000",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "boominggames/wild_silverback": {
        slug: "wild_silverback",
        name: "Wild Silverback",
        provider: "BoomingGames",
        providerSlug: "boominggames"
    },
    "bulletproof-games/7th_squadron_doublemax": {
        slug: "7th_squadron_doublemax",
        name: "7th Squadron Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/banana_twist": {
        slug: "banana_twist",
        name: "Banana Twist",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/diamond_symphony_doublemax": {
        slug: "diamond_symphony_doublemax",
        name: "Diamond Symphony Doublemax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/dragon_lore_gigarise": {
        slug: "dragon_lore_gigarise",
        name: "Dragon Lore Gigarise",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/hunters_moon_gigablox": {
        slug: "hunters_moon_gigablox",
        name: "Hunters Moon Gigablox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/irish_pots_multimax": {
        slug: "irish_pots_multimax",
        name: "Irish Pots Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/juiced_duomax": {
        slug: "juiced_duomax",
        name: "Juiced Duomax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/lollipop_drop_multimax": {
        slug: "lollipop_drop_multimax",
        name: "Lollipop Drop Multimax",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/midas_vs_medusa_wild_energy": {
        slug: "midas_vs_medusa_wild_energy",
        name: "Midas vs Medusa Wild Energy",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/roby_dick": {
        slug: "roby_dick",
        name: "Roby Dick",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/soccerbet_legends": {
        slug: "soccerbet_legends",
        name: "Soccerbet Legends",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tiki_runner_clusters": {
        slug: "tiki_runner_clusters",
        name: "Tiki Runner Clusters",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tiki_runner_gigablox": {
        slug: "tiki_runner_gigablox",
        name: "Tiki Runner GigaBlox",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "bulletproof-games/tumble_in_the_jungle_wild_fight": {
        slug: "tumble_in_the_jungle_wild_fight",
        name: "Tumble in the Jungle Wild Fight",
        provider: "Bulletproof Games",
        providerSlug: "bulletproof-games"
    },
    "coinraces/crypto_racing": {
        slug: "crypto_racing",
        name: "Crypto Racing",
        provider: "Coinraces",
        providerSlug: "coinraces"
    },
    "cq9slot/3_2_1_go": {
        slug: "3_2_1_go",
        name: "3 2 1 Go!",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/5_boxing": {
        slug: "5_boxing",
        name: "5 Boxing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/5_god_beasts": {
        slug: "5_god_beasts",
        name: "5 God Beasts",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/6_toros": {
        slug: "6_toros",
        name: "6 Toros",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/777": {
        slug: "777",
        name: "777",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/888": {
        slug: "888",
        name: "888",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/888_cai_shen": {
        slug: "888_cai_shen",
        name: "888 Cai Shen",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/acrobatics": {
        slug: "acrobatics",
        name: "Acrobatics",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/aladdins_lamp": {
        slug: "aladdins_lamp",
        name: "Aladdin's lamp",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/alice_run": {
        slug: "alice_run",
        name: "Alice Run",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/alice_run_jp": {
        slug: "alice_run_jp",
        name: "Alice Run JP",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/all_star_team": {
        slug: "all_star_team",
        name: "All Star Team",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/all_wilds": {
        slug: "all_wilds",
        name: "All Wilds",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/aog_blade_cockfight": {
        slug: "aog_blade_cockfight",
        name: "AOG Blade Cockfight",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/aog_gaff_cockfight": {
        slug: "aog_gaff_cockfight",
        name: "AOG Gaff Cockfight",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/apollo": {
        slug: "apollo",
        name: "Apollo",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/apsaras": {
        slug: "apsaras",
        name: "Apsaras",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ba_xian_chuan_qi": {
        slug: "ba_xian_chuan_qi",
        name: "Ba Xian Chuan Qi",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/backyard_gold": {
        slug: "backyard_gold",
        name: "Backyard Gold",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/banker_dice_bullbull": {
        slug: "banker_dice_bullbull",
        name: "Banker Dice Bull-Bull",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/baseball_fever": {
        slug: "baseball_fever",
        name: "Baseball Fever",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/beanstalk": {
        slug: "beanstalk",
        name: "Beanstalk",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/big_wolf": {
        slug: "big_wolf",
        name: "Big Wolf",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/black_wukong": {
        slug: "black_wukong",
        name: "Black Wukong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/boots_of_luck": {
        slug: "boots_of_luck",
        name: "Boots of Luck",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/burning_xiyou": {
        slug: "burning_xiyou",
        name: "Burning Xi-You",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/chameleon": {
        slug: "chameleon",
        name: "Chameleon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/chicago_": {
        slug: "chicago_",
        name: "CHICAGO ?",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/chicky_parm_parm": {
        slug: "chicky_parm_parm",
        name: "Chicky Parm Parm",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/cirque_de_fous": {
        slug: "cirque_de_fous",
        name: "Cirque de fous",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/coin_spinner": {
        slug: "coin_spinner",
        name: "Coin Spinner",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/crazy_nuozha": {
        slug: "crazy_nuozha",
        name: "Crazy NuoZha",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/cricket_fever": {
        slug: "cricket_fever",
        name: "Cricket Fever",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/da_fa_cai": {
        slug: "da_fa_cai",
        name: "Da Fa Cai",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/da_fu_xing": {
        slug: "da_fu_xing",
        name: "Da Fu Xing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/da_hong_zhong": {
        slug: "da_hong_zhong",
        name: "Da Hong Zhong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/detective_dee": {
        slug: "detective_dee",
        name: "Detective Dee",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/detective_dee_2": {
        slug: "detective_dee_2",
        name: "Detective Dee 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/diamond_fruit": {
        slug: "diamond_fruit",
        name: "Diamond Fruit",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/diamond_treasure": {
        slug: "diamond_treasure",
        name: "Diamond Treasure",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/disco_night": {
        slug: "disco_night",
        name: "Disco Night",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/disco_night_m": {
        slug: "disco_night_m",
        name: "Disco Night M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/doggone_lucky": {
        slug: "doggone_lucky",
        name: "Doggone Lucky",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dollar_bomb": {
        slug: "dollar_bomb",
        name: "Dollar Bomb",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dou_di_zhu": {
        slug: "dou_di_zhu",
        name: "Dou Di Zhu",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dou_di_zhu_plus": {
        slug: "dou_di_zhu_plus",
        name: "Dou Di Zhu Plus",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/double_fly": {
        slug: "double_fly",
        name: "Double Fly",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/double_happiness": {
        slug: "double_happiness",
        name: "Double Happiness",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/double_happy": {
        slug: "double_happy",
        name: "Double Happy",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_ball": {
        slug: "dragon_ball",
        name: "Dragon Ball",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_ball_dozer": {
        slug: "dragon_ball_dozer",
        name: "Dragon Ball Dozer",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_gate": {
        slug: "dragon_gate",
        name: "Dragon Gate",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_heart": {
        slug: "dragon_heart",
        name: "Dragon Heart",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_hunters": {
        slug: "dragon_hunters",
        name: "Dragon Hunters",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_koi": {
        slug: "dragon_koi",
        name: "Dragon Koi",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragon_pachinko": {
        slug: "dragon_pachinko",
        name: "Dragon Pachinko",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/dragons_treasure": {
        slug: "dragons_treasure",
        name: "Dragon's Treasure",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ecstatic_circus": {
        slug: "ecstatic_circus",
        name: "Ecstatic Circus",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/empress_wu": {
        slug: "empress_wu",
        name: "Empress Wu",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/eternal_fortune": {
        slug: "eternal_fortune",
        name: "Eternal Fortune",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fa_cai_fu_wa": {
        slug: "fa_cai_fu_wa",
        name: "Fa Cai Fu Wa",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fa_cai_shen": {
        slug: "fa_cai_shen",
        name: "Fa Cai Shen",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fa_cai_shen_m": {
        slug: "fa_cai_shen_m",
        name: "Fa Cai Shen M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fa_cai_shen2": {
        slug: "fa_cai_shen2",
        name: "Fa Cai Shen2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire_chibi": {
        slug: "fire_chibi",
        name: "Fire Chibi",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire_chibi_2": {
        slug: "fire_chibi_2",
        name: "Fire Chibi 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire_chibi_m": {
        slug: "fire_chibi_m",
        name: "Fire Chibi M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire_queen": {
        slug: "fire_queen",
        name: "Fire Queen",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire_queen_2": {
        slug: "fire_queen_2",
        name: "Fire Queen 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fire777": {
        slug: "fire777",
        name: "Fire777",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fishing_king": {
        slug: "fishing_king",
        name: "Fishing King",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/five_ghosts": {
        slug: "five_ghosts",
        name: "Five Ghosts",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/five_lucky_elements": {
        slug: "five_lucky_elements",
        name: "Five Lucky Elements",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/floating_market": {
        slug: "floating_market",
        name: "Floating Market",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/flower_fortunes": {
        slug: "flower_fortunes",
        name: "Flower Fortunes",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fly_out": {
        slug: "fly_out",
        name: "Fly Out",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/flying_cai_shen": {
        slug: "flying_cai_shen",
        name: "Flying Cai Shen",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/football_baby": {
        slug: "football_baby",
        name: "Football Baby",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/football_boots": {
        slug: "football_boots",
        name: "Football Boots",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/football_fever": {
        slug: "football_fever",
        name: "Football Fever",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/football_fever_m": {
        slug: "football_fever_m",
        name: "Football Fever M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fortune_cats": {
        slug: "fortune_cats",
        name: "Fortune Cats",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fortune_dragon": {
        slug: "fortune_dragon",
        name: "Fortune Dragon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fortune_gate": {
        slug: "fortune_gate",
        name: "Fortune Gate",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fortune_spirits": {
        slug: "fortune_spirits",
        name: "Fortune Spirits",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fortune_totem": {
        slug: "fortune_totem",
        name: "Fortune Totem",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/frozen_world": {
        slug: "frozen_world",
        name: "Frozen World",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fruit_king": {
        slug: "fruit_king",
        name: "Fruit King",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fruit_king_ii": {
        slug: "fruit_king_ii",
        name: "Fruit King II",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/fruity_carnival": {
        slug: "fruity_carnival",
        name: "Fruity Carnival",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/funky_bingo": {
        slug: "funky_bingo",
        name: "Funky Bingo",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/funny_alpaca": {
        slug: "funny_alpaca",
        name: "Funny Alpaca",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ganesha_jr": {
        slug: "ganesha_jr",
        name: "Ganesha Jr.",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/genie": {
        slug: "genie",
        name: "GENIE",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/go_fishing": {
        slug: "go_fishing",
        name: "Go Fishing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/god_of_chess": {
        slug: "god_of_chess",
        name: "God Of Chess",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/god_of_war": {
        slug: "god_of_war",
        name: "God of War",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/god_of_war_m": {
        slug: "god_of_war_m",
        name: "God of War M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gold_stealer": {
        slug: "gold_stealer",
        name: "Gold Stealer",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/golden_dragon_club": {
        slug: "golden_dragon_club",
        name: "Golden Dragon Club",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/golden_eggs": {
        slug: "golden_eggs",
        name: "Golden Eggs",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/golden_eggs_jp": {
        slug: "golden_eggs_jp",
        name: "Golden Eggs JP",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/golden_mayan": {
        slug: "golden_mayan",
        name: "Golden Mayan",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/good_fortune": {
        slug: "good_fortune",
        name: "Good Fortune",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/good_fortune_m": {
        slug: "good_fortune_m",
        name: "Good Fortune M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gophers_war": {
        slug: "gophers_war",
        name: "Gophers War",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/great_lion": {
        slug: "great_lion",
        name: "Great Lion",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/greek_gods": {
        slug: "greek_gods",
        name: "Greek Gods",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gu_gu_gu_2_m": {
        slug: "gu_gu_gu_2_m",
        name: "Gu Gu Gu 2 M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gu_gu_gu_3": {
        slug: "gu_gu_gu_3",
        name: "Gu Gu Gu 3",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gu_gu_gu_m": {
        slug: "gu_gu_gu_m",
        name: "Gu Gu Gu M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gugugu": {
        slug: "gugugu",
        name: "GuGuGu",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/gugugu_2": {
        slug: "gugugu_2",
        name: "GuGuGu 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hanuman_bingo": {
        slug: "hanuman_bingo",
        name: "Hanuman Bingo",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/happy_buddha": {
        slug: "happy_buddha",
        name: "HAPPY BUDDHA",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/happy_insect": {
        slug: "happy_insect",
        name: "Happy Insect",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/happy_rich_year": {
        slug: "happy_rich_year",
        name: "Happy Rich Year",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hephaestus": {
        slug: "hephaestus",
        name: "Hephaestus",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hercules": {
        slug: "hercules",
        name: "Hercules",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hero_fishing": {
        slug: "hero_fishing",
        name: "Hero Fishing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hero_of_the_3_kingdoms_cao_cao": {
        slug: "hero_of_the_3_kingdoms_cao_cao",
        name: "Hero of the 3 Kingdoms Cao Cao",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hollywood_pets": {
        slug: "hollywood_pets",
        name: "Hollywood Pets",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hong_kong_flavor": {
        slug: "hong_kong_flavor",
        name: "Hong Kong Flavor",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hot_dj": {
        slug: "hot_dj",
        name: "Hot DJ",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hot_pinatas": {
        slug: "hot_pinatas",
        name: "Hot Pinatas",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hot_spin": {
        slug: "hot_spin",
        name: "Hot Spin",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hu_got_lucky": {
        slug: "hu_got_lucky",
        name: "Hu Got Lucky",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/huga": {
        slug: "huga",
        name: "HUGA",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/hungry_cats": {
        slug: "hungry_cats",
        name: "Hungry Cats",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/invincible_elephant": {
        slug: "invincible_elephant",
        name: "Invincible Elephant",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jewel_luxury": {
        slug: "jewel_luxury",
        name: "Jewel Luxury",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jin_bi_hui_huang": {
        slug: "jin_bi_hui_huang",
        name: "Jin Bi Hui Huang",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jin_lian_pan": {
        slug: "jin_lian_pan",
        name: "JIN LIAN PAN",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jump_high": {
        slug: "jump_high",
        name: "Jump High",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jump_high_2": {
        slug: "jump_high_2",
        name: "Jump High 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jump_higher": {
        slug: "jump_higher",
        name: "Jump Higher",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jump_higher_mobile": {
        slug: "jump_higher_mobile",
        name: "Jump Higher mobile",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jumping_mobile": {
        slug: "jumping_mobile",
        name: "Jumping mobile",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jungle_island": {
        slug: "jungle_island",
        name: "JUNGLE ISLAND",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jungle_party": {
        slug: "jungle_party",
        name: "Jungle Party",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/jungle_treasure": {
        slug: "jungle_treasure",
        name: "Jungle Treasure",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/kickin_kash": {
        slug: "kickin_kash",
        name: "Kickin' Kash",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/king_kong_shake": {
        slug: "king_kong_shake",
        name: "King Kong Shake",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/king_of_atlantis": {
        slug: "king_of_atlantis",
        name: "King of Atlantis",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ko_island": {
        slug: "ko_island",
        name: "K.O. Island",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/kronos": {
        slug: "kronos",
        name: "Kronos",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/landlord_fights_carnival": {
        slug: "landlord_fights_carnival",
        name: "Landlord Fights Carnival",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/le_cirque": {
        slug: "le_cirque",
        name: "Le Cirque",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lin_chong": {
        slug: "lin_chong",
        name: "Lin Chong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lonely_planet": {
        slug: "lonely_planet",
        name: "Lonely Planet",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/longlaifa": {
        slug: "longlaifa",
        name: "LongLaiFa",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/longlonglong": {
        slug: "longlonglong",
        name: "LongLongLong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lord_ganesha": {
        slug: "lord_ganesha",
        name: "Lord Ganesha",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lotus_lantern": {
        slug: "lotus_lantern",
        name: "Lotus Lantern",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/love_story": {
        slug: "love_story",
        name: "Love Story",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/loy_krathong": {
        slug: "loy_krathong",
        name: "Loy Krathong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_3": {
        slug: "lucky_3",
        name: "Lucky 3",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_bats": {
        slug: "lucky_bats",
        name: "Lucky Bats",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_bats_jp": {
        slug: "lucky_bats_jp",
        name: "Lucky Bats JP",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_bats_m": {
        slug: "lucky_bats_m",
        name: "Lucky Bats M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_boxes": {
        slug: "lucky_boxes",
        name: "Lucky Boxes",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_fishing": {
        slug: "lucky_fishing",
        name: "Lucky Fishing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_legend": {
        slug: "lucky_legend",
        name: "Lucky Legend",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/lucky_tigers": {
        slug: "lucky_tigers",
        name: "Lucky Tigers",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mafia": {
        slug: "mafia",
        name: "Mafia",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/magic_world": {
        slug: "magic_world",
        name: "Magic World",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/magpie_bridge": {
        slug: "magpie_bridge",
        name: "Magpie Bridge",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mahjong_for_2_players": {
        slug: "mahjong_for_2_players",
        name: "Mahjong For 2 Players",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mahjong_fruit": {
        slug: "mahjong_fruit",
        name: "Mahjong Fruit",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mahjong_rich_ways": {
        slug: "mahjong_rich_ways",
        name: "Mahjong Rich Ways",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/master_panda": {
        slug: "master_panda",
        name: "Master Panda",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mazu": {
        slug: "mazu",
        name: "Mazu",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mega_winner": {
        slug: "mega_winner",
        name: "Mega Winner",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/meow": {
        slug: "meow",
        name: "Meow",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mini_roulette": {
        slug: "mini_roulette",
        name: "Mini Roulette",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mirror_mirror": {
        slug: "mirror_mirror",
        name: "Mirror Mirror",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/money_tree": {
        slug: "money_tree",
        name: "Money Tree",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/monkey_king": {
        slug: "monkey_king",
        name: "MONKEY KING",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/monkey_office_legend": {
        slug: "monkey_office_legend",
        name: "Monkey Office Legend",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/monster_hunter": {
        slug: "monster_hunter",
        name: "Monster Hunter",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/move_n_jump": {
        slug: "move_n_jump",
        name: "Move n' Jump",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mr_miser": {
        slug: "mr_miser",
        name: "Mr. Miser",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mr_rich": {
        slug: "mr_rich",
        name: "Mr. Rich",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mrbean": {
        slug: "mrbean",
        name: "Mr.Bean",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/muay_thai": {
        slug: "muay_thai",
        name: "Muay Thai",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mulan": {
        slug: "mulan",
        name: "MULAN",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/mummys_treasure": {
        slug: "mummys_treasure",
        name: "Mummy's Treasure",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/myeongryang": {
        slug: "myeongryang",
        name: "Myeong-ryang",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/myth": {
        slug: "myth",
        name: "Myth",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ne_zha_advent": {
        slug: "ne_zha_advent",
        name: "Ne Zha Advent",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/nezha": {
        slug: "nezha",
        name: "Nezha",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/night_city": {
        slug: "night_city",
        name: "Night City",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/ninja_raccoon": {
        slug: "ninja_raccoon",
        name: "Ninja Raccoon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/niu_niu_niu": {
        slug: "niu_niu_niu",
        name: "Niu Niu Niu",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/oneshot_fishing": {
        slug: "oneshot_fishing",
        name: "Oneshot Fishing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/oo_ga_cha_ka": {
        slug: "oo_ga_cha_ka",
        name: "Oo Ga Cha Ka",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/oriental_beauty": {
        slug: "oriental_beauty",
        name: "Oriental Beauty",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/paradise": {
        slug: "paradise",
        name: "Paradise",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/party_island": {
        slug: "party_island",
        name: "PARTY ISLAND",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/peeking_banker_bullbull": {
        slug: "peeking_banker_bullbull",
        name: "Peeking Banker Bull-Bull",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/pharaohs_gold": {
        slug: "pharaohs_gold",
        name: "Pharaoh's Gold",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/pig_of_luck": {
        slug: "pig_of_luck",
        name: "Pig Of Luck",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/poseidon": {
        slug: "poseidon",
        name: "Poseidon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/pub_tycoon": {
        slug: "pub_tycoon",
        name: "Pub Tycoon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/pyramid_raider": {
        slug: "pyramid_raider",
        name: "Pyramid Raider",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/queen_of_dead": {
        slug: "queen_of_dead",
        name: "Queen Of Dead",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rabbit_rampage": {
        slug: "rabbit_rampage",
        name: "Rabbit Rampage",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rave_high": {
        slug: "rave_high",
        name: "Rave High",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rave_jump": {
        slug: "rave_jump",
        name: "Rave Jump",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rave_jump_2": {
        slug: "rave_jump_2",
        name: "Rave Jump 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rave_jump_2_m": {
        slug: "rave_jump_2_m",
        name: "Rave Jump 2 M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rave_jump_mobile": {
        slug: "rave_jump_mobile",
        name: "Rave Jump mobile",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/red_phoenix": {
        slug: "red_phoenix",
        name: "Red Phoenix",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rolling_dragon": {
        slug: "rolling_dragon",
        name: "ROLLING DRAGON",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/royal_fruit": {
        slug: "royal_fruit",
        name: "Royal Fruit",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/running_animals": {
        slug: "running_animals",
        name: "Running Animals",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/runningtoro": {
        slug: "runningtoro",
        name: "RunningToro",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/rush_hour": {
        slug: "rush_hour",
        name: "Rush Hour",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sakura_legend": {
        slug: "sakura_legend",
        name: "Sakura Legend",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/seotda": {
        slug: "seotda",
        name: "Seotda",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sheng_xiao_chuan_qi": {
        slug: "sheng_xiao_chuan_qi",
        name: "Sheng Xiao Chuan Qi",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sherlock_holmes": {
        slug: "sherlock_holmes",
        name: "Sherlock Holmes",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/shouxin": {
        slug: "shouxin",
        name: "Shou-Xin",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/six_candy": {
        slug: "six_candy",
        name: "Six Candy",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/six_gacha": {
        slug: "six_gacha",
        name: "Six Gacha",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/skrskr": {
        slug: "skrskr",
        name: "SkrSkr",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sky_lanterns": {
        slug: "sky_lanterns",
        name: "Sky Lanterns",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/slot_777": {
        slug: "slot_777",
        name: "Slot 777",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/snow_queen": {
        slug: "snow_queen",
        name: "Snow Queen",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/so_sweet": {
        slug: "so_sweet",
        name: "So Sweet",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/songkran": {
        slug: "songkran",
        name: "Songkran",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/songkran_festival": {
        slug: "songkran_festival",
        name: "Songkran Festival",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/stone_to_gold": {
        slug: "stone_to_gold",
        name: "Stone to Gold",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/striker_wild": {
        slug: "striker_wild",
        name: "Striker WILD",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/summer_mood": {
        slug: "summer_mood",
        name: "Summer Mood",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sun_er_niang": {
        slug: "sun_er_niang",
        name: "Sun Er Niang",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sung_wukong": {
        slug: "sung_wukong",
        name: "Sung Wukong",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/super_5": {
        slug: "super_5",
        name: "Super 5",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sweet_666_deluxe": {
        slug: "sweet_666_deluxe",
        name: "Sweet 666 Deluxe",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/sweet_pop": {
        slug: "sweet_pop",
        name: "Sweet POP",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/tenfold_eggs": {
        slug: "tenfold_eggs",
        name: "Tenfold Eggs",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/thai_fish_prawn_crab": {
        slug: "thai_fish_prawn_crab",
        name: "Thai Fish Prawn Crab",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/thai_hilo": {
        slug: "thai_hilo",
        name: "Thai HILO",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/thai_pok_deng": {
        slug: "thai_pok_deng",
        name: "Thai Pok Deng",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_beast_war": {
        slug: "the_beast_war",
        name: "The Beast War",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_chicken_house": {
        slug: "the_chicken_house",
        name: "The Chicken House",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_cupids": {
        slug: "the_cupids",
        name: "The Cupids",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_dragon_brings_wealth": {
        slug: "the_dragon_brings_wealth",
        name: "The Dragon Brings Wealth",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_dragon_brings_wealth_2": {
        slug: "the_dragon_brings_wealth_2",
        name: "The Dragon Brings Wealth 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_legend_of_snake": {
        slug: "the_legend_of_snake",
        name: "The  Legend Of Snake",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/the_magic_brush": {
        slug: "the_magic_brush",
        name: "The Magic Brush",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/thor": {
        slug: "thor",
        name: "THOR",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/thor_2": {
        slug: "thor_2",
        name: "Thor 2",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/tiger_hero": {
        slug: "tiger_hero",
        name: "TIGER HERO",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_bowl": {
        slug: "treasure_bowl",
        name: "Treasure Bowl",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_bowl_jp": {
        slug: "treasure_bowl_jp",
        name: "Treasure Bowl JP",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_house": {
        slug: "treasure_house",
        name: "Treasure House",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_island": {
        slug: "treasure_island",
        name: "Treasure Island",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_koi": {
        slug: "treasure_koi",
        name: "Treasure Koi",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_of_seti": {
        slug: "treasure_of_seti",
        name: "Treasure of Seti",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/treasure_pirate": {
        slug: "treasure_pirate",
        name: "Treasure Pirate",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/typhoon_cash": {
        slug: "typhoon_cash",
        name: "Typhoon Cash",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/uproar_in_heaven": {
        slug: "uproar_in_heaven",
        name: "Uproar In Heaven",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/vampire_kiss": {
        slug: "vampire_kiss",
        name: "Vampire Kiss",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wanbaodino": {
        slug: "wanbaodino",
        name: "WanBaoDino",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/watah_master": {
        slug: "watah_master",
        name: "Watah Master",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/water_margin": {
        slug: "water_margin",
        name: "Water Margin",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/water_world": {
        slug: "water_world",
        name: "Water World",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wealthy_chicken": {
        slug: "wealthy_chicken",
        name: "Wealthy Chicken",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wheel_money": {
        slug: "wheel_money",
        name: "Wheel Money",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wild_chameleon": {
        slug: "wild_chameleon",
        name: "Wild Chameleon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wild_disco_night": {
        slug: "wild_disco_night",
        name: "Wild Disco Night",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wild_fudge": {
        slug: "wild_fudge",
        name: "Wild Fudge",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wild_tarzan": {
        slug: "wild_tarzan",
        name: "Wild Tarzan",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wing_chun": {
        slug: "wing_chun",
        name: "Wing Chun",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wolf_disco": {
        slug: "wolf_disco",
        name: "Wolf Disco",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wolf_moon": {
        slug: "wolf_moon",
        name: "Wolf Moon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wonderland": {
        slug: "wonderland",
        name: "Wonderland",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wonwonwon": {
        slug: "wonwonwon",
        name: "WonWonWon",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/world_cup_russia_2018": {
        slug: "world_cup_russia_2018",
        name: "World Cup Russia 2018",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/wukong_and_peaches": {
        slug: "wukong_and_peaches",
        name: "WuKong and Peaches",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xiao_fu_xing": {
        slug: "xiao_fu_xing",
        name: "Xiao Fu Xing",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xiao_ne_zha": {
        slug: "xiao_ne_zha",
        name: "Xiao Ne Zha",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xiyouji": {
        slug: "xiyouji",
        name: "XIYOUJI",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xmas": {
        slug: "xmas",
        name: "Xmas",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xmas_tales": {
        slug: "xmas_tales",
        name: "Xmas Tales",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/xoc_dia": {
        slug: "xoc_dia",
        name: "Xoc Dia",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/yuan_bao": {
        slug: "yuan_bao",
        name: "Yuan Bao",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/zeus": {
        slug: "zeus",
        name: "Zeus",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/zeus_m": {
        slug: "zeus_m",
        name: "Zeus M",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/zhong_kui": {
        slug: "zhong_kui",
        name: "Zhong Kui",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/zombies_fortune": {
        slug: "zombies_fortune",
        name: "Zombie's Fortune",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "cq9slot/zuma_wild": {
        slug: "zuma_wild",
        name: "Zuma Wild",
        provider: "Cq9slot",
        providerSlug: "cq9slot"
    },
    "creedroomz/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_auto_roulette": {
        slug: "aurum_auto_roulette",
        name: "Aurum Auto Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_auto_roulette_lava": {
        slug: "aurum_auto_roulette_lava",
        name: "Aurum Auto Roulette Lava",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_auto_roulette_luxe": {
        slug: "aurum_auto_roulette_luxe",
        name: "Aurum Auto Roulette Luxe",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_auto_roulette_speed": {
        slug: "aurum_auto_roulette_speed",
        name: "Aurum Auto Roulette Speed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_immersion_roulette": {
        slug: "aurum_immersion_roulette",
        name: "Aurum Immersion Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette": {
        slug: "aurum_roulette",
        name: "Aurum Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_arabic": {
        slug: "aurum_roulette_arabic",
        name: "Aurum Roulette Arabic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_armenian": {
        slug: "aurum_roulette_armenian",
        name: "Aurum Roulette Armenian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_brasileira": {
        slug: "aurum_roulette_brasileira",
        name: "Aurum Roulette Brasileira",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_eclipse": {
        slug: "aurum_roulette_eclipse",
        name: "Aurum Roulette Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_english": {
        slug: "aurum_roulette_english",
        name: "Aurum Roulette English",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_ftv": {
        slug: "aurum_roulette_ftv",
        name: "Aurum Roulette FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_kurdish": {
        slug: "aurum_roulette_kurdish",
        name: "Aurum Roulette Kurdish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_persian": {
        slug: "aurum_roulette_persian",
        name: "Aurum Roulette Persian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_popok": {
        slug: "aurum_roulette_popok",
        name: "Aurum Roulette PopOK",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_speed": {
        slug: "aurum_roulette_speed",
        name: "Aurum Roulette Speed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_turkish": {
        slug: "aurum_roulette_turkish",
        name: "Aurum Roulette Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_roulette_vision_vip": {
        slug: "aurum_roulette_vision_vip",
        name: "Aurum Roulette Vision VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/aurum_sic_bo": {
        slug: "aurum_sic_bo",
        name: "Aurum Sic Bo",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/auto_roulette_luxe": {
        slug: "auto_roulette_luxe",
        name: "Auto Roulette Luxe",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/auto_roulette_speed": {
        slug: "auto_roulette_speed",
        name: "Auto Roulette Speed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/baccarat_classic": {
        slug: "baccarat_classic",
        name: "Baccarat Classic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/baccarat_eclipse": {
        slug: "baccarat_eclipse",
        name: "Baccarat Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/baccarat_ftv": {
        slug: "baccarat_ftv",
        name: "Baccarat FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/bet_on_poker": {
        slug: "bet_on_poker",
        name: "Bet On Poker",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack": {
        slug: "blackjack",
        name: "BlackJack",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_arabic": {
        slug: "blackjack_arabic",
        name: "BlackJack Arabic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_armenian": {
        slug: "blackjack_armenian",
        name: "BlackJack Armenian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_atrium": {
        slug: "blackjack_atrium",
        name: "BlackJack Atrium",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_atrium_turkish": {
        slug: "blackjack_atrium_turkish",
        name: "BlackJack Atrium Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_brazilian": {
        slug: "blackjack_brazilian",
        name: "BlackJack Brazilian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_creed": {
        slug: "blackjack_creed",
        name: "BlackJack Creed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_eclipse": {
        slug: "blackjack_eclipse",
        name: "BlackJack Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_ftv": {
        slug: "blackjack_ftv",
        name: "BlackJack FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_ftv_vip": {
        slug: "blackjack_ftv_vip",
        name: "BlackJack FTV VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_kurdish": {
        slug: "blackjack_kurdish",
        name: "BlackJack Kurdish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_persian": {
        slug: "blackjack_persian",
        name: "BlackJack Persian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_premium": {
        slug: "blackjack_premium",
        name: "BlackJack Premium",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_russian": {
        slug: "blackjack_russian",
        name: "BlackJack Russian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_turkish": {
        slug: "blackjack_turkish",
        name: "BlackJack Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_vip": {
        slug: "blackjack_vip",
        name: "BlackJack VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/blackjack_vision": {
        slug: "blackjack_vision",
        name: "BlackJack VISION",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/cashout_blackjack": {
        slug: "cashout_blackjack",
        name: "Cashout Blackjack",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Holdem",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/casino_holdem_eclipse": {
        slug: "casino_holdem_eclipse",
        name: "Casino Holdem Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/filipino_baccarat": {
        slug: "filipino_baccarat",
        name: "Filipino Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack": {
        slug: "free_bet_blackjack",
        name: "Free Bet BlackJack",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_brazilian": {
        slug: "free_bet_blackjack_brazilian",
        name: "Free Bet BlackJack Brazilian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_creed": {
        slug: "free_bet_blackjack_creed",
        name: "Free Bet BlackJack CREED",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_fiesta": {
        slug: "free_bet_blackjack_fiesta",
        name: "Free Bet BlackJack Fiesta",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_turkish": {
        slug: "free_bet_blackjack_turkish",
        name: "Free Bet BlackJack Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_vip": {
        slug: "free_bet_blackjack_vip",
        name: "Free Bet BlackJack VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/free_bet_blackjack_vision": {
        slug: "free_bet_blackjack_vision",
        name: "Free Bet BlackJack Vision",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/immersion_roulette": {
        slug: "immersion_roulette",
        name: "Immersion Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/keno_live": {
        slug: "keno_live",
        name: "Keno Live",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/kickoff_roulette": {
        slug: "kickoff_roulette",
        name: "Kickoff Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/korean_baccarat": {
        slug: "korean_baccarat",
        name: "Korean Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/live_lobby": {
        slug: "live_lobby",
        name: "Live Lobby",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/mr_first_live": {
        slug: "mr_first_live",
        name: "Mr First Live",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_baccarat": {
        slug: "no_commission_baccarat",
        name: "No Commission Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_baccarat_eclipse": {
        slug: "no_commission_baccarat_eclipse",
        name: "No Commission Baccarat Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_baccarat_ftv": {
        slug: "no_commission_baccarat_ftv",
        name: "No Commission Baccarat FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_filipino_baccarat": {
        slug: "no_commission_filipino_baccarat",
        name: "No Commission Filipino Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_korean_baccarat": {
        slug: "no_commission_korean_baccarat",
        name: "No Commission Korean Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/no_commission_speed_baccarat": {
        slug: "no_commission_speed_baccarat",
        name: "No Commission Speed Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/richie_fruits_roulette": {
        slug: "richie_fruits_roulette",
        name: "Richie Fruits Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/richie_wheel": {
        slug: "richie_wheel",
        name: "Richie Wheel",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_arabic": {
        slug: "roulette_arabic",
        name: "Roulette Arabic",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_armenian": {
        slug: "roulette_armenian",
        name: "Roulette Armenian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_aurum": {
        slug: "roulette_aurum",
        name: "Roulette Aurum",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_brasileira": {
        slug: "roulette_brasileira",
        name: "Roulette Brasileira",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_eclipse": {
        slug: "roulette_eclipse",
        name: "Roulette Eclipse",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_english": {
        slug: "roulette_english",
        name: "Roulette English",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_ftv": {
        slug: "roulette_ftv",
        name: "Roulette FTV",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_kurdish": {
        slug: "roulette_kurdish",
        name: "Roulette Kurdish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_persian": {
        slug: "roulette_persian",
        name: "Roulette Persian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_popok": {
        slug: "roulette_popok",
        name: "Roulette PopOK",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_speed": {
        slug: "roulette_speed",
        name: "Roulette Speed",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_turkish": {
        slug: "roulette_turkish",
        name: "Roulette Turkish",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/roulette_vision_vip": {
        slug: "roulette_vision_vip",
        name: "Roulette Vision VIP",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/russian_poker": {
        slug: "russian_poker",
        name: "Russian Poker",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/speed_blackjack": {
        slug: "speed_blackjack",
        name: "Speed Blackjack",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/speed_blackjack_brazilian": {
        slug: "speed_blackjack_brazilian",
        name: "Speed Blackjack Brazilian",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/swift_roulette_8_in_one": {
        slug: "swift_roulette_8_in_one",
        name: "Swift Roulette 8 IN ONE",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "creedroomz/teen_patti": {
        slug: "teen_patti",
        name: "Teen Patti",
        provider: "Creedroomz",
        providerSlug: "creedroomz"
    },
    "edgelabs/apollos_riches": {
        slug: "apollos_riches",
        name: "Apollos Riches",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/blade_of_fortune": {
        slug: "blade_of_fortune",
        name: "Blade of Fortune",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/blazing_mustang_100_lines": {
        slug: "blazing_mustang_100_lines",
        name: "Blazing Mustang 100 Lines",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/blazing_mustang_50_lines": {
        slug: "blazing_mustang_50_lines",
        name: "Blazing Mustang 50 Lines",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/blue_bird": {
        slug: "blue_bird",
        name: "Blue Bird",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/blue_bird_bonus_extreme": {
        slug: "blue_bird_bonus_extreme",
        name: "Blue Bird Bonus Extreme",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/booming_forties": {
        slug: "booming_forties",
        name: "Booming Forties",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/bugs_to_riches_diamond": {
        slug: "bugs_to_riches_diamond",
        name: "Bugs to Riches Diamond",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/canada_eh": {
        slug: "canada_eh",
        name: "Canada EH",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/cleopatra_sands_of_time": {
        slug: "cleopatra_sands_of_time",
        name: "Cleopatra Sands of Time",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/day_of_the_dead": {
        slug: "day_of_the_dead",
        name: "Day of the Dead",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/devils_hot_7s": {
        slug: "devils_hot_7s",
        name: "Devil's Hot 7's",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/diamond_10x": {
        slug: "diamond_10x",
        name: "Diamond 10x",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/dusty_trail_treasures": {
        slug: "dusty_trail_treasures",
        name: "Dusty Trail Treasures",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/flaming_skulls": {
        slug: "flaming_skulls",
        name: "Flaming Skulls",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/golden_pride": {
        slug: "golden_pride",
        name: "Golden Pride",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/hollow_grave_of_riches": {
        slug: "hollow_grave_of_riches",
        name: "Hollow Grave of Riches",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/jewels_of_cleopatra": {
        slug: "jewels_of_cleopatra",
        name: "Jewels of Cleopatra",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/kandy_land_keno": {
        slug: "kandy_land_keno",
        name: "Kandy Land Keno",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/lanterns_rising": {
        slug: "lanterns_rising",
        name: "Lantern's Rising",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/liberty_rising": {
        slug: "liberty_rising",
        name: "Liberty Rising",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/lost_totem": {
        slug: "lost_totem",
        name: "Lost Totem",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/luck_n_clovers": {
        slug: "luck_n_clovers",
        name: "Luck N Clovers",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/mark_of_z": {
        slug: "mark_of_z",
        name: "Mark of Z",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/mayan_madness": {
        slug: "mayan_madness",
        name: "Mayan Madness",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/northern_buffalo_fortune": {
        slug: "northern_buffalo_fortune",
        name: "Northern Buffalo Fortune",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/panda_shores": {
        slug: "panda_shores",
        name: "Panda Shores",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/pandas_lucky_payday": {
        slug: "pandas_lucky_payday",
        name: "Panda's Lucky Payday",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/pirates_rising": {
        slug: "pirates_rising",
        name: "Pirate's Rising",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/plenty_o_coins": {
        slug: "plenty_o_coins",
        name: "Plenty o Coins",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/qian_gun_qian": {
        slug: "qian_gun_qian",
        name: "Qian Gun Qian",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/quick_wins_diamond_7s": {
        slug: "quick_wins_diamond_7s",
        name: "Quick Wins Diamond 7s",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/quick_wins_diamonds": {
        slug: "quick_wins_diamonds",
        name: "Quick Wins Diamonds",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/quick_wins_fortunes": {
        slug: "quick_wins_fortunes",
        name: "Quick Wins Fortunes",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/robins_arrow": {
        slug: "robins_arrow",
        name: "Robin's Arrow",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/ruby_x": {
        slug: "ruby_x",
        name: "Ruby X",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/santas_gift_hunt": {
        slug: "santas_gift_hunt",
        name: "Santa's Gift Hunt",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/scorching_hot": {
        slug: "scorching_hot",
        name: "Scorching Hot",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/steampunk_fortune": {
        slug: "steampunk_fortune",
        name: "Steampunk Fortune",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/sword_of_z": {
        slug: "sword_of_z",
        name: "Sword of Z",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/tiger_hunt": {
        slug: "tiger_hunt",
        name: "Tiger Hunt",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/ultimate_goal_10x": {
        slug: "ultimate_goal_10x",
        name: "Ultimate Goal 10x",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/viking_voyage_of_fortune": {
        slug: "viking_voyage_of_fortune",
        name: "Viking Voyage of Fortune",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "edgelabs/zombie_hunt": {
        slug: "zombie_hunt",
        name: "Zombie Hunt",
        provider: "Edgelabs",
        providerSlug: "edgelabs"
    },
    "elagames/adventure_of_bobby_woods": {
        slug: "adventure_of_bobby_woods",
        name: "Adventure of Bobby Woods",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/aqua_mafia": {
        slug: "aqua_mafia",
        name: "Aqua Mafia",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/bandidos_bang": {
        slug: "bandidos_bang",
        name: "Bandidos Bang!",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/bandidos_cash": {
        slug: "bandidos_cash",
        name: "Bandidos Cash",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/big_wave_delight": {
        slug: "big_wave_delight",
        name: "Big Wave Delight",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/bobby_woods": {
        slug: "bobby_woods",
        name: "Bobby Woods",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/book_of_meow": {
        slug: "book_of_meow",
        name: "Book of Meow",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/buffalo_force": {
        slug: "buffalo_force",
        name: "Buffalo Force",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/bullet_hole": {
        slug: "bullet_hole",
        name: "Bullet Hole",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/cash_of_egypt": {
        slug: "cash_of_egypt",
        name: "Cash Of Egypt",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/cash_of_gods": {
        slug: "cash_of_gods",
        name: "Cash Of Gods",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/chanced_riches_express": {
        slug: "chanced_riches_express",
        name: "Chanced Riches Express",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/detective_fortune": {
        slug: "detective_fortune",
        name: "Detective Fortune",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/devils_treasures": {
        slug: "devils_treasures",
        name: "Devils' Treasures",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/disco_wild": {
        slug: "disco_wild",
        name: "Disco Wild",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/eds_gun": {
        slug: "eds_gun",
        name: "Ed`s Gun",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/farm_hunt": {
        slug: "farm_hunt",
        name: "Farm Hunt",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/fish_and_spins": {
        slug: "fish_and_spins",
        name: "Fish and Spins",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/flame_fruits_frenzy": {
        slug: "flame_fruits_frenzy",
        name: "Flame Fruits Frenzy",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/flame_fruits_hold_and_win": {
        slug: "flame_fruits_hold_and_win",
        name: "Flame Fruits Hold and Win",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/genie_respins": {
        slug: "genie_respins",
        name: "Genie Respins ",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/gold_train": {
        slug: "gold_train",
        name: "Gold Train",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/golden_bunny": {
        slug: "golden_bunny",
        name: "Golden Bunny",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/golden_till": {
        slug: "golden_till",
        name: "Golden Till",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/its_shark_time": {
        slug: "its_shark_time",
        name: "It`s Shark Time!",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/its_shark_time_2": {
        slug: "its_shark_time_2",
        name: "It's Shark Time 2",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/its_shark_time_xmas": {
        slug: "its_shark_time_xmas",
        name: "It's Shark Time! Xmas",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/johns_book": {
        slug: "johns_book",
        name: "John's Book",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/joker_cashpoint": {
        slug: "joker_cashpoint",
        name: "Joker Cashpoint",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/joker_cashpot": {
        slug: "joker_cashpot",
        name: "Joker Cashpot",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/joker_jam": {
        slug: "joker_jam",
        name: "Joker Jam",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/juicy_crystal": {
        slug: "juicy_crystal",
        name: "Juicy Crystal",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/king_and_flame": {
        slug: "king_and_flame",
        name: "King and Flame",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/kraken_bay": {
        slug: "kraken_bay",
        name: "Kraken Bay",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/kraken_coins": {
        slug: "kraken_coins",
        name: "Kraken Coins",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/legacy_of_liberty": {
        slug: "legacy_of_liberty",
        name: "Legacy of Liberty",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/legacy_of_lost_gold": {
        slug: "legacy_of_lost_gold",
        name: "Legacy of Lost Gold",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/lucky_dwarfs": {
        slug: "lucky_dwarfs",
        name: "Lucky Dwarfs",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/madshow_circus": {
        slug: "madshow_circus",
        name: "Madshow Circus",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/malina": {
        slug: "malina",
        name: "Malina",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/noble_crown": {
        slug: "noble_crown",
        name: "Noble Crown",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/odysseus_wild_journey": {
        slug: "odysseus_wild_journey",
        name: "Odysseus Wild Journey",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/patricks_treasure_pots": {
        slug: "patricks_treasure_pots",
        name: "Patrick’s Treasure Pots",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/piatas_festival": {
        slug: "piatas_festival",
        name: "Piñatas Festival",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/piggy_brew_bonanza": {
        slug: "piggy_brew_bonanza",
        name: "Piggy Brew Bonanza",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/piggy_brick_bonanza": {
        slug: "piggy_brick_bonanza",
        name: "Piggy Brick Bonanza",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/pinatas_festival_world_cup": {
        slug: "pinatas_festival_world_cup",
        name: "Pinatas Festival World Cup",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/rabbit_winpot_deluxe": {
        slug: "rabbit_winpot_deluxe",
        name: "Rabbit WInpot Deluxe",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/rapid_wild": {
        slug: "rapid_wild",
        name: "Rapid Wild",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/riches_express": {
        slug: "riches_express",
        name: "Riches Express",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/roman_fortune": {
        slug: "roman_fortune",
        name: "Roman Fortune",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/royal_coins": {
        slug: "royal_coins",
        name: "Royal Coins",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/scarab_wheel": {
        slug: "scarab_wheel",
        name: "Scarab Wheel",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/shoot_happens": {
        slug: "shoot_happens",
        name: "Shoot Happens",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/silly_chili_dogs": {
        slug: "silly_chili_dogs",
        name: "Silly Chili Dogs",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/slot_crab": {
        slug: "slot_crab",
        name: "Slot Crab",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/spinanga": {
        slug: "spinanga",
        name: "Spinanga",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/spirit_of_savanna": {
        slug: "spirit_of_savanna",
        name: "Spirit of Savanna",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/sugar_blossom": {
        slug: "sugar_blossom",
        name: "Sugar Blossom",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/sugar_spins": {
        slug: "sugar_spins",
        name: "Sugar Spins",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/tail_of_crime": {
        slug: "tail_of_crime",
        name: "Tail Of Crime",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/tea_party_of_fortune": {
        slug: "tea_party_of_fortune",
        name: "Tea Party of Fortune",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/the_age_of_cleopatra": {
        slug: "the_age_of_cleopatra",
        name: "The Age of Cleopatra",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/the_age_of_cleopatra_bonus_buy": {
        slug: "the_age_of_cleopatra_bonus_buy",
        name: "The Age of Cleopatra Bonus Buy",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/thunder_ball": {
        slug: "thunder_ball",
        name: "Thunder Ball",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/thunder_ball_max": {
        slug: "thunder_ball_max",
        name: "Thunder Ball Max",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/vikings_wild": {
        slug: "vikings_wild",
        name: "Vikings Wild",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/vikings_wild_cash": {
        slug: "vikings_wild_cash",
        name: "Vikings Wild Cash",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/vilk_and_little_red": {
        slug: "vilk_and_little_red",
        name: "Vilk & Little Red",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/wazamba": {
        slug: "wazamba",
        name: "Wazamba",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/wealth_of_legends": {
        slug: "wealth_of_legends",
        name: "Wealth Of Legends",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/wealth_of_the_east": {
        slug: "wealth_of_the_east",
        name: "Wealth of the East",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/wild_piranha": {
        slug: "wild_piranha",
        name: "Wild Piranha",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/witches_book": {
        slug: "witches_book",
        name: "Witches' Book",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "elagames/zeus_cashpot": {
        slug: "zeus_cashpot",
        name: "Zeus Cashpot",
        provider: "Elagames",
        providerSlug: "elagames"
    },
    "electric-elephant/joker_jackpots": {
        slug: "joker_jackpots",
        name: "Joker Jackpots",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/sherlock_bones": {
        slug: "sherlock_bones",
        name: "Sherlock Bones",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/star_pops": {
        slug: "star_pops",
        name: "Star Pops",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/super_boost": {
        slug: "super_boost",
        name: "Super Boost",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "electric-elephant/who_wants_to_be_a_millionaire_roulette": {
        slug: "who_wants_to_be_a_millionaire_roulette",
        name: "Who Wants to be a Millionaire Roulette",
        provider: "Electric Elephant",
        providerSlug: "electric-elephant"
    },
    "emeraldgate/altitude": {
        slug: "altitude",
        name: "Altitude",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/bacon_bonanza": {
        slug: "bacon_bonanza",
        name: "Bacon Bonanza",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/banana_heist": {
        slug: "banana_heist",
        name: "Banana Heist",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/buffalo_bounty": {
        slug: "buffalo_bounty",
        name: "Buffalo Bounty",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/carrot_cash": {
        slug: "carrot_cash",
        name: "Carrot Cash",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/coco_loco_slots": {
        slug: "coco_loco_slots",
        name: "Coco Loco Slots",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/empire_of_gold": {
        slug: "empire_of_gold",
        name: "Empire Of Gold",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/fabulous_vegas": {
        slug: "fabulous_vegas",
        name: "Fabulous Vegas",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/golden_dragon": {
        slug: "golden_dragon",
        name: "Golden Dragon",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/jokers_paradise": {
        slug: "jokers_paradise",
        name: "Joker's Paradise",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/ox_of_gold": {
        slug: "ox_of_gold",
        name: "Ox Of Gold",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/panda_paradise": {
        slug: "panda_paradise",
        name: "Panda Paradise",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/pharaos_treasure": {
        slug: "pharaos_treasure",
        name: "Pharao's Treasure",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/spells_of_fortune": {
        slug: "spells_of_fortune",
        name: "Spells of Fortune",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/thors_fortune": {
        slug: "thors_fortune",
        name: "Thor's Fortune",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/tiger_crash": {
        slug: "tiger_crash",
        name: "Tiger Crash",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/tiger_luck": {
        slug: "tiger_luck",
        name: "Tiger Luck",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/tiger_spin_royal": {
        slug: "tiger_spin_royal",
        name: "Tiger Spin Royal",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/tigers_gold_mines": {
        slug: "tigers_gold_mines",
        name: "Tiger's Gold Mines",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/treasure_mines": {
        slug: "treasure_mines",
        name: "Treasure Mines",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "emeraldgate/warlords_treasure": {
        slug: "warlords_treasure",
        name: "Warlord's Treasure",
        provider: "Emeraldgate",
        providerSlug: "emeraldgate"
    },
    "endorphina/100_zombies": {
        slug: "100_zombies",
        name: "100 Zombies",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/100_zombies_dice": {
        slug: "100_zombies_dice",
        name: "100 Zombies Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2016_gladiators": {
        slug: "2016_gladiators",
        name: "2016 Gladiators",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2020_hit_slot": {
        slug: "2020_hit_slot",
        name: "2020 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2021_hit_slot": {
        slug: "2021_hit_slot",
        name: "2021 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2022_hit_slot": {
        slug: "2022_hit_slot",
        name: "2022 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2023_hit_slot": {
        slug: "2023_hit_slot",
        name: "2023 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2023_hit_slot_dice": {
        slug: "2023_hit_slot_dice",
        name: "2023 Hit Slot Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2024_hit_slot": {
        slug: "2024_hit_slot",
        name: "2024 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2025_hit_slot": {
        slug: "2025_hit_slot",
        name: "2025 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2026_hit_slot": {
        slug: "2026_hit_slot",
        name: "2026 Hit Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/2027_iss": {
        slug: "2027_iss",
        name: "2027 ISS",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/3_coin_towers": {
        slug: "3_coin_towers",
        name: "3 Coin Towers",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/3_coin_towers_dice": {
        slug: "3_coin_towers_dice",
        name: "3 Coin Towers Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/3_royal_dracos": {
        slug: "3_royal_dracos",
        name: "3 Royal Dracos",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/3_thunders": {
        slug: "3_thunders",
        name: "3 Thunders",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/3witch_pots": {
        slug: "3witch_pots",
        name: "3Witch Pots",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/4_of_a_king": {
        slug: "4_of_a_king",
        name: "4 of a King",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/7_bonus_up": {
        slug: "7_bonus_up",
        name: "7 Bonus Up",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/81_burning_ways": {
        slug: "81_burning_ways",
        name: "81 Burning Ways",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/age_of_glory": {
        slug: "age_of_glory",
        name: "Age Of Glory",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/akbar_birbal": {
        slug: "akbar_birbal",
        name: "Akbar Birbal",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/all_ways_luck": {
        slug: "all_ways_luck",
        name: "All Ways Luck",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/almighty_sparta": {
        slug: "almighty_sparta",
        name: "Almighty Sparta",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/almighty_sparta_dice": {
        slug: "almighty_sparta_dice",
        name: "Almighty Sparta Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/amazon_riches": {
        slug: "amazon_riches",
        name: "Amazon Riches",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/ancient_troy": {
        slug: "ancient_troy",
        name: "Ancient Troy",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/ancient_troy_dice": {
        slug: "ancient_troy_dice",
        name: "Ancient Troy Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/argonauts": {
        slug: "argonauts",
        name: "Argonauts",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/aristocats": {
        slug: "aristocats",
        name: "Aristocats",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/around_the_world": {
        slug: "around_the_world",
        name: "Around the World",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/asgardians": {
        slug: "asgardians",
        name: "Asgardians",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/asgardians_dice": {
        slug: "asgardians_dice",
        name: "Asgardians Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/aus_dem_tal": {
        slug: "aus_dem_tal",
        name: "Aus Dem Tal",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/bad_santa": {
        slug: "bad_santa",
        name: "Bad Santa",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/bazaar_monkey": {
        slug: "bazaar_monkey",
        name: "Bazaar Monkey",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/best_xmas": {
        slug: "best_xmas",
        name: "Best Xmas",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/big_brown": {
        slug: "big_brown",
        name: "Big Brown",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/blast_boom_bang": {
        slug: "blast_boom_bang",
        name: "Blast Boom Bang",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/blue_slot": {
        slug: "blue_slot",
        name: "Blue Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/blue_slot_dice": {
        slug: "blue_slot_dice",
        name: "Blue Slot Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_conquistador": {
        slug: "book_of_conquistador",
        name: "Book of Conquistador",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_ganesha": {
        slug: "book_of_ganesha",
        name: "Book Of Ganesha",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_lady": {
        slug: "book_of_lady",
        name: "Book of Lady",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_oil": {
        slug: "book_of_oil",
        name: "Book of Oil",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_santa": {
        slug: "book_of_santa",
        name: "Book of Santa",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_santa_dice": {
        slug: "book_of_santa_dice",
        name: "Book of Santa Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_vlad": {
        slug: "book_of_vlad",
        name: "Book of Vlad",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/book_of_vlad_dice": {
        slug: "book_of_vlad_dice",
        name: "Book of Vlad Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/buffalo_50": {
        slug: "buffalo_50",
        name: "Buffalo 50",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/burning_coins_100": {
        slug: "burning_coins_100",
        name: "Burning Coins 100",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/burning_coins_20": {
        slug: "burning_coins_20",
        name: "Burning Coins 20",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/burning_coins_40": {
        slug: "burning_coins_40",
        name: "Burning Coins 40",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/burning_hell": {
        slug: "burning_hell",
        name: "Burning Hell",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/burning_hell_3000": {
        slug: "burning_hell_3000",
        name: "Burning Hell 3000",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cash_streak": {
        slug: "cash_streak",
        name: "Cash Streak",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cash_streak_dice": {
        slug: "cash_streak_dice",
        name: "Cash Streak Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cash_tank": {
        slug: "cash_tank",
        name: "Cash Tank",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_100": {
        slug: "chance_machine_100",
        name: "Chance Machine 100",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_100_dice": {
        slug: "chance_machine_100_dice",
        name: "Chance Machine 100 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_20": {
        slug: "chance_machine_20",
        name: "Chance Machine 20",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_20_dice": {
        slug: "chance_machine_20_dice",
        name: "Chance Machine 20 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_40": {
        slug: "chance_machine_40",
        name: "Chance Machine 40",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_40_dice": {
        slug: "chance_machine_40_dice",
        name: "Chance Machine 40 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_5": {
        slug: "chance_machine_5",
        name: "Chance Machine 5",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chance_machine_5_dice": {
        slug: "chance_machine_5_dice",
        name: "Chance Machine 5 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chimney_sweep": {
        slug: "chimney_sweep",
        name: "Chimney Sweep",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/chunjie": {
        slug: "chunjie",
        name: "Chunjie",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/clover_flames": {
        slug: "clover_flames",
        name: "Clover Flames",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/clover_flames_dice": {
        slug: "clover_flames_dice",
        name: "Clover Flames Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cockroach_fortune": {
        slug: "cockroach_fortune",
        name: "Cockroach Fortune",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cowsandufos": {
        slug: "cowsandufos",
        name: "CowsandUFOs",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cricket_heroes": {
        slug: "cricket_heroes",
        name: "Cricket Heroes",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/crown_coins": {
        slug: "crown_coins",
        name: "Crown Coins",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/crown_coins_dice": {
        slug: "crown_coins_dice",
        name: "Crown Coins Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/crystal_skull": {
        slug: "crystal_skull",
        name: "Crystal Skull",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/crystal_skull_dice": {
        slug: "crystal_skull_dice",
        name: "Crystal Skull Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cuckoo": {
        slug: "cuckoo",
        name: "Cuckoo",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cupid": {
        slug: "cupid",
        name: "Cupid",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cyber_wolf": {
        slug: "cyber_wolf",
        name: "Cyber Wolf",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/cyber_wolf_dice": {
        slug: "cyber_wolf_dice",
        name: "Cyber Wolf Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/dazzling_crown": {
        slug: "dazzling_crown",
        name: "Dazzling Crown",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/dia_de_los_muertos": {
        slug: "dia_de_los_muertos",
        name: "Dia De Los Muertos",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/dia_de_los_muertos_2": {
        slug: "dia_de_los_muertos_2",
        name: "Dia De Los Muertos 2",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/diamond_chance": {
        slug: "diamond_chance",
        name: "Diamond Chance",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/diamond_vapor": {
        slug: "diamond_vapor",
        name: "Diamond Vapor",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/druid_forune": {
        slug: "druid_forune",
        name: "Druid Forune",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/dynamite_miner": {
        slug: "dynamite_miner",
        name: "Dynamite Miner",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fairy_tale": {
        slug: "fairy_tale",
        name: "Fairy Tale",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/festa_junina": {
        slug: "festa_junina",
        name: "Festa Junina",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fisher_king": {
        slug: "fisher_king",
        name: "Fisher King",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/football": {
        slug: "football",
        name: "Football",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/football_2022": {
        slug: "football_2022",
        name: "Football: 2022",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/football_2026": {
        slug: "football_2026",
        name: "Football 2026",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/football_mayhem": {
        slug: "football_mayhem",
        name: "Football Mayhem",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/football_superstar": {
        slug: "football_superstar",
        name: "Football Superstar",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fortune_bankers": {
        slug: "fortune_bankers",
        name: "Fortune Bankers",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fortune_capybara": {
        slug: "fortune_capybara",
        name: "Fortune Capybara",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fortune_chests": {
        slug: "fortune_chests",
        name: "Fortune Chests",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fortune_snake": {
        slug: "fortune_snake",
        name: "Fortune Snake",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fortune_stars": {
        slug: "fortune_stars",
        name: "Fortune Stars",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fresh_crush": {
        slug: "fresh_crush",
        name: "Fresh Crush",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fresh_fruits": {
        slug: "fresh_fruits",
        name: "Fresh Fruits",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fruletta": {
        slug: "fruletta",
        name: "Fruletta",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/fruletta_dice": {
        slug: "fruletta_dice",
        name: "Fruletta Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/gambleman": {
        slug: "gambleman",
        name: "Gambleman",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/geisha": {
        slug: "geisha",
        name: "Geisha",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/gem_blast": {
        slug: "gem_blast",
        name: "Gem Blast",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/gems_and_stones": {
        slug: "gems_and_stones",
        name: "Gems and Stones",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/giant_wild_goose_pagoda": {
        slug: "giant_wild_goose_pagoda",
        name: "Giant Wild Goose Pagoda",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/gladiators": {
        slug: "gladiators",
        name: "Gladiators",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/glory_of_egypt": {
        slug: "glory_of_egypt",
        name: "Glory of Egypt",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/goddess_of_war": {
        slug: "goddess_of_war",
        name: "Goddess of War",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/golden_brew": {
        slug: "golden_brew",
        name: "Golden Brew",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/golden_ox": {
        slug: "golden_ox",
        name: "Golden Ox",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/green_slot": {
        slug: "green_slot",
        name: "Green Slot",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_100": {
        slug: "hell_hot_100",
        name: "Hell Hot 100",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_100_dice": {
        slug: "hell_hot_100_dice",
        name: "Hell Hot 100 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_20": {
        slug: "hell_hot_20",
        name: "Hell Hot 20",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_20_dice": {
        slug: "hell_hot_20_dice",
        name: "Hell Hot 20 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_40": {
        slug: "hell_hot_40",
        name: "Hell Hot 40",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hell_hot_40_dice": {
        slug: "hell_hot_40_dice",
        name: "Hell Hot 40 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/hot_puzzle": {
        slug: "hot_puzzle",
        name: "Hot Puzzle",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/ice_pirates": {
        slug: "ice_pirates",
        name: "Ice Pirates",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/in_jazz": {
        slug: "in_jazz",
        name: "In Jazz",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/jade_coins": {
        slug: "jade_coins",
        name: "Jade Coins",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/janissaries": {
        slug: "janissaries",
        name: "Janissaries",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/jetsetter": {
        slug: "jetsetter",
        name: "Jetsetter",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/joker_ra": {
        slug: "joker_ra",
        name: "Joker Ra",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/joker_ra_dice": {
        slug: "joker_ra_dice",
        name: "Joker Ra Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/joker_ra_sunrise": {
        slug: "joker_ra_sunrise",
        name: "Joker Ra: Sunrise",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/joker_stoker": {
        slug: "joker_stoker",
        name: "Joker Stoker",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/joker_stoker_dice": {
        slug: "joker_stoker_dice",
        name: "Joker Stoker Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/jolly_queen": {
        slug: "jolly_queen",
        name: "Jolly Queen",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/jolly_santa": {
        slug: "jolly_santa",
        name: "Jolly Santa",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/kamchatka": {
        slug: "kamchatka",
        name: "Kamchatka",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/king_of_ghosts": {
        slug: "king_of_ghosts",
        name: "King of Ghosts",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/late_night_win": {
        slug: "late_night_win",
        name: "Late Night Win",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/legendary_sumo": {
        slug: "legendary_sumo",
        name: "Legendary Sumo",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/little_panda": {
        slug: "little_panda",
        name: "Little Panda",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/little_panda_dice": {
        slug: "little_panda_dice",
        name: "Little Panda Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lord_of_the_seas": {
        slug: "lord_of_the_seas",
        name: "Lord of the Seas",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/love_show": {
        slug: "love_show",
        name: "Love Show",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_cloverland": {
        slug: "lucky_cloverland",
        name: "Lucky Cloverland",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_cloverland_dice": {
        slug: "lucky_cloverland_dice",
        name: "Lucky Cloverland Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_dice_1": {
        slug: "lucky_dice_1",
        name: "Lucky Dice 1",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_dice_2": {
        slug: "lucky_dice_2",
        name: "Lucky Dice 2",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_dice_3": {
        slug: "lucky_dice_3",
        name: "Lucky Dice 3",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_lands": {
        slug: "lucky_lands",
        name: "Lucky Lands",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_stamps": {
        slug: "lucky_stamps",
        name: "Lucky Stamps",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_1": {
        slug: "lucky_streak_1",
        name: "Lucky Streak 1",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_1000": {
        slug: "lucky_streak_1000",
        name: "lucky Streak 1000",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_1000_dice": {
        slug: "lucky_streak_1000_dice",
        name: "lucky Streak 1000 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_2": {
        slug: "lucky_streak_2",
        name: "Lucky Streak 2",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_27": {
        slug: "lucky_streak_27",
        name: "Lucky Streak 27",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_3": {
        slug: "lucky_streak_3",
        name: "Lucky Streak 3",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lucky_streak_x": {
        slug: "lucky_streak_x",
        name: "Lucky Streak X",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/lumber_jack": {
        slug: "lumber_jack",
        name: "Lumber Jack",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/luxurylife": {
        slug: "luxurylife",
        name: "#LuxuryLife",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/macarons": {
        slug: "macarons",
        name: "Macarons",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/magnum_opus": {
        slug: "magnum_opus",
        name: "Magnum Opus",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/minotaur_reburn": {
        slug: "minotaur_reburn",
        name: "Minotaur ReBurn",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/minotauros": {
        slug: "minotauros",
        name: "Minotauros",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/minotauros_dice": {
        slug: "minotauros_dice",
        name: "Minotauros Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/mongol_treasures": {
        slug: "mongol_treasures",
        name: "Mongol Treasures",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/mongol_treasures_ii_archery_competition": {
        slug: "mongol_treasures_ii_archery_competition",
        name: "Mongol Treasures II: Archery Competition",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/moofo": {
        slug: "moofo",
        name: "MooFo",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/moon_tiger": {
        slug: "moon_tiger",
        name: "Moon Tiger",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/more_fresh_fruits": {
        slug: "more_fresh_fruits",
        name: "More Fresh Fruits",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/mrbells_40": {
        slug: "mrbells_40",
        name: "Mr.Bells 40",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/mrjingle_bells": {
        slug: "mrjingle_bells",
        name: "Mr.Jingle Bells",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/multistar_fruits": {
        slug: "multistar_fruits",
        name: "Multistar Fruits",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/mystery_of_eldorado": {
        slug: "mystery_of_eldorado",
        name: "Mystery of Eldorado",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/nazar_wishes": {
        slug: "nazar_wishes",
        name: "Nazar Wishes",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/ninja": {
        slug: "ninja",
        name: "Ninja",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/oriental_dragon": {
        slug: "oriental_dragon",
        name: "Oriental Dragon",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/origami": {
        slug: "origami",
        name: "Origami",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/pachamama": {
        slug: "pachamama",
        name: "Pachamama",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/panda_strike": {
        slug: "panda_strike",
        name: "Panda Strike",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/power_balls": {
        slug: "power_balls",
        name: "Power Balls",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/prestige_crown": {
        slug: "prestige_crown",
        name: "Prestige Crown",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/rabbits_rabbits_rabbits": {
        slug: "rabbits_rabbits_rabbits",
        name: "Rabbits Rabbits Rabbits",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/raging_wings": {
        slug: "raging_wings",
        name: "Raging Wings",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/rainbow_ray": {
        slug: "rainbow_ray",
        name: "Rainbow Ray",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/red_cap": {
        slug: "red_cap",
        name: "Red Cap",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/retromania": {
        slug: "retromania",
        name: "Retromania",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/riches_of_caliph": {
        slug: "riches_of_caliph",
        name: "Riches Of Caliph",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/rooster_fury": {
        slug: "rooster_fury",
        name: "Rooster Fury",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/rooster_fury_dice": {
        slug: "rooster_fury_dice",
        name: "Rooster Fury Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/royal_xmass": {
        slug: "royal_xmass",
        name: "Royal Xmass",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/royal_xmass_2": {
        slug: "royal_xmass_2",
        name: "Royal Xmass 2",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/royal_xmass_2_dice": {
        slug: "royal_xmass_2_dice",
        name: "Royal Xmass 2 Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/royal_xmass_dice": {
        slug: "royal_xmass_dice",
        name: "Royal Xmass Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/safari": {
        slug: "safari",
        name: "Safari",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/samarkands_gold": {
        slug: "samarkands_gold",
        name: "Samarkand's Gold",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/santas_gift": {
        slug: "santas_gift",
        name: "Santa's Gift",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/santas_puzzle": {
        slug: "santas_puzzle",
        name: "Santa's Puzzle",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/satoshis_secret": {
        slug: "satoshis_secret",
        name: "Satoshi's Secret",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/shaman": {
        slug: "shaman",
        name: "Shaman",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/silk_road": {
        slug: "silk_road",
        name: "Silk Road",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sloteus_gold": {
        slug: "sloteus_gold",
        name: "Sloteus Gold",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sloth_game": {
        slug: "sloth_game",
        name: "Sloth Game",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/slotomoji": {
        slug: "slotomoji",
        name: "Slotomoji",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/solar_eclipse": {
        slug: "solar_eclipse",
        name: "Solar Eclipse",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sparkling_fresh": {
        slug: "sparkling_fresh",
        name: "Sparkling Fresh",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/starshine_crystals": {
        slug: "starshine_crystals",
        name: "Starshine Crystals",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sticky_lips": {
        slug: "sticky_lips",
        name: "Sticky Lips",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/stone_age": {
        slug: "stone_age",
        name: "Stone Age",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sugar_glider": {
        slug: "sugar_glider",
        name: "Sugar Glider",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sugar_glider_dice": {
        slug: "sugar_glider_dice",
        name: "Sugar Glider Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/sushi": {
        slug: "sushi",
        name: "Sushi",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/taboo": {
        slug: "taboo",
        name: "Taboo",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/temple_cats": {
        slug: "temple_cats",
        name: "Temple Cats",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/temple_of_ra": {
        slug: "temple_of_ra",
        name: "Temple of Ra",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_emirate": {
        slug: "the_emirate",
        name: "The Emirate",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_emirate_ii": {
        slug: "the_emirate_ii",
        name: "The Emirate II",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_king": {
        slug: "the_king",
        name: "The King",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_rise_of_ai": {
        slug: "the_rise_of_ai",
        name: "The Rise of AI",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_vampires": {
        slug: "the_vampires",
        name: "The Vampires",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_vampires_ii": {
        slug: "the_vampires_ii",
        name: "The Vampires II",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_vampires_ii_dice": {
        slug: "the_vampires_ii_dice",
        name: "The Vampires II Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/the_vikings": {
        slug: "the_vikings",
        name: "The Vikings",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/thunder_crown": {
        slug: "thunder_crown",
        name: "Thunder Crown",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/thunder_crown_dice": {
        slug: "thunder_crown_dice",
        name: "Thunder Crown Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/tribe": {
        slug: "tribe",
        name: "Tribe",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/troll_haven": {
        slug: "troll_haven",
        name: "Troll Haven",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/twerk": {
        slug: "twerk",
        name: "Twerk",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/ultra_fresh": {
        slug: "ultra_fresh",
        name: "Ultra Fresh",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/undines_deep": {
        slug: "undines_deep",
        name: "Undine's Deep",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/urartu": {
        slug: "urartu",
        name: "Urartu",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/valentines_heart": {
        slug: "valentines_heart",
        name: "Valentine's Heart",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/vikings_way": {
        slug: "vikings_way",
        name: "Vikings Way",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/voodoo": {
        slug: "voodoo",
        name: "Voodoo",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/voodoo_dice": {
        slug: "voodoo_dice",
        name: "Voodoo Dice",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/water_tiger": {
        slug: "water_tiger",
        name: "Water Tiger",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/wild_fruits": {
        slug: "wild_fruits",
        name: "Wild Fruits",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/wild_love": {
        slug: "wild_love",
        name: "Wild Love",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/wild_streak": {
        slug: "wild_streak",
        name: "Wild Streak",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/windy_city": {
        slug: "windy_city",
        name: "Windy City",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "endorphina/xmas_burst": {
        slug: "xmas_burst",
        name: "Xmas Burst",
        provider: "Endorphina",
        providerSlug: "endorphina"
    },
    "evoplay/3_bunny_pots_bonanza": {
        slug: "3_bunny_pots_bonanza",
        name: "3 Bunny Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/3_crowns_coin_hunt": {
        slug: "3_crowns_coin_hunt",
        name: "3 Crowns Coin Hunt",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/3_flaming_clovers": {
        slug: "3_flaming_clovers",
        name: "3 Flaming Clovers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/3_super_volcanoes": {
        slug: "3_super_volcanoes",
        name: "3 Super Volcanoes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ace_round": {
        slug: "ace_round",
        name: "Ace Round",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush": {
        slug: "adrenaline_rush",
        name: "Adrenaline Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_scratch": {
        slug: "adrenaline_rush_scratch",
        name: "Adrenaline Rush Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_super_boost": {
        slug: "adrenaline_rush_super_boost",
        name: "Adrenaline Rush: Super Boost",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/adrenaline_rush_xcrash": {
        slug: "adrenaline_rush_xcrash",
        name: "Adrenaline Rush: XCrash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/american_roulette_3d_classic": {
        slug: "american_roulette_3d_classic",
        name: "American Roulette 3D Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/american_sevens": {
        slug: "american_sevens",
        name: "American Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/animal_quest": {
        slug: "animal_quest",
        name: "Animal Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/anubis_moon": {
        slug: "anubis_moon",
        name: "Anubis’ Moon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/avia_rush": {
        slug: "avia_rush",
        name: "Avia Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/baccarat_777": {
        slug: "baccarat_777",
        name: "Baccarat 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bandit_bust": {
        slug: "bandit_bust",
        name: "Bandit Bust",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bandit_bust_bonus_buy": {
        slug: "bandit_bust_bonus_buy",
        name: "Bandit Bust Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/basket_bounty": {
        slug: "basket_bounty",
        name: "Basket Bounty",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/basketball": {
        slug: "basketball",
        name: "Basketball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bball_blitz": {
        slug: "bball_blitz",
        name: "B-Ball Blitz",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/beanstalk_magic_treasures": {
        slug: "beanstalk_magic_treasures",
        name: "Beanstalk Magic Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/belfry_bliss": {
        slug: "belfry_bliss",
        name: "Belfry Bliss",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/belfry_bliss_hold_and_win": {
        slug: "belfry_bliss_hold_and_win",
        name: "Belfry Bliss Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/big_catch_game": {
        slug: "big_catch_game",
        name: "Big Catch Game",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blackjack_lucky_7s_xmas": {
        slug: "blackjack_lucky_7s_xmas",
        name: "Blackjack Lucky 7s Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blackjack_lucky_sevens": {
        slug: "blackjack_lucky_sevens",
        name: "BlackJack: Lucky Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/blessed_flame": {
        slug: "blessed_flame",
        name: "Blessed Flame",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_keno": {
        slug: "book_of_keno",
        name: "Book of Keno",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_rest": {
        slug: "book_of_rest",
        name: "Book of Rest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_the_priestess": {
        slug: "book_of_the_priestess",
        name: "Book of the Priestess",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/book_of_the_priestess_bonus_buy": {
        slug: "book_of_the_priestess_bonus_buy",
        name: "Book of the Priestess Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/brutal_santa": {
        slug: "brutal_santa",
        name: "Brutal Santa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/budai_reels": {
        slug: "budai_reels",
        name: "Budai Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/budai_reels_bonus_buy": {
        slug: "budai_reels_bonus_buy",
        name: "Budai Reels Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/bulls_club": {
        slug: "bulls_club",
        name: "Bull's Club",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/camino_de_chili": {
        slug: "camino_de_chili",
        name: "Camino de Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/camino_de_chili_bonus_buy": {
        slug: "camino_de_chili_bonus_buy",
        name: "Camino de Chili Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_craze": {
        slug: "candy_craze",
        name: "Candy Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams": {
        slug: "candy_dreams",
        name: "Candy Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams_sweet_planet": {
        slug: "candy_dreams_sweet_planet",
        name: "Candy Dreams: Sweet Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/candy_dreams_sweet_planet_bonus_buy": {
        slug: "candy_dreams_sweet_planet_bonus_buy",
        name: "Candy Dreams: Sweet Planet. Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/caramelo_dog_lucky_run": {
        slug: "caramelo_dog_lucky_run",
        name: "Caramelo Dog Lucky Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/catch_the_wind_bonus_buy": {
        slug: "catch_the_wind_bonus_buy",
        name: "Catch the Wind Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cats_blessing": {
        slug: "cats_blessing",
        name: "Cat's Blessing",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/chosen_by_the_gods": {
        slug: "chosen_by_the_gods",
        name: "Chosen by the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_crash": {
        slug: "christmas_crash",
        name: "Christmas Crash",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_reach": {
        slug: "christmas_reach",
        name: "Christmas Reach",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/christmas_reach_bonus_buy": {
        slug: "christmas_reach_bonus_buy",
        name: "Christmas Reach Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/clash_of_pirates": {
        slug: "clash_of_pirates",
        name: "Clash of Pirates",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/collapsed_castle": {
        slug: "collapsed_castle",
        name: "Collapsed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/collapsed_castle_bonus_buy": {
        slug: "collapsed_castle_bonus_buy",
        name: "Collapsed Castle Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/courier_sweeper": {
        slug: "courier_sweeper",
        name: "Courier Sweeper",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cricket_duel": {
        slug: "cricket_duel",
        name: "Cricket Duel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/crimson_crown": {
        slug: "crimson_crown",
        name: "Crimson Crown",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/curse_of_the_pharaoh": {
        slug: "curse_of_the_pharaoh",
        name: "Curse of the Pharaoh",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/curse_of_the_pharaoh_bonus_buy": {
        slug: "curse_of_the_pharaoh_bonus_buy",
        name: "Curse of the Pharaoh Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cursed_can_bonus_buy": {
        slug: "cursed_can_bonus_buy",
        name: "Cursed Can Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cursed_castle": {
        slug: "cursed_castle",
        name: "Cursed Castle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cycle_of_luck": {
        slug: "cycle_of_luck",
        name: "Cycle of Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/cycle_of_luck_bonus_buy": {
        slug: "cycle_of_luck_bonus_buy",
        name: "Cycle of Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/diamond_hustle": {
        slug: "diamond_hustle",
        name: "Diamond Hustle",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/dolce_dream": {
        slug: "dolce_dream",
        name: "Dolce Dream",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/don_juan_peppers": {
        slug: "don_juan_peppers",
        name: "Don Juan Peppers",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/dungeon_immortal_evil": {
        slug: "dungeon_immortal_evil",
        name: "Dungeon: Immortal Evil",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/egypt_gods": {
        slug: "egypt_gods",
        name: "Egypt Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/elven_princesses": {
        slug: "elven_princesses",
        name: "Elven Princesses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/elven_princesses_crown_quest": {
        slug: "elven_princesses_crown_quest",
        name: "Elven Princesses: Crown Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/emerald_brewer": {
        slug: "emerald_brewer",
        name: "Emerald Brewer",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/epic_gladiators": {
        slug: "epic_gladiators",
        name: "Epic Gladiators",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/et_lost_socks": {
        slug: "et_lost_socks",
        name: "E.T. Lost Socks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit": {
        slug: "europe_transit",
        name: "Europe Transit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit_bonus_buy": {
        slug: "europe_transit_bonus_buy",
        name: "Europe Transit Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/europe_transit_snowdrift": {
        slug: "europe_transit_snowdrift",
        name: "Europe Transit Snowdrift",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/european_christmas_roulette": {
        slug: "european_christmas_roulette",
        name: "European Christmas Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/expanding_master": {
        slug: "expanding_master",
        name: "Expanding Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/exploding_fruits": {
        slug: "exploding_fruits",
        name: "Exploding Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/flame_of_ra": {
        slug: "flame_of_ra",
        name: "Flame of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fogo_do_brasil_777": {
        slug: "fogo_do_brasil_777",
        name: "Fogo Do Brasil 777",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football_manager": {
        slug: "football_manager",
        name: "Football Manager",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/football_scratch": {
        slug: "football_scratch",
        name: "Football Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/forest_dreams": {
        slug: "forest_dreams",
        name: "Forest Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/french_roulette_classic": {
        slug: "french_roulette_classic",
        name: "French Roulette Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_fusion_three_pots": {
        slug: "fruit_fusion_three_pots",
        name: "Fruit Fusion: Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_nova": {
        slug: "fruit_nova",
        name: "Fruit Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova": {
        slug: "fruit_super_nova",
        name: "Fruit Super Nova",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_100": {
        slug: "fruit_super_nova_100",
        name: "Fruit Super Nova 100",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_30": {
        slug: "fruit_super_nova_30",
        name: "Fruit Super Nova 30",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_40": {
        slug: "fruit_super_nova_40",
        name: "Fruit Super Nova 40",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_60": {
        slug: "fruit_super_nova_60",
        name: "Fruit Super Nova 60",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruit_super_nova_80": {
        slug: "fruit_super_nova_80",
        name: "Fruit Super Nova 80",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/fruitburst": {
        slug: "fruitburst",
        name: "Fruitburst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gems_of_ra": {
        slug: "gems_of_ra",
        name: "Gems of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goblin_run": {
        slug: "goblin_run",
        name: "Goblin Run",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goddess_of_the_night": {
        slug: "goddess_of_the_night",
        name: "Goddess of the Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/goddess_of_the_night_bonus_buy": {
        slug: "goddess_of_the_night_bonus_buy",
        name: "Goddess of the Night Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gold_of_sirens": {
        slug: "gold_of_sirens",
        name: "Gold of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/gold_of_sirens_bonus_buy": {
        slug: "gold_of_sirens_bonus_buy",
        name: "Gold of Sirens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/golden_fish_collector": {
        slug: "golden_fish_collector",
        name: "Golden Fish Collector",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/good_luck_spell": {
        slug: "good_luck_spell",
        name: "Good Luck Spell",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/heads_and_tails": {
        slug: "heads_and_tails",
        name: "Heads and Tails",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/heart_of_africa_lion_way": {
        slug: "heart_of_africa_lion_way",
        name: "Heart of Africa: Lion Way",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hercules_sports_legend": {
        slug: "hercules_sports_legend",
        name: "Hercules: Sports Legend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/high_striker": {
        slug: "high_striker",
        name: "High Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hockey_shootout": {
        slug: "hockey_shootout",
        name: "Hockey Shootout",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hocus_pocus_sorcery": {
        slug: "hocus_pocus_sorcery",
        name: "Hocus Pocus Sorcery",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/honey_royale": {
        slug: "honey_royale",
        name: "Honey Royale",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_mania": {
        slug: "hot_mania",
        name: "Hot Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_nights": {
        slug: "hot_rio_nights",
        name: "Hot Rio Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_nights_bonus_buy": {
        slug: "hot_rio_nights_bonus_buy",
        name: "Hot Rio Nights Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_rio_samba": {
        slug: "hot_rio_samba",
        name: "Hot Rio Samba",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_slice": {
        slug: "hot_slice",
        name: "Hot Slice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens": {
        slug: "hot_triple_sevens",
        name: "Hot Triple Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens_hold_and_win": {
        slug: "hot_triple_sevens_hold_and_win",
        name: "Hot Triple Sevens Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_triple_sevens_special": {
        slug: "hot_triple_sevens_special",
        name: "Hot Triple Sevens Special",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_volcano": {
        slug: "hot_volcano",
        name: "Hot Volcano",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hot_volcano_bonus_buy": {
        slug: "hot_volcano_bonus_buy",
        name: "Hot Volcano Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/hungry_night": {
        slug: "hungry_night",
        name: "Hungry Night",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ice_mania": {
        slug: "ice_mania",
        name: "Ice Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ignis_rex": {
        slug: "ignis_rex",
        name: "Ignis Rex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/imperial_relics_three_pots": {
        slug: "imperial_relics_three_pots",
        name: "Imperial Relics Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/indianas_quest": {
        slug: "indianas_quest",
        name: "Indiana's Quest",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/inner_fire": {
        slug: "inner_fire",
        name: "Inner Fire",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/inner_fire_bonus_buy": {
        slug: "inner_fire_bonus_buy",
        name: "Inner Fire Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_reels": {
        slug: "irish_reels",
        name: "Irish Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_weekend": {
        slug: "irish_weekend",
        name: "Irish Weekend",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/irish_weekend_bonus_buy": {
        slug: "irish_weekend_bonus_buy",
        name: "Irish Weekend Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jackmaster_fruits": {
        slug: "jackmaster_fruits",
        name: "Jackmaster Fruits",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jelly_boom": {
        slug: "jelly_boom",
        name: "Jelly Boom",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jhana_of_god_bonus_buy": {
        slug: "jhana_of_god_bonus_buy",
        name: "Jhana of God Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jhana_of_god_scratch": {
        slug: "jhana_of_god_scratch",
        name: "Jhana of God: Scratch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/joker_jane": {
        slug: "joker_jane",
        name: "Joker Jane",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/jolt_circuit": {
        slug: "jolt_circuit",
        name: "Jolt Circuit",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_fruit_coins_hold_and_win": {
        slug: "juicy_fruit_coins_hold_and_win",
        name: "Juicy Fruit Coins Hold and Win",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_gems": {
        slug: "juicy_gems",
        name: "Juicy Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/juicy_gems_bonus_buy": {
        slug: "juicy_gems_bonus_buy",
        name: "Juicy Gems Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lava_burst": {
        slug: "lava_burst",
        name: "Lava Burst",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legacy_of_the_sages": {
        slug: "legacy_of_the_sages",
        name: "Legacy of the Sages",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legacy_of_the_sages_bonus_buy": {
        slug: "legacy_of_the_sages_bonus_buy",
        name: "Legacy of the Sages Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/legend_of_ra": {
        slug: "legend_of_ra",
        name: "Legend of Ra",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/liberty_fireworks": {
        slug: "liberty_fireworks",
        name: "Liberty Fireworks",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/long_ball": {
        slug: "long_ball",
        name: "Long Ball",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/love_and_luck_joker": {
        slug: "love_and_luck_joker",
        name: "Love and Luck Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lu_fu_vortex": {
        slug: "lu_fu_vortex",
        name: "Lu Fu Vortex",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/luck_reactor": {
        slug: "luck_reactor",
        name: "Luck Reactor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_card": {
        slug: "lucky_card",
        name: "Lucky Card",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_crumbling": {
        slug: "lucky_crumbling",
        name: "Lucky Crumbling",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_girls": {
        slug: "lucky_girls",
        name: "Lucky Girls",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lucky_porker_bonus_buy": {
        slug: "lucky_porker_bonus_buy",
        name: "Lucky Porker Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/lunar_wilds": {
        slug: "lunar_wilds",
        name: "Lunar Wilds",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/magic_wheel": {
        slug: "magic_wheel",
        name: "Magic Wheel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/marys_mining_mania": {
        slug: "marys_mining_mania",
        name: "Mary's Mining Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/massive_luck": {
        slug: "massive_luck",
        name: "Massive Luck",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/massive_luck_bonus_buy": {
        slug: "massive_luck_bonus_buy",
        name: "Massive Luck Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch": {
        slug: "mega_greatest_catch",
        name: "Mega Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch_blue_marlin": {
        slug: "mega_greatest_catch_blue_marlin",
        name: "Mega Greatest Catch Blue Marlin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mega_greatest_catch_bonus_buy": {
        slug: "mega_greatest_catch_bonus_buy",
        name: "Mega Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mine_field": {
        slug: "mine_field",
        name: "Mine Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/money_minter": {
        slug: "money_minter",
        name: "Money Minter",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/money_minter_bonus_buy": {
        slug: "money_minter_bonus_buy",
        name: "Money Minter Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mysteries_of_the_east": {
        slug: "mysteries_of_the_east",
        name: "Mysteries of the East",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystery_planet": {
        slug: "mystery_planet",
        name: "Mystery Planet",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystic_alaska": {
        slug: "mystic_alaska",
        name: "Mystic Alaska",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/mystic_totems": {
        slug: "mystic_totems",
        name: "Mystic Totems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/naughty_girls_cabaret": {
        slug: "naughty_girls_cabaret",
        name: "Naughty Girls Cabaret",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/neon_capital_bonus_buy": {
        slug: "neon_capital_bonus_buy",
        name: "Neon Capital Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/northern_temple": {
        slug: "northern_temple",
        name: "Northern Temple",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/northern_temple_bonus_buy": {
        slug: "northern_temple_bonus_buy",
        name: "Northern Temple Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/nuke_world": {
        slug: "nuke_world",
        name: "Nuke World",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/oasis_poker_classic": {
        slug: "oasis_poker_classic",
        name: "Oasis Poker Classic",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/oath_of_steel": {
        slug: "oath_of_steel",
        name: "Oath of Steel",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ocean_catch_bonus_buy": {
        slug: "ocean_catch_bonus_buy",
        name: "Ocean Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/old_west": {
        slug: "old_west",
        name: "Old West",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/olympus_gold_rush": {
        slug: "olympus_gold_rush",
        name: "Olympus Gold Rush",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/patricks_club_three_pots": {
        slug: "patricks_club_three_pots",
        name: "Patrick's Club Three Pots",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/patricks_magic_field": {
        slug: "patricks_magic_field",
        name: "Patrick's Magic Field",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_roulette": {
        slug: "penalty_roulette",
        name: "Penalty Roulette",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_series": {
        slug: "penalty_series",
        name: "Penalty Series",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_cup_mania": {
        slug: "penalty_shoot_out_cup_mania",
        name: "Penalty Shoot Out: Cup Mania",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_super_cup": {
        slug: "penalty_shoot_out_super_cup",
        name: "Penalty Shoot Out Super Cup",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shoot_out_super_spin": {
        slug: "penalty_shoot_out_super_spin",
        name: "Penalty Shoot Out Super Spin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shootout": {
        slug: "penalty_shootout",
        name: "Penalty Shoot-out",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/penalty_shootut_street": {
        slug: "penalty_shootut_street",
        name: "Penalty Shoot-оut: Street",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/piggy_bank_3_pots_bonanza": {
        slug: "piggy_bank_3_pots_bonanza",
        name: "Piggy Bank 3 Pots Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/piggy_bank_coinstorm": {
        slug: "piggy_bank_coinstorm",
        name: "Piggy Bank: Coinstorm",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/piggy_fest_bonanza": {
        slug: "piggy_fest_bonanza",
        name: "Piggy Fest Bonanza",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pirate_coins_3_chests": {
        slug: "pirate_coins_3_chests",
        name: "Pirate Coins: 3 Chests",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/plinko_blast": {
        slug: "plinko_blast",
        name: "Plinko Blast",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pumpkin_master": {
        slug: "pumpkin_master",
        name: "Pumpkin Master",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/pyro_joker": {
        slug: "pyro_joker",
        name: "Pyro Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/queen_of_sirens": {
        slug: "queen_of_sirens",
        name: "Queen of Sirens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/red_cliff": {
        slug: "red_cliff",
        name: "Red Cliff",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/reign_of_dragons": {
        slug: "reign_of_dragons",
        name: "Reign of Dragons",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rich_reels": {
        slug: "rich_reels",
        name: "Rich Reels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rise_of_horus": {
        slug: "rise_of_horus",
        name: "Rise of Horus",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/robin_hood": {
        slug: "robin_hood",
        name: "Robin Hood",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rock_vs_paper_vikings_mode": {
        slug: "rock_vs_paper_vikings_mode",
        name: "Rock vs Paper: Viking’s mode",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rocket_stars": {
        slug: "rocket_stars",
        name: "Rocket Stars",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/roll_the_dice": {
        slug: "roll_the_dice",
        name: "Roll the Dice",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/roman_rule": {
        slug: "roman_rule",
        name: "Roman Rule",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rueda_de_chile": {
        slug: "rueda_de_chile",
        name: "Rueda de Chile",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rueda_de_chile_bonus_buy": {
        slug: "rueda_de_chile_bonus_buy",
        name: "Rueda de Chile Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/rush_riches": {
        slug: "rush_riches",
        name: "Rush Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/safari_coins_heart_of_africa": {
        slug: "safari_coins_heart_of_africa",
        name: "Safari Coins: Heart of Africa",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/save_the_hamster": {
        slug: "save_the_hamster",
        name: "Save the Hamster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/scratch_match": {
        slug: "scratch_match",
        name: "Scratch Match",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/scratch_match_deluxe": {
        slug: "scratch_match_deluxe",
        name: "Scratch Match Deluxe",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sea_of_wealth": {
        slug: "sea_of_wealth",
        name: "Sea of Wealth",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sea_of_wealth_hunt_for_coin": {
        slug: "sea_of_wealth_hunt_for_coin",
        name: "Sea of Wealth: Hunt for Coin",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/shadow_of_luxor": {
        slug: "shadow_of_luxor",
        name: "Shadow of Luxor",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sky_sentinels": {
        slug: "sky_sentinels",
        name: "Sky Sentinels",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/soccer_solo_striker": {
        slug: "soccer_solo_striker",
        name: "Soccer Solo Striker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sold_it_bonus_buy": {
        slug: "sold_it_bonus_buy",
        name: "Sold it Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/star_guardians": {
        slug: "star_guardians",
        name: "Star Guardians",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/sunstone_riches": {
        slug: "sunstone_riches",
        name: "Sunstone Riches",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/talismans_of_fortune": {
        slug: "talismans_of_fortune",
        name: "Talismans of Fortune",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/tap_craze": {
        slug: "tap_craze",
        name: "Tap Craze",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_dead": {
        slug: "temple_of_dead",
        name: "Temple of Dead",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_dead_bonus_buy": {
        slug: "temple_of_dead_bonus_buy",
        name: "Temple of Dead Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder": {
        slug: "temple_of_thunder",
        name: "Temple of Thunder",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_3": {
        slug: "temple_of_thunder_3",
        name: "Temple of Thunder 3",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_ii": {
        slug: "temple_of_thunder_ii",
        name: "Temple of Thunder II",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/temple_of_thunder_ii_bonus_buy": {
        slug: "temple_of_thunder_ii_bonus_buy",
        name: "Temple of Thunder II Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/texas_holdem_bonus": {
        slug: "texas_holdem_bonus",
        name: "Texas Hold'em Bonus",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/texas_holdem_poker": {
        slug: "texas_holdem_poker",
        name: "Texas Hold'em Poker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_belt_of_champion_bonus_buy": {
        slug: "the_belt_of_champion_bonus_buy",
        name: "The Belt Of Champion Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_easter_catch": {
        slug: "the_easter_catch",
        name: "The Easter Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_emperors_tomb": {
        slug: "the_emperors_tomb",
        name: "The Emperor's Tomb",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_greatest_catch": {
        slug: "the_greatest_catch",
        name: "The Greatest Catch",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_greatest_catch_bonus_buy": {
        slug: "the_greatest_catch_bonus_buy",
        name: "The Greatest Catch Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_king_crimson_crown": {
        slug: "the_king_crimson_crown",
        name: "The King: Crimson Crown",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/the_slavs": {
        slug: "the_slavs",
        name: "The Slavs",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thimbles": {
        slug: "thimbles",
        name: "Thimbles",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/three_trojan_horses": {
        slug: "three_trojan_horses",
        name: "Three Trojan Horses",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thunder_mega_sevens": {
        slug: "thunder_mega_sevens",
        name: "Thunder Mega Sevens",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/thunder_mega_sevens_bonus_buy": {
        slug: "thunder_mega_sevens_bonus_buy",
        name: "Thunder Mega Sevens Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/tiger_of_fortuner": {
        slug: "tiger_of_fortuner",
        name: "Tiger of Fortuner",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/train_of_riches_capital_express": {
        slug: "train_of_riches_capital_express",
        name: "Train of Riches Capital Express",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes": {
        slug: "treasure_snipes",
        name: "Treasure Snipes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_bonus_buy": {
        slug: "treasure_snipes_bonus_buy",
        name: "Treasure Snipes Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_christmas": {
        slug: "treasure_snipes_christmas",
        name: "Treasure Snipes: Christmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasure_snipes_christmas_bonus_buy": {
        slug: "treasure_snipes_christmas_bonus_buy",
        name: "Treasure Snipes: Christmas Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/treasures_of_the_gods": {
        slug: "treasures_of_the_gods",
        name: "Treasures of the Gods",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/trick_or_treat_joker": {
        slug: "trick_or_treat_joker",
        name: "Trick or Treat Joker",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/triple_chili": {
        slug: "triple_chili",
        name: "Triple Chili",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/ultra_reels_fruteria": {
        slug: "ultra_reels_fruteria",
        name: "Ultra Reels Fruteria",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/uncrossable_rush_eggster": {
        slug: "uncrossable_rush_eggster",
        name: "Uncrossable Rush Eggster",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/uncrossable_rush_xmas": {
        slug: "uncrossable_rush_xmas",
        name: "Uncrossable Rush Xmas",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_treasures": {
        slug: "unlimited_treasures",
        name: "Unlimited Treasures",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_treasures_bonus_buy": {
        slug: "unlimited_treasures_bonus_buy",
        name: "Unlimited Treasures Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/unlimited_wishes": {
        slug: "unlimited_wishes",
        name: "Unlimited Wishes",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/valley_of_dreams": {
        slug: "valley_of_dreams",
        name: "Valley of Dreams",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/vegas_nights": {
        slug: "vegas_nights",
        name: "Vegas Nights",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/velvet_gems": {
        slug: "velvet_gems",
        name: "Velvet Gems",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/venice_festival": {
        slug: "venice_festival",
        name: "Venice Festival",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wealth_bells_40": {
        slug: "wealth_bells_40",
        name: "Wealth Bells 40",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_bullets": {
        slug: "wild_bullets",
        name: "Wild Bullets",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_overlords": {
        slug: "wild_overlords",
        name: "Wild Overlords",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_overlords_bonus_buy": {
        slug: "wild_overlords_bonus_buy",
        name: "Wild Overlords Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wild_pounce": {
        slug: "wild_pounce",
        name: "Wild Pounce",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/winter_star": {
        slug: "winter_star",
        name: "Winter Star",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/winter_star_bonus_buy": {
        slug: "winter_star_bonus_buy",
        name: "Winter Star Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wolf_hiding": {
        slug: "wolf_hiding",
        name: "Wolf Hiding",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wolf_hiding_bonus_buy": {
        slug: "wolf_hiding_bonus_buy",
        name: "Wolf Hiding Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/wonder_farm_bonus_buy": {
        slug: "wonder_farm_bonus_buy",
        name: "Wonder Farm Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xdemon": {
        slug: "xdemon",
        name: "X-Demon",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/xdemon_bonus_buy": {
        slug: "xdemon_bonus_buy",
        name: "X-Demon Bonus Buy",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_buffalo_coins": {
        slug: "young_buffalo_coins",
        name: "Young Buffalo Coins",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_buffalo_coins_special": {
        slug: "young_buffalo_coins_special",
        name: "Young Buffalo Coins Special",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_buffalo_song": {
        slug: "young_buffalo_song",
        name: "Young Buffalo Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_deer_song": {
        slug: "young_deer_song",
        name: "Young Deer Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_eagle_song": {
        slug: "young_eagle_song",
        name: "Young Eagle Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "evoplay/young_wolf_song": {
        slug: "young_wolf_song",
        name: "Young Wolf Song",
        provider: "Evoplay",
        providerSlug: "evoplay"
    },
    "exco/apex_dregs": {
        slug: "apex_dregs",
        name: "Apex Dregs",
        provider: "Exco",
        providerSlug: "exco"
    },
    "exco/luna_x": {
        slug: "luna_x",
        name: "Luna X",
        provider: "Exco",
        providerSlug: "exco"
    },
    "exco/ministry_of_like": {
        slug: "ministry_of_like",
        name: "Ministry of Like",
        provider: "Exco",
        providerSlug: "exco"
    },
    "exco/piranha_bite_club": {
        slug: "piranha_bite_club",
        name: "Piranha Bite Club",
        provider: "Exco",
        providerSlug: "exco"
    },
    "exco/the_robbin_goblins": {
        slug: "the_robbin_goblins",
        name: "The Robbin' Goblins",
        provider: "Exco",
        providerSlug: "exco"
    },
    "exco/vegascaline": {
        slug: "vegascaline",
        name: "Vegascaline",
        provider: "Exco",
        providerSlug: "exco"
    },
    "expanse-studios/100_super_icy": {
        slug: "100_super_icy",
        name: "100 Super Icy",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/beach_penalties": {
        slug: "beach_penalties",
        name: "Beach Penalties",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/book_of_eskimo": {
        slug: "book_of_eskimo",
        name: "Book of Eskimo",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/crazy_horses": {
        slug: "crazy_horses",
        name: "Crazy Horses",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/diamond_blackjack": {
        slug: "diamond_blackjack",
        name: "Diamond Blackjack",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/gates_of_olympia": {
        slug: "gates_of_olympia",
        name: "Gates of Olympia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/gem_miner": {
        slug: "gem_miner",
        name: "Gem Miner",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/leprechaun_wish": {
        slug: "leprechaun_wish",
        name: "Leprechaun Wish",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pia": {
        slug: "pia",
        name: "Pia",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pinata_loca": {
        slug: "pinata_loca",
        name: "Pinata Loca",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/pixel_poker": {
        slug: "pixel_poker",
        name: "Pixel Poker",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/rich_panda": {
        slug: "rich_panda",
        name: "Rich Panda",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/shaolin_crew": {
        slug: "shaolin_crew",
        name: "Shaolin Crew",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/titan_roulette": {
        slug: "titan_roulette",
        name: "Titan roulette",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/veni_vidi_vici": {
        slug: "veni_vidi_vici",
        name: "Veni Vidi Vici",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "expanse-studios/wild_corrida": {
        slug: "wild_corrida",
        name: "Wild Corrida",
        provider: "Expanse Studios",
        providerSlug: "expanse-studios"
    },
    "ezugi/32_cards": {
        slug: "32_cards",
        name: "32 Cards",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/american_football_auto_roulette": {
        slug: "american_football_auto_roulette",
        name: "American Football Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/arcade_roulette": {
        slug: "arcade_roulette",
        name: "Arcade Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/auto_claw_roulette": {
        slug: "auto_claw_roulette",
        name: "Auto Claw Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/bet_on_teen_patti": {
        slug: "bet_on_teen_patti",
        name: "Bet on Teen Patti",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/bet_with_streamers": {
        slug: "bet_with_streamers",
        name: "Bet with Streamers",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/big_cock_knockout": {
        slug: "big_cock_knockout",
        name: "Big Cock Knockout",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/blackjack_da_sorte": {
        slug: "blackjack_da_sorte",
        name: "Blackjack da Sorte",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/blackjack_salon_privee": {
        slug: "blackjack_salon_privee",
        name: "Blackjack Salon Privee",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/canada_blackjack": {
        slug: "canada_blackjack",
        name: "Canada Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Hold'em",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/casino_marina_andar_bahar": {
        slug: "casino_marina_andar_bahar",
        name: "Casino Marina Andar Bahar",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/casino_marina_baccarat": {
        slug: "casino_marina_baccarat",
        name: "Casino Marina Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/casino_marina_roulette": {
        slug: "casino_marina_roulette",
        name: "Casino Marina Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/christmas_auto_roulette": {
        slug: "christmas_auto_roulette",
        name: "Christmas Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/coin_rush": {
        slug: "coin_rush",
        name: "Coin Rush",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/coin_rush_pro": {
        slug: "coin_rush_pro",
        name: "Coin Rush Pro",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/cricket_auto_roulette": {
        slug: "cricket_auto_roulette",
        name: "Cricket Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/cricket_ball_roulette": {
        slug: "cricket_ball_roulette",
        name: "Cricket Ball Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/cricket_war": {
        slug: "cricket_war",
        name: "Cricket War",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/diamond_roulette": {
        slug: "diamond_roulette",
        name: "Diamond Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/diwali_auto_roulette": {
        slug: "diwali_auto_roulette",
        name: "Diwali Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/dragon_tiger_da_sorte": {
        slug: "dragon_tiger_da_sorte",
        name: "Dragon Tiger da Sorte",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_baccarat": {
        slug: "ez_baccarat",
        name: "EZ Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_bingo": {
        slug: "ez_bingo",
        name: "EZ Bingo",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_bonus_wheel": {
        slug: "ez_bonus_wheel",
        name: "EZ Bonus Wheel",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roleta_brazileira": {
        slug: "ez_dealer_roleta_brazileira",
        name: "EZ Dealer Roleta Brazileira",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_bengali": {
        slug: "ez_dealer_roulette_bengali",
        name: "EZ Dealer Roulette Bengali",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_english": {
        slug: "ez_dealer_roulette_english",
        name: "EZ Dealer Roulette English",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_football": {
        slug: "ez_dealer_roulette_football",
        name: "Ez Dealer Roulette Football",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_hindi": {
        slug: "ez_dealer_roulette_hindi",
        name: "EZ Dealer Roulette Hindi",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_japanese": {
        slug: "ez_dealer_roulette_japanese",
        name: "EZ Dealer Roulette Japanese",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_latina": {
        slug: "ez_dealer_roulette_latina",
        name: "EZ Dealer Roulette Latina",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_mandarin": {
        slug: "ez_dealer_roulette_mandarin",
        name: "EZ Dealer Roulette Mandarin",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_nederlands": {
        slug: "ez_dealer_roulette_nederlands",
        name: "EZ Dealer Roulette Nederlands",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_savanna": {
        slug: "ez_dealer_roulette_savanna",
        name: "EZ Dealer Roulette Savanna",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_thai": {
        slug: "ez_dealer_roulette_thai",
        name: "EZ Dealer Roulette Thai",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_dealer_roulette_turkish": {
        slug: "ez_dealer_roulette_turkish",
        name: "EZ Dealer Roulette Turkish",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_marble_race_las_vegas": {
        slug: "ez_marble_race_las_vegas",
        name: "EZ Marble Race Las Vegas",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_marble_race_monaco": {
        slug: "ez_marble_race_monaco",
        name: "EZ Marble Race Monaco",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ez_speed_bingo": {
        slug: "ez_speed_bingo",
        name: "EZ Speed Bingo",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ezugi_live_lobby": {
        slug: "ezugi_live_lobby",
        name: "Ezugi Live Lobby",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/football_auto_roulette": {
        slug: "football_auto_roulette",
        name: "Football Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/fortune_baccarat": {
        slug: "fortune_baccarat",
        name: "Fortune Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/fortune_pusher": {
        slug: "fortune_pusher",
        name: "Fortune Pusher",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/gold_blackjack": {
        slug: "gold_blackjack",
        name: "Gold Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/golden_goal_roulette": {
        slug: "golden_goal_roulette",
        name: "Golden Goal Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/halloween_auto_roulette": {
        slug: "halloween_auto_roulette",
        name: "Halloween Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/horse_racing_auto_roulette": {
        slug: "horse_racing_auto_roulette",
        name: "Horse Racing Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/italian_roulette": {
        slug: "italian_roulette",
        name: "Italian Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/knockout_baccarat": {
        slug: "knockout_baccarat",
        name: "Knockout Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/lucky": {
        slug: "lucky",
        name: "Lucky",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/magic_claw": {
        slug: "magic_claw",
        name: "Magic Claw",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/manga_madness": {
        slug: "manga_madness",
        name: "Manga Madness",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/matka": {
        slug: "matka",
        name: "Matka",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/namaste_roulette": {
        slug: "namaste_roulette",
        name: "Namaste Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/no_commission_over_under_baccarat": {
        slug: "no_commission_over_under_baccarat",
        name: "No Commission Over Under Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/one_day_teen_patti": {
        slug: "one_day_teen_patti",
        name: "One Day Teen Patti",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/oracle_360_roulette": {
        slug: "oracle_360_roulette",
        name: "Oracle 360 Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/oracle_real_roulette": {
        slug: "oracle_real_roulette",
        name: "Oracle Real Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/oracle_roulette": {
        slug: "oracle_roulette",
        name: "Oracle Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ott_andar_bahar": {
        slug: "ott_andar_bahar",
        name: "OTT Andar Bahar",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ott_baccarat": {
        slug: "ott_baccarat",
        name: "OTT Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ott_roulette": {
        slug: "ott_roulette",
        name: "OTT Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/over_under_baccarat": {
        slug: "over_under_baccarat",
        name: "Over Under Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/poker_lobby": {
        slug: "poker_lobby",
        name: "Poker Lobby",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/portomaso_roulette": {
        slug: "portomaso_roulette",
        name: "Portomaso Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/prestige_auto_roulette": {
        slug: "prestige_auto_roulette",
        name: "Prestige Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ride_free_blackjack_gold": {
        slug: "ride_free_blackjack_gold",
        name: "Ride Free Blackjack Gold",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/rng_roulette": {
        slug: "rng_roulette",
        name: "RNG Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/roleta_da_sorte": {
        slug: "roleta_da_sorte",
        name: "Roleta da sorte",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/roulette_lobby": {
        slug: "roulette_lobby",
        name: "Roulette Lobby",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ruleta_del_sol": {
        slug: "ruleta_del_sol",
        name: "Ruleta del Sol",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/rumba_blackjack": {
        slug: "rumba_blackjack",
        name: "Rumba Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/russian_blackjack": {
        slug: "russian_blackjack",
        name: "Russian Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/russian_poker": {
        slug: "russian_poker",
        name: "Russian Poker",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/russian_roulette": {
        slug: "russian_roulette",
        name: "Russian Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/salon_prive_blackjack": {
        slug: "salon_prive_blackjack",
        name: "Salon Prive Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/skyline_roulette": {
        slug: "skyline_roulette",
        name: "Skyline Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/spanish_roulette": {
        slug: "spanish_roulette",
        name: "Spanish Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/spanish_unlimited_blackjack": {
        slug: "spanish_unlimited_blackjack",
        name: "Spanish Unlimited Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/speed_auto_roulette": {
        slug: "speed_auto_roulette",
        name: "Speed Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/speed_fortune_baccarat": {
        slug: "speed_fortune_baccarat",
        name: "Speed Fortune Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/speed_roulette": {
        slug: "speed_roulette",
        name: "Speed Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/super_6_baccarat": {
        slug: "super_6_baccarat",
        name: "Super 6 Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/teen_patti_3_card": {
        slug: "teen_patti_3_card",
        name: "Teen Patti 3 Card",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/three_card_poker": {
        slug: "three_card_poker",
        name: "Three Card Poker",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/turkish_roulette": {
        slug: "turkish_roulette",
        name: "Turkish Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ultimate_andar_bahar": {
        slug: "ultimate_andar_bahar",
        name: "Ultimate Andar Bahar",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ultimate_auto_roulette": {
        slug: "ultimate_auto_roulette",
        name: "Ultimate Auto Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ultimate_flip": {
        slug: "ultimate_flip",
        name: "Ultimate Flip",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ultimate_roulette": {
        slug: "ultimate_roulette",
        name: "Ultimate Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/ultimate_sic_bo": {
        slug: "ultimate_sic_bo",
        name: "Ultimate Sic Bo",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/unlimited_blackjack": {
        slug: "unlimited_blackjack",
        name: "Unlimited Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/vip_diamond_blackjack": {
        slug: "vip_diamond_blackjack",
        name: "VIP Diamond Blackjack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/vip_fortune_baccarat": {
        slug: "vip_fortune_baccarat",
        name: "VIP Fortune Baccarat",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/vip_roulette": {
        slug: "vip_roulette",
        name: "VIP Roulette",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/vip_surrender_blackjack": {
        slug: "vip_surrender_blackjack",
        name: "VIP Surrender BlackJack",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "ezugi/xoc_dia": {
        slug: "xoc_dia",
        name: "Xoc Dia",
        provider: "Ezugi",
        providerSlug: "ezugi"
    },
    "fantasma/alice_in_adventureland": {
        slug: "alice_in_adventureland",
        name: "Alice in Adventureland",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/animal_carnival": {
        slug: "animal_carnival",
        name: "Animal Carnival",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/bounty_showdown": {
        slug: "bounty_showdown",
        name: "Bounty Showdown",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/caravan_of_riches": {
        slug: "caravan_of_riches",
        name: "Caravan of Riches",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/circle_of_sylvan": {
        slug: "circle_of_sylvan",
        name: "Circle of Sylvan",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/desert_shark": {
        slug: "desert_shark",
        name: "Desert Shark",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/elemento": {
        slug: "elemento",
        name: "Elemento",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/flower_fortunes_supreme": {
        slug: "flower_fortunes_supreme",
        name: "Flower Fortunes Supreme",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/fortune_llama": {
        slug: "fortune_llama",
        name: "Fortune Llama",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/golden_castle_titanways": {
        slug: "golden_castle_titanways",
        name: "Golden Castle TitanWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/hades_river_of_souls": {
        slug: "hades_river_of_souls",
        name: "Hades: River of Souls",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/heroes_hunt_2": {
        slug: "heroes_hunt_2",
        name: "Heroes Hunt 2",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/heroes_hunt_megaways": {
        slug: "heroes_hunt_megaways",
        name: "Heroes Hunt MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/magikspell": {
        slug: "magikspell",
        name: "Magikspell",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/maze_escape_megaways": {
        slug: "maze_escape_megaways",
        name: "Maze Escape MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/medallion_megaways": {
        slug: "medallion_megaways",
        name: "Medallion MegaWays",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/mystic_spells": {
        slug: "mystic_spells",
        name: "Mystic Spells",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/pirate_multi_coins": {
        slug: "pirate_multi_coins",
        name: "Pirate Multi Coins",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/rich_raptors": {
        slug: "rich_raptors",
        name: "Rich Raptors",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/safari_sun": {
        slug: "safari_sun",
        name: "Safari Sun",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/serpent_shrine": {
        slug: "serpent_shrine",
        name: "Serpent Shrine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/shadow_summoner_elementals": {
        slug: "shadow_summoner_elementals",
        name: "Shadow Summoner Elementals",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/twisted_turbine": {
        slug: "twisted_turbine",
        name: "Twisted Turbine",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/wins_of_mermaid_multi_power": {
        slug: "wins_of_mermaid_multi_power",
        name: "Wins of Mermaid Multi Power",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fantasma/wins_of_winter": {
        slug: "wins_of_winter",
        name: "Wins of Winter",
        provider: "Fantasma",
        providerSlug: "fantasma"
    },
    "fatpanda/777_rush": {
        slug: "777_rush",
        name: "777 Rush",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/code_of_cairo": {
        slug: "code_of_cairo",
        name: "Code of Cairo",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/dino_drop": {
        slug: "dino_drop",
        name: "Dino Drop",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/dj_neko": {
        slug: "dj_neko",
        name: "DJ Neko",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/emotiwins": {
        slug: "emotiwins",
        name: "Emotiwins",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/happy_dragon": {
        slug: "happy_dragon",
        name: "Happy Dragon",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/happy_nets": {
        slug: "happy_nets",
        name: "Happy Nets",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/jelly_candy": {
        slug: "jelly_candy",
        name: "Jelly Candy",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_bull": {
        slug: "lucky_bull",
        name: "Lucky Bull",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_dice_88": {
        slug: "lucky_dice_88",
        name: "Lucky Dice 88",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_dog": {
        slug: "lucky_dog",
        name: "Lucky Dog",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_fortune_tree": {
        slug: "lucky_fortune_tree",
        name: "Lucky Fortune Tree",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_monkey": {
        slug: "lucky_monkey",
        name: "Lucky Monkey",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_mouse": {
        slug: "lucky_mouse",
        name: "Lucky Mouse",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_panda": {
        slug: "lucky_panda",
        name: "Lucky Panda",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_phoenix": {
        slug: "lucky_phoenix",
        name: "Lucky Phoenix",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_tiger": {
        slug: "lucky_tiger",
        name: "Lucky Tiger",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_tiger_1000": {
        slug: "lucky_tiger_1000",
        name: "Lucky Tiger 1000",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/lucky_tiger_gold": {
        slug: "lucky_tiger_gold",
        name: "Lucky Tiger Gold",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/master_gems": {
        slug: "master_gems",
        name: "Master Gems",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/mystic_wishes": {
        slug: "mystic_wishes",
        name: "Mystic Wishes",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/olympus_wins": {
        slug: "olympus_wins",
        name: "Olympus Wins",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/pig_farm": {
        slug: "pig_farm",
        name: "Pig Farm",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/plushie_wins": {
        slug: "plushie_wins",
        name: "Plushie Wins",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/starlight_wins": {
        slug: "starlight_wins",
        name: "Starlight Wins",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/sweet_burst": {
        slug: "sweet_burst",
        name: "Sweet Burst",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/tuts_treasure_tower": {
        slug: "tuts_treasure_tower",
        name: "Tut's Treasure Tower",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fatpanda/wealthy_frog": {
        slug: "wealthy_frog",
        name: "Wealthy Frog",
        provider: "Fatpanda",
        providerSlug: "fatpanda"
    },
    "fbastards/anubis_curse": {
        slug: "anubis_curse",
        name: "Anubis Curse",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/anubis_curse_2": {
        slug: "anubis_curse_2",
        name: "Anubis Curse 2",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/bad_babushkas": {
        slug: "bad_babushkas",
        name: "Bad Babushkas",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/book_of_wizardry": {
        slug: "book_of_wizardry",
        name: "Book of Wizardry",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/bruce_bumerang": {
        slug: "bruce_bumerang",
        name: "Bruce Bumerang",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/cartel_chase": {
        slug: "cartel_chase",
        name: "Cartel Chase",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/crash_squad": {
        slug: "crash_squad",
        name: "Crash Squad",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/crash_squad_winter_party": {
        slug: "crash_squad_winter_party",
        name: "Crash Squad Winter Party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/crystal_chef_amped_up": {
        slug: "crystal_chef_amped_up",
        name: "Crystal Chef Amped Up",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/cyber_slot": {
        slug: "cyber_slot",
        name: "Cyber slot",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/demon_slayer": {
        slug: "demon_slayer",
        name: "Demon Slayer",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/dia_de_los_muertos": {
        slug: "dia_de_los_muertos",
        name: "Dia De Los Muertos",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/elves": {
        slug: "elves",
        name: "Elves",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/favela_boyz": {
        slug: "favela_boyz",
        name: "Favela Boyz",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/fire_dragon": {
        slug: "fire_dragon",
        name: "Fire dragon",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/football_hooligans": {
        slug: "football_hooligans",
        name: "Football Hooligans",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/frednfire": {
        slug: "frednfire",
        name: "Fred-Nfire",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/goldwins": {
        slug: "goldwins",
        name: "GoldWins",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jack_win": {
        slug: "jack_win",
        name: "Jack win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jokersontop": {
        slug: "jokersontop",
        name: "JokersOnTop",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/jolly_casino": {
        slug: "jolly_casino",
        name: "Jolly casino",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/la_clika_cash_run": {
        slug: "la_clika_cash_run",
        name: "La Clika: Cash Run",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/level20": {
        slug: "level20",
        name: "Level20",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/lucky_farm": {
        slug: "lucky_farm",
        name: "Lucky Farm",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/mafia": {
        slug: "mafia",
        name: "Mafia",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/mindiana_jones": {
        slug: "mindiana_jones",
        name: "Mindiana Jones",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/ocean_party": {
        slug: "ocean_party",
        name: "Ocean party",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/quest": {
        slug: "quest",
        name: "Quest",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/reels": {
        slug: "reels",
        name: "Reels",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/returntovalhalla": {
        slug: "returntovalhalla",
        name: "ReturnToValhalla",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/sit_n_win": {
        slug: "sit_n_win",
        name: "Sit 'N Win",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/skaterboy": {
        slug: "skaterboy",
        name: "SkaterBoy",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/treasure_hunter": {
        slug: "treasure_hunter",
        name: "Treasure Hunter",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/wildndice": {
        slug: "wildndice",
        name: "WildNDice",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/wonder_machine": {
        slug: "wonder_machine",
        name: "Wonder Machine",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbastards/zombie_knight": {
        slug: "zombie_knight",
        name: "Zombie Knight",
        provider: "Fbastards",
        providerSlug: "fbastards"
    },
    "fbmds/arctic_jumper_momentum_series": {
        slug: "arctic_jumper_momentum_series",
        name: "Arctic Jumper Momentum Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/bandit_fortune_sublime_series": {
        slug: "bandit_fortune_sublime_series",
        name: "Bandit Fortune Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/bingo_pilipino_tradicional_series": {
        slug: "bingo_pilipino_tradicional_series",
        name: "Bingo Pilipino Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/blazing_horse_legacy_series": {
        slug: "blazing_horse_legacy_series",
        name: "Blazing Horse Legacy Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/buffalo_canyon_bonanza_series": {
        slug: "buffalo_canyon_bonanza_series",
        name: "Buffalo Canyon Bonanza Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/buffalo_spirit_sublime_series": {
        slug: "buffalo_spirit_sublime_series",
        name: "Buffalo Spirit Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/cafe_charm_fortune_epic_series": {
        slug: "cafe_charm_fortune_epic_series",
        name: "Cafe Charm Fortune Epic Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/champion_ii_tradicional_series": {
        slug: "champion_ii_tradicional_series",
        name: "Champion II Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/champion_iv_tradicional_series": {
        slug: "champion_iv_tradicional_series",
        name: "Champion IV Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/cyber_fruits_cyber_series": {
        slug: "cyber_fruits_cyber_series",
        name: "Cyber Fruits Cyber Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/cyber_mexico": {
        slug: "cyber_mexico",
        name: "Cyber Mexico",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/cyber_miami_cyber_series": {
        slug: "cyber_miami_cyber_series",
        name: "Cyber Miami Cyber Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/dark_of_velkaria_sublime_series": {
        slug: "dark_of_velkaria_sublime_series",
        name: "Dark Of Velkaria - Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/desert_gold_titan_series": {
        slug: "desert_gold_titan_series",
        name: "Desert Gold Titan Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/donald_farm_bonanza_series": {
        slug: "donald_farm_bonanza_series",
        name: "Donald Farm - Bonanza Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/dragon_jewels": {
        slug: "dragon_jewels",
        name: "Dragon Jewels",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/dragons_fortune_mystic_series": {
        slug: "dragons_fortune_mystic_series",
        name: "Dragons Fortune Mystic Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/flow_of_fortune_mystic_series": {
        slug: "flow_of_fortune_mystic_series",
        name: "Flow Of Fortune Mystic Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/fruity_splash": {
        slug: "fruity_splash",
        name: "Fruity Splash",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/golden_patrick_rainbow_legacy_series": {
        slug: "golden_patrick_rainbow_legacy_series",
        name: "Golden Patrick Rainbow Legacy Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/heart_of_catrina": {
        slug: "heart_of_catrina",
        name: "Heart of Catrina",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/lap_of_treasures_bonanza_series": {
        slug: "lap_of_treasures_bonanza_series",
        name: "Lap of Treasures - Bonanza Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/magical_garden_momentum_series": {
        slug: "magical_garden_momentum_series",
        name: "Magical Garden Momentum Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/monolietneko_bonanza_series": {
        slug: "monolietneko_bonanza_series",
        name: "MonolietNeko Bonanza Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/multi_mega_tradicional_series": {
        slug: "multi_mega_tradicional_series",
        name: "Multi Mega Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/multi_plus_traditional_series": {
        slug: "multi_plus_traditional_series",
        name: "Multi Plus Traditional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/neko_treasure_sublime_series": {
        slug: "neko_treasure_sublime_series",
        name: "Neko Treasure Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/olympus_thunder": {
        slug: "olympus_thunder",
        name: "Olympus Thunder",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/panda_treasure_sublime_series": {
        slug: "panda_treasure_sublime_series",
        name: "Panda Treasure Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/pinata_pop_sublime_series": {
        slug: "pinata_pop_sublime_series",
        name: "Pinata POP Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/pinata_prestige": {
        slug: "pinata_prestige",
        name: "Pinata Prestige",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/pinata_rush_momentum_series": {
        slug: "pinata_rush_momentum_series",
        name: "Pinata Rush Momentum Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/plus_3_tradicional_series": {
        slug: "plus_3_tradicional_series",
        name: "Plus 3 Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/power_gacha_titan_series": {
        slug: "power_gacha_titan_series",
        name: "Power Gacha Titan Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/power_pick_lotto_tradicional_series": {
        slug: "power_pick_lotto_tradicional_series",
        name: "Power Pick Lotto Tradicional Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/reborn_empire_sublime_series": {
        slug: "reborn_empire_sublime_series",
        name: "Reborn Empire Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/sands_of_eternity_sublime_series": {
        slug: "sands_of_eternity_sublime_series",
        name: "Sands Of Eternity Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/sayuri_light_sublime_series": {
        slug: "sayuri_light_sublime_series",
        name: "Sayuri Light - Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/sea_of_fortune_sublime_series": {
        slug: "sea_of_fortune_sublime_series",
        name: "Sea of Fortune Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/secrets_of_scarabs_titan_series": {
        slug: "secrets_of_scarabs_titan_series",
        name: "Secrets of Scarabs Titan Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/shadow_fortune": {
        slug: "shadow_fortune",
        name: "Shadow Fortune",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/sheriff_bounty_sublime_series": {
        slug: "sheriff_bounty_sublime_series",
        name: "Sheriff Bounty Sublime Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "fbmds/zaltik_empire_titan_series": {
        slug: "zaltik_empire_titan_series",
        name: "Zaltik Empire Titan Series",
        provider: "FBMDS",
        providerSlug: "fbmds"
    },
    "flatdog/3_fiery_peppers_hold_and_win": {
        slug: "3_fiery_peppers_hold_and_win",
        name: "3 Fiery Peppers Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/3_scarab_storms_hold_and_win": {
        slug: "3_scarab_storms_hold_and_win",
        name: "3 Scarab Storms Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/40_clover_bounty_towerhits": {
        slug: "40_clover_bounty_towerhits",
        name: "40 Clover Bounty TowerHits",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/alien_trackers": {
        slug: "alien_trackers",
        name: "Alien Trackers",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/ancient_wolf_hold_and_win": {
        slug: "ancient_wolf_hold_and_win",
        name: "Ancient Wolf Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire": {
        slug: "angus_fire",
        name: "Angus Fire",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire_2": {
        slug: "angus_fire_2",
        name: "Angus Fire 2",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire_2_micromax": {
        slug: "angus_fire_2_micromax",
        name: "Angus Fire 2 Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire_gamble_feature": {
        slug: "angus_fire_gamble_feature",
        name: "Angus Fire Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire_gold_hunt": {
        slug: "angus_fire_gold_hunt",
        name: "Angus Fire Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/angus_fire_reloaded": {
        slug: "angus_fire_reloaded",
        name: "Angus Fire Reloaded",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anne_of_the_sea": {
        slug: "anne_of_the_sea",
        name: "Anne Of The Sea",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anne_of_the_sea_2": {
        slug: "anne_of_the_sea_2",
        name: "Anne of the Sea 2",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anne_of_the_sea_gamble_feature": {
        slug: "anne_of_the_sea_gamble_feature",
        name: "Anne Of The Sea Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anne_of_the_sea_hold_and_win": {
        slug: "anne_of_the_sea_hold_and_win",
        name: "Anne of the Sea Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anne_of_the_sea_micromax": {
        slug: "anne_of_the_sea_micromax",
        name: "Anne of the Sea Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/anubis_fire": {
        slug: "anubis_fire",
        name: "Anubis Fire",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/ape_riches_hold_and_win": {
        slug: "ape_riches_hold_and_win",
        name: "Ape Riches Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bad_boy_bill": {
        slug: "bad_boy_bill",
        name: "Bad Boy Bill",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bad_boy_bill_boomboom": {
        slug: "bad_boy_bill_boomboom",
        name: "Bad Boy Bill BoomBoom",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/barrels_of_bavaria": {
        slug: "barrels_of_bavaria",
        name: "Barrels Of Bavaria",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/beasts_of_helheim": {
        slug: "beasts_of_helheim",
        name: "Beasts Of Helheim",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/beasts_of_helheim_gamble_feature": {
        slug: "beasts_of_helheim_gamble_feature",
        name: "Beasts Of Helheim Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/benten_blades": {
        slug: "benten_blades",
        name: "Benten Blades",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bifrost_guardian": {
        slug: "bifrost_guardian",
        name: "Bifrost Guardian",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bifrost_guardian_gold_hunt": {
        slug: "bifrost_guardian_gold_hunt",
        name: "Bifrost Guardian Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/big_baiters_hold_and_win": {
        slug: "big_baiters_hold_and_win",
        name: "Big Baiters Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/blockbuster_7s_hold_and_win": {
        slug: "blockbuster_7s_hold_and_win",
        name: "Blockbuster 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/blue_bounty_7s": {
        slug: "blue_bounty_7s",
        name: "Blue Bounty 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/buffalo_twister_gold_hunt": {
        slug: "buffalo_twister_gold_hunt",
        name: "Buffalo Twister Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bullion_brews": {
        slug: "bullion_brews",
        name: "Bullion Brews",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bullion_brews_50k": {
        slug: "bullion_brews_50k",
        name: "Bullion Brews 50K",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/bullion_brews_bonanza": {
        slug: "bullion_brews_bonanza",
        name: "Bullion Brews Bonanza",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/canyon_chaos_towerhits": {
        slug: "canyon_chaos_towerhits",
        name: "Canyon Chaos TowerHits",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cash_quez": {
        slug: "cash_quez",
        name: "Cash Quez",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cashpot_craze": {
        slug: "cashpot_craze",
        name: "Cashpot Craze",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cashpot_frenzy_hold_and_win": {
        slug: "cashpot_frenzy_hold_and_win",
        name: "Cashpot Frenzy Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cherry_max_7s": {
        slug: "cherry_max_7s",
        name: "Cherry Max 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/clawface": {
        slug: "clawface",
        name: "Clawface",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/clover_disco_7s": {
        slug: "clover_disco_7s",
        name: "Clover Disco 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/clover_frenzy_hold_and_win": {
        slug: "clover_frenzy_hold_and_win",
        name: "Clover Frenzy Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/clue_chasers": {
        slug: "clue_chasers",
        name: "Clue Chasers",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/coin_maker_7s_hold_and_win": {
        slug: "coin_maker_7s_hold_and_win",
        name: "Coin Maker 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/coin_stacker_7s_hold_and_win": {
        slug: "coin_stacker_7s_hold_and_win",
        name: "Coin Stacker 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cyborg_empire": {
        slug: "cyborg_empire",
        name: "Cyborg Empire",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cyborg_empire_gold_hunt": {
        slug: "cyborg_empire_gold_hunt",
        name: "Cyborg Empire Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cyborg_empire_micromax": {
        slug: "cyborg_empire_micromax",
        name: "Cyborg Empire Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/cyborg_galaxy": {
        slug: "cyborg_galaxy",
        name: "Cyborg Galaxy",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/devils_barbeque": {
        slug: "devils_barbeque",
        name: "Devil’s Barbeque",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/devils_fishing_cruise": {
        slug: "devils_fishing_cruise",
        name: "Devil’s Fishing Cruise",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/diamond_twist_7s_hold_and_win": {
        slug: "diamond_twist_7s_hold_and_win",
        name: "Diamond Twist 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/divine_pearls": {
        slug: "divine_pearls",
        name: "Divine Pearls",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/divine_pearls_micromax": {
        slug: "divine_pearls_micromax",
        name: "Divine Pearls Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/dragon_ice_kingdom": {
        slug: "dragon_ice_kingdom",
        name: "Dragon Ice Kingdom",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/dragon_kingdom": {
        slug: "dragon_kingdom",
        name: "Dragon Kingdom",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/dragon_kingdom_micromax": {
        slug: "dragon_kingdom_micromax",
        name: "Dragon Kingdom Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/dynasty_gold": {
        slug: "dynasty_gold",
        name: "Dynasty Gold",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/dynasty_gold_gamble_feature": {
        slug: "dynasty_gold_gamble_feature",
        name: "Dynasty Gold Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/eagle_path_towerhits": {
        slug: "eagle_path_towerhits",
        name: "Eagle Path TowerHits",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/electro_stars": {
        slug: "electro_stars",
        name: "Electro Stars",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/electro_stars_xmas_edition": {
        slug: "electro_stars_xmas_edition",
        name: "Electro Stars Xmas Edition",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/emperor_spark_7s": {
        slug: "emperor_spark_7s",
        name: "Emperor Spark 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/eye_of_eternity_towerhits": {
        slug: "eye_of_eternity_towerhits",
        name: "Eye of Eternity TowerHits",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/eye_of_the_tiger": {
        slug: "eye_of_the_tiger",
        name: "Eye Of The tiger",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/feargals_fortunarium": {
        slug: "feargals_fortunarium",
        name: "Feargal’s Fortunarium",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/feargals_outlaws": {
        slug: "feargals_outlaws",
        name: "Feargal’s Outlaws",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/feargals_treasure_2": {
        slug: "feargals_treasure_2",
        name: "Feargal's Treasure 2",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/feargals_treasure_7s": {
        slug: "feargals_treasure_7s",
        name: "Feargal’s Treasure 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/fire_fairy": {
        slug: "fire_fairy",
        name: "Fire Fairy",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/fire_gems": {
        slug: "fire_gems",
        name: "Fire Gems",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/fire_gems_gamble_feature": {
        slug: "fire_gems_gamble_feature",
        name: "Fire Gems Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/flaming_pepper_7s_hold_and_win": {
        slug: "flaming_pepper_7s_hold_and_win",
        name: "Flaming Pepper 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/flying_sheriff_7s": {
        slug: "flying_sheriff_7s",
        name: "Flying Sheriff 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/football_fireblast_hold_and_win": {
        slug: "football_fireblast_hold_and_win",
        name: "Football Fireblast Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/football_fortunes": {
        slug: "football_fortunes",
        name: "Football Fortunes",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/football_fortunes_hold_and_win": {
        slug: "football_fortunes_hold_and_win",
        name: "Football Fortunes Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/fruity_flip": {
        slug: "fruity_flip",
        name: "Fruity Flip",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/fruity_flip_super_roll": {
        slug: "fruity_flip_super_roll",
        name: "Fruity Flip Super Roll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/gem_spark_hold_and_win": {
        slug: "gem_spark_hold_and_win",
        name: "Gem Spark Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/gem_stone_odyssey": {
        slug: "gem_stone_odyssey",
        name: "Gem Stone Odyssey",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/gem_stone_odyssey_micromax": {
        slug: "gem_stone_odyssey_micromax",
        name: "Gem Stone Odyssey Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/gem_universe": {
        slug: "gem_universe",
        name: "Gem Universe",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/glory_blitz_hold_and_win": {
        slug: "glory_blitz_hold_and_win",
        name: "Glory Blitz Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/golden_king": {
        slug: "golden_king",
        name: "Golden King",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/golden_king_micromax": {
        slug: "golden_king_micromax",
        name: "Golden King Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/golden_skies_crash": {
        slug: "golden_skies_crash",
        name: "Golden Skies Crash",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/gong_fu_dragons_hold_and_win": {
        slug: "gong_fu_dragons_hold_and_win",
        name: "Gong Fu Dragons Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/griffin_guardians": {
        slug: "griffin_guardians",
        name: "Griffin Guardians",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/griffin_guardians_gamble_feature": {
        slug: "griffin_guardians_gamble_feature",
        name: "Griffin Guardians Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/griffin_guardians_xmas": {
        slug: "griffin_guardians_xmas",
        name: "Griffin Guardians Xmas",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/harmony_8s_hold_and_win": {
        slug: "harmony_8s_hold_and_win",
        name: "Harmony 8s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/hawaiian_holiday_7s": {
        slug: "hawaiian_holiday_7s",
        name: "Hawaiian Holiday 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/hawaiian_maxi_7s_hold_and_win": {
        slug: "hawaiian_maxi_7s_hold_and_win",
        name: "Hawaiian Maxi 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/hawkfire_wilds": {
        slug: "hawkfire_wilds",
        name: "Hawkfire Wilds",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/heartbeat_blitz": {
        slug: "heartbeat_blitz",
        name: "Heartbeat Blitz",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/hot_vegas": {
        slug: "hot_vegas",
        name: "Hot Vegas",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/hot_vegas_micromax": {
        slug: "hot_vegas_micromax",
        name: "Hot Vegas Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/jester_festive_7s": {
        slug: "jester_festive_7s",
        name: "Jester Festive 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/jewel_respins_hold_and_win": {
        slug: "jewel_respins_hold_and_win",
        name: "Jewel Respins Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_arcade": {
        slug: "joker_arcade",
        name: "Joker Arcade",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_bounty_chase": {
        slug: "joker_bounty_chase",
        name: "Joker Bounty Chase",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_bounty_chase_2": {
        slug: "joker_bounty_chase_2",
        name: "Joker Bounty Chase 2",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_cashpot_bonanza": {
        slug: "joker_cashpot_bonanza",
        name: "Joker Cashpot Bonanza",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_cashpot_dash": {
        slug: "joker_cashpot_dash",
        name: "Joker Cashpot Dash",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_electro_7s": {
        slug: "joker_electro_7s",
        name: "Joker Electro 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_hot_wins": {
        slug: "joker_hot_wins",
        name: "Joker Hot Wins",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_hot_wins_50k": {
        slug: "joker_hot_wins_50k",
        name: "Joker Hot Wins 50K",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_knights": {
        slug: "joker_knights",
        name: "Joker Knights",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_knights_xmas": {
        slug: "joker_knights_xmas",
        name: "Joker Knights Xmas",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_pursuit_7s": {
        slug: "joker_pursuit_7s",
        name: "Joker Pursuit 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_rayz": {
        slug: "joker_rayz",
        name: "Joker Rayz",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_respins": {
        slug: "joker_respins",
        name: "Joker Respins",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_respins_hold_and_win": {
        slug: "joker_respins_hold_and_win",
        name: "Joker Respins Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_shamrocks": {
        slug: "joker_shamrocks",
        name: "Joker Shamrocks",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_shamrocks_hold_and_win": {
        slug: "joker_shamrocks_hold_and_win",
        name: "Joker Shamrocks Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_shamrocks_super_roll": {
        slug: "joker_shamrocks_super_roll",
        name: "Joker Shamrocks Super Roll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_shock_7s": {
        slug: "joker_shock_7s",
        name: "Joker Shock 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_trophies_superroll": {
        slug: "joker_trophies_superroll",
        name: "Joker Trophies SuperRoll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_ultimate": {
        slug: "joker_ultimate",
        name: "Joker Ultimate",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/joker_ultimate_xmas": {
        slug: "joker_ultimate_xmas",
        name: "Joker Ultimate Xmas",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/katanas_vs_kartels": {
        slug: "katanas_vs_kartels",
        name: "Katanas vs Kartels",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/katanas_vs_kartels_2": {
        slug: "katanas_vs_kartels_2",
        name: "Katanas vs Kartels 2",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/koban_kitty_7s": {
        slug: "koban_kitty_7s",
        name: "Koban Kitty 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/legend_of_maya": {
        slug: "legend_of_maya",
        name: "Legend of Maya",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lions_reign": {
        slug: "lions_reign",
        name: "Lion’s Reign",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lions_reign_superroll": {
        slug: "lions_reign_superroll",
        name: "Lion’s Reign: SuperRoll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lost_diamond": {
        slug: "lost_diamond",
        name: "Lost Diamond",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lucky_777_respins": {
        slug: "lucky_777_respins",
        name: "Lucky 777 Respins",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lucky_cashpot_7s": {
        slug: "lucky_cashpot_7s",
        name: "Lucky Cashpot 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lucky_cashpot_7s_xmas_edition": {
        slug: "lucky_cashpot_7s_xmas_edition",
        name: "Lucky Cashpot 7s Xmas Edition",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lucky_hare_7s": {
        slug: "lucky_hare_7s",
        name: "Lucky Hare 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lunar_snake_hold_and_win": {
        slug: "lunar_snake_hold_and_win",
        name: "Lunar Snake Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/lunar_steeds_hold_and_win": {
        slug: "lunar_steeds_hold_and_win",
        name: "Lunar Steeds Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mango_flip_7s": {
        slug: "mango_flip_7s",
        name: "Mango Flip 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/marine_millions_hold_and_win": {
        slug: "marine_millions_hold_and_win",
        name: "Marine Millions Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mastodon_money": {
        slug: "mastodon_money",
        name: "Mastodon Money",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mastodon_money_easter_edition": {
        slug: "mastodon_money_easter_edition",
        name: "Mastodon Money Easter Edition",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mega_joker": {
        slug: "mega_joker",
        name: "Mega Joker",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mega_joker_gamble_feature": {
        slug: "mega_joker_gamble_feature",
        name: "Mega Joker Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mega_joker_super_roll_xmas_edition": {
        slug: "mega_joker_super_roll_xmas_edition",
        name: "Mega Joker Super Roll X-mas Edition",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mega_joker_superroll": {
        slug: "mega_joker_superroll",
        name: "Mega Joker: SuperRoll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/merchants_of_menace": {
        slug: "merchants_of_menace",
        name: "Merchants of Menace",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/merchants_of_menace_superroll": {
        slug: "merchants_of_menace_superroll",
        name: "Merchants of Menace: SuperRoll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/merry_multi_7s_hold_and_win": {
        slug: "merry_multi_7s_hold_and_win",
        name: "Merry Multi 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/milkyway_mayhem": {
        slug: "milkyway_mayhem",
        name: "Milkyway Mayhem",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mission_jewel_heist": {
        slug: "mission_jewel_heist",
        name: "Mission Jewel Heist",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mission_jewel_heist_gamble_feature": {
        slug: "mission_jewel_heist_gamble_feature",
        name: "Mission Jewel Heist Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/mission_jewel_heist_micromax": {
        slug: "mission_jewel_heist_micromax",
        name: "Mission Jewel Heist Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/money_forge_7s_hold_and_win": {
        slug: "money_forge_7s_hold_and_win",
        name: "Money Forge 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/monster_wilds": {
        slug: "monster_wilds",
        name: "Monster Wilds",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/moon_dragons_hold_and_win": {
        slug: "moon_dragons_hold_and_win",
        name: "Moon Dragons Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/moonhowl_towerhits": {
        slug: "moonhowl_towerhits",
        name: "MoonHowl TowerHits",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/moonlight_millions_hold_and_win": {
        slug: "moonlight_millions_hold_and_win",
        name: "Moonlight Millions Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/moonrise_fireworks_hold_and_win": {
        slug: "moonrise_fireworks_hold_and_win",
        name: "Moonrise Fireworks Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/omniblitz_7s_hold_and_win": {
        slug: "omniblitz_7s_hold_and_win",
        name: "OmniBlitz 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/omniblitz_7s_maxi_hold_and_win": {
        slug: "omniblitz_7s_maxi_hold_and_win",
        name: "OmniBlitz 7s Maxi Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/paradise_gem_7s_hold_and_win": {
        slug: "paradise_gem_7s_hold_and_win",
        name: "Paradise Gem 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/party_fiesta_7s": {
        slug: "party_fiesta_7s",
        name: "Party Fiesta 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/patricks_sea_stash_hold_and_win": {
        slug: "patricks_sea_stash_hold_and_win",
        name: "Patrick’s Sea Stash Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pele_fire": {
        slug: "pele_fire",
        name: "Pele Fire",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pele_fire_micromax": {
        slug: "pele_fire_micromax",
        name: "Pele Fire Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pepper_maxi_7s_hold_and_win": {
        slug: "pepper_maxi_7s_hold_and_win",
        name: "Pepper Maxi 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pharaoh_frenzy_hold_and_win": {
        slug: "pharaoh_frenzy_hold_and_win",
        name: "Pharaoh Frenzy Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/piggy_bank_chase_hold_and_win": {
        slug: "piggy_bank_chase_hold_and_win",
        name: "Piggy Bank Chase Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/piggymid_treasure": {
        slug: "piggymid_treasure",
        name: "Piggymid Treasure",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pinata_sparkles": {
        slug: "pinata_sparkles",
        name: "Pinata Sparkles",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pumpkin_joker_hold_and_win": {
        slug: "pumpkin_joker_hold_and_win",
        name: "Pumpkin Joker Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pyro_blast_7s_hold_and_win": {
        slug: "pyro_blast_7s_hold_and_win",
        name: "Pyro Blast 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pyro_canyon_7s_hold_and_win": {
        slug: "pyro_canyon_7s_hold_and_win",
        name: "Pyro Canyon 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pyro_canyon_xmas_hold_and_win": {
        slug: "pyro_canyon_xmas_hold_and_win",
        name: "Pyro Canyon Xmas Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/pyro_maxi_7s_hold_and_win": {
        slug: "pyro_maxi_7s_hold_and_win",
        name: "Pyro Maxi 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/qinglong_legends": {
        slug: "qinglong_legends",
        name: "Qinglong Legends",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/quackpot_cash": {
        slug: "quackpot_cash",
        name: "Quackpot Cash",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/quarterback_fortune_hold_and_win": {
        slug: "quarterback_fortune_hold_and_win",
        name: "Quarterback Fortune Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/rabbit_riches": {
        slug: "rabbit_riches",
        name: "Rabbit Riches",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/rich_craft": {
        slug: "rich_craft",
        name: "Rich Craft",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/rodent_riot": {
        slug: "rodent_riot",
        name: "Rodent Riot",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/rodent_riot_hold_and_win": {
        slug: "rodent_riot_hold_and_win",
        name: "Rodent Riot Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/royal_majesty_7s_hold_and_win": {
        slug: "royal_majesty_7s_hold_and_win",
        name: "Royal Majesty 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/ruby_riches": {
        slug: "ruby_riches",
        name: "Ruby Riches",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/santa_bounty_hold_and_win": {
        slug: "santa_bounty_hold_and_win",
        name: "Santa Bounty Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/saturns_treasure": {
        slug: "saturns_treasure",
        name: "Saturn’s Treasure",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/saturns_treasure_hold_and_win": {
        slug: "saturns_treasure_hold_and_win",
        name: "Saturn’s Treasure Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/scarab_storm_gold_hunt": {
        slug: "scarab_storm_gold_hunt",
        name: "Scarab Storm Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/scarlet_diamonds_hold_and_win": {
        slug: "scarlet_diamonds_hold_and_win",
        name: "Scarlet Diamonds Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/seamaid_pearls": {
        slug: "seamaid_pearls",
        name: "Seamaid Pearls",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/serene_dragons_hold_and_win": {
        slug: "serene_dragons_hold_and_win",
        name: "Serene Dragons Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shamrock_max_hold_and_win": {
        slug: "shamrock_max_hold_and_win",
        name: "Shamrock Max Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shamrock_stampede_gold_hunt": {
        slug: "shamrock_stampede_gold_hunt",
        name: "Shamrock Stampede Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shamrock_twist_7s_hold_and_win": {
        slug: "shamrock_twist_7s_hold_and_win",
        name: "Shamrock Twist 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shark_strike": {
        slug: "shark_strike",
        name: "Shark Strike",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shining_bounty_7s": {
        slug: "shining_bounty_7s",
        name: "Shining Bounty 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/shockray7s": {
        slug: "shockray7s",
        name: "Shockray7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/skull_riches_hold_and_win": {
        slug: "skull_riches_hold_and_win",
        name: "Skull Riches Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/sneaky_scoundrelz": {
        slug: "sneaky_scoundrelz",
        name: "Sneaky Scoundrelz",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/solo_deluxe_hold_and_win": {
        slug: "solo_deluxe_hold_and_win",
        name: "Solo Deluxe Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/space_hencounter": {
        slug: "space_hencounter",
        name: "Space Hencounter",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/sparkle_bells_7s": {
        slug: "sparkle_bells_7s",
        name: "Sparkle Bells 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/sparkle_stream_7s": {
        slug: "sparkle_stream_7s",
        name: "Sparkle Stream 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/spooky_jokers": {
        slug: "spooky_jokers",
        name: "Spooky Jokers",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/spooky_jokers_hold_and_win": {
        slug: "spooky_jokers_hold_and_win",
        name: "Spooky Jokers Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/spooky_jokers_superroll": {
        slug: "spooky_jokers_superroll",
        name: "Spooky Jokers SuperRoll",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/star_glitter_7s": {
        slug: "star_glitter_7s",
        name: "Star Glitter 7s",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/star_light_temple": {
        slug: "star_light_temple",
        name: "Star Light Temple",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/steam_pirates": {
        slug: "steam_pirates",
        name: "Steam Pirates",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/steam_pirates_gamble_feature": {
        slug: "steam_pirates_gamble_feature",
        name: "Steam Pirates Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/super_scarabs": {
        slug: "super_scarabs",
        name: "Super Scarabs",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/super_scarabs_micromax": {
        slug: "super_scarabs_micromax",
        name: "Super Scarabs Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/swing_city_boost": {
        slug: "swing_city_boost",
        name: "Swing City Boost",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/tails_of_rostam": {
        slug: "tails_of_rostam",
        name: "Tails of Rostam",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/techno_lab": {
        slug: "techno_lab",
        name: "Techno Lab",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/tenoch_tribe_gold_hunt": {
        slug: "tenoch_tribe_gold_hunt",
        name: "Tenoch Tribe Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/tessa_tempest": {
        slug: "tessa_tempest",
        name: "Tessa Tempest",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/titan_guardian": {
        slug: "titan_guardian",
        name: "Titan Guardian",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/tome_of_the_ancestors_gold_hunt": {
        slug: "tome_of_the_ancestors_gold_hunt",
        name: "Tome of the Ancestors Gold Hunt",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/trex_safari": {
        slug: "trex_safari",
        name: "Trex Safari",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/triple_trick_clover_hold_and_win": {
        slug: "triple_trick_clover_hold_and_win",
        name: "Triple Trick Clover Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/triple_trick_piggies_hold_and_win": {
        slug: "triple_trick_piggies_hold_and_win",
        name: "Triple Trick Piggies Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/ultrafruit_patternz": {
        slug: "ultrafruit_patternz",
        name: "Ultrafruit: Patternz",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/undead_riches": {
        slug: "undead_riches",
        name: "Undead Riches",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/undead_riches_gamble_feature": {
        slug: "undead_riches_gamble_feature",
        name: "Undead Riches Gamble Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/under_seariches": {
        slug: "under_seariches",
        name: "Under Seariches",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/undersea_riches_st_patricks_edition": {
        slug: "undersea_riches_st_patricks_edition",
        name: "Undersea Riches St Patrick’s Edition",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/waikiki_wonder": {
        slug: "waikiki_wonder",
        name: "Waikiki Wonder",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wild_gates": {
        slug: "wild_gates",
        name: "Wild Gates",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wild_gates_micromax": {
        slug: "wild_gates_micromax",
        name: "Wild Gates Micro-Max",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wild_phoenix": {
        slug: "wild_phoenix",
        name: "Wild Phoenix",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wild_spectres": {
        slug: "wild_spectres",
        name: "Wild Spectres",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wonder_eagle_7s_hold_and_win": {
        slug: "wonder_eagle_7s_hold_and_win",
        name: "Wonder Eagle 7s Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wukongs_gold": {
        slug: "wukongs_gold",
        name: "Wukongs Gold",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/wukongs_gold_buy_feature": {
        slug: "wukongs_gold_buy_feature",
        name: "Wukongs Gold Buy Feature",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/xmas_diamonds_hold_and_win": {
        slug: "xmas_diamonds_hold_and_win",
        name: "Xmas Diamonds Hold and Win",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/yiao_gianshu": {
        slug: "yiao_gianshu",
        name: "Yiao Gianshu",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/zhaogongming": {
        slug: "zhaogongming",
        name: "Zhaogongming",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/zombie_shootout_bonanza": {
        slug: "zombie_shootout_bonanza",
        name: "Zombie Shootout Bonanza",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "flatdog/zombie_shootout_bonanza_boomboom": {
        slug: "zombie_shootout_bonanza_boomboom",
        name: "Zombie Shootout Bonanza BoomBoom",
        provider: "Flatdog",
        providerSlug: "flatdog"
    },
    "fomo-originals/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/coin_flip": {
        slug: "coin_flip",
        name: "Coin Flip",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/craps": {
        slug: "craps",
        name: "Craps",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/crash": {
        slug: "crash",
        name: "Crash",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/cross_the_lake": {
        slug: "cross_the_lake",
        name: "Cross The Lake",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/cross_the_road": {
        slug: "cross_the_road",
        name: "Cross the Road",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/diamonds": {
        slug: "diamonds",
        name: "Diamonds",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/dice": {
        slug: "dice",
        name: "Dice",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/dice_pro": {
        slug: "dice_pro",
        name: "Dice Pro",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/dragons_tower": {
        slug: "dragons_tower",
        name: "Dragon's Tower",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/hilo": {
        slug: "hilo",
        name: "Hilo",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/keno": {
        slug: "keno",
        name: "Keno",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/limbo": {
        slug: "limbo",
        name: "Limbo",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/maxwin": {
        slug: "maxwin",
        name: "MaxWin",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/multihand_blackjack": {
        slug: "multihand_blackjack",
        name: "Multi-Hand Blackjack",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/slider": {
        slug: "slider",
        name: "Slider",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/taptrader": {
        slug: "taptrader",
        name: "TapTrader",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/traffic_jam": {
        slug: "traffic_jam",
        name: "Traffic Jam",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/video_poker": {
        slug: "video_poker",
        name: "Video Poker",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "fomo-originals/wheel": {
        slug: "wheel",
        name: "Wheel",
        provider: "Fomo Originals",
        providerSlug: "fomo-originals"
    },
    "four-leaf-gaming/bloodaxe": {
        slug: "bloodaxe",
        name: "Bloodaxe",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/buffalo_blow": {
        slug: "buffalo_blow",
        name: "Buffalo Blow",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/clover_fortunes": {
        slug: "clover_fortunes",
        name: "Clover Fortunes",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/cosmic_rush_hyper_hitz": {
        slug: "cosmic_rush_hyper_hitz",
        name: "Cosmic Rush: Hyper Hitz",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/curse_of_ra": {
        slug: "curse_of_ra",
        name: "Curse of Ra",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/cyber_vault": {
        slug: "cyber_vault",
        name: "Cyber Vault",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/everest": {
        slug: "everest",
        name: "Everest",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/gold_rush_frenzy_megaways": {
        slug: "gold_rush_frenzy_megaways",
        name: "Gold Rush Frenzy Megaways",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/killer_sharks": {
        slug: "killer_sharks",
        name: "Killer Sharks",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/pickaxe_payday_action_collect_dream_drop": {
        slug: "pickaxe_payday_action_collect_dream_drop",
        name: "Pickaxe Payday Action Collect Dream Drop",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/temple_rush": {
        slug: "temple_rush",
        name: "Temple Rush",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/the_3_bears": {
        slug: "the_3_bears",
        name: "The 3 Bears",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/wild_buccaneers_megaways": {
        slug: "wild_buccaneers_megaways",
        name: "Wild Buccaneers MegaWays",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "four-leaf-gaming/wild_buccaneers_triple_treasure": {
        slug: "wild_buccaneers_triple_treasure",
        name: "Wild Buccaneers Triple Treasure",
        provider: "Four Leaf Gaming",
        providerSlug: "four-leaf-gaming"
    },
    "funkygames/3_combo_bombs": {
        slug: "3_combo_bombs",
        name: "3 Combo Bombs",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/3_combo_olympus": {
        slug: "3_combo_olympus",
        name: "3 Combo Olympus",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/3_combo_piggy": {
        slug: "3_combo_piggy",
        name: "3 Combo Piggy",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/7_up_down": {
        slug: "7_up_down",
        name: "7 Up Down",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/777_blazing_2_bonus_strike": {
        slug: "777_blazing_2_bonus_strike",
        name: "777 Blazing 2 Bonus Strike",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/777_blazing_classic": {
        slug: "777_blazing_classic",
        name: "777 Blazing Classic",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/777_blazing_hold_and_win": {
        slug: "777_blazing_hold_and_win",
        name: "777 Blazing Hold and Win",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/aloha_fruit_punch": {
        slug: "aloha_fruit_punch",
        name: "Aloha Fruit Punch",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/aloha_fruityways_megaways": {
        slug: "aloha_fruityways_megaways",
        name: "Aloha! Fruityways Megaways",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/aztec_fortune_megaways": {
        slug: "aztec_fortune_megaways",
        name: "Aztec Fortune Megaways",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/aztec_plinko": {
        slug: "aztec_plinko",
        name: "Aztec Plinko",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/baccarat_babes": {
        slug: "baccarat_babes",
        name: "Baccarat Babes",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/baccarat_vvip": {
        slug: "baccarat_vvip",
        name: "Baccarat VVIP",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/basketball_strike": {
        slug: "basketball_strike",
        name: "Basketball Strike",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/bau_cua": {
        slug: "bau_cua",
        name: "Bau Cua",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/belangkai": {
        slug: "belangkai",
        name: "Belangkai",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/big_bang_boxing": {
        slug: "big_bang_boxing",
        name: "Big Bang Boxing",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/buffalo_rage": {
        slug: "buffalo_rage",
        name: "Buffalo Rage",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/buffalo_splash": {
        slug: "buffalo_splash",
        name: "Buffalo Splash",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/caishenbaoxi": {
        slug: "caishenbaoxi",
        name: "CaiShenBaoXi",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/caribbean_saga": {
        slug: "caribbean_saga",
        name: "Caribbean Saga",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/cash_booster": {
        slug: "cash_booster",
        name: "Cash Booster",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/cash_or_crash": {
        slug: "cash_or_crash",
        name: "Cash or Crash",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/cash_or_crash_2": {
        slug: "cash_or_crash_2",
        name: "Cash or Crash 2",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/chicken_love": {
        slug: "chicken_love",
        name: "Chicken Love",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/clover_brew": {
        slug: "clover_brew",
        name: "Clover Brew",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/clover_coin_combo": {
        slug: "clover_coin_combo",
        name: "Clover Coin Combo",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/easter_run": {
        slug: "easter_run",
        name: "Easter Run",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/fantan": {
        slug: "fantan",
        name: "FanTan",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/fish_prawn_crab": {
        slug: "fish_prawn_crab",
        name: "Fish Prawn Crab",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/football_fever": {
        slug: "football_fever",
        name: "Football Fever",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/football_mines": {
        slug: "football_mines",
        name: "Football Mines",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/football_strike": {
        slug: "football_strike",
        name: "Football Strike",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/fortune_tree_wild": {
        slug: "fortune_tree_wild",
        name: "Fortune Tree Wild",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/gems_of_zeus": {
        slug: "gems_of_zeus",
        name: "Gems of Zeus",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/golden_koi_rise": {
        slug: "golden_koi_rise",
        name: "Golden Koi Rise",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/golden_mahjong_deluxe": {
        slug: "golden_mahjong_deluxe",
        name: "Golden Mahjong Deluxe",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/happy_hour_fruit_slot": {
        slug: "happy_hour_fruit_slot",
        name: "Happy Hour Fruit Slot",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/haunted_spirit": {
        slug: "haunted_spirit",
        name: "Haunted Spirit",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/jogo_do_bicho": {
        slug: "jogo_do_bicho",
        name: "Jogo Do Bicho",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/landing_chicken": {
        slug: "landing_chicken",
        name: "Landing Chicken",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/limbo_football": {
        slug: "limbo_football",
        name: "Limbo Football",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/lucky_lanterns": {
        slug: "lucky_lanterns",
        name: "Lucky Lanterns",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/lucky_wheel": {
        slug: "lucky_wheel",
        name: "Lucky Wheel",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/meow_hilo": {
        slug: "meow_hilo",
        name: "Meow HiLo",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/midnight_robbery": {
        slug: "midnight_robbery",
        name: "Midnight Robbery",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/mines_or_cash": {
        slug: "mines_or_cash",
        name: "Mines or Cash",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/mines_or_gifts": {
        slug: "mines_or_gifts",
        name: "Mines or Gifts",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/mines_or_treat": {
        slug: "mines_or_treat",
        name: "Mines or Treat",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/odds_hi_lo": {
        slug: "odds_hi_lo",
        name: "Odds Hi Lo",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/outlaw_trails": {
        slug: "outlaw_trails",
        name: "Outlaw Trails",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/plinko_mega_win": {
        slug: "plinko_mega_win",
        name: "Plinko Mega Win",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/plinko_ufo": {
        slug: "plinko_ufo",
        name: "Plinko UFO",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/plinkos": {
        slug: "plinkos",
        name: "PlinkoS",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/poseidon_777": {
        slug: "poseidon_777",
        name: "Poseidon 777",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/rage_of_olympus": {
        slug: "rage_of_olympus",
        name: "Rage Of Olympus",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/rizmu_boys": {
        slug: "rizmu_boys",
        name: "Rizmu Boys",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/roma_reborn": {
        slug: "roma_reborn",
        name: "Roma Reborn",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/roulette_vvip": {
        slug: "roulette_vvip",
        name: "Roulette VVIP",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/royal_ace": {
        slug: "royal_ace",
        name: "Royal Ace",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/royal_tiger_baccarat": {
        slug: "royal_tiger_baccarat",
        name: "Royal Tiger Baccarat",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/sexy_blink": {
        slug: "sexy_blink",
        name: "Sexy Blink",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/sparta2": {
        slug: "sparta2",
        name: "Sparta2",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/speed_blackjack": {
        slug: "speed_blackjack",
        name: "Speed Blackjack",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/speed_lotto": {
        slug: "speed_lotto",
        name: "Speed Lotto",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/sugar_high": {
        slug: "sugar_high",
        name: "Sugar High",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/sweet_bombs": {
        slug: "sweet_bombs",
        name: "Sweet Bombs",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/tai_xiu": {
        slug: "tai_xiu",
        name: "Tai Xiu",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/thai_hilo": {
        slug: "thai_hilo",
        name: "Thai HiLo",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/three_brave_piggies": {
        slug: "three_brave_piggies",
        name: "Three Brave Piggies",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/thunder_blackjack": {
        slug: "thunder_blackjack",
        name: "Thunder Blackjack",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/thunder_dice": {
        slug: "thunder_dice",
        name: "Thunder Dice",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/treasure_dragon": {
        slug: "treasure_dragon",
        name: "Treasure Dragon",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_baccarat": {
        slug: "virtual_baccarat",
        name: "Virtual Baccarat",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_dominoqq": {
        slug: "virtual_dominoqq",
        name: "Virtual DominoQQ",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_dragon_bonus_baccarat": {
        slug: "virtual_dragon_bonus_baccarat",
        name: "Virtual Dragon Bonus Baccarat",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_roulette": {
        slug: "virtual_roulette",
        name: "Virtual Roulette",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_sicbo": {
        slug: "virtual_sicbo",
        name: "Virtual SicBo",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "funkygames/virtual_tiger_baccarat": {
        slug: "virtual_tiger_baccarat",
        name: "Virtual Tiger Baccarat",
        provider: "Funkygames",
        providerSlug: "funkygames"
    },
    "galaxsys/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/atlantis": {
        slug: "atlantis",
        name: "Atlantis",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/aviabom": {
        slug: "aviabom",
        name: "Aviabom",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/aviashow": {
        slug: "aviashow",
        name: "Aviashow",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/bee_infinity": {
        slug: "bee_infinity",
        name: "Bee Infinity",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/bingo_star": {
        slug: "bingo_star",
        name: "Bingo Star",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/cash_show": {
        slug: "cash_show",
        name: "Cash Show",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/chicken_crash": {
        slug: "chicken_crash",
        name: "Chicken Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/coin_flip": {
        slug: "coin_flip",
        name: "Coin Flip",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/coin_rush": {
        slug: "coin_rush",
        name: "Coin Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/cosmo_saga": {
        slug: "cosmo_saga",
        name: "Cosmo Saga",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/crash": {
        slug: "crash",
        name: "Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/crasher": {
        slug: "crasher",
        name: "Crasher",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/deep_sea_wild": {
        slug: "deep_sea_wild",
        name: "Deep Sea Wild",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/dr_shocker": {
        slug: "dr_shocker",
        name: "Dr. Shocker",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/egyptian_legends": {
        slug: "egyptian_legends",
        name: "Egyptian Legends",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/el_dorado": {
        slug: "el_dorado",
        name: "El Dorado",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/figoal": {
        slug: "figoal",
        name: "Figoal",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/fmines": {
        slug: "fmines",
        name: "Fmines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/fruity_lines": {
        slug: "fruity_lines",
        name: "Fruity Lines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/fruity_wilds": {
        slug: "fruity_wilds",
        name: "Fruity Wilds",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/funny_faces_hoglet_moglet": {
        slug: "funny_faces_hoglet_moglet",
        name: "Funny Faces Hoglet Moglet",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/gangsta_piggy_hold_and_win": {
        slug: "gangsta_piggy_hold_and_win",
        name: "Gangsta Piggy Hold and Win",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/gates_of_asgard_nine_realms": {
        slug: "gates_of_asgard_nine_realms",
        name: "Gates of Asgard Nine Realms",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/golden_ra": {
        slug: "golden_ra",
        name: "Golden Ra",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/guardians_of_glory": {
        slug: "guardians_of_glory",
        name: "Guardians of Glory",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hamster_mania": {
        slug: "hamster_mania",
        name: "Hamster Mania",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/handigo": {
        slug: "handigo",
        name: "Handigo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hilo": {
        slug: "hilo",
        name: "Hilo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hot_gear": {
        slug: "hot_gear",
        name: "Hot Gear",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/hungry_wolf": {
        slug: "hungry_wolf",
        name: "Hungry Wolf",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/infinity": {
        slug: "infinity",
        name: "Infinity",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/instawin": {
        slug: "instawin",
        name: "Instawin",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/jungle_wheel": {
        slug: "jungle_wheel",
        name: "Jungle Wheel",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_10_1_minute": {
        slug: "keno_10_1_minute",
        name: "Keno 10 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_10_2_minutes": {
        slug: "keno_10_2_minutes",
        name: "Keno 10 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_8_1_minute": {
        slug: "keno_8_1_minute",
        name: "Keno 8 1 Minute",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_8_2_minutes": {
        slug: "keno_8_2_minutes",
        name: "Keno 8 2 Minutes",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/keno_express": {
        slug: "keno_express",
        name: "Keno Express",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/king_of_ocean": {
        slug: "king_of_ocean",
        name: "King of Ocean",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/knife_drop": {
        slug: "knife_drop",
        name: "Knife Drop",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/limbo_crash": {
        slug: "limbo_crash",
        name: "Limbo Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/lottoboom": {
        slug: "lottoboom",
        name: "LottoBoom",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/maestro": {
        slug: "maestro",
        name: "Maestro",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/magic_dice": {
        slug: "magic_dice",
        name: "Magic Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/mr_thimble": {
        slug: "mr_thimble",
        name: "Mr Thimble",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/ninja_crash": {
        slug: "ninja_crash",
        name: "Ninja Crash",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/olympian_legends": {
        slug: "olympian_legends",
        name: "Olympian Legends",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/penalty": {
        slug: "penalty",
        name: "Penalty",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/play_me": {
        slug: "play_me",
        name: "Play Me",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/plinko_dice": {
        slug: "plinko_dice",
        name: "Plinko Dice",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/plinkoman": {
        slug: "plinkoman",
        name: "Plinkoman",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/rise_of_frogs_book_of_legacy": {
        slug: "rise_of_frogs_book_of_legacy",
        name: "Rise of Frogs: Book of Legacy",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/rocketon": {
        slug: "rocketon",
        name: "Rocketon",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/roulette_x": {
        slug: "roulette_x",
        name: "Roulette X",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/scratch_map": {
        slug: "scratch_map",
        name: "Scratch Map",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/sicbo": {
        slug: "sicbo",
        name: "SicBo",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/slap_shot": {
        slug: "slap_shot",
        name: "Slap Shot",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/starlight": {
        slug: "starlight",
        name: "Starlight",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/totem": {
        slug: "totem",
        name: "Totem",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/tower_rush": {
        slug: "tower_rush",
        name: "Tower Rush",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "galaxsys/turbo_mines": {
        slug: "turbo_mines",
        name: "Turbo Mines",
        provider: "Galaxsys",
        providerSlug: "galaxsys"
    },
    "gameart/10_lucky_sevens": {
        slug: "10_lucky_sevens",
        name: "10 Lucky Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/100_lucky_sevens": {
        slug: "100_lucky_sevens",
        name: "100 Lucky Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/20_brilliant_hot": {
        slug: "20_brilliant_hot",
        name: "20 Brilliant Hot",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/20_hot_fruit_delights": {
        slug: "20_hot_fruit_delights",
        name: "20 Hot Fruit Delights",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/20_hot_super_fruits": {
        slug: "20_hot_super_fruits",
        name: "20 Hot Super Fruits",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/20_super_sevens": {
        slug: "20_super_sevens",
        name: "20 Super Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/3_headed_dragon": {
        slug: "3_headed_dragon",
        name: "3 Headed Dragon",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/40_lucky_sevens": {
        slug: "40_lucky_sevens",
        name: "40 Lucky Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/40_splendid_sevens": {
        slug: "40_splendid_sevens",
        name: "40 Splendid Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/40_super_blazing_sevens": {
        slug: "40_super_blazing_sevens",
        name: "40 Super Blazing Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/40_super_heated_sevens": {
        slug: "40_super_heated_sevens",
        name: "40 Super Heated Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/40_super_heated_sevens_dice": {
        slug: "40_super_heated_sevens_dice",
        name: "40 Super Heated Sevens Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/5_lucky_sevens": {
        slug: "5_lucky_sevens",
        name: "5 Lucky Sevens",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/7s_and_diamonds": {
        slug: "7s_and_diamonds",
        name: "7s and Diamonds",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/7s_fury_20": {
        slug: "7s_fury_20",
        name: "7s Fury 20",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/7s_fury_40": {
        slug: "7s_fury_40",
        name: "7s Fury 40",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/88_riches": {
        slug: "88_riches",
        name: "88 Riches",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/african_sunset": {
        slug: "african_sunset",
        name: "African Sunset",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/african_sunset_2": {
        slug: "african_sunset_2",
        name: "African Sunset 2",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/aladdins_quest": {
        slug: "aladdins_quest",
        name: "Aladdin's Quest",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/ali_babas_riches": {
        slug: "ali_babas_riches",
        name: "Ali Baba's Riches",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/ancient_gong": {
        slug: "ancient_gong",
        name: "Ancient Gong",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/angry_dogs": {
        slug: "angry_dogs",
        name: "Angry Dogs",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/angry_dragons": {
        slug: "angry_dragons",
        name: "Angry Dragons",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/apocalypse_quest": {
        slug: "apocalypse_quest",
        name: "Apocalypse Quest",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/atlantis_world": {
        slug: "atlantis_world",
        name: "Atlantis World",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/awesome_7s": {
        slug: "awesome_7s",
        name: "Awesome 7s",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/azrabah_wishes": {
        slug: "azrabah_wishes",
        name: "Azrabah Wishes",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/backstreet_mayhem": {
        slug: "backstreet_mayhem",
        name: "Backstreet Mayhem",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/battle_for_atlantis": {
        slug: "battle_for_atlantis",
        name: "Battle for Atlantis",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/big_fruit_show": {
        slug: "big_fruit_show",
        name: "Big Fruit Show",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/big_snapper": {
        slug: "big_snapper",
        name: "Big Snapper",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/bit_vault": {
        slug: "bit_vault",
        name: "Bit Vault",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/blackjack_gold": {
        slug: "blackjack_gold",
        name: "Blackjack Gold",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/blackjack_multipliers": {
        slug: "blackjack_multipliers",
        name: "Blackjack Multipliers",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/blackjack_side_bets": {
        slug: "blackjack_side_bets",
        name: "Blackjack - Side Bets",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/book_of_cupigs": {
        slug: "book_of_cupigs",
        name: "Book of Cupigs",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/book_of_museum": {
        slug: "book_of_museum",
        name: "Book of Museum",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/book_of_oziris": {
        slug: "book_of_oziris",
        name: "Book of Oziris",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/broken_ballerina": {
        slug: "broken_ballerina",
        name: "Broken Ballerina",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/bubble_fruits": {
        slug: "bubble_fruits",
        name: "Bubble Fruits",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/buffalo_sunset": {
        slug: "buffalo_sunset",
        name: "Buffalo Sunset",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/buffaloes_duel": {
        slug: "buffaloes_duel",
        name: "Buffaloes Duel",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/bursting_crowns_5": {
        slug: "bursting_crowns_5",
        name: "Bursting Crowns 5",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/caligula": {
        slug: "caligula",
        name: "Caligula",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/candy_treats": {
        slug: "candy_treats",
        name: "Candy Treats",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/candy_trouble": {
        slug: "candy_trouble",
        name: "Candy Trouble",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/caribbean_stud_poker": {
        slug: "caribbean_stud_poker",
        name: "Caribbean Stud Poker",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/carnival_x": {
        slug: "carnival_x",
        name: "Carnival X",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/castle_blood": {
        slug: "castle_blood",
        name: "Castle Blood",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/chili_quest": {
        slug: "chili_quest",
        name: "Chili Quest",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/chinese_zodiac": {
        slug: "chinese_zodiac",
        name: "Chinese Zodiac",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/circus_of_horror": {
        slug: "circus_of_horror",
        name: "Circus of Horror",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/cleopatra": {
        slug: "cleopatra",
        name: "Cleopatra",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/clover_goes_wild": {
        slug: "clover_goes_wild",
        name: "Clover Goes Wild",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dancing_lions": {
        slug: "dancing_lions",
        name: "Dancing Lions",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dawn_of_olympus": {
        slug: "dawn_of_olympus",
        name: "Dawn of Olympus",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dead_mouse_adventures": {
        slug: "dead_mouse_adventures",
        name: "Dead Mouse Adventures",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/diamond_magic": {
        slug: "diamond_magic",
        name: "Diamond Magic",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/diamond_magic_deluxe": {
        slug: "diamond_magic_deluxe",
        name: "Diamond Magic Deluxe",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/diamond_magic_dice": {
        slug: "diamond_magic_dice",
        name: "Diamond Magic Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dolphins_dream": {
        slug: "dolphins_dream",
        name: "Dolphin's Dream",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dragon_king": {
        slug: "dragon_king",
        name: "Dragon King",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dragon_king_megaways": {
        slug: "dragon_king_megaways",
        name: "Dragon King Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dragon_lady": {
        slug: "dragon_lady",
        name: "Dragon Lady",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dragon_whisperer": {
        slug: "dragon_whisperer",
        name: "Dragon Whisperer",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dynamite_fruits": {
        slug: "dynamite_fruits",
        name: "Dynamite Fruits",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/dynamite_fruits_deluxe": {
        slug: "dynamite_fruits_deluxe",
        name: "Dynamite Fruits Deluxe",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/emperors_wealth": {
        slug: "emperors_wealth",
        name: "Emperors Wealth",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/empire_of_wealth": {
        slug: "empire_of_wealth",
        name: "Empire of Wealth",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/european_roulette": {
        slug: "european_roulette",
        name: "European roulette",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/fates_fury": {
        slug: "fates_fury",
        name: "Fate's Fury",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/fortune_maiden": {
        slug: "fortune_maiden",
        name: "Fortune Maiden",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/frozen_joker": {
        slug: "frozen_joker",
        name: "Frozen Joker",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/gems_elevator": {
        slug: "gems_elevator",
        name: "Gems Elevator",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/gladiator": {
        slug: "gladiator",
        name: "Gladiator+",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/gold_goal_plinko": {
        slug: "gold_goal_plinko",
        name: "Gold Goal Plinko",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/gold_of_ra": {
        slug: "gold_of_ra",
        name: "Gold Of Ra",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/golden_dragon": {
        slug: "golden_dragon",
        name: "Golden Dragon",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/golden_furong": {
        slug: "golden_furong",
        name: "Golden Furong",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/great_buffalo_holdn_win": {
        slug: "great_buffalo_holdn_win",
        name: "Great Buffalo Hold'n Win",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/great_buffalo_megaways": {
        slug: "great_buffalo_megaways",
        name: "Great Buffalo Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/greek_pantheon_megaways": {
        slug: "greek_pantheon_megaways",
        name: "Greek Pantheon Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/halloween_farm": {
        slug: "halloween_farm",
        name: "Halloween Farm",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/hawaiian_christmas": {
        slug: "hawaiian_christmas",
        name: "Hawaiian Christmas",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/hollywoof": {
        slug: "hollywoof",
        name: "Hollywoof",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/hot_fruit_delights": {
        slug: "hot_fruit_delights",
        name: "Hot Fruit Delights",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/hot_glowing_fruits": {
        slug: "hot_glowing_fruits",
        name: "Hot Glowing Fruits",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/jaguar_riches": {
        slug: "jaguar_riches",
        name: "Jaguar Riches",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/jazz_jam_jackpots": {
        slug: "jazz_jam_jackpots",
        name: "Jazz Jam Jackpots",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/jingle_jokers": {
        slug: "jingle_jokers",
        name: "Jingle Jokers",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/joan_of_arc": {
        slug: "joan_of_arc",
        name: "Joan of Arc",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/jumpin_pot": {
        slug: "jumpin_pot",
        name: "Jumpin Pot",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/jungle_rave": {
        slug: "jungle_rave",
        name: "Jungle Rave",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/kitty_twins": {
        slug: "kitty_twins",
        name: "Kitty Twins",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/kukulkans_queen": {
        slug: "kukulkans_queen",
        name: "Kukulkan's Queen",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lady_luck": {
        slug: "lady_luck",
        name: "Lady Luck",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/legends_of_the_wild_moon": {
        slug: "legends_of_the_wild_moon",
        name: "Legends of the Wild Moon",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lilly_palmer_london": {
        slug: "lilly_palmer_london",
        name: "Lilly Palmer London",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lucky_coins": {
        slug: "lucky_coins",
        name: "Lucky Coins",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lucky_fruits_and_diamonds": {
        slug: "lucky_fruits_and_diamonds",
        name: "Lucky Fruits & Diamonds",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lucky_loser": {
        slug: "lucky_loser",
        name: "Lucky Loser",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lucky_pups": {
        slug: "lucky_pups",
        name: "Lucky Pups",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lucky_reefs": {
        slug: "lucky_reefs",
        name: "Lucky Reefs",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/lunar_rabbit": {
        slug: "lunar_rabbit",
        name: "Lunar Rabbit",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/luxor_secrets_holdn_win": {
        slug: "luxor_secrets_holdn_win",
        name: "Luxor Secrets Hold'n Win",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/magic_dragon": {
        slug: "magic_dragon",
        name: "Magic Dragon",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/magic_unicorn": {
        slug: "magic_unicorn",
        name: "Magic Unicorn",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/mariachi_fiesta": {
        slug: "mariachi_fiesta",
        name: "Mariachi Fiesta",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/mega_wild_spin": {
        slug: "mega_wild_spin",
        name: "Mega Wild Spin",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/midgards_fortune_megaways": {
        slug: "midgards_fortune_megaways",
        name: "Midgard's Fortune Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/money_farm": {
        slug: "money_farm",
        name: "Money Farm",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/money_farm_2": {
        slug: "money_farm_2",
        name: "Money Farm 2",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/money_farm_2_dice": {
        slug: "money_farm_2_dice",
        name: "Money Farm 2 Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/money_farm_megaways": {
        slug: "money_farm_megaways",
        name: "Money Farm Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/money_farm_west": {
        slug: "money_farm_west",
        name: "Money Farm West",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/more_cash": {
        slug: "more_cash",
        name: "More Cash",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/nefertitis_nile": {
        slug: "nefertitis_nile",
        name: "Nefertiti's Nile",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/night_at_ktv": {
        slug: "night_at_ktv",
        name: "Night at KTV",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/norns_fate": {
        slug: "norns_fate",
        name: "Norns' Fate",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/olympus_majesty": {
        slug: "olympus_majesty",
        name: "Olympus Majesty",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/one_hand_blackjack": {
        slug: "one_hand_blackjack",
        name: "One Hand Blackjack",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/oreally_lucky": {
        slug: "oreally_lucky",
        name: "O'Really Lucky",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/peters_universe": {
        slug: "peters_universe",
        name: "Peter's Universe",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/phoenix_princess": {
        slug: "phoenix_princess",
        name: "Phoenix Princess",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/piggy_bjorn_2_winter_is_coming": {
        slug: "piggy_bjorn_2_winter_is_coming",
        name: "Piggy Bjorn 2 - Winter is Coming",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/piggy_bjorn_muspelheims_treasure": {
        slug: "piggy_bjorn_muspelheims_treasure",
        name: "Piggy Bjorn - Muspelheim's Treasure",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/piggy_holmes": {
        slug: "piggy_holmes",
        name: "Piggy Holmes",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/pirates_pearl_megaways": {
        slug: "pirates_pearl_megaways",
        name: "Pirate's Pearl Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/pixel_invaders": {
        slug: "pixel_invaders",
        name: "Pixel Invaders",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/power_dragon": {
        slug: "power_dragon",
        name: "Power Dragon",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/ragnas_rock": {
        slug: "ragnas_rock",
        name: "Ragna's Rock",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/raiders_of_the_lost_book": {
        slug: "raiders_of_the_lost_book",
        name: "Raiders of the Lost Book",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/rosh_immortality_cube_megaways": {
        slug: "rosh_immortality_cube_megaways",
        name: "Rosh Immortality Cube Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/royal_gems": {
        slug: "royal_gems",
        name: "Royal Gems",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/royal_gems_dice": {
        slug: "royal_gems_dice",
        name: "Royal Gems Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/safari_cubs_go_wild": {
        slug: "safari_cubs_go_wild",
        name: "Safari Cubs Go Wild",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/safari_gems": {
        slug: "safari_gems",
        name: "Safari Gems",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/san_loong_fortune": {
        slug: "san_loong_fortune",
        name: "San Loong Fortune",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/santas_downfall": {
        slug: "santas_downfall",
        name: "Santa's Downfall",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/santas_factory": {
        slug: "santas_factory",
        name: "Santa's Factory",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/santas_sleigh_workshop": {
        slug: "santas_sleigh_workshop",
        name: "Santa's Sleigh Workshop",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/slasher_and_berry": {
        slug: "slasher_and_berry",
        name: "Slasher and Berry",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/spooky_graves": {
        slug: "spooky_graves",
        name: "Spooky Graves",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/storming_flame": {
        slug: "storming_flame",
        name: "Storming Flame",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/striking_joker": {
        slug: "striking_joker",
        name: "Striking Joker",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/sugar_loot_spark": {
        slug: "sugar_loot_spark",
        name: "Sugar Loot Spark",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/summer_jam": {
        slug: "summer_jam",
        name: "Summer Jam",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/super_heated_7s": {
        slug: "super_heated_7s",
        name: "Super Heated 7s",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/surfin_joker": {
        slug: "surfin_joker",
        name: "Surfin' Joker",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/surfin_joker_dice": {
        slug: "surfin_joker_dice",
        name: "Surfin' Joker Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/sushi_yatta": {
        slug: "sushi_yatta",
        name: "Sushi Yatta",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/tales_of_the_serpent_maiden": {
        slug: "tales_of_the_serpent_maiden",
        name: "Tales of the Serpent Maiden",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/texas_rangers_reward": {
        slug: "texas_rangers_reward",
        name: "Texas Rangers Reward",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/the_way_of_the_dead": {
        slug: "the_way_of_the_dead",
        name: "The Way of the Dead",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/three_kings": {
        slug: "three_kings",
        name: "Three Kings",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/tiger_heart": {
        slug: "tiger_heart",
        name: "Tiger Heart",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/totem_token": {
        slug: "totem_token",
        name: "Totem Token",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/tractor_frenzy_40": {
        slug: "tractor_frenzy_40",
        name: "Tractor Frenzy 40",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/ultra_cluster_kingdom": {
        slug: "ultra_cluster_kingdom",
        name: "Ultra Cluster Kingdom",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/vegas_kingmaker_100": {
        slug: "vegas_kingmaker_100",
        name: "Vegas Kingmaker 100",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/vegas_kingmaker_20": {
        slug: "vegas_kingmaker_20",
        name: "Vegas Kingmaker 20",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/vegas_kingmaker_40": {
        slug: "vegas_kingmaker_40",
        name: "Vegas Kingmaker 40",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/vegas_kingmaker_5": {
        slug: "vegas_kingmaker_5",
        name: "Vegas Kingmaker 5",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/video_poker": {
        slug: "video_poker",
        name: "Video Poker",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/vulcano_roulette": {
        slug: "vulcano_roulette",
        name: "Vulcano Roulette",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/wild_dolphin": {
        slug: "wild_dolphin",
        name: "Wild Dolphin",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/wild_marmalade": {
        slug: "wild_marmalade",
        name: "Wild Marmalade",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/wild_wild_fruit": {
        slug: "wild_wild_fruit",
        name: "Wild Wild Fruit",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/witchs_candy_quest_megaways": {
        slug: "witchs_candy_quest_megaways",
        name: "Witch's Candy Quest Megaways",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/wolf_hunt": {
        slug: "wolf_hunt",
        name: "Wolf Hunt",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/wolf_hunt_dice": {
        slug: "wolf_hunt_dice",
        name: "Wolf Hunt Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/xmas_express": {
        slug: "xmas_express",
        name: "Xmas Express",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/xtreme_hot": {
        slug: "xtreme_hot",
        name: "Xtreme Hot",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/xtreme_hot_dice": {
        slug: "xtreme_hot_dice",
        name: "Xtreme Hot Dice",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/xtreme_summer_hot": {
        slug: "xtreme_summer_hot",
        name: "Xtreme Summer Hot",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/yellow_diver": {
        slug: "yellow_diver",
        name: "Yellow Diver",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gameart/zeus_blitz_power_strike": {
        slug: "zeus_blitz_power_strike",
        name: "Zeus Blitz: Power Strike",
        provider: "GameArt",
        providerSlug: "gameart"
    },
    "gametech/abduction": {
        slug: "abduction",
        name: "Abduction",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/awesome_penguin": {
        slug: "awesome_penguin",
        name: "Awesome Penguin",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/beat_box": {
        slug: "beat_box",
        name: "Beat Box",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/blood_moon": {
        slug: "blood_moon",
        name: "Blood Moon",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/campaign": {
        slug: "campaign",
        name: "Campaign",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/chaos_royale": {
        slug: "chaos_royale",
        name: "Chaos Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/cherry_bombs": {
        slug: "cherry_bombs",
        name: "Cherry Bombs",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/ddakji": {
        slug: "ddakji",
        name: "Ddakji",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/end_of_edo": {
        slug: "end_of_edo",
        name: "End Of Edo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/football_crash": {
        slug: "football_crash",
        name: "Football Crash",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/four_sacred_souls": {
        slug: "four_sacred_souls",
        name: "Four Sacred Souls",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/freegame": {
        slug: "freegame",
        name: "Freegame",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/great_beauties_of_china": {
        slug: "great_beauties_of_china",
        name: "Great Beauties of China",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/jackpot": {
        slug: "jackpot",
        name: "Jackpot",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/journey_to_the_gold": {
        slug: "journey_to_the_gold",
        name: "Journey to the Gold",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/kokeshi": {
        slug: "kokeshi",
        name: "Kokeshi",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/ladder": {
        slug: "ladder",
        name: "Ladder",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/league_of_conquerors": {
        slug: "league_of_conquerors",
        name: "League of Conquerors",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/megajackpot": {
        slug: "megajackpot",
        name: "Megajackpot",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/money_royale": {
        slug: "money_royale",
        name: "Money Royale",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/monster_quest": {
        slug: "monster_quest",
        name: "Monster Quest",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/neo_tokyo": {
        slug: "neo_tokyo",
        name: "Neo Tokyo",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/nezha": {
        slug: "nezha",
        name: "Nezha",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/other": {
        slug: "other",
        name: "Other",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/pebble": {
        slug: "pebble",
        name: "Pebble",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/piggy_bank_millionaire": {
        slug: "piggy_bank_millionaire",
        name: "Piggy Bank Millionaire",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/power_of_elements": {
        slug: "power_of_elements",
        name: "Power of Elements",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/quick_niu_niu": {
        slug: "quick_niu_niu",
        name: "Quick Niu Niu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/shiba_inu": {
        slug: "shiba_inu",
        name: "Shiba Inu",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/sichuan_opera_face_changing": {
        slug: "sichuan_opera_face_changing",
        name: "Sichuan Opera Face Changing",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/smash_and_crash": {
        slug: "smash_and_crash",
        name: "Smash and Crash",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/space_girl": {
        slug: "space_girl",
        name: "Space Girl",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/squid_ladder": {
        slug: "squid_ladder",
        name: "Squid Ladder",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/sumie": {
        slug: "sumie",
        name: "Sumi-e",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/sushicade": {
        slug: "sushicade",
        name: "Sushicade",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/tokyo_kombat": {
        slug: "tokyo_kombat",
        name: "Tokyo Kombat",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/tournament": {
        slug: "tournament",
        name: "Tournament",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gametech/ukiyoe": {
        slug: "ukiyoe",
        name: "Ukiyo-e",
        provider: "GameTech",
        providerSlug: "gametech"
    },
    "gamingcorps/3_easter_pigs_hop_and_win_94": {
        slug: "3_easter_pigs_hop_and_win_94",
        name: "3 Easter Pigs Hop and Win 94",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_gifts_of_xmas": {
        slug: "3_gifts_of_xmas",
        name: "3 Gifts of Xmas",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_instant_blitz": {
        slug: "3_pigs_instant_blitz",
        name: "3 Pigs Instant Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_of_independence_hog_and_win": {
        slug: "3_pigs_of_independence_hog_and_win",
        name: "3 Pigs of Independence Hog and Win",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_of_olympus_2_rise_of_the_demihog": {
        slug: "3_pigs_of_olympus_2_rise_of_the_demihog",
        name: "3 Pigs of Olympus 2 Rise of the Demihog",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_of_olympus_bonus_pot": {
        slug: "3_pigs_of_olympus_bonus_pot",
        name: "3 Pigs of Olympus Bonus Pot",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_of_the_caribbean": {
        slug: "3_pigs_of_the_caribbean",
        name: "3 Pigs of the Caribbean",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pigs_of_xmas_bonus_pot_20000": {
        slug: "3_pigs_of_xmas_bonus_pot_20000",
        name: "3 Pigs of Xmas Bonus Pot 20,000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/3_pots_of_potions": {
        slug: "3_pots_of_potions",
        name: "3 Pots of Potions",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/4_gym_pigs_porky": {
        slug: "4_gym_pigs_porky",
        name: "4 Gym Pigs Porky",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/777_jackpot_diamond_hold_and_win": {
        slug: "777_jackpot_diamond_hold_and_win",
        name: "777 Jackpot Diamond Hold and Win",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/777_jackpot_diamond_hold_and_win_deluxe": {
        slug: "777_jackpot_diamond_hold_and_win_deluxe",
        name: "777 Jackpot Diamond Hold and Win Deluxe",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/9_hot_fruits_stick_and_spin_3x3": {
        slug: "9_hot_fruits_stick_and_spin_3x3",
        name: "9 Hot Fruits Stick and Spin 3x3",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/9_jokers_stick_and_spin": {
        slug: "9_jokers_stick_and_spin",
        name: "9 Jokers Stick and Spin",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/amazonia_jackpot": {
        slug: "amazonia_jackpot",
        name: "Amazonia Jackpot",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/angry_elf_christmas_miner": {
        slug: "angry_elf_christmas_miner",
        name: "Angry Elf Christmas Miner",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/anubis_vs_horus_twin_titans": {
        slug: "anubis_vs_horus_twin_titans",
        name: "Anubis vs Horus Twin Titans",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/aztec_bonus_pot": {
        slug: "aztec_bonus_pot",
        name: "Aztec Bonus Pot",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/bank_or_bust": {
        slug: "bank_or_bust",
        name: "Bank or Bust",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/banknote_blitz": {
        slug: "banknote_blitz",
        name: "Banknote Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/bass_rewards": {
        slug: "bass_rewards",
        name: "Bass Rewards",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/bass_rewards_bonanza_the_golden_catch": {
        slug: "bass_rewards_bonanza_the_golden_catch",
        name: "Bass Rewards Bonanza - The Golden Catch",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/big_buck_blitz": {
        slug: "big_buck_blitz",
        name: "Big Buck Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/blackjack_bonus_wheel_1000_6": {
        slug: "blackjack_bonus_wheel_1000_6",
        name: "Blackjack Bonus Wheel 1000 6",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/blackjack_bonus_wheel_1000_8": {
        slug: "blackjack_bonus_wheel_1000_8",
        name: "Blackjack Bonus Wheel 1000 8",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/blackjack_multi_hand": {
        slug: "blackjack_multi_hand",
        name: "Blackjack Multi Hand",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/blackjack_multihand_vip": {
        slug: "blackjack_multihand_vip",
        name: "Blackjack Multihand VIP",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/bon_bon_bonanza": {
        slug: "bon_bon_bonanza",
        name: "Bon Bon Bonanza",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/buffalo_bash": {
        slug: "buffalo_bash",
        name: "Buffalo Bash",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/bwin_mines": {
        slug: "bwin_mines",
        name: "Bwin Mines",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/christmas_miner": {
        slug: "christmas_miner",
        name: "Christmas Miner",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/clucks_and_robbers_coin_collect": {
        slug: "clucks_and_robbers_coin_collect",
        name: "Clucks and Robbers Coin Collect",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/coin_miner_2": {
        slug: "coin_miner_2",
        name: "Coin Miner 2",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/coins_of_valhalla_20000": {
        slug: "coins_of_valhalla_20000",
        name: "Coins of Valhalla 20000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/destino_das_almas": {
        slug: "destino_das_almas",
        name: "Destino Das Almas",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/easter_plinko": {
        slug: "easter_plinko",
        name: "Easter Plinko",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/egypt_bonus_pot": {
        slug: "egypt_bonus_pot",
        name: "Egypt Bonus Pot",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/expanding_joker": {
        slug: "expanding_joker",
        name: "Expanding Joker",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/fins_of_fortune": {
        slug: "fins_of_fortune",
        name: "Fins of Fortune",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/fire_and_freedom_rapid_hold_and_win": {
        slug: "fire_and_freedom_rapid_hold_and_win",
        name: "Fire and Freedom Rapid Hold and Win",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/football_freestyler": {
        slug: "football_freestyler",
        name: "Football Freestyler",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/freedom_eagle": {
        slug: "freedom_eagle",
        name: "Freedom Eagle",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/gates_of_hellfire": {
        slug: "gates_of_hellfire",
        name: "Gates of Hellfire",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/gems_rampage": {
        slug: "gems_rampage",
        name: "Gems Rampage",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/goals_to_glory_football_fever": {
        slug: "goals_to_glory_football_fever",
        name: "Goals to Glory Football Fever",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/goals_to_glory_instant_blitz": {
        slug: "goals_to_glory_instant_blitz",
        name: "Goals to Glory Instant Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/golden_dragon_wealth": {
        slug: "golden_dragon_wealth",
        name: "Golden Dragon Wealth",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/golf_champion": {
        slug: "golf_champion",
        name: "Golf Champion",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/ho_ho_hodl": {
        slug: "ho_ho_hodl",
        name: "Ho Ho HODL",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/hyena_heis": {
        slug: "hyena_heis",
        name: "Hyena Heis",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/hyena_heist": {
        slug: "hyena_heist",
        name: "Hyena Heist",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/instant_blitz": {
        slug: "instant_blitz",
        name: "Instant Blitz",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/jet_lucky_2": {
        slug: "jet_lucky_2",
        name: "Jet Lucky 2",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/lobster_hotpot": {
        slug: "lobster_hotpot",
        name: "Lobster Hotpot",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/lobster_hotpot_2_even_hotter": {
        slug: "lobster_hotpot_2_even_hotter",
        name: "Lobster Hotpot 2 Even Hotter",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/lucky_ominer": {
        slug: "lucky_ominer",
        name: "Lucky O'Miner",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/lucky_yuanbao": {
        slug: "lucky_yuanbao",
        name: "Lucky Yuanbao",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/luke_e_chance_and_the_book_of_luck": {
        slug: "luke_e_chance_and_the_book_of_luck",
        name: "Luke E Chance and the Book of Luck",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/luke_e_chance_and_the_inca_sun_god": {
        slug: "luke_e_chance_and_the_inca_sun_god",
        name: "Luke E Chance and the Inca Sun God",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/mega_mammoth_multiplier_mayhem": {
        slug: "mega_mammoth_multiplier_mayhem",
        name: "Mega Mammoth Multiplier Mayhem",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/midas_glory_coin_collect": {
        slug: "midas_glory_coin_collect",
        name: "Midas Glory Coin Collect",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/mighty_mammoth": {
        slug: "mighty_mammoth",
        name: "Mighty Mammoth",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/mining_madness": {
        slug: "mining_madness",
        name: "Mining Madness",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/paddys_payout_race_to_riches_94": {
        slug: "paddys_payout_race_to_riches_94",
        name: "Paddy's Payout Race to Riches 94",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/paddys_payouts": {
        slug: "paddys_payouts",
        name: "Paddy's Payouts",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/penalty_champion": {
        slug: "penalty_champion",
        name: "Penalty Champion",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/penalty_champion_2": {
        slug: "penalty_champion_2",
        name: "Penalty Champion 2",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/penalty_champion_goals_to_glory": {
        slug: "penalty_champion_goals_to_glory",
        name: "Penalty Champion Goals to Glory",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/piggy_smash": {
        slug: "piggy_smash",
        name: "Piggy Smash",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/piggy_smash_2": {
        slug: "piggy_smash_2",
        name: "Piggy Smash 2",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/plinkball_5000": {
        slug: "plinkball_5000",
        name: "Plinkball 5000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/plinkgoal": {
        slug: "plinkgoal",
        name: "Plinkgoal",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/plinko_5000": {
        slug: "plinko_5000",
        name: "Plinko 5000",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/prospectors_plinko": {
        slug: "prospectors_plinko",
        name: "Prospector's Plinko",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/raging_zeus": {
        slug: "raging_zeus",
        name: "Raging Zeus",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/raging_zeus_mines": {
        slug: "raging_zeus_mines",
        name: "Raging Zeus Mines",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/rampage": {
        slug: "rampage",
        name: "Rampage",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/samba_soccer": {
        slug: "samba_soccer",
        name: "Samba Soccer",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/savannah_stacks": {
        slug: "savannah_stacks",
        name: "Savannah Stacks",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/shootout_champion": {
        slug: "shootout_champion",
        name: "Shootout Champion",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/six_or_out": {
        slug: "six_or_out",
        name: "Six or Out!",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/skyliner": {
        slug: "skyliner",
        name: "Skyliner",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/snoops_high_roller": {
        slug: "snoops_high_roller",
        name: "Snoop's High Roller",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/star_pigs_of_the_clusterverse": {
        slug: "star_pigs_of_the_clusterverse",
        name: "Star Pigs of the Clusterverse",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/stormy_witch": {
        slug: "stormy_witch",
        name: "Stormy Witch",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/super_hot_stacks": {
        slug: "super_hot_stacks",
        name: "Super Hot Stacks",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/sweet_miner": {
        slug: "sweet_miner",
        name: "Sweet Miner",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/tikiz_n_juice": {
        slug: "tikiz_n_juice",
        name: "Tikiz 'n Juice",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/to_mars_and_beyond": {
        slug: "to_mars_and_beyond",
        name: "To Mars and Beyond",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/udder_carnage_holy_cow": {
        slug: "udder_carnage_holy_cow",
        name: "Udder Carnage Holy Cow!",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/uplinko_by_fashion_tv": {
        slug: "uplinko_by_fashion_tv",
        name: "UPlinko by Fashion TV",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/vegas_payouts_rapid_hold_and_win": {
        slug: "vegas_payouts_rapid_hold_and_win",
        name: "Vegas Payouts Rapid Hold & Win",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/whole_lotta_honey_94": {
        slug: "whole_lotta_honey_94",
        name: "Whole Lotta Honey 94",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/wild_woof": {
        slug: "wild_woof",
        name: "Wild Woof",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/wild_woof_returns": {
        slug: "wild_woof_returns",
        name: "Wild Woof Returns",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "gamingcorps/xmas_plinko": {
        slug: "xmas_plinko",
        name: "Xmas Plinko",
        provider: "GamingCorps",
        providerSlug: "gamingcorps"
    },
    "habanero/12_zodiacs": {
        slug: "12_zodiacs",
        name: "12 Zodiacs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/5_lucky_lions": {
        slug: "5_lucky_lions",
        name: "5 Lucky Lions",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/5_mariachis": {
        slug: "5_mariachis",
        name: "5 Mariachis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_1_hand": {
        slug: "aces_and_eights_1_hand",
        name: "Aces and Eights 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_10_hand": {
        slug: "aces_and_eights_10_hand",
        name: "Aces and Eights 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_100_hand": {
        slug: "aces_and_eights_100_hand",
        name: "Aces and Eights 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_5_hand": {
        slug: "aces_and_eights_5_hand",
        name: "Aces and Eights 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aces_and_eights_50_hand": {
        slug: "aces_and_eights_50_hand",
        name: "Aces and Eights 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_1_hand": {
        slug: "all_american_poker_1_hand",
        name: "All American Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_10_hand": {
        slug: "all_american_poker_10_hand",
        name: "All American Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_100_hand": {
        slug: "all_american_poker_100_hand",
        name: "All American Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_5_hand": {
        slug: "all_american_poker_5_hand",
        name: "All American Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_american_poker_50_hand": {
        slug: "all_american_poker_50_hand",
        name: "All American Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/all_for_one": {
        slug: "all_for_one",
        name: "All For One",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/american_blackjack": {
        slug: "american_blackjack",
        name: "American Blackjack",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arcane_elements": {
        slug: "arcane_elements",
        name: "Arcane Elements",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arctic_hunt": {
        slug: "arctic_hunt",
        name: "Arctic Hunt",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/arctic_wonders": {
        slug: "arctic_wonders",
        name: "Arctic Wonders",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/atomic_kittens": {
        slug: "atomic_kittens",
        name: "Atomic Kittens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/aztlans_gold": {
        slug: "aztlans_gold",
        name: "Aztlan's Gold",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/baba_yaga": {
        slug: "baba_yaga",
        name: "Baba Yaga",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/baccarat_zero_commission": {
        slug: "baccarat_zero_commission",
        name: "Baccarat Zero Commission",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/barnstormer_bucks": {
        slug: "barnstormer_bucks",
        name: "Barnstormer Bucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/battle_the_beast": {
        slug: "battle_the_beast",
        name: "Battle the beast",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/battleship_strike": {
        slug: "battleship_strike",
        name: "Battleship Strike",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/before_time_runs_out": {
        slug: "before_time_runs_out",
        name: "Before Time Runs Out",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bikini_island": {
        slug: "bikini_island",
        name: "Bikini Island",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bikini_island_deluxe": {
        slug: "bikini_island_deluxe",
        name: "Bikini Island Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bird_of_thunder": {
        slug: "bird_of_thunder",
        name: "Bird of Thunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/blackbeards_bounty": {
        slug: "blackbeards_bounty",
        name: "Blackbeard's Bounty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/blackjack_3_hand": {
        slug: "blackjack_3_hand",
        name: "Blackjack 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bomb_runner": {
        slug: "bomb_runner",
        name: "Bomb Runner",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bombs_away": {
        slug: "bombs_away",
        name: "Bombs Away",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_1_hand": {
        slug: "bonus_deuces_wild_1_hand",
        name: "Bonus Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_10_hand": {
        slug: "bonus_deuces_wild_10_hand",
        name: "Bonus Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_100_hand": {
        slug: "bonus_deuces_wild_100_hand",
        name: "Bonus Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_5_hand": {
        slug: "bonus_deuces_wild_5_hand",
        name: "Bonus Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_deuces_wild_50_hand": {
        slug: "bonus_deuces_wild_50_hand",
        name: "Bonus Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_1_hand": {
        slug: "bonus_poker_1_hand",
        name: "Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_10_hand": {
        slug: "bonus_poker_10_hand",
        name: "Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_100_hand": {
        slug: "bonus_poker_100_hand",
        name: "Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_5_hand": {
        slug: "bonus_poker_5_hand",
        name: "Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/bonus_poker_50_hand": {
        slug: "bonus_poker_50_hand",
        name: "Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/buggy_bonus": {
        slug: "buggy_bonus",
        name: "Buggy Bonus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cake_valley": {
        slug: "cake_valley",
        name: "Cake Valley",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/calaveras_explosivas": {
        slug: "calaveras_explosivas",
        name: "Calaveras Explosivas",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/candy_tower": {
        slug: "candy_tower",
        name: "Candy Tower",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/caribbean_holdem": {
        slug: "caribbean_holdem",
        name: "Caribbean Hold'em",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/caribbean_stud": {
        slug: "caribbean_stud",
        name: "Caribbean Stud",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/carnival_cash": {
        slug: "carnival_cash",
        name: "Carnival Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/carnival_cove": {
        slug: "carnival_cove",
        name: "Carnival Cove",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cash_reef": {
        slug: "cash_reef",
        name: "Cash Reef",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cashosaurus": {
        slug: "cashosaurus",
        name: "Cashosaurus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/christmas_gift_rush": {
        slug: "christmas_gift_rush",
        name: "Christmas Gift Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/cirque_du_habanero": {
        slug: "cirque_du_habanero",
        name: "Cirque Du Habanero",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/colossal_gems": {
        slug: "colossal_gems",
        name: "Colossal Gems",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/coyote_crash": {
        slug: "coyote_crash",
        name: "Coyote Crash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/crystopia": {
        slug: "crystopia",
        name: "Crystopia",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/daruma_impact": {
        slug: "daruma_impact",
        name: "Daruma Impact",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_1_hand": {
        slug: "deuces_wild_1_hand",
        name: "Deuces Wild 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_10_hand": {
        slug: "deuces_wild_10_hand",
        name: "Deuces Wild 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_100_hand": {
        slug: "deuces_wild_100_hand",
        name: "Deuces Wild 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_5_hand": {
        slug: "deuces_wild_5_hand",
        name: "Deuces Wild 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/deuces_wild_50_hand": {
        slug: "deuces_wild_50_hand",
        name: "Deuces Wild 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/disco_beats": {
        slug: "disco_beats",
        name: "Disco Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/disco_funk": {
        slug: "disco_funk",
        name: "Disco Funk",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_1_hand": {
        slug: "double_bonus_poker_1_hand",
        name: "Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_10_hand": {
        slug: "double_bonus_poker_10_hand",
        name: "Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_100_hand": {
        slug: "double_bonus_poker_100_hand",
        name: "Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_5_hand": {
        slug: "double_bonus_poker_5_hand",
        name: "Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_bonus_poker_50_hand": {
        slug: "double_bonus_poker_50_hand",
        name: "Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_1_hand": {
        slug: "double_double_bonus_poker_1_hand",
        name: "Double Double Bonus Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_10_hand": {
        slug: "double_double_bonus_poker_10_hand",
        name: "Double Double Bonus Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_100_hand": {
        slug: "double_double_bonus_poker_100_hand",
        name: "Double Double Bonus Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_5_hand": {
        slug: "double_double_bonus_poker_5_hand",
        name: "Double Double Bonus Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_double_bonus_poker_50_hand": {
        slug: "double_double_bonus_poker_50_hand",
        name: "Double Double Bonus Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_exposure_3_hand": {
        slug: "double_exposure_3_hand",
        name: "Double Exposure 3 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/double_o_dollars": {
        slug: "double_o_dollars",
        name: "Double O Dollars",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dr_feelgood": {
        slug: "dr_feelgood",
        name: "Dr Feelgood",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_castle": {
        slug: "dragon_castle",
        name: "Dragon Castle",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragon_tiger_gate": {
        slug: "dragon_tiger_gate",
        name: "Dragon Tiger Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragons_realm": {
        slug: "dragons_realm",
        name: "Dragon's Realm",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/dragons_throne": {
        slug: "dragons_throne",
        name: "Dragon's Throne",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/egyptian_dreams": {
        slug: "egyptian_dreams",
        name: "Egyptian Dreams",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/egyptian_dreams_deluxe": {
        slug: "egyptian_dreams_deluxe",
        name: "Egyptian Dreams Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fa_cai_shen": {
        slug: "fa_cai_shen",
        name: "Fa Cai Shen",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fa_cai_shen_deluxe": {
        slug: "fa_cai_shen_deluxe",
        name: "Fa Cai Shen Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fenghuang": {
        slug: "fenghuang",
        name: "Fenghuang",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fire_rooster": {
        slug: "fire_rooster",
        name: "Fire Rooster",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fly": {
        slug: "fly",
        name: "Fly!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/flying_high": {
        slug: "flying_high",
        name: "Flying High",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fortune_dogs": {
        slug: "fortune_dogs",
        name: "Fortune Dogs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fortune_dragon_joy": {
        slug: "fortune_dragon_joy",
        name: "Fortune Dragon Joy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/four_divine_beasts": {
        slug: "four_divine_beasts",
        name: "Four Divine Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/frontier_fortunes": {
        slug: "frontier_fortunes",
        name: "Frontier Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fruity_halloween": {
        slug: "fruity_halloween",
        name: "Fruity Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/fruity_mayan": {
        slug: "fruity_mayan",
        name: "Fruity Mayan",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/galactic_cash": {
        slug: "galactic_cash",
        name: "Galactic Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/galaxy_babies": {
        slug: "galaxy_babies",
        name: "Galaxy Babies",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gangsters": {
        slug: "gangsters",
        name: "Gangsters",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/genies_showtime": {
        slug: "genies_showtime",
        name: "Genie's Showtime",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gladiator_royal": {
        slug: "gladiator_royal",
        name: "Gladiator Royal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/glam_rock": {
        slug: "glam_rock",
        name: "Glam Rock",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/glory_of_rome": {
        slug: "glory_of_rome",
        name: "Glory Of Rome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gold_koi_fortune": {
        slug: "gold_koi_fortune",
        name: "Gold Koi Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_taj_mahal": {
        slug: "golden_taj_mahal",
        name: "Golden Taj Mahal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_unicorn": {
        slug: "golden_unicorn",
        name: "Golden Unicorn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/golden_unicorn_deluxe": {
        slug: "golden_unicorn_deluxe",
        name: "Golden Unicorn Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happiest_christmas_tree": {
        slug: "happiest_christmas_tree",
        name: "Happiest Christmas Tree",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happy_ape": {
        slug: "happy_ape",
        name: "Happy Ape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/happy_hatchlings": {
        slug: "happy_hatchlings",
        name: "Happy Hatchlings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/haunted_harbor": {
        slug: "haunted_harbor",
        name: "Haunted Harbor",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/haunted_house": {
        slug: "haunted_house",
        name: "Haunted House",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hey_sushi": {
        slug: "hey_sushi",
        name: "Hey Sushi",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_fruit": {
        slug: "hot_hot_fruit",
        name: "Hot Hot Fruit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_halloween": {
        slug: "hot_hot_halloween",
        name: "Hot Hot Halloween",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hot_hot_summer": {
        slug: "hot_hot_summer",
        name: "Hot Hot Summer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/hyper_hues": {
        slug: "hyper_hues",
        name: "Hyper Hues",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/indian_cash_catcher": {
        slug: "indian_cash_catcher",
        name: "Indian Cash Catcher",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/indiana_wolf": {
        slug: "indiana_wolf",
        name: "Indiana Wolf",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/infernal_fury": {
        slug: "infernal_fury",
        name: "Infernal Fury",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/isibaya_queens": {
        slug: "isibaya_queens",
        name: "Isibaya Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_1_hand": {
        slug: "jacks_or_better_1_hand",
        name: "Jacks or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_10_hand": {
        slug: "jacks_or_better_10_hand",
        name: "Jacks or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_100_hand": {
        slug: "jacks_or_better_100_hand",
        name: "Jacks or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_5_hand": {
        slug: "jacks_or_better_5_hand",
        name: "Jacks or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jacks_or_better_50_hand": {
        slug: "jacks_or_better_50_hand",
        name: "Jacks or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/japanese_mask": {
        slug: "japanese_mask",
        name: "Japanese Mask",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jellyfish_flow": {
        slug: "jellyfish_flow",
        name: "Jellyfish Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jellyfish_flow_ultra": {
        slug: "jellyfish_flow_ultra",
        name: "Jellyfish Flow Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_1_hand": {
        slug: "joker_poker_1_hand",
        name: "Joker Poker 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_10_hand": {
        slug: "joker_poker_10_hand",
        name: "Joker Poker 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_100_hand": {
        slug: "joker_poker_100_hand",
        name: "Joker Poker 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_5_hand": {
        slug: "joker_poker_5_hand",
        name: "Joker Poker 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/joker_poker_50_hand": {
        slug: "joker_poker_50_hand",
        name: "Joker Poker 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jugglenaut": {
        slug: "jugglenaut",
        name: "Jugglenaut",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jump": {
        slug: "jump",
        name: "Jump!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jump_2": {
        slug: "jump_2",
        name: "Jump! 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/jungle_rumble": {
        slug: "jungle_rumble",
        name: "Jungle Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/kanes_inferno": {
        slug: "kanes_inferno",
        name: "Kane's Inferno",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/king_frog_feast": {
        slug: "king_frog_feast",
        name: "King Frog Feast",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/king_tuts_tomb": {
        slug: "king_tuts_tomb",
        name: "King Tut's Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/knockout_football": {
        slug: "knockout_football",
        name: "Knockout Football",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/knockout_football_rush": {
        slug: "knockout_football_rush",
        name: "Knockout Football Rush",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/koi_gate": {
        slug: "koi_gate",
        name: "Koi Gate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/koi_koi_treasure": {
        slug: "koi_koi_treasure",
        name: "Koi Koi Treasure",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lantern_luck": {
        slug: "lantern_luck",
        name: "Lantern Luck",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/laughing_buddha": {
        slug: "laughing_buddha",
        name: "Laughing Buddha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/legend_of_nezha": {
        slug: "legend_of_nezha",
        name: "Legend Of Nezha",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/legendary_beasts": {
        slug: "legendary_beasts",
        name: "Legendary Beasts",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/little_green_money": {
        slug: "little_green_money",
        name: "Little Green Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/london_hunter": {
        slug: "london_hunter",
        name: "London Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/loony_blox": {
        slug: "loony_blox",
        name: "Loony Blox",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/love_and_riches_el_dorado": {
        slug: "love_and_riches_el_dorado",
        name: "Love and Riches El Dorado",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_durian": {
        slug: "lucky_durian",
        name: "Lucky Durian",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_fortune_cat": {
        slug: "lucky_fortune_cat",
        name: "Lucky Fortune Cat",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/lucky_lucky": {
        slug: "lucky_lucky",
        name: "Lucky Lucky",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/magic_oak": {
        slug: "magic_oak",
        name: "Magic Oak",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/marvelous_furlongs": {
        slug: "marvelous_furlongs",
        name: "Marvelous Furlongs",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/meow_janken": {
        slug: "meow_janken",
        name: "Meow Janken",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mighty_medusa": {
        slug: "mighty_medusa",
        name: "Mighty Medusa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/monster_mash_cash": {
        slug: "monster_mash_cash",
        name: "Monster Mash Cash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/moo_moo_cow": {
        slug: "moo_moo_cow",
        name: "Moo Moo Cow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mount_mazuma": {
        slug: "mount_mazuma",
        name: "Mount Mazuma",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mr_bling": {
        slug: "mr_bling",
        name: "Mr Bling",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mummy_hunter": {
        slug: "mummy_hunter",
        name: "Mummy Hunter",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mummy_money": {
        slug: "mummy_money",
        name: "Mummy Money",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mx_mania": {
        slug: "mx_mania",
        name: "MX Mania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_fortune": {
        slug: "mystic_fortune",
        name: "Mystic Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_fortune_deluxe": {
        slug: "mystic_fortune_deluxe",
        name: "Mystic Fortune Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_rings": {
        slug: "mystic_rings",
        name: "Mystic Rings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/mystic_shaman": {
        slug: "mystic_shaman",
        name: "Mystic Shaman",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/naughty_santa": {
        slug: "naughty_santa",
        name: "Naughty Santa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/naughty_wukong": {
        slug: "naughty_wukong",
        name: "Naughty Wukong",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/new_years_bash": {
        slug: "new_years_bash",
        name: "New Years Bash",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nine_tails": {
        slug: "nine_tails",
        name: "Nine Tails",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nuwa": {
        slug: "nuwa",
        name: "Nuwa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/nuwa_deluxe": {
        slug: "nuwa_deluxe",
        name: "Nuwa Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/oceans_call": {
        slug: "oceans_call",
        name: "Ocean's Call",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/orbs_of_atlantis": {
        slug: "orbs_of_atlantis",
        name: "Orbs of Atlantis",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pamper_me": {
        slug: "pamper_me",
        name: "Pamper Me",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/panda_panda": {
        slug: "panda_panda",
        name: "Panda Panda",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pirates_plunder": {
        slug: "pirates_plunder",
        name: "Pirate's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/poker_gamble_beat_the_dealer": {
        slug: "poker_gamble_beat_the_dealer",
        name: "Poker Gamble Beat the Dealer",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pool_shark": {
        slug: "pool_shark",
        name: "Pool Shark",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/poseidon": {
        slug: "poseidon",
        name: "Poseidon",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/presto": {
        slug: "presto",
        name: "Presto!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/prosperity_horse": {
        slug: "prosperity_horse",
        name: "Prosperity Horse",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/prost": {
        slug: "prost",
        name: "Prost!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pucker_up_prince": {
        slug: "pucker_up_prince",
        name: "Pucker Up Prince",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/pumpkin_patch": {
        slug: "pumpkin_patch",
        name: "Pumpkin Patch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/queen_of_queens": {
        slug: "queen_of_queens",
        name: "Queen of Queens",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/queen_of_queens_ii": {
        slug: "queen_of_queens_ii",
        name: "Queen of Queens II",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/racing_royalty": {
        slug: "racing_royalty",
        name: "Racing Royalty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/raiden_shogun": {
        slug: "raiden_shogun",
        name: "Raiden Shogun",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rainbowmania": {
        slug: "rainbowmania",
        name: "Rainbowmania",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/return_to_the_feature": {
        slug: "return_to_the_feature",
        name: "Return To The Feature",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rhythm_nights": {
        slug: "rhythm_nights",
        name: "Rhythm Nights",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ride_em_cowboy": {
        slug: "ride_em_cowboy",
        name: "Ride 'em Cowboy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rodeo_drive": {
        slug: "rodeo_drive",
        name: "Rodeo Drive",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/rolling_roger": {
        slug: "rolling_roger",
        name: "Rolling Roger",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/roman_empire": {
        slug: "roman_empire",
        name: "Roman Empire",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ruffled_up": {
        slug: "ruffled_up",
        name: "Ruffled Up",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/safari_rumble": {
        slug: "safari_rumble",
        name: "Safari Rumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/santas_inn": {
        slug: "santas_inn",
        name: "Santa's Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/santas_village": {
        slug: "santas_village",
        name: "Santa's Village",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/scopa": {
        slug: "scopa",
        name: "Scopa",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/scruffy_scallywags": {
        slug: "scruffy_scallywags",
        name: "Scruffy Scallywags",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shamrock_quest": {
        slug: "shamrock_quest",
        name: "Shamrock Quest",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shaolin_fortunes": {
        slug: "shaolin_fortunes",
        name: "Shaolin Fortunes",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shaolin_fortunes_100": {
        slug: "shaolin_fortunes_100",
        name: "Shaolin Fortunes 100",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shivering_strings": {
        slug: "shivering_strings",
        name: "Shivering Strings",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/shoguns_land": {
        slug: "shoguns_land",
        name: "Shogun's Land",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sir_blingalot": {
        slug: "sir_blingalot",
        name: "Sir Blingalot",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sirens_spell": {
        slug: "sirens_spell",
        name: "Siren's Spell",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/skys_the_limit": {
        slug: "skys_the_limit",
        name: "Sky's the Limit",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/slime_party": {
        slug: "slime_party",
        name: "Slime Party",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/soju_bomb": {
        slug: "soju_bomb",
        name: "Soju Bomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sos": {
        slug: "sos",
        name: "S.O.S!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/space_fortune": {
        slug: "space_fortune",
        name: "Space Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/space_goonz": {
        slug: "space_goonz",
        name: "Space Goonz",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/sparta": {
        slug: "sparta",
        name: "Sparta",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/steampunk_plinko": {
        slug: "steampunk_plinko",
        name: "Steampunk Plinko",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_fruit_blast": {
        slug: "super_fruit_blast",
        name: "Super Fruit Blast",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_strike": {
        slug: "super_strike",
        name: "Super Strike",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/super_twister": {
        slug: "super_twister",
        name: "Super Twister",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taberna_de_los_muertos": {
        slug: "taberna_de_los_muertos",
        name: "Taberna De Los Muertos",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taberna_de_los_muertos_ultra": {
        slug: "taberna_de_los_muertos_ultra",
        name: "Taberna De Los Muertos Ultra",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/taiko_beats": {
        slug: "taiko_beats",
        name: "Taiko Beats",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/techno_tumble": {
        slug: "techno_tumble",
        name: "Techno Tumble",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_1_hand": {
        slug: "tens_or_better_1_hand",
        name: "Tens or Better 1 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_10_hand": {
        slug: "tens_or_better_10_hand",
        name: "Tens or Better 10 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_100_hand": {
        slug: "tens_or_better_100_hand",
        name: "Tens or Better 100 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_5_hand": {
        slug: "tens_or_better_5_hand",
        name: "Tens or Better 5 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tens_or_better_50_hand": {
        slug: "tens_or_better_50_hand",
        name: "Tens or Better 50 Hand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_big_deal": {
        slug: "the_big_deal",
        name: "The Big Deal",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_big_deal_deluxe": {
        slug: "the_big_deal_deluxe",
        name: "The Big Deal Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_dead_escape": {
        slug: "the_dead_escape",
        name: "The Dead Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/the_grape_escape": {
        slug: "the_grape_escape",
        name: "The Grape Escape",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/three_card_poker": {
        slug: "three_card_poker",
        name: "Three Card Poker",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/three_card_poker_deluxe": {
        slug: "three_card_poker_deluxe",
        name: "Three Card Poker Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tooty_fruity_fruits": {
        slug: "tooty_fruity_fruits",
        name: "Tooty Fruity Fruits",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/totem_towers": {
        slug: "totem_towers",
        name: "Totem Towers",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/totem_warrior": {
        slug: "totem_warrior",
        name: "Totem Warrior",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tower_of_pizza": {
        slug: "tower_of_pizza",
        name: "Tower Of Pizza",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/treasure_diver": {
        slug: "treasure_diver",
        name: "Treasure Diver",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/treasure_tomb": {
        slug: "treasure_tomb",
        name: "Treasure Tomb",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/tuk_tuk_thailand": {
        slug: "tuk_tuk_thailand",
        name: "Tuk Tuk Thailand",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/valentine_monchy": {
        slug: "valentine_monchy",
        name: "Valentine Monchy",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/vampires_fate": {
        slug: "vampires_fate",
        name: "Vampire's Fate",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/vikings_plunder": {
        slug: "vikings_plunder",
        name: "Viking's Plunder",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/waltz_beauty": {
        slug: "waltz_beauty",
        name: "Waltz Beauty",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/war": {
        slug: "war",
        name: "War",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/ways_of_fortune": {
        slug: "ways_of_fortune",
        name: "Ways Of Fortune",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wealth_inn": {
        slug: "wealth_inn",
        name: "Wealth Inn",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/weird_science": {
        slug: "weird_science",
        name: "Weird Science",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wicked_witch": {
        slug: "wicked_witch",
        name: "Wicked Witch",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wild_flow": {
        slug: "wild_flow",
        name: "Wild Flow",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wild_trucks": {
        slug: "wild_trucks",
        name: "Wild Trucks",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/witches_tome": {
        slug: "witches_tome",
        name: "Witches Tome",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/wizards_want_war": {
        slug: "wizards_want_war",
        name: "Wizards Want War!",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus": {
        slug: "zeus",
        name: "Zeus",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus_2": {
        slug: "zeus_2",
        name: "Zeus 2",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "habanero/zeus_deluxe": {
        slug: "zeus_deluxe",
        name: "Zeus Deluxe",
        provider: "Habanero",
        providerSlug: "habanero"
    },
    "hacksaw-gaming/2_wild_2_die": {
        slug: "2_wild_2_die",
        name: "2 Wild 2 Die",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/3_cursed_chests_hold_and_win": {
        slug: "3_cursed_chests_hold_and_win",
        name: "3 Cursed Chests: Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/3_magic_piggy_banks_hold_and_win": {
        slug: "3_magic_piggy_banks_hold_and_win",
        name: "3 Magic Piggy Banks Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/aiko_and_the_wind_spirit": {
        slug: "aiko_and_the_wind_spirit",
        name: "Aiko and the Wind Spirit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/aliens_among_us": {
        slug: "aliens_among_us",
        name: "Aliens Among Us",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/alpha_eagle": {
        slug: "alpha_eagle",
        name: "Alpha Eagle",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/arizona_james_and_the_lost_relics": {
        slug: "arizona_james_and_the_lost_relics",
        name: "Arizona James and the Lost Relics",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/army_of_ares": {
        slug: "army_of_ares",
        name: "Army of Ares",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/aztec_twist": {
        slug: "aztec_twist",
        name: "Aztec Twist",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/balloons": {
        slug: "balloons",
        name: "Balloons",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bash_bros": {
        slug: "bash_bros",
        name: "Bash Bros",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/beam_boys": {
        slug: "beam_boys",
        name: "Beam Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/beast_below": {
        slug: "beast_below",
        name: "Beast Below",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/benny_the_beer": {
        slug: "benny_the_beer",
        name: "Benny The Beer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bloodthirst": {
        slug: "bloodthirst",
        name: "Bloodthirst",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/book_of_time": {
        slug: "book_of_time",
        name: "Book of Time",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/booze_bash": {
        slug: "booze_bash",
        name: "Booze Bash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/born_wild": {
        slug: "born_wild",
        name: "Born Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bouncy_bombs": {
        slug: "bouncy_bombs",
        name: "Bouncy Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/break_bones": {
        slug: "break_bones",
        name: "Break Bones",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/break_the_ice": {
        slug: "break_the_ice",
        name: "Break the Ice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/buffalo_stack_n_sync": {
        slug: "buffalo_stack_n_sync",
        name: "Buffalo Stack 'n Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/buffalo_stacknsync": {
        slug: "buffalo_stacknsync",
        name: "Buffalo Stack'n'Sync",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/bullets_and_bounty": {
        slug: "bullets_and_bounty",
        name: "Bullets and Bounty",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_compass": {
        slug: "cash_compass",
        name: "Cash Compass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_crew": {
        slug: "cash_crew",
        name: "Cash Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_crooks": {
        slug: "cash_crooks",
        name: "Cash Crooks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_pool": {
        slug: "cash_pool",
        name: "Cash Pool",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_quest": {
        slug: "cash_quest",
        name: "Cash Quest",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_vault_i": {
        slug: "cash_vault_i",
        name: "Cash Vault I",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cash_vault_ii": {
        slug: "cash_vault_ii",
        name: "Cash Vault II",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew": {
        slug: "chaos_crew",
        name: "Chaos Crew",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_2": {
        slug: "chaos_crew_2",
        name: "Chaos Crew 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_3": {
        slug: "chaos_crew_3",
        name: "Chaos Crew 3",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/chaos_crew_scratch": {
        slug: "chaos_crew_scratch",
        name: "Chaos Crew Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/circle_of_life": {
        slug: "circle_of_life",
        name: "Circle of Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cloud_princess": {
        slug: "cloud_princess",
        name: "Cloud Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/coffee_dealer": {
        slug: "coffee_dealer",
        name: "Coffee Dealer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/coins": {
        slug: "coins",
        name: "Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/colors": {
        slug: "colors",
        name: "Colors",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/crazy_donuts": {
        slug: "crazy_donuts",
        name: "Crazy Donuts",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cubes": {
        slug: "cubes",
        name: "Cubes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cubes_2": {
        slug: "cubes_2",
        name: "Cubes 2",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cursed_crypt": {
        slug: "cursed_crypt",
        name: "Cursed Crypt",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/cut_the_grass": {
        slug: "cut_the_grass",
        name: "Cut the Grass",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dandy_diamonds": {
        slug: "dandy_diamonds",
        name: "Dandy Diamonds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/danny_dollar": {
        slug: "danny_dollar",
        name: "Danny Dollar",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dark_spiral_94": {
        slug: "dark_spiral_94",
        name: "Dark Spiral 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dark_summoning": {
        slug: "dark_summoning",
        name: "Dark Summoning",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dawn_of_kings": {
        slug: "dawn_of_kings",
        name: "Dawn of Kings",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/deal_with_death": {
        slug: "deal_with_death",
        name: "Deal with Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/death_becomes_you": {
        slug: "death_becomes_you",
        name: "Death Becomes You",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/demonic_dolls": {
        slug: "demonic_dolls",
        name: "Demonic Dolls",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/densho": {
        slug: "densho",
        name: "Densho",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/diamond_rush": {
        slug: "diamond_rush",
        name: "Diamond Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/divine_drop": {
        slug: "divine_drop",
        name: "Divine Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donny_and_danny": {
        slug: "donny_and_danny",
        name: "Donny and Danny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donny_dough": {
        slug: "donny_dough",
        name: "Donny Dough",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/donut_division": {
        slug: "donut_division",
        name: "Donut Division",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dork_unit": {
        slug: "dork_unit",
        name: "Dork Unit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/double_rainbow": {
        slug: "double_rainbow",
        name: "Double Rainbow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/double_salary_1_year": {
        slug: "double_salary_1_year",
        name: "Double Salary 1 Year",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dr_zappo": {
        slug: "dr_zappo",
        name: "Dr Zappo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dragons_domain": {
        slug: "dragons_domain",
        name: "Dragon's Domain",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dream_car_speed": {
        slug: "dream_car_speed",
        name: "Dream Car Speed",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dream_car_urban": {
        slug: "dream_car_urban",
        name: "Dream Car Urban",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dropem": {
        slug: "dropem",
        name: "Drop'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/duel_at_dawn": {
        slug: "duel_at_dawn",
        name: "Duel at Dawn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dusk_princess_94": {
        slug: "dusk_princess_94",
        name: "Dusk Princess 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/dynasty_of_death": {
        slug: "dynasty_of_death",
        name: "Dynasty of Death",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eggstra_cash": {
        slug: "eggstra_cash",
        name: "Eggstra Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/epic_bullets_and_bounty_94": {
        slug: "epic_bullets_and_bounty_94",
        name: "Epic Bullets and Bounty 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/epic_ze_zeus": {
        slug: "epic_ze_zeus",
        name: "Epic Ze Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eternal_duel_94": {
        slug: "eternal_duel_94",
        name: "Eternal Duel 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/evil_eyes": {
        slug: "evil_eyes",
        name: "Evil Eyes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/express_200_scratch": {
        slug: "express_200_scratch",
        name: "Express 200 Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eye_of_medusa": {
        slug: "eye_of_medusa",
        name: "Eye of Medusa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/eye_of_the_panda": {
        slug: "eye_of_the_panda",
        name: "Eye of the Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fear_the_dark": {
        slug: "fear_the_dark",
        name: "Fear the Dark",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/feel_the_beat": {
        slug: "feel_the_beat",
        name: "Feel The Beat",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fighter_pit": {
        slug: "fighter_pit",
        name: "Fighter Pit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fire_my_laser": {
        slug: "fire_my_laser",
        name: "Fire my Laser",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fist_of_destruction": {
        slug: "fist_of_destruction",
        name: "Fist Of Destruction",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fist_of_destruction_megamultiplier": {
        slug: "fist_of_destruction_megamultiplier",
        name: "Fist of Destruction Megamultiplier",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/football_scratch": {
        slug: "football_scratch",
        name: "Football Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/forest_fortune": {
        slug: "forest_fortune",
        name: "Forest Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/franks_farm": {
        slug: "franks_farm",
        name: "Frank's Farm",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/freds_food_truck": {
        slug: "freds_food_truck",
        name: "Fred's Food Truck",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frkn_bananas": {
        slug: "frkn_bananas",
        name: "FRKN Bananas",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frogs_scratch": {
        slug: "frogs_scratch",
        name: "Frogs Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/fruit_duel": {
        slug: "fruit_duel",
        name: "Fruit Duel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/frutz": {
        slug: "frutz",
        name: "Frutz",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/get_the_cheese": {
        slug: "get_the_cheese",
        name: "Get the CHEESE",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gladiator_legends": {
        slug: "gladiator_legends",
        name: "Gladiator Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/go_panda": {
        slug: "go_panda",
        name: "Go Panda",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gold_coins": {
        slug: "gold_coins",
        name: "Gold Coins",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/great_game_rockies": {
        slug: "great_game_rockies",
        name: "Great Game Rockies",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/great_game_serengeti": {
        slug: "great_game_serengeti",
        name: "Great Game Serengeti",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/gronks_gems": {
        slug: "gronks_gems",
        name: "Gronk's Gems",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/grug_make_fire": {
        slug: "grug_make_fire",
        name: "Grug Make Fire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hand_of_anubis": {
        slug: "hand_of_anubis",
        name: "Hand of Anubis",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/happy_scratch": {
        slug: "happy_scratch",
        name: "Happy Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/harvest_wilds": {
        slug: "harvest_wilds",
        name: "Harvest Wilds",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hilo": {
        slug: "hilo",
        name: "HiLo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hopnpop": {
        slug: "hopnpop",
        name: "Hop'n'Pop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hot_ross_94": {
        slug: "hot_ross_94",
        name: "Hot Ross 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/hounds_of_hell": {
        slug: "hounds_of_hell",
        name: "Hounds of Hell",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/immortal_desire": {
        slug: "immortal_desire",
        name: "Immortal Desire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/invictus": {
        slug: "invictus",
        name: "Invictus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/itero": {
        slug: "itero",
        name: "ITERO",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/its_bananas": {
        slug: "its_bananas",
        name: "It's bananas!",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/jaws_of_justice": {
        slug: "jaws_of_justice",
        name: "Jaws of Justice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/jelly_slice": {
        slug: "jelly_slice",
        name: "Jelly Slice",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/joker_bombs": {
        slug: "joker_bombs",
        name: "Joker Bombs",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/keepem": {
        slug: "keepem",
        name: "Keep'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/king_carrot": {
        slug: "king_carrot",
        name: "King Carrot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/king_treasure": {
        slug: "king_treasure",
        name: "King Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/klowns": {
        slug: "klowns",
        name: "Klowns",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/koi_cash": {
        slug: "koi_cash",
        name: "Koi Cash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_bandit": {
        slug: "le_bandit",
        name: "Le Bandit",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_bandit_hold_and_win": {
        slug: "le_bandit_hold_and_win",
        name: "Le Bandit Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_bunny": {
        slug: "le_bunny",
        name: "Le Bunny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_cowboy": {
        slug: "le_cowboy",
        name: "Le Cowboy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_digger": {
        slug: "le_digger",
        name: "Le Digger",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_fisherman": {
        slug: "le_fisherman",
        name: "Le Fisherman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_football_fan": {
        slug: "le_football_fan",
        name: "Le Football Fan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_hooligan": {
        slug: "le_hooligan",
        name: "Le Hooligan",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_king": {
        slug: "le_king",
        name: "Le King",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_pharaoh": {
        slug: "le_pharaoh",
        name: "Le Pharaoh",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_prachaun": {
        slug: "le_prachaun",
        name: "Le Prachaun",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_santa": {
        slug: "le_santa",
        name: "Le Santa",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_soccer": {
        slug: "le_soccer",
        name: "Le Soccer",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_vampire": {
        slug: "le_vampire",
        name: "Le Vampire",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_viking": {
        slug: "le_viking",
        name: "Le Viking",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/le_zeus": {
        slug: "le_zeus",
        name: "Le Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/let_it_snow": {
        slug: "let_it_snow",
        name: "Let It Snow",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/limbo": {
        slug: "limbo",
        name: "Limbo",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lines": {
        slug: "lines",
        name: "Lines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/love_is_all_you_need": {
        slug: "love_is_all_you_need",
        name: "LOVE is all you need",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x12": {
        slug: "lucky_numbers_x12",
        name: "Lucky Numbers x12",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x16": {
        slug: "lucky_numbers_x16",
        name: "Lucky Numbers x16",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x20": {
        slug: "lucky_numbers_x20",
        name: "Lucky Numbers x20",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_numbers_x8": {
        slug: "lucky_numbers_x8",
        name: "Lucky Numbers x8",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_scratch": {
        slug: "lucky_scratch",
        name: "Lucky Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/lucky_shot": {
        slug: "lucky_shot",
        name: "Lucky Shot",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/magic_piggy": {
        slug: "magic_piggy",
        name: "Magic Piggy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/magic_piggy_og": {
        slug: "magic_piggy_og",
        name: "Magic Piggy OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters": {
        slug: "marlin_masters",
        name: "Marlin Masters",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_atlantis_94": {
        slug: "marlin_masters_atlantis_94",
        name: "Marlin Masters: Atlantis 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_og": {
        slug: "marlin_masters_og",
        name: "Marlin Masters OG",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/marlin_masters_the_big_haul": {
        slug: "marlin_masters_the_big_haul",
        name: "Marlin Masters: The Big Haul",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/max_win_machine": {
        slug: "max_win_machine",
        name: "Max Win Machine",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mayan_stackways": {
        slug: "mayan_stackways",
        name: "Mayan Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/miami_mayhem": {
        slug: "miami_mayhem",
        name: "Miami Mayhem",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/miami_multiplier": {
        slug: "miami_multiplier",
        name: "Miami Multiplier",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mighty_masks": {
        slug: "mighty_masks",
        name: "Mighty Masks",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mines_supreme": {
        slug: "mines_supreme",
        name: "Mines Supreme",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/minted_mike": {
        slug: "minted_mike",
        name: "Minted Mike",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/moneyplane_bail2win": {
        slug: "moneyplane_bail2win",
        name: "Moneyplane Bail2Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/munchy_milo_94": {
        slug: "munchy_milo_94",
        name: "Munchy Milo 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/mystery_motel": {
        slug: "mystery_motel",
        name: "Mystery Motel",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/nitro_nights": {
        slug: "nitro_nights",
        name: "Nitro Nights",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/octo_attack": {
        slug: "octo_attack",
        name: "Octo Attack",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/omnom": {
        slug: "omnom",
        name: "OmNom",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/orb_of_destiny": {
        slug: "orb_of_destiny",
        name: "Orb of Destiny",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/outlaws_inc": {
        slug: "outlaws_inc",
        name: "Outlaws Inc.",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/phoenix_duelreels": {
        slug: "phoenix_duelreels",
        name: "Phoenix DuelReels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/power_of_ten": {
        slug: "power_of_ten",
        name: "Power of Ten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pray_for_six": {
        slug: "pray_for_six",
        name: "Pray for Six",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pray_for_three": {
        slug: "pray_for_three",
        name: "Pray for Three",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/prince_treasure": {
        slug: "prince_treasure",
        name: "Prince Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/pug_life": {
        slug: "pug_life",
        name: "Pug Life",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/queen_treasure": {
        slug: "queen_treasure",
        name: "Queen Treasure",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rad_maxx": {
        slug: "rad_maxx",
        name: "Rad Maxx",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rainbow_princess": {
        slug: "rainbow_princess",
        name: "Rainbow Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rat_riches": {
        slug: "rat_riches",
        name: "Rat Riches",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/red_rascal": {
        slug: "red_rascal",
        name: "Red Rascal",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rip_city": {
        slug: "rip_city",
        name: "RIP City",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rise_of_fortuna": {
        slug: "rise_of_fortuna",
        name: "Rise of Fortuna",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rise_of_ymir": {
        slug: "rise_of_ymir",
        name: "Rise of Ymir",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rocket_reels": {
        slug: "rocket_reels",
        name: "Rocket Reels",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ronin_stackways": {
        slug: "ronin_stackways",
        name: "Ronin Stackways",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rotten": {
        slug: "rotten",
        name: "Rotten",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ruby_rush": {
        slug: "ruby_rush",
        name: "Ruby Rush",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/rusty_and_curly": {
        slug: "rusty_and_curly",
        name: "Rusty and Curly",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sand_and_ashes": {
        slug: "sand_and_ashes",
        name: "Sand and Ashes",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_bronze": {
        slug: "scratch_bronze",
        name: "SCRATCH! Bronze",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_em": {
        slug: "scratch_em",
        name: "Scratch 'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_gold": {
        slug: "scratch_gold",
        name: "SCRATCH! Gold",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_platinum": {
        slug: "scratch_platinum",
        name: "SCRATCH! Platinum",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratch_silver": {
        slug: "scratch_silver",
        name: "SCRATCH! Silver",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchem": {
        slug: "scratchem",
        name: "Scratch’em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy": {
        slug: "scratchy",
        name: "Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy_big": {
        slug: "scratchy_big",
        name: "Scratchy Big",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/scratchy_mini": {
        slug: "scratchy_mini",
        name: "Scratchy Mini",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/shave_the_beard": {
        slug: "shave_the_beard",
        name: "Shave the Beard",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/shave_the_sheep": {
        slug: "shave_the_sheep",
        name: "Shave the Sheep",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sixsixsix": {
        slug: "sixsixsix",
        name: "SixSixSix",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/slayers_inc": {
        slug: "slayers_inc",
        name: "Slayers Inc",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/smoking_dragon": {
        slug: "smoking_dragon",
        name: "Smoking Dragon",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/snow_scratcher": {
        slug: "snow_scratcher",
        name: "Snow Scratcher",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/snow_slingers": {
        slug: "snow_slingers",
        name: "Snow Slingers",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spear_of_athena": {
        slug: "spear_of_athena",
        name: "Spear of Athena",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/speed_crash": {
        slug: "speed_crash",
        name: "Speed Crash",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spinman": {
        slug: "spinman",
        name: "Spinman",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/spooky_scary_scratchy": {
        slug: "spooky_scary_scratchy",
        name: "Spooky Scary Scratchy",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stack_em": {
        slug: "stack_em",
        name: "Stack 'Em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stackem": {
        slug: "stackem",
        name: "Stack'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/steamrunners": {
        slug: "steamrunners",
        name: "Steamrunners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stickem": {
        slug: "stickem",
        name: "Stick'em",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stormborn": {
        slug: "stormborn",
        name: "Stormborn",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/stormforged": {
        slug: "stormforged",
        name: "Stormforged",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/strength_of_hercules": {
        slug: "strength_of_hercules",
        name: "Strength of Hercules",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/summer_scratch": {
        slug: "summer_scratch",
        name: "Summer Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/sun_princess": {
        slug: "sun_princess",
        name: "Sun Princess",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/supernova_galaxy_orbs_hold_and_win": {
        slug: "supernova_galaxy_orbs_hold_and_win",
        name: "Supernova Galaxy Orbs Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/superstar_sevens_94": {
        slug: "superstar_sevens_94",
        name: "Superstar Sevens 94",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/supreme_zeus": {
        slug: "supreme_zeus",
        name: "Supreme Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tai_the_toad": {
        slug: "tai_the_toad",
        name: "Tai the Toad",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tasty_treats": {
        slug: "tasty_treats",
        name: "Tasty Treats",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/temple_of_torment": {
        slug: "temple_of_torment",
        name: "Temple of Torment",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_bowery_boys": {
        slug: "the_bowery_boys",
        name: "The Bowery Boys",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_count": {
        slug: "the_count",
        name: "The Count",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_jade_path_hold_and_win": {
        slug: "the_jade_path_hold_and_win",
        name: "The Jade Path Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_luxe": {
        slug: "the_luxe",
        name: "The Luxe",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_perfect_scratch": {
        slug: "the_perfect_scratch",
        name: "The Perfect Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_respinners": {
        slug: "the_respinners",
        name: "The Respinners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/the_wildwood_curse": {
        slug: "the_wildwood_curse",
        name: "The Wildwood Curse",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tiger_legends": {
        slug: "tiger_legends",
        name: "Tiger Legends",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tiger_scratch": {
        slug: "tiger_scratch",
        name: "Tiger Scratch",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/time_spinners": {
        slug: "time_spinners",
        name: "Time Spinners",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/toshi_video_club": {
        slug: "toshi_video_club",
        name: "Toshi Video Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/toshi_ways_club": {
        slug: "toshi_ways_club",
        name: "Toshi Ways Club",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/tres_pinatas_hold_and_win": {
        slug: "tres_pinatas_hold_and_win",
        name: "Tres Pinatas Hold and Win",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/twentyone": {
        slug: "twentyone",
        name: "TwentyOne",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/twisted_lab": {
        slug: "twisted_lab",
        name: "Twisted Lab",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ultimate_slot_of_america": {
        slug: "ultimate_slot_of_america",
        name: "Ultimate Slot of America",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/undead_fortune": {
        slug: "undead_fortune",
        name: "Undead Fortune",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/vending_machine": {
        slug: "vending_machine",
        name: "Vending Machine",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/wanted_dead_or_a_wild": {
        slug: "wanted_dead_or_a_wild",
        name: "Wanted Dead or a Wild",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/wicked_grin": {
        slug: "wicked_grin",
        name: "Wicked Grin",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/wings_of_horus": {
        slug: "wings_of_horus",
        name: "Wings of Horus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/xmas_drop": {
        slug: "xmas_drop",
        name: "Xmas Drop",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/ze_zeus": {
        slug: "ze_zeus",
        name: "Ze Zeus",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hacksaw-gaming/zeus_ze_zecond": {
        slug: "zeus_ze_zecond",
        name: "Zeus Ze Zecond",
        provider: "Hacksaw Gaming",
        providerSlug: "hacksaw-gaming"
    },
    "hissho-dragon/aaaahhhh_wild_king": {
        slug: "aaaahhhh_wild_king",
        name: "Aaaahhhh! Wild King",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/dragon_princess": {
        slug: "dragon_princess",
        name: "Dragon Princess",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/guan_di": {
        slug: "guan_di",
        name: "Guan Di",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/happy_green": {
        slug: "happy_green",
        name: "Happy Green",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/inimitable_sweets": {
        slug: "inimitable_sweets",
        name: "Inimitable Sweets",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/lucky_cat": {
        slug: "lucky_cat",
        name: "Lucky Cat",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/spanking_piggy": {
        slug: "spanking_piggy",
        name: "Spanking Piggy",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/the_vault_gold_and_silver": {
        slug: "the_vault_gold_and_silver",
        name: "The Vault Gold And Silver",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/trance_wild": {
        slug: "trance_wild",
        name: "Trance Wild",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/ultra_hot_animals": {
        slug: "ultra_hot_animals",
        name: "Ultra Hot Animals",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "hissho-dragon/volcanic_eruption": {
        slug: "volcanic_eruption",
        name: "Volcanic Eruption",
        provider: "Hissho Dragon",
        providerSlug: "hissho-dragon"
    },
    "holdyourhat/cooked": {
        slug: "cooked",
        name: "Cooked",
        provider: "Holdyourhat",
        providerSlug: "holdyourhat"
    },
    "hot-rise-games/medusa_hot_1": {
        slug: "medusa_hot_1",
        name: "Medusa Hot 1",
        provider: "Hot Rise Games",
        providerSlug: "hot-rise-games"
    },
    "iconic21/88_lucky_coins": {
        slug: "88_lucky_coins",
        name: "88 Lucky Coins",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/arrow_chase": {
        slug: "arrow_chase",
        name: "Arrow Chase",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/bass_hunter_bonanza": {
        slug: "bass_hunter_bonanza",
        name: "Bass Hunter Bonanza",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/bet_on_teen_patti": {
        slug: "bet_on_teen_patti",
        name: "Bet on Teen Patti",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/big_marlin_rush": {
        slug: "big_marlin_rush",
        name: "Big Marlin Rush",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blackjack_360_midday": {
        slug: "blackjack_360_midday",
        name: "Blackjack 360 Midday",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blackjack_360_midnight": {
        slug: "blackjack_360_midnight",
        name: "Blackjack 360 Midnight",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blackjack_360_sunrise": {
        slug: "blackjack_360_sunrise",
        name: "Blackjack 360 Sunrise",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blackjack_360_sunset": {
        slug: "blackjack_360_sunset",
        name: "Blackjack 360 Sunset",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blackjack_bonus_live": {
        slug: "blackjack_bonus_live",
        name: "Blackjack Bonus Live",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blitz_blackjack_midday": {
        slug: "blitz_blackjack_midday",
        name: "Blitz Blackjack Midday",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blitz_blackjack_midnight": {
        slug: "blitz_blackjack_midnight",
        name: "Blitz Blackjack Midnight",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blitz_blackjack_sunrise": {
        slug: "blitz_blackjack_sunrise",
        name: "Blitz Blackjack Sunrise",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blitz_blackjack_sunset": {
        slug: "blitz_blackjack_sunset",
        name: "Blitz Blackjack Sunset",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/blossom_temple": {
        slug: "blossom_temple",
        name: "Blossom Temple",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/bubble_craps": {
        slug: "bubble_craps",
        name: "Bubble Craps",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/buffalo_250_anniversary": {
        slug: "buffalo_250_anniversary",
        name: "Buffalo 250 Anniversary",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/buffalo_bonanza_hold_and_win": {
        slug: "buffalo_bonanza_hold_and_win",
        name: "Buffalo Bonanza Hold and Win",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/buffalo_wild_collection": {
        slug: "buffalo_wild_collection",
        name: "Buffalo Wild Collection",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/capy_cauldrons": {
        slug: "capy_cauldrons",
        name: "Capy Cauldrons",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/chicken_run": {
        slug: "chicken_run",
        name: "Chicken Run",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/crash": {
        slug: "crash",
        name: "Crash",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/crash_live": {
        slug: "crash_live",
        name: "Crash Live",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/cricket_blackjack": {
        slug: "cricket_blackjack",
        name: "Cricket Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/cricket_premier_blackjack": {
        slug: "cricket_premier_blackjack",
        name: "Cricket Premier Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/cricket_roulette": {
        slug: "cricket_roulette",
        name: "Cricket Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/football_cup_blackjack_360": {
        slug: "football_cup_blackjack_360",
        name: "Football Cup Blackjack 360",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/ghost_road": {
        slug: "ghost_road",
        name: "Ghost Road",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/grand_bank": {
        slug: "grand_bank",
        name: "Grand Bank",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/grand_bonus_baccarat": {
        slug: "grand_bonus_baccarat",
        name: "Grand Bonus Baccarat",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/grand_bonus_blackjack": {
        slug: "grand_bonus_blackjack",
        name: "Grand Bonus Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_auto_roulette": {
        slug: "gravity_auto_roulette",
        name: "Gravity Auto Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_blackjack": {
        slug: "gravity_blackjack",
        name: "Gravity Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_plinko": {
        slug: "gravity_plinko",
        name: "Gravity Plinko",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_poker": {
        slug: "gravity_poker",
        name: "Gravity Poker",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_roulette": {
        slug: "gravity_roulette",
        name: "Gravity Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_sic_bo": {
        slug: "gravity_sic_bo",
        name: "Gravity Sic Bo",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/gravity_wheel": {
        slug: "gravity_wheel",
        name: "Gravity Wheel",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/hi_lo": {
        slug: "hi_lo",
        name: "Hi Lo",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/huff_house_bonanza_2": {
        slug: "huff_house_bonanza_2",
        name: "Huff House Bonanza 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/huff_house_bonanza_94": {
        slug: "huff_house_bonanza_94",
        name: "Huff House Bonanza 94",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/idealer_blackjack": {
        slug: "idealer_blackjack",
        name: "iDealer Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/idealer_boulevard_blackjack": {
        slug: "idealer_boulevard_blackjack",
        name: "iDealer Boulevard Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/instant_win_blackjack": {
        slug: "instant_win_blackjack",
        name: "Instant Win Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/instant_win_blackjack_social": {
        slug: "instant_win_blackjack_social",
        name: "Instant Win Blackjack Social",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/jack_and_the_wild_beanstalk": {
        slug: "jack_and_the_wild_beanstalk",
        name: "Jack and the Wild Beanstalk",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/keno": {
        slug: "keno",
        name: "Keno",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/knock_knock": {
        slug: "knock_knock",
        name: "Knock Knock",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/las_piggas_94": {
        slug: "las_piggas_94",
        name: "Las Piggas 94",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/lightspeed": {
        slug: "lightspeed",
        name: "Lightspeed",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/limbo": {
        slug: "limbo",
        name: "Limbo",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/live_baccarat_1": {
        slug: "live_baccarat_1",
        name: "Live Baccarat 1",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/live_baccarat_1_nc": {
        slug: "live_baccarat_1_nc",
        name: "Live Baccarat 1 NC",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/live_french_roulette": {
        slug: "live_french_roulette",
        name: "Live French Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/live_lobby": {
        slug: "live_lobby",
        name: "Live Lobby",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/live_roulette": {
        slug: "live_roulette",
        name: "Live Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/medusa_vs_perseus_stone_duel_94": {
        slug: "medusa_vs_perseus_stone_duel_94",
        name: "Medusa vs Perseus Stone Duel 94",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/mines_94": {
        slug: "mines_94",
        name: "Mines 94",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/mythic_link_monkey_king": {
        slug: "mythic_link_monkey_king",
        name: "Mythic Link: Monkey King",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/oasis_blackjack": {
        slug: "oasis_blackjack",
        name: "Oasis Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/oasis_blackjack_2": {
        slug: "oasis_blackjack_2",
        name: "Oasis Blackjack 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/oasis_vip_blackjack": {
        slug: "oasis_vip_blackjack",
        name: "Oasis VIP Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/packs": {
        slug: "packs",
        name: "Packs",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/patricks_lucky_fortune": {
        slug: "patricks_lucky_fortune",
        name: "Patrick's Lucky Fortune",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/prime_blackjack_1": {
        slug: "prime_blackjack_1",
        name: "Prime Blackjack 1",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/prime_blackjack_2": {
        slug: "prime_blackjack_2",
        name: "Prime Blackjack 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/prime_blackjack_3": {
        slug: "prime_blackjack_3",
        name: "Prime Blackjack 3",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/prime_blackjack_4": {
        slug: "prime_blackjack_4",
        name: "Prime Blackjack 4",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/private_edition_blackjack": {
        slug: "private_edition_blackjack",
        name: "Private Edition Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/roulette_lite": {
        slug: "roulette_lite",
        name: "Roulette Lite",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/royal_roulette": {
        slug: "royal_roulette",
        name: "Royal Roulette",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/soccer_world_championship": {
        slug: "soccer_world_championship",
        name: "Soccer World Championship",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/speed_blackjack": {
        slug: "speed_blackjack",
        name: "Speed Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/speed_blackjack_2": {
        slug: "speed_blackjack_2",
        name: "Speed Blackjack 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/speed_blackjack_3": {
        slug: "speed_blackjack_3",
        name: "Speed Blackjack 3",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/speed_blackjack_4": {
        slug: "speed_blackjack_4",
        name: "Speed Blackjack 4",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/spooky_blackjack_1": {
        slug: "spooky_blackjack_1",
        name: "Spooky Blackjack 1",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/spooky_blackjack_2": {
        slug: "spooky_blackjack_2",
        name: "Spooky Blackjack 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/squeeze_baccarat": {
        slug: "squeeze_baccarat",
        name: "Squeeze Baccarat",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/sugar_kingdom_bonanza": {
        slug: "sugar_kingdom_bonanza",
        name: "Sugar Kingdom Bonanza",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/sugar_kingdom_halloween": {
        slug: "sugar_kingdom_halloween",
        name: "Sugar Kingdom Halloween",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/sweet_royale": {
        slug: "sweet_royale",
        name: "Sweet Royale",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/sweet_royale_xmas": {
        slug: "sweet_royale_xmas",
        name: "Sweet Royale Xmas",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/take_deal_or_risk_blackjack": {
        slug: "take_deal_or_risk_blackjack",
        name: "Take Deal or Risk Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/the_kickoff": {
        slug: "the_kickoff",
        name: "The Kickoff",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/top_card": {
        slug: "top_card",
        name: "Top Card",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/viking_wild_feast": {
        slug: "viking_wild_feast",
        name: "Viking Wild Feast",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/vip_baccarat": {
        slug: "vip_baccarat",
        name: "VIP Baccarat",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/vip_blackjack": {
        slug: "vip_blackjack",
        name: "VIP Blackjack",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/vip_nc_baccarat": {
        slug: "vip_nc_baccarat",
        name: "VIP NC Baccarat",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/virtual_dragon_tiger": {
        slug: "virtual_dragon_tiger",
        name: "Virtual Dragon Tiger",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/virtual_top_card": {
        slug: "virtual_top_card",
        name: "Virtual Top Card",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/wild_gold_mine": {
        slug: "wild_gold_mine",
        name: "Wild Gold Mine",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/wild_gold_mine_2": {
        slug: "wild_gold_mine_2",
        name: "Wild Gold Mine 2",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/wild_tornado_ranch": {
        slug: "wild_tornado_ranch",
        name: "Wild Tornado Ranch",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "iconic21/wolfs_moon_fortune": {
        slug: "wolfs_moon_fortune",
        name: "Wolf's Moon Fortune",
        provider: "Iconic21",
        providerSlug: "iconic21"
    },
    "irondog/1_million_fortunes_megaways": {
        slug: "1_million_fortunes_megaways",
        name: "1 Million Fortunes Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/1_million_megaways_bc": {
        slug: "1_million_megaways_bc",
        name: "1 Million Megaways BC",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/12_volt_diamonds": {
        slug: "12_volt_diamonds",
        name: "12 Volt Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_apex_treasures": {
        slug: "3_apex_treasures",
        name: "3 Apex Treasures",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_capybaras": {
        slug: "3_capybaras",
        name: "3 Capybaras",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_cheeky_chimps": {
        slug: "3_cheeky_chimps",
        name: "3 Cheeky Chimps",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_christmas_fortunes": {
        slug: "3_christmas_fortunes",
        name: "3 Christmas Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_crazy_tikis": {
        slug: "3_crazy_tikis",
        name: "3 Crazy Tikis",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_dragon_pots_ultimate": {
        slug: "3_dragon_pots_ultimate",
        name: "3 Dragon Pots Ultimate",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_gods_of_goalympus": {
        slug: "3_gods_of_goalympus",
        name: "3 Gods of Goalympus",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_hot_chilli_peppers": {
        slug: "3_hot_chilli_peppers",
        name: "3 Hot Chilli Peppers",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_hot_chilli_peppers_extra": {
        slug: "3_hot_chilli_peppers_extra",
        name: "3 Hot Chilli Peppers Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_jewelling_diamonds": {
        slug: "3_jewelling_diamonds",
        name: "3 Jewelling Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_leprechaun_charms": {
        slug: "3_leprechaun_charms",
        name: "3 Leprechaun Charms",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_mad_frogs": {
        slug: "3_mad_frogs",
        name: "3 Mad Frogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_pinatas": {
        slug: "3_pinatas",
        name: "3 Pinatas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_plucky_hens": {
        slug: "3_plucky_hens",
        name: "3 Plucky Hens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_christmas": {
        slug: "3_porky_banks_christmas",
        name: "3 Porky Banks Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_hold_and_win": {
        slug: "3_porky_banks_hold_and_win",
        name: "3 Porky Banks Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_porky_banks_hold_and_win_extra": {
        slug: "3_porky_banks_hold_and_win_extra",
        name: "3 Porky Banks Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_runaway_riches": {
        slug: "3_runaway_riches",
        name: "3 Runaway Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_shooting_stars": {
        slug: "3_shooting_stars",
        name: "3 Shooting Stars",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_super_porky_banks": {
        slug: "3_super_porky_banks",
        name: "3 Super Porky Banks",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_top_dogs": {
        slug: "3_top_dogs",
        name: "3 Top Dogs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_wicked_devils": {
        slug: "3_wicked_devils",
        name: "3 Wicked Devils",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3_wild_aliens": {
        slug: "3_wild_aliens",
        name: "3 Wild Aliens",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_baccarat": {
        slug: "3d_baccarat",
        name: "3D Baccarat",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_blackjack": {
        slug: "3d_blackjack",
        name: "3D Blackjack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/3d_european_roulette": {
        slug: "3d_european_roulette",
        name: "3D European Roulette",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_crabbin_fortunes": {
        slug: "4_crabbin_fortunes",
        name: "4 Crabbin' Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_dragon_pots": {
        slug: "4_dragon_pots",
        name: "4 Dragon Pots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/4_wild_riches": {
        slug: "4_wild_riches",
        name: "4 Wild Riches",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/5x_hot_magma_multipliers": {
        slug: "5x_hot_magma_multipliers",
        name: "5x Hot Magma Multipliers",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/7s_v_bars": {
        slug: "7s_v_bars",
        name: "7s V Bars",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/8_treasures_luck_of_the_dragon": {
        slug: "8_treasures_luck_of_the_dragon",
        name: "8 Treasures Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/ahoy_royale": {
        slug: "ahoy_royale",
        name: "Ahoy Royale",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/apex_strike_lucky_cache": {
        slug: "apex_strike_lucky_cache",
        name: "Apex Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/apex_strike_megaways": {
        slug: "apex_strike_megaways",
        name: "Apex Strike Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/arriba_heat_salsa_wilds": {
        slug: "arriba_heat_salsa_wilds",
        name: "Arriba Heat Salsa Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/astro_newts_megaways": {
        slug: "astro_newts_megaways",
        name: "Astro Newts Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/aztec_wilds_megaways": {
        slug: "aztec_wilds_megaways",
        name: "Aztec Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/bacon_banker": {
        slug: "bacon_banker",
        name: "Bacon Banker",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/barbarian_gold": {
        slug: "barbarian_gold",
        name: "Barbarian Gold",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blackjack_classic": {
        slug: "blackjack_classic",
        name: "Blackjack Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blirix_workshop": {
        slug: "blirix_workshop",
        name: "Blirix workshop",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/blood_queen_scratch": {
        slug: "blood_queen_scratch",
        name: "Blood Queen Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/book_of_baal": {
        slug: "book_of_baal",
        name: "Book Of Ba'al",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/boom_time": {
        slug: "boom_time",
        name: "Boom Time",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/branded_book_of": {
        slug: "branded_book_of",
        name: "Branded Book Of",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/branded_megaways": {
        slug: "branded_megaways",
        name: "Branded Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/chain_reaction_hold_and_blitz": {
        slug: "chain_reaction_hold_and_blitz",
        name: "Chain Reaction Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cherry_blast_scratch": {
        slug: "cherry_blast_scratch",
        name: "Cherry Blast Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/christmas_megaways": {
        slug: "christmas_megaways",
        name: "Christmas Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cleopatras_fortune": {
        slug: "cleopatras_fortune",
        name: "Cleopatra's Fortune",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cosmic_crystals_scratch": {
        slug: "cosmic_crystals_scratch",
        name: "Cosmic Crystals Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/cowboy_showdown": {
        slug: "cowboy_showdown",
        name: "Cowboy Showdown",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/crazy_tiki_hold_and_win": {
        slug: "crazy_tiki_hold_and_win",
        name: "Crazy Tiki Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/crown_of_avalon": {
        slug: "crown_of_avalon",
        name: "Crown of Avalon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_extra": {
        slug: "diamond_charge_extra",
        name: "Diamond Charge Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_hold_and_win": {
        slug: "diamond_charge_hold_and_win",
        name: "Diamond Charge Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_charge_megaways": {
        slug: "diamond_charge_megaways",
        name: "Diamond Charge Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/diamond_supercharge": {
        slug: "diamond_supercharge",
        name: "Diamond Supercharge",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dolla_dolla_bill": {
        slug: "dolla_dolla_bill",
        name: "Dolla Dolla Bill",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dolla_dolla_bill_mo_money": {
        slug: "dolla_dolla_bill_mo_money",
        name: "Dolla Dolla Bill Mo Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/double_cash_mummy": {
        slug: "double_cash_mummy",
        name: "Double Cash Mummy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/dwarven_gems_megaways": {
        slug: "dwarven_gems_megaways",
        name: "Dwarven Gems Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike": {
        slug: "eagle_strike",
        name: "Eagle Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike_extra": {
        slug: "eagle_strike_extra",
        name: "Eagle Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/eagle_strike_lucky_cache": {
        slug: "eagle_strike_lucky_cache",
        name: "Eagle Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/everest_avalanche": {
        slug: "everest_avalanche",
        name: "Everest Avalanche",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/farming_frenzy": {
        slug: "farming_frenzy",
        name: "Farming Frenzy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/feeding_fury": {
        slug: "feeding_fury",
        name: "Feeding Fury",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fishin_and_crabbin": {
        slug: "fishin_and_crabbin",
        name: "Fishin' and Crabbin'",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/football_hold_and_blitz": {
        slug: "football_hold_and_blitz",
        name: "Football Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/forge_of_the_gods": {
        slug: "forge_of_the_gods",
        name: "Forge of the Gods",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruit_lightning": {
        slug: "fruit_lightning",
        name: "Fruit Lightning",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruit_lightning_3x5": {
        slug: "fruit_lightning_3x5",
        name: "Fruit Lightning 3x5",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruity_hold_and_blitz": {
        slug: "fruity_hold_and_blitz",
        name: "Fruity Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/fruity_megaways": {
        slug: "fruity_megaways",
        name: "Fruity Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gifts_of_ostara_scratch": {
        slug: "gifts_of_ostara_scratch",
        name: "Gifts of Ostara Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goal_blitz": {
        slug: "goal_blitz",
        name: "Goal Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goal_blitz_shootout": {
        slug: "goal_blitz_shootout",
        name: "Goal Blitz Shootout",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_asgard_megaways": {
        slug: "gods_of_asgard_megaways",
        name: "Gods Of Asgard Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_3_megaways": {
        slug: "gods_of_olympus_3_megaways",
        name: "Gods Of Olympus 3 Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_ii": {
        slug: "gods_of_olympus_ii",
        name: "Gods of Olympus II",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_iv": {
        slug: "gods_of_olympus_iv",
        name: "Gods of Olympus IV",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/gods_of_olympus_v": {
        slug: "gods_of_olympus_v",
        name: "Gods of Olympus V",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/goldstar_express": {
        slug: "goldstar_express",
        name: "Goldstar Express",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grand_ahoy": {
        slug: "grand_ahoy",
        name: "Grand Ahoy",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grizzly_strike": {
        slug: "grizzly_strike",
        name: "Grizzly Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/grizzly_strike_lucky_cache": {
        slug: "grizzly_strike_lucky_cache",
        name: "Grizzly Strike Lucky Cache",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/halloween_horrors_megaways": {
        slug: "halloween_horrors_megaways",
        name: "Halloween Horrors Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/hot_joker_fruits_20": {
        slug: "hot_joker_fruits_20",
        name: "Hot Joker Fruits 20",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/inspector_wilds": {
        slug: "inspector_wilds",
        name: "Inspector Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/jewelling_diamonds": {
        slug: "jewelling_diamonds",
        name: "Jewelling Diamonds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/jolly_bonus_wins": {
        slug: "jolly_bonus_wins",
        name: "Jolly Bonus Wins",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/leprechaun_charms_rainbow_jackpot": {
        slug: "leprechaun_charms_rainbow_jackpot",
        name: "Leprechaun Charms Rainbow Jackpot",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/loot_crab": {
        slug: "loot_crab",
        name: "Loot Crab",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/luck_of_the_dragon": {
        slug: "luck_of_the_dragon",
        name: "Luck of the Dragon",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/lucky_cauldron": {
        slug: "lucky_cauldron",
        name: "Lucky Cauldron",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mad_cabs": {
        slug: "mad_cabs",
        name: "Mad Cabs",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mad_cabs_hold_and_win": {
        slug: "mad_cabs_hold_and_win",
        name: "Mad Cabs Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack": {
        slug: "megaways_jack",
        name: "MegaWays Jack",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack_and_the_magic_beans": {
        slug: "megaways_jack_and_the_magic_beans",
        name: "MegaWays Jack and The Magic Beans",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/megaways_jack_frost": {
        slug: "megaways_jack_frost",
        name: "Megaways Jack Frost",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/merry_megaways": {
        slug: "merry_megaways",
        name: "Merry Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/moirai_blaze_scratch": {
        slug: "moirai_blaze_scratch",
        name: "Moirai Blaze Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/money_minecarts": {
        slug: "money_minecarts",
        name: "Money Minecarts",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/mr_porky_banker_cash_stash": {
        slug: "mr_porky_banker_cash_stash",
        name: "Mr Porky Banker: Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/neon_jungle_scratch": {
        slug: "neon_jungle_scratch",
        name: "Neon Jungle Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/paint_scratch": {
        slug: "paint_scratch",
        name: "Paint Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/piggy_bank_cash": {
        slug: "piggy_bank_cash",
        name: "Piggy Bank Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/piggy_bank_stash": {
        slug: "piggy_bank_stash",
        name: "Piggy Bank Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/pinata_go_go": {
        slug: "pinata_go_go",
        name: "Pinata Go Go",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/pirate_kingdom_megaways": {
        slug: "pirate_kingdom_megaways",
        name: "Pirate Kingdom Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/plucky_hens_cluck_yeah": {
        slug: "plucky_hens_cluck_yeah",
        name: "Plucky Hens: Cluck Yeah",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainbow_wilds_megaways": {
        slug: "rainbow_wilds_megaways",
        name: "Rainbow Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainbow_wilds_scratch": {
        slug: "rainbow_wilds_scratch",
        name: "Rainbow Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rainin_money": {
        slug: "rainin_money",
        name: "Rainin Money",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/red_zone_blitz": {
        slug: "red_zone_blitz",
        name: "Red Zone Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/red_zone_blitz_hold_and_win": {
        slug: "red_zone_blitz_hold_and_win",
        name: "Red Zone Blitz Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/robbin_robin": {
        slug: "robbin_robin",
        name: "Robbin Robin",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rock_the_reels_megaways": {
        slug: "rock_the_reels_megaways",
        name: "Rock the Reels Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/roulette_classic": {
        slug: "roulette_classic",
        name: "Roulette Classic",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/rum_and_raiders": {
        slug: "rum_and_raiders",
        name: "Rum and Raiders",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/santas_big_bash_megaways": {
        slug: "santas_big_bash_megaways",
        name: "Santa's Big Bash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/santas_express_hold_and_win": {
        slug: "santas_express_hold_and_win",
        name: "Santa's Express Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/savannah_strike": {
        slug: "savannah_strike",
        name: "Savannah Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/savannah_strike_extra": {
        slug: "savannah_strike_extra",
        name: "Savannah Strike Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sirens_kingdom": {
        slug: "sirens_kingdom",
        name: "Siren's Kingdom",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sirens_kingdom_scratch": {
        slug: "sirens_kingdom_scratch",
        name: "Siren's Kingdom Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/smoking_hot_fortunes": {
        slug: "smoking_hot_fortunes",
        name: "Smoking Hot Fortunes",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/soccer_hold_and_blitz": {
        slug: "soccer_hold_and_blitz",
        name: "Soccer Hold and Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/solar_nova": {
        slug: "solar_nova",
        name: "Solar Nova",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/solar_nova_megaways": {
        slug: "solar_nova_megaways",
        name: "Solar Nova Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/stampeding_strike": {
        slug: "stampeding_strike",
        name: "Stampeding Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/stickman_cash": {
        slug: "stickman_cash",
        name: "Stickman Cash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/super_diamond_charge_hold_and_win": {
        slug: "super_diamond_charge_hold_and_win",
        name: "Super Diamond Charge Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_blitz": {
        slug: "sweet_candy_blitz",
        name: "Sweet Candy Blitz",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_megaways": {
        slug: "sweet_candy_cash_megaways",
        name: "Sweet Candy Cash Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_megaways_deluxe": {
        slug: "sweet_candy_cash_megaways_deluxe",
        name: "Sweet Candy Cash Megaways Deluxe",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_cash_stash": {
        slug: "sweet_candy_cash_stash",
        name: "Sweet Candy Cash Stash",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/sweet_candy_christmas": {
        slug: "sweet_candy_christmas",
        name: "Sweet Candy Christmas",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_choice_is_yours_megaways": {
        slug: "the_choice_is_yours_megaways",
        name: "The Choice is Yours Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_curious_cabinet_scratch": {
        slug: "the_curious_cabinet_scratch",
        name: "The Curious Cabinet Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/the_golden_mummy_hold_and_win": {
        slug: "the_golden_mummy_hold_and_win",
        name: "The Golden Mummy Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/train_strike_hold_and_win": {
        slug: "train_strike_hold_and_win",
        name: "Train Strike Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/treasure_of_horus_scratch": {
        slug: "treasure_of_horus_scratch",
        name: "Treasure of Horus Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/tropical_thunder": {
        slug: "tropical_thunder",
        name: "Tropical Thunder",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/vegas_hold_and_win": {
        slug: "vegas_hold_and_win",
        name: "Vegas Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/vegas_hot_spots": {
        slug: "vegas_hot_spots",
        name: "Vegas Hot spots",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/viking_wilds_scratch": {
        slug: "viking_wilds_scratch",
        name: "Viking Wilds Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/waikiki_scratch": {
        slug: "waikiki_scratch",
        name: "Wai-Kiki Scratch",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds": {
        slug: "western_wilds",
        name: "Western Wilds",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds_hold_and_win": {
        slug: "western_wilds_hold_and_win",
        name: "Western Wilds Hold and Win",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/western_wilds_megaways": {
        slug: "western_wilds_megaways",
        name: "Western Wilds Megaways",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/wheel_of_porkies": {
        slug: "wheel_of_porkies",
        name: "Wheel of Porkies",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/wolf_strike": {
        slug: "wolf_strike",
        name: "Wolf Strike",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "irondog/wolf_strike_hold_and_win_extra": {
        slug: "wolf_strike_hold_and_win_extra",
        name: "Wolf Strike Hold and Win Extra",
        provider: "IronDog",
        providerSlug: "irondog"
    },
    "jacks/10_fruity_fire": {
        slug: "10_fruity_fire",
        name: "10 Fruity Fire",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_fruity_fire_and_pots": {
        slug: "10_fruity_fire_and_pots",
        name: "10 Fruity Fire and Pots",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_fruity_fire_deluxe": {
        slug: "10_fruity_fire_deluxe",
        name: "10 Fruity fire Deluxe",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_sizzling_staxx": {
        slug: "10_sizzling_staxx",
        name: "10 Sizzling Staxx",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_sizzling_staxx_and_pots": {
        slug: "10_sizzling_staxx_and_pots",
        name: "10 Sizzling Staxx and Pots",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_sliding_crown": {
        slug: "10_sliding_crown",
        name: "10 Sliding Crown",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_sliding_crown_and_pots": {
        slug: "10_sliding_crown_and_pots",
        name: "10 Sliding Crown and Pots",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_sliding_crown_deluxe": {
        slug: "10_sliding_crown_deluxe",
        name: "10 Sliding Crown Deluxe",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/10_wild_lock": {
        slug: "10_wild_lock",
        name: "10 WIld Lock",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/aloha_riches": {
        slug: "aloha_riches",
        name: "Aloha Riches",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/better_bass": {
        slug: "better_bass",
        name: "Better Bass",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/better_bass_crash": {
        slug: "better_bass_crash",
        name: "Better Bass Crash",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/book_of_glory": {
        slug: "book_of_glory",
        name: "Book of Glory",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/cash_of_cleopatra": {
        slug: "cash_of_cleopatra",
        name: "Cash of Cleopatra",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/cash_of_cleopatra_2": {
        slug: "cash_of_cleopatra_2",
        name: "Cash of Cleopatra 2",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/catsby_royale": {
        slug: "catsby_royale",
        name: "Catsby Royale",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/golden_wishes": {
        slug: "golden_wishes",
        name: "Golden Wishes",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hogs_of_valhalla": {
        slug: "hogs_of_valhalla",
        name: "Hogs of Valhalla",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hogs_of_valhalla_xmas": {
        slug: "hogs_of_valhalla_xmas",
        name: "Hogs of Valhalla Xmas",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hot_step": {
        slug: "hot_step",
        name: "Hot Step",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hot_step_2": {
        slug: "hot_step_2",
        name: "Hot Step 2",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hot_step_2_extreme": {
        slug: "hot_step_2_extreme",
        name: "Hot Step 2 Extreme",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/hot_step_3": {
        slug: "hot_step_3",
        name: "Hot Step 3",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/huff_n_wolf": {
        slug: "huff_n_wolf",
        name: "Huff n' Wolf",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/inferno_sevens": {
        slug: "inferno_sevens",
        name: "Inferno Sevens",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/racoon_riches": {
        slug: "racoon_riches",
        name: "Racoon Riches",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/spooky_step": {
        slug: "spooky_step",
        name: "Spooky Step",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/sugar_buzz": {
        slug: "sugar_buzz",
        name: "Sugar Buzz",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/thunder_step": {
        slug: "thunder_step",
        name: "Thunder Step",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/thunder_step_2": {
        slug: "thunder_step_2",
        name: "Thunder Step 2",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jacks/zeus_of_olympus": {
        slug: "zeus_of_olympus",
        name: "Zeus of Olympus",
        provider: "Jacks",
        providerSlug: "jacks"
    },
    "jili-games/10_sparkling_crown": {
        slug: "10_sparkling_crown",
        name: "10 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/100_blazing_clover": {
        slug: "100_blazing_clover",
        name: "100 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/20_blazing_clover": {
        slug: "20_blazing_clover",
        name: "20 Blazing Clover",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_charge_buffalo": {
        slug: "3_charge_buffalo",
        name: "3 Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_golden_ox": {
        slug: "3_coin_golden_ox",
        name: "3 Coin Golden Ox",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_treasures": {
        slug: "3_coin_treasures",
        name: "3 Coin Treasures",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_treasures_2": {
        slug: "3_coin_treasures_2",
        name: "3 Coin Treasures 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_wild_horse": {
        slug: "3_coin_wild_horse",
        name: "3 Coin Wild Horse",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_coin_wild_tiger": {
        slug: "3_coin_wild_tiger",
        name: "3 Coin Wild Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_baozhu": {
        slug: "3_lucky_baozhu",
        name: "3 Lucky Baozhu",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_lions": {
        slug: "3_lucky_lions",
        name: "3 Lucky Lions",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_lucky_piggy": {
        slug: "3_lucky_piggy",
        name: "3 Lucky Piggy",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_pot_dragons": {
        slug: "3_pot_dragons",
        name: "3 Pot Dragons",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/3_witchs_lamp": {
        slug: "3_witchs_lamp",
        name: "3 Witch's Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/40_sparkling_crown": {
        slug: "40_sparkling_crown",
        name: "40 Sparkling Crown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/7up7down": {
        slug: "7up7down",
        name: "7up7down",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/agent_ace": {
        slug: "agent_ace",
        name: "Agent Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ak47": {
        slug: "ak47",
        name: "AK47",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ali_baba": {
        slug: "ali_baba",
        name: "Ali Baba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/allstar_fishing": {
        slug: "allstar_fishing",
        name: "All-star Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/amar_akhbar_anthony": {
        slug: "amar_akhbar_anthony",
        name: "Amar Akhbar Anthony",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/arena_fighter": {
        slug: "arena_fighter",
        name: "Arena Fighter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/aztec_priestess": {
        slug: "aztec_priestess",
        name: "Aztec Priestess",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bangla_beauty": {
        slug: "bangla_beauty",
        name: "Bangla Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bao_boon_chin": {
        slug: "bao_boon_chin",
        name: "Bao boon chin",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/big_small": {
        slug: "big_small",
        name: "Big Small",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/big_small_casino_royale": {
        slug: "big_small_casino_royale",
        name: "Big Small Casino Royale",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bingo_adventure": {
        slug: "bingo_adventure",
        name: "Bingo Adventure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bingo_carnaval": {
        slug: "bingo_carnaval",
        name: "Bingo Carnaval",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/blackjack_lucky_ladies": {
        slug: "blackjack_lucky_ladies",
        name: "Blackjack Lucky Ladies",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bombing_fishing": {
        slug: "bombing_fishing",
        name: "Bombing Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bone_fortune": {
        slug: "bone_fortune",
        name: "Bone Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bonus_hunter": {
        slug: "bonus_hunter",
        name: "Bonus Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/book_of_gold": {
        slug: "book_of_gold",
        name: "Book of Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boom_legend": {
        slug: "boom_legend",
        name: "Boom Legend",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_extravaganza": {
        slug: "boxing_extravaganza",
        name: "Boxing Extravaganza",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_king": {
        slug: "boxing_king",
        name: "Boxing King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/boxing_king_title_match": {
        slug: "boxing_king_title_match",
        name: "Boxing King Title Match",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/bubble_beauty": {
        slug: "bubble_beauty",
        name: "Bubble Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/calaca_bingo": {
        slug: "calaca_bingo",
        name: "Calaca Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/candy_baby": {
        slug: "candy_baby",
        name: "Candy Baby",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/candyland_bingo": {
        slug: "candyland_bingo",
        name: "Candyland Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cash_balloon": {
        slug: "cash_balloon",
        name: "Cash balloon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/charge_buffalo": {
        slug: "charge_buffalo",
        name: "Charge Buffalo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/charge_buffalo_ascent": {
        slug: "charge_buffalo_ascent",
        name: "Charge Buffalo Ascent",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chicken_dash": {
        slug: "chicken_dash",
        name: "Chicken Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chicken_dash_1000": {
        slug: "chicken_dash_1000",
        name: "Chicken Dash 1000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/chin_shi_huang": {
        slug: "chin_shi_huang",
        name: "Chin Shi Huang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/circus_jackpot": {
        slug: "circus_jackpot",
        name: "Circus Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/circus_joker_4096": {
        slug: "circus_joker_4096",
        name: "Circus Joker 4096",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/clover_coins_3x3": {
        slug: "clover_coins_3x3",
        name: "Clover Coins 3x3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/clover_coins_3x5": {
        slug: "clover_coins_3x5",
        name: "Clover Coins 3x5",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/clover_coins_4x4": {
        slug: "clover_coins_4x4",
        name: "Clover Coins 4x4",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/coin_of_lightning": {
        slug: "coin_of_lightning",
        name: "Coin of Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/coin_tree": {
        slug: "coin_tree",
        name: "Coin Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/color_game": {
        slug: "color_game",
        name: "Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/color_prediction": {
        slug: "color_prediction",
        name: "Color Prediction",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_bonus": {
        slug: "crash_bonus",
        name: "Crash Bonus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_fruit": {
        slug: "crash_fruit",
        name: "Crash Fruit",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_puck": {
        slug: "crash_puck",
        name: "Crash Puck",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_touchdown": {
        slug: "crash_touchdown",
        name: "Crash Touchdown",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crash_trader": {
        slug: "crash_trader",
        name: "Crash Trader",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_777_2": {
        slug: "crazy_777_2",
        name: "Crazy 777 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_fafafa": {
        slug: "crazy_fafafa",
        name: "Crazy FaFaFa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_hunter": {
        slug: "crazy_hunter",
        name: "Crazy Hunter",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_hunter_2": {
        slug: "crazy_hunter_2",
        name: "Crazy Hunter 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy_pusher": {
        slug: "crazy_pusher",
        name: "Crazy Pusher",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crazy777": {
        slug: "crazy777",
        name: "Crazy777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_king_18": {
        slug: "cricket_king_18",
        name: "Cricket King 18",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_roulette": {
        slug: "cricket_roulette",
        name: "Cricket Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/cricket_sah_75": {
        slug: "cricket_sah_75",
        name: "Cricket Sah 75",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crown_of_fortune": {
        slug: "crown_of_fortune",
        name: "Crown of Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/crystal_777_deluxe": {
        slug: "crystal_777_deluxe",
        name: "Crystal 777 Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dabanggg": {
        slug: "dabanggg",
        name: "Dabanggg",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire": {
        slug: "devil_fire",
        name: "Devil Fire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire_2": {
        slug: "devil_fire_2",
        name: "Devil Fire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/devil_fire_twins": {
        slug: "devil_fire_twins",
        name: "Devil Fire Twins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/diamondparty": {
        slug: "diamondparty",
        name: "DiamondParty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dice_and_drop": {
        slug: "dice_and_drop",
        name: "Dice and Drop",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dinosaur_tycoon": {
        slug: "dinosaur_tycoon",
        name: "Dinosaur Tycoon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dinosaur_tycoon_ii": {
        slug: "dinosaur_tycoon_ii",
        name: "Dinosaur Tycoon II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_and_tiger": {
        slug: "dragon_and_tiger",
        name: "Dragon and Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_fortune": {
        slug: "dragon_fortune",
        name: "Dragon Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/dragon_treasure": {
        slug: "dragon_treasure",
        name: "Dragon Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/drop_ball": {
        slug: "drop_ball",
        name: "Drop Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/egypts_glow": {
        slug: "egypts_glow",
        name: "Egypt's Glow",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/elf_bingo": {
        slug: "elf_bingo",
        name: "Elf Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/extreme_color_game": {
        slug: "extreme_color_game",
        name: "Extreme Color Game",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fa_fa_fa": {
        slug: "fa_fa_fa",
        name: "Fa Fa Fa",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fengshen": {
        slug: "fengshen",
        name: "Fengshen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/football_golden_cup": {
        slug: "football_golden_cup",
        name: "Football Golden Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_bingo": {
        slug: "fortune_bingo",
        name: "Fortune Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_coins": {
        slug: "fortune_coins",
        name: "Fortune Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_coins_2": {
        slug: "fortune_coins_2",
        name: "Fortune Coins 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gartuda_500": {
        slug: "fortune_gartuda_500",
        name: "Fortune Gartuda 500",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_garuda_1000": {
        slug: "fortune_garuda_1000",
        name: "Fortune Garuda 1000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems": {
        slug: "fortune_gems",
        name: "Fortune Gems",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_2": {
        slug: "fortune_gems_2",
        name: "Fortune Gems 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_3": {
        slug: "fortune_gems_3",
        name: "Fortune Gems 3",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_500": {
        slug: "fortune_gems_500",
        name: "Fortune Gems 500",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_gems_scratch": {
        slug: "fortune_gems_scratch",
        name: "Fortune Gems Scratch",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_hook_boom": {
        slug: "fortune_hook_boom",
        name: "Fortune Hook Boom",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_king_jackpot": {
        slug: "fortune_king_jackpot",
        name: "Fortune King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_monkey": {
        slug: "fortune_monkey",
        name: "Fortune Monkey",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_roulette": {
        slug: "fortune_roulette",
        name: "Fortune Roulette",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_tree": {
        slug: "fortune_tree",
        name: "Fortune Tree",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortune_zombie": {
        slug: "fortune_zombie",
        name: "Fortune Zombie",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fortunepig": {
        slug: "fortunepig",
        name: "FortunePig",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/frog_dash": {
        slug: "frog_dash",
        name: "Frog Dash",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/fruity_wheel": {
        slug: "fruity_wheel",
        name: "Fruity Wheel",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/gem_party": {
        slug: "gem_party",
        name: "Gem Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_for_champion": {
        slug: "go_for_champion",
        name: "Go for Champion",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_goal_bingo": {
        slug: "go_goal_bingo",
        name: "Go Goal BIngo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/go_rush": {
        slug: "go_rush",
        name: "Go Rush",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/god_of_martial": {
        slug: "god_of_martial",
        name: "God Of Martial",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/gold_mine_express": {
        slug: "gold_mine_express",
        name: "Gold Mine Express",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_bank": {
        slug: "golden_bank",
        name: "Golden Bank",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_bank_2": {
        slug: "golden_bank_2",
        name: "Golden Bank 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_empire": {
        slug: "golden_empire",
        name: "Golden Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_empire_2": {
        slug: "golden_empire_2",
        name: "Golden Empire 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_joker": {
        slug: "golden_joker",
        name: "Golden Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_land": {
        slug: "golden_land",
        name: "Golden Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_queen": {
        slug: "golden_queen",
        name: "Golden Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_temple": {
        slug: "golden_temple",
        name: "Golden Temple",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_treasure": {
        slug: "golden_treasure",
        name: "Golden Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/golden_treasure_lightning": {
        slug: "golden_treasure_lightning",
        name: "Golden Treasure Lightning",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/happy_fishing": {
        slug: "happy_fishing",
        name: "Happy Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/happy_taxi": {
        slug: "happy_taxi",
        name: "Happy Taxi",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hawaii_beauty": {
        slug: "hawaii_beauty",
        name: "Hawaii Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hot_chilli": {
        slug: "hot_chilli",
        name: "Hot Chilli",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/hyper_burst": {
        slug: "hyper_burst",
        name: "Hyper Burst",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/irich_bingo": {
        slug: "irich_bingo",
        name: "iRich Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_bingo": {
        slug: "jackpot_bingo",
        name: "Jackpot Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_fishing": {
        slug: "jackpot_fishing",
        name: "Jackpot Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_fishing_2_shoot_and_win": {
        slug: "jackpot_fishing_2_shoot_and_win",
        name: "Jackpot Fishing 2 Shoot and Win",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_football": {
        slug: "jackpot_football",
        name: "Jackpot Football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_joker": {
        slug: "jackpot_joker",
        name: "Jackpot Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jackpot_joker_fever": {
        slug: "jackpot_joker_fever",
        name: "Jackpot Joker Fever",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jili_caishen": {
        slug: "jili_caishen",
        name: "JILI CAISHEN",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jogo_do_bicho": {
        slug: "jogo_do_bicho",
        name: "Jogo do Bicho",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/joker_coins": {
        slug: "joker_coins",
        name: "Joker Coins",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jokers_fortune": {
        slug: "jokers_fortune",
        name: "Joker's Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/journey_west_m": {
        slug: "journey_west_m",
        name: "Journey West M",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/jungle_king": {
        slug: "jungle_king",
        name: "Jungle King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno": {
        slug: "keno",
        name: "Keno",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno_bonus_number": {
        slug: "keno_bonus_number",
        name: "Keno Bonus Number",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/keno_extra_bet": {
        slug: "keno_extra_bet",
        name: "Keno Extra Bet",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/king_arthur": {
        slug: "king_arthur",
        name: "King Arthur",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_ball": {
        slug: "lucky_ball",
        name: "Lucky Ball",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_bingo": {
        slug: "lucky_bingo",
        name: "Lucky Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_caramelo": {
        slug: "lucky_caramelo",
        name: "Lucky Caramelo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_coming": {
        slug: "lucky_coming",
        name: "Lucky Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_goldbricks": {
        slug: "lucky_goldbricks",
        name: "Lucky Goldbricks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_jaguar": {
        slug: "lucky_jaguar",
        name: "Lucky Jaguar",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_jaguar_2": {
        slug: "lucky_jaguar_2",
        name: "Lucky Jaguar 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_macaw": {
        slug: "lucky_macaw",
        name: "Lucky Macaw",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_tiger": {
        slug: "lucky_tiger",
        name: "Lucky Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/lucky_tiger_2": {
        slug: "lucky_tiger_2",
        name: "Lucky Tiger 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/magic_lamp": {
        slug: "magic_lamp",
        name: "Magic Lamp",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/magic_lamp_bingo": {
        slug: "magic_lamp_bingo",
        name: "Magic Lamp Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/master_tiger": {
        slug: "master_tiger",
        name: "Master Tiger",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mayan_empire": {
        slug: "mayan_empire",
        name: "Mayan Empire",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mega_ace": {
        slug: "mega_ace",
        name: "Mega Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mega_fishing": {
        slug: "mega_fishing",
        name: "Mega Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_cricket": {
        slug: "mines_cricket",
        name: "Mines Cricket",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_football": {
        slug: "mines_football",
        name: "Mines football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_gold": {
        slug: "mines_gold",
        name: "Mines Gold",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/mines_grand": {
        slug: "mines_grand",
        name: "Mines Grand",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_coming": {
        slug: "money_coming",
        name: "Money Coming",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_coming_2": {
        slug: "money_coming_2",
        name: "Money Coming 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_coming_expand_bets": {
        slug: "money_coming_expand_bets",
        name: "Money Coming Expand Bets",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/money_pot": {
        slug: "money_pot",
        name: "Money Pot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/monkey_party": {
        slug: "monkey_party",
        name: "Monkey Party",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/neko_fortune": {
        slug: "neko_fortune",
        name: "Neko Fortune",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/night_city": {
        slug: "night_city",
        name: "Night City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/nightfall_hunting": {
        slug: "nightfall_hunting",
        name: "Nightfall Hunting",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/number_king": {
        slug: "number_king",
        name: "Number King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/ocean_king_jackpot": {
        slug: "ocean_king_jackpot",
        name: "Ocean King Jackpot",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pappu": {
        slug: "pappu",
        name: "PAPPU",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/party_ape": {
        slug: "party_ape",
        name: "Party Ape",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/party_night": {
        slug: "party_night",
        name: "Party Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pearls_of_bingo": {
        slug: "pearls_of_bingo",
        name: "Pearls of Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/penalty_kicks": {
        slug: "penalty_kicks",
        name: "Penalty Kicks",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pharaoh_treasure": {
        slug: "pharaoh_treasure",
        name: "Pharaoh Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pirate_queen": {
        slug: "pirate_queen",
        name: "Pirate Queen",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pirate_queen_2": {
        slug: "pirate_queen_2",
        name: "Pirate Queen 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko_football": {
        slug: "plinko_football",
        name: "Plinko Football",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/plinko_of_mine": {
        slug: "plinko_of_mine",
        name: "Plinko of Mine",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/poker_king": {
        slug: "poker_king",
        name: "Poker King",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/poseidon": {
        slug: "poseidon",
        name: "Poseidon",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/potion_wizard": {
        slug: "potion_wizard",
        name: "Potion Wizard",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/pusoy_go": {
        slug: "pusoy_go",
        name: "Pusoy Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/rapid_gems_777": {
        slug: "rapid_gems_777",
        name: "Rapid Gems 777",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/roma_x_10000": {
        slug: "roma_x_10000",
        name: "Roma X 10000",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/roma_x_deluxe": {
        slug: "roma_x_deluxe",
        name: "Roma X Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/romax": {
        slug: "romax",
        name: "RomaX",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/royal_fishing": {
        slug: "royal_fishing",
        name: "Royal Fishing",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/royal_quest": {
        slug: "royal_quest",
        name: "Royal Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/samba": {
        slug: "samba",
        name: "Samba",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/secret_treasure": {
        slug: "secret_treasure",
        name: "Secret Treasure",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sevensevenseven": {
        slug: "sevensevenseven",
        name: "SevenSevenSeven",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/shanghai_beauty": {
        slug: "shanghai_beauty",
        name: "Shanghai Beauty",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/shogun": {
        slug: "shogun",
        name: "Shogun",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sin_city": {
        slug: "sin_city",
        name: "Sin City",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/speed_andar_bahar": {
        slug: "speed_andar_bahar",
        name: "Speed Andar Bahar",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/storm_of_seth_2": {
        slug: "storm_of_seth_2",
        name: "Storm of Seth 2",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace": {
        slug: "super_ace",
        name: "Super Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_deluxe": {
        slug: "super_ace_deluxe",
        name: "Super Ace Deluxe",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_ii": {
        slug: "super_ace_ii",
        name: "Super Ace II",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_joker": {
        slug: "super_ace_joker",
        name: "Super Ace Joker",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_ace_speed": {
        slug: "super_ace_speed",
        name: "Super Ace SPEED",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_bingo": {
        slug: "super_bingo",
        name: "Super Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_esabong": {
        slug: "super_esabong",
        name: "Super E-Sabong",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/super_rich": {
        slug: "super_rich",
        name: "Super Rich",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/supernova": {
        slug: "supernova",
        name: "Supernova",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sweet_land": {
        slug: "sweet_land",
        name: "Sweet Land",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/sweet_magic": {
        slug: "sweet_magic",
        name: "Sweet Magic",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/teenpatti": {
        slug: "teenpatti",
        name: "TeenPatti",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thai_hilo": {
        slug: "thai_hilo",
        name: "Thai Hilo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thor_dice": {
        slug: "thor_dice",
        name: "Thor Dice",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/thor_x": {
        slug: "thor_x",
        name: "Thor X",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/tongits_go": {
        slug: "tongits_go",
        name: "Tongits Go",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/tower": {
        slug: "tower",
        name: "Tower",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/treasure_quest": {
        slug: "treasure_quest",
        name: "Treasure Quest",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/trial_of_phoenix": {
        slug: "trial_of_phoenix",
        name: "Trial of Phoenix",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/twin_wins": {
        slug: "twin_wins",
        name: "TWIN WINS",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/west_hunter_bingo": {
        slug: "west_hunter_bingo",
        name: "West Hunter Bingo",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/wild_ace": {
        slug: "wild_ace",
        name: "Wild Ace",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/wild_racer": {
        slug: "wild_racer",
        name: "Wild Racer",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/win_drop": {
        slug: "win_drop",
        name: "Win Drop",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/witches_night": {
        slug: "witches_night",
        name: "Witches Night",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/world_cup": {
        slug: "world_cup",
        name: "World Cup",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/x7_hot": {
        slug: "x7_hot",
        name: "X7 HOT",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/xiyangyang": {
        slug: "xiyangyang",
        name: "XiYangYang",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "jili-games/zeus": {
        slug: "zeus",
        name: "Zeus",
        provider: "Jili Games",
        providerSlug: "jili-games"
    },
    "justslots/book_of_abyss": {
        slug: "book_of_abyss",
        name: "Book of Abyss",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/book_of_arcane_100": {
        slug: "book_of_arcane_100",
        name: "Book of Arcane 100",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/cyber_egypt": {
        slug: "cyber_egypt",
        name: "Cyber Egypt",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/dynamos_show": {
        slug: "dynamos_show",
        name: "Dynamo's Show",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/fish_mafia": {
        slug: "fish_mafia",
        name: "Fish Mafia",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/ice_vacation": {
        slug: "ice_vacation",
        name: "Ice Vacation",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/rain_and_ruin": {
        slug: "rain_and_ruin",
        name: "Rain and Ruin",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/shadow_pirates": {
        slug: "shadow_pirates",
        name: "Shadow Pirates",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/shogun_skylord": {
        slug: "shogun_skylord",
        name: "Shogun Skylord",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/shogun_skylord_jade_empress": {
        slug: "shogun_skylord_jade_empress",
        name: "Shogun Skylord Jade Empress",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/sugar_heaven": {
        slug: "sugar_heaven",
        name: "Sugar Heaven",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/sugar_hell": {
        slug: "sugar_hell",
        name: "Sugar Hell",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/unholy_mystery": {
        slug: "unholy_mystery",
        name: "Unholy Mystery",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/unholy_mystery_freaky_fiesta": {
        slug: "unholy_mystery_freaky_fiesta",
        name: "Unholy Mystery Freaky Fiesta",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "justslots/vegan_nightmare": {
        slug: "vegan_nightmare",
        name: "Vegan Nightmare",
        provider: "Justslots",
        providerSlug: "justslots"
    },
    "konquer/bubblegum": {
        slug: "bubblegum",
        name: "Bubblegum",
        provider: "Konquer",
        providerSlug: "konquer"
    },
    "konquer/card_castle": {
        slug: "card_castle",
        name: "Card Castle",
        provider: "Konquer",
        providerSlug: "konquer"
    },
    "konquer/fireworks": {
        slug: "fireworks",
        name: "Fireworks",
        provider: "Konquer",
        providerSlug: "konquer"
    },
    "konquer/fortune_cookie": {
        slug: "fortune_cookie",
        name: "Fortune Cookie",
        provider: "Konquer",
        providerSlug: "konquer"
    },
    "konquer/joker": {
        slug: "joker",
        name: "Joker",
        provider: "Konquer",
        providerSlug: "konquer"
    },
    "libertyspins/10_celestial_fruits": {
        slug: "10_celestial_fruits",
        name: "10 Celestial Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/10_hot_diamond_desire": {
        slug: "10_hot_diamond_desire",
        name: "10 Hot Diamond Desire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/100_flaring_fruits": {
        slug: "100_flaring_fruits",
        name: "100 Flaring Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/20_ember_wilds": {
        slug: "20_ember_wilds",
        name: "20 Ember Wilds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/20_flaring_fruits": {
        slug: "20_flaring_fruits",
        name: "20 Flaring Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/20_hot_diamond_desire": {
        slug: "20_hot_diamond_desire",
        name: "20 Hot Diamond Desire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/3_coin_cowboy": {
        slug: "3_coin_cowboy",
        name: "3 Coin Cowboy",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/3_coin_cowboy_dollars_and_dreams": {
        slug: "3_coin_cowboy_dollars_and_dreams",
        name: "3 Coin Cowboy Dollars and Dreams",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/4_the_loot": {
        slug: "4_the_loot",
        name: "4 The Loot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/40_finest_xxl": {
        slug: "40_finest_xxl",
        name: "40 Finest XXL",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/40_finest_xxl_flaming_link": {
        slug: "40_finest_xxl_flaming_link",
        name: "40 Finest XXL Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/40_hot_diamond_desire": {
        slug: "40_hot_diamond_desire",
        name: "40 Hot Diamond Desire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/5_amazon_jewels": {
        slug: "5_amazon_jewels",
        name: "5 Amazon Jewels",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/5_ember_wilds": {
        slug: "5_ember_wilds",
        name: "5 Ember Wilds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/5_flaring_fruits": {
        slug: "5_flaring_fruits",
        name: "5 Flaring Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/5_hot_diamond_desire": {
        slug: "5_hot_diamond_desire",
        name: "5 Hot Diamond Desire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/50_flaring_fruit": {
        slug: "50_flaring_fruit",
        name: "50 Flaring Fruit",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/50_flaring_fruits": {
        slug: "50_flaring_fruits",
        name: "50 Flaring Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/7_fates": {
        slug: "7_fates",
        name: "7 Fates",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/7_shields_of_fortune": {
        slug: "7_shields_of_fortune",
        name: "7 Shields of Fortune",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/alexandria_fire": {
        slug: "alexandria_fire",
        name: "Alexandria Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/almighty_hera": {
        slug: "almighty_hera",
        name: "Almighty Hera",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/almighty_pegasus": {
        slug: "almighty_pegasus",
        name: "Almighty Pegasus",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/alpha_gold": {
        slug: "alpha_gold",
        name: "Alpha Gold",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/amped_up": {
        slug: "amped_up",
        name: "Amped Up!",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/amulets_of_horus": {
        slug: "amulets_of_horus",
        name: "Amulets of Horus",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/amun_ascension": {
        slug: "amun_ascension",
        name: "Amun Ascension",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ancient_magic": {
        slug: "ancient_magic",
        name: "Ancient Magic",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ancient_riches": {
        slug: "ancient_riches",
        name: "Ancient Riches",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ancient_riches_red_hot_firepot": {
        slug: "ancient_riches_red_hot_firepot",
        name: "Ancient Riches Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/argos_quest": {
        slug: "argos_quest",
        name: "Argos Quest",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/atlantic_wilds": {
        slug: "atlantic_wilds",
        name: "Atlantic Wilds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/aura_of_jupiter": {
        slug: "aura_of_jupiter",
        name: "Aura of Jupiter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/aura_of_jupiter_crazy_chicken_shooter": {
        slug: "aura_of_jupiter_crazy_chicken_shooter",
        name: "Aura of Jupiter Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/back_of_the_net": {
        slug: "back_of_the_net",
        name: "Back of the Net",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/back_to_the_fruits": {
        slug: "back_to_the_fruits",
        name: "Back to the Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/back_to_the_fruits_respins_of_amunre": {
        slug: "back_to_the_fruits_respins_of_amunre",
        name: "Back to the Fruits Respins of Amun-Re",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/bad_bass": {
        slug: "bad_bass",
        name: "Bad Bass",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/bad_bass_3_reels": {
        slug: "bad_bass_3_reels",
        name: "Bad Bass 3 Reels",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/bad_bass_cash_haul": {
        slug: "bad_bass_cash_haul",
        name: "Bad Bass Cash Haul",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/bankers_and_cash": {
        slug: "bankers_and_cash",
        name: "Bankers and Cash",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/beautiful_nature": {
        slug: "beautiful_nature",
        name: "Beautiful Nature",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/beer_party": {
        slug: "beer_party",
        name: "Beer Party",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/big_roar": {
        slug: "big_roar",
        name: "Big Roar",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/bioluminanza": {
        slug: "bioluminanza",
        name: "Bioluminanza",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/black_beauty": {
        slug: "black_beauty",
        name: "Black Beauty",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/blazing_frenzy": {
        slug: "blazing_frenzy",
        name: "Blazing Frenzy",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_blackeyes_bounty": {
        slug: "book_of_blackeyes_bounty",
        name: "Book of Blackeye's Bounty",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_buffalo": {
        slug: "book_of_buffalo",
        name: "Book of Buffalo",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_crazy_chicken_golden_nights": {
        slug: "book_of_crazy_chicken_golden_nights",
        name: "Book of Crazy Chicken Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_elements": {
        slug: "book_of_elements",
        name: "Book of Elements",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_juno": {
        slug: "book_of_juno",
        name: "Book of Juno",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_madness": {
        slug: "book_of_madness",
        name: "Book of Madness",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_madness_2": {
        slug: "book_of_madness_2",
        name: "Book of Madness 2",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_madness_deluxe": {
        slug: "book_of_madness_deluxe",
        name: "Book of Madness Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_madness_flaming_link": {
        slug: "book_of_madness_flaming_link",
        name: "Book of Madness Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_madness_respins_of_amunre": {
        slug: "book_of_madness_respins_of_amunre",
        name: "Book of Madness Respins of Amun-Re",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_oasis": {
        slug: "book_of_oasis",
        name: "Book of Oasis",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_romeo_and_julia": {
        slug: "book_of_romeo_and_julia",
        name: "Book of Romeo and Julia",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_romeo_and_julia_golden_nights": {
        slug: "book_of_romeo_and_julia_golden_nights",
        name: "Book of Romeo and Julia Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/book_of_the_ages": {
        slug: "book_of_the_ages",
        name: "Book of The Ages",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_bounties": {
        slug: "books_and_bounties",
        name: "Books and Bounties",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_bulls": {
        slug: "books_and_bulls",
        name: "Books and Bulls",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_bulls_golden_nights": {
        slug: "books_and_bulls_golden_nights",
        name: "Books and Bulls Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_bulls_red_hot_firepot": {
        slug: "books_and_bulls_red_hot_firepot",
        name: "Books and Bulls Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_pearls": {
        slug: "books_and_pearls",
        name: "Books and Pearls",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_pearls_respins_of_amunre": {
        slug: "books_and_pearls_respins_of_amunre",
        name: "Books and Pearls Respins of Amun-Re",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/books_and_temples": {
        slug: "books_and_temples",
        name: "Books and Temples",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/buffalo_bucks": {
        slug: "buffalo_bucks",
        name: "Buffalo Bucks",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/cai_fu_emperor_ways": {
        slug: "cai_fu_emperor_ways",
        name: "Cai Fu Emperor Ways",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/candy_treasures": {
        slug: "candy_treasures",
        name: "Candy Treasures",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/candy_treasures_3_reels": {
        slug: "candy_treasures_3_reels",
        name: "Candy Treasures 3 Reels",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/carnival_of_madness": {
        slug: "carnival_of_madness",
        name: "Carnival of Madness",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/carts_of_cash": {
        slug: "carts_of_cash",
        name: "Carts of Cash",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/carts_of_cash_xmas": {
        slug: "carts_of_cash_xmas",
        name: "Carts Of Cash Xmas",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/cash_whirl": {
        slug: "cash_whirl",
        name: "Cash Whirl",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/charming_hearts": {
        slug: "charming_hearts",
        name: "Charming Hearts",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/clover_luck": {
        slug: "clover_luck",
        name: "Clover Luck",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/coins_of_the_hood_10000_ways": {
        slug: "coins_of_the_hood_10000_ways",
        name: "Coins of the Hood 10,000 Ways",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crazy_diamonds": {
        slug: "crazy_diamonds",
        name: "Crazy Diamonds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crazy_jokers": {
        slug: "crazy_jokers",
        name: "Crazy Jokers",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/creepy_christmas": {
        slug: "creepy_christmas",
        name: "Creepy Christmas",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/cross_it": {
        slug: "cross_it",
        name: "Cross It!",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball": {
        slug: "crystal_ball",
        name: "Crystal Ball",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball_deluxe": {
        slug: "crystal_ball_deluxe",
        name: "Crystal Ball Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball_flaming_link": {
        slug: "crystal_ball_flaming_link",
        name: "Crystal Ball Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball_golden_nights": {
        slug: "crystal_ball_golden_nights",
        name: "Crystal Ball Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball_multi_symbols": {
        slug: "crystal_ball_multi_symbols",
        name: "Crystal Ball Multi Symbols",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_ball_red_hot_firepot": {
        slug: "crystal_ball_red_hot_firepot",
        name: "Crystal Ball Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_burst_xxl": {
        slug: "crystal_burst_xxl",
        name: "Crystal Burst XXL",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/crystal_strike": {
        slug: "crystal_strike",
        name: "Crystal Strike",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/cutie_cat": {
        slug: "cutie_cat",
        name: "Cutie Cat",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/cutie_cat_crazy_chicken_shooter": {
        slug: "cutie_cat_crazy_chicken_shooter",
        name: "Cutie Cat Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dead_legion": {
        slug: "dead_legion",
        name: "Dead Legion",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dega_baby": {
        slug: "dega_baby",
        name: "Dega Baby",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/diamond_desire": {
        slug: "diamond_desire",
        name: "Diamond Desire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/diamond_desire_deluxe": {
        slug: "diamond_desire_deluxe",
        name: "Diamond Desire Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/diamond_desire_flame": {
        slug: "diamond_desire_flame",
        name: "Diamond Desire Flame",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/diamond_flash": {
        slug: "diamond_flash",
        name: "Diamond Flash",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/diamond_safari": {
        slug: "diamond_safari",
        name: "Diamond Safari",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/disc_of_athena": {
        slug: "disc_of_athena",
        name: "Disc of Athena",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/divine_empress": {
        slug: "divine_empress",
        name: "Divine Empress",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/divine_fire": {
        slug: "divine_fire",
        name: "Divine Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/divine_wine": {
        slug: "divine_wine",
        name: "Divine Wine",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/down_the_chimney": {
        slug: "down_the_chimney",
        name: "Down the Chimney",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dragon_of_the_princess": {
        slug: "dragon_of_the_princess",
        name: "Dragon of the Princess",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dragon_power_10000_ways": {
        slug: "dragon_power_10000_ways",
        name: "Dragon Power 10,000 Ways",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dragon_power_keno": {
        slug: "dragon_power_keno",
        name: "Dragon Power Keno",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dragon_power_super_orbs": {
        slug: "dragon_power_super_orbs",
        name: "Dragon Power Super Orbs",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dragon_power_triple_gold": {
        slug: "dragon_power_triple_gold",
        name: "Dragon Power Triple Gold",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dreamy_genie": {
        slug: "dreamy_genie",
        name: "Dreamy Genie",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/dreamy_genie_dollars_and_dreams": {
        slug: "dreamy_genie_dollars_and_dreams",
        name: "Dreamy Genie Dollars and Dreams",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/duck_king": {
        slug: "duck_king",
        name: "Duck King",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/duck_shooter": {
        slug: "duck_shooter",
        name: "Duck Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/duck_shooter_crazy_chicken_shooter": {
        slug: "duck_shooter_crazy_chicken_shooter",
        name: "Duck Shooter Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/egyptian_magic": {
        slug: "egyptian_magic",
        name: "Egyptian Magic",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/egyptian_magic_dollars_and_dreams": {
        slug: "egyptian_magic_dollars_and_dreams",
        name: "Egyptian Magic Dollars and Dreams",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/egyptian_magic_keno": {
        slug: "egyptian_magic_keno",
        name: "Egyptian Magic Keno",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/electric_jungle": {
        slug: "electric_jungle",
        name: "Electric Jungle",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/enchanted_manor": {
        slug: "enchanted_manor",
        name: "Enchanted Manor",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/enchanted_manor_50_lines": {
        slug: "enchanted_manor_50_lines",
        name: "Enchanted Manor 50 lines",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/enchanted_manor_94_50_lines": {
        slug: "enchanted_manor_94_50_lines",
        name: "Enchanted Manor 94 50 lines",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/expanding_fireworks": {
        slug: "expanding_fireworks",
        name: "Expanding Fireworks",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/explodiac": {
        slug: "explodiac",
        name: "Explodiac",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/explodiac_red_hot_firepot": {
        slug: "explodiac_red_hot_firepot",
        name: "Explodiac Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fabulous_777s": {
        slug: "fabulous_777s",
        name: "Fabulous 777s",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fairy_dust": {
        slug: "fairy_dust",
        name: "Fairy Dust",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits": {
        slug: "fancy_fruits",
        name: "Fancy Fruits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_crazy_chicken_shooter": {
        slug: "fancy_fruits_crazy_chicken_shooter",
        name: "Fancy Fruits Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_deluxe": {
        slug: "fancy_fruits_deluxe",
        name: "Fancy Fruits Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_flaming_link": {
        slug: "fancy_fruits_flaming_link",
        name: "Fancy Fruits Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_golden_nights": {
        slug: "fancy_fruits_golden_nights",
        name: "Fancy Fruits Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_red_hot_firepot": {
        slug: "fancy_fruits_red_hot_firepot",
        name: "Fancy Fruits Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fancy_fruits_respins_of_amunre": {
        slug: "fancy_fruits_respins_of_amunre",
        name: "Fancy Fruits Respins of Amun-Re",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fengs_fortune": {
        slug: "fengs_fortune",
        name: "Feng's Fortune",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/flight_of_fire": {
        slug: "flight_of_fire",
        name: "Flight of Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/flor_de_muerto": {
        slug: "flor_de_muerto",
        name: "Flor De Muerto",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/football_super_spins": {
        slug: "football_super_spins",
        name: "Football Super Spins",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/forever_diamonds": {
        slug: "forever_diamonds",
        name: "Forever Diamonds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fort_brave": {
        slug: "fort_brave",
        name: "Fort Brave",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fortune_babies": {
        slug: "fortune_babies",
        name: "Fortune Babies",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fortune_babies_harmony": {
        slug: "fortune_babies_harmony",
        name: "Fortune Babies Harmony",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/frooty_troupe_cirque_du_money": {
        slug: "frooty_troupe_cirque_du_money",
        name: "Frooty Troupe Cirque du Money",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/frooty_troupe_game_on": {
        slug: "frooty_troupe_game_on",
        name: "Frooty Troupe Game On!",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/frooty_troupe_gold_club": {
        slug: "frooty_troupe_gold_club",
        name: "Frooty Troupe Gold Club",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/frooty_troupe_sun_splash": {
        slug: "frooty_troupe_sun_splash",
        name: "Frooty Troupe Sun Splash",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_love": {
        slug: "fruit_love",
        name: "Fruit Love",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_mania": {
        slug: "fruit_mania",
        name: "Fruit Mania",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_mania_deluxe": {
        slug: "fruit_mania_deluxe",
        name: "Fruit Mania Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_mania_flaming_link": {
        slug: "fruit_mania_flaming_link",
        name: "Fruit Mania Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_mania_golden_nights": {
        slug: "fruit_mania_golden_nights",
        name: "Fruit Mania Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_mania_red_hot_firepot": {
        slug: "fruit_mania_red_hot_firepot",
        name: "Fruit Mania Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fruit_rush": {
        slug: "fruit_rush",
        name: "Fruit Rush",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/fu_bao_dumpling_house": {
        slug: "fu_bao_dumpling_house",
        name: "Fu Bao Dumpling House",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/gates_of_persia": {
        slug: "gates_of_persia",
        name: "Gates of Persia",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/girl_with_the_golden_eyes": {
        slug: "girl_with_the_golden_eyes",
        name: "Girl with the Golden Eyes",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/glamorous_times": {
        slug: "glamorous_times",
        name: "Glamorous Times",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/gold_gobblers": {
        slug: "gold_gobblers",
        name: "Gold Gobblers",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_avalanche": {
        slug: "golden_avalanche",
        name: "Golden Avalanche",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_egg_of_crazy_chicken": {
        slug: "golden_egg_of_crazy_chicken",
        name: "Golden Egg of Crazy Chicken",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_egg_of_crazy_chicken_crazy_chicken_shooter": {
        slug: "golden_egg_of_crazy_chicken_crazy_chicken_shooter",
        name: "Golden Egg of Crazy Chicken Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_gals": {
        slug: "golden_gals",
        name: "Golden Gal's",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_gals_3_reels": {
        slug: "golden_gals_3_reels",
        name: "Golden Gal's 3 Reels",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_gals_hen_hunt": {
        slug: "golden_gals_hen_hunt",
        name: "Golden Gal's Hen Hunt",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_gills": {
        slug: "golden_gills",
        name: "Golden Gills",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_harvest": {
        slug: "golden_harvest",
        name: "Golden Harvest",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_horn": {
        slug: "golden_horn",
        name: "Golden Horn",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_horn_deluxe": {
        slug: "golden_horn_deluxe",
        name: "Golden Horn Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_touch": {
        slug: "golden_touch",
        name: "Golden Touch",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golden_treasures": {
        slug: "golden_treasures",
        name: "Golden Treasures",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/golfing_glory": {
        slug: "golfing_glory",
        name: "Golfing Glory",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/great_grizzly": {
        slug: "great_grizzly",
        name: "Great Grizzly",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/great_warrior": {
        slug: "great_warrior",
        name: "Great Warrior",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/happy_lucky": {
        slug: "happy_lucky",
        name: "Happy Lucky",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/hellfire": {
        slug: "hellfire",
        name: "Hellfire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/hexwood": {
        slug: "hexwood",
        name: "Hexwood",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/hot_heads": {
        slug: "hot_heads",
        name: "Hot Heads",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/hot_luck": {
        slug: "hot_luck",
        name: "Hot Luck",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/hot_rod_hog": {
        slug: "hot_rod_hog",
        name: "Hot Rod Hog",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ink_and_ivory": {
        slug: "ink_and_ivory",
        name: "Ink and Ivory",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/jaguars_wheel": {
        slug: "jaguars_wheel",
        name: "Jaguar's Wheel",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/jesters_vegas_experience": {
        slug: "jesters_vegas_experience",
        name: "Jester's Vegas Experience",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/jolly_cash": {
        slug: "jolly_cash",
        name: "Jolly Cash",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/juicy_explosion": {
        slug: "juicy_explosion",
        name: "Juicy Explosion",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/juicy_jester": {
        slug: "juicy_jester",
        name: "Juicy Jester",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/karens_merry_meltdown": {
        slug: "karens_merry_meltdown",
        name: "Karen's Merry Meltdown",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/king_and_queen": {
        slug: "king_and_queen",
        name: "King and Queen",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/king_of_the_jungle": {
        slug: "king_of_the_jungle",
        name: "King of the Jungle",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/king_of_the_jungle_golden_nights": {
        slug: "king_of_the_jungle_golden_nights",
        name: "King of The Jungle Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/king_of_the_jungle_red_hot_firepot": {
        slug: "king_of_the_jungle_red_hot_firepot",
        name: "King of The Jungle Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/kitty_coins": {
        slug: "kitty_coins",
        name: "Kitty Coins",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita": {
        slug: "la_dolce_vita",
        name: "La Dolce Vita",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita_2": {
        slug: "la_dolce_vita_2",
        name: "La Dolce Vita 2",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita_deluxe": {
        slug: "la_dolce_vita_deluxe",
        name: "La Dolce Vita Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita_flaming_link": {
        slug: "la_dolce_vita_flaming_link",
        name: "La Dolce Vita Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita_golden_nights": {
        slug: "la_dolce_vita_golden_nights",
        name: "La Dolce Vita Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/la_dolce_vita_red_hot_firepot": {
        slug: "la_dolce_vita_red_hot_firepot",
        name: "La Dolce Vita Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/lava_lions": {
        slug: "lava_lions",
        name: "Lava Lions",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/legacy_of_ramses_book": {
        slug: "legacy_of_ramses_book",
        name: "Legacy of Ramses Book",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/lucky_nudge": {
        slug: "lucky_nudge",
        name: "Lucky Nudge",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/lucky_train": {
        slug: "lucky_train",
        name: "Lucky Train",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/maaax_diamonds": {
        slug: "maaax_diamonds",
        name: "Maaax Diamonds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/maaax_diamonds_christmas_edition": {
        slug: "maaax_diamonds_christmas_edition",
        name: "Maaax Diamonds Christmas Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/maaax_diamonds_deluxe": {
        slug: "maaax_diamonds_deluxe",
        name: "Maaax Diamonds Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/maaax_diamonds_flaming_link": {
        slug: "maaax_diamonds_flaming_link",
        name: "Maaax Diamonds Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/maaax_diamonds_golden_nights": {
        slug: "maaax_diamonds_golden_nights",
        name: "Maaax Diamonds Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/magic_stone": {
        slug: "magic_stone",
        name: "Magic Stone",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mayan_fire": {
        slug: "mayan_fire",
        name: "Mayan Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mega_mystery_mine": {
        slug: "mega_mystery_mine",
        name: "Mega Mystery Mine",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mermaid_pays_100_lines": {
        slug: "mermaid_pays_100_lines",
        name: "Mermaid Pays 100 lines",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mermaid_pays_50_lines": {
        slug: "mermaid_pays_50_lines",
        name: "Mermaid Pays 50 lines",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mighty_dragon": {
        slug: "mighty_dragon",
        name: "Mighty Dragon",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mighty_marlin": {
        slug: "mighty_marlin",
        name: "Mighty Marlin",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mighty_marlin_super_reel": {
        slug: "mighty_marlin_super_reel",
        name: "Mighty Marlin: Super Reel",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mighty_mountain": {
        slug: "mighty_mountain",
        name: "Mighty Mountain",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/money_in_the_middle": {
        slug: "money_in_the_middle",
        name: "Money in the Middle",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/monkey_mania": {
        slug: "monkey_mania",
        name: "Monkey Mania",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mr_porky_bankster_10000_ways": {
        slug: "mr_porky_bankster_10000_ways",
        name: "Mr. Porky Bankster 10,000 Ways",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/muertos_magic": {
        slug: "muertos_magic",
        name: "Muertos Magic",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/multi_machine": {
        slug: "multi_machine",
        name: "Multi Machine",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mystery_mine": {
        slug: "mystery_mine",
        name: "Mystery Mine",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/mystical_forest": {
        slug: "mystical_forest",
        name: "Mystical Forest",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/night_wolves": {
        slug: "night_wolves",
        name: "Night Wolves",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/nordic_fire": {
        slug: "nordic_fire",
        name: "Nordic Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/old_fisherman": {
        slug: "old_fisherman",
        name: "Old Fisherman",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/paddy_o_plunder": {
        slug: "paddy_o_plunder",
        name: "Paddy O' Plunder",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/paddys_pooches": {
        slug: "paddys_pooches",
        name: "Paddy's Pooches",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/panda_pots": {
        slug: "panda_pots",
        name: "Panda Pots",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/phantoms_mirror": {
        slug: "phantoms_mirror",
        name: "Phantom's Mirror",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/pharaos_riches": {
        slug: "pharaos_riches",
        name: "Pharao's Riches",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/pharaos_riches_golden_nights": {
        slug: "pharaos_riches_golden_nights",
        name: "Pharao's Riches Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/pharaos_riches_red_hot_firepot": {
        slug: "pharaos_riches_red_hot_firepot",
        name: "Pharao's Riches Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/phoenix_fury": {
        slug: "phoenix_fury",
        name: "Phoenix Fury",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/phoenix_queen": {
        slug: "phoenix_queen",
        name: "Phoenix Queen",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/pigster": {
        slug: "pigster",
        name: "Pigster",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/plushie_peril": {
        slug: "plushie_peril",
        name: "Plushie Peril",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/professor_bigwin": {
        slug: "professor_bigwin",
        name: "Professor Bigwin",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/puff_puff_puffer": {
        slug: "puff_puff_puffer",
        name: "Puff Puff Puffer",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/pumped_up": {
        slug: "pumped_up",
        name: "Pumped Up",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/raging_rabbits": {
        slug: "raging_rabbits",
        name: "Raging Rabbits",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book": {
        slug: "ramses_book",
        name: "Ramses Book",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_christmas_edition": {
        slug: "ramses_book_christmas_edition",
        name: "Ramses Book Christmas Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_deluxe": {
        slug: "ramses_book_deluxe",
        name: "Ramses Book Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_easter_egg": {
        slug: "ramses_book_easter_egg",
        name: "Ramses Book Easter Egg",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_flaming_link": {
        slug: "ramses_book_flaming_link",
        name: "Ramses Book Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_golden_nights": {
        slug: "ramses_book_golden_nights",
        name: "Ramses Book Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_red_hot_firepot": {
        slug: "ramses_book_red_hot_firepot",
        name: "Ramses Book Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_respins_of_amunre": {
        slug: "ramses_book_respins_of_amunre",
        name: "Ramses Book Respins of Amun-Re",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/ramses_book_rock_edition": {
        slug: "ramses_book_rock_edition",
        name: "Ramses Book Rock Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/rich_gecko": {
        slug: "rich_gecko",
        name: "Rich Gecko",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion": {
        slug: "roman_legion",
        name: "Roman Legion",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion_deluxe": {
        slug: "roman_legion_deluxe",
        name: "Roman Legion Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion_flaming_link": {
        slug: "roman_legion_flaming_link",
        name: "Roman Legion Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion_golden_nights": {
        slug: "roman_legion_golden_nights",
        name: "Roman Legion Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion_xtreme": {
        slug: "roman_legion_xtreme",
        name: "Roman Legion Xtreme",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/roman_legion_xtreme_red_hot_firepot": {
        slug: "roman_legion_xtreme_red_hot_firepot",
        name: "Roman Legion Xtreme Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_luck": {
        slug: "royal_luck",
        name: "Royal Luck",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven": {
        slug: "royal_seven",
        name: "Royal Seven",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_deluxe": {
        slug: "royal_seven_deluxe",
        name: "Royal Seven Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_flaming_link": {
        slug: "royal_seven_flaming_link",
        name: "Royal Seven Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_golden_nights": {
        slug: "royal_seven_golden_nights",
        name: "Royal Seven Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_ultra": {
        slug: "royal_seven_ultra",
        name: "Royal Seven Ultra",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_ultra_deluxe": {
        slug: "royal_seven_ultra_deluxe",
        name: "Royal Seven Ultra Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_ultra_flaming_link": {
        slug: "royal_seven_ultra_flaming_link",
        name: "Royal Seven Ultra Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_xxl": {
        slug: "royal_seven_xxl",
        name: "Royal Seven XXL",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_xxl_deluxe": {
        slug: "royal_seven_xxl_deluxe",
        name: "Royal Seven XXL Deluxe",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_xxl_easter_egg": {
        slug: "royal_seven_xxl_easter_egg",
        name: "Royal Seven XXL Easter Egg",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_xxl_flaming_link": {
        slug: "royal_seven_xxl_flaming_link",
        name: "Royal Seven XXL Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/royal_seven_xxl_red_hot_firepot": {
        slug: "royal_seven_xxl_red_hot_firepot",
        name: "Royal Seven XXL Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/samurai_ikusa": {
        slug: "samurai_ikusa",
        name: "Samurai Ikusa",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/santas_sack": {
        slug: "santas_sack",
        name: "Santa's Sack",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/savanna_moon": {
        slug: "savanna_moon",
        name: "Savanna Moon",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sea_of_plenty": {
        slug: "sea_of_plenty",
        name: "Sea of Plenty",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sevens_and_books": {
        slug: "sevens_and_books",
        name: "Sevens and Books",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sevens_and_jok3rs": {
        slug: "sevens_and_jok3rs",
        name: "Sevens and Jok3rs",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sevens_and_suns": {
        slug: "sevens_and_suns",
        name: "Sevens and Suns",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sevens_fire": {
        slug: "sevens_fire",
        name: "Sevens Fire",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/shark_hunter": {
        slug: "shark_hunter",
        name: "Shark Hunter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/shoguns_secret": {
        slug: "shoguns_secret",
        name: "Shogun's Secret",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/shoguns_secret_crazy_chicken_shooter": {
        slug: "shoguns_secret_crazy_chicken_shooter",
        name: "Shogun's Secret Crazy Chicken Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/side_strike": {
        slug: "side_strike",
        name: "Side Strike",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/simply_the_best": {
        slug: "simply_the_best",
        name: "Simply the Best",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/solar_sentinels": {
        slug: "solar_sentinels",
        name: "Solar Sentinels",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/speed_champion": {
        slug: "speed_champion",
        name: "Speed Champion",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/stacks_of_jacks": {
        slug: "stacks_of_jacks",
        name: "Stacks of Jacks",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/stellar_luck_5": {
        slug: "stellar_luck_5",
        name: "Stellar Luck 5",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sticky_diamonds": {
        slug: "sticky_diamonds",
        name: "Sticky Diamonds",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sticky_diamonds_easter_egg": {
        slug: "sticky_diamonds_easter_egg",
        name: "Sticky Diamonds Easter Egg",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sticky_diamonds_flaming_link": {
        slug: "sticky_diamonds_flaming_link",
        name: "Sticky Diamonds Flaming Link",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sticky_diamonds_red_hot_firepot": {
        slug: "sticky_diamonds_red_hot_firepot",
        name: "Sticky Diamonds Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sugar_spree": {
        slug: "sugar_spree",
        name: "Sugar Spree",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/sunny_sevens": {
        slug: "sunny_sevens",
        name: "Sunny Sevens",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/super_duper_cherry": {
        slug: "super_duper_cherry",
        name: "Super Duper Cherry",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/super_duper_cherry_red_hot_firepot": {
        slug: "super_duper_cherry_red_hot_firepot",
        name: "Super Duper Cherry Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/super_duper_crazy_chicken_easter_egg": {
        slug: "super_duper_crazy_chicken_easter_egg",
        name: "Super Duper Crazy Chicken Easter Egg",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/super_sake": {
        slug: "super_sake",
        name: "Super Sake",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/take_5": {
        slug: "take_5",
        name: "Take 5",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/take_5_christmas_edition": {
        slug: "take_5_christmas_edition",
        name: "Take 5 Christmas Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/take_5_golden_nights": {
        slug: "take_5_golden_nights",
        name: "Take 5 Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/take_5_red_hot_firepot": {
        slug: "take_5_red_hot_firepot",
        name: "Take 5 Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_book_beyond": {
        slug: "the_book_beyond",
        name: "The Book Beyond",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_book_beyond_2": {
        slug: "the_book_beyond_2",
        name: "The Book Beyond 2",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_expandable": {
        slug: "the_expandable",
        name: "The Expandable",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_land_of_heroes": {
        slug: "the_land_of_heroes",
        name: "The Land Of Heroes",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_land_of_heroes_golden_nights": {
        slug: "the_land_of_heroes_golden_nights",
        name: "The Land Of Heroes Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/the_mighty_king": {
        slug: "the_mighty_king",
        name: "The Mighty King",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/thunder_blitz": {
        slug: "thunder_blitz",
        name: "Thunder Blitz",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/tikaani_gold": {
        slug: "tikaani_gold",
        name: "Tikaani Gold",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/tower_of_power": {
        slug: "tower_of_power",
        name: "Tower of Power",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/treat_yoelf": {
        slug: "treat_yoelf",
        name: "Treat Yo'Elf",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/truckers_vs_aliens": {
        slug: "truckers_vs_aliens",
        name: "Truckers vs Aliens",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/vegas_joker": {
        slug: "vegas_joker",
        name: "Vegas Joker",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/vegas_royale": {
        slug: "vegas_royale",
        name: "Vegas Royale",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/western_jack": {
        slug: "western_jack",
        name: "Western Jack",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wicked_whiskers": {
        slug: "wicked_whiskers",
        name: "Wicked Whiskers",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_hour_league": {
        slug: "wild_hour_league",
        name: "Wild Hour League",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_luck_40": {
        slug: "wild_luck_40",
        name: "Wild Luck 40",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_rubies": {
        slug: "wild_rubies",
        name: "Wild Rubies",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_rubies_christmas_edition": {
        slug: "wild_rubies_christmas_edition",
        name: "Wild Rubies Christmas Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_rubies_golden_nights": {
        slug: "wild_rubies_golden_nights",
        name: "Wild Rubies Golden Nights",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wild_rubies_red_hot_firepot": {
        slug: "wild_rubies_red_hot_firepot",
        name: "Wild Rubies Red Hot Firepot",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/wilds_gone_wild": {
        slug: "wilds_gone_wild",
        name: "Wilds Gone Wild",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/win_blaster": {
        slug: "win_blaster",
        name: "Win Blaster",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/win_blaster_christmas_edition": {
        slug: "win_blaster_christmas_edition",
        name: "Win Blaster Christmas Edition",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/win_shooter": {
        slug: "win_shooter",
        name: "Win Shooter",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "libertyspins/xploding_pumpkins": {
        slug: "xploding_pumpkins",
        name: "Xploding Pumpkins",
        provider: "Libertyspins",
        providerSlug: "libertyspins"
    },
    "manna-play/88_ya": {
        slug: "88_ya",
        name: "88 Ya",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/88fa": {
        slug: "88fa",
        name: "88FA",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/aloha_cuties_jp": {
        slug: "aloha_cuties_jp",
        name: "Aloha Cuties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queen_dating": {
        slug: "bikini_queen_dating",
        name: "Bikini Queen Dating",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queen_party": {
        slug: "bikini_queen_party",
        name: "Bikini Queen Party",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens": {
        slug: "bikini_queens",
        name: "Bikini Queens",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_live": {
        slug: "bikini_queens_live",
        name: "Bikini Queens Live",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_making_waves": {
        slug: "bikini_queens_making_waves",
        name: "Bikini Queens Making Waves",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bikini_queens_xmas": {
        slug: "bikini_queens_xmas",
        name: "Bikini Queens Xmas",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bingo_fun": {
        slug: "bingo_fun",
        name: "Bingo Fun",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bounty_hunter": {
        slug: "bounty_hunter",
        name: "Bounty Hunter",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/bull_fafa": {
        slug: "bull_fafa",
        name: "Bull FaFa",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/candy_rocket": {
        slug: "candy_rocket",
        name: "Candy Rocket",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/candy_storm_rainbow_rush": {
        slug: "candy_storm_rainbow_rush",
        name: "Candy Storm Rainbow Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/carnival_beats": {
        slug: "carnival_beats",
        name: "Carnival Beats",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/choi_sun_yeah_jp": {
        slug: "choi_sun_yeah_jp",
        name: "Choi Sun Yeah JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cleopatras_code": {
        slug: "cleopatras_code",
        name: "Cleopatra's Code",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/coin_tank": {
        slug: "coin_tank",
        name: "Coin Tank",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cougar_gold": {
        slug: "cougar_gold",
        name: "Cougar Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/cougar_roar": {
        slug: "cougar_roar",
        name: "Cougar Roar",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/danssser": {
        slug: "danssser",
        name: "Danssser",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_777_plus": {
        slug: "diamond_777_plus",
        name: "Diamond 777 Plus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_love_777": {
        slug: "diamond_love_777",
        name: "Diamond Love 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_storm": {
        slug: "diamond_storm",
        name: "Diamond Storm",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/diamond_storm_jewel_blast": {
        slug: "diamond_storm_jewel_blast",
        name: "Diamond Storm Jewel Blast",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/double_dragons": {
        slug: "double_dragons",
        name: "Double Dragons",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_emperor": {
        slug: "dragon_emperor",
        name: "Dragon Emperor",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_reborn": {
        slug: "dragon_reborn",
        name: "Dragon Reborn",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_reborn_rush": {
        slug: "dragon_reborn_rush",
        name: "Dragon Reborn Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_x_tiger": {
        slug: "dragon_x_tiger",
        name: "Dragon X Tiger",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragon_x_tiger_ii": {
        slug: "dragon_x_tiger_ii",
        name: "Dragon X Tiger II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragons_hoard": {
        slug: "dragons_hoard",
        name: "Dragon's Hoard",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/dragons_legend": {
        slug: "dragons_legend",
        name: "Dragons Legend",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/elves_kingdom": {
        slug: "elves_kingdom",
        name: "Elves Kingdom",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fa_choi_tree_jp": {
        slug: "fa_choi_tree_jp",
        name: "Fa Choi Tree JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fancy_alice": {
        slug: "fancy_alice",
        name: "Fancy Alice",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_dragon_3": {
        slug: "fortune_dragon_3",
        name: "Fortune Dragon 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_dragon_ii": {
        slug: "fortune_dragon_ii",
        name: "Fortune Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_fish": {
        slug: "fortune_fish",
        name: "Fortune Fish",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fortune_lucky_jp": {
        slug: "fortune_lucky_jp",
        name: "Fortune Lucky JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/four_saint_treasure": {
        slug: "four_saint_treasure",
        name: "Four Saint Treasure",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fruit_saga": {
        slug: "fruit_saga",
        name: "Fruit Saga",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fruit_splash": {
        slug: "fruit_splash",
        name: "Fruit Splash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/fufu_fa_jp": {
        slug: "fufu_fa_jp",
        name: "Fufu Fa JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ganesha_lucky": {
        slug: "ganesha_lucky",
        name: "Ganesha Lucky",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ganesha_shine": {
        slug: "ganesha_shine",
        name: "Ganesha Shine",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_hunter": {
        slug: "gem_hunter",
        name: "Gem Hunter",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_hunter_crash": {
        slug: "gem_hunter_crash",
        name: "Gem Hunter Crash",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gem_princess": {
        slug: "gem_princess",
        name: "Gem Princess",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/gold_of_horus": {
        slug: "gold_of_horus",
        name: "Gold of Horus",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_buffalo_rush": {
        slug: "golden_buffalo_rush",
        name: "Golden Buffalo Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_dragon_ii": {
        slug: "golden_dragon_ii",
        name: "Golden Dragon II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_egypt": {
        slug: "golden_egypt",
        name: "Golden Egypt",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_mouse": {
        slug: "golden_mouse",
        name: "Golden Mouse",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_mouse_3": {
        slug: "golden_mouse_3",
        name: "Golden Mouse 3",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_sea": {
        slug: "golden_sea",
        name: "Golden Sea",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/golden_try": {
        slug: "golden_try",
        name: "Golden Try",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/hey_fu_cai": {
        slug: "hey_fu_cai",
        name: "Hey Fu Cai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/high_up": {
        slug: "high_up",
        name: "High UP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/jumping_frog": {
        slug: "jumping_frog",
        name: "Jumping Frog",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/king_lion": {
        slug: "king_lion",
        name: "King Lion",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legacy_of_egypt_jp": {
        slug: "legacy_of_egypt_jp",
        name: "Legacy of Egypt JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legend_of_atlantis": {
        slug: "legend_of_atlantis",
        name: "Legend of Atlantis",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/legend_of_piggies_royal_edition": {
        slug: "legend_of_piggies_royal_edition",
        name: "Legend of Piggies Royal Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_4_spirits": {
        slug: "lucky_4_spirits",
        name: "Lucky 4 Spirits",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_bunny_eggs_bonanza": {
        slug: "lucky_bunny_eggs_bonanza",
        name: "Lucky Bunny Eggs Bonanza",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_calico_mahjong": {
        slug: "lucky_calico_mahjong",
        name: "Lucky Calico Mahjong",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_cat_and_maid": {
        slug: "lucky_cat_and_maid",
        name: "Lucky Cat & Maid",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_cat_and_maid_rush": {
        slug: "lucky_cat_and_maid_rush",
        name: "Lucky Cat & Maid Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/lucky_gallops_mega": {
        slug: "lucky_gallops_mega",
        name: "Lucky Gallops Mega",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/magic_jewels": {
        slug: "magic_jewels",
        name: "Magic Jewels",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mahjong_master": {
        slug: "mahjong_master",
        name: "Mahjong Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mahjong_master_2": {
        slug: "mahjong_master_2",
        name: "Mahjong Master 2",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mega_dragon": {
        slug: "mega_dragon",
        name: "Mega Dragon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mega_fruits_777": {
        slug: "mega_fruits_777",
        name: "Mega Fruits 777",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/misa_augur_swettie": {
        slug: "misa_augur_swettie",
        name: "Misa Augur Swettie",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mouse_gold_mega_edition": {
        slug: "mouse_gold_mega_edition",
        name: "Mouse Gold Mega Edition",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/mouse_gold_rush": {
        slug: "mouse_gold_rush",
        name: "Mouse Gold Rush",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/muay_thai_unlimited_ii": {
        slug: "muay_thai_unlimited_ii",
        name: "Muay Thai Unlimited II",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/ninja_master": {
        slug: "ninja_master",
        name: "Ninja Master",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirate_queen_treasure_raid": {
        slug: "pirate_queen_treasure_raid",
        name: "Pirate Queen: Treasure Raid",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirates_gold": {
        slug: "pirates_gold",
        name: "Pirate's Gold",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pirates_gold_jp": {
        slug: "pirates_gold_jp",
        name: "Pirates Gold JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/pixel_eater": {
        slug: "pixel_eater",
        name: "Pixel Eater",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/space_candy_enhanced": {
        slug: "space_candy_enhanced",
        name: "Space Candy Enhanced",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/splash_party": {
        slug: "splash_party",
        name: "Splash Party",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sushi_cat": {
        slug: "sushi_cat",
        name: "Sushi Cat",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sweet_paradise": {
        slug: "sweet_paradise",
        name: "Sweet Paradise",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/sweets_paradise_jp": {
        slug: "sweets_paradise_jp",
        name: "Sweets Paradise JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/taisho_samurai": {
        slug: "taisho_samurai",
        name: "Taisho Samurai",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/tokyo_sweeties": {
        slug: "tokyo_sweeties",
        name: "Tokyo Sweeties",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/tokyo_sweeties_jp": {
        slug: "tokyo_sweeties_jp",
        name: "Tokyo Sweeties JP",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/treasure_comet": {
        slug: "treasure_comet",
        name: "Treasure Comet",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/true_dragon_x": {
        slug: "true_dragon_x",
        name: "True Dragon X",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_buffalo": {
        slug: "wild_buffalo",
        name: "Wild Buffalo",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_joker": {
        slug: "wild_joker",
        name: "Wild Joker",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wild_pirates": {
        slug: "wild_pirates",
        name: "Wild Pirates",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wolf_moon": {
        slug: "wolf_moon",
        name: "Wolf Moon",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/wolf_queen": {
        slug: "wolf_queen",
        name: "Wolf Queen",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "manna-play/yokai_village": {
        slug: "yokai_village",
        name: "Yokai Village",
        provider: "Manna Play",
        providerSlug: "manna-play"
    },
    "mascotgaming/1_win_zeus_the_thunderer_deluxe": {
        slug: "1_win_zeus_the_thunderer_deluxe",
        name: "1 WIN ZEUS THE THUNDERER DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/1_x_fruits": {
        slug: "1_x_fruits",
        name: "1 x Fruits",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/10k_dice": {
        slug: "10k_dice",
        name: "10k Dice",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/1x_blackjack": {
        slug: "1x_blackjack",
        name: "1X Blackjack",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/1x_riot": {
        slug: "1x_riot",
        name: "1X Riot",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/1x_twin_fruits": {
        slug: "1x_twin_fruits",
        name: "1x Twin Fruits",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/243_fruity_zen": {
        slug: "243_fruity_zen",
        name: "243 Fruity Zen",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/3_corsairs": {
        slug: "3_corsairs",
        name: "3 Corsairs",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/across_the_universe": {
        slug: "across_the_universe",
        name: "Across the Universe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/across_the_universe_keno": {
        slug: "across_the_universe_keno",
        name: "Across the Universe Keno",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/admiral_x_fruit_machine": {
        slug: "admiral_x_fruit_machine",
        name: "Admiral X Fruit Machine",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/aloha_tiki_bar": {
        slug: "aloha_tiki_bar",
        name: "Aloha! Tiki Bar",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/aloha_tiki_bar_dice": {
        slug: "aloha_tiki_bar_dice",
        name: "Aloha Tiki Bar Dice",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/amaterasu_keno": {
        slug: "amaterasu_keno",
        name: "Amaterasu Keno",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/anksunamun_deluxe": {
        slug: "anksunamun_deluxe",
        name: "ANKSUNAMUN DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/anksunamun_the_queen_of_egypt": {
        slug: "anksunamun_the_queen_of_egypt",
        name: "Anksunamun: the queen of Egypt",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/azino_fruit_machine_x25": {
        slug: "azino_fruit_machine_x25",
        name: "Azino Fruit Machine x25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bamboo_bear": {
        slug: "bamboo_bear",
        name: "Bamboo Bear",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bamboo_bear_deluxe": {
        slug: "bamboo_bear_deluxe",
        name: "BAMBOO BEAR DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bastet_and_cats": {
        slug: "bastet_and_cats",
        name: "Bastet and Cats",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bastet_and_cats_deluxe": {
        slug: "bastet_and_cats_deluxe",
        name: "Bastet And Cats Deluxe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/battle_loot_hold_and_win": {
        slug: "battle_loot_hold_and_win",
        name: "Battle Loot: Hold and Win",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/ben_gunn_robinson": {
        slug: "ben_gunn_robinson",
        name: "Ben Gunn Robinson",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bennys_the_biggest_game": {
        slug: "bennys_the_biggest_game",
        name: "Benny's the Biggest game",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/big_win_x25": {
        slug: "big_win_x25",
        name: "Big Win x25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/bitmine_bonanza": {
        slug: "bitmine_bonanza",
        name: "BITMINE BONANZA",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/black_jack": {
        slug: "black_jack",
        name: "Black Jack",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/book_of_amaterasu": {
        slug: "book_of_amaterasu",
        name: "Book of Amaterasu",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/book_of_anksunamun_rockways": {
        slug: "book_of_anksunamun_rockways",
        name: "Book of Anksunamun Rockways",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/booming_fruity_boom": {
        slug: "booming_fruity_boom",
        name: "Booming Fruity Boom",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/cancan_saloon": {
        slug: "cancan_saloon",
        name: "CanCan Saloon",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/cancan_saloon_deluxe": {
        slug: "cancan_saloon_deluxe",
        name: "Cancan Saloon Deluxe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Hold'em",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/catch_the_win": {
        slug: "catch_the_win",
        name: "Catch The Win",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/christmas_infinite_gifts": {
        slug: "christmas_infinite_gifts",
        name: "Christmas Infinite Gifts",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/cleopatras_gems_bingo": {
        slug: "cleopatras_gems_bingo",
        name: "Cleopatra's Gems Bingo",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/cleopatras_gems_rockways": {
        slug: "cleopatras_gems_rockways",
        name: "Cleopatra's Gems. Rockways",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/crash_hamster_crash": {
        slug: "crash_hamster_crash",
        name: "Crash, Hamster, Crash!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/deepsea_riches": {
        slug: "deepsea_riches",
        name: "Deepsea Riches",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dice_disco_mega_stacks": {
        slug: "dice_disco_mega_stacks",
        name: "Dice Disco: Mega Stacks",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dice_of_luxor": {
        slug: "dice_of_luxor",
        name: "Dice Of Luxor",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dice_vegas": {
        slug: "dice_vegas",
        name: "Dice Vegas",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/double_roulette": {
        slug: "double_roulette",
        name: "Double Roulette",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/double_triple_fruits": {
        slug: "double_triple_fruits",
        name: "Double Triple Fruits",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dragons_lucky_25": {
        slug: "dragons_lucky_25",
        name: "Dragon's Lucky 25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dragons_nest": {
        slug: "dragons_nest",
        name: "Dragon’s Nest",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/dreamshock_jackpot_x": {
        slug: "dreamshock_jackpot_x",
        name: "Dreamshock Jackpot X",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/easter_luck": {
        slug: "easter_luck",
        name: "Easter Luck",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/european_roulette": {
        slug: "european_roulette",
        name: "EUROPEAN ROULETTE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/evil_bet_shoot_them_all": {
        slug: "evil_bet_shoot_them_all",
        name: "EVIL BET: SHOOT THEM ALL!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fabulous_farm_slot": {
        slug: "fabulous_farm_slot",
        name: "Fabulous Farm Slot",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fairytale_coven": {
        slug: "fairytale_coven",
        name: "Fairytale Coven",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fly_high": {
        slug: "fly_high",
        name: "Fly High",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/for_the_realm": {
        slug: "for_the_realm",
        name: "For the Realm!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/for_the_realm_deluxe": {
        slug: "for_the_realm_deluxe",
        name: "For The Realm Deluxe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/friar_tucks_inn": {
        slug: "friar_tucks_inn",
        name: "FRIAR TUCK'S INN",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_disco_mega_stacks": {
        slug: "fruit_disco_mega_stacks",
        name: "Fruit Disco: Mega Stacks",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_macau": {
        slug: "fruit_macau",
        name: "Fruit Macau",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_machine_mega_x": {
        slug: "fruit_machine_mega_x",
        name: "FRUIT MACHINE: MEGA X",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_machine_megabonus": {
        slug: "fruit_machine_megabonus",
        name: "Fruit Machine: Megabonus!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_machine_x25": {
        slug: "fruit_machine_x25",
        name: "Fruit Machine x25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_monaco": {
        slug: "fruit_monaco",
        name: "Fruit Monaco",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_vegas": {
        slug: "fruit_vegas",
        name: "Fruit Vegas",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruit_vegas_extreme_x125": {
        slug: "fruit_vegas_extreme_x125",
        name: "Fruit Vegas Extreme X125",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruits_of_luxor": {
        slug: "fruits_of_luxor",
        name: "Fruits of Luxor",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruits_of_mbit": {
        slug: "fruits_of_mbit",
        name: "Fruits of Mbit",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/fruity_x125": {
        slug: "fruity_x125",
        name: "FRUITY X125",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/ganamos_mega_x": {
        slug: "ganamos_mega_x",
        name: "GANAMOS MEGA X",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/gemz_grow": {
        slug: "gemz_grow",
        name: "Gemz Grow",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/greedy_greenskins_rockways": {
        slug: "greedy_greenskins_rockways",
        name: "Greedy Greenskins Rockways",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/gryphons_castle": {
        slug: "gryphons_castle",
        name: "Gryphon's Castle",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/gryphons_castle_deluxe": {
        slug: "gryphons_castle_deluxe",
        name: "GRYPHON'S CASTLE DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/gryphons_castle_rush": {
        slug: "gryphons_castle_rush",
        name: "Gryphons Castle Rush",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/gunman_crash": {
        slug: "gunman_crash",
        name: "GUNMAN CRASH!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/hello_win": {
        slug: "hello_win",
        name: "Hello Win",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/hellsing": {
        slug: "hellsing",
        name: "Hell'Sing",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/hook_up_fishing_wars": {
        slug: "hook_up_fishing_wars",
        name: "Hook up! Fishing Wars",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/hot_fruit_x15": {
        slug: "hot_fruit_x15",
        name: "Hot Fruit x15",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/hydras_lair": {
        slug: "hydras_lair",
        name: "Hydra's Lair",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/ice_number_one": {
        slug: "ice_number_one",
        name: "Ice Number One",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/icy_rockfall_x25": {
        slug: "icy_rockfall_x25",
        name: "Icy Rockfall X25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/jewel_boost_reels": {
        slug: "jewel_boost_reels",
        name: "Jewel Boost Reels",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/keno_party": {
        slug: "keno_party",
        name: "Keno Party",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/kite_festival_crash_game": {
        slug: "kite_festival_crash_game",
        name: "Kite Festival Crash Game",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/la_fiesta_de_muertos": {
        slug: "la_fiesta_de_muertos",
        name: "La Fiesta De Muertos",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/legioner": {
        slug: "legioner",
        name: "Legioner",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/lightning_path": {
        slug: "lightning_path",
        name: "Lightning Path",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/lions_pride": {
        slug: "lions_pride",
        name: "Lion's Pride",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/loot_the_train": {
        slug: "loot_the_train",
        name: "Loot The Train!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/lucky_fruity_coin": {
        slug: "lucky_fruity_coin",
        name: "LUCKY FRUITY COIN",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/lucky_year_25": {
        slug: "lucky_year_25",
        name: "Lucky Year 25",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/marble_bounce": {
        slug: "marble_bounce",
        name: "MARBLE_BOUNCE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/mayan_riches_bingo": {
        slug: "mayan_riches_bingo",
        name: "Mayan Riches Bingo",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/mayan_riches_rockways": {
        slug: "mayan_riches_rockways",
        name: "Mayan Riches. Rockways",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/merlins_tower": {
        slug: "merlins_tower",
        name: "Merlin's Tower",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/mermaids_bay": {
        slug: "mermaids_bay",
        name: "Mermaid's Bay",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/merry_scary_christmas": {
        slug: "merry_scary_christmas",
        name: "Merry Scary Christmas!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/metal_frontiers": {
        slug: "metal_frontiers",
        name: "Metal Frontiers",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/mines_blast": {
        slug: "mines_blast",
        name: "Mines Blast",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/minotaurs_wilds": {
        slug: "minotaurs_wilds",
        name: "Minotaurs Wilds",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/mist": {
        slug: "mist",
        name: "Mist",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/northern_heat": {
        slug: "northern_heat",
        name: "Northern Heat",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/origami_quest": {
        slug: "origami_quest",
        name: "Origami Quest",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/ouija_secrets": {
        slug: "ouija_secrets",
        name: "Ouija Secrets",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/overheat": {
        slug: "overheat",
        name: "OVERHEAT",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/paper_lanterns_crash_game": {
        slug: "paper_lanterns_crash_game",
        name: "Paper Lanterns: Crash Game",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/pin_plinko": {
        slug: "pin_plinko",
        name: "PIN PLINKO",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/pinup_dolls": {
        slug: "pinup_dolls",
        name: "PinUp Dolls",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/plinball_machine": {
        slug: "plinball_machine",
        name: "PLINBALL MACHINE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/plinko_builder": {
        slug: "plinko_builder",
        name: "Plinko Builder",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/plinko_pop": {
        slug: "plinko_pop",
        name: "Plinko Pop",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/primal_bet_rockways": {
        slug: "primal_bet_rockways",
        name: "Primal Bet. RockWays",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/prince_of_persia_the_gems_of_persepolis": {
        slug: "prince_of_persia_the_gems_of_persepolis",
        name: "Prince of Persia: the Gems of Persepolis",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/princess_and_dwarfs_deluxe": {
        slug: "princess_and_dwarfs_deluxe",
        name: "PRINCESS and DWARFS DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/purple_pills": {
        slug: "purple_pills",
        name: "Purple Pills",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/queen_of_spades": {
        slug: "queen_of_spades",
        name: "Queen of Spades",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/re_kill": {
        slug: "re_kill",
        name: "Re Kill",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/re_kill_ultimate": {
        slug: "re_kill_ultimate",
        name: "Re Kill Ultimate",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/red_horde": {
        slug: "red_horde",
        name: "Red Horde",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/reel_eldorado": {
        slug: "reel_eldorado",
        name: "Reel Eldorado",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/reveal_the_kraken": {
        slug: "reveal_the_kraken",
        name: "Reveal the Kraken",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/rice_and_riches_hold_and_win": {
        slug: "rice_and_riches_hold_and_win",
        name: "Rice and Riches: Hold and Win",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/riot": {
        slug: "riot",
        name: "Riot",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/riot_2_blow_and_burn": {
        slug: "riot_2_blow_and_burn",
        name: "Riot 2: Blow and Burn!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/riot_brutalskis_revenge": {
        slug: "riot_brutalskis_revenge",
        name: "Riot: Brutalski's Revenge",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/riot_ultimate": {
        slug: "riot_ultimate",
        name: "Riot Ultimate",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/riot_urban_wilds": {
        slug: "riot_urban_wilds",
        name: "Riot: Urban Wilds",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/robin_of_loxley": {
        slug: "robin_of_loxley",
        name: "Robin of Loxley",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/rocket_chimp_jackpot": {
        slug: "rocket_chimp_jackpot",
        name: "Rocket Chimp Jackpot!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/rooster_run": {
        slug: "rooster_run",
        name: "Rooster Run",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/scratch_the_bank": {
        slug: "scratch_the_bank",
        name: "Scratch The Bank",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/secrets_of_papyrus": {
        slug: "secrets_of_papyrus",
        name: "SECRETS OF PAPYRUS",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/shining_wilds": {
        slug: "shining_wilds",
        name: "Shining Wilds",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/shooting_galaxy": {
        slug: "shooting_galaxy",
        name: "Shooting Galaxy",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/skyrocket": {
        slug: "skyrocket",
        name: "SKYROCKET",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/space_blaze": {
        slug: "space_blaze",
        name: "Space Blaze",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/space_gems_rockblocks": {
        slug: "space_gems_rockblocks",
        name: "Space Gems Rockblocks",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/spicy_candies_rockblocks": {
        slug: "spicy_candies_rockblocks",
        name: "Spicy Candies Rockblocks",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/sticky_fruit_madness": {
        slug: "sticky_fruit_madness",
        name: "Sticky Fruit Madness",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/tessa_hunt_and_the_eye_of_horus": {
        slug: "tessa_hunt_and_the_eye_of_horus",
        name: "Tessa Hunt and The Eye of Horus",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/tessa_hunt_and_the_golden_sands": {
        slug: "tessa_hunt_and_the_golden_sands",
        name: "Tessa Hunt and the Golden Sands",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/tessa_hunt_and_the_mission_monte_carlo": {
        slug: "tessa_hunt_and_the_mission_monte_carlo",
        name: "Tessa Hunt and the Mission Monte Carlo",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/tessa_hunt_and_the_warrior_tomb": {
        slug: "tessa_hunt_and_the_warrior_tomb",
        name: "TESSA HUNT AND THE WARRIOR TOMB",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_biggest_win_x50": {
        slug: "the_biggest_win_x50",
        name: "The Biggest Win x50",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_candy_keno": {
        slug: "the_candy_keno",
        name: "The Candy Keno",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_candy_slot_deluxe": {
        slug: "the_candy_slot_deluxe",
        name: "The Candy Slot Deluxe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_dawn_is_coming": {
        slug: "the_dawn_is_coming",
        name: "THE DAWN IS COMING!",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_epic_win_x125": {
        slug: "the_epic_win_x125",
        name: "The Epic Win x125",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_evil_bet": {
        slug: "the_evil_bet",
        name: "The Evil Bet",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_incredible_x_fu_hero": {
        slug: "the_incredible_x_fu_hero",
        name: "The Incredible X Fu Hero",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_myth": {
        slug: "the_myth",
        name: "The Myth",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_myth_deluxe": {
        slug: "the_myth_deluxe",
        name: "THE MYTH DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_pendragon_legend": {
        slug: "the_pendragon_legend",
        name: "the Pendragon Legend",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_princess_and_dwarfs_rockways": {
        slug: "the_princess_and_dwarfs_rockways",
        name: "The Princess and Dwarfs: Rockways",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_rite": {
        slug: "the_rite",
        name: "The Rite",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/the_tomb": {
        slug: "the_tomb",
        name: "The Tomb",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/trump_card_queen": {
        slug: "trump_card_queen",
        name: "Trump Card: Queen",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/twin_dice_of_olympus": {
        slug: "twin_dice_of_olympus",
        name: "Twin Dice Of Olympus",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/twin_fruits_of_olympus": {
        slug: "twin_fruits_of_olympus",
        name: "Twin Fruits of Olympus",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/twin_fruits_of_santa": {
        slug: "twin_fruits_of_santa",
        name: "Twin Fruits of Santa",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/venetian_magic": {
        slug: "venetian_magic",
        name: "Venetian Magic",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/videopoker_3_in_1": {
        slug: "videopoker_3_in_1",
        name: "VIDEOPOKER 3 IN 1",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wasteland_riches": {
        slug: "wasteland_riches",
        name: "Wasteland Riches",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wild_phoenix_rises": {
        slug: "wild_phoenix_rises",
        name: "Wild Phoenix Rises",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wild_spirit": {
        slug: "wild_spirit",
        name: "Wild Spirit",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wild_spirit_deluxe": {
        slug: "wild_spirit_deluxe",
        name: "WILD SPIRIT DELUXE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wild_wild_bet": {
        slug: "wild_wild_bet",
        name: "Wild Wild Bet",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wildlife_riches": {
        slug: "wildlife_riches",
        name: "Wildlife Riches",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/wood_luck": {
        slug: "wood_luck",
        name: "Wood Luck",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/yukon_fever": {
        slug: "yukon_fever",
        name: "Yukon Fever",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/zeus_the_invincible": {
        slug: "zeus_the_invincible",
        name: "ZEUS THE INVINCIBLE",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/zeus_the_thunderer": {
        slug: "zeus_the_thunderer",
        name: "Zeus the Thunderer",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/zeus_the_thunderer_deluxe": {
        slug: "zeus_the_thunderer_deluxe",
        name: "Zeus the Thunderer deluxe",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "mascotgaming/zeus_titan_fury": {
        slug: "zeus_titan_fury",
        name: "Zeus: Titan Fury",
        provider: "Mascotgaming",
        providerSlug: "mascotgaming"
    },
    "max-win-gaming/5_monsters": {
        slug: "5_monsters",
        name: "5 Monsters",
        provider: "Max Win Gaming",
        providerSlug: "max-win-gaming"
    },
    "max-win-gaming/fruit_strike": {
        slug: "fruit_strike",
        name: "Fruit Strike",
        provider: "Max Win Gaming",
        providerSlug: "max-win-gaming"
    },
    "max-win-gaming/golden_gods": {
        slug: "golden_gods",
        name: "Golden Gods",
        provider: "Max Win Gaming",
        providerSlug: "max-win-gaming"
    },
    "max-win-gaming/splendour_forest": {
        slug: "splendour_forest",
        name: "Splendour Forest",
        provider: "Max Win Gaming",
        providerSlug: "max-win-gaming"
    },
    "max-win-gaming/wild_donuts": {
        slug: "wild_donuts",
        name: "Wild Donuts",
        provider: "Max Win Gaming",
        providerSlug: "max-win-gaming"
    },
    "maxxilabs/10000_fortunes": {
        slug: "10000_fortunes",
        name: "10000 Fortunes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/10000_fortunes_vf": {
        slug: "10000_fortunes_vf",
        name: "10000 Fortunes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/12_skulls_of_the_dead": {
        slug: "12_skulls_of_the_dead",
        name: "12 Skulls of the Dead",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/12_skulls_of_the_dead_vf": {
        slug: "12_skulls_of_the_dead_vf",
        name: "12 Skulls of the Dead VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/123_soccer_link_and_merge": {
        slug: "123_soccer_link_and_merge",
        name: "123 Soccer Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/123_soccer_link_and_merge_vf": {
        slug: "123_soccer_link_and_merge_vf",
        name: "123 Soccer Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/3rd_base": {
        slug: "3rd_base",
        name: "3rd Base",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/3rd_base_vf": {
        slug: "3rd_base_vf",
        name: "3rd Base VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/african_wilds": {
        slug: "african_wilds",
        name: "African Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/african_wilds_vf": {
        slug: "african_wilds_vf",
        name: "African Wilds VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_athena_empire": {
        slug: "almighty_athena_empire",
        name: "Almighty Athena Empire",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_athena_empire_vf": {
        slug: "almighty_athena_empire_vf",
        name: "Almighty Athena Empire VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_dionysus_empire": {
        slug: "almighty_dionysus_empire",
        name: "Almighty Dionysus Empire",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_poseidon_empire": {
        slug: "almighty_poseidon_empire",
        name: "Almighty Poseidon Empire",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_empire": {
        slug: "almighty_zeus_empire",
        name: "Almighty Zeus Empire",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_empire_vf": {
        slug: "almighty_zeus_empire_vf",
        name: "Almighty Zeus Empire VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_wilds": {
        slug: "almighty_zeus_wilds",
        name: "Almighty Zeus Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_wilds_link_and_merge": {
        slug: "almighty_zeus_wilds_link_and_merge",
        name: "Almighty Zeus Wilds Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_wilds_link_and_merge_vf": {
        slug: "almighty_zeus_wilds_link_and_merge_vf",
        name: "Almighty Zeus Wilds Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/almighty_zeus_wilds_vf": {
        slug: "almighty_zeus_wilds_vf",
        name: "Almighty Zeus Wilds VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ancient_treasure_poseidon": {
        slug: "ancient_treasure_poseidon",
        name: "Ancient Treasure Poseidon",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ancient_treasure_poseidon_vf": {
        slug: "ancient_treasure_poseidon_vf",
        name: "Ancient Treasure: Poseidon VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/andar_bahar_royale": {
        slug: "andar_bahar_royale",
        name: "Andar Bahar Royale",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/aviax": {
        slug: "aviax",
        name: "AviaX",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/aviax_vf": {
        slug: "aviax_vf",
        name: "AviaX VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/basketball_star_wilds": {
        slug: "basketball_star_wilds",
        name: "Basketball Star Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bass_catch_super_luck": {
        slug: "bass_catch_super_luck",
        name: "Bass Catch Super Luck",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bass_catch_super_luck_vf": {
        slug: "bass_catch_super_luck_vf",
        name: "Bass Catch SUPER LUCK VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bass_catch_super_up": {
        slug: "bass_catch_super_up",
        name: "Bass Catch Super Up",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bass_catch_super_up_vf": {
        slug: "bass_catch_super_up_vf",
        name: "Bass Catch SUPER UP VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bison_fire_charge": {
        slug: "bison_fire_charge",
        name: "Bison Fire Charge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bison_fire_charge_vf": {
        slug: "bison_fire_charge_vf",
        name: "Bison Fire Charge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bolts_of_zeus_coin_grid": {
        slug: "bolts_of_zeus_coin_grid",
        name: "Bolts of Zeus Coin Grid",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bolts_of_zeus_coin_grid_vf": {
        slug: "bolts_of_zeus_coin_grid_vf",
        name: "Bolts of Zeus Coin Grid VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bountiful_birds": {
        slug: "bountiful_birds",
        name: "Bountiful Birds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/bountiful_birds_vf": {
        slug: "bountiful_birds_vf",
        name: "Bountiful Birds VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_candy_link_and_merge": {
        slug: "break_away_candy_link_and_merge",
        name: "Break Away Candy Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_candy_link_and_merge_vf": {
        slug: "break_away_candy_link_and_merge_vf",
        name: "Break Away Candy Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_deluxe_triple_pots": {
        slug: "break_away_deluxe_triple_pots",
        name: "Break Away Deluxe - Triple Pots",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_deluxe_triple_pots_vf": {
        slug: "break_away_deluxe_triple_pots_vf",
        name: "Break Away Deluxe - Triple Pots VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_gold_vf": {
        slug: "break_away_gold_vf",
        name: "Break Away Gold VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_max_vf": {
        slug: "break_away_max_vf",
        name: "Break Away Max VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/break_away_ultra": {
        slug: "break_away_ultra",
        name: "Break Away Ultra",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/breakaway_gold": {
        slug: "breakaway_gold",
        name: "Breakaway Gold",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/breakaway_max": {
        slug: "breakaway_max",
        name: "Breakaway MAX",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/candy_rush_wilds": {
        slug: "candy_rush_wilds",
        name: "Candy Rush Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/candy_rush_wilds_2": {
        slug: "candy_rush_wilds_2",
        name: "Candy Rush Wilds 2",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/candy_rush_wilds_2_vf": {
        slug: "candy_rush_wilds_2_vf",
        name: "Candy Rush Wilds 2 VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/carnaval_fiesta": {
        slug: "carnaval_fiesta",
        name: "Carnaval Fiesta",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cash_blitz": {
        slug: "cash_blitz",
        name: "Cash Blitz",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cash_blitz_extreme": {
        slug: "cash_blitz_extreme",
        name: "Cash Blitz Extreme",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cash_blitz_extreme_vf": {
        slug: "cash_blitz_extreme_vf",
        name: "Cash Blitz Extreme VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cash_blitz_vf": {
        slug: "cash_blitz_vf",
        name: "Cash Blitz VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/circus_jugglers_jackpots": {
        slug: "circus_jugglers_jackpots",
        name: "Circus Jugglers Jackpots",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cluckin_sweet_feast": {
        slug: "cluckin_sweet_feast",
        name: "Cluckin Sweet Feast",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cluckin_sweet_feast_vf": {
        slug: "cluckin_sweet_feast_vf",
        name: "Cluckin' Sweet Feast VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/clucking_rush": {
        slug: "clucking_rush",
        name: "Clucking Rush",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/clucking_rush_vf": {
        slug: "clucking_rush_vf",
        name: "Clucking Rush VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/crazy_bob_bonanza": {
        slug: "crazy_bob_bonanza",
        name: "Crazy Bob Bonanza",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/crazy_rich_tigers": {
        slug: "crazy_rich_tigers",
        name: "Crazy Rich Tigers",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/crazy_rich_tigers_vf": {
        slug: "crazy_rich_tigers_vf",
        name: "Crazy Rich Tigers VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cricket_century_kings": {
        slug: "cricket_century_kings",
        name: "Cricket Century Kings",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/cricket_century_kings_vf": {
        slug: "cricket_century_kings_vf",
        name: "Cricket Century Kings VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/curse_of_medusa": {
        slug: "curse_of_medusa",
        name: "Curse of Medusa",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/curse_of_medusa_vf": {
        slug: "curse_of_medusa_vf",
        name: "Curse of Medusa VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/diamond_diva_oink_bonanza": {
        slug: "diamond_diva_oink_bonanza",
        name: "Diamond Diva Oink Bonanza",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/diamond_diva_oink_bonanza_vf": {
        slug: "diamond_diva_oink_bonanza_vf",
        name: "Diamond Diva Oink Bonanza VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/dice_pop": {
        slug: "dice_pop",
        name: "Dice Pop",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/fire_and_diamond_jingle_joker": {
        slug: "fire_and_diamond_jingle_joker",
        name: "Fire and Diamond Jingle Joker",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/fire_and_diamond_jingle_joker_vf": {
        slug: "fire_and_diamond_jingle_joker_vf",
        name: "Fire & Diamond Jingle Joker VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/fire_and_diamond_joker": {
        slug: "fire_and_diamond_joker",
        name: "Fire and Diamond Joker",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/fire_and_diamond_joker_vf": {
        slug: "fire_and_diamond_joker_vf",
        name: "Fire & Diamond Joker VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/genies_fortune_wishes": {
        slug: "genies_fortune_wishes",
        name: "Genie's Fortune Wishes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/genies_fortune_wishes_vf": {
        slug: "genies_fortune_wishes_vf",
        name: "Genie's Fortune Wishes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/genies_magic_wishes": {
        slug: "genies_magic_wishes",
        name: "Genie's Magic Wishes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/genies_magic_wishes_vf": {
        slug: "genies_magic_wishes_vf",
        name: "Genie's Magic Wishes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/gold_infinity": {
        slug: "gold_infinity",
        name: "Gold Infinity",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/gold_infinity_vf": {
        slug: "gold_infinity_vf",
        name: "Gold Infinity VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/golden_cat_fortunes": {
        slug: "golden_cat_fortunes",
        name: "Golden Cat Fortunes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/golden_cat_fortunes_vf": {
        slug: "golden_cat_fortunes_vf",
        name: "Golden Cat Fortunes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/grand_casino_heist": {
        slug: "grand_casino_heist",
        name: "Grand Casino Heist",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/grand_casino_heist_vf": {
        slug: "grand_casino_heist_vf",
        name: "Grand Casino Heist VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/happy_lucky_cats": {
        slug: "happy_lucky_cats",
        name: "Happy Lucky Cats",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/heavenly_elephant_fortune": {
        slug: "heavenly_elephant_fortune",
        name: "Heavenly Elephant Fortune",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/heavenly_elephant_fortune_vf": {
        slug: "heavenly_elephant_fortune_vf",
        name: "Heavenly Elephant Fortune VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/horses_treasure": {
        slug: "horses_treasure",
        name: "Horse's Treasure",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/horses_treasures_vf": {
        slug: "horses_treasures_vf",
        name: "Horse's Treasures VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ice_pop_party": {
        slug: "ice_pop_party",
        name: "Ice Pop Party",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/kongs_jungle_tower": {
        slug: "kongs_jungle_tower",
        name: "Kong's Jungle Tower",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/kongs_jungle_tower_vf": {
        slug: "kongs_jungle_tower_vf",
        name: "Kong's Jungle Tower VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/kung_pao_panda": {
        slug: "kung_pao_panda",
        name: "Kung Pao Panda",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/land_of_fortunes": {
        slug: "land_of_fortunes",
        name: "Land of Fortunes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/land_of_fortunes_vf": {
        slug: "land_of_fortunes_vf",
        name: "Land of Fortunes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_little_dragons": {
        slug: "lucky_little_dragons",
        name: "Lucky Little Dragons",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_rainbow_rush": {
        slug: "lucky_rainbow_rush",
        name: "Lucky Rainbow Rush",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_rainbow_rush_vf": {
        slug: "lucky_rainbow_rush_vf",
        name: "Lucky Rainbow Rush VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_and_9_lions": {
        slug: "lucky_twins_and_9_lions",
        name: "Lucky Twins and 9 Lions",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_power_cluster": {
        slug: "lucky_twins_power_cluster",
        name: "Lucky Twins Power Cluster",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_powerclusters_vf": {
        slug: "lucky_twins_powerclusters_vf",
        name: "Lucky Twins PowerClusters VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds": {
        slug: "lucky_twins_wilds",
        name: "Lucky Twins Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds_jackpots": {
        slug: "lucky_twins_wilds_jackpots",
        name: "Lucky Twins Wilds Jackpots",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds_jackpots_vf": {
        slug: "lucky_twins_wilds_jackpots_vf",
        name: "Lucky Twins Wilds Jackpots VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds_link_and_merge": {
        slug: "lucky_twins_wilds_link_and_merge",
        name: "Lucky Twins Wilds Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds_link_and_merge_vf": {
        slug: "lucky_twins_wilds_link_and_merge_vf",
        name: "Lucky Twins Wilds Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/lucky_twins_wilds_vf": {
        slug: "lucky_twins_wilds_vf",
        name: "Lucky Twins Wilds VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/luna_princess_link_and_merge": {
        slug: "luna_princess_link_and_merge",
        name: "Luna Princess Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/luna_princess_link_and_merge_vf": {
        slug: "luna_princess_link_and_merge_vf",
        name: "Luna Princess Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mad_ducks": {
        slug: "mad_ducks",
        name: "Mad Ducks",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mad_ducks_vf": {
        slug: "mad_ducks_vf",
        name: "Mad Ducks VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mahjong_wilds_link_and_merge": {
        slug: "mahjong_wilds_link_and_merge",
        name: "Mahjong Wilds Link and Merge",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mahjong_wilds_link_and_merge_vf": {
        slug: "mahjong_wilds_link_and_merge_vf",
        name: "Mahjong Wilds Link and Merge VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mayan_boost": {
        slug: "mayan_boost",
        name: "Mayan Boost",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mayan_boost_vf": {
        slug: "mayan_boost_vf",
        name: "Mayan Boost VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/merlins_secret_maxways": {
        slug: "merlins_secret_maxways",
        name: "Merlin's Secret Maxways",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/merlins_secret_maxways_vf": {
        slug: "merlins_secret_maxways_vf",
        name: "Merlin's Secret Maxways VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mine_pop": {
        slug: "mine_pop",
        name: "Mine Pop",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mithai_madness_10000x": {
        slug: "mithai_madness_10000x",
        name: "Mithai Madness 10000X",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/mithai_madness_10000x_vf": {
        slug: "mithai_madness_10000x_vf",
        name: "Mithai Madness 10000X VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/moonlight_romance_the_awakening": {
        slug: "moonlight_romance_the_awakening",
        name: "Moonlight Romance The Awakening",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/moonlight_romance_the_awakening_vf": {
        slug: "moonlight_romance_the_awakening_vf",
        name: "Moonlight Romance - The Awakening VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ne_zha_triple_powers": {
        slug: "ne_zha_triple_powers",
        name: "Ne Zha: Triple Powers",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ne_zha_triple_powers_vf": {
        slug: "ne_zha_triple_powers_vf",
        name: "Ne Zha: Triple Powers VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/nova_blast_ultra_vf": {
        slug: "nova_blast_ultra_vf",
        name: "Nova Blast Ultra VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/nova_ultra_blast": {
        slug: "nova_ultra_blast",
        name: "Nova Ultra Blast",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/phoenix_blaze": {
        slug: "phoenix_blaze",
        name: "Phoenix Blaze",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/phoenix_blaze_vf": {
        slug: "phoenix_blaze_vf",
        name: "Phoenix Blaze VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ping_pong_star": {
        slug: "ping_pong_star",
        name: "Ping Pong Star",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pirates_fight_for_fortune": {
        slug: "pirates_fight_for_fortune",
        name: "Pirate's Fight for Fortune",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pirates_fight_for_fortune_vf": {
        slug: "pirates_fight_for_fortune_vf",
        name: "Pirate�s Fight for Fortune VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/playboy": {
        slug: "playboy",
        name: "Playboy",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/playboy_gems_and_desires": {
        slug: "playboy_gems_and_desires",
        name: "Playboy Gems and Desires",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/playboy_gems_and_desires_vf": {
        slug: "playboy_gems_and_desires_vf",
        name: "Playboy Gems and Desires VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/playboy_wilds": {
        slug: "playboy_wilds",
        name: "Playboy Wilds",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/plinko_pop": {
        slug: "plinko_pop",
        name: "Plinko Pop",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pong_pong_mahjong": {
        slug: "pong_pong_mahjong",
        name: "Pong Pong Mahjong",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pong_pong_mahjong_2": {
        slug: "pong_pong_mahjong_2",
        name: "Pong Pong Mahjong 2",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pong_pong_mahjong_2_vf": {
        slug: "pong_pong_mahjong_2_vf",
        name: "Pong Pong Mahjong 2 VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pong_pong_mahjong_jackpots": {
        slug: "pong_pong_mahjong_jackpots",
        name: "Pong Pong Mahjong Jackpots",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/pong_pong_mahjong_vf": {
        slug: "pong_pong_mahjong_vf",
        name: "Pong Pong Mahjong VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/possessed_fortunes": {
        slug: "possessed_fortunes",
        name: "Possessed Fortunes",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/possessed_fortunes_vf": {
        slug: "possessed_fortunes_vf",
        name: "Possessed Fortunes VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_cairo": {
        slug: "queen_of_cairo",
        name: "Queen of Cairo",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_cairo_royal_maxways": {
        slug: "queen_of_cairo_royal_maxways",
        name: "Queen of Cairo: Royal Maxways",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_cairo_royal_maxways_vf": {
        slug: "queen_of_cairo_royal_maxways_vf",
        name: "Queen of Cairo: Royal Maxways VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_cairo_vf": {
        slug: "queen_of_cairo_vf",
        name: "Queen of Cairo VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_the_sphinx": {
        slug: "queen_of_the_sphinx",
        name: "Queen of the Sphinx",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/queen_of_the_sphinx_vf": {
        slug: "queen_of_the_sphinx_vf",
        name: "Queen of the Sphinx VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/skulls_and_souls_bonanza_coin_grid": {
        slug: "skulls_and_souls_bonanza_coin_grid",
        name: "Skulls and Souls Bonanza Coin Grid",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/skulls_and_souls_bonanza_coin_grid_vf": {
        slug: "skulls_and_souls_bonanza_coin_grid_vf",
        name: "Skulls and Souls Bonanza Coin Grid VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/soccerx": {
        slug: "soccerx",
        name: "SoccerX",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/soccerx_vf": {
        slug: "soccerx_vf",
        name: "SoccerX VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/soju_power_maxways": {
        slug: "soju_power_maxways",
        name: "Soju Power Maxways",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/soju_power_maxways_vf": {
        slug: "soju_power_maxways_vf",
        name: "Soju Power Maxways VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/sweet_jar_combo": {
        slug: "sweet_jar_combo",
        name: "Sweet Jar Combo",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/sweet_jar_combo_vf": {
        slug: "sweet_jar_combo_vf",
        name: "Sweet Jar Combo VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/sweet_jar_xmas_combo": {
        slug: "sweet_jar_xmas_combo",
        name: "Sweet Jar Xmas Combo",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/sweet_jar_xmas_combo_vf": {
        slug: "sweet_jar_xmas_combo_vf",
        name: "Sweet Jar Xmas Combo VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/tigers_treasures": {
        slug: "tigers_treasures",
        name: "Tiger's Treasures",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/tigers_treasures_vf": {
        slug: "tigers_treasures_vf",
        name: "Tiger's Treasures VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ultimate_goal_blitz": {
        slug: "ultimate_goal_blitz",
        name: "Ultimate Goal Blitz",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ultimate_goal_blitz_vf": {
        slug: "ultimate_goal_blitz_vf",
        name: "Ultimate Goal Blitz VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ultra_ace": {
        slug: "ultra_ace",
        name: "Ultra Ace",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "maxxilabs/ultra_ace_vf": {
        slug: "ultra_ace_vf",
        name: "Ultra Ace VF",
        provider: "Maxxilabs",
        providerSlug: "maxxilabs"
    },
    "mg-live/sicbo_live": {
        slug: "sicbo_live",
        name: "Sicbo Live",
        provider: "MG Live",
        providerSlug: "mg-live"
    },
    "microgaming-live/airwave_roulette": {
        slug: "airwave_roulette",
        name: "Airwave Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/amstel_roulette": {
        slug: "amstel_roulette",
        name: "Amstel Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/baccarat_after_dark": {
        slug: "baccarat_after_dark",
        name: "Baccarat After Dark",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_amsterdam": {
        slug: "blackjack_amsterdam",
        name: "Blackjack Amsterdam",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_berlin": {
        slug: "blackjack_berlin",
        name: "Blackjack Berlin",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_calgary": {
        slug: "blackjack_calgary",
        name: "Blackjack Calgary",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_manchester": {
        slug: "blackjack_manchester",
        name: "Blackjack Manchester",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_monte_carlo": {
        slug: "blackjack_monte_carlo",
        name: "Blackjack Monte Carlo",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_montreal": {
        slug: "blackjack_montreal",
        name: "Blackjack Montreal",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_niagara_falls": {
        slug: "blackjack_niagara_falls",
        name: "Blackjack Niagara Falls",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_ottawa": {
        slug: "blackjack_ottawa",
        name: "Blackjack Ottawa",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_riga": {
        slug: "blackjack_riga",
        name: "Blackjack Riga",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/blackjack_toronto": {
        slug: "blackjack_toronto",
        name: "Blackjack Toronto",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/clubhouse_roulette": {
        slug: "clubhouse_roulette",
        name: "Clubhouse Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/everplay_blackjack": {
        slug: "everplay_blackjack",
        name: "Everplay Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/fashion_tv_blackjack": {
        slug: "fashion_tv_blackjack",
        name: "Fashion TV Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/fashion_tv_roulette": {
        slug: "fashion_tv_roulette",
        name: "Fashion TV Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/istanbul_roulette": {
        slug: "istanbul_roulette",
        name: "Istanbul Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/korean_all_in_speed_baccarat": {
        slug: "korean_all_in_speed_baccarat",
        name: "Korean All In Speed Baccarat",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/microgaming_live_lobby": {
        slug: "microgaming_live_lobby",
        name: "Microgaming Live Lobby",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/playboy_blackjack": {
        slug: "playboy_blackjack",
        name: "Playboy Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/playboy_roulette": {
        slug: "playboy_roulette",
        name: "Playboy Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/speed_blackjack": {
        slug: "speed_blackjack",
        name: "Speed Blackjack",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/speed_roulette": {
        slug: "speed_roulette",
        name: "Speed Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "microgaming-live/turkish_roulette": {
        slug: "turkish_roulette",
        name: "Turkish Roulette",
        provider: "MicroGaming Live",
        providerSlug: "microgaming-live"
    },
    "million-games/book_of_love": {
        slug: "book_of_love",
        name: "Book of Love",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/captains_curse": {
        slug: "captains_curse",
        name: "Captain's Curse",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/chicken_x": {
        slug: "chicken_x",
        name: "Chicken X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/chicken_x_and_friends": {
        slug: "chicken_x_and_friends",
        name: "Chicken X and Friends",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/coco_rush": {
        slug: "coco_rush",
        name: "Coco Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/draw_sevens": {
        slug: "draw_sevens",
        name: "Draw Sevens",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/druids_drop": {
        slug: "druids_drop",
        name: "Druid's Drop",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/east_west_wild": {
        slug: "east_west_wild",
        name: "East West Wild",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/farm_frenzy": {
        slug: "farm_frenzy",
        name: "Farm Frenzy",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/fortune_city": {
        slug: "fortune_city",
        name: "Fortune City",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/fortune_fairies_holdandwin": {
        slug: "fortune_fairies_holdandwin",
        name: "Fortune Fairies Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/freakshow_hotel": {
        slug: "freakshow_hotel",
        name: "Freakshow Hotel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/gatsby_gold_booster_bar": {
        slug: "gatsby_gold_booster_bar",
        name: "Gatsby Gold Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/ghost_harbour": {
        slug: "ghost_harbour",
        name: "Ghost Harbour",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/give_me_the_money": {
        slug: "give_me_the_money",
        name: "Give Me The Money",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/goblin_brew": {
        slug: "goblin_brew",
        name: "Goblin Brew",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/golden_chase_booster_bar": {
        slug: "golden_chase_booster_bar",
        name: "Golden Chase Booster Bar",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/halloween_queen": {
        slug: "halloween_queen",
        name: "Halloween Queen",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/hard_eight_poker": {
        slug: "hard_eight_poker",
        name: "Hard Eight Poker",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/icarus_wilds": {
        slug: "icarus_wilds",
        name: "Icarus Wilds",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/infinite_x": {
        slug: "infinite_x",
        name: "Infinite X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/island_ices": {
        slug: "island_ices",
        name: "Island Ices",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/looting_raccoons": {
        slug: "looting_raccoons",
        name: "Looting Raccoons",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_baccarat": {
        slug: "million_baccarat",
        name: "Million Baccarat",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_blackjack_london_deal": {
        slug: "million_blackjack_london_deal",
        name: "Million Blackjack London Deal",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_blackjack_peek": {
        slug: "million_blackjack_peek",
        name: "Million Blackjack Peek",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_dice": {
        slug: "million_dice",
        name: "Million Dice",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_hilo": {
        slug: "million_hilo",
        name: "Million HiLo",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_mine": {
        slug: "million_mine",
        name: "Million Mine",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_plinko": {
        slug: "million_plinko",
        name: "Million Plinko",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/million_wheel": {
        slug: "million_wheel",
        name: "Million Wheel",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/perfect_catch": {
        slug: "perfect_catch",
        name: "Perfect Catch",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/piggy_rush": {
        slug: "piggy_rush",
        name: "Piggy Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/riches_of_zeus": {
        slug: "riches_of_zeus",
        name: "Riches of Zeus",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/rudolphs_gone_rogue": {
        slug: "rudolphs_gone_rogue",
        name: "Rudolph's Gone Rogue",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/skull_kings_treasure": {
        slug: "skull_kings_treasure",
        name: "Skull King's Treasure",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/temple_treasure_holdandwin": {
        slug: "temple_treasure_holdandwin",
        name: "Temple Treasure Hold&Win",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/temple_x": {
        slug: "temple_x",
        name: "Temple X",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/thorfinns_journey": {
        slug: "thorfinns_journey",
        name: "Thorfinn's Journey",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/van_gogh": {
        slug: "van_gogh",
        name: "Van Gogh",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/vault_rush": {
        slug: "vault_rush",
        name: "Vault Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/wild_island": {
        slug: "wild_island",
        name: "Wild Island",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/xmas_rush": {
        slug: "xmas_rush",
        name: "Xmas Rush",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "million-games/yin_and_yang": {
        slug: "yin_and_yang",
        name: "Yin & Yang",
        provider: "Million Games",
        providerSlug: "million-games"
    },
    "novomatic/10_devils_hotfire": {
        slug: "10_devils_hotfire",
        name: "10 Devils Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/10_super_clover": {
        slug: "10_super_clover",
        name: "10 Super Clover",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/20_mega_hotfire": {
        slug: "20_mega_hotfire",
        name: "20 Mega Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/25_red_hot_7_clover_link": {
        slug: "25_red_hot_7_clover_link",
        name: "25 Red Hot 7 Clover Link",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/25_red_hot_burning_clover_link": {
        slug: "25_red_hot_burning_clover_link",
        name: "25 Red Hot Burning Clover Link",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/3_merry_pines_hold_and_win": {
        slug: "3_merry_pines_hold_and_win",
        name: "3 Merry Pines Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/3_mystic_urns_hold_and_win": {
        slug: "3_mystic_urns_hold_and_win",
        name: "3 Mystic Urns Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/4_gold_lanterns_hold_and_win": {
        slug: "4_gold_lanterns_hold_and_win",
        name: "4 Gold Lanterns Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/40_mega_hotfire": {
        slug: "40_mega_hotfire",
        name: "40 Mega Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/40_super_clover": {
        slug: "40_super_clover",
        name: "40 Super Clover",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/5_sevens": {
        slug: "5_sevens",
        name: "5 Sevens",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/5_sevens_dice": {
        slug: "5_sevens_dice",
        name: "5 Sevens Dice",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/5_sevens_hold_and_win": {
        slug: "5_sevens_hold_and_win",
        name: "5 Sevens Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/5_sevens_hold_and_win_christmas": {
        slug: "5_sevens_hold_and_win_christmas",
        name: "5 Sevens Hold and Win Christmas",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/5_super_clover": {
        slug: "5_super_clover",
        name: "5 Super Clover",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/50_jokers_christmas": {
        slug: "50_jokers_christmas",
        name: "50 Jokers Christmas",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/50_jokers_hotfire": {
        slug: "50_jokers_hotfire",
        name: "50 Jokers Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/50_red_hot_burning_clover_link": {
        slug: "50_red_hot_burning_clover_link",
        name: "50 Red Hot Burning Clover Link",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/8_bullets_hold_and_win": {
        slug: "8_bullets_hold_and_win",
        name: "8 Bullets Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/always_hot": {
        slug: "always_hot",
        name: "Always Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/aztec_eclipse_hold_and_win": {
        slug: "aztec_eclipse_hold_and_win",
        name: "Aztec Eclipse Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/aztec_empire_hold_and_win": {
        slug: "aztec_empire_hold_and_win",
        name: "Aztec Empire: Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/banana_splash": {
        slug: "banana_splash",
        name: "Banana Splash",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bananas_go_bahamas": {
        slug: "bananas_go_bahamas",
        name: "Bananas Go Bahamas",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bells_of_glory": {
        slug: "bells_of_glory",
        name: "Bells of Glory",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/black_forest_treasures_lock_and_spin": {
        slug: "black_forest_treasures_lock_and_spin",
        name: "Black Forest Treasures Lock and Spin",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bonsai_gold_2_age_of_prosperity": {
        slug: "bonsai_gold_2_age_of_prosperity",
        name: "Bonsai Gold 2 Age of Prosperity",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bonsai_gold_hold_and_win": {
        slug: "bonsai_gold_hold_and_win",
        name: "Bonsai Gold Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_hotfire": {
        slug: "book_hotfire",
        name: "Book Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_hotfire_buy_bonus": {
        slug: "book_hotfire_buy_bonus",
        name: "Book Hotfire Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_hotfire_multichance": {
        slug: "book_hotfire_multichance",
        name: "Book Hotfire Multichance",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_hotfire_multichance_buy_bonus": {
        slug: "book_hotfire_multichance_buy_bonus",
        name: "Book Hotfire Multichance Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_flames": {
        slug: "book_of_flames",
        name: "Book of Flames",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_flames_buy_bonus": {
        slug: "book_of_flames_buy_bonus",
        name: "Book of Flames Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_flames_extra_hold_and_win": {
        slug: "book_of_flames_extra_hold_and_win",
        name: "Book of Flames Extra Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_flames_hold_and_win": {
        slug: "book_of_flames_hold_and_win",
        name: "Book of Flames Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_flames_multichance_buy_bonus": {
        slug: "book_of_flames_multichance_buy_bonus",
        name: "Book of Flames Multichance Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_luck": {
        slug: "book_of_luck",
        name: "Book of Luck",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra": {
        slug: "book_of_ra",
        name: "Book of Ra",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra_deluxe": {
        slug: "book_of_ra_deluxe",
        name: "Book of Ra deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra_deluxe_6": {
        slug: "book_of_ra_deluxe_6",
        name: "Book of Ra deluxe 6",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra_deluxe_buy_bonus": {
        slug: "book_of_ra_deluxe_buy_bonus",
        name: "Book of Ra Deluxe Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra_magic": {
        slug: "book_of_ra_magic",
        name: "Book of Ra Magic",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/book_of_ra_symbol_select_buy_bonus": {
        slug: "book_of_ra_symbol_select_buy_bonus",
        name: "Book of Ra Symbol Select Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bounty_of_the_seas_2_hold_and_win": {
        slug: "bounty_of_the_seas_2_hold_and_win",
        name: "Bounty of the Seas 2 Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/bounty_of_the_seas_hold_and_win": {
        slug: "bounty_of_the_seas_hold_and_win",
        name: "Bounty of the Seas: Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/canyon_cart_bonanza_hold_and_win": {
        slug: "canyon_cart_bonanza_hold_and_win",
        name: "Canyon Cart Bonanza: Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/cash_connection_charming_lady": {
        slug: "cash_connection_charming_lady",
        name: "Cash Connection Charming Lady",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/cash_connection_dolphins_pearl": {
        slug: "cash_connection_dolphins_pearl",
        name: "Cash Connection Dolphin's Pearl",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/cash_connection_golden_book_of_ra": {
        slug: "cash_connection_golden_book_of_ra",
        name: "Cash Connection Golden Book of Ra",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/cash_connection_sizzling_hot": {
        slug: "cash_connection_sizzling_hot",
        name: "Cash Connection Sizzling Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/charming_ladys_boom": {
        slug: "charming_ladys_boom",
        name: "Charming Lady's Boom",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/chicago": {
        slug: "chicago",
        name: "Chicago",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/chip_runner": {
        slug: "chip_runner",
        name: "Chip Runner",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/christmas_boom": {
        slug: "christmas_boom",
        name: "Christmas Boom",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/coins_of_fate": {
        slug: "coins_of_fate",
        name: "Coins of Fate",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/colossus_fortune": {
        slug: "colossus_fortune",
        name: "Colossus Fortune",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/columbus_deluxe": {
        slug: "columbus_deluxe",
        name: "Columbus deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/devils_3_piggy_hotfire_hold_and_win_buy_bonus": {
        slug: "devils_3_piggy_hotfire_hold_and_win_buy_bonus",
        name: "Devils 3 Piggy Hotfire Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/devils_coins_halloween_hotfire_hold_and_win": {
        slug: "devils_coins_halloween_hotfire_hold_and_win",
        name: "Devil’s Coins Halloween Hotfire Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/devils_coins_hotfire_hold_and_win_buy_bonus": {
        slug: "devils_coins_hotfire_hold_and_win_buy_bonus",
        name: "Devil's Coins Hotfire Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/devils_hotfire_xpand": {
        slug: "devils_hotfire_xpand",
        name: "Devils Hotfire Xpand",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/diamond_link_mighty_sevens": {
        slug: "diamond_link_mighty_sevens",
        name: "Diamond Link: Mighty Sevens",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/divine_egypt_hold_and_win": {
        slug: "divine_egypt_hold_and_win",
        name: "Divine Egypt Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/dolphins_pearl": {
        slug: "dolphins_pearl",
        name: "Dolphin's Pearl",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/dolphins_pearl_deluxe": {
        slug: "dolphins_pearl_deluxe",
        name: "Dolphin's Pearl deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/dolphins_pearl_deluxe_buy_bonus": {
        slug: "dolphins_pearl_deluxe_buy_bonus",
        name: "Dolphin's Pearl Deluxe Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/double_devils_hotfire": {
        slug: "double_devils_hotfire",
        name: "Double Devil's Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/faust": {
        slug: "faust",
        name: "Faust",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/faust_buy_bonus": {
        slug: "faust_buy_bonus",
        name: "Faust Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/fire_diamond": {
        slug: "fire_diamond",
        name: "Fire Diamond",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/firecracker_frenzy_empress_wealth_buy_bonus": {
        slug: "firecracker_frenzy_empress_wealth_buy_bonus",
        name: "Firecracker Frenzy Empress Wealth Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/flame_dancer": {
        slug: "flame_dancer",
        name: "Flame Dancer",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/fortune_flames_gold_buy_bonus": {
        slug: "fortune_flames_gold_buy_bonus",
        name: "Fortune Flames Gold Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/fortune_god": {
        slug: "fortune_god",
        name: "Fortune God",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/giza_fortunes_hold_and_win": {
        slug: "giza_fortunes_hold_and_win",
        name: "Giza Fortunes Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/gold_fever": {
        slug: "gold_fever",
        name: "Gold Fever",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/gold_fever_buy_bonus": {
        slug: "gold_fever_buy_bonus",
        name: "Gold Fever Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/golden_ark": {
        slug: "golden_ark",
        name: "Golden Ark",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/golden_ark_buy_bonus": {
        slug: "golden_ark_buy_bonus",
        name: "Golden Ark Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/gorilla": {
        slug: "gorilla",
        name: "Gorilla",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/grand_bazaar_hold_and_win": {
        slug: "grand_bazaar_hold_and_win",
        name: "Grand Bazaar Hold and WIn",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/gryphons_gold": {
        slug: "gryphons_gold",
        name: "Gryphon's Gold",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/hot_chance": {
        slug: "hot_chance",
        name: "Hot Chance",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/imperial_express_hold_and_win": {
        slug: "imperial_express_hold_and_win",
        name: "Imperial Express Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/indian_spirit": {
        slug: "indian_spirit",
        name: "Indian Spirit",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/infinite_hot": {
        slug: "infinite_hot",
        name: "Infinite Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/jackass_coins_hold_and_win_buy_bonus": {
        slug: "jackass_coins_hold_and_win_buy_bonus",
        name: "Jackass Coins Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/jackass_gold_hold_and_win": {
        slug: "jackass_gold_hold_and_win",
        name: "Jackass Gold Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/jackass_gold_hold_and_win_buy_bonus": {
        slug: "jackass_gold_hold_and_win_buy_bonus",
        name: "Jackass Gold Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/jackass_gold_hold_and_win_christmas": {
        slug: "jackass_gold_hold_and_win_christmas",
        name: "Jackass Gold Hold and Win Christmas",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/joker_heist": {
        slug: "joker_heist",
        name: "Joker Heist",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/joker_sevens_hotfire_hold_and_win": {
        slug: "joker_sevens_hotfire_hold_and_win",
        name: "Joker Sevens Hotfire Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/jokers_magic_box_hotfire_buy_bonus": {
        slug: "jokers_magic_box_hotfire_buy_bonus",
        name: "Joker's Magic Box Hotfire Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/just_jewels_deluxe": {
        slug: "just_jewels_deluxe",
        name: "Just Jewels deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/katana": {
        slug: "katana",
        name: "Katana",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/king_of_cards": {
        slug: "king_of_cards",
        name: "King of Cards",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lord_of_the_ocean": {
        slug: "lord_of_the_ocean",
        name: "Lord of the Ocean",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lord_of_the_ocean_buy_bonus": {
        slug: "lord_of_the_ocean_buy_bonus",
        name: "Lord of the Ocean Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lord_of_the_ocean_symbol_select_buy_bonus": {
        slug: "lord_of_the_ocean_symbol_select_buy_bonus",
        name: "Lord of the Ocean Symbol Select Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lucky_ladys_charm_deluxe": {
        slug: "lucky_ladys_charm_deluxe",
        name: "Lucky Lady's Charm deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lucky_ladys_charm_deluxe_6": {
        slug: "lucky_ladys_charm_deluxe_6",
        name: "Lucky Lady's Charm deluxe 6",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/lucky_ladys_charm_deluxe_buy_bonus": {
        slug: "lucky_ladys_charm_deluxe_buy_bonus",
        name: "Lucky Lady's Charm Deluxe Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/macarena": {
        slug: "macarena",
        name: "Macarena",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/madame_moonlight": {
        slug: "madame_moonlight",
        name: "Madame Moonlight",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/magic_money": {
        slug: "magic_money",
        name: "Magic Money",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/magma_strike_blazing_jackpots": {
        slug: "magma_strike_blazing_jackpots",
        name: "Magma Strike Blazing Jackpots",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/mega_joker": {
        slug: "mega_joker",
        name: "Mega Joker",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/mermaids_pearl": {
        slug: "mermaids_pearl",
        name: "Mermaid's Pearl",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/million_dollar_heist": {
        slug: "million_dollar_heist",
        name: "Million Dollar Heist",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/million_dollar_heist_xtreme": {
        slug: "million_dollar_heist_xtreme",
        name: "Million Dollar Heist Xtreme",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/million_dollar_heist_xtreme_buy_bonus": {
        slug: "million_dollar_heist_xtreme_buy_bonus",
        name: "Million Dollar Heist Xtreme Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/mystic_bull": {
        slug: "mystic_bull",
        name: "Mystic Bull",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/olivers_bar": {
        slug: "olivers_bar",
        name: "Oliver's Bar",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/pharaohs_gold_ii": {
        slug: "pharaohs_gold_ii",
        name: "Pharaoh's Gold II",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/phoenix_hit_hotfire_hold_and_win_buy_bonus": {
        slug: "phoenix_hit_hotfire_hold_and_win_buy_bonus",
        name: "Phoenix HIT Hotfire Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/phoenix_hotfire_hold_and_win": {
        slug: "phoenix_hotfire_hold_and_win",
        name: "Phoenix Hotfire Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/phoenix_hotfire_xpand": {
        slug: "phoenix_hotfire_xpand",
        name: "Phoenix Hotfire Xpand",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/phoenix_luck_hotfire_hold_and_win_buy_bonus": {
        slug: "phoenix_luck_hotfire_hold_and_win_buy_bonus",
        name: "Phoenix Luck Hotfire Hold and Win Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_coins_o_plenty": {
        slug: "piggy_prizes_coins_o_plenty",
        name: "Piggy Prizes Coins O' Plenty",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_wand_of_riches": {
        slug: "piggy_prizes_wand_of_riches",
        name: "Piggy Prizes Wand of Riches",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_wand_of_riches_2": {
        slug: "piggy_prizes_wand_of_riches_2",
        name: "Piggy Prizes Wand of Riches 2",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_wand_of_riches_buy_bonus": {
        slug: "piggy_prizes_wand_of_riches_buy_bonus",
        name: "Piggy Prizes Wand of Riches Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_wish_of_riches": {
        slug: "piggy_prizes_wish_of_riches",
        name: "Piggy Prizes Wish of Riches",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/piggy_prizes_wish_of_riches_buy_bonus": {
        slug: "piggy_prizes_wish_of_riches_buy_bonus",
        name: "Piggy Prizes Wish of Riches Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/pirate_queen_hold_and_win": {
        slug: "pirate_queen_hold_and_win",
        name: "Pirate Queen Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/plenty_of_fruit_20_hot": {
        slug: "plenty_of_fruit_20_hot",
        name: "Plenty of Fruit 20 Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/plenty_of_fruit_40": {
        slug: "plenty_of_fruit_40",
        name: "Plenty of Fruit 40",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/plenty_on_twenty_hot": {
        slug: "plenty_on_twenty_hot",
        name: "Plenty on Twenty Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/poseidons_realm": {
        slug: "poseidons_realm",
        name: "Poseidon's Realm",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/power_stars": {
        slug: "power_stars",
        name: "Power Stars",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/queen_of_hearts_deluxe": {
        slug: "queen_of_hearts_deluxe",
        name: "Queen of Hearts Deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/riches_of_india": {
        slug: "riches_of_india",
        name: "Riches of India",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/rise_of_tut_magic": {
        slug: "rise_of_tut_magic",
        name: "Rise of Tut Magic",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/rise_of_tut_magic_buy_bonus": {
        slug: "rise_of_tut_magic_buy_bonus",
        name: "Rise of Tut Magic Buy Bonus",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/river_queen": {
        slug: "river_queen",
        name: "River Queen",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/roaring_forties": {
        slug: "roaring_forties",
        name: "Roaring Forties",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/rock_and_riches_hold_and_win": {
        slug: "rock_and_riches_hold_and_win",
        name: "Rock and Riches Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/royal_treasures": {
        slug: "royal_treasures",
        name: "Royal Treasures",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/scarab_fortunes": {
        slug: "scarab_fortunes",
        name: "Scarab Fortunes",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sharky": {
        slug: "sharky",
        name: "Sharky",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/silver_fox": {
        slug: "silver_fox",
        name: "Silver Fox",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sizzling_gems": {
        slug: "sizzling_gems",
        name: "Sizzling Gems",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sizzling_hot": {
        slug: "sizzling_hot",
        name: "Sizzling Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sizzling_hot_6_extra_gold": {
        slug: "sizzling_hot_6_extra_gold",
        name: "Sizzling Hot 6 Extra Gold",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sizzling_hot_deluxe": {
        slug: "sizzling_hot_deluxe",
        name: "Sizzling Hot Deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/starlight_jackpots_athena_goddess_of_war": {
        slug: "starlight_jackpots_athena_goddess_of_war",
        name: "Starlight Jackpots Athena Goddess of War",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/starlight_jackpots_captains_catch": {
        slug: "starlight_jackpots_captains_catch",
        name: "Starlight Jackpots Captains Catch",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sultan_strike_hold_and_win": {
        slug: "sultan_strike_hold_and_win",
        name: "Sultan Strike: Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/sun_totem_hold_and_win": {
        slug: "sun_totem_hold_and_win",
        name: "Sun Totem Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/supra_hot": {
        slug: "supra_hot",
        name: "Supra Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/tale_of_fire_hold_and_win": {
        slug: "tale_of_fire_hold_and_win",
        name: "Tale of Fire Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/the_euro_game": {
        slug: "the_euro_game",
        name: "The Euro Game",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/the_jade_emperor_hold_and_win": {
        slug: "the_jade_emperor_hold_and_win",
        name: "The Jade Emperor Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/the_magic_flute": {
        slug: "the_magic_flute",
        name: "The Magic Flute",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/the_money_game": {
        slug: "the_money_game",
        name: "The Money Game",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/three_hotfire": {
        slug: "three_hotfire",
        name: "Three Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/thunder_play_voodoo_magic": {
        slug: "thunder_play_voodoo_magic",
        name: "Thunder Play Voodoo Magic",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/thunder_vault_hold_and_win": {
        slug: "thunder_vault_hold_and_win",
        name: "Thunder Vault: Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/treasure_jewels": {
        slug: "treasure_jewels",
        name: "Treasure Jewels",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/triple_treasure_cove_hold_and_win": {
        slug: "triple_treasure_cove_hold_and_win",
        name: "Triple Treasure Cove Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/twister_fortunes_hold_and_win": {
        slug: "twister_fortunes_hold_and_win",
        name: "Twister Fortunes Hold and Win",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/ultra_hot_deluxe": {
        slug: "ultra_hot_deluxe",
        name: "Ultra Hot Deluxe",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/ultra_hotfire": {
        slug: "ultra_hotfire",
        name: "Ultra Hotfire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/vault_lock_crack_it_big": {
        slug: "vault_lock_crack_it_big",
        name: "Vault Lock: Crack it Big",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/well_of_riches": {
        slug: "well_of_riches",
        name: "Well of Riches",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/wild_west_express": {
        slug: "wild_west_express",
        name: "Wild West Express",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/wings_of_fire": {
        slug: "wings_of_fire",
        name: "Wings of Fire",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/wolf_luck": {
        slug: "wolf_luck",
        name: "Wolf Luck",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "novomatic/xtra_hot": {
        slug: "xtra_hot",
        name: "Xtra Hot",
        provider: "Novomatic",
        providerSlug: "novomatic"
    },
    "onetouch/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/angels_and_demons": {
        slug: "angels_and_demons",
        name: "Angels & Demons",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/baccarat_no_commission": {
        slug: "baccarat_no_commission",
        name: "Baccarat No Commission",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/baccarat_supreme": {
        slug: "baccarat_supreme",
        name: "Baccarat Supreme",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/baccarat_supreme_no_commission": {
        slug: "baccarat_supreme_no_commission",
        name: "Baccarat Supreme No Commission",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/blackjack_classic": {
        slug: "blackjack_classic",
        name: "Blackjack Classic",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/blackjack_classic_perfect_pairs": {
        slug: "blackjack_classic_perfect_pairs",
        name: "Blackjack Classic Perfect Pairs",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/blackjack_supreme_multi_hand_perfect_pairs": {
        slug: "blackjack_supreme_multi_hand_perfect_pairs",
        name: "Blackjack Supreme Multi Hand Perfect Pairs",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/blackjack_supreme_single_hand_perfect_pairs": {
        slug: "blackjack_supreme_single_hand_perfect_pairs",
        name: "Blackjack Supreme Single Hand Perfect Pairs",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/bonus_track": {
        slug: "bonus_track",
        name: "Bonus Track",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/bubbles_bonanza": {
        slug: "bubbles_bonanza",
        name: "Bubbles Bonanza",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/christmas_grand_heist_feature_buy": {
        slug: "christmas_grand_heist_feature_buy",
        name: "Christmas Grand Heist Feature Buy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/colosseum_clash": {
        slug: "colosseum_clash",
        name: "Colosseum Clash",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/fire_combo": {
        slug: "fire_combo",
        name: "Fire Combo",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/flexing_dragons": {
        slug: "flexing_dragons",
        name: "Flexing Dragons",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/forgotten_pharaoh": {
        slug: "forgotten_pharaoh",
        name: "Forgotten Pharaoh",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/fortune_miner": {
        slug: "fortune_miner",
        name: "Fortune Miner",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/ganbaruto_battle": {
        slug: "ganbaruto_battle",
        name: "GanBaruto Battle",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/genies_secret": {
        slug: "genies_secret",
        name: "Genie's Secret",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/genies_secret_with_feature_buy": {
        slug: "genies_secret_with_feature_buy",
        name: "Genie's Secret with Feature Buy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/gifts_of_horus": {
        slug: "gifts_of_horus",
        name: "Gifts of Horus",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/god_hand": {
        slug: "god_hand",
        name: "God Hand",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/god_hand_feature_buy": {
        slug: "god_hand_feature_buy",
        name: "God Hand Feature Buy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/golden_shisa": {
        slug: "golden_shisa",
        name: "Golden Shisa",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/golden_stripe": {
        slug: "golden_stripe",
        name: "Golden Stripe",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/grand_heist": {
        slug: "grand_heist",
        name: "Grand Heist",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/grand_heist_feature_buy": {
        slug: "grand_heist_feature_buy",
        name: "Grand Heist Feature Buy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/halloween_hunt": {
        slug: "halloween_hunt",
        name: "Halloween Hunt",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/high_hand_holdem_poker": {
        slug: "high_hand_holdem_poker",
        name: "High Hand Hold'em Poker",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/holdem_poker": {
        slug: "holdem_poker",
        name: "Hold?em Poker",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/in_between_poker": {
        slug: "in_between_poker",
        name: "In Between Poker",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/infinity_tower": {
        slug: "infinity_tower",
        name: "Infinity Tower",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/juicy_7": {
        slug: "juicy_7",
        name: "Juicy 7",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/keno_rush": {
        slug: "keno_rush",
        name: "Keno Rush",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/king_of_mafia": {
        slug: "king_of_mafia",
        name: "King of Mafia",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/lady_fortuna": {
        slug: "lady_fortuna",
        name: "Lady Fortuna",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/legends_cup": {
        slug: "legends_cup",
        name: "Legends Cup",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/loot_or_boot": {
        slug: "loot_or_boot",
        name: "Loot Or Boot",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/lucky_lion": {
        slug: "lucky_lion",
        name: "Lucky Lion",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/miko_festival": {
        slug: "miko_festival",
        name: "Miko Festival",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/miko_festival_feature_buy": {
        slug: "miko_festival_feature_buy",
        name: "Miko Festival Feature Buy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/momomoolah": {
        slug: "momomoolah",
        name: "MoMoMoolah",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/monkeys_treasure": {
        slug: "monkeys_treasure",
        name: "Monkey's Treasure",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/mvp_hoops": {
        slug: "mvp_hoops",
        name: "MVP Hoops",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/neon_2077": {
        slug: "neon_2077",
        name: "Neon 2077",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/pawsome_plinko": {
        slug: "pawsome_plinko",
        name: "Pawsome Plinko",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/pips_quest": {
        slug: "pips_quest",
        name: "Pip's Quest",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/queens_of_glory": {
        slug: "queens_of_glory",
        name: "Queens of Glory",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/queens_of_glory_legacy": {
        slug: "queens_of_glory_legacy",
        name: "Queens of Glory Legacy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/raiden_medal_burst": {
        slug: "raiden_medal_burst",
        name: "Raiden Medal Burst",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/reel_fruitz_frenzy": {
        slug: "reel_fruitz_frenzy",
        name: "Reel Fruitz Frenzy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/russian_poker": {
        slug: "russian_poker",
        name: "Russian Poker",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/ryse_of_rome": {
        slug: "ryse_of_rome",
        name: "Ryse of Rome",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/ryse_of_the_mighty_gods": {
        slug: "ryse_of_the_mighty_gods",
        name: "Ryse of the Mighty Gods",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/sea_treasure": {
        slug: "sea_treasure",
        name: "Sea Treasure",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/sea_treasure_deep_dive": {
        slug: "sea_treasure_deep_dive",
        name: "Sea Treasure Deep Dive",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/snack_blast": {
        slug: "snack_blast",
        name: "Snack Blast",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/steam_vault": {
        slug: "steam_vault",
        name: "Steam Vault",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/stone_gaze": {
        slug: "stone_gaze",
        name: "Stone Gaze",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/sumo_showdown": {
        slug: "sumo_showdown",
        name: "Sumo Showdown",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/teen_patti_2020": {
        slug: "teen_patti_2020",
        name: "Teen Patti 2020",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/tiki_terror": {
        slug: "tiki_terror",
        name: "Tiki Terror",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/tonatiuhs_legacy": {
        slug: "tonatiuhs_legacy",
        name: "Tonatiuh's Legacy",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/traveling_treasures_africa": {
        slug: "traveling_treasures_africa",
        name: "Traveling Treasures Africa",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/traveling_treasures_brazil": {
        slug: "traveling_treasures_brazil",
        name: "Traveling Treasures Brazil",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/traveling_treasures_india": {
        slug: "traveling_treasures_india",
        name: "Traveling Treasures India",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wacky_wildlife": {
        slug: "wacky_wildlife",
        name: "Wacky Wildlife",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/watford_fc_slot": {
        slug: "watford_fc_slot",
        name: "Watford FC Slot",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wealthy_sharks": {
        slug: "wealthy_sharks",
        name: "Wealthy Sharks",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wheel_of_fortune": {
        slug: "wheel_of_fortune",
        name: "Wheel of Fortune",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wild_coyote_megaways": {
        slug: "wild_coyote_megaways",
        name: "Wild Coyote Megaways",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wild_sorcery": {
        slug: "wild_sorcery",
        name: "Wild Sorcery",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wild_voodoo": {
        slug: "wild_voodoo",
        name: "Wild Voodoo",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wild_waves_megaways": {
        slug: "wild_waves_megaways",
        name: "Wild Waves Megaways",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "onetouch/wild_wild_west_2120": {
        slug: "wild_wild_west_2120",
        name: "Wild Wild West 2120",
        provider: "Onetouch",
        providerSlug: "onetouch"
    },
    "penguinking/12_treasures_aztec_riches": {
        slug: "12_treasures_aztec_riches",
        name: "12 Treasures: Aztec Riches",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/15_totem_stacks_hold_and_win": {
        slug: "15_totem_stacks_hold_and_win",
        name: "15 Totem Stacks Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_christmas_pyramids_hold_and_win": {
        slug: "3_christmas_pyramids_hold_and_win",
        name: "3 Christmas Pyramids Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_energy_diamonds_hold_and_win": {
        slug: "3_energy_diamonds_hold_and_win",
        name: "3 Energy Diamonds Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_eternal_drums_rhytm_of_fortune": {
        slug: "3_eternal_drums_rhytm_of_fortune",
        name: "3 Eternal Drums Rhytm of Fortune",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_fire_frogs_hold_and_win": {
        slug: "3_fire_frogs_hold_and_win",
        name: "3 Fire Frogs: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_fortune_beasts_hold_and_win": {
        slug: "3_fortune_beasts_hold_and_win",
        name: "3 Fortune Beasts Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_gods_unleashed_hold_and_win": {
        slug: "3_gods_unleashed_hold_and_win",
        name: "3 Gods Unleashed Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_golden_baskets_treasure_tides": {
        slug: "3_golden_baskets_treasure_tides",
        name: "3 Golden Baskets Treasure Tides",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_pyramids_of_gold_hold_and_win": {
        slug: "3_pyramids_of_gold_hold_and_win",
        name: "3 Pyramids of Gold: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/3_rail_express_hold_and_win": {
        slug: "3_rail_express_hold_and_win",
        name: "3 Rail Express Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/4_leaf_fortune_hold_and_win": {
        slug: "4_leaf_fortune_hold_and_win",
        name: "4 Leaf Fortune Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/5_pyramids_of_gold_hold_and_win": {
        slug: "5_pyramids_of_gold_hold_and_win",
        name: "5 Pyramids of Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/5_relics_of_power_hold_and_win": {
        slug: "5_relics_of_power_hold_and_win",
        name: "5 Relics of Power Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/5_rings_of_darkness": {
        slug: "5_rings_of_darkness",
        name: "5 Rings of Darkness",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/5_star_boost_hold_and_win": {
        slug: "5_star_boost_hold_and_win",
        name: "5 Star Boost: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/5_star_coins_hold_and_win": {
        slug: "5_star_coins_hold_and_win",
        name: "5 Star Coins Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_hot_reels": {
        slug: "777_hot_reels",
        name: "777 Hot Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_hot_reels_supercharged": {
        slug: "777_hot_reels_supercharged",
        name: "777 Hot Reels Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_streak": {
        slug: "777_streak",
        name: "777 Streak",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_streak_megacharged": {
        slug: "777_streak_megacharged",
        name: "777 Streak: Megacharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_streak_supercharged": {
        slug: "777_streak_supercharged",
        name: "777 Streak Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/777_super_wheel_hold_and_win": {
        slug: "777_super_wheel_hold_and_win",
        name: "777 Super Wheel Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/8s_on_fire_supercharged": {
        slug: "8s_on_fire_supercharged",
        name: "8s on Fire Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/aztec_ancients": {
        slug: "aztec_ancients",
        name: "Aztec Ancients",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/ballin_jackpots_hit_the_line": {
        slug: "ballin_jackpots_hit_the_line",
        name: "Ballin Jackpots Hit The Line",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bank_busters_the_big_score": {
        slug: "bank_busters_the_big_score",
        name: "Bank Busters The Big Score",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/barhalla": {
        slug: "barhalla",
        name: "Barhalla",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bash_the_banana_stash_hold_and_win": {
        slug: "bash_the_banana_stash_hold_and_win",
        name: "Bash the Banana Stash Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bash_the_banana_stash_vault_smash": {
        slug: "bash_the_banana_stash_vault_smash",
        name: "Bash the Banana Stash: Vault Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bass_smash": {
        slug: "bass_smash",
        name: "Bass Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/beaks_gold": {
        slug: "beaks_gold",
        name: "Beaks Gold",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/blarneys_gold": {
        slug: "blarneys_gold",
        name: "Blarneys Gold",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/blazing_inferno_chaos_reels": {
        slug: "blazing_inferno_chaos_reels",
        name: "Blazing Inferno Chaos Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/blazing_touch": {
        slug: "blazing_touch",
        name: "Blazing Touch",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/boom_the_buffoon": {
        slug: "boom_the_buffoon",
        name: "Boom the Buffoon",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/boos_booty": {
        slug: "boos_booty",
        name: "Boo's Booty",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bounty_smash": {
        slug: "bounty_smash",
        name: "Bounty Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/break_the_piggy_bank": {
        slug: "break_the_piggy_bank",
        name: "Break the Piggy Bank",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/buffalo_blaze_wild_wealth": {
        slug: "buffalo_blaze_wild_wealth",
        name: "Buffalo Blaze: Wild Wealth",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/buffalo_smash": {
        slug: "buffalo_smash",
        name: "Buffalo Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/buffalo_smash_supercharged": {
        slug: "buffalo_smash_supercharged",
        name: "Buffalo Smash Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/bullet_bonanza": {
        slug: "bullet_bonanza",
        name: "Bullet Bonanza",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/burn_it_up_hold_and_win": {
        slug: "burn_it_up_hold_and_win",
        name: "Burn it Up Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/caishen_smash": {
        slug: "caishen_smash",
        name: "Caishen Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/caishens_temple_of_gold": {
        slug: "caishens_temple_of_gold",
        name: "Caishen's Temple of Gold",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/candyland_jackpots": {
        slug: "candyland_jackpots",
        name: "Candyland Jackpots",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/candyland_pop": {
        slug: "candyland_pop",
        name: "Candyland Pop",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/carved_in_gold_hold_and_win": {
        slug: "carved_in_gold_hold_and_win",
        name: "Carved in Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/cash_inferno_sizzling_scatters": {
        slug: "cash_inferno_sizzling_scatters",
        name: "Cash Inferno: Sizzling Scatters",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/cash_link_express_hold_and_win": {
        slug: "cash_link_express_hold_and_win",
        name: "Cash Link Express: Hold & Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/cash_maximus_battle_arena": {
        slug: "cash_maximus_battle_arena",
        name: "Cash Maximus: Battle Arena",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/cash_on_wheels_hold_and_win": {
        slug: "cash_on_wheels_hold_and_win",
        name: "Cash on Wheels Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/cash_strike": {
        slug: "cash_strike",
        name: "Cash Strike",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/chonky_kong_hold_and_win": {
        slug: "chonky_kong_hold_and_win",
        name: "Chonky Kong: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/christmas_crumble": {
        slug: "christmas_crumble",
        name: "Christmas Crumble",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/christmas_link_express_hold_and_win": {
        slug: "christmas_link_express_hold_and_win",
        name: "Christmas Link Express Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/coin_bang_bang_hold_and_win": {
        slug: "coin_bang_bang_hold_and_win",
        name: "Coin Bang Bang Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/coins_and_diamonds_hold_and_win": {
        slug: "coins_and_diamonds_hold_and_win",
        name: "Coins and Diamonds Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/crack_and_smash_the_piggy_bank": {
        slug: "crack_and_smash_the_piggy_bank",
        name: "Crack and Smash the Piggy Bank",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/crack_more_piggy_banks": {
        slug: "crack_more_piggy_banks",
        name: "Crack More Piggy Banks",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/crack_the_piggy_bank_express": {
        slug: "crack_the_piggy_bank_express",
        name: "Crack the Piggy Bank Express",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/crack_the_pumpkin_bank": {
        slug: "crack_the_pumpkin_bank",
        name: "Crack the Pumpkin Bank",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/crop_of_the_dead": {
        slug: "crop_of_the_dead",
        name: "Crop of the Dead",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/dead_mans_bounty_hold_and_win": {
        slug: "dead_mans_bounty_hold_and_win",
        name: "Dead Mans Bounty: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/dead_mans_gold_hold_and_win": {
        slug: "dead_mans_gold_hold_and_win",
        name: "Dead Man's Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/disco_dive": {
        slug: "disco_dive",
        name: "Disco Dive",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/doge_life": {
        slug: "doge_life",
        name: "Doge Life",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/dooms_digging_machine": {
        slug: "dooms_digging_machine",
        name: "Doom's Digging Machine",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/double_dragon_gold_hold_and_win": {
        slug: "double_dragon_gold_hold_and_win",
        name: "Double Dragon Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/dynamite_trail_hold_and_win": {
        slug: "dynamite_trail_hold_and_win",
        name: "Dynamite Trail Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/dystopia_rebel_road": {
        slug: "dystopia_rebel_road",
        name: "Dystopia Rebel Road",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/eagle_gold_hold_and_win": {
        slug: "eagle_gold_hold_and_win",
        name: "Eagle Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/eggsponential": {
        slug: "eggsponential",
        name: "Eggsponential",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/eternal_clash": {
        slug: "eternal_clash",
        name: "Eternal Clash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/eternal_clash_reloaded": {
        slug: "eternal_clash_reloaded",
        name: "Eternal Clash Reloaded",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/fire_eruption": {
        slug: "fire_eruption",
        name: "Fire Eruption",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/flame_and_fortune_hold_and_win": {
        slug: "flame_and_fortune_hold_and_win",
        name: "Flame and Fortune: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/flaming_chicken_highway_hazard": {
        slug: "flaming_chicken_highway_hazard",
        name: "Flaming Chicken Highway Hazard",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/flaming_frenzy": {
        slug: "flaming_frenzy",
        name: "Flaming Frenzy",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/flynns_gold_clovers_hold_and_win": {
        slug: "flynns_gold_clovers_hold_and_win",
        name: "Flynn's Gold Clovers: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/follow_the_cash_rabbit": {
        slug: "follow_the_cash_rabbit",
        name: "Follow the Cash Rabbit",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/fruity_diamond_stacks": {
        slug: "fruity_diamond_stacks",
        name: "Fruity Diamond Stacks",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/gates_of_the_underworld": {
        slug: "gates_of_the_underworld",
        name: "Gates of the Underworld",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/gemstone_guardians": {
        slug: "gemstone_guardians",
        name: "Gemstone Guardians",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/god_smash_eternal_chaos": {
        slug: "god_smash_eternal_chaos",
        name: "God Smash: Eternal Chaos",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/gold_chain": {
        slug: "gold_chain",
        name: "Gold Chain",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/gold_smash": {
        slug: "gold_smash",
        name: "Gold Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/golden_lhoot": {
        slug: "golden_lhoot",
        name: "Golden L'Hoot",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/golden_suns_chain_collect": {
        slug: "golden_suns_chain_collect",
        name: "Golden Suns: Chain Collect",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/guardian_of_gold_hold_and_win": {
        slug: "guardian_of_gold_hold_and_win",
        name: "Guardian of Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/happy_honey": {
        slug: "happy_honey",
        name: "Happy Honey",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/heavy_anchor": {
        slug: "heavy_anchor",
        name: "Heavy Anchor",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/hell_of_a_spin": {
        slug: "hell_of_a_spin",
        name: "Hell of a Spin",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/hot_chili_heat_spicy_hot_pots": {
        slug: "hot_chili_heat_spicy_hot_pots",
        name: "Hot Chili Heat: Spicy Hot Pots",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/hot_harvest": {
        slug: "hot_harvest",
        name: "Hot Harvest",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/inferno_rising_hold_and_win": {
        slug: "inferno_rising_hold_and_win",
        name: "Inferno Rising: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/jackpot_district_city_of_fortune": {
        slug: "jackpot_district_city_of_fortune",
        name: "Jackpot District City of Fortune",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/jackpot_heist_daylight_robbery": {
        slug: "jackpot_heist_daylight_robbery",
        name: "Jackpot Heist: Daylight Robbery",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/jj_1000_hold_and_win": {
        slug: "jj_1000_hold_and_win",
        name: "JJ 1000 Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/joker_jackpots_prize_mania": {
        slug: "joker_jackpots_prize_mania",
        name: "Joker Jackpots Prize Mania",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/juicy_jewels_supercharged": {
        slug: "juicy_jewels_supercharged",
        name: "Juicy Jewels Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/juicy_rolls_feature_frenzy": {
        slug: "juicy_rolls_feature_frenzy",
        name: "Juicy Rolls Feature Frenzy",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/kawaii_princess": {
        slug: "kawaii_princess",
        name: "Kawaii Princess",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/lady_wish": {
        slug: "lady_wish",
        name: "Lady Wish",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/legends_battle_for_earth": {
        slug: "legends_battle_for_earth",
        name: "Legends: Battle for Earth",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/liberty_coins_hold_and_win": {
        slug: "liberty_coins_hold_and_win",
        name: "Liberty Coins Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/lollicat": {
        slug: "lollicat",
        name: "Lollicat",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/lord_of_the_dunes": {
        slug: "lord_of_the_dunes",
        name: "Lord of the Dunes",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/lucky_seven_spin": {
        slug: "lucky_seven_spin",
        name: "Lucky Seven Spin",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mad_melons_chaos_reels": {
        slug: "mad_melons_chaos_reels",
        name: "Mad Melons Chaos Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mega_flex_hold_and_win": {
        slug: "mega_flex_hold_and_win",
        name: "Mega Flex Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/midas_moolah_random_reels": {
        slug: "midas_moolah_random_reels",
        name: "Midas Moolah: Random Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mole_in_the_hole": {
        slug: "mole_in_the_hole",
        name: "Mole in the Hole",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mole_smash": {
        slug: "mole_smash",
        name: "Mole Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mr_piggles": {
        slug: "mr_piggles",
        name: "Mr Piggles",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/mutant_potatoes": {
        slug: "mutant_potatoes",
        name: "Mutant Potatoes",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/next_stop_riches_hold_and_win": {
        slug: "next_stop_riches_hold_and_win",
        name: "Next Stop Riches: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/outlaw_rails_hold_and_win": {
        slug: "outlaw_rails_hold_and_win",
        name: "Outlaw Rails: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/panda_bills": {
        slug: "panda_bills",
        name: "Panda Bills",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/pearly_shores": {
        slug: "pearly_shores",
        name: "Pearly Shores",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/piggy_bankroll_the_big_stash": {
        slug: "piggy_bankroll_the_big_stash",
        name: "Piggy Bankroll: The Big Stash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/piggy_bankroll_vault_smash": {
        slug: "piggy_bankroll_vault_smash",
        name: "Piggy Bankroll: Vault Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/pip_and_pippas_pots_of_plenty": {
        slug: "pip_and_pippas_pots_of_plenty",
        name: "Pip and Pippa's Pots of Plenty",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/pot_of_charms": {
        slug: "pot_of_charms",
        name: "Pot of Charms",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/reel_bass_jackpot_catch": {
        slug: "reel_bass_jackpot_catch",
        name: "Reel Bass: Jackpot Catch",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/roaming_wild_buffalo": {
        slug: "roaming_wild_buffalo",
        name: "Roaming Wild Buffalo",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/roosters_gold_hold_and_win": {
        slug: "roosters_gold_hold_and_win",
        name: "Rooster's Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/royal_ribbit": {
        slug: "royal_ribbit",
        name: "Royal Ribbit",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/rune_raiders": {
        slug: "rune_raiders",
        name: "Rune Raiders",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/salmon_king": {
        slug: "salmon_king",
        name: "Salmon King",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/santa_smash": {
        slug: "santa_smash",
        name: "Santa Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/savannah_gold_coin_of_the_wild": {
        slug: "savannah_gold_coin_of_the_wild",
        name: "Savannah Gold Coin of the Wild",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/serpent_gold_hold_and_win": {
        slug: "serpent_gold_hold_and_win",
        name: "Serpent Gold Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/shaolin_panda_chaos_reels": {
        slug: "shaolin_panda_chaos_reels",
        name: "Shaolin Panda Chaos Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/shaolin_panda_hold_and_win": {
        slug: "shaolin_panda_hold_and_win",
        name: "Shaolin Panda Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/sheep_king": {
        slug: "sheep_king",
        name: "Sheep King",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/smooth_7s_strike": {
        slug: "smooth_7s_strike",
        name: "Smooth 7s Strike",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/sphere_smash": {
        slug: "sphere_smash",
        name: "Sphere Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/spirit_blast": {
        slug: "spirit_blast",
        name: "Spirit Blast",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/star_kingdom": {
        slug: "star_kingdom",
        name: "Star Kingdom",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/sugar_splash": {
        slug: "sugar_splash",
        name: "Sugar Splash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_boosted_prizes_hold_and_win": {
        slug: "super_boosted_prizes_hold_and_win",
        name: "Super Boosted Prizes: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_cash_boost_hold_and_win": {
        slug: "super_cash_boost_hold_and_win",
        name: "Super Cash Boost Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_cash_three_little_wins": {
        slug: "super_cash_three_little_wins",
        name: "Super Cash Three Little Wins",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_grand_link_express_hold_and_win": {
        slug: "super_grand_link_express_hold_and_win",
        name: "Super Grand Link Express Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_pyramid_of_gold_hold_and_win": {
        slug: "super_pyramid_of_gold_hold_and_win",
        name: "Super Pyramid of Gold: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/super_sundae": {
        slug: "super_sundae",
        name: "Super Sundae",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/supersonic_express_hold_and_win": {
        slug: "supersonic_express_hold_and_win",
        name: "Supersonic Express Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/sweet_smash": {
        slug: "sweet_smash",
        name: "Sweet Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/teddys_quest": {
        slug: "teddys_quest",
        name: "Teddy's Quest",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/the_big_bark_golden_jackpot": {
        slug: "the_big_bark_golden_jackpot",
        name: "The Big Bark Golden Jackpot",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/the_great_jackpot_expedition": {
        slug: "the_great_jackpot_expedition",
        name: "The Great Jackpot Expedition",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/the_greed_machine": {
        slug: "the_greed_machine",
        name: "The Greed Machine",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/thunder_hog_chaos_reels": {
        slug: "thunder_hog_chaos_reels",
        name: "Thunder Hog Chaos Reels",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/thunderline_express_hold_and_win": {
        slug: "thunderline_express_hold_and_win",
        name: "Thunderline Express: Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/thunderline_express_supercharged": {
        slug: "thunderline_express_supercharged",
        name: "Thunderline Express: Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/treasure_journey_genies_gold": {
        slug: "treasure_journey_genies_gold",
        name: "Treasure Journey Genie's Gold",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/triple_5s_supercharged": {
        slug: "triple_5s_supercharged",
        name: "Triple 5's Supercharged",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/turbo_diamonds_hold_and_win": {
        slug: "turbo_diamonds_hold_and_win",
        name: "Turbo Diamonds Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/twice_as_nice": {
        slug: "twice_as_nice",
        name: "Twice as Nice",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/twin_cash_hold_and_win": {
        slug: "twin_cash_hold_and_win",
        name: "Twin Cash Hold and WIn",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/vault_blast_hold_and_win": {
        slug: "vault_blast_hold_and_win",
        name: "Vault Blast Hold & Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/vegas_blitz_hold_and_win": {
        slug: "vegas_blitz_hold_and_win",
        name: "Vegas Blitz Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/vegas_is_dead_battle_arena": {
        slug: "vegas_is_dead_battle_arena",
        name: "Vegas is Dead Battle Arena",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/walrus_king": {
        slug: "walrus_king",
        name: "Walrus King",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/wild_white_rhino": {
        slug: "wild_white_rhino",
        name: "Wild White Rhino",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/wilfreds_wheel": {
        slug: "wilfreds_wheel",
        name: "Wilfred's Wheel",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/wish_for_a_cash_star": {
        slug: "wish_for_a_cash_star",
        name: "Wish for a Cash Star",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/wish_of_a_lifetime_hold_and_win": {
        slug: "wish_of_a_lifetime_hold_and_win",
        name: "Wish of a Lifetime Hold and Win",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "penguinking/zeus_smash": {
        slug: "zeus_smash",
        name: "Zeus Smash",
        provider: "Penguinking",
        providerSlug: "penguinking"
    },
    "peter-and-sons/abrakadabra": {
        slug: "abrakadabra",
        name: "Abrakadabra",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/alibi": {
        slug: "alibi",
        name: "Alibi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/animafia": {
        slug: "animafia",
        name: "Animafia",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/artifacts": {
        slug: "artifacts",
        name: "Artifacts",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bad_santa": {
        slug: "bad_santa",
        name: "Bad Santa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa": {
        slug: "barbarossa",
        name: "Barbarossa",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa_beyond_the_edge": {
        slug: "barbarossa_beyond_the_edge",
        name: "Barbarossa: Beyond the Edge",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa_dragon_empire": {
        slug: "barbarossa_dragon_empire",
        name: "Barbarossa Dragon Empire",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/barbarossa_revenge": {
        slug: "barbarossa_revenge",
        name: "Barbarossa Revenge",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bear_patrol": {
        slug: "bear_patrol",
        name: "Bear Patrol",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/big_bounty_bandits_3_pots": {
        slug: "big_bounty_bandits_3_pots",
        name: "Big Bounty Bandits: 3 Pots",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/blood_club": {
        slug: "blood_club",
        name: "Blood Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bloody_mary": {
        slug: "bloody_mary",
        name: "Bloody Mary",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/book_of_books": {
        slug: "book_of_books",
        name: "Book of Books",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/boom_farm": {
        slug: "boom_farm",
        name: "Boom Farm",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bubblegum_and_robo": {
        slug: "bubblegum_and_robo",
        name: "Bubblegum and Robo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/bunny_heist": {
        slug: "bunny_heist",
        name: "Bunny Heist",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/burning_riot": {
        slug: "burning_riot",
        name: "Burning RIot",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cauldron": {
        slug: "cauldron",
        name: "Cauldron",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/clash_of_claws": {
        slug: "clash_of_claws",
        name: "Clash of Claws",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/coin_blox": {
        slug: "coin_blox",
        name: "Coin Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/coins_of_cleo": {
        slug: "coins_of_cleo",
        name: "Coins of Cleo",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cyber_doom": {
        slug: "cyber_doom",
        name: "Cyber Doom",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/cyber_runner": {
        slug: "cyber_runner",
        name: "Cyber Runner",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dcirque": {
        slug: "dcirque",
        name: "Dcirque",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dig_it": {
        slug: "dig_it",
        name: "Dig it",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dragon_blox": {
        slug: "dragon_blox",
        name: "Dragon Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dragon_guardians_3_pots": {
        slug: "dragon_guardians_3_pots",
        name: "Dragon Guardians: 3 Pots",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/dungeon_tower": {
        slug: "dungeon_tower",
        name: "Dungeon Tower",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/epic_hellas": {
        slug: "epic_hellas",
        name: "Epic Hellas",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/evil_devil": {
        slug: "evil_devil",
        name: "Evil Devil",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/frozen_age": {
        slug: "frozen_age",
        name: "Frozen Age",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ghost_father": {
        slug: "ghost_father",
        name: "Ghost Father",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ghostfather_awakened": {
        slug: "ghostfather_awakened",
        name: "Ghostfather Awakened",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/ginger_wins_wild_jungle": {
        slug: "ginger_wins_wild_jungle",
        name: "Ginger Wins: Wild Jungle",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/gnomes_and_giants": {
        slug: "gnomes_and_giants",
        name: "Gnomes and Giants",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/greedy_alice_2_bigger_bites": {
        slug: "greedy_alice_2_bigger_bites",
        name: "Greedy Alice 2: Bigger Bites",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/gun_powder": {
        slug: "gun_powder",
        name: "Gun Powder",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/hammer_of_gods": {
        slug: "hammer_of_gods",
        name: "Hammer of Gods",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/headhunter": {
        slug: "headhunter",
        name: "Headhunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/johnan_legendarian": {
        slug: "johnan_legendarian",
        name: "Johnan Legendarian",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/kaiser": {
        slug: "kaiser",
        name: "Kaiser",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/king_power": {
        slug: "king_power",
        name: "King Power",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/lockn_load": {
        slug: "lockn_load",
        name: "Lock'n Load",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/lucky_caiman": {
        slug: "lucky_caiman",
        name: "Lucky Caiman",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/manic_fairy": {
        slug: "manic_fairy",
        name: "Manic Fairy",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/monster_blox": {
        slug: "monster_blox",
        name: "Monster Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/muddy_waters": {
        slug: "muddy_waters",
        name: "Muddy Waters",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/mutagenes": {
        slug: "mutagenes",
        name: "Mutagenes",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/peter_hunter": {
        slug: "peter_hunter",
        name: "Peter Hunter",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/pop_cop": {
        slug: "pop_cop",
        name: "Pop Cop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/precious_7": {
        slug: "precious_7",
        name: "Precious 7",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/punch_club": {
        slug: "punch_club",
        name: "Punch Club",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/roadquake": {
        slug: "roadquake",
        name: "Roadquake",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/robin_nottingham_raiders": {
        slug: "robin_nottingham_raiders",
        name: "Robin - Nottingham Raiders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/robin_sherwood_marauders": {
        slug: "robin_sherwood_marauders",
        name: "Robin - Sherwood Marauders",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/roman_glory": {
        slug: "roman_glory",
        name: "Roman Glory",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rome_the_conquerors": {
        slug: "rome_the_conquerors",
        name: "Rome - The Conquerors",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rudis": {
        slug: "rudis",
        name: "Rudis",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/rust_world": {
        slug: "rust_world",
        name: "Rust World",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/sands_of_destiny": {
        slug: "sands_of_destiny",
        name: "Sands of Destiny",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/sheriff_colt": {
        slug: "sheriff_colt",
        name: "Sheriff Colt",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/speed_freaks": {
        slug: "speed_freaks",
        name: "Speed Freaks",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/spell_forged": {
        slug: "spell_forged",
        name: "Spell Forged",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/steamworks_the_workshop": {
        slug: "steamworks_the_workshop",
        name: "Steamworks the Workshop",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/street_ninja": {
        slug: "street_ninja",
        name: "Street Ninja",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/tango_of_chaos": {
        slug: "tango_of_chaos",
        name: "Tango of Chaos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_legend_of_musashi": {
        slug: "the_legend_of_musashi",
        name: "The Legend of Musashi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_mafiosi": {
        slug: "the_mafiosi",
        name: "The Mafiosi",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/the_soapranos": {
        slug: "the_soapranos",
        name: "The Soapranos",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/thunder_hawk": {
        slug: "thunder_hawk",
        name: "Thunder Hawk",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/valkyries": {
        slug: "valkyries",
        name: "Valkyries",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/viking_legacy_hold_and_win": {
        slug: "viking_legacy_hold_and_win",
        name: "Viking Legacy Hold and Win",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/voodoo_hex": {
        slug: "voodoo_hex",
        name: "Voodoo Hex",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/water_blox": {
        slug: "water_blox",
        name: "Water Blox",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_bard": {
        slug: "wild_bard",
        name: "Wild Bard",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_duel": {
        slug: "wild_duel",
        name: "Wild Duel",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/wild_one": {
        slug: "wild_one",
        name: "Wild One",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/xibalba": {
        slug: "xibalba",
        name: "Xibalba",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/zombie_road": {
        slug: "zombie_road",
        name: "Zombie Road",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "peter-and-sons/zombies": {
        slug: "zombies",
        name: "Zombies",
        provider: "Peter & Sons",
        providerSlug: "peter-and-sons"
    },
    "pgsoft/alchemy_gold": {
        slug: "alchemy_gold",
        name: "Alchemy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/alibabas_cave_of_fortune": {
        slug: "alibabas_cave_of_fortune",
        name: "Alibaba's Cave of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/anubis_wrath": {
        slug: "anubis_wrath",
        name: "Anubis Wrath",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/asgardian_rising": {
        slug: "asgardian_rising",
        name: "Asgardian Rising",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/baccarat_deluxe": {
        slug: "baccarat_deluxe",
        name: "Baccarat Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bakery_bonanza": {
        slug: "bakery_bonanza",
        name: "Bakery Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bali_vacation": {
        slug: "bali_vacation",
        name: "Bali Vacation",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/battleground_royale": {
        slug: "battleground_royale",
        name: "Battleground Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/bikini_paradise": {
        slug: "bikini_paradise",
        name: "Bikini Paradise",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/buffalo_win": {
        slug: "buffalo_win",
        name: "Buffalo Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/butterfly_blossom": {
        slug: "butterfly_blossom",
        name: "Butterfly Blossom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/caishen_wins": {
        slug: "caishen_wins",
        name: "Caishen Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/candy_bonanza": {
        slug: "candy_bonanza",
        name: "Candy Bonanza",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/candy_burst": {
        slug: "candy_burst",
        name: "Candy Burst",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/captains_bounty": {
        slug: "captains_bounty",
        name: "Captain's Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cash_mania": {
        slug: "cash_mania",
        name: "Cash Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/chicky_run": {
        slug: "chicky_run",
        name: "Chicky Run",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/chocolate_deluxe": {
        slug: "chocolate_deluxe",
        name: "Chocolate Deluxe",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/circus_delight": {
        slug: "circus_delight",
        name: "Circus Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cocktail_nights": {
        slug: "cocktail_nights",
        name: "Cocktail Nights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/cruise_royale": {
        slug: "cruise_royale",
        name: "Cruise Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/crypto_gold": {
        slug: "crypto_gold",
        name: "Crypto Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dead_mans_riches": {
        slug: "dead_mans_riches",
        name: "Dead Man's Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/destiny_of_sun_and_moon": {
        slug: "destiny_of_sun_and_moon",
        name: "Destiny of Sun and Moon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/diner_delights": {
        slug: "diner_delights",
        name: "Diner Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/diner_frenzy_spins": {
        slug: "diner_frenzy_spins",
        name: "Diner Frenzy Spins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/doomsday_rampage": {
        slug: "doomsday_rampage",
        name: "Doomsday Rampage",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/double_fortune": {
        slug: "double_fortune",
        name: "Double Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_hatch": {
        slug: "dragon_hatch",
        name: "Dragon Hatch",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_legend": {
        slug: "dragon_legend",
        name: "Dragon Legend",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragon_tiger_luck": {
        slug: "dragon_tiger_luck",
        name: "Dragon Tiger Luck",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dragons_treasure_quest": {
        slug: "dragons_treasure_quest",
        name: "Dragon's Treasure Quest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/dreams_of_macau": {
        slug: "dreams_of_macau",
        name: "Dreams of Macau",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/egypts_book_of_mystery": {
        slug: "egypts_book_of_mystery",
        name: "Egypt's Book of Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/emoji_riches": {
        slug: "emoji_riches",
        name: "Emoji Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/emperors_favour": {
        slug: "emperors_favour",
        name: "Emperor's Favour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/farmstead_fortune": {
        slug: "farmstead_fortune",
        name: "Farmstead Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/flirting_scholar": {
        slug: "flirting_scholar",
        name: "Flirting Scholar",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/forbidden_alchemy": {
        slug: "forbidden_alchemy",
        name: "Forbidden Alchemy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/forge_of_wealth": {
        slug: "forge_of_wealth",
        name: "Forge of Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_dragon": {
        slug: "fortune_dragon",
        name: "Fortune Dragon",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_gods": {
        slug: "fortune_gods",
        name: "Fortune Gods",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_horse": {
        slug: "fortune_horse",
        name: "Fortune Horse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_mouse": {
        slug: "fortune_mouse",
        name: "Fortune Mouse",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_ox": {
        slug: "fortune_ox",
        name: "Fortune Ox",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_rabbit": {
        slug: "fortune_rabbit",
        name: "Fortune Rabbit",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_snake": {
        slug: "fortune_snake",
        name: "Fortune Snake",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fortune_tiger": {
        slug: "fortune_tiger",
        name: "Fortune Tiger",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/fruit_candy": {
        slug: "fruit_candy",
        name: "Fruit Candy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/funky_fortunez": {
        slug: "funky_fortunez",
        name: "Funky Fortunez",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/futebol_fever": {
        slug: "futebol_fever",
        name: "Futebol Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/galactic_gems": {
        slug: "galactic_gems",
        name: "Galactic Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/galaxy_miner": {
        slug: "galaxy_miner",
        name: "Galaxy Miner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ganesha_fortune": {
        slug: "ganesha_fortune",
        name: "Ganesha Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ganesha_gold": {
        slug: "ganesha_gold",
        name: "Ganesha Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/garuda_gems": {
        slug: "garuda_gems",
        name: "Garuda Gems",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/geishas_revenge": {
        slug: "geishas_revenge",
        name: "Geisha's Revenge",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour": {
        slug: "gem_saviour",
        name: "Gem Saviour",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour_conquest": {
        slug: "gem_saviour_conquest",
        name: "Gem Saviour Conquest",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gem_saviour_sword": {
        slug: "gem_saviour_sword",
        name: "Gem Saviour Sword",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gemstones_gold": {
        slug: "gemstones_gold",
        name: "Gemstones Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/genies_3_wishes": {
        slug: "genies_3_wishes",
        name: "Genie's 3 Wishes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/gladiators_glory": {
        slug: "gladiators_glory",
        name: "Gladiators Glory",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/graffiti_rush": {
        slug: "graffiti_rush",
        name: "Graffiti Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/grimms_bounty_hanset_and_gretel": {
        slug: "grimms_bounty_hanset_and_gretel",
        name: "Grimms Bounty Hanset and Gretel",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/grimms_bounty_princess_and_the_frog": {
        slug: "grimms_bounty_princess_and_the_frog",
        name: "Grimms' Bounty: Princess and the Frog",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/guardians_of_ice_and_fire": {
        slug: "guardians_of_ice_and_fire",
        name: "Guardians of Ice and Fire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hawaiian_tiki": {
        slug: "hawaiian_tiki",
        name: "Hawaiian Tiki",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/heist_stakes": {
        slug: "heist_stakes",
        name: "Heist Stakes",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hip_hop_panda": {
        slug: "hip_hop_panda",
        name: "Hip Hop Panda",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/honey_trap_of_diao_chan": {
        slug: "honey_trap_of_diao_chan",
        name: "Honey Trap of Diao Chan",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hood_vs_wolf": {
        slug: "hood_vs_wolf",
        name: "Hood vs Wolf",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/hotpot": {
        slug: "hotpot",
        name: "Hotpot",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/incan_wonders": {
        slug: "incan_wonders",
        name: "Incan Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/inferno_mayhem": {
        slug: "inferno_mayhem",
        name: "Inferno Mayhem",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jack_frosts_winter": {
        slug: "jack_frosts_winter",
        name: "Jack Frost's Winter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jack_the_giant_hunter": {
        slug: "jack_the_giant_hunter",
        name: "Jack the Giant Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jewels_of_prosperity": {
        slug: "jewels_of_prosperity",
        name: "Jewels of Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/journey_to_the_wealth": {
        slug: "journey_to_the_wealth",
        name: "Journey to the Wealth",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jungle_delight": {
        slug: "jungle_delight",
        name: "Jungle Delight",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/jurassic_kingdom": {
        slug: "jurassic_kingdom",
        name: "Jurassic Kingdom",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/knockout_riches": {
        slug: "knockout_riches",
        name: "Knockout Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/kraken_gold_rush": {
        slug: "kraken_gold_rush",
        name: "Kraken Gold Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legend_of_hou_yi": {
        slug: "legend_of_hou_yi",
        name: "Legend of Hou Yi",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legend_of_perseus": {
        slug: "legend_of_perseus",
        name: "Legend of Perseus",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/legendary_monkey_king": {
        slug: "legendary_monkey_king",
        name: "Legendary Monkey King",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/leprechaun_riches": {
        slug: "leprechaun_riches",
        name: "Leprechaun Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_clover_riches": {
        slug: "lucky_clover_riches",
        name: "Lucky Clover Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_mischief": {
        slug: "lucky_mischief",
        name: "Lucky Mischief",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_neko": {
        slug: "lucky_neko",
        name: "Lucky Neko",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/lucky_piggy": {
        slug: "lucky_piggy",
        name: "Lucky Piggy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mahjong_ways": {
        slug: "mahjong_ways",
        name: "Mahjong Ways",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mahjong_ways_2": {
        slug: "mahjong_ways_2",
        name: "Mahjong Ways 2",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/majestic_empire": {
        slug: "majestic_empire",
        name: "Majestic Empire",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/majestic_treasures": {
        slug: "majestic_treasures",
        name: "Majestic Treasures",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mask_carnival": {
        slug: "mask_carnival",
        name: "Mask Carnival",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mayan_destiny": {
        slug: "mayan_destiny",
        name: "Mayan Destiny",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/medusa": {
        slug: "medusa",
        name: "Medusa",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/medusa_ii": {
        slug: "medusa_ii",
        name: "Medusa II",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mermaid_riches": {
        slug: "mermaid_riches",
        name: "Mermaid Riches",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/midas_fortune": {
        slug: "midas_fortune",
        name: "Midas Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mighty_mania": {
        slug: "mighty_mania",
        name: "Mighty Mania",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/monkeys_wild_party": {
        slug: "monkeys_wild_party",
        name: "Monkeys Wild Party",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mr_hallowwin": {
        slug: "mr_hallowwin",
        name: "Mr. Hallow-Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mr_treasures_fortune": {
        slug: "mr_treasures_fortune",
        name: "Mr Treasure's Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/muay_thai_champion": {
        slug: "muay_thai_champion",
        name: "Muay Thai Champion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/museum_mystery": {
        slug: "museum_mystery",
        name: "Museum Mystery",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mystic_potion": {
        slug: "mystic_potion",
        name: "Mystic Potion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mystical_spirits": {
        slug: "mystical_spirits",
        name: "Mystical Spirits",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/mythical_guardians": {
        slug: "mythical_guardians",
        name: "Mythical Guardians",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ninja_raccoon_frenzy": {
        slug: "ninja_raccoon_frenzy",
        name: "Ninja Raccoon Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ninja_vs_samurai": {
        slug: "ninja_vs_samurai",
        name: "Ninja vs Samurai",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/oishi_delights": {
        slug: "oishi_delights",
        name: "Oishi Delights",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/opera_dynasty": {
        slug: "opera_dynasty",
        name: "Opera Dynasty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/oriental_prosperity": {
        slug: "oriental_prosperity",
        name: "Oriental Prosperity",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/perfect_strike": {
        slug: "perfect_strike",
        name: "Perfect Strike",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/pharaoh_royale": {
        slug: "pharaoh_royale",
        name: "Pharaoh Royale",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/phoenix_rises": {
        slug: "phoenix_rises",
        name: "Phoenix Rises",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/piggy_gold": {
        slug: "piggy_gold",
        name: "Piggy Gold",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/pinata_wins": {
        slug: "pinata_wins",
        name: "Pinata Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/plushie_frenzy": {
        slug: "plushie_frenzy",
        name: "Plushie Frenzy",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/poker_kingdom_win": {
        slug: "poker_kingdom_win",
        name: "Poker Kingdom Win",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/prosperity_fortune_tree": {
        slug: "prosperity_fortune_tree",
        name: "Prosperity Fortune Tree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/prosperity_lanterns": {
        slug: "prosperity_lanterns",
        name: "Prosperity Lanterns",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/prosperity_lion": {
        slug: "prosperity_lion",
        name: "Prosperity Lion",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/queen_of_bounty": {
        slug: "queen_of_bounty",
        name: "Queen of Bounty",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/raider_janes_crypt_of_fortune": {
        slug: "raider_janes_crypt_of_fortune",
        name: "Raider Jane's Crypt of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rave_party_fever": {
        slug: "rave_party_fever",
        name: "Rave Party Fever",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/reel_love": {
        slug: "reel_love",
        name: "Reel Love",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/reel_royale_showdown": {
        slug: "reel_royale_showdown",
        name: "Reel Royale Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rio_fantasia": {
        slug: "rio_fantasia",
        name: "Rio Fantasia",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rise_of_apollo": {
        slug: "rise_of_apollo",
        name: "Rise of Apollo",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/rooster_rumble": {
        slug: "rooster_rumble",
        name: "Rooster Rumble",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/safari_wilds": {
        slug: "safari_wilds",
        name: "Safari Wilds",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/santas_gift_rush": {
        slug: "santas_gift_rush",
        name: "Santa's Gift Rush",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/secrets_of_cleopatra": {
        slug: "secrets_of_cleopatra",
        name: "Secrets of Cleopatra",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/shaolin_soccer": {
        slug: "shaolin_soccer",
        name: "Shaolin Soccer",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/shark_hunter": {
        slug: "shark_hunter",
        name: "Shark Hunter",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/skylight_wonders": {
        slug: "skylight_wonders",
        name: "Skylight Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/songkran_splash": {
        slug: "songkran_splash",
        name: "Songkran Splash",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/speed_winner": {
        slug: "speed_winner",
        name: "Speed Winner",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/spirited_wonders": {
        slug: "spirited_wonders",
        name: "Spirited Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/super_golf_drive": {
        slug: "super_golf_drive",
        name: "Super Golf Drive",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/super_wildrix": {
        slug: "super_wildrix",
        name: "Super Wildrix",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/supermarket_spree": {
        slug: "supermarket_spree",
        name: "Supermarket Spree",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/symbols_of_egypt": {
        slug: "symbols_of_egypt",
        name: "Symbols of Egypt",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/thai_river_wonders": {
        slug: "thai_river_wonders",
        name: "Thai River Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/the_great_icescape": {
        slug: "the_great_icescape",
        name: "The Great Icescape",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/the_queens_banquet": {
        slug: "the_queens_banquet",
        name: "The Queen's Banquet",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/three_crazy_piggies": {
        slug: "three_crazy_piggies",
        name: "Three Crazy Piggies",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/tornado_rampage": {
        slug: "tornado_rampage",
        name: "Tornado Rampage",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/totem_wonders": {
        slug: "totem_wonders",
        name: "Totem Wonders",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/touchdown_wins": {
        slug: "touchdown_wins",
        name: "Touchdown Wins",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/treasures_of_aztec": {
        slug: "treasures_of_aztec",
        name: "Treasures of Aztec",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/tree_of_fortune": {
        slug: "tree_of_fortune",
        name: "Tree of Fortune",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ultimate_striker": {
        slug: "ultimate_striker",
        name: "Ultimate Striker",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/vampires_charm": {
        slug: "vampires_charm",
        name: "Vampire's Charm",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/ways_of_the_qilin": {
        slug: "ways_of_the_qilin",
        name: "Ways of the Qilin",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_ape_3258": {
        slug: "wild_ape_3258",
        name: "Wild Ape 3258",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_bandito": {
        slug: "wild_bandito",
        name: "Wild Bandito",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_bounty_showdown": {
        slug: "wild_bounty_showdown",
        name: "Wild Bounty Showdown",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_coaster": {
        slug: "wild_coaster",
        name: "Wild Coaster",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wild_fireworks": {
        slug: "wild_fireworks",
        name: "Wild Fireworks",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/win_win_fish_prawn_crab": {
        slug: "win_win_fish_prawn_crab",
        name: "Win Win Fish Prawn Crab",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/win_win_won": {
        slug: "win_win_won",
        name: "Win Win Won",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/wings_of_iguazu": {
        slug: "wings_of_iguazu",
        name: "Wings of Iguazu",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/yakuza_honor": {
        slug: "yakuza_honor",
        name: "Yakuza Honor",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/zombie_blasters": {
        slug: "zombie_blasters",
        name: "Zombie Blasters",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "pgsoft/zombie_outbreak": {
        slug: "zombie_outbreak",
        name: "Zombie Outbreak",
        provider: "PGSoft",
        providerSlug: "pgsoft"
    },
    "play-beyond-games/aswang_attack": {
        slug: "aswang_attack",
        name: "Aswang Attack",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/boracay_beauties": {
        slug: "boracay_beauties",
        name: "Boracay Beauties",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/dragon_vs_phoenix": {
        slug: "dragon_vs_phoenix",
        name: "Dragon vs Phoenix",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/fruit_fiesta": {
        slug: "fruit_fiesta",
        name: "Fruit Fiesta",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/good_luck_money": {
        slug: "good_luck_money",
        name: "Good Luck Money",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/jeepney_scatter": {
        slug: "jeepney_scatter",
        name: "Jeepney Scatter",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/pixiemagic_color_game": {
        slug: "pixiemagic_color_game",
        name: "PixieMagic Color Game",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/pop_monsters_cutesy_clash": {
        slug: "pop_monsters_cutesy_clash",
        name: "Pop Monsters: Cutesy Clash",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/royal_ace": {
        slug: "royal_ace",
        name: "Royal Ace",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/sari_sari_store": {
        slug: "sari_sari_store",
        name: "Sari Sari Store",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/super_galaxy_princess": {
        slug: "super_galaxy_princess",
        name: "Super Galaxy Princess",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/sweet_dash": {
        slug: "sweet_dash",
        name: "Sweet Dash",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/war_for_olympus": {
        slug: "war_for_olympus",
        name: "War for Olympus",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/xmas_around_the_world": {
        slug: "xmas_around_the_world",
        name: "Xmas Around the World",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-beyond-games/yamashitas_treasure": {
        slug: "yamashitas_treasure",
        name: "Yamashita's Treasure",
        provider: "Play Beyond Games",
        providerSlug: "play-beyond-games"
    },
    "play-n-go/1001_mystery_genie_fortunes": {
        slug: "1001_mystery_genie_fortunes",
        name: "1001 Mystery Genie Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/13th_trial_hercules_abyssways": {
        slug: "13th_trial_hercules_abyssways",
        name: "13th Trial Hercules Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/15_crystal_roses_a_tale_of_love": {
        slug: "15_crystal_roses_a_tale_of_love",
        name: "15 Crystal Roses: A Tale of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/24k_dragon": {
        slug: "24k_dragon",
        name: "24K Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_blades_and_blessings": {
        slug: "3_blades_and_blessings",
        name: "3 Blades and Blessings",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_clown_monty": {
        slug: "3_clown_monty",
        name: "3 Clown Monty",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_clown_monty_ii": {
        slug: "3_clown_monty_ii",
        name: "3 Clown Monty II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/3_hand_casino": {
        slug: "3_hand_casino",
        name: "3 Hand Casino",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/5x_magic": {
        slug: "5x_magic",
        name: "5x Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/7_sins": {
        slug: "7_sins",
        name: "7 Sins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ace_of_spades": {
        slug: "ace_of_spades",
        name: "Ace of Spades",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/agent_destiny": {
        slug: "agent_destiny",
        name: "Agent Destiny",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/agent_of_hearts": {
        slug: "agent_of_hearts",
        name: "Agent of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/animal_madness": {
        slug: "animal_madness",
        name: "Animal Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ankh_of_anubis": {
        slug: "ankh_of_anubis",
        name: "Ankh of Anubis",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ankh_of_anubis_awakening": {
        slug: "ankh_of_anubis_awakening",
        name: "Ankh of Anubis Awakening",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/annihilator": {
        slug: "annihilator",
        name: "Annihilator",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/athena_ascending": {
        slug: "athena_ascending",
        name: "Athena Ascending",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/aztec_idols": {
        slug: "aztec_idols",
        name: "Aztec Idols",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/aztec_warrior_princess": {
        slug: "aztec_warrior_princess",
        name: "Aztec Warrior Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bakers_treat": {
        slug: "bakers_treat",
        name: "Baker's Treat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banana_rock": {
        slug: "banana_rock",
        name: "Banana Rock",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banana_rush": {
        slug: "banana_rush",
        name: "Banana Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/banquet_of_dead": {
        slug: "banquet_of_dead",
        name: "Banquet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bao_shi": {
        slug: "bao_shi",
        name: "Bao Shi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/barn_busters": {
        slug: "barn_busters",
        name: "Barn Busters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/baron_lord_of_saturday": {
        slug: "baron_lord_of_saturday",
        name: "Baron Lord of Saturday",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/battle_royal": {
        slug: "battle_royal",
        name: "Battle Royal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/beasts_of_fire": {
        slug: "beasts_of_fire",
        name: "Beasts of Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/beasts_of_fire_inferno": {
        slug: "beasts_of_fire_inferno",
        name: "Beasts of Fire Inferno",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/beasts_of_fire_maximum": {
        slug: "beasts_of_fire_maximum",
        name: "Beasts of Fire Maximum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_777": {
        slug: "big_win_777",
        name: "Big Win 777",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_cat": {
        slug: "big_win_cat",
        name: "Big Win Cat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/big_win_city_pawsperity": {
        slug: "big_win_city_pawsperity",
        name: "Big Win City Pawsperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/black_mamba": {
        slug: "black_mamba",
        name: "Black Mamba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blackjack_multi_hand": {
        slug: "blackjack_multi_hand",
        name: "Blackjack Multi Hand",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blazin_bullfrog": {
        slug: "blazin_bullfrog",
        name: "Blazin' Bullfrog",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/blinged": {
        slug: "blinged",
        name: "Blinged",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza": {
        slug: "boat_bonanza",
        name: "Boat Bonanza",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_christmas": {
        slug: "boat_bonanza_christmas",
        name: "Boat Bonanza Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_colossal_catch": {
        slug: "boat_bonanza_colossal_catch",
        name: "Boat Bonanza Colossal Catch",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_croconile": {
        slug: "boat_bonanza_croconile",
        name: "Boat Bonanza Croconile",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/boat_bonanza_down_under": {
        slug: "boat_bonanza_down_under",
        name: "Boat Bonanza Down Under",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/book_of_dead": {
        slug: "book_of_dead",
        name: "Book of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/book_of_dead_go_collect": {
        slug: "book_of_dead_go_collect",
        name: "Book of Dead Go Collect",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bubblin_riches": {
        slug: "bubblin_riches",
        name: "Bubblin Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buffalo_of_wealth": {
        slug: "buffalo_of_wealth",
        name: "Buffalo of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_bucks": {
        slug: "buildin_bucks",
        name: "Buildin Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_even_more_bucks": {
        slug: "buildin_even_more_bucks",
        name: "Buildin' Even More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/buildin_more_bucks": {
        slug: "buildin_more_bucks",
        name: "Buildin More Bucks",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bull_in_a_china_shop": {
        slug: "bull_in_a_china_shop",
        name: "Bull in a China Shop",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bull_in_a_rodeo": {
        slug: "bull_in_a_rodeo",
        name: "Bull in a Rodeo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/bullion_express": {
        slug: "bullion_express",
        name: "Bullion Express",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/candy_island_princess": {
        slug: "candy_island_princess",
        name: "Candy Island Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/canine_carnage": {
        slug: "canine_carnage",
        name: "Canine Carnage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/captain_glum_pirate_hunter": {
        slug: "captain_glum_pirate_hunter",
        name: "Captain Glum: Pirate Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/captain_xenos_earth_adventure": {
        slug: "captain_xenos_earth_adventure",
        name: "Captain Xeno's Earth Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_a_cabana": {
        slug: "cash_a_cabana",
        name: "Cash a Cabana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_of_command": {
        slug: "cash_of_command",
        name: "Cash of Command",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_pump": {
        slug: "cash_pump",
        name: "Cash Pump",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cash_vandal": {
        slug: "cash_vandal",
        name: "Cash Vandal",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cashin_joker": {
        slug: "cashin_joker",
        name: "Cashin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_doom_of_dead": {
        slug: "cat_wilde_and_the_doom_of_dead",
        name: "Cat Wilde and the Doom of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_incan_quest": {
        slug: "cat_wilde_and_the_incan_quest",
        name: "Cat Wilde and the Incan Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_lost_chapter": {
        slug: "cat_wilde_and_the_lost_chapter",
        name: "Cat Wilde and the Lost Chapter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_and_the_pyramids_of_dead": {
        slug: "cat_wilde_and_the_pyramids_of_dead",
        name: "Cat Wilde and the Pyramids of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cat_wilde_in_the_eclipse_of_the_sun_god": {
        slug: "cat_wilde_in_the_eclipse_of_the_sun_god",
        name: "Cat Wilde in the Eclipse of the Sun God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cats_and_cash": {
        slug: "cats_and_cash",
        name: "Cats and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chambers_of_ancients": {
        slug: "chambers_of_ancients",
        name: "Chambers of Ancients",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/champions_of_mithrune": {
        slug: "champions_of_mithrune",
        name: "Champions of Mithrune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance": {
        slug: "charlie_chance",
        name: "Charlie Chance",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance_and_the_curse_of_cleopatra": {
        slug: "charlie_chance_and_the_curse_of_cleopatra",
        name: "Charlie Chance and The Curse of Cleopatra",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/charlie_chance_in_hell_to_pay": {
        slug: "charlie_chance_in_hell_to_pay",
        name: "Charlie Chance in Hell to Pay",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chinese_new_year": {
        slug: "chinese_new_year",
        name: "Chinese New Year",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chronos_joker": {
        slug: "chronos_joker",
        name: "Chronos Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/chunky_carlos_money_mania": {
        slug: "chunky_carlos_money_mania",
        name: "Chunky Carlo's Money Mania",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/city_of_sound": {
        slug: "city_of_sound",
        name: "City of Sound",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/clash_of_camelot": {
        slug: "clash_of_camelot",
        name: "Clash of Camelot",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cloud_quest": {
        slug: "cloud_quest",
        name: "Cloud Quest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/coils_of_cash": {
        slug: "coils_of_cash",
        name: "Coils of Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/colt_lightning": {
        slug: "colt_lightning",
        name: "Colt Lightning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/colt_lightning_firestorm": {
        slug: "colt_lightning_firestorm",
        name: "Colt Lightning Firestorm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/contact": {
        slug: "contact",
        name: "Contact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/copsnrobbers": {
        slug: "copsnrobbers",
        name: "Cops'n'Robbers",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/count_jokula": {
        slug: "count_jokula",
        name: "Count Jokula",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/court_of_hearts": {
        slug: "court_of_hearts",
        name: "Court of Hearts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/coywolf_cash": {
        slug: "coywolf_cash",
        name: "Coywolf Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crabbys_gold": {
        slug: "crabbys_gold",
        name: "Crabby's Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crabbys_gold_ii": {
        slug: "crabbys_gold_ii",
        name: "Crabby's Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crazy_cows": {
        slug: "crazy_cows",
        name: "Crazy Cows",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crystal_hall": {
        slug: "crystal_hall",
        name: "Crystal Hall",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/crystal_sun": {
        slug: "crystal_sun",
        name: "Crystal Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/cursed_moon_power_collection": {
        slug: "cursed_moon_power_collection",
        name: "Cursed Moon Power Collection",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dansband_pa_turne": {
        slug: "dansband_pa_turne",
        name: "Dansband Pa Turne",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dawn_of_egypt": {
        slug: "dawn_of_egypt",
        name: "Dawn of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/demon": {
        slug: "demon",
        name: "Demon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/derby_wheel": {
        slug: "derby_wheel",
        name: "Derby Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/diamond_vortex": {
        slug: "diamond_vortex",
        name: "Diamond Vortex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/diamonds_of_the_realm": {
        slug: "diamonds_of_the_realm",
        name: "Diamonds of the Realm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dio_killing_the_dragon": {
        slug: "dio_killing_the_dragon",
        name: "DIO Killing the Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/disco_diamonds": {
        slug: "disco_diamonds",
        name: "Disco Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/divina_commedia_i_nove_cerchi": {
        slug: "divina_commedia_i_nove_cerchi",
        name: "Divina Commedia I Nove Cerchi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/divine_showdown": {
        slug: "divine_showdown",
        name: "Divine Showdown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/doom_of_egypt": {
        slug: "doom_of_egypt",
        name: "Doom of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/double_exposure_blackjack": {
        slug: "double_exposure_blackjack",
        name: "Double Exposure Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dr_toonz": {
        slug: "dr_toonz",
        name: "Dr. Toonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragon_maiden": {
        slug: "dragon_maiden",
        name: "Dragon Maiden",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragon_ship": {
        slug: "dragon_ship",
        name: "Dragon Ship",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/dragonfates_favour": {
        slug: "dragonfates_favour",
        name: "Dragonfate's Favour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/easter_eggs": {
        slug: "easter_eggs",
        name: "Easter Eggs",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/easter_eggspedition": {
        slug: "easter_eggspedition",
        name: "Easter Eggspedition",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/enchanted_crystals": {
        slug: "enchanted_crystals",
        name: "Enchanted Crystals",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/enchanted_meadow": {
        slug: "enchanted_meadow",
        name: "Enchanted Meadow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/energoonz": {
        slug: "energoonz",
        name: "Energoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/european_blackjack": {
        slug: "european_blackjack",
        name: "European Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/eye_of_atum": {
        slug: "eye_of_atum",
        name: "Eye of Atum",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/eye_of_the_kraken": {
        slug: "eye_of_the_kraken",
        name: "Eye of the Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fangs_and_fire": {
        slug: "fangs_and_fire",
        name: "Fangs and Fire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fat_frankies": {
        slug: "fat_frankies",
        name: "Fat Frankies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fate_of_dead_blitzways": {
        slug: "fate_of_dead_blitzways",
        name: "Fate of Dead Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fates_fortune": {
        slug: "fates_fortune",
        name: "Fate's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/feline_fury": {
        slug: "feline_fury",
        name: "Feline Fury",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker": {
        slug: "fire_joker",
        name: "Fire Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_100": {
        slug: "fire_joker_100",
        name: "Fire Joker 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_blitz": {
        slug: "fire_joker_blitz",
        name: "Fire Joker Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_joker_freeze": {
        slug: "fire_joker_freeze",
        name: "Fire Joker Freeze",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_toad": {
        slug: "fire_toad",
        name: "Fire Toad",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fire_toad_2": {
        slug: "fire_toad_2",
        name: "Fire Toad 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/firefly_frenzy": {
        slug: "firefly_frenzy",
        name: "Firefly Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/forge_of_fortunes": {
        slug: "forge_of_fortunes",
        name: "Forge of Fortunes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/forge_of_gems": {
        slug: "forge_of_gems",
        name: "Forge of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fortune_teller": {
        slug: "fortune_teller",
        name: "Fortune Teller",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fortunes_of_ali_baba": {
        slug: "fortunes_of_ali_baba",
        name: "Fortunes of Ali Baba",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fox_mayhem": {
        slug: "fox_mayhem",
        name: "Fox Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/free_reelin_joker": {
        slug: "free_reelin_joker",
        name: "Free Reelin' Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/free_reelin_joker_1000": {
        slug: "free_reelin_joker_1000",
        name: "Free Reelin' Joker 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/frozen_gems": {
        slug: "frozen_gems",
        name: "Frozen Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fu_er_dai": {
        slug: "fu_er_dai",
        name: "Fu Er Dai",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/fulong_88": {
        slug: "fulong_88",
        name: "Fulong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/game_of_gladiators": {
        slug: "game_of_gladiators",
        name: "Game of Gladiators",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/game_of_gladiators_uprising": {
        slug: "game_of_gladiators_uprising",
        name: "Game of Gladiators: Uprising",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gargantoonz": {
        slug: "gargantoonz",
        name: "Gargantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gates_of_troy": {
        slug: "gates_of_troy",
        name: "Gates of Troy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix": {
        slug: "gemix",
        name: "GEMiX",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix_100": {
        slug: "gemix_100",
        name: "Gemix 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gemix_2": {
        slug: "gemix_2",
        name: "Gemix 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gerards_gambit": {
        slug: "gerards_gambit",
        name: "Gerard's Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ghost_booster_go_guaranteed": {
        slug: "ghost_booster_go_guaranteed",
        name: "Ghost Booster! GO Guaranteed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ghost_of_dead": {
        slug: "ghost_of_dead",
        name: "Ghost of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gigantoonz": {
        slug: "gigantoonz",
        name: "Gigantoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gnawn_gold": {
        slug: "gnawn_gold",
        name: "Gnaw'n Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/go_craps": {
        slug: "go_craps",
        name: "Go Craps",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_king": {
        slug: "gold_king",
        name: "Gold King",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_of_fortune_god": {
        slug: "gold_of_fortune_god",
        name: "Gold of Fortune God",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_trophy_2": {
        slug: "gold_trophy_2",
        name: "Gold Trophy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/gold_volcano": {
        slug: "gold_volcano",
        name: "Gold Volcano",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_caravan": {
        slug: "golden_caravan",
        name: "Golden Caravan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_colts": {
        slug: "golden_colts",
        name: "Golden Colts",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_legend": {
        slug: "golden_legend",
        name: "Golden Legend",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_osiris": {
        slug: "golden_osiris",
        name: "Golden Osiris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_ticket": {
        slug: "golden_ticket",
        name: "Golden Ticket",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/golden_ticket_2": {
        slug: "golden_ticket_2",
        name: "Golden Ticket 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/grannys_wild": {
        slug: "grannys_wild",
        name: "Granny's Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/grim_muerto": {
        slug: "grim_muerto",
        name: "Grim Muerto",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/happy_halloween": {
        slug: "happy_halloween",
        name: "Happy Halloween",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/highway_legends": {
        slug: "highway_legends",
        name: "Highway Legends",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/holiday_season": {
        slug: "holiday_season",
        name: "Holiday Season",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/holiday_spirits": {
        slug: "holiday_spirits",
        name: "Holiday Spirits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/holy_moo_extreme_power": {
        slug: "holy_moo_extreme_power",
        name: "Holy Moo! Extreme Power",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush": {
        slug: "honey_rush",
        name: "Honey Rush",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush_100": {
        slug: "honey_rush_100",
        name: "Honey Rush 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/honey_rush_black_and_yellow": {
        slug: "honey_rush_black_and_yellow",
        name: "Honey Rush Black and Yellow",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hooligan_hustle": {
        slug: "hooligan_hustle",
        name: "Hooligan Hustle",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hope_unleashed_fortune_reels": {
        slug: "hope_unleashed_fortune_reels",
        name: "Hope Unleashed Fortune Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hot_dog_heist": {
        slug: "hot_dog_heist",
        name: "Hot Dog Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/hotel_yetiway": {
        slug: "hotel_yetiway",
        name: "Hotel Yeti-Way",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/house_of_doom": {
        slug: "house_of_doom",
        name: "House of Doom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/house_of_doom_2_the_crypt": {
        slug: "house_of_doom_2_the_crypt",
        name: "House of Doom 2: The Crypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ice_joker": {
        slug: "ice_joker",
        name: "Ice Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/idol_of_fortune": {
        slug: "idol_of_fortune",
        name: "Idol of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/immortails_of_egypt": {
        slug: "immortails_of_egypt",
        name: "Immortails of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/imperial_opera": {
        slug: "imperial_opera",
        name: "Imperial Opera",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/infernal_trinity_go_guaranteed": {
        slug: "infernal_trinity_go_guaranteed",
        name: "Infernal Trinity GO Guaranteed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/inferno_joker": {
        slug: "inferno_joker",
        name: "Inferno Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/inferno_star": {
        slug: "inferno_star",
        name: "Inferno Star",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas": {
        slug: "invading_vegas",
        name: "Invading Vegas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas_las_christmas": {
        slug: "invading_vegas_las_christmas",
        name: "Invading Vegas: Las Christmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/invading_vegas_revenge_on_mars": {
        slug: "invading_vegas_revenge_on_mars",
        name: "Invading Vegas Revenge on Mars",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/irish_gold": {
        slug: "irish_gold",
        name: "Irish Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/iron_girl": {
        slug: "iron_girl",
        name: "Iron Girl",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jade_magician": {
        slug: "jade_magician",
        name: "Jade Magician",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jewel_box": {
        slug: "jewel_box",
        name: "Jewel Box",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/joker_flip": {
        slug: "joker_flip",
        name: "Joker Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger": {
        slug: "jolly_roger",
        name: "Jolly Roger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger_2": {
        slug: "jolly_roger_2",
        name: "Jolly Roger 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/jolly_roger_wild_kraken": {
        slug: "jolly_roger_wild_kraken",
        name: "Jolly Roger Wild Kraken",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/journey_to_paris": {
        slug: "journey_to_paris",
        name: "Journey to Paris",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/king_of_sweets": {
        slug: "king_of_sweets",
        name: "King of Sweets",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kingdom_below": {
        slug: "kingdom_below",
        name: "Kingdom Below",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kings_mask": {
        slug: "kings_mask",
        name: "King's Mask",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/kings_mask_eclipse_of_gods": {
        slug: "kings_mask_eclipse_of_gods",
        name: "King's Mask Eclipse of Gods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lab_of_madness": {
        slug: "lab_of_madness",
        name: "Lab of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune": {
        slug: "lady_of_fortune",
        name: "Lady of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune_destiny_spins": {
        slug: "lady_of_fortune_destiny_spins",
        name: "Lady of Fortune Destiny Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lady_of_fortune_remastered": {
        slug: "lady_of_fortune_remastered",
        name: "Lady of Fortune Remastered",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lawn_n_complete_disorder": {
        slug: "lawn_n_complete_disorder",
        name: "Lawn n' Complete Disorder",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lawn_n_disorder": {
        slug: "lawn_n_disorder",
        name: "Lawn N' Disorder",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_dead": {
        slug: "legacy_of_dead",
        name: "Legacy of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_dynasties": {
        slug: "legacy_of_dynasties",
        name: "Legacy of Dynasties",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_egypt": {
        slug: "legacy_of_egypt",
        name: "Legacy of Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_gems_blitzways": {
        slug: "legacy_of_gems_blitzways",
        name: "Legacy of Gems Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_inca": {
        slug: "legacy_of_inca",
        name: "Legacy of Inca",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legacy_of_undead_dragon_abyssways": {
        slug: "legacy_of_undead_dragon_abyssways",
        name: "Legacy of Undead Dragon Abyssways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legend_of_the_ice_dragon": {
        slug: "legend_of_the_ice_dragon",
        name: "Legend of the Ice Dragon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold": {
        slug: "legion_gold",
        name: "Legion Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_and_the_sphinx_of_dead": {
        slug: "legion_gold_and_the_sphinx_of_dead",
        name: "Legion Gold and the Sphinx of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_and_the_throne_of_dead": {
        slug: "legion_gold_and_the_throne_of_dead",
        name: "Legion Gold And The Throne Of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_reckoning": {
        slug: "legion_gold_reckoning",
        name: "Legion Gold Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_unleashed": {
        slug: "legion_gold_unleashed",
        name: "Legion Gold Unleashed",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/legion_gold_victory": {
        slug: "legion_gold_victory",
        name: "Legion Gold Victory",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechaun_goes_egypt": {
        slug: "leprechaun_goes_egypt",
        name: "Leprechaun goes Egypt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechaun_goes_wild": {
        slug: "leprechaun_goes_wild",
        name: "Leprechaun Goes Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechauns_diamond_dig": {
        slug: "leprechauns_diamond_dig",
        name: "Leprechaun's Diamond Dig",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/leprechauns_vault": {
        slug: "leprechauns_vault",
        name: "Leprechaun's Vault",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lion_saga_odyssey": {
        slug: "lion_saga_odyssey",
        name: "Lion Saga Odyssey",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/loot_and_labyrinths": {
        slug: "loot_and_labyrinths",
        name: "Loot and Labyrinths",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lord_merlin_and_the_lady_of_the_lake": {
        slug: "lord_merlin_and_the_lady_of_the_lake",
        name: "Lord Merlin and the Lady of the Lake",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/love_is_in_the_fair": {
        slug: "love_is_in_the_fair",
        name: "Love is in the Fair",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/love_joker": {
        slug: "love_joker",
        name: "Love Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/luchamigos": {
        slug: "luchamigos",
        name: "Luchamigos",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/lucky_diamonds": {
        slug: "lucky_diamonds",
        name: "Lucky Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/madame_ink": {
        slug: "madame_ink",
        name: "Madame Ink",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mafia_gold": {
        slug: "mafia_gold",
        name: "Mafia Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mahjong_88": {
        slug: "mahjong_88",
        name: "Mahjong 88",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/manta_mayhem": {
        slug: "manta_mayhem",
        name: "Manta Mayhem",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/matsuri": {
        slug: "matsuri",
        name: "Matsuri",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/medusas_madness": {
        slug: "medusas_madness",
        name: "Medusa's Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mega_don_feeding_frenzy": {
        slug: "mega_don_feeding_frenzy",
        name: "Mega Don Feeding Frenzy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mega_don_triple_threat": {
        slug: "mega_don_triple_threat",
        name: "Mega Don Triple Threat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/megadon": {
        slug: "megadon",
        name: "Megadon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_and_the_ice_queen_morgana": {
        slug: "merlin_and_the_ice_queen_morgana",
        name: "Merlin and the Ice Queen Morgana",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_journey_of_flame": {
        slug: "merlin_journey_of_flame",
        name: "Merlin: Journey of Flame",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlin_realm_of_charm": {
        slug: "merlin_realm_of_charm",
        name: "Merlin Realm of Charm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merlins_grimoire": {
        slug: "merlins_grimoire",
        name: "Merlin's Grimoire",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mermaids_diamond": {
        slug: "mermaids_diamond",
        name: "Mermaid's Diamond",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/merry_xmas": {
        slug: "merry_xmas",
        name: "Merry Xmas",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/midnight_gold": {
        slug: "midnight_gold",
        name: "Midnight Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/miner_donkey_trouble": {
        slug: "miner_donkey_trouble",
        name: "Miner Donkey Trouble",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mini_baccarat": {
        slug: "mini_baccarat",
        name: "Mini Baccarat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mirror_joker": {
        slug: "mirror_joker",
        name: "Mirror Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mission_cash": {
        slug: "mission_cash",
        name: "Mission Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mole_digger": {
        slug: "mole_digger",
        name: "Mole Digger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/money_wheel": {
        slug: "money_wheel",
        name: "Money Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/monkey_battle_for_the_scrolls": {
        slug: "monkey_battle_for_the_scrolls",
        name: "Monkey Battle for the Scrolls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess": {
        slug: "moon_princess",
        name: "Moon Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_christmas_kingdom": {
        slug: "moon_princess_christmas_kingdom",
        name: "Moon Princess: Christmas Kingdom",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_extreme": {
        slug: "moon_princess_extreme",
        name: "Moon Princess Extreme",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_origins": {
        slug: "moon_princess_origins",
        name: "Moon Princess Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_power_of_love": {
        slug: "moon_princess_power_of_love",
        name: "Moon Princess Power of Love",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_stargazing": {
        slug: "moon_princess_stargazing",
        name: "Moon Princess Stargazing",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/moon_princess_trinity": {
        slug: "moon_princess_trinity",
        name: "Moon Princess Trinity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/motley_crue": {
        slug: "motley_crue",
        name: "Motley Crue",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mount_m": {
        slug: "mount_m",
        name: "Mount M",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/muerto_en_mictlan": {
        slug: "muerto_en_mictlan",
        name: "Muerto En Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/multifruit_81": {
        slug: "multifruit_81",
        name: "MultiFruit 81",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_egg_surprise": {
        slug: "mystery_egg_surprise",
        name: "Mystery Egg Surprise",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_genie_fortunes_of_the_lamp": {
        slug: "mystery_genie_fortunes_of_the_lamp",
        name: "Mystery Genie Fortunes of the Lamp",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_joker": {
        slug: "mystery_joker",
        name: "Mystery Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/mystery_joker_6000": {
        slug: "mystery_joker_6000",
        name: "Mystery Joker 6000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/myth": {
        slug: "myth",
        name: "Myth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/myth_of_dead": {
        slug: "myth_of_dead",
        name: "Myth of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/naughty_nicks_book": {
        slug: "naughty_nicks_book",
        name: "Naughty Nick's Book",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/new_year_riches": {
        slug: "new_year_riches",
        name: "New Year Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ninja_fruits": {
        slug: "ninja_fruits",
        name: "Ninja Fruits",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/nugget_n_nonsense": {
        slug: "nugget_n_nonsense",
        name: "Nugget N' Nonsense",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/oasis_of_dead": {
        slug: "oasis_of_dead",
        name: "Oasis of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/octopus_treasure": {
        slug: "octopus_treasure",
        name: "Octopus Treasure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/odin_protector_of_realms": {
        slug: "odin_protector_of_realms",
        name: "Odin: Protector of Realms",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pack_and_cash": {
        slug: "pack_and_cash",
        name: "Pack and Cash",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pandastic_adventure": {
        slug: "pandastic_adventure",
        name: "Pandastic Adventure",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pandoras_box_of_evil": {
        slug: "pandoras_box_of_evil",
        name: "Pandora's Box of Evil",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pearl_lagoon": {
        slug: "pearl_lagoon",
        name: "Pearl Lagoon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pearls_of_india": {
        slug: "pearls_of_india",
        name: "Pearls of India",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/perfect_gems": {
        slug: "perfect_gems",
        name: "Perfect Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/phoenix_reborn": {
        slug: "phoenix_reborn",
        name: "Phoenix Reborn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/photo_safari": {
        slug: "photo_safari",
        name: "Photo Safari",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_bank_farm": {
        slug: "piggy_bank_farm",
        name: "Piggy Bank Farm",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz": {
        slug: "piggy_blitz",
        name: "Piggy Blitz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz_casino_gold": {
        slug: "piggy_blitz_casino_gold",
        name: "Piggy Blitz Casino Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_blitz_disco_gold": {
        slug: "piggy_blitz_disco_gold",
        name: "Piggy Blitz Disco Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_heist": {
        slug: "piggy_heist",
        name: "Piggy Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/piggy_heist_bingo": {
        slug: "piggy_heist_bingo",
        name: "Piggy Heist Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pilgrim_of_dead": {
        slug: "pilgrim_of_dead",
        name: "Pilgrim of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pimped": {
        slug: "pimped",
        name: "Pimped",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/pirahna_pays": {
        slug: "pirahna_pays",
        name: "Pirahna Pays",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/planet_fortune": {
        slug: "planet_fortune",
        name: "Planet Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/potion_of_madness": {
        slug: "potion_of_madness",
        name: "Potion of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/primal_rampage": {
        slug: "primal_rampage",
        name: "Primal Rampage",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prism_of_gems": {
        slug: "prism_of_gems",
        name: "Prism of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prissy_princess": {
        slug: "prissy_princess",
        name: "Prissy Princess",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/prosperity_palace": {
        slug: "prosperity_palace",
        name: "Prosperity Palace",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/puebla_parade": {
        slug: "puebla_parade",
        name: "Puebla Parade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/queens_day_tilt": {
        slug: "queens_day_tilt",
        name: "Queen's Day Tilt",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rabbit_hole_riches": {
        slug: "rabbit_hole_riches",
        name: "Rabbit Hole Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rage_to_riches": {
        slug: "rage_to_riches",
        name: "Rage to Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex": {
        slug: "raging_rex",
        name: "Raging Rex",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex_2": {
        slug: "raging_rex_2",
        name: "Raging Rex 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/raging_rex_3": {
        slug: "raging_rex_3",
        name: "Raging Rex 3",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rainforest_magic": {
        slug: "rainforest_magic",
        name: "Rainforest Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rainforest_magic_bingo": {
        slug: "rainforest_magic_bingo",
        name: "Rainforest Magic Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rally_4_riches": {
        slug: "rally_4_riches",
        name: "Rally 4 Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ras_reckoning": {
        slug: "ras_reckoning",
        name: "Ra's Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rascal_riches": {
        slug: "rascal_riches",
        name: "Rascal Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz": {
        slug: "reactoonz",
        name: "Reactoonz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz_100": {
        slug: "reactoonz_100",
        name: "Reactoonz 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz_2": {
        slug: "reactoonz_2",
        name: "Reactoonz 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/reactoonz_blitzways": {
        slug: "reactoonz_blitzways",
        name: "Reactoonz Blitzways",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/redtail_robber_cash_vault_heist": {
        slug: "redtail_robber_cash_vault_heist",
        name: "Redtail Robber Cash Vault Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_amulet_of_dead": {
        slug: "rich_wilde_and_the_amulet_of_dead",
        name: "Rich Wilde and The Amulet of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_pearls_of_vishnu": {
        slug: "rich_wilde_and_the_pearls_of_vishnu",
        name: "Rich Wilde and the Pearls of Vishnu",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_shield_of_athena": {
        slug: "rich_wilde_and_the_shield_of_athena",
        name: "Rich Wilde and the Shield of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_dead": {
        slug: "rich_wilde_and_the_tome_of_dead",
        name: "Rich Wilde and the Tome of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_insanity": {
        slug: "rich_wilde_and_the_tome_of_insanity",
        name: "Rich Wilde and the Tome of Insanity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_tome_of_madness": {
        slug: "rich_wilde_and_the_tome_of_madness",
        name: "Rich Wilde and the Tome of Madness",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rich_wilde_and_the_wandering_city": {
        slug: "rich_wilde_and_the_wandering_city",
        name: "Rich Wilde and the Wandering City",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riches_of_ra": {
        slug: "riches_of_ra",
        name: "Riches of RA",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riches_of_robin": {
        slug: "riches_of_robin",
        name: "Riches of Robin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/riddle_reels_a_case_of_riches": {
        slug: "riddle_reels_a_case_of_riches",
        name: "Riddle Reels: A Case of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ring_of_odin": {
        slug: "ring_of_odin",
        name: "Ring of Odin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rings_of_prosperity": {
        slug: "rings_of_prosperity",
        name: "Rings of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_athena": {
        slug: "rise_of_athena",
        name: "Rise of Athena",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_dead": {
        slug: "rise_of_dead",
        name: "Rise of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_gods_reckoning": {
        slug: "rise_of_gods_reckoning",
        name: "Rise of Gods: Reckoning",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_merlin": {
        slug: "rise_of_merlin",
        name: "Rise of Merlin",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus": {
        slug: "rise_of_olympus",
        name: "Rise of Olympus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_100": {
        slug: "rise_of_olympus_100",
        name: "Rise of Olympus 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_1000": {
        slug: "rise_of_olympus_1000",
        name: "Rise of Olympus 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_bingo": {
        slug: "rise_of_olympus_bingo",
        name: "Rise of Olympus Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_extreme": {
        slug: "rise_of_olympus_extreme",
        name: "Rise of Olympus Extreme",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_olympus_origins": {
        slug: "rise_of_olympus_origins",
        name: "Rise of Olympus Origins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rise_of_orpheus": {
        slug: "rise_of_orpheus",
        name: "Rise of Orpheus",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rocco_gallo": {
        slug: "rocco_gallo",
        name: "Rocco Gallo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ronins_honour": {
        slug: "ronins_honour",
        name: "Ronin's Honour",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rosy_orbit_treasure_turn": {
        slug: "rosy_orbit_treasure_turn",
        name: "Rosy Orbit Treasure Turn",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/rotiki": {
        slug: "rotiki",
        name: "RoTiki",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/royal_masquerade": {
        slug: "royal_masquerade",
        name: "Royal Masquerade",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ruff_heist": {
        slug: "ruff_heist",
        name: "Ruff Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sabaton": {
        slug: "sabaton",
        name: "Sabaton",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/safari_of_wealth": {
        slug: "safari_of_wealth",
        name: "Safari of Wealth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sails_of_gold": {
        slug: "sails_of_gold",
        name: "Sails of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sails_of_riches": {
        slug: "sails_of_riches",
        name: "Sails of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/samba_carnival": {
        slug: "samba_carnival",
        name: "Samba Carnival",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scales_of_dead": {
        slug: "scales_of_dead",
        name: "Scales of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scourge_of_rome": {
        slug: "scourge_of_rome",
        name: "Scourge of Rome",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scroll_of_dead": {
        slug: "scroll_of_dead",
        name: "Scroll of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/scroll_of_seth": {
        slug: "scroll_of_seth",
        name: "Scroll of Seth",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sea_hunter": {
        slug: "sea_hunter",
        name: "Sea Hunter",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/secret_of_dead": {
        slug: "secret_of_dead",
        name: "Secret of Dead",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shamrock_miner": {
        slug: "shamrock_miner",
        name: "Shamrock Miner",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shark_feast": {
        slug: "shark_feast",
        name: "Shark Feast",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sherwood_gold": {
        slug: "sherwood_gold",
        name: "Sherwood Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/shimmering_woods": {
        slug: "shimmering_woods",
        name: "Shimmering Woods",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/single_deck_blackjack": {
        slug: "single_deck_blackjack",
        name: "Single Deck Blackjack",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sisters_of_the_sun": {
        slug: "sisters_of_the_sun",
        name: "Sisters of the Sun",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sizzling_spins": {
        slug: "sizzling_spins",
        name: "Sizzling Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/slashimi": {
        slug: "slashimi",
        name: "Slashimi",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sobeks_godly_spins": {
        slug: "sobeks_godly_spins",
        name: "Sobek's Godly Spins",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/space_race": {
        slug: "space_race",
        name: "Space Race",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spark_of_genius": {
        slug: "spark_of_genius",
        name: "Spark of Genius",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sparky_and_shortz": {
        slug: "sparky_and_shortz",
        name: "Sparky & Shortz",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spice_spice_baby": {
        slug: "spice_spice_baby",
        name: "Spice Spice Baby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spin_party": {
        slug: "spin_party",
        name: "Spin Party",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spinnin_records_into_the_beat": {
        slug: "spinnin_records_into_the_beat",
        name: "Spinnin Records into the Beat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/spinnin_records_raving_reels": {
        slug: "spinnin_records_raving_reels",
        name: "Spinnin Records Raving Reels",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/stadium_of_riches": {
        slug: "stadium_of_riches",
        name: "Stadium of Riches",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/star_joker": {
        slug: "star_joker",
        name: "Star Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/static_nightmare": {
        slug: "static_nightmare",
        name: "Static Nightmare",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/stepping_diamonds": {
        slug: "stepping_diamonds",
        name: "Stepping Diamonds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sticky_joker": {
        slug: "sticky_joker",
        name: "Sticky Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/stompin_gold": {
        slug: "stompin_gold",
        name: "Stompin' Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/street_magic": {
        slug: "street_magic",
        name: "Street Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_flip": {
        slug: "super_flip",
        name: "Super Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_flip_deluxe": {
        slug: "super_flip_deluxe",
        name: "Super Flip Deluxe",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/super_wheel": {
        slug: "super_wheel",
        name: "Super Wheel",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_27": {
        slug: "sweet_27",
        name: "Sweet 27",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy": {
        slug: "sweet_alchemy",
        name: "Sweet Alchemy",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_100": {
        slug: "sweet_alchemy_100",
        name: "Sweet Alchemy 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_2": {
        slug: "sweet_alchemy_2",
        name: "Sweet Alchemy 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/sweet_alchemy_bingo": {
        slug: "sweet_alchemy_bingo",
        name: "Sweet Alchemy Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tale_of_kyubiko": {
        slug: "tale_of_kyubiko",
        name: "Tale of Kyubiko",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_asgard_freyas_wedding": {
        slug: "tales_of_asgard_freyas_wedding",
        name: "Tales of Asgard: Freya's Wedding",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_asgard_lokis_fortune": {
        slug: "tales_of_asgard_lokis_fortune",
        name: "Tales of Asgard: Loki's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tales_of_mithrune_syns_fortune": {
        slug: "tales_of_mithrune_syns_fortune",
        name: "Tales of Mithrune Syn's Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_prosperity": {
        slug: "temple_of_prosperity",
        name: "Temple of Prosperity",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_three": {
        slug: "temple_of_three",
        name: "Temple of Three",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/temple_of_tollan": {
        slug: "temple_of_tollan",
        name: "Temple of Tollan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/ternion": {
        slug: "ternion",
        name: "Ternion",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/testament": {
        slug: "testament",
        name: "Testament",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/thats_rich": {
        slug: "thats_rich",
        name: "That's Rich",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_faces_of_freya": {
        slug: "the_faces_of_freya",
        name: "The Faces of Freya",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_green_knight": {
        slug: "the_green_knight",
        name: "The Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_green_knight_oath_of_thorns": {
        slug: "the_green_knight_oath_of_thorns",
        name: "The Green Knight Oath of Thorns",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_last_sundown": {
        slug: "the_last_sundown",
        name: "The Last Sundown",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_paying_piano_club": {
        slug: "the_paying_piano_club",
        name: "The Paying Piano Club",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_return_of_the_green_knight": {
        slug: "the_return_of_the_green_knight",
        name: "The Return of the Green Knight",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_sword_and_the_grail": {
        slug: "the_sword_and_the_grail",
        name: "The Sword and The Grail",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_sword_and_the_grail_excalibur": {
        slug: "the_sword_and_the_grail_excalibur",
        name: "The Sword and the Grail Excalibur",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/the_wild_class": {
        slug: "the_wild_class",
        name: "The Wild Class",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/three_pots_of_the_genie": {
        slug: "three_pots_of_the_genie",
        name: "Three Pots of the Genie",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/thunderscreech": {
        slug: "thunderscreech",
        name: "Thunderscreech",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold": {
        slug: "tomb_of_gold",
        name: "Tomb of Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold_ii": {
        slug: "tomb_of_gold_ii",
        name: "Tomb of Gold II",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tomb_of_gold_reimagined": {
        slug: "tomb_of_gold_reimagined",
        name: "Tomb of Gold Reimagined",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tome_of_madness_bingo": {
        slug: "tome_of_madness_bingo",
        name: "Tome Of Madness Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/tower_run_treasure_steps": {
        slug: "tower_run_treasure_steps",
        name: "Tower Run Treasure Steps",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/track_n_gold": {
        slug: "track_n_gold",
        name: "Track n' Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/treasures_of_kongar": {
        slug: "treasures_of_kongar",
        name: "Treasures of Kongar",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/treats_of_terror": {
        slug: "treats_of_terror",
        name: "Treats of Terror",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/trinity_impact": {
        slug: "trinity_impact",
        name: "Trinity Impact",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/triple_beasts_of_fortune": {
        slug: "triple_beasts_of_fortune",
        name: "Triple Beasts of Fortune",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/triple_launch_fortune_wild": {
        slug: "triple_launch_fortune_wild",
        name: "Triple Launch Fortune Wild",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/troll_hunters": {
        slug: "troll_hunters",
        name: "Troll Hunters",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/troll_hunters_2": {
        slug: "troll_hunters_2",
        name: "Troll Hunters 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/undefeated_xerxes": {
        slug: "undefeated_xerxes",
        name: "Undefeated Xerxes",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/unigoat": {
        slug: "unigoat",
        name: "Unigoat",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/usa_flip": {
        slug: "usa_flip",
        name: "USA Flip",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/valhalluck": {
        slug: "valhalluck",
        name: "Valhalluck",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_apocalypse": {
        slug: "viking_apocalypse",
        name: "Viking Apocalypse",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft": {
        slug: "viking_runecraft",
        name: "Viking Runecraft",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft_100": {
        slug: "viking_runecraft_100",
        name: "Viking Runecraft 100",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft_1000": {
        slug: "viking_runecraft_1000",
        name: "Viking Runecraft 1000",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viking_runecraft_bingo": {
        slug: "viking_runecraft_bingo",
        name: "Viking Runecraft Bingo",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/viper_city_heist": {
        slug: "viper_city_heist",
        name: "Viper City Heist",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wheel_of_mictlan": {
        slug: "wheel_of_mictlan",
        name: "Wheel of Mictlan",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/whispering_winds": {
        slug: "whispering_winds",
        name: "Whispering Winds",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_bandolier": {
        slug: "wild_bandolier",
        name: "Wild Bandolier",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_blood": {
        slug: "wild_blood",
        name: "Wild Blood",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_blood_2": {
        slug: "wild_blood_2",
        name: "Wild Blood 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_falls": {
        slug: "wild_falls",
        name: "Wild Falls",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_falls_2": {
        slug: "wild_falls_2",
        name: "Wild Falls 2",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_frames": {
        slug: "wild_frames",
        name: "Wild Frames",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_melon": {
        slug: "wild_melon",
        name: "Wild Melon",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_north": {
        slug: "wild_north",
        name: "Wild North",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_north_radiant_skies": {
        slug: "wild_north_radiant_skies",
        name: "Wild North Radiant Skies",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_rails": {
        slug: "wild_rails",
        name: "Wild Rails",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_survivor": {
        slug: "wild_survivor",
        name: "Wild Survivor",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wild_trigger": {
        slug: "wild_trigger",
        name: "Wild Trigger",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wildest_gambit": {
        slug: "wildest_gambit",
        name: "Wildest Gambit",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wildhound_derby": {
        slug: "wildhound_derby",
        name: "Wildhound Derby",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/winabeest": {
        slug: "winabeest",
        name: "Win-A-Beest",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wizard_of_gems": {
        slug: "wizard_of_gems",
        name: "Wizard of Gems",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wrappin_gold": {
        slug: "wrappin_gold",
        name: "Wrappin Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/wrappin_more_gold": {
        slug: "wrappin_more_gold",
        name: "Wrappin' More Gold",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/xmas_joker": {
        slug: "xmas_joker",
        name: "Xmas Joker",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "play-n-go/xmas_magic": {
        slug: "xmas_magic",
        name: "Xmas Magic",
        provider: "Play n GO",
        providerSlug: "play-n-go"
    },
    "playace/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Playace",
        providerSlug: "playace"
    },
    "playgenx/3_fortune_wishes": {
        slug: "3_fortune_wishes",
        name: "3 Fortune Wishes",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/777_wealth": {
        slug: "777_wealth",
        name: "777 Wealth",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/american_respin": {
        slug: "american_respin",
        name: "American Respin",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/billy_west_wild_hunt": {
        slug: "billy_west_wild_hunt",
        name: "Billy West Wild Hunt",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/book_of_eternity": {
        slug: "book_of_eternity",
        name: "Book of Eternity",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/caichen_tripple_blossom": {
        slug: "caichen_tripple_blossom",
        name: "Caichen Tripple Blossom",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/cascading_gemstones": {
        slug: "cascading_gemstones",
        name: "Cascading Gemstones",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/coin_magnetzo": {
        slug: "coin_magnetzo",
        name: "Coin Magnetzo",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/cup_up": {
        slug: "cup_up",
        name: "Cup Up",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/dragon_and_dragons": {
        slug: "dragon_and_dragons",
        name: "Dragon and Dragons",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/drop": {
        slug: "drop",
        name: "Drop",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/neon_respin": {
        slug: "neon_respin",
        name: "Neon Respin",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/plinko": {
        slug: "plinko",
        name: "Plinko",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/rock_paper_scissorz_win_or_draw": {
        slug: "rock_paper_scissorz_win_or_draw",
        name: "Rock Paper Scissorz Win or Draw",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playgenx/super_triple_fortune": {
        slug: "super_triple_fortune",
        name: "Super Triple Fortune",
        provider: "Playgenx",
        providerSlug: "playgenx"
    },
    "playnetic/1000_winning_nights": {
        slug: "1000_winning_nights",
        name: "1000 Winning Nights",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/7_djinn_wishes": {
        slug: "7_djinn_wishes",
        name: "7 Djinn Wishes",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/777_el_macho_chilli": {
        slug: "777_el_macho_chilli",
        name: "777 El Macho Chilli",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/ace_bounty_respin_saloon": {
        slug: "ace_bounty_respin_saloon",
        name: "Ace Bounty ReSpin Saloon",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/ally_aliens": {
        slug: "ally_aliens",
        name: "Ally Aliens",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/american_wilds": {
        slug: "american_wilds",
        name: "American Wilds",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/angry_or_hungry": {
        slug: "angry_or_hungry",
        name: "Angry or Hungry",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/angry_zeus_jackpot": {
        slug: "angry_zeus_jackpot",
        name: "Angry Zeus Jackpot",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/assassin_of_rome": {
        slug: "assassin_of_rome",
        name: "Assassin of Rome",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/balls_of_fortune": {
        slug: "balls_of_fortune",
        name: "Balls of Fortune",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/bear_upswing": {
        slug: "bear_upswing",
        name: "Bear Upswing",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/big_wiz": {
        slug: "big_wiz",
        name: "Big Wiz",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/bison_trails": {
        slug: "bison_trails",
        name: "Bison Trails",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/blazin_fruit_fortune": {
        slug: "blazin_fruit_fortune",
        name: "Blazin' Fruit Fortune",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/book_of_magery_anubis_trial": {
        slug: "book_of_magery_anubis_trial",
        name: "Book of Magery: Anubis Trial",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/book_of_magery_rich_chapter": {
        slug: "book_of_magery_rich_chapter",
        name: "Book of Magery: Rich Chapter",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/break_an_egg": {
        slug: "break_an_egg",
        name: "Break An Egg",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/bubble_or_broom": {
        slug: "bubble_or_broom",
        name: "Bubble or Broom",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/buffalo_the_wild_power": {
        slug: "buffalo_the_wild_power",
        name: "Buffalo. The Wild Power",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/cactus_goes_nuts": {
        slug: "cactus_goes_nuts",
        name: "Cactus Goes Nuts",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/carnaval_de_muertos": {
        slug: "carnaval_de_muertos",
        name: "Carnaval de Muertos",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/cashomatic_3x3": {
        slug: "cashomatic_3x3",
        name: "Cash-o-Matic 3x3",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/cashomatic_extreme_cash_out": {
        slug: "cashomatic_extreme_cash_out",
        name: "Cash-o-Matic! Extreme Cash Out",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/chicken_farm": {
        slug: "chicken_farm",
        name: "Chicken Farm",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/count_catula_hold_n_win": {
        slug: "count_catula_hold_n_win",
        name: "Count Catula: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/dark_reels_pays": {
        slug: "dark_reels_pays",
        name: "Dark Reels Pays",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/darkblood_rising_hold_n_win": {
        slug: "darkblood_rising_hold_n_win",
        name: "Darkblood Rising: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/deejay_monkey": {
        slug: "deejay_monkey",
        name: "Deejay Monkey",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/dracos_eye_jackpot": {
        slug: "dracos_eye_jackpot",
        name: "Draco's Eye Jackpot",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/dragons_blaze": {
        slug: "dragons_blaze",
        name: "Dragon's Blaze",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/dreamcatcher": {
        slug: "dreamcatcher",
        name: "Dreamcatcher",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/egypt_night_and_day": {
        slug: "egypt_night_and_day",
        name: "Egypt Night and Day",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/el_dorado": {
        slug: "el_dorado",
        name: "El Dorado",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/eldritch_runes": {
        slug: "eldritch_runes",
        name: "Eldritch Runes",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/farmageddon": {
        slug: "farmageddon",
        name: "Farmageddon",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/fiesta_frenzy": {
        slug: "fiesta_frenzy",
        name: "Fiesta Frenzy",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/flame_and_sword_hold_n_win": {
        slug: "flame_and_sword_hold_n_win",
        name: "Flame and Sword: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/fluffalo_fortune_hold_n_win": {
        slug: "fluffalo_fortune_hold_n_win",
        name: "Fluffalo Fortune: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/fortune_digging_gold_rush": {
        slug: "fortune_digging_gold_rush",
        name: "Fortune Digging: Gold Rush",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/funny_gummy": {
        slug: "funny_gummy",
        name: "Funny Gummy",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/gems_win_respin": {
        slug: "gems_win_respin",
        name: "Gems, Win, Respin!",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/ghostlight_manor": {
        slug: "ghostlight_manor",
        name: "Ghostlight Manor",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/gimme_ore": {
        slug: "gimme_ore",
        name: "Gimme Ore!",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/gods_of_darkness": {
        slug: "gods_of_darkness",
        name: "Gods Of Darkness",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/golden_eve_hold_n_roll": {
        slug: "golden_eve_hold_n_roll",
        name: "Golden Eve: Hold n' Roll",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/hades_wild_payday_hold_n_roll": {
        slug: "hades_wild_payday_hold_n_roll",
        name: "Hades' Wild Payday: Hold n' Roll",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/hallowfruits": {
        slug: "hallowfruits",
        name: "HallowFruits",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/hysteria": {
        slug: "hysteria",
        name: "Hysteria",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/incan_wilds": {
        slug: "incan_wilds",
        name: "Incan Wilds",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/jack_ryder_and_the_bazaar_of_wealth": {
        slug: "jack_ryder_and_the_bazaar_of_wealth",
        name: "Jack Ryder and the Bazaar of Wealth",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/jackpot_ganesha_fortune": {
        slug: "jackpot_ganesha_fortune",
        name: "Jackpot Ganesha Fortune",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/joxer": {
        slug: "joxer",
        name: "Joxer",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/jump_shot_jackpot": {
        slug: "jump_shot_jackpot",
        name: "Jump Shot Jackpot",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/jurassic_jackpots_hold_n_win": {
        slug: "jurassic_jackpots_hold_n_win",
        name: "Jurassic Jackpots: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/lady_of_the_woods": {
        slug: "lady_of_the_woods",
        name: "Lady of the Woods",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/little_lord_rich": {
        slug: "little_lord_rich",
        name: "Little Lord Rich",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/lucky_licks": {
        slug: "lucky_licks",
        name: "Lucky Licks",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/lucky_lucy_rainbow_party": {
        slug: "lucky_lucy_rainbow_party",
        name: "Lucky Lucy Rainbow Party",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/man_vs_seagull": {
        slug: "man_vs_seagull",
        name: "Man vs Seagull",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/max_catch": {
        slug: "max_catch",
        name: "Max Catch",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/medusas_fury": {
        slug: "medusas_fury",
        name: "Medusa's Fury",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/mighte_vs_evilla_hold_n_win": {
        slug: "mighte_vs_evilla_hold_n_win",
        name: "MightE vs Evilla: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/miners_are_wild": {
        slug: "miners_are_wild",
        name: "Miners are Wild",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/miss_mystic": {
        slug: "miss_mystic",
        name: "Miss Mystic",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/moneyball": {
        slug: "moneyball",
        name: "Moneyball",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/moonlight_guardian": {
        slug: "moonlight_guardian",
        name: "Moonlight Guardian",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/mystery_rainbow": {
        slug: "mystery_rainbow",
        name: "Mystery Rainbow",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/nefertitis_ring": {
        slug: "nefertitis_ring",
        name: "Nefertiti's Ring",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/nefertitis_ring_jackpot": {
        slug: "nefertitis_ring_jackpot",
        name: "Nefertiti's Ring Jackpot",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/osiris_fortune": {
        slug: "osiris_fortune",
        name: "Osiris Fortune",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/pandariffic_hold_n_roll": {
        slug: "pandariffic_hold_n_roll",
        name: "Pandariffic: Hold n' Roll",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/panthers_riches": {
        slug: "panthers_riches",
        name: "Panther's Riches",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/patrick_vs_joker": {
        slug: "patrick_vs_joker",
        name: "Patrick vs Joker",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/patrick_vs_nefertiti_hold_n_win": {
        slug: "patrick_vs_nefertiti_hold_n_win",
        name: "Patrick vs Nefertiti: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/paws_of_egypt": {
        slug: "paws_of_egypt",
        name: "Paws of Egypt",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/pearl_hunter": {
        slug: "pearl_hunter",
        name: "Pearl Hunter",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/piggy_plunder_lucky_7_seas": {
        slug: "piggy_plunder_lucky_7_seas",
        name: "Piggy Plunder Lucky 7 Seas",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/pop_the_bank": {
        slug: "pop_the_bank",
        name: "Pop The Bank",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/raiders_of_atlantis": {
        slug: "raiders_of_atlantis",
        name: "Raiders of Atlantis",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/rampant_bull": {
        slug: "rampant_bull",
        name: "Rampant Bull",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/rattle_dime_hold_n_win": {
        slug: "rattle_dime_hold_n_win",
        name: "Rattle Dime: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/reel_goals": {
        slug: "reel_goals",
        name: "Reel Goals!",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/relax_lounge": {
        slug: "relax_lounge",
        name: "Relax Lounge",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/respin_the_win": {
        slug: "respin_the_win",
        name: "Respin the Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/samba_rio_spins": {
        slug: "samba_rio_spins",
        name: "Samba Rio Spins",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/santa_surprise": {
        slug: "santa_surprise",
        name: "Santa Surprise",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/santas_luck": {
        slug: "santas_luck",
        name: "Santa's Luck",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/scarabs_of_wealth": {
        slug: "scarabs_of_wealth",
        name: "Scarabs Of Wealth",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/scroll_of_gods": {
        slug: "scroll_of_gods",
        name: "Scroll of Gods",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/smash_factory": {
        slug: "smash_factory",
        name: "Smash Factory",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/spooky_hollow": {
        slug: "spooky_hollow",
        name: "Spooky Hollow",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/starlight_travellers": {
        slug: "starlight_travellers",
        name: "Starlight Travellers",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/sun_vs_moon_hold_n_win": {
        slug: "sun_vs_moon_hold_n_win",
        name: "Sun vs Moon: Hold n' Win",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/sunburst": {
        slug: "sunburst",
        name: "Sunburst",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/sunburst_eclipse_bonus": {
        slug: "sunburst_eclipse_bonus",
        name: "Sunburst: Eclipse Bonus",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/sunburst_shooting_wilds": {
        slug: "sunburst_shooting_wilds",
        name: "Sunburst: Shooting Wilds",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/surfin_santa": {
        slug: "surfin_santa",
        name: "Surfin' Santa",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/sweets_and_hits": {
        slug: "sweets_and_hits",
        name: "Sweets and Hits",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/the_oracles_fortune": {
        slug: "the_oracles_fortune",
        name: "The Oracle's Fortune",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/thors_wild_power": {
        slug: "thors_wild_power",
        name: "Thor's Wild Power",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/tiger_tumble": {
        slug: "tiger_tumble",
        name: "Tiger Tumble",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/tiki_boom": {
        slug: "tiki_boom",
        name: "Tiki Boom",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/tufeis_treasure": {
        slug: "tufeis_treasure",
        name: "Tufei's Treasure",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/tuts_spirit": {
        slug: "tuts_spirit",
        name: "Tut's Spirit",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/twoway_trouble": {
        slug: "twoway_trouble",
        name: "Two-Way Trouble",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/undersea_treasure": {
        slug: "undersea_treasure",
        name: "Undersea Treasure",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/wild_kandi": {
        slug: "wild_kandi",
        name: "Wild Kandi",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/wildosaurs": {
        slug: "wildosaurs",
        name: "Wildosaurs",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/win_peaks": {
        slug: "win_peaks",
        name: "Win Peaks",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/wolf_moon_pays": {
        slug: "wolf_moon_pays",
        name: "Wolf Moon Pays",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/xo_paradise": {
        slug: "xo_paradise",
        name: "XO Paradise",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/year_of_the_goat": {
        slug: "year_of_the_goat",
        name: "Year of the Goat",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/year_of_the_horse": {
        slug: "year_of_the_horse",
        name: "Year of the Horse",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/year_of_the_snake": {
        slug: "year_of_the_snake",
        name: "Year Of The Snake",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/zen_panda": {
        slug: "zen_panda",
        name: "Zen Panda",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/zeus_goes_bananas": {
        slug: "zeus_goes_bananas",
        name: "Zeus Goes Bananas",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/zhulongs_treasure": {
        slug: "zhulongs_treasure",
        name: "Zhulong's Treasure",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playnetic/zombie_cat_apocalypse": {
        slug: "zombie_cat_apocalypse",
        name: "Zombie Cat Apocalypse",
        provider: "Playnetic",
        providerSlug: "playnetic"
    },
    "playngopremium/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Hold'em",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/hammerfall": {
        slug: "hammerfall",
        name: "HammerFall",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/helloween": {
        slug: "helloween",
        name: "Helloween",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/hugo": {
        slug: "hugo",
        name: "Hugo",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/hugo_2": {
        slug: "hugo_2",
        name: "Hugo 2",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/hugo_goal": {
        slug: "hugo_goal",
        name: "Hugo Goal",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/hugos_adventure": {
        slug: "hugos_adventure",
        name: "Hugo's Adventure",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/saxon": {
        slug: "saxon",
        name: "Saxon",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playngopremium/twisted_sister": {
        slug: "twisted_sister",
        name: "Twisted Sister",
        provider: "Playngopremium",
        providerSlug: "playngopremium"
    },
    "playson/100_joker_staxx": {
        slug: "100_joker_staxx",
        name: "100 Joker Staxx",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/25_cookies_hit_the_bonus": {
        slug: "25_cookies_hit_the_bonus",
        name: "25 Cookies: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_carts_of_gold_hold_and_win": {
        slug: "3_carts_of_gold_hold_and_win",
        name: "3 Carts of Gold: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_chillies_and_joker_hold_and_win": {
        slug: "3_chillies_and_joker_hold_and_win",
        name: "3 Chillies and Joker Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_luxor_pots_hold_and_win": {
        slug: "3_luxor_pots_hold_and_win",
        name: "3 Luxor Pots Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_magic_lamps_hold_and_win": {
        slug: "3_magic_lamps_hold_and_win",
        name: "3 Magic Lamps: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_pirate_barrels_hold_and_win": {
        slug: "3_pirate_barrels_hold_and_win",
        name: "3 Pirate Barrels Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_pots_riches_extra_hold_and_win": {
        slug: "3_pots_riches_extra_hold_and_win",
        name: "3 Pots Riches Extra: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_pots_riches_hold_and_win": {
        slug: "3_pots_riches_hold_and_win",
        name: "3 Pots Riches: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_royal_coins_hold_and_win": {
        slug: "3_royal_coins_hold_and_win",
        name: "3 Royal Coins Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_supercharged_diamonds_hold_and_win": {
        slug: "3_supercharged_diamonds_hold_and_win",
        name: "3 Supercharged Diamonds Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3_thunder_coins_hold_and_win": {
        slug: "3_thunder_coins_hold_and_win",
        name: "3 Thunder Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/3x_catch": {
        slug: "3x_catch",
        name: "3x Catch",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_chili_amigos_hold_and_win": {
        slug: "4_chili_amigos_hold_and_win",
        name: "4 Chili Amigos Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_chili_pots_hold_and_win": {
        slug: "4_chili_pots_hold_and_win",
        name: "4 Chili Pots: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_pots_riches_super_wheel": {
        slug: "4_pots_riches_super_wheel",
        name: "4 Pots Riches: Super Wheel",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_supercharged_clovers": {
        slug: "4_supercharged_clovers",
        name: "4 Supercharged Clovers",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_supercharged_clovers_super_wheel": {
        slug: "4_supercharged_clovers_super_wheel",
        name: "4 Supercharged Clovers: Super Wheel",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/4_supershiny_diamonds_hold_and_win": {
        slug: "4_supershiny_diamonds_hold_and_win",
        name: "4 Supershiny Diamonds: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/5_fortunator": {
        slug: "5_fortunator",
        name: "5 Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/5_super_sevens_and_fruits": {
        slug: "5_super_sevens_and_fruits",
        name: "5 Super Sevens and Fruits",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/777_sizzling_wins_5_line": {
        slug: "777_sizzling_wins_5_line",
        name: "777 Sizzling Wins: 5 Line",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/arizona_heist_hold_and_win": {
        slug: "arizona_heist_hold_and_win",
        name: "Arizona Heist: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/beez_turn_wild": {
        slug: "beez_turn_wild",
        name: "Beez Turn Wild",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/blazing_wins_5_lines": {
        slug: "blazing_wins_5_lines",
        name: "Blazing Wins: 5 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/book_del_sol": {
        slug: "book_del_sol",
        name: "Book Del Sol",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/book_of_gold_classic": {
        slug: "book_of_gold_classic",
        name: "Book of Gold: Classic",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/book_of_gold_double_chance": {
        slug: "book_of_gold_double_chance",
        name: "Book of Gold: Double Chance",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/book_of_gold_multichance": {
        slug: "book_of_gold_multichance",
        name: "Book of Gold: Multichance",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/buffalo_power_2": {
        slug: "buffalo_power_2",
        name: "Buffalo Power 2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/buffalo_power_2_hold_and_win": {
        slug: "buffalo_power_2_hold_and_win",
        name: "Buffalo Power 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/buffalo_power_christmas": {
        slug: "buffalo_power_christmas",
        name: "Buffalo Power: Christmas",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/buffalo_power_hold_and_win": {
        slug: "buffalo_power_hold_and_win",
        name: "Buffalo Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/buffalo_power_megaways": {
        slug: "buffalo_power_megaways",
        name: "Buffalo Power Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/burning_fortunator": {
        slug: "burning_fortunator",
        name: "Burning Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/burning_wins": {
        slug: "burning_wins",
        name: "Burning Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/burning_wins_x2": {
        slug: "burning_wins_x2",
        name: "Burning Wins X2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/charge_the_clovers_hit_the_bonus": {
        slug: "charge_the_clovers_hit_the_bonus",
        name: "Charge the Clovers Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/classic_fruit_hold_and_win": {
        slug: "classic_fruit_hold_and_win",
        name: "Classic Fruit Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/clover_charm_hit_the_bonus": {
        slug: "clover_charm_hit_the_bonus",
        name: "Clover Charm: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/clover_smash": {
        slug: "clover_smash",
        name: "Clover Smash",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/clover_strike_hold_and_win": {
        slug: "clover_strike_hold_and_win",
        name: "Clover Strike Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/coin_strike_2_hold_and_win": {
        slug: "coin_strike_2_hold_and_win",
        name: "Coin Strike 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/coin_strike_xxl": {
        slug: "coin_strike_xxl",
        name: "Coin Strike XXL",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/coin_strike_xxl_multicoin": {
        slug: "coin_strike_xxl_multicoin",
        name: "Coin Strike XXL: Multicoin",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/crown_and_diamonds_hold_and_win": {
        slug: "crown_and_diamonds_hold_and_win",
        name: "Crown and Diamonds Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/crown_strike_hold_and_win": {
        slug: "crown_strike_hold_and_win",
        name: "Crown Strike: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/diamond_fortunator": {
        slug: "diamond_fortunator",
        name: "Diamond Fortunator",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/diamond_power_hold_and_win": {
        slug: "diamond_power_hold_and_win",
        name: "Diamond Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/diamond_power_xxl_hold_and_win": {
        slug: "diamond_power_xxl_hold_and_win",
        name: "Diamond Power XXL Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/diamond_wins": {
        slug: "diamond_wins",
        name: "Diamond Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/divine_dragon_hold_and_win": {
        slug: "divine_dragon_hold_and_win",
        name: "Divine Dragon: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/eagle_power_hold_and_win": {
        slug: "eagle_power_hold_and_win",
        name: "Eagle Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/empire_gold_hold_and_win": {
        slug: "empire_gold_hold_and_win",
        name: "Empire Gold Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/energy_coins_hold_and_win": {
        slug: "energy_coins_hold_and_win",
        name: "Energy Coins Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/energy_joker_hold_and_win": {
        slug: "energy_joker_hold_and_win",
        name: "Energy Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/fire_coins_hold_and_win": {
        slug: "fire_coins_hold_and_win",
        name: "Fire Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/fire_temple_hold_and_win": {
        slug: "fire_temple_hold_and_win",
        name: "Fire Temple: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/fruits_and_jokers_100_lines": {
        slug: "fruits_and_jokers_100_lines",
        name: "Fruits and Jokers: 100 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/fruits_and_jokers_20_lines": {
        slug: "fruits_and_jokers_20_lines",
        name: "Fruits and Jokers: 20 lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/fruits_and_jokers_40_lines": {
        slug: "fruits_and_jokers_40_lines",
        name: "Fruits and Jokers: 40 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/giza_nights_hold_and_win": {
        slug: "giza_nights_hold_and_win",
        name: "Giza Nights: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/golden_penny_x1000": {
        slug: "golden_penny_x1000",
        name: "Golden Penny x1000",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/golden_penny_x1000_super_wheel": {
        slug: "golden_penny_x1000_super_wheel",
        name: "Golden Penny x1000: Super Wheel",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/hit_the_bank_hold_and_win": {
        slug: "hit_the_bank_hold_and_win",
        name: "Hit the Bank: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/hot_burning_wins": {
        slug: "hot_burning_wins",
        name: "Hot Burning Wins",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/hot_coins_hold_and_win": {
        slug: "hot_coins_hold_and_win",
        name: "Hot Coins Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/imperial_fruits_100_lines": {
        slug: "imperial_fruits_100_lines",
        name: "Imperial Fruits: 100 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/imperial_fruits_5_lines": {
        slug: "imperial_fruits_5_lines",
        name: "Imperial Fruits: 5 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/jingle_coins_hold_and_win": {
        slug: "jingle_coins_hold_and_win",
        name: "Jingle Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/joker_expand_5_lines": {
        slug: "joker_expand_5_lines",
        name: "Joker Expand: 5 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/jokers_coins_hold_and_win": {
        slug: "jokers_coins_hold_and_win",
        name: "Jokers Coins: Hold and WIn",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/king_of_the_sky_hit_the_bonus": {
        slug: "king_of_the_sky_hit_the_bonus",
        name: "King of the Sky Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/legend_of_cleopatra": {
        slug: "legend_of_cleopatra",
        name: "Legend of Cleopatra",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/legend_of_cleopatra_megaways": {
        slug: "legend_of_cleopatra_megaways",
        name: "Legend of Cleopatra Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/lightning_clovers_hit_the_bonus": {
        slug: "lightning_clovers_hit_the_bonus",
        name: "Lightning Clovers Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/lion_gems_3_pot_hold_and_win": {
        slug: "lion_gems_3_pot_hold_and_win",
        name: "Lion Gems 3 Pot Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/lion_gems_hold_and_win": {
        slug: "lion_gems_hold_and_win",
        name: "Lion Gems: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/luxor_gold_hold_and_win": {
        slug: "luxor_gold_hold_and_win",
        name: "Luxor Gold: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/merry_giftmas_hold_and_win": {
        slug: "merry_giftmas_hold_and_win",
        name: "Merry Giftmas: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/pearl_beauty_hold_and_win": {
        slug: "pearl_beauty_hold_and_win",
        name: "Pearl Beauty: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/pearl_ocean_hold_and_win": {
        slug: "pearl_ocean_hold_and_win",
        name: "Pearl Ocean: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/piggy_power_hit_the_bonus": {
        slug: "piggy_power_hit_the_bonus",
        name: "Piggy Power: Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/pink_clovers_xxxl_hold_and_win": {
        slug: "pink_clovers_xxxl_hold_and_win",
        name: "Pink Clovers XXXL: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/pink_joker_hold_and_win": {
        slug: "pink_joker_hold_and_win",
        name: "Pink Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/pirate_chest_hold_and_win": {
        slug: "pirate_chest_hold_and_win",
        name: "Pirate Chest: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/power_crown_hold_and_win": {
        slug: "power_crown_hold_and_win",
        name: "Power Crown: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/rhino_coins_hit_the_bonus": {
        slug: "rhino_coins_hit_the_bonus",
        name: "Rhino Coins Hit the Bonus",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/rich_diamonds_hold_and_win": {
        slug: "rich_diamonds_hold_and_win",
        name: "Rich Diamonds: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/rise_of_egypt": {
        slug: "rise_of_egypt",
        name: "Rise of Egypt",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/rockin_joker_hold_and_win": {
        slug: "rockin_joker_hold_and_win",
        name: "Rockin Joker Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/royal_coins_2_hold_and_win": {
        slug: "royal_coins_2_hold_and_win",
        name: "Royal Coins 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/royal_coins_hold_and_win": {
        slug: "royal_coins_hold_and_win",
        name: "Royal Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/royal_express_hold_and_win": {
        slug: "royal_express_hold_and_win",
        name: "Royal Express Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/royal_fortunator_hold_and_win": {
        slug: "royal_fortunator_hold_and_win",
        name: "Royal Fortunator Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/royal_joker_hold_and_win": {
        slug: "royal_joker_hold_and_win",
        name: "Royal Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/sevens_and_fruits": {
        slug: "sevens_and_fruits",
        name: "Sevens and Fruits",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/sevens_and_fruits_20_lines": {
        slug: "sevens_and_fruits_20_lines",
        name: "Sevens and Fruits: 20 Lines",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/solar_king": {
        slug: "solar_king",
        name: "Solar King",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/solar_queen": {
        slug: "solar_queen",
        name: "Solar Queen",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/solar_temple": {
        slug: "solar_temple",
        name: "Solar Temple",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/sugar_teddy": {
        slug: "sugar_teddy",
        name: "Sugar Teddy",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/sunny_fruits_2_hold_and_win": {
        slug: "sunny_fruits_2_hold_and_win",
        name: "Sunny Fruits 2: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/sunny_fruits_hold_and_win": {
        slug: "sunny_fruits_hold_and_win",
        name: "Sunny Fruits: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/super_pink_joker_hold_and_win": {
        slug: "super_pink_joker_hold_and_win",
        name: "Super Pink Joker: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/supercharged_clovers_hold_and_win": {
        slug: "supercharged_clovers_hold_and_win",
        name: "Supercharged Clovers: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/thunder_coins_hold_and_win": {
        slug: "thunder_coins_hold_and_win",
        name: "Thunder Coins: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/thunder_coins_xxl_boostercells": {
        slug: "thunder_coins_xxl_boostercells",
        name: "Thunder Coins XXL: BoosterCells",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/thunder_coins_xxl_hold_and_win": {
        slug: "thunder_coins_xxl_hold_and_win",
        name: "Thunder Coins XXL: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/thunder_coins_xxl_multicoin": {
        slug: "thunder_coins_xxl_multicoin",
        name: "Thunder Coins XXL Multicoin",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/tornado_power_hold_and_win": {
        slug: "tornado_power_hold_and_win",
        name: "Tornado Power Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/treasures_of_fire": {
        slug: "treasures_of_fire",
        name: "Treasures of Fire",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/treasures_of_fire_scatter_pays": {
        slug: "treasures_of_fire_scatter_pays",
        name: "Treasures of Fire: Scatter Pays",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/wolf_power_hold_and_win": {
        slug: "wolf_power_hold_and_win",
        name: "Wolf Power: Hold and Win",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/wolf_power_megaways": {
        slug: "wolf_power_megaways",
        name: "Wolf Power Megaways",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playson/x1000_golden_penny_2": {
        slug: "x1000_golden_penny_2",
        name: "x1000 Golden Penny 2",
        provider: "Playson",
        providerSlug: "playson"
    },
    "playtech-live/3_card_brag": {
        slug: "3_card_brag",
        name: "3 Card Brag",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/adventures_beyond_wonderland_brasil": {
        slug: "adventures_beyond_wonderland_brasil",
        name: "Adventures Beyond Wonderland Brasil",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/adventures_beyond_wonderland_live": {
        slug: "adventures_beyond_wonderland_live",
        name: "Adventures Beyond Wonderland Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/all_bets_blackjack": {
        slug: "all_bets_blackjack",
        name: "All Bets Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/all_bets_blackjack_lobby": {
        slug: "all_bets_blackjack_lobby",
        name: "All Bets Blackjack Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/andar_bahar": {
        slug: "andar_bahar",
        name: "Andar Bahar",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/arabic_roulette": {
        slug: "arabic_roulette",
        name: "Arabic Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_brasileira": {
        slug: "baccarat_brasileira",
        name: "Baccarat Brasileira",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_brasileira_nc": {
        slug: "baccarat_brasileira_nc",
        name: "Baccarat Brasileira NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_lobby": {
        slug: "baccarat_lobby",
        name: "Baccarat Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_nc": {
        slug: "baccarat_nc",
        name: "Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_showdown": {
        slug: "baccarat_showdown",
        name: "Baccarat Showdown",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_soiree": {
        slug: "baccarat_soiree",
        name: "Baccarat Soiree",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/baccarat_soiree_nc": {
        slug: "baccarat_soiree_nc",
        name: "Baccarat Soiree NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bet_on_baccarat": {
        slug: "bet_on_baccarat",
        name: "Bet On Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bet_on_dragon_tiger": {
        slug: "bet_on_dragon_tiger",
        name: "Bet On Dragon Tiger",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bet_on_poker": {
        slug: "bet_on_poker",
        name: "Bet On Poker",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/big_bad_wolf_live": {
        slug: "big_bad_wolf_live",
        name: "Big Bad Wolf Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack_italiano": {
        slug: "blackjack_italiano",
        name: "Blackjack Italiano",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack_italiano_vip": {
        slug: "blackjack_italiano_vip",
        name: "Blackjack Italiano VIP",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack_lobby": {
        slug: "blackjack_lobby",
        name: "Blackjack Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack_soiree": {
        slug: "blackjack_soiree",
        name: "Blackjack Soiree",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/blackjack_soiree_gold": {
        slug: "blackjack_soiree_gold",
        name: "Blackjack Soiree Gold",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/brussels_roulette": {
        slug: "brussels_roulette",
        name: "Brussels Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bucharest_french_roulette": {
        slug: "bucharest_french_roulette",
        name: "Bucharest French Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bucharest_quantum_roulette": {
        slug: "bucharest_quantum_roulette",
        name: "Bucharest Quantum Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/bucharest_roulette": {
        slug: "bucharest_roulette",
        name: "Bucharest Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/buffalo_blitz_espana": {
        slug: "buffalo_blitz_espana",
        name: "Buffalo Blitz Espana",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/buffalo_blitz_live_slots": {
        slug: "buffalo_blitz_live_slots",
        name: "Buffalo Blitz Live Slots",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/buffalo_blitz_live_slots_lobby": {
        slug: "buffalo_blitz_live_slots_lobby",
        name: "Buffalo Blitz Live Slots Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/busted_or_bailed": {
        slug: "busted_or_bailed",
        name: "Busted or Bailed",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/cash_collect_roulette_live": {
        slug: "cash_collect_roulette_live",
        name: "Cash Collect Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/casino_holdem": {
        slug: "casino_holdem",
        name: "Casino Hold'em",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/casino_stud_poker": {
        slug: "casino_stud_poker",
        name: "Casino Stud Poker",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/deutsches_blackjack": {
        slug: "deutsches_blackjack",
        name: "Deutsches Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/deutsches_roulette": {
        slug: "deutsches_roulette",
        name: "Deutsches Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/deutsches_speed_roulette": {
        slug: "deutsches_speed_roulette",
        name: "Deutsches Speed Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/dragon_tiger_lobby": {
        slug: "dragon_tiger_lobby",
        name: "Dragon Tiger Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/elite_roulette": {
        slug: "elite_roulette",
        name: "Elite Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/emperor_baccarat": {
        slug: "emperor_baccarat",
        name: "Emperor Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/emperor_baccarat_nc": {
        slug: "emperor_baccarat_nc",
        name: "Emperor Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/fashion_tv_baccarat": {
        slug: "fashion_tv_baccarat",
        name: "Fashion TV Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/fashion_tv_baccarat_nc": {
        slug: "fashion_tv_baccarat_nc",
        name: "Fashion TV Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/fashion_tv_mega_party": {
        slug: "fashion_tv_mega_party",
        name: "Fashion TV Mega Party",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/football_french_roulette": {
        slug: "football_french_roulette",
        name: "Football French Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/football_roulette": {
        slug: "football_roulette",
        name: "Football Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/french_roulette": {
        slug: "french_roulette",
        name: "French Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/french_roulette_lobby": {
        slug: "french_roulette_lobby",
        name: "French Roulette Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/friday_big_quiz": {
        slug: "friday_big_quiz",
        name: "Friday Big Quiz",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/grand_baccarat": {
        slug: "grand_baccarat",
        name: "Grand Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/grand_baccarat_nc": {
        slug: "grand_baccarat_nc",
        name: "Grand Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/grand_blackjack": {
        slug: "grand_blackjack",
        name: "Grand Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/greek_quantum_roulette": {
        slug: "greek_quantum_roulette",
        name: "Greek Quantum Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/greek_roulette": {
        slug: "greek_roulette",
        name: "Greek Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/hilo_western_live": {
        slug: "hilo_western_live",
        name: "Hi-Lo Western Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/hindi_roulette": {
        slug: "hindi_roulette",
        name: "Hindi Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/hybrid_blackjack": {
        slug: "hybrid_blackjack",
        name: "Hybrid Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/italian_cashback_blackjack": {
        slug: "italian_cashback_blackjack",
        name: "Italian Cashback Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/jade_blackjack": {
        slug: "jade_blackjack",
        name: "Jade Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/japanese_squeeze_baccarat": {
        slug: "japanese_squeeze_baccarat",
        name: "Japanese Squeeze Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/japanese_squeeze_baccarat_nc": {
        slug: "japanese_squeeze_baccarat_nc",
        name: "Japanese Squeeze Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/jet_set_racing_roulette_live": {
        slug: "jet_set_racing_roulette_live",
        name: "Jet Set Racing Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/jogo_do_bozo_turbo": {
        slug: "jogo_do_bozo_turbo",
        name: "Jogo Do Bozo Turbo",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/korean_speed_baccarat": {
        slug: "korean_speed_baccarat",
        name: "Korean Speed Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/korean_speed_baccarat_nc": {
        slug: "korean_speed_baccarat_nc",
        name: "Korean Speed Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/live_lobby": {
        slug: "live_lobby",
        name: "Live Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/lucky_ball_roulette_live": {
        slug: "lucky_ball_roulette_live",
        name: "Lucky Ball Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/majority_rules_speed_blackjack": {
        slug: "majority_rules_speed_blackjack",
        name: "Majority Rules Speed Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_age_of_gods_roulette_live": {
        slug: "mega_fire_blaze_age_of_gods_roulette_live",
        name: "Mega Fire Blaze Age Of Gods Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_blackjack_live": {
        slug: "mega_fire_blaze_blackjack_live",
        name: "Mega Fire Blaze Blackjack Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_live_trivia": {
        slug: "mega_fire_blaze_live_trivia",
        name: "Mega Fire Blaze Live Trivia",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_live_trivia_lobby": {
        slug: "mega_fire_blaze_live_trivia_lobby",
        name: "Mega Fire Blaze Live Trivia Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_lucky_ball_brasileiro": {
        slug: "mega_fire_blaze_lucky_ball_brasileiro",
        name: "Mega Fire Blaze Lucky Ball Brasileiro",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_roleta_brasileira_live": {
        slug: "mega_fire_blaze_roleta_brasileira_live",
        name: "Mega Fire Blaze Roleta Brasileira Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_roulette_live": {
        slug: "mega_fire_blaze_roulette_live",
        name: "Mega Fire Blaze Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_ruleta_espana": {
        slug: "mega_fire_blaze_ruleta_espana",
        name: "Mega Fire Blaze Ruleta Espana",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/mega_fire_blaze_ruleta_espana_lobby": {
        slug: "mega_fire_blaze_ruleta_espana_lobby",
        name: "Mega Fire Blaze Ruleta Espana Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/nederlandstalige_roulette": {
        slug: "nederlandstalige_roulette",
        name: "Nederlandstalige Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/prestige_roulette": {
        slug: "prestige_roulette",
        name: "Prestige Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/punto_banco_soiree_gold": {
        slug: "punto_banco_soiree_gold",
        name: "Punto Banco Soiree Gold",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/quantum_auto_roulette": {
        slug: "quantum_auto_roulette",
        name: "Quantum Auto Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/quantum_baccarat": {
        slug: "quantum_baccarat",
        name: "Quantum Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/quantum_blackjack_plus": {
        slug: "quantum_blackjack_plus",
        name: "Quantum Blackjack Plus",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/quantum_roulette_live": {
        slug: "quantum_roulette_live",
        name: "Quantum Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/quantum_roulette_live_lobby": {
        slug: "quantum_roulette_live_lobby",
        name: "Quantum Roulette Live Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/roleta_brasileira": {
        slug: "roleta_brasileira",
        name: "Roleta Brasileira",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/roleta_canarinho": {
        slug: "roleta_canarinho",
        name: "Roleta Canarinho",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/roulette_italiana": {
        slug: "roulette_italiana",
        name: "Roulette Italiana",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/roulette_lobby": {
        slug: "roulette_lobby",
        name: "Roulette Lobby",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/royal_baccarat": {
        slug: "royal_baccarat",
        name: "Royal Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/royale_blackjack": {
        slug: "royale_blackjack",
        name: "Royale Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/ru_yi_speed_baccarat": {
        slug: "ru_yi_speed_baccarat",
        name: "Ru Yi Speed Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/ru_yi_speed_baccarat_nc": {
        slug: "ru_yi_speed_baccarat_nc",
        name: "Ru Yi Speed Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/ruleta_rapida": {
        slug: "ruleta_rapida",
        name: "Ruleta Rapida",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/ruyi_french_roulette": {
        slug: "ruyi_french_roulette",
        name: "Ruyi French Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/ruyi_roulette": {
        slug: "ruyi_roulette",
        name: "Ruyi Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/sakura_fortune_live": {
        slug: "sakura_fortune_live",
        name: "Sakura Fortune Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/sette_e_mezzo": {
        slug: "sette_e_mezzo",
        name: "Sette E Mezzo",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/sicbo_deluxe": {
        slug: "sicbo_deluxe",
        name: "SicBo Deluxe",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/soho_all_bets_blackjack": {
        slug: "soho_all_bets_blackjack",
        name: "Soho All Bets Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/soiree_blackjack": {
        slug: "soiree_blackjack",
        name: "Soiree Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/soiree_elite_blackjack": {
        slug: "soiree_elite_blackjack",
        name: "Soiree Elite Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/soiree_elite_vip_blackjack": {
        slug: "soiree_elite_vip_blackjack",
        name: "Soiree Elite VIP Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/soiree_privee_blackjack": {
        slug: "soiree_privee_blackjack",
        name: "Soiree Privee Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_6_scanner_baccarat": {
        slug: "speed_6_scanner_baccarat",
        name: "Speed 6 Scanner Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_6_scanner_baccarat_nc": {
        slug: "speed_6_scanner_baccarat_nc",
        name: "Speed 6 Scanner Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_auto_roulette": {
        slug: "speed_auto_roulette",
        name: "Speed Auto Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_baccarat_nc": {
        slug: "speed_baccarat_nc",
        name: "Speed Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_blackjack_1": {
        slug: "speed_blackjack_1",
        name: "Speed Blackjack 1",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_blackjack_italiano": {
        slug: "speed_blackjack_italiano",
        name: "Speed Blackjack Italiano",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_roleta_brasileira": {
        slug: "speed_roleta_brasileira",
        name: "Speed Roleta Brasileira",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_roulette": {
        slug: "speed_roulette",
        name: "Speed Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/speed_sic_bo": {
        slug: "speed_sic_bo",
        name: "Speed Sic Bo",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/spin_a_win": {
        slug: "spin_a_win",
        name: "Spin a Win",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/spin_a_win_wild_brasileiro": {
        slug: "spin_a_win_wild_brasileiro",
        name: "Spin a Win Wild Brasileiro",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/spin_a_win_wild_live": {
        slug: "spin_a_win_wild_live",
        name: "Spin A Win Wild Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/spread_bet_roulette": {
        slug: "spread_bet_roulette",
        name: "Spread Bet Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/sticky_bandits_roulette_live": {
        slug: "sticky_bandits_roulette_live",
        name: "Sticky Bandits Roulette Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/super_speed_baccarat": {
        slug: "super_speed_baccarat",
        name: "Super Speed Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/teen_patti_live": {
        slug: "teen_patti_live",
        name: "Teen Patti Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/the_greatest_cards_show_live": {
        slug: "the_greatest_cards_show_live",
        name: "The Greatest Cards Show Live",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/turkish_roulette": {
        slug: "turkish_roulette",
        name: "Turkish Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/uk_roulette": {
        slug: "uk_roulette",
        name: "UK Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/unlimited_blackjack": {
        slug: "unlimited_blackjack",
        name: "Unlimited Blackjack",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/vip_baccarat": {
        slug: "vip_baccarat",
        name: "VIP Baccarat",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/vip_baccarat_nc": {
        slug: "vip_baccarat_nc",
        name: "VIP Baccarat NC",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/wonderland_lucky_ball": {
        slug: "wonderland_lucky_ball",
        name: "Wonderland Lucky Ball",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/x1000_quantum_roulette": {
        slug: "x1000_quantum_roulette",
        name: "x1000 Quantum Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech-live/xiang_long_roulette": {
        slug: "xiang_long_roulette",
        name: "Xiang Long Roulette",
        provider: "Playtech Live",
        providerSlug: "playtech-live"
    },
    "playtech/1000_diamond_bet_roulette": {
        slug: "1000_diamond_bet_roulette",
        name: "1000 Diamond bet Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/15_stars_ablaze": {
        slug: "15_stars_ablaze",
        name: "15 Stars Ablaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/1ofakind_a1": {
        slug: "1ofakind_a1",
        name: "1-Of-A-Kind A1",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/20_stars_ablaze": {
        slug: "20_stars_ablaze",
        name: "20 Stars Ablaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/28_mansions": {
        slug: "28_mansions",
        name: "28 Mansions",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/3_big_barrels_aztec": {
        slug: "3_big_barrels_aztec",
        name: "3 Big Barrels Aztec",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/3_big_barrels_buffalo": {
        slug: "3_big_barrels_buffalo",
        name: "3 Big Barrels Buffalo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/3_big_barrels_elfin_rich": {
        slug: "3_big_barrels_elfin_rich",
        name: "3 Big Barrels Elfin' Rich",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/3_card_brag": {
        slug: "3_card_brag",
        name: "3 Card brag",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/4_cash_planes_multiplayer": {
        slug: "4_cash_planes_multiplayer",
        name: "4 Cash Planes: Multiplayer",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/4_crazy_cluckers": {
        slug: "4_crazy_cluckers",
        name: "4 Crazy Cluckers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/8_treasures_1_queen": {
        slug: "8_treasures_1_queen",
        name: "8 Treasures 1 Queen",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/81_gold_cascade": {
        slug: "81_gold_cascade",
        name: "81 Gold Cascade",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/81_joker_hot_reels": {
        slug: "81_joker_hot_reels",
        name: "81 Joker Hot Reels",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/81_mahjong_cascade": {
        slug: "81_mahjong_cascade",
        name: "81 Mahjong Cascade",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/9_stars_ablaze": {
        slug: "9_stars_ablaze",
        name: "9 Stars Ablaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/a_night_out": {
        slug: "a_night_out",
        name: "A Night Out",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/absolutely_mammoth": {
        slug: "absolutely_mammoth",
        name: "Absolutely Mammoth!",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/adventures_beyond_wonderland_magical_maze": {
        slug: "adventures_beyond_wonderland_magical_maze",
        name: "Adventures Beyond Wonderland Magical Maze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/adventures_of_lil_red": {
        slug: "adventures_of_lil_red",
        name: "Adventures of Li'l Red",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_egypt": {
        slug: "age_of_egypt",
        name: "Age of Egypt",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_gods_book_of_oracle": {
        slug: "age_of_gods_book_of_oracle",
        name: "Age of Gods: Book of Oracle",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_dogs": {
        slug: "age_of_the_dogs",
        name: "Age of the Dogs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods": {
        slug: "age_of_the_gods",
        name: "Age Of The Gods",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_amazon_wild": {
        slug: "age_of_the_gods_amazon_wild",
        name: "Age of the Gods: Amazon Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_apollo_power": {
        slug: "age_of_the_gods_apollo_power",
        name: "Age Of The Gods: Apollo Power",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_cash_collect": {
        slug: "age_of_the_gods_cash_collect",
        name: "Age of the Gods: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_epic_troy": {
        slug: "age_of_the_gods_epic_troy",
        name: "Age of the Gods - Epic Troy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_fate_sisters": {
        slug: "age_of_the_gods_fate_sisters",
        name: "Age of the gods Fate Sisters",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_furious_four": {
        slug: "age_of_the_gods_furious_four",
        name: "Age of the gods Furious Four",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_glorious_griffin": {
        slug: "age_of_the_gods_glorious_griffin",
        name: "Age of the Gods: Glorious Griffin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_god_of_storms": {
        slug: "age_of_the_gods_god_of_storms",
        name: "Age of the Gods: God of Storms",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_god_of_storms_2": {
        slug: "age_of_the_gods_god_of_storms_2",
        name: "Age of the Gods God of Storms 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_god_of_storms_3": {
        slug: "age_of_the_gods_god_of_storms_3",
        name: "Age of the Gods: God of Storms 3",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_god_of_storms_fire_blaze": {
        slug: "age_of_the_gods_god_of_storms_fire_blaze",
        name: "Age of the Gods God of Storms Fire Blaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_goddess_of_wisdom": {
        slug: "age_of_the_gods_goddess_of_wisdom",
        name: "Age of the gods Goddess of Wisdom",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_helios": {
        slug: "age_of_the_gods_helios",
        name: "Age of the Gods: Helios",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_hercules_rules": {
        slug: "age_of_the_gods_hercules_rules",
        name: "Age of the Gods Hercules Rules",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_keno": {
        slug: "age_of_the_gods_keno",
        name: "Age of the Gods: Keno",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_king_of_olympus": {
        slug: "age_of_the_gods_king_of_olympus",
        name: "Age of the Gods King of Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_king_of_olympus_fire_blaze_xtreme": {
        slug: "age_of_the_gods_king_of_olympus_fire_blaze_xtreme",
        name: "Age of the Gods: King of Olympus Fire Blaze Xtreme",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_king_of_olympus_megaways": {
        slug: "age_of_the_gods_king_of_olympus_megaways",
        name: "Age of the Gods: King of Olympus Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_maze_keeper": {
        slug: "age_of_the_gods_maze_keeper",
        name: "Age of the Gods: Maze Keeper",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_medusa_and_monsters": {
        slug: "age_of_the_gods_medusa_and_monsters",
        name: "Age of the Gods Medusa & Monsters",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_mighty_midas": {
        slug: "age_of_the_gods_mighty_midas",
        name: "Age Of The Gods: Mighty Midas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_prince_of_olympus": {
        slug: "age_of_the_gods_prince_of_olympus",
        name: "Age of the gods Prince of Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_roulette": {
        slug: "age_of_the_gods_roulette",
        name: "Age Of The Gods Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_ruler_of_the_dead": {
        slug: "age_of_the_gods_ruler_of_the_dead",
        name: "Age of the Gods: Ruler Of The Dead",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_ruler_of_the_seas": {
        slug: "age_of_the_gods_ruler_of_the_seas",
        name: "Age of the Gods: Ruler of the Seas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_ruler_of_the_sky": {
        slug: "age_of_the_gods_ruler_of_the_sky",
        name: "Age of the Gods: Ruler of the Sky",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_rulers_of_olympus": {
        slug: "age_of_the_gods_rulers_of_olympus",
        name: "Age Of The Gods: Rulers of Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_spin_a_win": {
        slug: "age_of_the_gods_spin_a_win",
        name: "Age of the Gods: Spin A Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_wheels_of_olympus": {
        slug: "age_of_the_gods_wheels_of_olympus",
        name: "Age of the Gods: Wheels of Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/age_of_the_gods_wonder_warriors": {
        slug: "age_of_the_gods_wonder_warriors",
        name: "Age of the Gods: Wonder Warriors",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/alice_and_the_mad_respin_party": {
        slug: "alice_and_the_mad_respin_party",
        name: "Alice and the Mad Respin Party",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/alohawaii_cash_collect": {
        slug: "alohawaii_cash_collect",
        name: "Alohawaii: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/anaconda_uncoiled": {
        slug: "anaconda_uncoiled",
        name: "Anaconda Uncoiled",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/anaconda_wild": {
        slug: "anaconda_wild",
        name: "Anaconda Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/anaconda_wild_ii": {
        slug: "anaconda_wild_ii",
        name: "Anaconda Wild II",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ancient_pharaoh": {
        slug: "ancient_pharaoh",
        name: "Ancient Pharaoh",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/animal_instinct": {
        slug: "animal_instinct",
        name: "Animal Instinct",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/arabian_secret": {
        slug: "arabian_secret",
        name: "Arabian Secret",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/arcane_beauties": {
        slug: "arcane_beauties",
        name: "Arcane Beauties",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/archer": {
        slug: "archer",
        name: "Archer",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/arowanas_luck": {
        slug: "arowanas_luck",
        name: "Arowana's Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/asian_fantasy": {
        slug: "asian_fantasy",
        name: "Asian Fantasy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/atlantis_cash_collect": {
        slug: "atlantis_cash_collect",
        name: "Atlantis: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/autumn_gold": {
        slug: "autumn_gold",
        name: "Autumn Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/aztec_expedition_thundershots": {
        slug: "aztec_expedition_thundershots",
        name: "Aztec Expedition Thundershots",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/aztec_fruits": {
        slug: "aztec_fruits",
        name: "Aztec Fruits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/aztec_reel": {
        slug: "aztec_reel",
        name: "Aztec Reel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/azteca_cash_collect": {
        slug: "azteca_cash_collect",
        name: "Azteca: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/azticons_chaos_clusters": {
        slug: "azticons_chaos_clusters",
        name: "Azticons Chaos Clusters",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/baa_baa_baa": {
        slug: "baa_baa_baa",
        name: "Baa, Baa, Baa",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bai_shi": {
        slug: "bai_shi",
        name: "Bai Shi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bamboo_fortune": {
        slug: "bamboo_fortune",
        name: "Bamboo Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/beach_life": {
        slug: "beach_life",
        name: "Beach Life",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bear_buzz": {
        slug: "bear_buzz",
        name: "Bear Buzz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/beastwood": {
        slug: "beastwood",
        name: "Beastwood",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/beat_the_bobbies": {
        slug: "beat_the_bobbies",
        name: "Beat The Bobbies",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bee_frenzy": {
        slug: "bee_frenzy",
        name: "Bee Frenzy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/beez_kneez": {
        slug: "beez_kneez",
        name: "Beez Kneez",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bermuda_triangle": {
        slug: "bermuda_triangle",
        name: "Bermuda Triangle",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/better_wilds": {
        slug: "better_wilds",
        name: "Better Wilds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/betty_bonkers": {
        slug: "betty_bonkers",
        name: "Betty Bonkers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/big_bad_towers": {
        slug: "big_bad_towers",
        name: "Big Bad Towers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/big_bad_wolf": {
        slug: "big_bad_wolf",
        name: "Big Bad Wolf",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/big_bad_wolf_cash_collect_and_link": {
        slug: "big_bad_wolf_cash_collect_and_link",
        name: "Big Bad Wolf: Cash Collect & Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/big_bad_wolf_megaways": {
        slug: "big_bad_wolf_megaways",
        name: "Big Bad Wolf Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/big_bad_wolf_pigs_of_steel": {
        slug: "big_bad_wolf_pigs_of_steel",
        name: "Big Bad Wolf: Pigs of Steel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blackbeards_hoard_cash_sacks": {
        slug: "blackbeards_hoard_cash_sacks",
        name: "Blackbeard's Hoard Cash Sacks",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blackjack_surrender": {
        slug: "blackjack_surrender",
        name: "Blackjack Surrender",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blazing_bells": {
        slug: "blazing_bells",
        name: "Blazing Bells",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blazing_rainbows": {
        slug: "blazing_rainbows",
        name: "Blazing Rainbows",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blazing_tiger": {
        slug: "blazing_tiger",
        name: "Blazing Tiger",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blue_wizard": {
        slug: "blue_wizard",
        name: "Blue Wizard",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/blue_wizard_cash_collect_and_link": {
        slug: "blue_wizard_cash_collect_and_link",
        name: "Blue Wizard: Cash Collect & Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bombs": {
        slug: "bombs",
        name: "Bombs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bonus_bears": {
        slug: "bonus_bears",
        name: "Bonus Bears",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_8_riches": {
        slug: "book_of_8_riches",
        name: "Book of 8 Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_duat": {
        slug: "book_of_duat",
        name: "Book of Duat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_inferno": {
        slug: "book_of_inferno",
        name: "Book of Inferno",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_kings": {
        slug: "book_of_kings",
        name: "Book of Kings",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_riches": {
        slug: "book_of_riches",
        name: "Book Of Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_riches_deluxe": {
        slug: "book_of_riches_deluxe",
        name: "Book Of Riches Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_riches_deluxe_chapter_2": {
        slug: "book_of_riches_deluxe_chapter_2",
        name: "Book of Riches Deluxe: Chapter 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/book_of_sakura": {
        slug: "book_of_sakura",
        name: "Book of Sakura",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bouncy_balls_2": {
        slug: "bouncy_balls_2",
        name: "Bouncy Balls 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/brawlers_bar_cash_collect": {
        slug: "brawlers_bar_cash_collect",
        name: "Brawlers Bar Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/brawlers_brew": {
        slug: "brawlers_brew",
        name: "Brawlers Brew",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/breach_the_vault": {
        slug: "breach_the_vault",
        name: "Breach the Vault",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/breakout_bob": {
        slug: "breakout_bob",
        name: "Breakout Bob",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/brilliant_gems": {
        slug: "brilliant_gems",
        name: "Brilliant Gems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/brooklyn_bootleggers": {
        slug: "brooklyn_bootleggers",
        name: "Brooklyn Bootleggers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bubblegum_burst": {
        slug: "bubblegum_burst",
        name: "Bubblegum Burst",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/buffalo_blitz": {
        slug: "buffalo_blitz",
        name: "Buffalo Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/buffalo_blitz_cash_collect": {
        slug: "buffalo_blitz_cash_collect",
        name: "Buffalo Blitz Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/buffalo_blitz_ii": {
        slug: "buffalo_blitz_ii",
        name: "Buffalo Blitz II",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/buffalo_blitz_mega_merge": {
        slug: "buffalo_blitz_mega_merge",
        name: "Buffalo Blitz: Mega Merge",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/buffalo_blitz_megaways": {
        slug: "buffalo_blitz_megaways",
        name: "Buffalo Blitz: Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bufon_fortuna": {
        slug: "bufon_fortuna",
        name: "Bufon Fortuna",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bufon_fortuna_deluxe": {
        slug: "bufon_fortuna_deluxe",
        name: "Bufon Fortuna Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/bull_fever": {
        slug: "bull_fever",
        name: "Bull Fever",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cache_rush": {
        slug: "cache_rush",
        name: "Cache Rush",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/caishen_ways": {
        slug: "caishen_ways",
        name: "Caishen Ways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/candy_roll": {
        slug: "candy_roll",
        name: "Candy Roll",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/capitano_galliano": {
        slug: "capitano_galliano",
        name: "Capitano Galliano",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/captains_treasure": {
        slug: "captains_treasure",
        name: "Captains Treasure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/caravan_to_cairo": {
        slug: "caravan_to_cairo",
        name: "Caravan To Cairo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cascading_cave": {
        slug: "cascading_cave",
        name: "Cascading Cave",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_collect_roulette": {
        slug: "cash_collect_roulette",
        name: "Cash Collect Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_it": {
        slug: "cash_it",
        name: "Cash It",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_it_multiplayer": {
        slug: "cash_it_multiplayer",
        name: "Cash It Multiplayer",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_it_multiplayer_double_heat": {
        slug: "cash_it_multiplayer_double_heat",
        name: "Cash It Multiplayer Double Heat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_reveal_credits": {
        slug: "cash_reveal_credits",
        name: "Cash Reveal Credits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_truck": {
        slug: "cash_truck",
        name: "Cash Truck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_truck_2": {
        slug: "cash_truck_2",
        name: "Cash Truck 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_truck_3_turbo": {
        slug: "cash_truck_3_turbo",
        name: "Cash Truck 3 Turbo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_truck_begins": {
        slug: "cash_truck_begins",
        name: "Cash Truck Begins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cash_truck_xmas_delivery": {
        slug: "cash_truck_xmas_delivery",
        name: "Cash Truck Xmas Delivery",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cashback_blackjack": {
        slug: "cashback_blackjack",
        name: "Cashback Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/casino_hold_em": {
        slug: "casino_hold_em",
        name: "Casino Hold 'Em",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cat_queen": {
        slug: "cat_queen",
        name: "Cat Queen",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/catrinas_coins": {
        slug: "catrinas_coins",
        name: "Catrina's Coins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/celestial_flame_coin_rise": {
        slug: "celestial_flame_coin_rise",
        name: "Celestial Flame Coin Rise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/champions_of_poseidon": {
        slug: "champions_of_poseidon",
        name: "Champions of Poseidon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/chaoji_888": {
        slug: "chaoji_888",
        name: "Chaoji 888",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/chili_eruption": {
        slug: "chili_eruption",
        name: "Chili Eruption",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/chilli_xtreme": {
        slug: "chilli_xtreme",
        name: "Chilli Xtreme",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/chinese_kitchen": {
        slug: "chinese_kitchen",
        name: "Chinese Kitchen",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/christmas_fortune": {
        slug: "christmas_fortune",
        name: "Christmas Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/circuit_shock": {
        slug: "circuit_shock",
        name: "Circuit Shock",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/clover_flip": {
        slug: "clover_flip",
        name: "Clover Flip",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/clover_rollover_2": {
        slug: "clover_rollover_2",
        name: "Clover Rollover 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/clovers_of_luck": {
        slug: "clovers_of_luck",
        name: "Clovers of Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/clovers_of_luck_2": {
        slug: "clovers_of_luck_2",
        name: "Clovers of Luck 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cluck_it": {
        slug: "cluck_it",
        name: "Cluck It",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/coffee_explosion": {
        slug: "coffee_explosion",
        name: "Coffee Explosion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/coinfall_the_big_freeze": {
        slug: "coinfall_the_big_freeze",
        name: "CoinFall: The Big Freeze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/craps": {
        slug: "craps",
        name: "Craps",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/crazy_7": {
        slug: "crazy_7",
        name: "Crazy 7",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/crocodile_blitz": {
        slug: "crocodile_blitz",
        name: "Crocodile Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/crystal_furnace": {
        slug: "crystal_furnace",
        name: "Crystal Furnace",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/crystal_lotus": {
        slug: "crystal_lotus",
        name: "Crystal Lotus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/crystal_lotuses": {
        slug: "crystal_lotuses",
        name: "Crystal Lotuses",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/cup_carnaval": {
        slug: "cup_carnaval",
        name: "Cup Carnaval",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/curse_of_anubis": {
        slug: "curse_of_anubis",
        name: "Curse of Anubis",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dawn_of_the_incas": {
        slug: "dawn_of_the_incas",
        name: "Dawn of the Incas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/desert_treasure": {
        slug: "desert_treasure",
        name: "Desert Treasure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/devil_wilds": {
        slug: "devil_wilds",
        name: "Devil Wilds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_bet_roulette": {
        slug: "diamond_bet_roulette",
        name: "Diamond Bet Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_explosion_777": {
        slug: "diamond_explosion_777",
        name: "Diamond Explosion 777",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_explosion_7s": {
        slug: "diamond_explosion_7s",
        name: "Diamond Explosion 7s",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_explosion_christmas_tango": {
        slug: "diamond_explosion_christmas_tango",
        name: "Diamond Explosion Christmas Tango",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_explosion_patriots": {
        slug: "diamond_explosion_patriots",
        name: "Diamond Explosion Patriots",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_explosion_sweet_love": {
        slug: "diamond_explosion_sweet_love",
        name: "Diamond Explosion Sweet Love",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_match": {
        slug: "diamond_match",
        name: "Diamond Match",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_match_deluxe": {
        slug: "diamond_match_deluxe",
        name: "Diamond Match Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/diamond_rise_l": {
        slug: "diamond_rise_l",
        name: "Diamond Rise L",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/divine_9": {
        slug: "divine_9",
        name: "Divine 9",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dog_town_deal": {
        slug: "dog_town_deal",
        name: "Dog Town Deal",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dolphin_reef": {
        slug: "dolphin_reef",
        name: "Dolphin Reef",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/double_digger": {
        slug: "double_digger",
        name: "Double Digger",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/double_heat_crown": {
        slug: "double_heat_crown",
        name: "Double Heat: Crown",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dr_frankenstein": {
        slug: "dr_frankenstein",
        name: "Dr. Frankenstein",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_8s_25x": {
        slug: "dragon_8s_25x",
        name: "Dragon 8s 25x",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_bond": {
        slug: "dragon_bond",
        name: "Dragon Bond",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_champions": {
        slug: "dragon_champions",
        name: "Dragon Champions",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_chi": {
        slug: "dragon_chi",
        name: "Dragon Chi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_jackpot_roulette": {
        slug: "dragon_jackpot_roulette",
        name: "Dragon Jackpot Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_ladies": {
        slug: "dragon_ladies",
        name: "Dragon Ladies",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_prophecy": {
        slug: "dragon_prophecy",
        name: "Dragon Prophecy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_riches": {
        slug: "dragon_riches",
        name: "Dragon Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_shrine": {
        slug: "dragon_shrine",
        name: "Dragon Shrine",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragon_spark": {
        slug: "dragon_spark",
        name: "Dragon Spark",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragoness": {
        slug: "dragoness",
        name: "Dragoness",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dragons_hall_thundershots": {
        slug: "dragons_hall_thundershots",
        name: "Dragon's Hall Thundershots",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/drop_for_top": {
        slug: "drop_for_top",
        name: "Drop for Top",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/dynamite_digger_eureka": {
        slug: "dynamite_digger_eureka",
        name: "Dynamite Digger Eureka",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/easter_surprise": {
        slug: "easter_surprise",
        name: "Easter Surprise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/eastern_emeralds": {
        slug: "eastern_emeralds",
        name: "Eastern Emeralds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/eastern_emeralds_megaways": {
        slug: "eastern_emeralds_megaways",
        name: "Eastern Emeralds Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/egypt_spin": {
        slug: "egypt_spin",
        name: "Egypt Spin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/egyptian_emeralds": {
        slug: "egyptian_emeralds",
        name: "Egyptian Emeralds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/egyptian_sun": {
        slug: "egyptian_sun",
        name: "Egyptian Sun",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/el_capy": {
        slug: "el_capy",
        name: "El Capy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/el_ranchero_cash_collect_diamond_path": {
        slug: "el_ranchero_cash_collect_diamond_path",
        name: "El Ranchero Cash Collect Diamond Path",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/elephant_riches": {
        slug: "elephant_riches",
        name: "Elephant Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/elephant_stampede": {
        slug: "elephant_stampede",
        name: "Elephant Stampede",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/enchanted_prince": {
        slug: "enchanted_prince",
        name: "Enchanted Prince",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/enchanted_prince_2": {
        slug: "enchanted_prince_2",
        name: "Enchanted Prince 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/enter_the_vault": {
        slug: "enter_the_vault",
        name: "Enter the Vault",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_ape": {
        slug: "epic_ape",
        name: "Epic Ape",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_ape_blitz_cash_collect": {
        slug: "epic_ape_blitz_cash_collect",
        name: "Epic Ape: Blitz Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_ape_ii_jackpot_blitz": {
        slug: "epic_ape_ii_jackpot_blitz",
        name: "Epic Ape II Jackpot Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_fish_adventure": {
        slug: "epic_fish_adventure",
        name: "Epic Fish Adventure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_fish_marlin_madness": {
        slug: "epic_fish_marlin_madness",
        name: "Epic Fish: Marlin Madness",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_fish_of_fortune": {
        slug: "epic_fish_of_fortune",
        name: "Epic Fish of Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/epic_fish_winter_catch": {
        slug: "epic_fish_winter_catch",
        name: "Epic Fish: Winter Catch",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/eternal_lady": {
        slug: "eternal_lady",
        name: "Eternal Lady",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/eye_of_anubis": {
        slug: "eye_of_anubis",
        name: "Eye of Anubis",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fat_choy_choy_sun": {
        slug: "fat_choy_choy_sun",
        name: "Fat Choy Choy Sun",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/feasting_fox": {
        slug: "feasting_fox",
        name: "Feasting Fox",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fei_cui_gong_zhu": {
        slug: "fei_cui_gong_zhu",
        name: "Fei Cui Gong Zhu",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fei_long_zai_tian": {
        slug: "fei_long_zai_tian",
        name: "Fei Long Zai Tian",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/feliz_dia_de_los_muertos": {
        slug: "feliz_dia_de_los_muertos",
        name: "Feliz Dia De Los Muertos",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/feng_kuang_ma_jiang": {
        slug: "feng_kuang_ma_jiang",
        name: "Feng Kuang Ma Jiang",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/feng_shui_flip": {
        slug: "feng_shui_flip",
        name: "Feng Shui Flip",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_4_cash_collect_quattro": {
        slug: "fire_4_cash_collect_quattro",
        name: "Fire 4: Cash Collect Quattro",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_adventure_trail": {
        slug: "fire_blaze_adventure_trail",
        name: "Fire Blaze: Adventure Trail",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_blue_wizard_megaways": {
        slug: "fire_blaze_blue_wizard_megaways",
        name: "Fire Blaze: Blue Wizard Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_fire_fighter": {
        slug: "fire_blaze_fire_fighter",
        name: "Fire Blaze: Fire Fighter",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_golden_amazing_factory": {
        slug: "fire_blaze_golden_amazing_factory",
        name: "Fire Blaze Golden: Amazing Factory",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_golden_buccaneer_bells": {
        slug: "fire_blaze_golden_buccaneer_bells",
        name: "Fire Blaze Golden: Buccaneer Bells",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_green_wizard": {
        slug: "fire_blaze_green_wizard",
        name: "Fire Blaze: Green Wizard",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_oink_oink_oink": {
        slug: "fire_blaze_oink_oink_oink",
        name: "Fire Blaze: Oink Oink Oink",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_pearls_pearls_pearls": {
        slug: "fire_blaze_pearls_pearls_pearls",
        name: "Fire Blaze: Pearls Pearls Pearls",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_quattro_celtic_charm": {
        slug: "fire_blaze_quattro_celtic_charm",
        name: "Fire Blaze Quattro: Celtic Charm",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_red_wizard": {
        slug: "fire_blaze_red_wizard",
        name: "Fire Blaze: Red Wizard",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_river_empress": {
        slug: "fire_blaze_river_empress",
        name: "Fire Blaze: River Empress",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_sisters_gift": {
        slug: "fire_blaze_sisters_gift",
        name: "Fire Blaze: Sisters Gift",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_sky_queen_megaways": {
        slug: "fire_blaze_sky_queen_megaways",
        name: "Fire Blaze Sky Queen Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_toltec_blocks": {
        slug: "fire_blaze_toltec_blocks",
        name: "Fire Blaze: Toltec Blocks",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_tundra_wolf": {
        slug: "fire_blaze_tundra_wolf",
        name: "Fire Blaze: Tundra Wolf",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_blaze_white_witch": {
        slug: "fire_blaze_white_witch",
        name: "Fire Blaze White Witch",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_reel": {
        slug: "fire_reel",
        name: "Fire Reel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fire_tale": {
        slug: "fire_tale",
        name: "Fire Tale",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fireworks_frenzy": {
        slug: "fireworks_frenzy",
        name: "Fireworks Frenzy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fish_prawn_crab": {
        slug: "fish_prawn_crab",
        name: "Fish Prawn Crab",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fish_trio": {
        slug: "fish_trio",
        name: "Fish Trio",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fishin_bonanza": {
        slug: "fishin_bonanza",
        name: "Fishin' Bonanza",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/flaming_bars": {
        slug: "flaming_bars",
        name: "Flaming Bars",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/flaming_stallion_blitz": {
        slug: "flaming_stallion_blitz",
        name: "Flaming Stallion Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/flip_royale": {
        slug: "flip_royale",
        name: "Flip Royale",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites": {
        slug: "fluffy_favourites",
        name: "Fluffy Favourites",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_10": {
        slug: "fluffy_favourites_10",
        name: "Fluffy Favourites 10",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_cash_collect": {
        slug: "fluffy_favourites_cash_collect",
        name: "Fluffy Favourites: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_clickawin": {
        slug: "fluffy_favourites_clickawin",
        name: "Fluffy Favourites Click-A-Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_megaways": {
        slug: "fluffy_favourites_megaways",
        name: "Fluffy Favourites Megaways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_mix_n_win": {
        slug: "fluffy_favourites_mix_n_win",
        name: "Fluffy Favourites Mix n Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_favourites_remastered": {
        slug: "fluffy_favourites_remastered",
        name: "Fluffy Favourites Remastered",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fluffy_fishin": {
        slug: "fluffy_fishin",
        name: "Fluffy Fishin'",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/football_cash_collect": {
        slug: "football_cash_collect",
        name: "Football! Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/football_cash_collect_powerplay_jackpot": {
        slug: "football_cash_collect_powerplay_jackpot",
        name: "Football! Cash Collect PowerPlay Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/football_rules": {
        slug: "football_rules",
        name: "Football Rules",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fortune_day": {
        slug: "fortune_day",
        name: "Fortune Day",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fortune_lions": {
        slug: "fortune_lions",
        name: "Fortune Lions",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fortunes_of_the_fox": {
        slug: "fortunes_of_the_fox",
        name: "Fortunes of the Fox",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/free_the_dragon": {
        slug: "free_the_dragon",
        name: "Free the Dragon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/frogs_gift": {
        slug: "frogs_gift",
        name: "Frogs Gift",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fruit_harvest": {
        slug: "fruit_harvest",
        name: "Fruit Harvest",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fruit_mania": {
        slug: "fruit_mania",
        name: "Fruit Mania",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fruity_burst_2": {
        slug: "fruity_burst_2",
        name: "Fruity Burst 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fruity_showers": {
        slug: "fruity_showers",
        name: "Fruity Showers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/fu_double_luck_diamond_explosion": {
        slug: "fu_double_luck_diamond_explosion",
        name: "Fu Double Luck Diamond Explosion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/full_moon_white_king_powerplay_jackpot": {
        slug: "full_moon_white_king_powerplay_jackpot",
        name: "Full Moon: White King PowerPlay Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/full_moon_white_panda": {
        slug: "full_moon_white_panda",
        name: "Full Moon: White Panda",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/full_moon_white_thunder": {
        slug: "full_moon_white_thunder",
        name: "Full Moon: White Thunder",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/funky_fruits_jackpot_game": {
        slug: "funky_fruits_jackpot_game",
        name: "Funky Fruits Jackpot Game",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/funky_monkey": {
        slug: "funky_monkey",
        name: "Funky Monkey",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/funky_monkey_jackpot": {
        slug: "funky_monkey_jackpot",
        name: "Funky Monkey Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gaelic_luck": {
        slug: "gaelic_luck",
        name: "Gaelic Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/galactic_girls": {
        slug: "galactic_girls",
        name: "Galactic Girls",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gallantry": {
        slug: "gallantry",
        name: "Gallantry",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/geisha_story": {
        slug: "geisha_story",
        name: "Geisha Story",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gem_heat_high_roller": {
        slug: "gem_heat_high_roller",
        name: "Gem Heat (High Roller)",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gem_queen": {
        slug: "gem_queen",
        name: "Gem Queen",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_bunny": {
        slug: "giga_match_bunny",
        name: "Giga Match Bunny",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_egypt": {
        slug: "giga_match_egypt",
        name: "Giga Match Egypt",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_fruits": {
        slug: "giga_match_fruits",
        name: "Giga Match Fruits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_gems": {
        slug: "giga_match_gems",
        name: "Giga Match Gems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_mahjong": {
        slug: "giga_match_mahjong",
        name: "Giga Match Mahjong",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_moolah": {
        slug: "giga_match_moolah",
        name: "Giga Match Moolah",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_north_pole": {
        slug: "giga_match_north_pole",
        name: "Giga Match North Pole",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_phantasmal": {
        slug: "giga_match_phantasmal",
        name: "Giga Match Phantasmal",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/giga_match_sugar_skull": {
        slug: "giga_match_sugar_skull",
        name: "Giga Match Sugar Skull",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gloria_invicta": {
        slug: "gloria_invicta",
        name: "Gloria Invicta",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/glorious_guardians": {
        slug: "glorious_guardians",
        name: "Glorious Guardians",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_fruit": {
        slug: "go_high_fruit",
        name: "Go High Fruit",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_gallina": {
        slug: "go_high_gallina",
        name: "Go High Gallina",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_gone_fishing": {
        slug: "go_high_gone_fishing",
        name: "Go High Gone Fishing",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_harvest": {
        slug: "go_high_harvest",
        name: "Go High Harvest",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_joker": {
        slug: "go_high_joker",
        name: "Go High Joker",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_olympus": {
        slug: "go_high_olympus",
        name: "Go High Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_panda": {
        slug: "go_high_panda",
        name: "Go High Panda",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_puppy_love": {
        slug: "go_high_puppy_love",
        name: "Go High Puppy Love",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_high_safari": {
        slug: "go_high_safari",
        name: "Go High Safari",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/go_joker_go": {
        slug: "go_joker_go",
        name: "Go Joker Go",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goal_goal_goal_blackjack": {
        slug: "goal_goal_goal_blackjack",
        name: "Goal Goal Goal Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goal_goal_goal_cash_collect": {
        slug: "goal_goal_goal_cash_collect",
        name: "Goal Goal Goal: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goal_goal_goal_mines": {
        slug: "goal_goal_goal_mines",
        name: "Goal Goal Goal Mines",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goal_goal_goal_pachingoal": {
        slug: "goal_goal_goal_pachingoal",
        name: "Goal Goal Goal: Pachin-Goal",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goal_goal_goal_roulette": {
        slug: "goal_goal_goal_roulette",
        name: "Goal Goal Goal Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_and_link_jp_bacon_co": {
        slug: "gold_hit_and_link_jp_bacon_co",
        name: "Gold Hit & Link: JP Bacon & Co",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_and_link_tiger_jones": {
        slug: "gold_hit_and_link_tiger_jones",
        name: "Gold Hit and Link: Tiger Jones",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_dragon_bonanza": {
        slug: "gold_hit_dragon_bonanza",
        name: "Gold Hit: Dragon Bonanza",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_lil_demon": {
        slug: "gold_hit_lil_demon",
        name: "Gold Hit Lil Demon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_lucky_granny": {
        slug: "gold_hit_lucky_granny",
        name: "Gold Hit Lucky Granny",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_oreillys_charms": {
        slug: "gold_hit_oreillys_charms",
        name: "Gold Hit: O'Reilly's Charms",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_oreillys_riches": {
        slug: "gold_hit_oreillys_riches",
        name: "Gold Hit: O'Reilly's Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_shrine_of_anubis": {
        slug: "gold_hit_shrine_of_anubis",
        name: "Gold Hit: Shrine of Anubis",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_hit_viva_las_robot": {
        slug: "gold_hit_viva_las_robot",
        name: "Gold Hit: Viva Las Robot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_pile_new_years_gold": {
        slug: "gold_pile_new_years_gold",
        name: "Gold Pile: New Years Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_pile_orangutan": {
        slug: "gold_pile_orangutan",
        name: "Gold Pile: Orangutan!",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_pile_tigers_pride": {
        slug: "gold_pile_tigers_pride",
        name: "Gold Pile: Tigers Pride",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_pile_toltec_treasure": {
        slug: "gold_pile_toltec_treasure",
        name: "Gold Pile: Toltec Treasure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio": {
        slug: "gold_trio",
        name: "Gold Trio",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_10000": {
        slug: "gold_trio_10000",
        name: "Gold Trio 10000",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_jackpot": {
        slug: "gold_trio_jackpot",
        name: "Gold Trio Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_leprechauns_luck_bf": {
        slug: "gold_trio_leprechauns_luck_bf",
        name: "Gold Trio Leprechaun's Luck BF",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_leprechauns_luck_race_bonanza": {
        slug: "gold_trio_leprechauns_luck_race_bonanza",
        name: "Gold Trio: Leprechaun's Luck Race Bonanza",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_lil_demon": {
        slug: "gold_trio_lil_demon",
        name: "Gold Trio: Lil Demon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_santa_surprise": {
        slug: "gold_trio_santa_surprise",
        name: "Gold Trio: Santa Surprise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_sinbads_riches": {
        slug: "gold_trio_sinbads_riches",
        name: "Gold Trio: Sinbad's Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gold_trio_zones": {
        slug: "gold_trio_zones",
        name: "Gold Trio: Zones",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/golden_forge": {
        slug: "golden_forge",
        name: "Golden Forge",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/golden_glyph_3": {
        slug: "golden_glyph_3",
        name: "Golden Glyph 3",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/golden_macaque": {
        slug: "golden_macaque",
        name: "Golden Macaque",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/golden_tour": {
        slug: "golden_tour",
        name: "Golden Tour",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/golden_ways": {
        slug: "golden_ways",
        name: "Golden Ways",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/goood_heavens": {
        slug: "goood_heavens",
        name: "Goood Heavens",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_express_action_class": {
        slug: "grand_express_action_class",
        name: "Grand Express: Action Class",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_express_diamond_class": {
        slug: "grand_express_diamond_class",
        name: "Grand Express: Diamond Class",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_express_fiesta": {
        slug: "grand_express_fiesta",
        name: "Grand Express: Fiesta",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_junction_enchanted_inca": {
        slug: "grand_junction_enchanted_inca",
        name: "Grand Junction: Enchanted Inca",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_junction_mountain_express": {
        slug: "grand_junction_mountain_express",
        name: "Grand Junction: Mountain Express",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/grand_mariachi": {
        slug: "grand_mariachi",
        name: "Grand Mariachi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/great_blue": {
        slug: "great_blue",
        name: "Great Blue",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/great_blue_jackpot": {
        slug: "great_blue_jackpot",
        name: "Great Blue Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/gummy_giga_match": {
        slug: "gummy_giga_match",
        name: "Gummy Giga Match",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hainan_ice": {
        slug: "hainan_ice",
        name: "Hainan Ice",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/halloween_fortune": {
        slug: "halloween_fortune",
        name: "Halloween Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/halloween_fortune_ii": {
        slug: "halloween_fortune_ii",
        name: "Halloween Fortune II",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hammer_of_vulcan": {
        slug: "hammer_of_vulcan",
        name: "Hammer of Vulcan",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/haoshi_cheng_shuang": {
        slug: "haoshi_cheng_shuang",
        name: "Haoshi Cheng Shuang",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/haunted_house": {
        slug: "haunted_house",
        name: "Haunted House",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/he_he_yang": {
        slug: "he_he_yang",
        name: "He He Yang",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/heads_up_holdem": {
        slug: "heads_up_holdem",
        name: "Heads Up Holdem",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/heart_of_the_frontier": {
        slug: "heart_of_the_frontier",
        name: "Heart of the Frontier",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/heartburst": {
        slug: "heartburst",
        name: "Heartburst",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/heavenly_ruler": {
        slug: "heavenly_ruler",
        name: "Heavenly Ruler",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/heroes_arrow": {
        slug: "heroes_arrow",
        name: "Heroes Arrow",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/high_street_heist": {
        slug: "high_street_heist",
        name: "High Street Heist",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/highway_kings": {
        slug: "highway_kings",
        name: "Highway Kings",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hit_bar": {
        slug: "hit_bar",
        name: "Hit Bar",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hit_bar_gold": {
        slug: "hit_bar_gold",
        name: "Hit Bar: Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hold_the_safe": {
        slug: "hold_the_safe",
        name: "Hold The Safe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/honey_gems": {
        slug: "honey_gems",
        name: "Honey Gems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/honeylocks_pots": {
        slug: "honeylocks_pots",
        name: "Honeylock's Pots",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_and_heavy": {
        slug: "hot_and_heavy",
        name: "Hot and Heavy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_crown_deluxe": {
        slug: "hot_crown_deluxe",
        name: "Hot Crown Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_gems": {
        slug: "hot_gems",
        name: "Hot Gems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_gems_xtreme": {
        slug: "hot_gems_xtreme",
        name: "Hot Gems Xtreme",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_gems_xtreme_scratch": {
        slug: "hot_gems_xtreme_scratch",
        name: "Hot Gems Xtreme Scratch",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_ktv": {
        slug: "hot_ktv",
        name: "Hot KTV",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/hot_off_the_press": {
        slug: "hot_off_the_press",
        name: "Hot off the Press",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ice_cave": {
        slug: "ice_cave",
        name: "Ice Cave",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_empress": {
        slug: "immortal_empress",
        name: "Immortal Empress",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_3_fates": {
        slug: "immortal_ways_3_fates",
        name: "Immortal Ways 3 Fates",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_88_charms": {
        slug: "immortal_ways_88_charms",
        name: "Immortal Ways 88 Charms",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_buffalo": {
        slug: "immortal_ways_buffalo",
        name: "Immortal Ways Buffalo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_champions": {
        slug: "immortal_ways_champions",
        name: "Immortal Ways Champions",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_cleopatra": {
        slug: "immortal_ways_cleopatra",
        name: "Immortal Ways Cleopatra",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_diamonds": {
        slug: "immortal_ways_diamonds",
        name: "Immortal Ways Diamonds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_gallina_harvest": {
        slug: "immortal_ways_gallina_harvest",
        name: "Immortal Ways Gallina Harvest",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_heart_to_heart": {
        slug: "immortal_ways_heart_to_heart",
        name: "Immortal Ways Heart to Heart",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_lady_moon": {
        slug: "immortal_ways_lady_moon",
        name: "Immortal Ways Lady Moon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_magic_gems": {
        slug: "immortal_ways_magic_gems",
        name: "Immortal Ways Magic Gems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_pinata": {
        slug: "immortal_ways_pinata",
        name: "Immortal Ways Pinata",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_spooktacular": {
        slug: "immortal_ways_spooktacular",
        name: "Immortal Ways Spooktacular",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_sweet_coin": {
        slug: "immortal_ways_sweet_coin",
        name: "Immortal Ways Sweet Coin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/immortal_ways_volcano": {
        slug: "immortal_ways_volcano",
        name: "Immortal Ways Volcano",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/irish_clickawin": {
        slug: "irish_clickawin",
        name: "Irish Click-A-Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/irish_luck": {
        slug: "irish_luck",
        name: "Irish Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/irish_luck_eyecon": {
        slug: "irish_luck_eyecon",
        name: "Irish Luck Eyecon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_3_buffalo": {
        slug: "j_mania_3_buffalo",
        name: "J Mania 3 Buffalo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_diamonds": {
        slug: "j_mania_diamonds",
        name: "J Mania Diamonds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_goal_nations": {
        slug: "j_mania_goal_nations",
        name: "J Mania Goal Nations",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_golden_eggs": {
        slug: "j_mania_golden_eggs",
        name: "J Mania Golden Eggs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_hot_asses": {
        slug: "j_mania_hot_asses",
        name: "J Mania Hot Asses",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_loco_habanero": {
        slug: "j_mania_loco_habanero",
        name: "J Mania Loco Habanero",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_lucky_pyggs": {
        slug: "j_mania_lucky_pyggs",
        name: "J Mania Lucky Pyggs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_maniac": {
        slug: "j_mania_maniac",
        name: "J Mania Maniac",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_triple_jam": {
        slug: "j_mania_triple_jam",
        name: "J Mania Triple Jam",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/j_mania_turkey_chef": {
        slug: "j_mania_turkey_chef",
        name: "J Mania Turkey Chef",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jacks_or_better_classic": {
        slug: "jacks_or_better_classic",
        name: "Jacks or Better Classic",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jane_jones_book_of_kings_2": {
        slug: "jane_jones_book_of_kings_2",
        name: "Jane Jones Book of Kings 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jin_qian_wa": {
        slug: "jin_qian_wa",
        name: "Jin Qian Wa",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jinfu_long": {
        slug: "jinfu_long",
        name: "Jinfu Long",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jinfu_xingyun": {
        slug: "jinfu_xingyun",
        name: "Jinfu Xingyun",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jinns_moon": {
        slug: "jinns_moon",
        name: "Jinns Moon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jo_blitz": {
        slug: "jo_blitz",
        name: "Jo Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/joker_hot_reels": {
        slug: "joker_hot_reels",
        name: "Joker Hot Reels",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/joker_rush": {
        slug: "joker_rush",
        name: "Joker Rush",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/joker_rush_cash_collect": {
        slug: "joker_rush_cash_collect",
        name: "Joker Rush: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/joker_spin_and_roll": {
        slug: "joker_spin_and_roll",
        name: "Joker Spin & Roll",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jungle_giants": {
        slug: "jungle_giants",
        name: "Jungle Giants",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/jurassic_island_ii": {
        slug: "jurassic_island_ii",
        name: "Jurassic Island II",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ka_ching_boom": {
        slug: "ka_ching_boom",
        name: "Ka Ching Boom",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/kick_it_multiplayer": {
        slug: "kick_it_multiplayer",
        name: "Kick It Multiplayer",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/king_blitz": {
        slug: "king_blitz",
        name: "King Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/king_of_giza_mega_cash_collect_and_link": {
        slug: "king_of_giza_mega_cash_collect_and_link",
        name: "King of Giza Mega Cash Collect and Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/king_of_olympus": {
        slug: "king_of_olympus",
        name: "King of Olympus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/king_richwin": {
        slug: "king_richwin",
        name: "King Richwin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/kiss_me_clover": {
        slug: "kiss_me_clover",
        name: "Kiss Me Clover",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/kitty_payout": {
        slug: "kitty_payout",
        name: "Kitty Payout",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/koi_harmony": {
        slug: "koi_harmony",
        name: "Koi Harmony",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/kraken_spins": {
        slug: "kraken_spins",
        name: "Kraken Spins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ladderz": {
        slug: "ladderz",
        name: "Ladderz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lady_phoenix": {
        slug: "lady_phoenix",
        name: "Lady Phoenix",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/legacy_of_the_wild": {
        slug: "legacy_of_the_wild",
        name: "Legacy Of The Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/legacy_of_the_wild_2": {
        slug: "legacy_of_the_wild_2",
        name: "Legacy of the Wild 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/leprechauns_luck_cash_collect": {
        slug: "leprechauns_luck_cash_collect",
        name: "Leprechaun's Luck: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/leprechauns_luck_cash_collect_megaways": {
        slug: "leprechauns_luck_cash_collect_megaways",
        name: "Leprechaun’s Luck: Cash Collect: MegaWays",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/leprechauns_luck_mega_cash_collect_a1": {
        slug: "leprechauns_luck_mega_cash_collect_a1",
        name: "Leprechaun's Luck: Mega Cash Collect A1",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lie_yan_zuan_shi": {
        slug: "lie_yan_zuan_shi",
        name: "Lie Yan Zuan Shi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lights_of_luck": {
        slug: "lights_of_luck",
        name: "Lights of Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_demo_double_heat": {
        slug: "lil_demo_double_heat",
        name: "Lil Demo Double Heat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_demon_blazing_lava": {
        slug: "lil_demon_blazing_lava",
        name: "Lil Demon: Blazing Lava",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_demon_clickawin": {
        slug: "lil_demon_clickawin",
        name: "Lil Demon: Click-A-Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_demon_mega_cash_collect": {
        slug: "lil_demon_mega_cash_collect",
        name: "Lil Demon: Mega Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_greedy": {
        slug: "lil_greedy",
        name: "Lil Greedy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lil_sphinx": {
        slug: "lil_sphinx",
        name: "Lil Sphinx",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lion_mania": {
        slug: "lion_mania",
        name: "Lion Mania",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lock_and_hit_red_knight": {
        slug: "lock_and_hit_red_knight",
        name: "Lock & Hit: Red Knight",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lockdown_loot": {
        slug: "lockdown_loot",
        name: "Lockdown Loot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/loco_habanero": {
        slug: "loco_habanero",
        name: "Loco Habanero",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/long_jia_xiang_yun": {
        slug: "long_jia_xiang_yun",
        name: "Long Jia Xiang Yun",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/long_long_long": {
        slug: "long_long_long",
        name: "Long Long Long",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lost_island": {
        slug: "lost_island",
        name: "Lost Island",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lotto_madness": {
        slug: "lotto_madness",
        name: "Lotto Madness",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lovefool": {
        slug: "lovefool",
        name: "Lovefool",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lucha_rumble": {
        slug: "lucha_rumble",
        name: "Lucha Rumble",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lucky_bass_mega_cash_collect": {
        slug: "lucky_bass_mega_cash_collect",
        name: "Lucky Bass: Mega Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lucky_emeralds": {
        slug: "lucky_emeralds",
        name: "Lucky Emeralds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lucky_gift_cash_collect": {
        slug: "lucky_gift_cash_collect",
        name: "Lucky Gift: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/luminous_life": {
        slug: "luminous_life",
        name: "Luminous Life",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lunar_link_nile_moon": {
        slug: "lunar_link_nile_moon",
        name: "Lunar Link: Nile Moon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lunar_link_phoenix_moons": {
        slug: "lunar_link_phoenix_moons",
        name: "Lunar Link: Phoenix Moons",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lunar_link_sky_king": {
        slug: "lunar_link_sky_king",
        name: "Lunar Link: Sky King",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/lunar_link_the_legend_of_king_arthur": {
        slug: "lunar_link_the_legend_of_king_arthur",
        name: "Lunar Link: The Legend of King Arthur",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/macabra_linx": {
        slug: "macabra_linx",
        name: "Macabra LinX",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/macau_beauties": {
        slug: "macau_beauties",
        name: "Macau Beauties",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_bearhaus": {
        slug: "mad_hit_bearhaus",
        name: "Mad Hit Bearhaus",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_devil": {
        slug: "mad_hit_devil",
        name: "Mad Hit Devil",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_diamonds": {
        slug: "mad_hit_diamonds",
        name: "Mad Hit Diamonds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_diamonds_deluxe": {
        slug: "mad_hit_diamonds_deluxe",
        name: "Mad Hit Diamonds Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_easter_eggsplosion": {
        slug: "mad_hit_easter_eggsplosion",
        name: "Mad Hit Easter Eggsplosion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_full_steam": {
        slug: "mad_hit_full_steam",
        name: "Mad Hit Full Steam",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_gold": {
        slug: "mad_hit_gold",
        name: "Mad Hit Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_gorillatron": {
        slug: "mad_hit_gorillatron",
        name: "Mad Hit Gorillatron",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_hidden_cities": {
        slug: "mad_hit_hidden_cities",
        name: "Mad Hit Hidden Cities",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_ho_ho_hot_pudding": {
        slug: "mad_hit_ho_ho_hot_pudding",
        name: "Mad Hit Ho Ho Hot Pudding",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_jokester": {
        slug: "mad_hit_jokester",
        name: "Mad Hit Jokester",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_marlin_bonanza": {
        slug: "mad_hit_marlin_bonanza",
        name: "Mad Hit Marlin Bonanza",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_mr_coin": {
        slug: "mad_hit_mr_coin",
        name: "Mad Hit Mr Coin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_oasis": {
        slug: "mad_hit_oasis",
        name: "Mad Hit Oasis",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_savannah": {
        slug: "mad_hit_savannah",
        name: "Mad Hit Savannah",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_slippery_soap": {
        slug: "mad_hit_slippery_soap",
        name: "Mad Hit Slippery Soap",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_supernova": {
        slug: "mad_hit_supernova",
        name: "Mad Hit Supernova",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_vegas": {
        slug: "mad_hit_vegas",
        name: "Mad Hit Vegas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mad_hit_wild_alice": {
        slug: "mad_hit_wild_alice",
        name: "Mad Hit Wild Alice",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/madame_luck": {
        slug: "madame_luck",
        name: "Madame Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/magical_stacks": {
        slug: "magical_stacks",
        name: "Magical Stacks",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mahjong_magic": {
        slug: "mahjong_magic",
        name: "Mahjong Magic",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/match_blitz_scatter_shock": {
        slug: "match_blitz_scatter_shock",
        name: "Match Blitz Scatter Shock",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mayan_blaze": {
        slug: "mayan_blaze",
        name: "Mayan Blaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mayan_blocks": {
        slug: "mayan_blocks",
        name: "Mayan Blocks",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mayan_cache": {
        slug: "mayan_cache",
        name: "Mayan Cache",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/medusa_money": {
        slug: "medusa_money",
        name: "Medusa Money",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_3_wizards": {
        slug: "mega_fire_blaze_3_wizards",
        name: "Mega Fire Blaze: 3 Wizards",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_big_circus": {
        slug: "mega_fire_blaze_big_circus",
        name: "Mega Fire Blaze: Big Circus!",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_dwarves_and_goblins": {
        slug: "mega_fire_blaze_dwarves_and_goblins",
        name: "Mega Fire Blaze: Dwarves and Goblins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_emperor_of_rome": {
        slug: "mega_fire_blaze_emperor_of_rome",
        name: "Mega Fire Blaze: Emperor of Rome",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_khonsu_god_of_moon": {
        slug: "mega_fire_blaze_khonsu_god_of_moon",
        name: "Mega Fire Blaze: Khonsu God of Moon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_legacy_of_the_tiger": {
        slug: "mega_fire_blaze_legacy_of_the_tiger",
        name: "Mega Fire Blaze : Legacy of the Tiger",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_lucky_bass": {
        slug: "mega_fire_blaze_lucky_bass",
        name: "Mega Fire Blaze Lucky Bass",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_piggies_and_the_bank": {
        slug: "mega_fire_blaze_piggies_and_the_bank",
        name: "Mega Fire Blaze: Piggies and the Bank",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_piggies_and_the_bank_powerplay_jackpot": {
        slug: "mega_fire_blaze_piggies_and_the_bank_powerplay_jackpot",
        name: "Mega Fire Blaze: Piggies and the Bank PowerPlay Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_plinko": {
        slug: "mega_fire_blaze_plinko",
        name: "Mega Fire Blaze: Plinko",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_roulette": {
        slug: "mega_fire_blaze_roulette",
        name: "Mega Fire Blaze Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_the_khan": {
        slug: "mega_fire_blaze_the_khan",
        name: "Mega Fire Blaze: The Khan",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mega_fire_blaze_wild_pistolero": {
        slug: "mega_fire_blaze_wild_pistolero",
        name: "Mega Fire Blaze: Wild Pistolero",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/metal_reel": {
        slug: "metal_reel",
        name: "Metal Reel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/midnight_wilds": {
        slug: "midnight_wilds",
        name: "Midnight Wilds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mighty_hat_lamp_of_gold_l": {
        slug: "mighty_hat_lamp_of_gold_l",
        name: "Mighty Hat : Lamp of Gold L",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mine_and_melt": {
        slug: "mine_and_melt",
        name: "Mine & Melt",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/minealicious": {
        slug: "minealicious",
        name: "Mine-a-Licious",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mini_roulette": {
        slug: "mini_roulette",
        name: "Mini Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/miss_fortune": {
        slug: "miss_fortune",
        name: "Miss Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mobile_blackjack": {
        slug: "mobile_blackjack",
        name: "Mobile Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/monkey_and_rat": {
        slug: "monkey_and_rat",
        name: "Monkey and Rat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/monkey_mania": {
        slug: "monkey_mania",
        name: "Monkey Mania",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/monkey_mania_2": {
        slug: "monkey_mania_2",
        name: "Monkey Mania 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/monster_multipliers": {
        slug: "monster_multipliers",
        name: "Monster Multipliers",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/moo_moo_moo": {
        slug: "moo_moo_moo",
        name: "Moo Moo Moo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/more_dragon_ladies": {
        slug: "more_dragon_ladies",
        name: "More Dragon Ladies",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mrcashback": {
        slug: "mrcashback",
        name: "Mr.Cashback",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mucho_loco_habanero": {
        slug: "mucho_loco_habanero",
        name: "Mucho Loco Habanero",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/mystic_mines": {
        slug: "mystic_mines",
        name: "Mystic Mines",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/native_spirit": {
        slug: "native_spirit",
        name: "Native Spirit",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/neptunes_kingdom": {
        slug: "neptunes_kingdom",
        name: "Neptunes Kingdom",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/new_year_happiness": {
        slug: "new_year_happiness",
        name: "New Year Happiness",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/new_year_rising": {
        slug: "new_year_rising",
        name: "New Year Rising",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ni_shu_shen_me": {
        slug: "ni_shu_shen_me",
        name: "Ni Shu Shen Me",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/nian_nian_you_yu": {
        slug: "nian_nian_you_yu",
        name: "Nian Nian You Yu",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ocean_frenzy": {
        slug: "ocean_frenzy",
        name: "Ocean Frenzy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/oink_oink_oink": {
        slug: "oink_oink_oink",
        name: "Oink Oink Oink",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/oink_oink_oink_astrosnouts": {
        slug: "oink_oink_oink_astrosnouts",
        name: "Oink Oink Oink: Astrosnouts",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/oink_oink_oink_pharaohs": {
        slug: "oink_oink_oink_pharaohs",
        name: "Oink Oink Oink Pharaohs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/olympus_explosion": {
        slug: "olympus_explosion",
        name: "Olympus Explosion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/orianas_orbs": {
        slug: "orianas_orbs",
        name: "Oriana's Orbs",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ox_riches": {
        slug: "ox_riches",
        name: "Ox Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/panda_blitz": {
        slug: "panda_blitz",
        name: "Panda Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/panda_luck": {
        slug: "panda_luck",
        name: "Panda Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/panther_moon": {
        slug: "panther_moon",
        name: "Panther Moon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/panther_moon_bonus_lines": {
        slug: "panther_moon_bonus_lines",
        name: "Panther Moon: Bonus Lines",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/panther_pays": {
        slug: "panther_pays",
        name: "Panther Pays",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/past_the_post": {
        slug: "past_the_post",
        name: "Past The Post",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pearl_coin_rise": {
        slug: "pearl_coin_rise",
        name: "Pearl Coin Rise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pearl_o_plinko_fire_and_bones": {
        slug: "pearl_o_plinko_fire_and_bones",
        name: "Pearl o' Plinko - Fire & Bones",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pearl_o_plinko_mermaid_cove": {
        slug: "pearl_o_plinko_mermaid_cove",
        name: "Pearl O' Plinko Mermaid Cove",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/penguin_vacation": {
        slug: "penguin_vacation",
        name: "Penguin Vacation",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/perfect_blackjack": {
        slug: "perfect_blackjack",
        name: "Perfect Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pharaohs_daughter": {
        slug: "pharaohs_daughter",
        name: "Pharaohs Daughter ",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pharaohs_secrets": {
        slug: "pharaohs_secrets",
        name: "Pharaoh's Secrets",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pharaohs_treasure_deluxe": {
        slug: "pharaohs_treasure_deluxe",
        name: "Pharaoh's Treasure Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/phoenix_heat": {
        slug: "phoenix_heat",
        name: "Phoenix Heat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pigeons_from_space_a1": {
        slug: "pigeons_from_space_a1",
        name: "Pigeons From Space! A1",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggies_and_the_bank_cash_collect_and_link": {
        slug: "piggies_and_the_bank_cash_collect_and_link",
        name: "Piggies and the Bank: Cash Collect and Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggies_and_the_bank_click_a_win": {
        slug: "piggies_and_the_bank_click_a_win",
        name: "Piggies and the Bank: Click A Win",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggies_and_the_wolf": {
        slug: "piggies_and_the_wolf",
        name: "Piggies and the Wolf",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggy_gold": {
        slug: "piggy_gold",
        name: "Piggy Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggy_mania": {
        slug: "piggy_mania",
        name: "Piggy Mania",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/piggy_payout": {
        slug: "piggy_payout",
        name: "Piggy Payout",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pigs_feast": {
        slug: "pigs_feast",
        name: "Pigs Feast",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pirates_booty": {
        slug: "pirates_booty",
        name: "Pirates Booty",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pixel_samurai": {
        slug: "pixel_samurai",
        name: "Pixel Samurai",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/plenty_ofortune": {
        slug: "plenty_ofortune",
        name: "Plenty O'Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/power_zones_ishtar": {
        slug: "power_zones_ishtar",
        name: "Power Zones: Ishtar",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/power_zones_pyramid_valley": {
        slug: "power_zones_pyramid_valley",
        name: "Power Zones: Pyramid Valley",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/power_zones_thunder_birds": {
        slug: "power_zones_thunder_birds",
        name: "Power Zones: Thunder Birds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/powerzones_legend_of_hydra": {
        slug: "powerzones_legend_of_hydra",
        name: "PowerZones: Legend of Hydra",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/premium_american_roulette": {
        slug: "premium_american_roulette",
        name: "Premium American Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/premium_baccarat": {
        slug: "premium_baccarat",
        name: "Premium Baccarat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/premium_blackjack": {
        slug: "premium_blackjack",
        name: "Premium Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/premium_european_roulette": {
        slug: "premium_european_roulette",
        name: "Premium (European) Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pride_of_persia_empire_treasures": {
        slug: "pride_of_persia_empire_treasures",
        name: "Pride of Persia: Empire Treasures",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/primal_spirits": {
        slug: "primal_spirits",
        name: "Primal Spirits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/prince_of_riches": {
        slug: "prince_of_riches",
        name: "Prince of Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/prosperity_journey": {
        slug: "prosperity_journey",
        name: "Prosperity Journey",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/puggy_payout": {
        slug: "puggy_payout",
        name: "Puggy Payout",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/pyramid_linx_l": {
        slug: "pyramid_linx_l",
        name: "Pyramid LinX L",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/qins_empire_caishens_temple": {
        slug: "qins_empire_caishens_temple",
        name: "Qin's Empire : Caishen's Temple",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/quantum_roulette_instant_play": {
        slug: "quantum_roulette_instant_play",
        name: "Quantum Roulette Instant Play",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/queen_of_the_pyramids_mega_cash_collect": {
        slug: "queen_of_the_pyramids_mega_cash_collect",
        name: "Queen Of The Pyramids: Mega Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/queen_of_wands": {
        slug: "queen_of_wands",
        name: "Queen Of Wands",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/queens_mystery": {
        slug: "queens_mystery",
        name: "Queen's Mystery",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/quest_of_gods": {
        slug: "quest_of_gods",
        name: "Quest Of Gods",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/quest_west": {
        slug: "quest_west",
        name: "Quest West",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rabbit_and_the_fox": {
        slug: "rabbit_and_the_fox",
        name: "Rabbit and the Fox",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/raven_rising": {
        slug: "raven_rising",
        name: "Raven Rising",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/reaction_link": {
        slug: "reaction_link",
        name: "Reaction Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ready_steady_robo": {
        slug: "ready_steady_robo",
        name: "Ready, Steady, Robo",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ready_to_blow_thundershots": {
        slug: "ready_to_blow_thundershots",
        name: "Ready To Blow Thundershots",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rebets_splendour": {
        slug: "rebets_splendour",
        name: "Rebets Splendour",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/record_riches": {
        slug: "record_riches",
        name: "Record Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/red_wizard_bank_it_up": {
        slug: "red_wizard_bank_it_up",
        name: "Red Wizard: Bank It Up",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/reel_allstars": {
        slug: "reel_allstars",
        name: "Reel All-Stars",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/respin_mania_wu_shi_jackpot": {
        slug: "respin_mania_wu_shi_jackpot",
        name: "Respin Mania Wu Shi Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/retro_rush": {
        slug: "retro_rush",
        name: "Retro Rush",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rhino_blitz": {
        slug: "rhino_blitz",
        name: "Rhino Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ri_ri_jin_cai": {
        slug: "ri_ri_jin_cai",
        name: "Ri Ri Jin Cai",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rich_roll_lust_for_gold": {
        slug: "rich_roll_lust_for_gold",
        name: "Rich Roll: Lust for Gold!",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rio_pleasure": {
        slug: "rio_pleasure",
        name: "Rio Pleasure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/riverboat_reel": {
        slug: "riverboat_reel",
        name: "Riverboat Reel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/robbits": {
        slug: "robbits",
        name: "Robbits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rockin_gorilla": {
        slug: "rockin_gorilla",
        name: "Rockin' Gorilla",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rogues_draw": {
        slug: "rogues_draw",
        name: "Rogues Draw",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/roleta_canarinho": {
        slug: "roleta_canarinho",
        name: "Roleta Canarinho",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/roman_fruits": {
        slug: "roman_fruits",
        name: "Roman Fruits",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/roman_legend": {
        slug: "roman_legend",
        name: "Roman Legend",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rome_and_glory": {
        slug: "rome_and_glory",
        name: "Rome and Glory",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/roving_clover": {
        slug: "roving_clover",
        name: "Roving Clover",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/royal_griffin": {
        slug: "royal_griffin",
        name: "Royal Griffin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rulers_of_the_world_empire_treasures": {
        slug: "rulers_of_the_world_empire_treasures",
        name: "Rulers of the World: Empire Treasures",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rush_fever_7s": {
        slug: "rush_fever_7s",
        name: "Rush Fever 7s",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rush_fever_7s_deluxe": {
        slug: "rush_fever_7s_deluxe",
        name: "Rush Fever 7s Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rush_fever_catchem_all": {
        slug: "rush_fever_catchem_all",
        name: "Rush Fever Catch'em All",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/rush_fever_soda_pop": {
        slug: "rush_fever_soda_pop",
        name: "Rush Fever Soda Pop",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/safari_heat": {
        slug: "safari_heat",
        name: "Safari Heat",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sahara_riches_cash_collect": {
        slug: "sahara_riches_cash_collect",
        name: "Sahara Riches: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sahara_riches_cash_collect_mix": {
        slug: "sahara_riches_cash_collect_mix",
        name: "Sahara Riches Cash Collect Mix",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sahara_riches_megaways_cash_collect": {
        slug: "sahara_riches_megaways_cash_collect",
        name: "Sahara Riches MegaWays: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sakura_fortune": {
        slug: "sakura_fortune",
        name: "Sakura Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sakura_fortune_2": {
        slug: "sakura_fortune_2",
        name: "Sakura Fortune 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sakura_fortune_epic_bloom": {
        slug: "sakura_fortune_epic_bloom",
        name: "Sakura Fortune Epic Bloom",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/samurai_fury": {
        slug: "samurai_fury",
        name: "Samurai Fury",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/santa_surprise": {
        slug: "santa_surprise",
        name: "Santa Surprise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/savage_jungle": {
        slug: "savage_jungle",
        name: "Savage Jungle",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/savage_lion": {
        slug: "savage_lion",
        name: "Savage Lion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/savannah_cash": {
        slug: "savannah_cash",
        name: "Savannah Cash",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/savannah_fortune": {
        slug: "savannah_fortune",
        name: "Savannah Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/scatter_monsters": {
        slug: "scatter_monsters",
        name: "Scatter Monsters",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/scepter_of_anubis": {
        slug: "scepter_of_anubis",
        name: "Scepter of Anubis",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/secret_garden": {
        slug: "secret_garden",
        name: "Secret Garden",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/secrets_of_the_amazon": {
        slug: "secrets_of_the_amazon",
        name: "Secrets of the Amazon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shake_shake_christmas": {
        slug: "shake_shake_christmas",
        name: "Shake Shake Christmas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shake_shake_leprechaun": {
        slug: "shake_shake_leprechaun",
        name: "Shake Shake Leprechaun",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shake_shake_money_tree": {
        slug: "shake_shake_money_tree",
        name: "Shake Shake Money Tree",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shamans_dream_2": {
        slug: "shamans_dream_2",
        name: "Shamans Dream 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shark_blitz": {
        slug: "shark_blitz",
        name: "Shark Blitz",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sheerluck": {
        slug: "sheerluck",
        name: "SheerLuck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shields_of_lambda": {
        slug: "shields_of_lambda",
        name: "Shields of Lambda",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/shopping_spree": {
        slug: "shopping_spree",
        name: "Shopping Spree",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/si_ling": {
        slug: "si_ling",
        name: "Si Ling",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/si_xiang": {
        slug: "si_xiang",
        name: "Si Xiang",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/silent_samurai": {
        slug: "silent_samurai",
        name: "Silent Samurai",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/silent_samurai_mega_cash_collect": {
        slug: "silent_samurai_mega_cash_collect",
        name: "Silent Samurai: Mega Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/silver_and_gold_mine": {
        slug: "silver_and_gold_mine",
        name: "Silver & Gold Mine",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/silver_bullet": {
        slug: "silver_bullet",
        name: "Silver Bullet",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/silver_bullet_bandit_cash_collect": {
        slug: "silver_bullet_bandit_cash_collect",
        name: "Silver Bullet Bandit: Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sinbads_golden_voyage": {
        slug: "sinbads_golden_voyage",
        name: "Sinbad's Golden Voyage",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/skullapalooza": {
        slug: "skullapalooza",
        name: "Skullapalooza",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sky_queen": {
        slug: "sky_queen",
        name: "Sky Queen",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/solar_eclipse_desert_treasure": {
        slug: "solar_eclipse_desert_treasure",
        name: "Solar Eclipse: Desert Treasure",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/solar_eclipse_jaguars_lair": {
        slug: "solar_eclipse_jaguars_lair",
        name: "Solar Eclipse: Jaguar's Lair",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/solar_eclipse_northern_winds": {
        slug: "solar_eclipse_northern_winds",
        name: "Solar Eclipse: Northern Winds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/songkran_the_launch_date_is_postponed_until_further_notice": {
        slug: "songkran_the_launch_date_is_postponed_until_further_notice",
        name: "Songkran (The launch date is postponed until further notice)",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sorcerers_guild_of_magic": {
        slug: "sorcerers_guild_of_magic",
        name: "Sorcerer's Guild of Magic",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/spin_em_round": {
        slug: "spin_em_round",
        name: "Spin 'Em Round!",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/spinions_game_day": {
        slug: "spinions_game_day",
        name: "Spinions Game Day",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/spread_bet_roulette": {
        slug: "spread_bet_roulette",
        name: "Spread Bet Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stallion_strike": {
        slug: "stallion_strike",
        name: "Stallion Strike",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stampede": {
        slug: "stampede",
        name: "Stampede",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stampede_call_of_the_pride": {
        slug: "stampede_call_of_the_pride",
        name: "Stampede Call of the Pride",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stampede_rush_speedy_santa": {
        slug: "stampede_rush_speedy_santa",
        name: "Stampede Rush Speedy Santa",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stampede_rush_trident": {
        slug: "stampede_rush_trident",
        name: "Stampede Rush Trident",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stampede_rush_wicked": {
        slug: "stampede_rush_wicked",
        name: "Stampede Rush Wicked",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/starmada_exiles": {
        slug: "starmada_exiles",
        name: "Starmada Exiles",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/stepback_7s": {
        slug: "stepback_7s",
        name: "Stepback 7s",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sticky_bandits_thunder_rail": {
        slug: "sticky_bandits_thunder_rail",
        name: "Sticky Bandits Thunder Rail",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sticky_bandits_trail_of_blood": {
        slug: "sticky_bandits_trail_of_blood",
        name: "Sticky Bandits Trail of Blood",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sticky_bandits_unchained": {
        slug: "sticky_bandits_unchained",
        name: "Sticky Bandits Unchained",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/streak_of_luck": {
        slug: "streak_of_luck",
        name: "Streak of Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/streak_of_luck_double_dice": {
        slug: "streak_of_luck_double_dice",
        name: "Streak of Luck: Double Dice",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/striker_goes_wild": {
        slug: "striker_goes_wild",
        name: "Striker Goes Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sugar_rush_fever": {
        slug: "sugar_rush_fever",
        name: "Sugar Rush Fever",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sun_of_ra": {
        slug: "sun_of_ra",
        name: "Sun of Ra",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/super_lion": {
        slug: "super_lion",
        name: "Super Lion",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/super_roulette": {
        slug: "super_roulette",
        name: "Super Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/super_stepper": {
        slug: "super_stepper",
        name: "Super Stepper",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sweet_n_juicy": {
        slug: "sweet_n_juicy",
        name: "Sweet N Juicy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/sweet_party": {
        slug: "sweet_party",
        name: "Sweet Party",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/temple_of_iris_2": {
        slug: "temple_of_iris_2",
        name: "Temple of Iris 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/temple_of_paw": {
        slug: "temple_of_paw",
        name: "Temple of Paw",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ten_ton_ways_luck": {
        slug: "ten_ton_ways_luck",
        name: "Ten Ton Ways Luck",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ten_ton_ways_odins_gifts": {
        slug: "ten_ton_ways_odins_gifts",
        name: "Ten Ton Ways Odin's Gifts",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ten_ton_ways_stampede": {
        slug: "ten_ton_ways_stampede",
        name: "Ten Ton Ways Stampede",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/thai_paradise": {
        slug: "thai_paradise",
        name: "Thai Paradise",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_great_genie": {
        slug: "the_great_genie",
        name: "The Great Genie",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_grim_reaper": {
        slug: "the_grim_reaper",
        name: "The Grim Reaper",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_jokeress": {
        slug: "the_jokeress",
        name: "The Jokeress",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_queens_curse_empire_treasures": {
        slug: "the_queens_curse_empire_treasures",
        name: "The Queen's Curse: Empire Treasures",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_racaroon": {
        slug: "the_racaroon",
        name: "The Racaroon",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_racaroon_2": {
        slug: "the_racaroon_2",
        name: "The Racaroon 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_racaroon_2_jackpot": {
        slug: "the_racaroon_2_jackpot",
        name: "The Racaroon 2 Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/the_riches_of_don_quixote": {
        slug: "the_riches_of_don_quixote",
        name: "The Riches of Don Quixote",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tiger_claw": {
        slug: "tiger_claw",
        name: "Tiger Claw",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tiger_stacks": {
        slug: "tiger_stacks",
        name: "Tiger Stacks",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tiger_turtle_dragon_phoenix": {
        slug: "tiger_turtle_dragon_phoenix",
        name: "Tiger Turtle Dragon Phoenix",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tiki_beats": {
        slug: "tiki_beats",
        name: "Tiki Beats",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tiki_blaze": {
        slug: "tiki_blaze",
        name: "Tiki Blaze",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tip_top_totems": {
        slug: "tip_top_totems",
        name: "Tip Top Totems",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/toads_gift": {
        slug: "toads_gift",
        name: "Toad's Gift",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/toucan_mania": {
        slug: "toucan_mania",
        name: "Toucan Mania",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/treasures_of_the_lamps": {
        slug: "treasures_of_the_lamps",
        name: "Treasures of the lamps",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tree_wishes": {
        slug: "tree_wishes",
        name: "Tree Wishes",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_meow_riches": {
        slug: "triple_meow_riches",
        name: "Triple Meow Riches",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_money_jackpot": {
        slug: "triple_money_jackpot",
        name: "Triple Money Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_money_jackpot_bells": {
        slug: "triple_money_jackpot_bells",
        name: "Triple Money Jackpot Bells",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_money_jackpot_gold": {
        slug: "triple_money_jackpot_gold",
        name: "Triple Money Jackpot Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_money_jackpot_spicy": {
        slug: "triple_money_jackpot_spicy",
        name: "Triple Money Jackpot Spicy",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_monkey": {
        slug: "triple_monkey",
        name: "Triple Monkey",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/triple_stop_mermaids_find": {
        slug: "triple_stop_mermaids_find",
        name: "Triple Stop: Mermaids Find",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/true_love": {
        slug: "true_love",
        name: "True Love",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/true_wild": {
        slug: "true_wild",
        name: "True Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/tsai_shens_gift": {
        slug: "tsai_shens_gift",
        name: "Tsai Shens Gift",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ugga_bugga": {
        slug: "ugga_bugga",
        name: "Ugga Bugga",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ultra_ace": {
        slug: "ultra_ace",
        name: "ULTRA ACE",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vacation_station": {
        slug: "vacation_station",
        name: "Vacation Station",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vacation_station_deluxe": {
        slug: "vacation_station_deluxe",
        name: "Vacation Station Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vegas_blackjack": {
        slug: "vegas_blackjack",
        name: "Vegas Blackjack",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vegas_hotties": {
        slug: "vegas_hotties",
        name: "Vegas Hotties",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vegas_no_limit_wins": {
        slug: "vegas_no_limit_wins",
        name: "Vegas No Limit Wins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vegas_repeat_wins": {
        slug: "vegas_repeat_wins",
        name: "Vegas Repeat Wins",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/veils_of_venice": {
        slug: "veils_of_venice",
        name: "Veils of Venice",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/very_merry_christmas": {
        slug: "very_merry_christmas",
        name: "Very Merry Christmas",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/viking_crusade": {
        slug: "viking_crusade",
        name: "Viking Crusade",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vikings_empire_treasures": {
        slug: "vikings_empire_treasures",
        name: "Vikings: Empire Treasures",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/virtual_cycling": {
        slug: "virtual_cycling",
        name: "Virtual! Cycling",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/virtual_dog_racing": {
        slug: "virtual_dog_racing",
        name: "Virtual! Dog Racing",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/virtual_horse_racing": {
        slug: "virtual_horse_racing",
        name: "Virtual! Horse Racing",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/virtual_horse_racing_usa": {
        slug: "virtual_horse_racing_usa",
        name: "Virtual! Horse Racing USA",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/virtual_trotting": {
        slug: "virtual_trotting",
        name: "Virtual! Trotting",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/vlads_castle": {
        slug: "vlads_castle",
        name: "Vlads Castle",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/volcano_rising": {
        slug: "volcano_rising",
        name: "Volcano Rising",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/voltage_blitz_egypt": {
        slug: "voltage_blitz_egypt",
        name: "Voltage Blitz Egypt",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/voltage_blitz_rapid": {
        slug: "voltage_blitz_rapid",
        name: "Voltage Blitz Rapid",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/voltage_blitz_vortex": {
        slug: "voltage_blitz_vortex",
        name: "Voltage Blitz Vortex",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/voltage_blitz_zeus_up": {
        slug: "voltage_blitz_zeus_up",
        name: "Voltage Blitz Zeus Up",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/warp_wreckers_power_glyph": {
        slug: "warp_wreckers_power_glyph",
        name: "Warp Wreckers Power Glyph",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/warriors_gold": {
        slug: "warriors_gold",
        name: "Warriors Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/water_reel": {
        slug: "water_reel",
        name: "Water Reel",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ways_of_the_phoenix": {
        slug: "ways_of_the_phoenix",
        name: "Ways of the Phoenix",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wheels_of_flame": {
        slug: "wheels_of_flame",
        name: "Wheels of Flame",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/white_king": {
        slug: "white_king",
        name: "White King",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/white_king_2": {
        slug: "white_king_2",
        name: "White King 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/white_wizard": {
        slug: "white_wizard",
        name: "White Wizard",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/white_wizard_deluxe": {
        slug: "white_wizard_deluxe",
        name: "White Wizard Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_beans": {
        slug: "wild_beans",
        name: "Wild Beans",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_crusade_empire_treasures": {
        slug: "wild_crusade_empire_treasures",
        name: "Wild Crusade: Empire Treasures",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_harlequin": {
        slug: "wild_harlequin",
        name: "Wild Harlequin",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_koi": {
        slug: "wild_koi",
        name: "Wild Koi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_lava": {
        slug: "wild_lava",
        name: "Wild Lava",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_lava_scratch": {
        slug: "wild_lava_scratch",
        name: "Wild Lava Scratch",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_linx": {
        slug: "wild_linx",
        name: "Wild LinX",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_roll": {
        slug: "wild_roll",
        name: "Wild Roll",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_thirst": {
        slug: "wild_thirst",
        name: "Wild Thirst",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wild_west_wilds": {
        slug: "wild_west_wilds",
        name: "Wild West Wilds",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wins_of_fortune": {
        slug: "wins_of_fortune",
        name: "Wins of Fortune",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/witchescash_collect": {
        slug: "witchescash_collect",
        name: "Witches:Cash Collect",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wizards_spell": {
        slug: "wizards_spell",
        name: "Wizard's Spell",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wizzy_trix": {
        slug: "wizzy_trix",
        name: "Wizzy Trix",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wolf_and_crown": {
        slug: "wolf_and_crown",
        name: "Wolf & Crown",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wolf_haven": {
        slug: "wolf_haven",
        name: "Wolf Haven",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wolves_cand_collect_and_link": {
        slug: "wolves_cand_collect_and_link",
        name: "Wolves Cand Collect and Link",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wonderland_lucky_ball": {
        slug: "wonderland_lucky_ball",
        name: "Wonderland Lucky Ball",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wu_long": {
        slug: "wu_long",
        name: "Wu Long",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/wushu_punch": {
        slug: "wushu_punch",
        name: "Wushu Punch",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/xingyun_baozhu": {
        slug: "xingyun_baozhu",
        name: "Xingyun BaoZhu",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/xmas_cash": {
        slug: "xmas_cash",
        name: "Xmas Cash",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/xtreme_fire_blaze_roulette": {
        slug: "xtreme_fire_blaze_roulette",
        name: "Xtreme Fire Blaze Roulette",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/xuan_pu_lian_huan": {
        slug: "xuan_pu_lian_huan",
        name: "Xuan Pu Lian Huan",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/ying_xiong_lu_bu": {
        slug: "ying_xiong_lu_bu",
        name: "Ying Xiong Lu Bu",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/yoyos_wild": {
        slug: "yoyos_wild",
        name: "YoYo's Wild",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/yu_tu_jin_cai_cash_collect_a1": {
        slug: "yu_tu_jin_cai_cash_collect_a1",
        name: "Yu Tu Jin Cai: Cash Collect A1",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/yun_cong_long": {
        slug: "yun_cong_long",
        name: "Yun Cong Long",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zapotec_gold": {
        slug: "zapotec_gold",
        name: "ZapOtec Gold",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zeus_rush_fever": {
        slug: "zeus_rush_fever",
        name: "Zeus Rush Fever",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zeus_rush_fever_deluxe": {
        slug: "zeus_rush_fever_deluxe",
        name: "Zeus Rush Fever Deluxe",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zhao_cai_jin_bao": {
        slug: "zhao_cai_jin_bao",
        name: "Zhao Cai Jin Bao",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zhao_cai_jin_bao_2": {
        slug: "zhao_cai_jin_bao_2",
        name: "Zhao Cai Jin Bao 2",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zhao_cai_jin_bao_jackpot": {
        slug: "zhao_cai_jin_bao_jackpot",
        name: "Zhao Cai Jin Bao Jackpot",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zhao_cai_tong_zi": {
        slug: "zhao_cai_tong_zi",
        name: "Zhao Cai Tong Zi",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playtech/zodiac_charms": {
        slug: "zodiac_charms",
        name: "Zodiac Charms",
        provider: "Playtech",
        providerSlug: "playtech"
    },
    "playzia/all_men_are_brothers": {
        slug: "all_men_are_brothers",
        name: "All Men are Brothers",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/american_party_riches": {
        slug: "american_party_riches",
        name: "American Party Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/aztec_prosperity": {
        slug: "aztec_prosperity",
        name: "Aztec Prosperity",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_bison": {
        slug: "billionaire_bison",
        name: "Billionaire Bison",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_rhino": {
        slug: "billionaire_rhino",
        name: "Billionaire Rhino",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/billionaire_wolf": {
        slug: "billionaire_wolf",
        name: "Billionaire Wolf",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/bills_buck_bonanza": {
        slug: "bills_buck_bonanza",
        name: "Bill's Buck Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/blazing_fruit_7s": {
        slug: "blazing_fruit_7s",
        name: "Blazing Fruit 7s",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/book_of_alexandria": {
        slug: "book_of_alexandria",
        name: "Book of Alexandria",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/caishens_coins": {
        slug: "caishens_coins",
        name: "Caishen’s Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/cosmos_cash": {
        slug: "cosmos_cash",
        name: "Cosmos Cash",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/crazy_chilli_party": {
        slug: "crazy_chilli_party",
        name: "Crazy Chilli Party",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/crystal_rush": {
        slug: "crystal_rush",
        name: "Crystal Rush",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/dwarves_treasure_race": {
        slug: "dwarves_treasure_race",
        name: "Dwarves Treasure Race",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fight_or_die_crew": {
        slug: "fight_or_die_crew",
        name: "Fight or Die Crew",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fire_horse_fortune": {
        slug: "fire_horse_fortune",
        name: "Fire Horse Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fortune_dragon_riches": {
        slug: "fortune_dragon_riches",
        name: "Fortune Dragon Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/freedom_frenzy": {
        slug: "freedom_frenzy",
        name: "Freedom Frenzy",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/fruity_fiesta": {
        slug: "fruity_fiesta",
        name: "Fruity Fiesta",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/goal_rush_deluxe": {
        slug: "goal_rush_deluxe",
        name: "Goal Rush Deluxe",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/grand_ocean_megaways": {
        slug: "grand_ocean_megaways",
        name: "Grand Ocean Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/greek_goddess_siege_of_olympus_megaways_94": {
        slug: "greek_goddess_siege_of_olympus_megaways_94",
        name: "Greek Goddess: Siege of Olympus Megaways 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/hot_spin_fiesta": {
        slug: "hot_spin_fiesta",
        name: "Hot Spin Fiesta",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/jokers_dice": {
        slug: "jokers_dice",
        name: "Joker’s Dice",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/knights_the_siege": {
        slug: "knights_the_siege",
        name: "Knights: The Siege",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/la_copa_grande": {
        slug: "la_copa_grande",
        name: "La Copa Grande",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/lollipop_loot": {
        slug: "lollipop_loot",
        name: "Lollipop Loot",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/love_island_hold_the_love": {
        slug: "love_island_hold_the_love",
        name: "Love Island Hold the Love",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/love_island_instant_match": {
        slug: "love_island_instant_match",
        name: "Love Island Instant Match",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/lucky_aces": {
        slug: "lucky_aces",
        name: "Lucky Aces",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/lucky_totems": {
        slug: "lucky_totems",
        name: "Lucky Totems",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/medusa_mystic_reels_megaways": {
        slug: "medusa_mystic_reels_megaways",
        name: "Medusa Mystic Reels Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/not_yet_another_irish_game": {
        slug: "not_yet_another_irish_game",
        name: "Not Yet Another Irish Game",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_coin_flip": {
        slug: "playzia_coin_flip",
        name: "Playzia Coin Flip",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_magic_7": {
        slug: "playzia_magic_7",
        name: "Playzia Magic 7",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_plinko": {
        slug: "playzia_plinko",
        name: "Playzia Plinko",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/playzia_wheel": {
        slug: "playzia_wheel",
        name: "Playzia Wheel",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/raiders_of_valhalla_megaways_94": {
        slug: "raiders_of_valhalla_megaways_94",
        name: "Raiders of Valhalla Megaways 94",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/raul_the_vampire": {
        slug: "raul_the_vampire",
        name: "Raul the Vampire",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/red_envelope_riches": {
        slug: "red_envelope_riches",
        name: "Red Envelope Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/safari_kingdom": {
        slug: "safari_kingdom",
        name: "Safari Kingdom",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/santas_reels": {
        slug: "santas_reels",
        name: "Santa’s Reels",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/sweet_candy_fortune": {
        slug: "sweet_candy_fortune",
        name: "Sweet Candy Fortune",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/sweet_candy_fortune_bonanza": {
        slug: "sweet_candy_fortune_bonanza",
        name: "Sweet Candy Fortune Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/tale_of_the_red_dragon": {
        slug: "tale_of_the_red_dragon",
        name: "Tale of The Red Dragon",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/the_great_fishing_adventure": {
        slug: "the_great_fishing_adventure",
        name: "The Great Fishing Adventure",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/the_great_fishing_adventure_bonanza": {
        slug: "the_great_fishing_adventure_bonanza",
        name: "The Great Fishing Adventure Bonanza",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/tomb_of_luxor": {
        slug: "tomb_of_luxor",
        name: "Tomb of Luxor",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/trans_santas_sack": {
        slug: "trans_santas_sack",
        name: "Trans Santa's Sack",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/trex_treasure_hunt_megaways": {
        slug: "trex_treasure_hunt_megaways",
        name: "T-Rex Treasure Hunt Megaways",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/velvet_riches": {
        slug: "velvet_riches",
        name: "Velvet Riches",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/volcanic_coins": {
        slug: "volcanic_coins",
        name: "Volcanic Coins",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/wanted_los_desesperados": {
        slug: "wanted_los_desesperados",
        name: "Wanted: Los Desesperados",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/wild_tigers_bounty": {
        slug: "wild_tigers_bounty",
        name: "Wild Tiger's Bounty",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/zeuss_thunderstrike": {
        slug: "zeuss_thunderstrike",
        name: "Zeus's Thunderstrike",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "playzia/zombie_the_apocalypse": {
        slug: "zombie_the_apocalypse",
        name: "Zombie the Apocalypse",
        provider: "Playzia",
        providerSlug: "playzia"
    },
    "popiplay/16_royal_coins": {
        slug: "16_royal_coins",
        name: "16 Royal Coins",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/3_orbs_of_zeus_hold_and_win": {
        slug: "3_orbs_of_zeus_hold_and_win",
        name: "3 Orbs of Zeus Hold and Win",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/3_pots_of_destiny": {
        slug: "3_pots_of_destiny",
        name: "3 Pots of Destiny",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/4_lucky_nuggets": {
        slug: "4_lucky_nuggets",
        name: "4 Lucky Nuggets",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/4_lucky_nuggets_pots_of_gold": {
        slug: "4_lucky_nuggets_pots_of_gold",
        name: "4 Lucky Nuggets Pots of Gold",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/amazon_city_of_gold": {
        slug: "amazon_city_of_gold",
        name: "Amazon City Of Gold",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/anaki_skywalkers": {
        slug: "anaki_skywalkers",
        name: "Anaki Skywalkers",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/angry_fruits_xpress": {
        slug: "angry_fruits_xpress",
        name: "Angry Fruits Xpress",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/area_69": {
        slug: "area_69",
        name: "Area 69",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/axe_max": {
        slug: "axe_max",
        name: "Axe Max",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/baba_jam": {
        slug: "baba_jam",
        name: "Baba Jam",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/bison_horizon_hold_and_win": {
        slug: "bison_horizon_hold_and_win",
        name: "Bison Horizon Hold and Win",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/blades_of_rome": {
        slug: "blades_of_rome",
        name: "Blades of Rome",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/blazing_coins_deluxe_hold_and_win": {
        slug: "blazing_coins_deluxe_hold_and_win",
        name: "Blazing Coins Deluxe: Hold and Win",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/bubbles": {
        slug: "bubbles",
        name: "Bubbles",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/cash_wash": {
        slug: "cash_wash",
        name: "Cash Wash",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/cipollino": {
        slug: "cipollino",
        name: "Cipollino",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/clover_castle": {
        slug: "clover_castle",
        name: "Clover Castle",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/creepy_ink": {
        slug: "creepy_ink",
        name: "Creepy Ink",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/cultist": {
        slug: "cultist",
        name: "Cultist",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/curse_of_echnaton": {
        slug: "curse_of_echnaton",
        name: "Curse of Echnaton",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/detective_donut": {
        slug: "detective_donut",
        name: "Detective Donut",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/detective_donut_kickback": {
        slug: "detective_donut_kickback",
        name: "Detective Donut Kickback",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/dirty_dates": {
        slug: "dirty_dates",
        name: "Dirty Dates",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/dogmasons": {
        slug: "dogmasons",
        name: "Dogmasons",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/dogmasons_megawoof": {
        slug: "dogmasons_megawoof",
        name: "Dogmasons MegaWOOF",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/double_diamond_night": {
        slug: "double_diamond_night",
        name: "Double Diamond Night",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/dream_diner": {
        slug: "dream_diner",
        name: "Dream Diner",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/emotions": {
        slug: "emotions",
        name: "Emotions",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/fish_and_cash": {
        slug: "fish_and_cash",
        name: "Fish And Cash",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/fish_and_cash_arctic": {
        slug: "fish_and_cash_arctic",
        name: "Fish And Cash Arctic",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/five_guys": {
        slug: "five_guys",
        name: "Five Guys",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/gamba_mamba": {
        slug: "gamba_mamba",
        name: "Gamba Mamba",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/gates_of_anubis": {
        slug: "gates_of_anubis",
        name: "Gates Of Anubis",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/goblin_cave": {
        slug: "goblin_cave",
        name: "Goblin Cave",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/guns_and_dragons": {
        slug: "guns_and_dragons",
        name: "Guns And Dragons",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/hanafuda": {
        slug: "hanafuda",
        name: "Hanafuda",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/junkrat_max": {
        slug: "junkrat_max",
        name: "Junkrat Max",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/keys_to_the_sea": {
        slug: "keys_to_the_sea",
        name: "Keys To The Sea",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/lime_time": {
        slug: "lime_time",
        name: "Lime Time",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/lokum_rush": {
        slug: "lokum_rush",
        name: "Lokum Rush",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/mad_labs": {
        slug: "mad_labs",
        name: "Mad Labs",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/master_of_lightning": {
        slug: "master_of_lightning",
        name: "Master of Lightning",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/maxzilla": {
        slug: "maxzilla",
        name: "Maxzilla",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/maya_relics": {
        slug: "maya_relics",
        name: "Maya Relics",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/money_mansion": {
        slug: "money_mansion",
        name: "Money Mansion",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/moneyfest": {
        slug: "moneyfest",
        name: "Moneyfest",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/moneyscript": {
        slug: "moneyscript",
        name: "Moneyscript",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/monster_getaway": {
        slug: "monster_getaway",
        name: "Monster Getaway",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/mummy_x_riches": {
        slug: "mummy_x_riches",
        name: "Mummy X Riches",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/mythos": {
        slug: "mythos",
        name: "Mythos",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/neon_fruits": {
        slug: "neon_fruits",
        name: "Neon Fruits",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/ninja_frog": {
        slug: "ninja_frog",
        name: "Ninja Frog",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/queen_of_the_nile": {
        slug: "queen_of_the_nile",
        name: "Queen of the Nile",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/raven_bjorn": {
        slug: "raven_bjorn",
        name: "Raven Bjorn",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/roxdogs": {
        slug: "roxdogs",
        name: "RoxDogs",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/ruby_royal": {
        slug: "ruby_royal",
        name: "Ruby Royal",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/slotham_city": {
        slug: "slotham_city",
        name: "Slotham City",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/sons_of_monarchy": {
        slug: "sons_of_monarchy",
        name: "Sons of Monarchy",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/spinguin": {
        slug: "spinguin",
        name: "Spinguin",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/store_wars": {
        slug: "store_wars",
        name: "Store Wars",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/sweet_punks": {
        slug: "sweet_punks",
        name: "Sweet Punks",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/tik_tak_toad": {
        slug: "tik_tak_toad",
        name: "Tik Tak Toad",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/tiki_trip": {
        slug: "tiki_trip",
        name: "Tiki Trip",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/traders_fortune": {
        slug: "traders_fortune",
        name: "Traders Fortune",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/ufo_joe": {
        slug: "ufo_joe",
        name: "UFO Joe",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/unipopcorn": {
        slug: "unipopcorn",
        name: "Unipopcorn",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/veracruz_wild": {
        slug: "veracruz_wild",
        name: "Veracruz Wild",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_piggy_bank": {
        slug: "wild_piggy_bank",
        name: "Wild Piggy Bank",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_wild_bank": {
        slug: "wild_wild_bank",
        name: "Wild Wild Bank",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_wild_duck": {
        slug: "wild_wild_duck",
        name: "Wild Wild Duck",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_wild_gold": {
        slug: "wild_wild_gold",
        name: "Wild Wild Gold",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_wild_steel": {
        slug: "wild_wild_steel",
        name: "Wild Wild Steel",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/wild_witches": {
        slug: "wild_witches",
        name: "Wild Witches",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/xmas_crash": {
        slug: "xmas_crash",
        name: "Xmas Crash",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/xperiment_gold": {
        slug: "xperiment_gold",
        name: "Xperiment Gold",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "popiplay/zoodiac": {
        slug: "zoodiac",
        name: "Zoodiac",
        provider: "Popiplay",
        providerSlug: "popiplay"
    },
    "pragmatic-play-live/24d_spin": {
        slug: "24d_spin",
        name: "24D Spin",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/amazing_baccarat": {
        slug: "amazing_baccarat",
        name: "Amazing Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/auto_mega_roulette": {
        slug: "auto_mega_roulette",
        name: "Auto Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/auto_roulette": {
        slug: "auto_roulette",
        name: "Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/baccarat_lobby": {
        slug: "baccarat_lobby",
        name: "Baccarat Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/big_small_baccarat": {
        slug: "big_small_baccarat",
        name: "Big Small Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack": {
        slug: "blackjack",
        name: "Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_azure": {
        slug: "blackjack_azure",
        name: "Blackjack Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_lobby": {
        slug: "blackjack_lobby",
        name: "Blackjack Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_x_azure": {
        slug: "blackjack_x_azure",
        name: "Blackjack X Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjack_x_ruby": {
        slug: "blackjack_x_ruby",
        name: "Blackjack X Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjackx": {
        slug: "blackjackx",
        name: "BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjackx_azure": {
        slug: "blackjackx_azure",
        name: "BlackjackX Azure",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjackx_emerald": {
        slug: "blackjackx_emerald",
        name: "BlackjackX Emerald",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/blackjackx_ruby": {
        slug: "blackjackx_ruby",
        name: "BlackjackX Ruby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_mega_roulette": {
        slug: "brazilian_mega_roulette",
        name: "Brazilian Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/brazilian_roulette": {
        slug: "brazilian_roulette",
        name: "Brazilian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/cantonese_speed_baccarat": {
        slug: "cantonese_speed_baccarat",
        name: "Cantonese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/chinese_speed_baccarat": {
        slug: "chinese_speed_baccarat",
        name: "Chinese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/color_game_bonanza": {
        slug: "color_game_bonanza",
        name: "Color Game Bonanza",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/crystal_roulette": {
        slug: "crystal_roulette",
        name: "Crystal Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dice_city": {
        slug: "dice_city",
        name: "Dice City",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dragon_tiger_lobby": {
        slug: "dragon_tiger_lobby",
        name: "Dragon Tiger Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dutch_one_blackjack": {
        slug: "dutch_one_blackjack",
        name: "Dutch ONE Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/dutch_roulette": {
        slug: "dutch_roulette",
        name: "Dutch Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/football_blitz_top_card": {
        slug: "football_blitz_top_card",
        name: "Football Blitz Top Card",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/fortune_baccarat": {
        slug: "fortune_baccarat",
        name: "Fortune Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/fortune_roulette": {
        slug: "fortune_roulette",
        name: "Fortune Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/gates_of_olympus_roulette": {
        slug: "gates_of_olympus_roulette",
        name: "Gates of Olympus Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/german_roulette": {
        slug: "german_roulette",
        name: "German Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/hilo_baccarat": {
        slug: "hilo_baccarat",
        name: "Hi-Lo Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/immersive_roulette_deluxe": {
        slug: "immersive_roulette_deluxe",
        name: "Immersive Roulette Deluxe",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesia_speed_baccarat": {
        slug: "indonesia_speed_baccarat",
        name: "Indonesia Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesian_blackjackx": {
        slug: "indonesian_blackjackx",
        name: "Indonesian BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/indonesian_speed_baccarat": {
        slug: "indonesian_speed_baccarat",
        name: "Indonesian Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/japanese_speed_baccarat": {
        slug: "japanese_speed_baccarat",
        name: "Japanese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_blackjackx": {
        slug: "korean_blackjackx",
        name: "Korean BlackjackX",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_roulette": {
        slug: "korean_roulette",
        name: "Korean Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/korean_speed_baccarat": {
        slug: "korean_speed_baccarat",
        name: "Korean Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/lucky_roulette": {
        slug: "lucky_roulette",
        name: "Lucky Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_baccarat": {
        slug: "mega_baccarat",
        name: "Mega Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_roulette": {
        slug: "mega_roulette",
        name: "Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_roulette_3000": {
        slug: "mega_roulette_3000",
        name: "Mega Roulette 3000",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_sic_bac": {
        slug: "mega_sic_bac",
        name: "Mega Sic Bac",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/mega_wheel": {
        slug: "mega_wheel",
        name: "Mega Wheel",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/money_time": {
        slug: "money_time",
        name: "Money Time",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/one_blackjack": {
        slug: "one_blackjack",
        name: "One Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/pay4d_speed_baccarat": {
        slug: "pay4d_speed_baccarat",
        name: "Pay4D Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/powerup_roulette": {
        slug: "powerup_roulette",
        name: "PowerUP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/prive_lounge_baccarat": {
        slug: "prive_lounge_baccarat",
        name: "Prive Lounge Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/prive_lounge_russian_poker": {
        slug: "prive_lounge_russian_poker",
        name: "Prive Lounge Russian Poker",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/romanian_roulette": {
        slug: "romanian_roulette",
        name: "Romanian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_italia_tricolore": {
        slug: "roulette_italia_tricolore",
        name: "Roulette Italia Tricolore",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_latina": {
        slug: "roulette_latina",
        name: "Roulette Latina",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_lobby": {
        slug: "roulette_lobby",
        name: "Roulette Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/roulette_macao": {
        slug: "roulette_macao",
        name: "Roulette Macao",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/russian_roulette": {
        slug: "russian_roulette",
        name: "Russian Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sic_bo": {
        slug: "sic_bo",
        name: "Sic Bo",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sic_bo_lobby": {
        slug: "sic_bo_lobby",
        name: "Sic Bo Lobby",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/snakes_and_ladders_live": {
        slug: "snakes_and_ladders_live",
        name: "Snakes and Ladders Live",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/spanish_roulette": {
        slug: "spanish_roulette",
        name: "Spanish Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_auto_roulette": {
        slug: "speed_auto_roulette",
        name: "Speed Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_baccarat": {
        slug: "speed_baccarat",
        name: "Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/speed_roulette": {
        slug: "speed_roulette",
        name: "Speed Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/super_baccarat": {
        slug: "super_baccarat",
        name: "Super Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/sweet_bonanza_candyland": {
        slug: "sweet_bonanza_candyland",
        name: "Sweet Bonanza Candyland",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/thai_baccarat": {
        slug: "thai_baccarat",
        name: "Thai Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/thai_speed_baccarat": {
        slug: "thai_speed_baccarat",
        name: "Thai Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/the_bingo_spot": {
        slug: "the_bingo_spot",
        name: "The Bingo Spot",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/treasure_island": {
        slug: "treasure_island",
        name: "Treasure Island",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_mega_roulette": {
        slug: "turkish_mega_roulette",
        name: "Turkish Mega Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_one_blackjack": {
        slug: "turkish_one_blackjack",
        name: "Turkish ONE Blackjack",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/turkish_roulette": {
        slug: "turkish_roulette",
        name: "Turkish Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vietnamese_speed_baccarat": {
        slug: "vietnamese_speed_baccarat",
        name: "Vietnamese Speed Baccarat",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_auto_roulette": {
        slug: "vip_auto_roulette",
        name: "VIP Auto Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_roulette": {
        slug: "vip_roulette",
        name: "VIP Roulette",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play-live/vip_roulette_the_club": {
        slug: "vip_roulette_the_club",
        name: "VIP Roulette The Club",
        provider: "Pragmatic Play Live",
        providerSlug: "pragmatic-play-live"
    },
    "pragmatic-play/3_buzzing_wilds": {
        slug: "3_buzzing_wilds",
        name: "3 Buzzing Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_dancing_monkeys": {
        slug: "3_dancing_monkeys",
        name: "3 Dancing Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_genie_wishes": {
        slug: "3_genie_wishes",
        name: "3 Genie Wishes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_kingdoms_battle_of_red_cliffs": {
        slug: "3_kingdoms_battle_of_red_cliffs",
        name: "3 Kingdoms Battle of Red Cliffs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/3_magic_eggs": {
        slug: "3_magic_eggs",
        name: "3 Magic Eggs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_frozen_charms_megaways": {
        slug: "5_frozen_charms_megaways",
        name: "5 Frozen Charms Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions": {
        slug: "5_lions",
        name: "5 Lions",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_dance": {
        slug: "5_lions_dance",
        name: "5 Lions Dance",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_gold": {
        slug: "5_lions_gold",
        name: "5 Lions Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_megaways": {
        slug: "5_lions_megaways",
        name: "5 Lions Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_lions_reborn": {
        slug: "5_lions_reborn",
        name: "5 Lions Reborn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/5_rabbits_megaways": {
        slug: "5_rabbits_megaways",
        name: "5 Rabbits Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/6_jokers": {
        slug: "6_jokers",
        name: "6 Jokers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_clovers_of_fortune": {
        slug: "7_clovers_of_fortune",
        name: "7 Clovers of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_monkeys": {
        slug: "7_monkeys",
        name: "7 Monkeys",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/7_piggies": {
        slug: "7_piggies",
        name: "7 Piggies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/777_wheel_blitz": {
        slug: "777_wheel_blitz",
        name: "777 Wheel Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/8_dragons": {
        slug: "8_dragons",
        name: "8 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/8_golden_dragon_challenge": {
        slug: "8_golden_dragon_challenge",
        name: "8 Golden Dragon Challenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/888_bonanza": {
        slug: "888_bonanza",
        name: "888 Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/888_dragons": {
        slug: "888_dragons",
        name: "888 Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/african_elephant": {
        slug: "african_elephant",
        name: "African Elephant",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aladdin_and_the_sorcerer": {
        slug: "aladdin_and_the_sorcerer",
        name: "Aladdin and the Sorcerer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/alien_invaders": {
        slug: "alien_invaders",
        name: "Alien Invaders",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/amazing_money_machine": {
        slug: "amazing_money_machine",
        name: "Amazing Money Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/american_blackjack": {
        slug: "american_blackjack",
        name: "American Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/american_roulette": {
        slug: "american_roulette",
        name: "American Roulette",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/anacoda_gold": {
        slug: "anacoda_gold",
        name: "Anacoda Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_egypt": {
        slug: "ancient_egypt",
        name: "Ancient Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_egypt_classic": {
        slug: "ancient_egypt_classic",
        name: "Ancient Egypt Classic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ancient_island_megaways": {
        slug: "ancient_island_megaways",
        name: "Ancient Island Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/angel_vs_sinner": {
        slug: "angel_vs_sinner",
        name: "Angel vs Sinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/anime_mecha_megaways": {
        slug: "anime_mecha_megaways",
        name: "Anime Mecha Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/argonauts": {
        slug: "argonauts",
        name: "Argonauts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/asgard": {
        slug: "asgard",
        name: "Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_blaze": {
        slug: "aztec_blaze",
        name: "Aztec Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_bonanza": {
        slug: "aztec_bonanza",
        name: "Aztec Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems": {
        slug: "aztec_gems",
        name: "Aztec Gems",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems_deluxe": {
        slug: "aztec_gems_deluxe",
        name: "Aztec Gems Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_gems_megaways": {
        slug: "aztec_gems_megaways",
        name: "Aztec Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_king": {
        slug: "aztec_king",
        name: "Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_king_megaways": {
        slug: "aztec_king_megaways",
        name: "Aztec King Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_powernudge": {
        slug: "aztec_powernudge",
        name: "Aztec Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_smash": {
        slug: "aztec_smash",
        name: "Aztec Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_treasure": {
        slug: "aztec_treasure",
        name: "Aztec Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/aztec_treasure_hunt": {
        slug: "aztec_treasure_hunt",
        name: "Aztec Treasure Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/baccarat": {
        slug: "baccarat",
        name: "Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/badge_blitz": {
        slug: "badge_blitz",
        name: "Badge Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bandit_megaways": {
        slug: "bandit_megaways",
        name: "Bandit Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/barn_festival": {
        slug: "barn_festival",
        name: "Barn Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/barnyard_megahays_megaways": {
        slug: "barnyard_megahays_megaways",
        name: "Barnyard Megahays Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bear_crazy": {
        slug: "bear_crazy",
        name: "Bear Crazy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bee_keeper": {
        slug: "bee_keeper",
        name: "Bee Keeper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bermuda_riches": {
        slug: "bermuda_riches",
        name: "Bermuda Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/better_barn_house_bonanza": {
        slug: "better_barn_house_bonanza",
        name: "Better Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/beware_the_deep_megaways": {
        slug: "beware_the_deep_megaways",
        name: "Beware The Deep Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_amazon_xtreme": {
        slug: "big_bass_amazon_xtreme",
        name: "Big Bass Amazon Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_blast": {
        slug: "big_bass_blast",
        name: "Big Bass Blast",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza": {
        slug: "big_bass_bonanza",
        name: "Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_1000": {
        slug: "big_bass_bonanza_1000",
        name: "Big Bass Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_3_reeler": {
        slug: "big_bass_bonanza_3_reeler",
        name: "Big Bass Bonanza 3 Reeler",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_keeping_it_reel": {
        slug: "big_bass_bonanza_keeping_it_reel",
        name: "Big Bass Bonanza Keeping it Reel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_megaways": {
        slug: "big_bass_bonanza_megaways",
        name: "Big Bass Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_bonanza_reel_action": {
        slug: "big_bass_bonanza_reel_action",
        name: "Big Bass Bonanza Reel Action",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_boxing_bonus_round": {
        slug: "big_bass_boxing_bonus_round",
        name: "Big Bass Boxing Bonus Round",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_christmas_bash": {
        slug: "big_bass_christmas_bash",
        name: "Big Bass Christmas Bash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_christmas_frozen_lake": {
        slug: "big_bass_christmas_frozen_lake",
        name: "Big Bass Christmas Frozen Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_crash": {
        slug: "big_bass_crash",
        name: "Big Bass Crash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_day_at_the_races": {
        slug: "big_bass_day_at_the_races",
        name: "Big Bass Day At The Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_floats_my_boat": {
        slug: "big_bass_floats_my_boat",
        name: "Big Bass Floats My Boat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_football_bonanza": {
        slug: "big_bass_football_bonanza",
        name: "Big Bass Football Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween": {
        slug: "big_bass_halloween",
        name: "Big Bass Halloween",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween_2": {
        slug: "big_bass_halloween_2",
        name: "Big Bass Halloween 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_halloween_3": {
        slug: "big_bass_halloween_3",
        name: "Big Bass Halloween 3",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_hold_and_spinner": {
        slug: "big_bass_hold_and_spinner",
        name: "Big Bass Hold and Spinner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_hold_and_spinner_megaways": {
        slug: "big_bass_hold_and_spinner_megaways",
        name: "Big Bass Hold and Spinner Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_mission_fishin": {
        slug: "big_bass_mission_fishin",
        name: "Big Bass Mission Fishin’",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_raceday_repeat": {
        slug: "big_bass_raceday_repeat",
        name: "Big Bass Raceday Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_reel_repeat": {
        slug: "big_bass_reel_repeat",
        name: "Big Bass Reel Repeat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_return_to_the_races": {
        slug: "big_bass_return_to_the_races",
        name: "Big Bass Return to the Races",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_secrets_of_the_golden_lake": {
        slug: "big_bass_secrets_of_the_golden_lake",
        name: "Big Bass Secrets of the Golden Lake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_splash": {
        slug: "big_bass_splash",
        name: "Big Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_splash_1000": {
        slug: "big_bass_splash_1000",
        name: "Big Bass Splash 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_trophy_catch": {
        slug: "big_bass_trophy_catch",
        name: "Big Bass Trophy Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_vegas_1000": {
        slug: "big_bass_vegas_1000",
        name: "Big Bass Vegas 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_vegas_double_down_deluxe": {
        slug: "big_bass_vegas_double_down_deluxe",
        name: "Big Bass Vegas Double Down Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_bass_xmas_xtreme": {
        slug: "big_bass_xmas_xtreme",
        name: "Big Bass Xmas Xtreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_burger_load_it_up_with_xtra_cheese": {
        slug: "big_burger_load_it_up_with_xtra_cheese",
        name: "Big Burger Load it up with Xtra cheese",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/big_juan": {
        slug: "big_juan",
        name: "Big Juan",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_barn_house_bonanza": {
        slug: "bigger_barn_house_bonanza",
        name: "Bigger Barn House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_blizzard_christmas_catch": {
        slug: "bigger_bass_blizzard_christmas_catch",
        name: "Bigger Bass Blizzard Christmas Catch",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_bonanza": {
        slug: "bigger_bass_bonanza",
        name: "Bigger Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bigger_bass_splash": {
        slug: "bigger_bass_splash",
        name: "Bigger Bass Splash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bingo_mania": {
        slug: "bingo_mania",
        name: "Bingo Mania",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/black_bull": {
        slug: "black_bull",
        name: "Black Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blade_and_fangs": {
        slug: "blade_and_fangs",
        name: "Blade and Fangs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blazing_wilds_megaways": {
        slug: "blazing_wilds_megaways",
        name: "Blazing Wilds Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/blitz_super_wheel": {
        slug: "blitz_super_wheel",
        name: "Blitz Super Wheel",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bloody_dawn": {
        slug: "bloody_dawn",
        name: "Bloody Dawn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bomb_bonanza": {
        slug: "bomb_bonanza",
        name: "Bomb Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bonanza_gold": {
        slug: "bonanza_gold",
        name: "Bonanza Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_aztec_king": {
        slug: "book_of_aztec_king",
        name: "Book of Aztec King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_golden_sands": {
        slug: "book_of_golden_sands",
        name: "Book of Golden Sands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_kingdoms": {
        slug: "book_of_kingdoms",
        name: "Book of Kingdoms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/book_of_monsters": {
        slug: "book_of_monsters",
        name: "Book of Monsters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bounty_gold": {
        slug: "bounty_gold",
        name: "Bounty Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bounty_hunter": {
        slug: "bounty_hunter",
        name: "Bounty Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bow_of_artemis": {
        slug: "bow_of_artemis",
        name: "Bow of Artemis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/brick_house_bonanza": {
        slug: "brick_house_bonanza",
        name: "Brick House Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bubble_pop": {
        slug: "bubble_pop",
        name: "Bubble Pop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bubble_up": {
        slug: "bubble_up",
        name: "Bubble Up!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king": {
        slug: "buffalo_king",
        name: "Buffalo King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king_megaways": {
        slug: "buffalo_king_megaways",
        name: "Buffalo King Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/buffalo_king_untamed_megaways": {
        slug: "buffalo_king_untamed_megaways",
        name: "Buffalo King Untamed Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/bull_fiesta": {
        slug: "bull_fiesta",
        name: "Bull Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/busy_bees": {
        slug: "busy_bees",
        name: "Busy Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_cash": {
        slug: "caishens_cash",
        name: "Caishen's Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_cash_pots": {
        slug: "caishens_cash_pots",
        name: "Caishen's Cash Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/caishens_gold": {
        slug: "caishens_gold",
        name: "Caishen's Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_blitz": {
        slug: "candy_blitz",
        name: "Candy Blitz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_blitz_bombs": {
        slug: "candy_blitz_bombs",
        name: "Candy Blitz Bombs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_corner": {
        slug: "candy_corner",
        name: "Candy Corner",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_jar_clusters": {
        slug: "candy_jar_clusters",
        name: "Candy Jar Clusters",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_rush": {
        slug: "candy_rush",
        name: "Candy Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_stars": {
        slug: "candy_stars",
        name: "Candy Stars",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/candy_village": {
        slug: "candy_village",
        name: "Candy Village",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/captain_kraken_megaways": {
        slug: "captain_kraken_megaways",
        name: "Captain Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_bonanza": {
        slug: "cash_bonanza",
        name: "Cash Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_box": {
        slug: "cash_box",
        name: "Cash Box",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_chips": {
        slug: "cash_chips",
        name: "Cash Chips",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_elevator": {
        slug: "cash_elevator",
        name: "Cash Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_patrol": {
        slug: "cash_patrol",
        name: "Cash Patrol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cash_surge": {
        slug: "cash_surge",
        name: "Cash Surge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/castle_of_fire": {
        slug: "castle_of_fire",
        name: "Castle of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chase_for_glory": {
        slug: "chase_for_glory",
        name: "Chase For Glory",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cheeky_emperor": {
        slug: "cheeky_emperor",
        name: "Cheeky Emperor",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cheetah_wild": {
        slug: "cheetah_wild",
        name: "Cheetah Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chests_of_cai_shen": {
        slug: "chests_of_cai_shen",
        name: "Chests of Cai Shen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chests_of_cai_shen_2": {
        slug: "chests_of_cai_shen_2",
        name: "Chests of Cai Shen 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken": {
        slug: "chicken",
        name: "Chicken+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken_chase": {
        slug: "chicken_chase",
        name: "Chicken Chase",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chicken_drop": {
        slug: "chicken_drop",
        name: "Chicken Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat": {
        slug: "chilli_heat",
        name: "Chilli Heat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat_megaways": {
        slug: "chilli_heat_megaways",
        name: "Chilli Heat Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/chilli_heat_spicy_spins": {
        slug: "chilli_heat_spicy_spins",
        name: "Chilli Heat Spicy Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/christmas_big_bass_bonanza": {
        slug: "christmas_big_bass_bonanza",
        name: "Christmas Big Bass Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/christmas_carol_megaways": {
        slug: "christmas_carol_megaways",
        name: "Christmas Carol Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cleocatra": {
        slug: "cleocatra",
        name: "Cleocatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/clover_gold": {
        slug: "clover_gold",
        name: "Clover Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/club_tropicana": {
        slug: "club_tropicana",
        name: "Club Tropicana",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/club_tropicana_happy_hour": {
        slug: "club_tropicana_happy_hour",
        name: "Club Tropicana Happy Hour",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/coffee_wild": {
        slug: "coffee_wild",
        name: "Coffee Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/colossal_cash_zone": {
        slug: "colossal_cash_zone",
        name: "Colossal Cash Zone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/congo_cash": {
        slug: "congo_cash",
        name: "Congo Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/congo_cash_xl": {
        slug: "congo_cash_xl",
        name: "Congo Cash XL",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cosmic_cash": {
        slug: "cosmic_cash",
        name: "Cosmic Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cosmic_clusters": {
        slug: "cosmic_clusters",
        name: "Cosmic Clusters!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/coven_rising": {
        slug: "coven_rising",
        name: "Coven Rising",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cowboy_coins": {
        slug: "cowboy_coins",
        name: "Cowboy Coins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cowboys_gold": {
        slug: "cowboys_gold",
        name: "Cowboys Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crank_it_up": {
        slug: "crank_it_up",
        name: "Crank It Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crown_of_fire": {
        slug: "crown_of_fire",
        name: "Crown of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/crystal_caverns_megaways": {
        slug: "crystal_caverns_megaways",
        name: "Crystal Caverns Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cult": {
        slug: "cult",
        name: "CULT",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/curse_of_the_werewolf_megaways": {
        slug: "curse_of_the_werewolf_megaways",
        name: "Curse of the Werewolf Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyber_heist": {
        slug: "cyber_heist",
        name: "Cyber Heist",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyber_pup_megaways": {
        slug: "cyber_pup_megaways",
        name: "Cyber Pup Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyberheist_city": {
        slug: "cyberheist_city",
        name: "Cyberheist City",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/cyclops_smash": {
        slug: "cyclops_smash",
        name: "Cyclops Smash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/da_vincis_treasure": {
        slug: "da_vincis_treasure",
        name: "Da Vinci's Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dance_party": {
        slug: "dance_party",
        name: "Dance Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/day_of_dead": {
        slug: "day_of_dead",
        name: "Day of Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/death_dominion": {
        slug: "death_dominion",
        name: "Death Dominion",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/demon_pots": {
        slug: "demon_pots",
        name: "Demon Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/devilicious": {
        slug: "devilicious",
        name: "Devilicious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/devils_13": {
        slug: "devils_13",
        name: "Devil's 13",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamond_cascade": {
        slug: "diamond_cascade",
        name: "Diamond Cascade",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamond_strike": {
        slug: "diamond_strike",
        name: "Diamond Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamonds_are_forever_3_lines": {
        slug: "diamonds_are_forever_3_lines",
        name: "Diamonds are Forever 3 Lines",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/diamonds_of_egypt": {
        slug: "diamonds_of_egypt",
        name: "Diamonds of Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ding_dong_christmas_bells": {
        slug: "ding_dong_christmas_bells",
        name: "Ding Dong Christmas Bells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/disco_lady": {
        slug: "disco_lady",
        name: "Disco Lady",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/down_the_rails": {
        slug: "down_the_rails",
        name: "Down The Rails",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/drago_jewels_of_fortune": {
        slug: "drago_jewels_of_fortune",
        name: "Drago Jewels of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_bonus_baccarat": {
        slug: "dragon_bonus_baccarat",
        name: "Dragon Bonus Baccarat",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_gold_88": {
        slug: "dragon_gold_88",
        name: "Dragon Gold 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_hero": {
        slug: "dragon_hero",
        name: "Dragon Hero",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_hot_hold_and_spin": {
        slug: "dragon_hot_hold_and_spin",
        name: "Dragon Hot Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_king_hot_pots": {
        slug: "dragon_king_hot_pots",
        name: "Dragon King Hot Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_kingdom": {
        slug: "dragon_kingdom",
        name: "Dragon Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_kingdom_eyes_of_fire": {
        slug: "dragon_kingdom_eyes_of_fire",
        name: "Dragon Kingdom Eyes of Fire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_pots_megaways": {
        slug: "dragon_pots_megaways",
        name: "Dragon Pots Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_tiger": {
        slug: "dragon_tiger",
        name: "Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragon_tiger_fortunes": {
        slug: "dragon_tiger_fortunes",
        name: "Dragon Tiger Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dragons_gate_bonus_choice": {
        slug: "dragons_gate_bonus_choice",
        name: "Dragon's Gate Bonus Choice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/drill_that_gold": {
        slug: "drill_that_gold",
        name: "Drill that Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/duel_of_night_and_day": {
        slug: "duel_of_night_and_day",
        name: "Duel of Night and Day",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dwarf_and_dragon": {
        slug: "dwarf_and_dragon",
        name: "Dwarf and Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dwarven_gold_deluxe": {
        slug: "dwarven_gold_deluxe",
        name: "Dwarven Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/dynamite_diggin_doug": {
        slug: "dynamite_diggin_doug",
        name: "Dynamite Diggin Doug",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eastern_fury": {
        slug: "eastern_fury",
        name: "Eastern Fury",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/egyptian_fortunes": {
        slug: "egyptian_fortunes",
        name: "Egyptian Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/elemental_gems_megaways": {
        slug: "elemental_gems_megaways",
        name: "Elemental Gems Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king": {
        slug: "emerald_king",
        name: "Emerald King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king_rainbow_road": {
        slug: "emerald_king_rainbow_road",
        name: "Emerald King Rainbow Road",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emerald_king_wheel_of_wealth": {
        slug: "emerald_king_wheel_of_wealth",
        name: "Emerald King Wheel of Wealth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/emperor_caishen": {
        slug: "emperor_caishen",
        name: "Emperor Caishen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/empty_the_bank": {
        slug: "empty_the_bank",
        name: "Empty the Bank",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/escape_the_pyramid_fire_and_ice": {
        slug: "escape_the_pyramid_fire_and_ice",
        name: "Escape the Pyramid Fire and Ice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eternal_diamonds": {
        slug: "eternal_diamonds",
        name: "Eternal Diamonds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eternal_empress_freeze_time": {
        slug: "eternal_empress_freeze_time",
        name: "Eternal Empress Freeze Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/excalibur_unleashed": {
        slug: "excalibur_unleashed",
        name: "Excalibur Unleashed",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/extra_juicy": {
        slug: "extra_juicy",
        name: "Extra Juicy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/extra_juicy_megaways": {
        slug: "extra_juicy_megaways",
        name: "Extra Juicy Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_cleopatra": {
        slug: "eye_of_cleopatra",
        name: "Eye of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_spartacus": {
        slug: "eye_of_spartacus",
        name: "Eye of Spartacus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/eye_of_the_storm": {
        slug: "eye_of_the_storm",
        name: "Eye of the Storm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fairytale_fortune": {
        slug: "fairytale_fortune",
        name: "Fairytale Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fangtastic_freespins": {
        slug: "fangtastic_freespins",
        name: "Fangtastic Freespins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fat_panda": {
        slug: "fat_panda",
        name: "Fat Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fiesta_fortune": {
        slug: "fiesta_fortune",
        name: "Fiesta Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/finger_lickn_free_spins": {
        slug: "finger_lickn_free_spins",
        name: "Finger Lick'n Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_88": {
        slug: "fire_88",
        name: "Fire 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_archer": {
        slug: "fire_archer",
        name: "Fire Archer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_100": {
        slug: "fire_hot_100",
        name: "Fire Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_20": {
        slug: "fire_hot_20",
        name: "Fire Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_40": {
        slug: "fire_hot_40",
        name: "Fire Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_hot_5": {
        slug: "fire_hot_5",
        name: "Fire Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_portals": {
        slug: "fire_portals",
        name: "Fire Portals",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede": {
        slug: "fire_stampede",
        name: "Fire Stampede",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede_2": {
        slug: "fire_stampede_2",
        name: "Fire Stampede 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_stampede_ultimate": {
        slug: "fire_stampede_ultimate",
        name: "Fire Stampede Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_strike": {
        slug: "fire_strike",
        name: "Fire Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fire_strike_2": {
        slug: "fire_strike_2",
        name: "Fire Strike 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/firebird_spirit_connect_and_collect": {
        slug: "firebird_spirit_connect_and_collect",
        name: "Firebird Spirit Connect and Collect",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fish_eye": {
        slug: "fish_eye",
        name: "Fish Eye",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fishin_reels": {
        slug: "fishin_reels",
        name: "Fishin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon": {
        slug: "floating_dragon",
        name: "Floating Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_dragon_boat_festival": {
        slug: "floating_dragon_dragon_boat_festival",
        name: "Floating Dragon Dragon Boat Festival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_megaways": {
        slug: "floating_dragon_megaways",
        name: "Floating Dragon Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_new_year_festival_ultra_megaways": {
        slug: "floating_dragon_new_year_festival_ultra_megaways",
        name: "Floating Dragon New Year Festival Ultra Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_wild_horses": {
        slug: "floating_dragon_wild_horses",
        name: "Floating Dragon Wild Horses",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/floating_dragon_year_of_the_snake": {
        slug: "floating_dragon_year_of_the_snake",
        name: "Floating Dragon Year of the Snake",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fonzos_feline_fortunes": {
        slug: "fonzos_feline_fortunes",
        name: "Fonzo’s Feline Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/forever_split_megaways": {
        slug: "forever_split_megaways",
        name: "Forever Split Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/forge_of_olympus": {
        slug: "forge_of_olympus",
        name: "Forge of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/forging_wilds": {
        slug: "forging_wilds",
        name: "Forging Wilds",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_ace": {
        slug: "fortune_ace",
        name: "Fortune Ace",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_ace_scatter": {
        slug: "fortune_ace_scatter",
        name: "Fortune Ace Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_dragon": {
        slug: "fortune_dragon",
        name: "Fortune Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_hitn_roll": {
        slug: "fortune_hitn_roll",
        name: "Fortune Hit’n Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_of_giza": {
        slug: "fortune_of_giza",
        name: "Fortune of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortune_of_olympus": {
        slug: "fortune_of_olympus",
        name: "Fortune of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fortunes_of_aztec": {
        slug: "fortunes_of_aztec",
        name: "Fortunes of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/freya_1000": {
        slug: "freya_1000",
        name: "Freya 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frightening_frankie": {
        slug: "frightening_frankie",
        name: "Frightening Frankie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frogs_and_bugs": {
        slug: "frogs_and_bugs",
        name: "Frogs and Bugs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/front_runner_odds_on": {
        slug: "front_runner_odds_on",
        name: "Front Runner Odds On",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/frozen_tropics": {
        slug: "frozen_tropics",
        name: "Frozen Tropics",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_party": {
        slug: "fruit_party",
        name: "Fruit Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_party_2": {
        slug: "fruit_party_2",
        name: "Fruit Party 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruit_rainbow": {
        slug: "fruit_rainbow",
        name: "Fruit Rainbow",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fruity_treats": {
        slug: "fruity_treats",
        name: "Fruity Treats",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fu_fu_fu": {
        slug: "fu_fu_fu",
        name: "Fu Fu Fu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/furry_bonanza_megaways": {
        slug: "furry_bonanza_megaways",
        name: "Furry Bonanza Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fury_of_anubis": {
        slug: "fury_of_anubis",
        name: "Fury of Anubis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/fury_of_odin_megaways": {
        slug: "fury_of_odin_megaways",
        name: "Fury of Odin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_aztec": {
        slug: "gates_of_aztec",
        name: "Gates of Aztec",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca": {
        slug: "gates_of_gatot_kaca",
        name: "Gates of Gatot Kaca",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca_1000": {
        slug: "gates_of_gatot_kaca_1000",
        name: "Gates Of Gatot Kaca 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_gatot_kaca_super_scatter": {
        slug: "gates_of_gatot_kaca_super_scatter",
        name: "Gates of Gatot Kaca Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_hades": {
        slug: "gates_of_hades",
        name: "Gates of Hades",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus": {
        slug: "gates_of_olympus",
        name: "Gates of Olympus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_1000": {
        slug: "gates_of_olympus_1000",
        name: "Gates Of Olympus 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_2500": {
        slug: "gates_of_olympus_2500",
        name: "Gates of Olympus 2500",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_pop": {
        slug: "gates_of_olympus_pop",
        name: "Gates of Olympus POP",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_olympus_super_scatter": {
        slug: "gates_of_olympus_super_scatter",
        name: "Gates of Olympus Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_pyroth": {
        slug: "gates_of_pyroth",
        name: "Gates of Pyroth",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gates_of_valhalla": {
        slug: "gates_of_valhalla",
        name: "Gates of Valhalla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gatot_kacas_fury": {
        slug: "gatot_kacas_fury",
        name: "Gatot Kaca's Fury",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gears_of_horus": {
        slug: "gears_of_horus",
        name: "Gears Of Horus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_elevator": {
        slug: "gem_elevator",
        name: "Gem Elevator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_fire_fortune": {
        slug: "gem_fire_fortune",
        name: "Gem Fire Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gem_trio": {
        slug: "gem_trio",
        name: "Gem Trio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gems_bonanza": {
        slug: "gems_bonanza",
        name: "Gems Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/genies_gem_bonanza": {
        slug: "genies_gem_bonanza",
        name: "Genie's Gem Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/goblin_heist_powernudge": {
        slug: "goblin_heist_powernudge",
        name: "Goblin Heist Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gods_of_giza": {
        slug: "gods_of_giza",
        name: "Gods of Giza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_oasis": {
        slug: "gold_oasis",
        name: "Gold Oasis",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_party": {
        slug: "gold_party",
        name: "Gold Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_party_2_after_hours": {
        slug: "gold_party_2_after_hours",
        name: "Gold Party 2 After Hours",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_rush": {
        slug: "gold_rush",
        name: "Gold Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gold_train": {
        slug: "gold_train",
        name: "Gold Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_ox": {
        slug: "golden_ox",
        name: "Golden Ox",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_pig": {
        slug: "golden_pig",
        name: "Golden Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/golden_retriever": {
        slug: "golden_retriever",
        name: "Golden Retriever",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/good_luck_and_good_fortune": {
        slug: "good_luck_and_good_fortune",
        name: "Good Luck and Good Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gorilla_mayhem": {
        slug: "gorilla_mayhem",
        name: "Gorilla Mayhem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/grace_of_ebisu": {
        slug: "grace_of_ebisu",
        name: "Grace of Ebisu",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/gravity_bonanza": {
        slug: "gravity_bonanza",
        name: "Gravity Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_ghosts": {
        slug: "great_ghosts",
        name: "Great Ghosts!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_lagoon": {
        slug: "great_lagoon",
        name: "Great Lagoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_reef": {
        slug: "great_reef",
        name: "Great Reef",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino": {
        slug: "great_rhino",
        name: "Great Rhino",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino_deluxe": {
        slug: "great_rhino_deluxe",
        name: "Great Rhino Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/great_rhino_megaways": {
        slug: "great_rhino_megaways",
        name: "Great Rhino Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greedy_fortune_pig": {
        slug: "greedy_fortune_pig",
        name: "Greedy Fortune Pig",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greedy_wolf": {
        slug: "greedy_wolf",
        name: "Greedy Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/greek_gods": {
        slug: "greek_gods",
        name: "Greek Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hammerstorm": {
        slug: "hammerstorm",
        name: "Hammerstorm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hand_of_midas_2": {
        slug: "hand_of_midas_2",
        name: "Hand of Midas 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/harvest_moon_grave_profits": {
        slug: "harvest_moon_grave_profits",
        name: "Harvest Moon Grave Profits",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/haunted_crypt": {
        slug: "haunted_crypt",
        name: "Haunted Crypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heart_of_cleopatra": {
        slug: "heart_of_cleopatra",
        name: "Heart of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heart_of_rio": {
        slug: "heart_of_rio",
        name: "Heart of Rio",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heartbreakers": {
        slug: "heartbreakers",
        name: "Heartbreakers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hearts_of_venus": {
        slug: "hearts_of_venus",
        name: "Hearts of Venus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heist_for_the_golden_nuggets": {
        slug: "heist_for_the_golden_nuggets",
        name: "Heist for the Golden Nuggets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/helios_triple_sun": {
        slug: "helios_triple_sun",
        name: "Helios Triple Sun",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hell_butcher": {
        slug: "hell_butcher",
        name: "Hell Butcher",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hellvis_wild": {
        slug: "hellvis_wild",
        name: "Hellvis Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hercules_and_pegasus": {
        slug: "hercules_and_pegasus",
        name: "Hercules and Pegasus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hercules_son_of_zeus": {
        slug: "hercules_son_of_zeus",
        name: "Hercules Son Of Zeus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/heroic_spins": {
        slug: "heroic_spins",
        name: "Heroic Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/high_flyer": {
        slug: "high_flyer",
        name: "High Flyer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/himalayan_wild": {
        slug: "himalayan_wild",
        name: "Himalayan Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hockey_attack": {
        slug: "hockey_attack",
        name: "Hockey Attack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hokkaido_wolf": {
        slug: "hokkaido_wolf",
        name: "Hokkaido Wolf",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/holiday_ride": {
        slug: "holiday_ride",
        name: "Holiday Ride",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/honey_honey_honey": {
        slug: "honey_honey_honey",
        name: "Honey Honey Honey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_chilli": {
        slug: "hot_chilli",
        name: "Hot Chilli",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_fiesta": {
        slug: "hot_fiesta",
        name: "Hot Fiesta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_pepper": {
        slug: "hot_pepper",
        name: "Hot Pepper",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_safari": {
        slug: "hot_safari",
        name: "Hot Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn": {
        slug: "hot_to_burn",
        name: "Hot to Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_7_deadly_free_spins": {
        slug: "hot_to_burn_7_deadly_free_spins",
        name: "Hot to Burn 7 Deadly Free Spins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_extreme": {
        slug: "hot_to_burn_extreme",
        name: "Hot to Burn Extreme",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_hold_and_spin": {
        slug: "hot_to_burn_hold_and_spin",
        name: "Hot to Burn Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_to_burn_multiplier": {
        slug: "hot_to_burn_multiplier",
        name: "Hot to Burn Multiplier",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hot_tuna": {
        slug: "hot_tuna",
        name: "Hot Tuna",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/hundreds_and_thousands": {
        slug: "hundreds_and_thousands",
        name: "Hundreds and Thousands",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ice_lobster": {
        slug: "ice_lobster",
        name: "Ice Lobster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ice_mint": {
        slug: "ice_mint",
        name: "Ice Mint",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/idol_pop_fever": {
        slug: "idol_pop_fever",
        name: "Idol Pop Fever",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/inca_queen": {
        slug: "inca_queen",
        name: "Inca Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/infective_wild": {
        slug: "infective_wild",
        name: "Infective Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/irish_charms": {
        slug: "irish_charms",
        name: "Irish Charms",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/irish_crown": {
        slug: "irish_crown",
        name: "Irish Crown",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jackpot_blaze": {
        slug: "jackpot_blaze",
        name: "Jackpot Blaze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jackpot_hunter": {
        slug: "jackpot_hunter",
        name: "Jackpot Hunter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jade_butterfly": {
        slug: "jade_butterfly",
        name: "Jade Butterfly",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jade_legends": {
        slug: "jade_legends",
        name: "Jade Legends",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jane_hunter_and_the_mask_of_montezuma": {
        slug: "jane_hunter_and_the_mask_of_montezuma",
        name: "Jane Hunter and the Mask of Montezuma",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jasmine_dreams": {
        slug: "jasmine_dreams",
        name: "Jasmine Dreams",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jelly_express": {
        slug: "jelly_express",
        name: "Jelly Express",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jewel_rush": {
        slug: "jewel_rush",
        name: "Jewel Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_galileos_secrets": {
        slug: "john_hunter_and_galileos_secrets",
        name: "John Hunter and Galileo's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_book_of_tut_megaways": {
        slug: "john_hunter_and_the_book_of_tut_megaways",
        name: "John Hunter and the Book of Tut Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_mayan_gods": {
        slug: "john_hunter_and_the_mayan_gods",
        name: "John Hunter and the Mayan Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/john_hunter_and_the_tomb_of_the_scarab_queen": {
        slug: "john_hunter_and_the_tomb_of_the_scarab_queen",
        name: "John Hunter and the Tomb of the Scarab Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_jewels_dice": {
        slug: "joker_jewels_dice",
        name: "Joker Jewels Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_king": {
        slug: "joker_king",
        name: "Joker King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/joker_race": {
        slug: "joker_race",
        name: "Joker Race",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels": {
        slug: "jokers_jewels",
        name: "Joker's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_cash": {
        slug: "jokers_jewels_cash",
        name: "Joker's Jewels Cash",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_hold_and_spin": {
        slug: "jokers_jewels_hold_and_spin",
        name: "Joker's Jewels Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_hot": {
        slug: "jokers_jewels_hot",
        name: "Joker’s Jewels Hot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_jewels_wild": {
        slug: "jokers_jewels_wild",
        name: "Joker’s Jewels Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jokers_revenge": {
        slug: "jokers_revenge",
        name: "Joker's Revenge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/journey_to_the_west": {
        slug: "journey_to_the_west",
        name: "Journey to the West",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/juicy_fruits": {
        slug: "juicy_fruits",
        name: "Juicy Fruits",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/juicy_fruits_multihold": {
        slug: "juicy_fruits_multihold",
        name: "Juicy Fruits Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jumbo_safari": {
        slug: "jumbo_safari",
        name: "Jumbo Safari",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/jungle_gorilla": {
        slug: "jungle_gorilla",
        name: "Jungle Gorilla",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/king_of_spear": {
        slug: "king_of_spear",
        name: "King of Spear",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/kingdom_of_asgard": {
        slug: "kingdom_of_asgard",
        name: "Kingdom of Asgard",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/kingdom_of_the_dead": {
        slug: "kingdom_of_the_dead",
        name: "Kingdom of The Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/knight_hot_spotz": {
        slug: "knight_hot_spotz",
        name: "Knight Hot Spotz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/knights_vs_barbarians": {
        slug: "knights_vs_barbarians",
        name: "Knights vs Barbarians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/koi_pond": {
        slug: "koi_pond",
        name: "Koi Pond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/krakens_sky_bounty": {
        slug: "krakens_sky_bounty",
        name: "Kraken's Sky Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lady_godiva": {
        slug: "lady_godiva",
        name: "Lady Godiva",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lamp_of_infinity": {
        slug: "lamp_of_infinity",
        name: "Lamp Of Infinity",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/launch_to_riches": {
        slug: "launch_to_riches",
        name: "Launch to Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lava_balls": {
        slug: "lava_balls",
        name: "Lava Balls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/legend_of_heroes_megaways": {
        slug: "legend_of_heroes_megaways",
        name: "Legend of Heroes Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/leprechaun_carol": {
        slug: "leprechaun_carol",
        name: "Leprechaun Carol",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/leprechaun_song": {
        slug: "leprechaun_song",
        name: "Leprechaun Song",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/limbo": {
        slug: "limbo",
        name: "Limbo+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/little_gem": {
        slug: "little_gem",
        name: "Little Gem",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_bobs_crazy_crab_shack": {
        slug: "lobster_bobs_crazy_crab_shack",
        name: "Lobster Bob’s Crazy Crab Shack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_bobs_sea_food_and_win_it": {
        slug: "lobster_bobs_sea_food_and_win_it",
        name: "Lobster Bob’s Sea Food and Win It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lobster_house": {
        slug: "lobster_house",
        name: "Lobster House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lokis_riches": {
        slug: "lokis_riches",
        name: "Loki’s Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_dragon_ball": {
        slug: "lucky_dragon_ball",
        name: "Lucky Dragon Ball",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_dragons": {
        slug: "lucky_dragons",
        name: "Lucky Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_drums_88": {
        slug: "lucky_drums_88",
        name: "Lucky Drums 88",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_fishing_megaways": {
        slug: "lucky_fishing_megaways",
        name: "Lucky Fishing Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_grace_and_charm": {
        slug: "lucky_grace_and_charm",
        name: "Lucky, Grace and Charm",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_lightning": {
        slug: "lucky_lightning",
        name: "Lucky Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_new_year": {
        slug: "lucky_new_year",
        name: "Lucky New Year",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/lucky_new_year_tiger_treasures": {
        slug: "lucky_new_year_tiger_treasures",
        name: "Lucky New Year Tiger Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luckys_wild_pub": {
        slug: "luckys_wild_pub",
        name: "Lucky's Wild Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luckys_wild_pub_2": {
        slug: "luckys_wild_pub_2",
        name: "Lucky's Wild Pub 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/luxor_of_cleopatra": {
        slug: "luxor_of_cleopatra",
        name: "Luxor of Cleopatra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/madame_destiny": {
        slug: "madame_destiny",
        name: "Madame Destiny",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/madame_destiny_megaways": {
        slug: "madame_destiny_megaways",
        name: "Madame Destiny Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magic_journey": {
        slug: "magic_journey",
        name: "Magic Journey",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magic_money_maze": {
        slug: "magic_money_maze",
        name: "Magic Money Maze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/magicians_secrets": {
        slug: "magicians_secrets",
        name: "Magician's Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_panda": {
        slug: "mahjong_panda",
        name: "Mahjong Panda",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins": {
        slug: "mahjong_wins",
        name: "Mahjong Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_bonus": {
        slug: "mahjong_wins_bonus",
        name: "Mahjong Wins Bonus",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_super_scatter": {
        slug: "mahjong_wins_super_scatter",
        name: "Mahjong Wins Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mahjong_wins_triple_pot": {
        slug: "mahjong_wins_triple_pot",
        name: "Mahjong Wins Triple Pot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/majestic_express_gold_run": {
        slug: "majestic_express_gold_run",
        name: "Majestic Express Gold Run",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mammoth_gold_megaways": {
        slug: "mammoth_gold_megaways",
        name: "Mammoth Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/master_chens_fortune": {
        slug: "master_chens_fortune",
        name: "Master Chen's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/master_joker": {
        slug: "master_joker",
        name: "Master Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/medusas_stone": {
        slug: "medusas_stone",
        name: "Medusa’s Stone",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mermaids_treasure_love": {
        slug: "mermaids_treasure_love",
        name: "Mermaid's Treasure Love",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/might_of_freya_megaways": {
        slug: "might_of_freya_megaways",
        name: "Might of Freya Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/might_of_ra": {
        slug: "might_of_ra",
        name: "Might of Ra",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mighty_kong": {
        slug: "mighty_kong",
        name: "Mighty Kong",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mighty_munching_melons": {
        slug: "mighty_munching_melons",
        name: "Mighty Munching Melons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mines": {
        slug: "mines",
        name: "Mines+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mining_rush": {
        slug: "mining_rush",
        name: "Mining Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mochimon": {
        slug: "mochimon",
        name: "Mochimon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/moleionaire": {
        slug: "moleionaire",
        name: "Moleionaire",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_money_money": {
        slug: "money_money_money",
        name: "Money Money Money",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_mouse": {
        slug: "money_mouse",
        name: "Money Mouse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_roll": {
        slug: "money_roll",
        name: "Money Roll",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_stacks": {
        slug: "money_stacks",
        name: "Money Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/money_stacks_megaways": {
        slug: "money_stacks_megaways",
        name: "Money Stacks Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monkey_madness": {
        slug: "monkey_madness",
        name: "Monkey Madness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monkey_warrior": {
        slug: "monkey_warrior",
        name: "Monkey Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/monster_superlanche": {
        slug: "monster_superlanche",
        name: "Monster Superlanche",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/moonshot": {
        slug: "moonshot",
        name: "Moonshot",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mr_nulls_wicked_wares": {
        slug: "mr_nulls_wicked_wares",
        name: "Mr Null's Wicked Wares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/muertos_multiplier_megaways": {
        slug: "muertos_multiplier_megaways",
        name: "Muertos Multiplier Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/multihand_blackjack": {
        slug: "multihand_blackjack",
        name: "Multihand Blackjack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mummys_jewels": {
        slug: "mummys_jewels",
        name: "Mummy's Jewels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mummys_jewels_100": {
        slug: "mummys_jewels_100",
        name: "Mummy's Jewels 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_gold": {
        slug: "mustang_gold",
        name: "Mustang Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_gold_megaways": {
        slug: "mustang_gold_megaways",
        name: "Mustang Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mustang_trail": {
        slug: "mustang_trail",
        name: "Mustang Trail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mysterious": {
        slug: "mysterious",
        name: "Mysterious",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mysterious_egypt": {
        slug: "mysterious_egypt",
        name: "Mysterious Egypt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mystery_mice": {
        slug: "mystery_mice",
        name: "Mystery Mice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/mystic_chief": {
        slug: "mystic_chief",
        name: "Mystic Chief",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/nile_fortune": {
        slug: "nile_fortune",
        name: "Nile Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/north_guardians": {
        slug: "north_guardians",
        name: "North Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/octobeer_fortunes": {
        slug: "octobeer_fortunes",
        name: "Octobeer Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/oodles_of_noodles": {
        slug: "oodles_of_noodles",
        name: "Oodles of Noodles",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/oracle_of_gold": {
        slug: "oracle_of_gold",
        name: "Oracle of Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/out_of_the_woods": {
        slug: "out_of_the_woods",
        name: "Out of the Woods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/panda_fortune_2": {
        slug: "panda_fortune_2",
        name: "Panda Fortune 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pandas_fortune": {
        slug: "pandas_fortune",
        name: "Panda's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pandemic_rising": {
        slug: "pandemic_rising",
        name: "Pandemic Rising",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/peking_luck": {
        slug: "peking_luck",
        name: "Peking Luck",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/penguins_christmas_party_time": {
        slug: "penguins_christmas_party_time",
        name: "Penguins Christmas Party Time",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/peppes_pepperoni_pizza_plaza": {
        slug: "peppes_pepperoni_pizza_plaza",
        name: "Peppe's Pepperoni Pizza Plaza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/phoenix_forge": {
        slug: "phoenix_forge",
        name: "Phoenix Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/piggy_bank_bills": {
        slug: "piggy_bank_bills",
        name: "Piggy Bank Bills",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/piggy_bankers": {
        slug: "piggy_bankers",
        name: "Piggy Bankers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pinup_girls": {
        slug: "pinup_girls",
        name: "Pinup Girls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirate_gold": {
        slug: "pirate_gold",
        name: "Pirate Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirate_gold_deluxe": {
        slug: "pirate_gold_deluxe",
        name: "Pirate Gold Deluxe",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pirates_pub": {
        slug: "pirates_pub",
        name: "Pirates Pub",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pixie_wings": {
        slug: "pixie_wings",
        name: "Pixie Wings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pizza_pizza_pizza": {
        slug: "pizza_pizza_pizza",
        name: "PIZZA! PIZZA? PIZZA!",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/plinko": {
        slug: "plinko",
        name: "Plinko+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pompeii_megareels_megaways": {
        slug: "pompeii_megareels_megaways",
        name: "Pompeii Megareels Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pot_of_fortune": {
        slug: "pot_of_fortune",
        name: "Pot of Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_merlin_megaways": {
        slug: "power_of_merlin_megaways",
        name: "Power of Merlin Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_ninja": {
        slug: "power_of_ninja",
        name: "Power Of Ninja",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/power_of_thor_megaways": {
        slug: "power_of_thor_megaways",
        name: "Power of Thor Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pub_kings": {
        slug: "pub_kings",
        name: "Pub Kings",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pyramid_bonanza": {
        slug: "pyramid_bonanza",
        name: "Pyramid Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/pyramid_king": {
        slug: "pyramid_king",
        name: "Pyramid King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queen_of_gods": {
        slug: "queen_of_gods",
        name: "Queen of Gods",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/queenie": {
        slug: "queenie",
        name: "Queenie",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ra_vs_osiris": {
        slug: "ra_vs_osiris",
        name: "Ra vs Osiris",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rabbit_garden": {
        slug: "rabbit_garden",
        name: "Rabbit Garden",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/raging_bull": {
        slug: "raging_bull",
        name: "Raging Bull",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/raging_waterfall_megaways": {
        slug: "raging_waterfall_megaways",
        name: "Raging Waterfall Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rainbow_gold": {
        slug: "rainbow_gold",
        name: "Rainbow Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rainbow_reels": {
        slug: "rainbow_reels",
        name: "Rainbow Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/reel_banks": {
        slug: "reel_banks",
        name: "Reel Banks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_bison": {
        slug: "release_the_bison",
        name: "Release the Bison",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken": {
        slug: "release_the_kraken",
        name: "Release the Kraken",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken_2": {
        slug: "release_the_kraken_2",
        name: "Release the Kraken 2",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/release_the_kraken_megaways": {
        slug: "release_the_kraken_megaways",
        name: "Release the Kraken Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/resurrecting_riches": {
        slug: "resurrecting_riches",
        name: "Resurrecting Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/return_of_the_dead": {
        slug: "return_of_the_dead",
        name: "Return of the Dead",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/revenge_of_loki_megaways": {
        slug: "revenge_of_loki_megaways",
        name: "Revenge of Loki Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ride_the_lightning": {
        slug: "ride_the_lightning",
        name: "Ride the Lightning",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ripe_rewards": {
        slug: "ripe_rewards",
        name: "Ripe Rewards",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_giza_powernudge": {
        slug: "rise_of_giza_powernudge",
        name: "Rise of Giza PowerNudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_pyramids": {
        slug: "rise_of_pyramids",
        name: "Rise of Pyramids",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai": {
        slug: "rise_of_samurai",
        name: "Rise of Samurai",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_4": {
        slug: "rise_of_samurai_4",
        name: "Rise of Samurai 4",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_iii": {
        slug: "rise_of_samurai_iii",
        name: "Rise Of Samurai III",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rise_of_samurai_megaways": {
        slug: "rise_of_samurai_megaways",
        name: "Rise of Samurai Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/robber_strike": {
        slug: "robber_strike",
        name: "Robber Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rock_vegas": {
        slug: "rock_vegas",
        name: "Rock Vegas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rocket_blast_megaways": {
        slug: "rocket_blast_megaways",
        name: "Rocket Blast Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rolling_in_treasures": {
        slug: "rolling_in_treasures",
        name: "Rolling in Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/roulette": {
        slug: "roulette",
        name: "Roulette",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/rujak_bonanza": {
        slug: "rujak_bonanza",
        name: "Rujak Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/running_sushi": {
        slug: "running_sushi",
        name: "Running Sushi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/safari_king": {
        slug: "safari_king",
        name: "Safari King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/samurai_code": {
        slug: "samurai_code",
        name: "Samurai Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sanatorium_secrets": {
        slug: "sanatorium_secrets",
        name: "Sanatorium Secrets",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santa": {
        slug: "santa",
        name: "Santa",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_great_gifts": {
        slug: "santas_great_gifts",
        name: "Santa's Great Gifts",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_slay": {
        slug: "santas_slay",
        name: "Santa's Slay",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_wonderland": {
        slug: "santas_wonderland",
        name: "Santa's Wonderland",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/santas_xmas_rush": {
        slug: "santas_xmas_rush",
        name: "Santa’s Xmas Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sea_fantasy": {
        slug: "sea_fantasy",
        name: "Sea Fantasy",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/secret_city_gold": {
        slug: "secret_city_gold",
        name: "Secret City Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shield_of_sparta": {
        slug: "shield_of_sparta",
        name: "Shield of Sparta",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_100": {
        slug: "shining_hot_100",
        name: "Shining Hot 100",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_20": {
        slug: "shining_hot_20",
        name: "Shining Hot 20",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_40": {
        slug: "shining_hot_40",
        name: "Shining Hot 40",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/shining_hot_5": {
        slug: "shining_hot_5",
        name: "Shining Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sleeping_dragon": {
        slug: "sleeping_dragon",
        name: "Sleeping Dragon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sleeping_dragon_ultra_dark": {
        slug: "sleeping_dragon_ultra_dark",
        name: "Sleeping Dragon Ultra Dark",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/slots_lobby": {
        slug: "slots_lobby",
        name: "Slots Lobby",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/smugglers_cove": {
        slug: "smugglers_cove",
        name: "Smugglers Cove",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snakes_and_ladders_megadice": {
        slug: "snakes_and_ladders_megadice",
        name: "Snakes and Ladders Megadice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snakes_and_ladders_snake_eyes": {
        slug: "snakes_and_ladders_snake_eyes",
        name: "Snakes and Ladders Snake Eyes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/snow_party": {
        slug: "snow_party",
        name: "Snow Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spartan_king": {
        slug: "spartan_king",
        name: "Spartan King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spellbinding_mystery": {
        slug: "spellbinding_mystery",
        name: "Spellbinding Mystery",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spellmaster": {
        slug: "spellmaster",
        name: "Spellmaster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spin_and_score_megaways": {
        slug: "spin_and_score_megaways",
        name: "Spin and Score Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spire": {
        slug: "spire",
        name: "Spire+",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/spirit_of_adventure": {
        slug: "spirit_of_adventure",
        name: "Spirit of adventure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/star_bounty": {
        slug: "star_bounty",
        name: "Star Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/star_pirates_code": {
        slug: "star_pirates_code",
        name: "Star Pirates Code",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_archer_1000": {
        slug: "starlight_archer_1000",
        name: "Starlight Archer 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_christmas": {
        slug: "starlight_christmas",
        name: "Starlight Christmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess": {
        slug: "starlight_princess",
        name: "Starlight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_1000": {
        slug: "starlight_princess_1000",
        name: "Starlight Princess 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_pachi": {
        slug: "starlight_princess_pachi",
        name: "Starlight Princess Pachi",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starlight_princess_super_scatter": {
        slug: "starlight_princess_super_scatter",
        name: "Starlight Princess Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/starz_megaways": {
        slug: "starz_megaways",
        name: "Starz Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/steamin_reels": {
        slug: "steamin_reels",
        name: "Steamin Reels",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sticky_bees": {
        slug: "sticky_bees",
        name: "Sticky Bees",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/strawberry_cocktail": {
        slug: "strawberry_cocktail",
        name: "Strawberry Cocktail",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/street_racer": {
        slug: "street_racer",
        name: "Street Racer",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/striking_hot_5": {
        slug: "striking_hot_5",
        name: "Striking Hot 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush": {
        slug: "sugar_rush",
        name: "Sugar Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_1000": {
        slug: "sugar_rush_1000",
        name: "Sugar Rush 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_super_scatter": {
        slug: "sugar_rush_super_scatter",
        name: "Sugar Rush Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_rush_xmas": {
        slug: "sugar_rush_xmas",
        name: "Sugar Rush Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sugar_supreme_powernudge": {
        slug: "sugar_supreme_powernudge",
        name: "Sugar Supreme Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sumo_supreme_megaways": {
        slug: "sumo_supreme_megaways",
        name: "Sumo Supreme Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sunnydaze_asylum": {
        slug: "sunnydaze_asylum",
        name: "Sunnydaze Asylum",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_7s": {
        slug: "super_7s",
        name: "Super 7s",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_gummy_strike": {
        slug: "super_gummy_strike",
        name: "Super Gummy Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_joker": {
        slug: "super_joker",
        name: "Super Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_serge": {
        slug: "super_serge",
        name: "Super Serge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_tiki_strike": {
        slug: "super_tiki_strike",
        name: "Super Tiki Strike",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/super_x": {
        slug: "super_x",
        name: "Super X",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza": {
        slug: "sweet_bonanza",
        name: "Sweet Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_1000": {
        slug: "sweet_bonanza_1000",
        name: "Sweet Bonanza 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_2500": {
        slug: "sweet_bonanza_2500",
        name: "Sweet Bonanza 2500",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_dice": {
        slug: "sweet_bonanza_dice",
        name: "Sweet Bonanza Dice",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_pop": {
        slug: "sweet_bonanza_pop",
        name: "Sweet Bonanza POP",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_super_scatter": {
        slug: "sweet_bonanza_super_scatter",
        name: "Sweet Bonanza Super Scatter",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_bonanza_xmas": {
        slug: "sweet_bonanza_xmas",
        name: "Sweet Bonanza Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_craze": {
        slug: "sweet_craze",
        name: "Sweet Craze",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_kingdom": {
        slug: "sweet_kingdom",
        name: "Sweet Kingdom",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_powernudge": {
        slug: "sweet_powernudge",
        name: "Sweet Powernudge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sweet_rush_bonanza": {
        slug: "sweet_rush_bonanza",
        name: "Sweet Rush Bonanza",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/sword_of_ares": {
        slug: "sword_of_ares",
        name: "Sword of Ares",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/temple_guardians": {
        slug: "temple_guardians",
        name: "Temple Guardians",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/temujin_treasures": {
        slug: "temujin_treasures",
        name: "Temujin Treasures",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_alter_ego": {
        slug: "the_alter_ego",
        name: "The Alter Ego",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_big_dawgs": {
        slug: "the_big_dawgs",
        name: "The Big Dawgs",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_big_dog_house": {
        slug: "the_big_dog_house",
        name: "The Big Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house": {
        slug: "the_dog_house",
        name: "The Dog House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_dice_show": {
        slug: "the_dog_house_dice_show",
        name: "The Dog House Dice Show",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_dog_or_alive": {
        slug: "the_dog_house_dog_or_alive",
        name: "The Dog House Dog or Alive",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_megaways": {
        slug: "the_dog_house_megaways",
        name: "The Dog House Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_megaways_1000": {
        slug: "the_dog_house_megaways_1000",
        name: "The Dog House Megaways 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_multihold": {
        slug: "the_dog_house_multihold",
        name: "The Dog House Multihold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_muttley_crew": {
        slug: "the_dog_house_muttley_crew",
        name: "The Dog House Muttley Crew",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dog_house_royal_hunt": {
        slug: "the_dog_house_royal_hunt",
        name: "The Dog House Royal Hunt",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_dragon_tiger": {
        slug: "the_dragon_tiger",
        name: "The Dragon Tiger",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_great_chicken_escape": {
        slug: "the_great_chicken_escape",
        name: "The Great Chicken Escape",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_great_stickup": {
        slug: "the_great_stickup",
        name: "The Great Stick-Up",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_hand_of_midas": {
        slug: "the_hand_of_midas",
        name: "The Hand of Midas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_knight_king": {
        slug: "the_knight_king",
        name: "The Knight King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_magic_cauldron": {
        slug: "the_magic_cauldron",
        name: "The Magic Cauldron",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_money_men_megaways": {
        slug: "the_money_men_megaways",
        name: "The Money Men Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_red_queen": {
        slug: "the_red_queen",
        name: "The Red Queen",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_tiger_warrior": {
        slug: "the_tiger_warrior",
        name: "The Tiger Warrior",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_tweety_house": {
        slug: "the_tweety_house",
        name: "The Tweety House",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_ultimate_5": {
        slug: "the_ultimate_5",
        name: "The Ultimate 5",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_wild_gang": {
        slug: "the_wild_gang",
        name: "The Wild Gang",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/the_wild_machine": {
        slug: "the_wild_machine",
        name: "The Wild Machine",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/three_star_fortune": {
        slug: "three_star_fortune",
        name: "Three Star Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tic_tac_take": {
        slug: "tic_tac_take",
        name: "Tic Tac Take",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/timber_stacks": {
        slug: "timber_stacks",
        name: "Timber Stacks",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tiny_toads": {
        slug: "tiny_toads",
        name: "Tiny Toads",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/towering_fortunes": {
        slug: "towering_fortunes",
        name: "Towering Fortunes",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/treasure_horse": {
        slug: "treasure_horse",
        name: "Treasure Horse",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/treasure_wild": {
        slug: "treasure_wild",
        name: "Treasure Wild",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tree_of_riches": {
        slug: "tree_of_riches",
        name: "Tree of Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/trees_of_treasure": {
        slug: "trees_of_treasure",
        name: "Trees Of Treasure",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_dragons": {
        slug: "triple_dragons",
        name: "Triple Dragons",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_hop_pots": {
        slug: "triple_hop_pots",
        name: "Triple Hop Pots",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_diamond": {
        slug: "triple_pot_diamond",
        name: "Triple Pot Diamond",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_gold": {
        slug: "triple_pot_gold",
        name: "Triple Pot Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_pot_plinko_hercules": {
        slug: "triple_pot_plinko_hercules",
        name: "Triple Pot Plinko Hercules",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/triple_tigers": {
        slug: "triple_tigers",
        name: "Triple Tigers",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tropical_tiki": {
        slug: "tropical_tiki",
        name: "Tropical Tiki",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/tundras_fortune": {
        slug: "tundras_fortune",
        name: "Tundra's Fortune",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/twilight_princess": {
        slug: "twilight_princess",
        name: "Twilight Princess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ultra_burn": {
        slug: "ultra_burn",
        name: "Ultra Burn",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/ultra_hold_and_spin": {
        slug: "ultra_hold_and_spin",
        name: "Ultra Hold and Spin",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vampires_vs_wolves": {
        slug: "vampires_vs_wolves",
        name: "Vampires VS Wolves",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vampy_party": {
        slug: "vampy_party",
        name: "Vampy Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vegas_magic": {
        slug: "vegas_magic",
        name: "Vegas Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/vegas_nights": {
        slug: "vegas_nights",
        name: "Vegas Nights",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/viking_forge": {
        slug: "viking_forge",
        name: "Viking Forge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/volcano_goddess": {
        slug: "volcano_goddess",
        name: "Volcano Goddess",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/voodoo_magic": {
        slug: "voodoo_magic",
        name: "Voodoo Magic",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/waves_of_poseidon": {
        slug: "waves_of_poseidon",
        name: "Waves of Poseidon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wheel_of_happiness": {
        slug: "wheel_of_happiness",
        name: "Wheel of Happiness",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wheel_ogold": {
        slug: "wheel_ogold",
        name: "Wheel O'Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_beach_party": {
        slug: "wild_beach_party",
        name: "Wild Beach Party",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_bison_charge": {
        slug: "wild_bison_charge",
        name: "Wild Bison Charge",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_booster": {
        slug: "wild_booster",
        name: "Wild Booster",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_celebrity_bus_megaways": {
        slug: "wild_celebrity_bus_megaways",
        name: "Wild Celebrity Bus Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_depths": {
        slug: "wild_depths",
        name: "Wild Depths",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_gladiator": {
        slug: "wild_gladiator",
        name: "Wild Gladiator",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_hop_and_drop": {
        slug: "wild_hop_and_drop",
        name: "Wild Hop and Drop",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_pixies": {
        slug: "wild_pixies",
        name: "Wild Pixies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_skullz": {
        slug: "wild_skullz",
        name: "Wild Skullz",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_spells": {
        slug: "wild_spells",
        name: "Wild Spells",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_walker": {
        slug: "wild_walker",
        name: "Wild Walker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold": {
        slug: "wild_west_gold",
        name: "Wild West Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold_blazing_bounty": {
        slug: "wild_west_gold_blazing_bounty",
        name: "Wild West Gold Blazing Bounty",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_west_gold_megaways": {
        slug: "wild_west_gold_megaways",
        name: "Wild West Gold Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_bananas": {
        slug: "wild_wild_bananas",
        name: "Wild Wild Bananas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_joker": {
        slug: "wild_wild_joker",
        name: "Wild Wild Joker",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_pearls": {
        slug: "wild_wild_pearls",
        name: "Wild Wild Pearls",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_riches": {
        slug: "wild_wild_riches",
        name: "Wild Wild Riches",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wild_riches_returns": {
        slug: "wild_wild_riches_returns",
        name: "Wild Wild Riches Returns",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wild_wildebeest_wins": {
        slug: "wild_wildebeest_wins",
        name: "Wild Wildebeest Wins",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wildies": {
        slug: "wildies",
        name: "Wildies",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena": {
        slug: "wisdom_of_athena",
        name: "Wisdom of Athena",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena_1000": {
        slug: "wisdom_of_athena_1000",
        name: "Wisdom of Athena 1000",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wisdom_of_athena_1000_xmas": {
        slug: "wisdom_of_athena_1000_xmas",
        name: "Wisdom of Athena 1000 Xmas",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/witch_heart_megaways": {
        slug: "witch_heart_megaways",
        name: "Witch Heart Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold": {
        slug: "wolf_gold",
        name: "Wolf Gold",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold_4_pack": {
        slug: "wolf_gold_4_pack",
        name: "Wolf Gold 4 Pack",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wolf_gold_ultimate": {
        slug: "wolf_gold_ultimate",
        name: "Wolf Gold Ultimate",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/wukong_rush": {
        slug: "wukong_rush",
        name: "Wukong Rush",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/year_of_the_dragon_king": {
        slug: "year_of_the_dragon_king",
        name: "Year of the Dragon King",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/yeti_quest": {
        slug: "yeti_quest",
        name: "Yeti Quest",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/you_can_piggy_bank_on_it": {
        slug: "you_can_piggy_bank_on_it",
        name: "You Can Piggy Bank On It",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/yum_yum_powerways": {
        slug: "yum_yum_powerways",
        name: "Yum Yum Powerways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_hades_gods_of_war": {
        slug: "zeus_vs_hades_gods_of_war",
        name: "Zeus vs Hades Gods of War",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_hades_gods_of_war_250": {
        slug: "zeus_vs_hades_gods_of_war_250",
        name: "Zeus vs Hades Gods of War 250",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zeus_vs_typhoon": {
        slug: "zeus_vs_typhoon",
        name: "Zeus vs Typhoon",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_carnival": {
        slug: "zombie_carnival",
        name: "Zombie Carnival",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_school_megaways": {
        slug: "zombie_school_megaways",
        name: "Zombie School Megaways",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "pragmatic-play/zombie_train": {
        slug: "zombie_train",
        name: "Zombie Train",
        provider: "Pragmatic Play",
        providerSlug: "pragmatic-play"
    },
    "print-studios/12_burning_baseballs": {
        slug: "12_burning_baseballs",
        name: "12 Burning Baseballs",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/big_stack_lumberjack": {
        slug: "big_stack_lumberjack",
        name: "Big Stack Lumberjack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/big_stack_nutcrack": {
        slug: "big_stack_nutcrack",
        name: "Big Stack Nutcrack",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/book_of_destiny": {
        slug: "book_of_destiny",
        name: "Book of Destiny",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/cash_defense": {
        slug: "cash_defense",
        name: "Cash Defense",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/chomplings": {
        slug: "chomplings",
        name: "Chomplings",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/crystal_golem": {
        slug: "crystal_golem",
        name: "Crystal Golem",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/darkness": {
        slug: "darkness",
        name: "Darkness",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/deck_of_divinity": {
        slug: "deck_of_divinity",
        name: "Deck of Divinity",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/deck_of_scurra": {
        slug: "deck_of_scurra",
        name: "Deck of Scurra",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/dreadworks": {
        slug: "dreadworks",
        name: "Dreadworks",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/eldritch_dungeon": {
        slug: "eldritch_dungeon",
        name: "Eldritch Dungeon",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/holy_hand_grenade": {
        slug: "holy_hand_grenade",
        name: "Holy Hand Grenade",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/holy_hand_grenade_2": {
        slug: "holy_hand_grenade_2",
        name: "Holy Hand Grenade 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/honey_hunters": {
        slug: "honey_hunters",
        name: "Honey Hunters",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/huntress_wild_vengeance": {
        slug: "huntress_wild_vengeance",
        name: "Huntress Wild Vengeance",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/out_of_the_ice": {
        slug: "out_of_the_ice",
        name: "Out of the Ice",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/phantom_pulse": {
        slug: "phantom_pulse",
        name: "Phantom Pulse",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pine_of_plinko": {
        slug: "pine_of_plinko",
        name: "Pine of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pine_of_plinko_2": {
        slug: "pine_of_plinko_2",
        name: "Pine of Plinko 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/pond_of_plinko": {
        slug: "pond_of_plinko",
        name: "Pond of Plinko",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/punk_penguin": {
        slug: "punk_penguin",
        name: "Punk Penguin",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/reapers": {
        slug: "reapers",
        name: "Reapers",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/royal_potato": {
        slug: "royal_potato",
        name: "Royal Potato",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/royal_potato_2": {
        slug: "royal_potato_2",
        name: "Royal Potato 2",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/royal_potato_dream_drop": {
        slug: "royal_potato_dream_drop",
        name: "Royal Potato Dream Drop",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/shinobi_spirit": {
        slug: "shinobi_spirit",
        name: "Shinobi Spirit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/tarasque": {
        slug: "tarasque",
        name: "Tarasque",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/uncle_profit": {
        slug: "uncle_profit",
        name: "Uncle Profit",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "print-studios/wino_mart": {
        slug: "wino_mart",
        name: "Win-O Mart",
        provider: "Print Studios",
        providerSlug: "print-studios"
    },
    "prospectgaming/3_dragon_pots": {
        slug: "3_dragon_pots",
        name: "3 Dragon Pots",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat": {
        slug: "arriba_heat",
        name: "Arriba Heat",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat_fuego_fortunes": {
        slug: "arriba_heat_fuego_fortunes",
        name: "Arriba Heat Fuego Fortunes",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/arriba_heat_megaways": {
        slug: "arriba_heat_megaways",
        name: "Arriba Heat Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/blood_moon_hold_and_win": {
        slug: "blood_moon_hold_and_win",
        name: "Blood Moon Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/burn_in_hell": {
        slug: "burn_in_hell",
        name: "Burn in Hell",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/burn_in_love": {
        slug: "burn_in_love",
        name: "Burn in Love",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/cleopatra_wilds_hold_and_win": {
        slug: "cleopatra_wilds_hold_and_win",
        name: "Cleopatra Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/diamond_surge": {
        slug: "diamond_surge",
        name: "Diamond Surge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/fruit_coins_hold_and_win": {
        slug: "fruit_coins_hold_and_win",
        name: "Fruit Coins Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/fruit_double_wins": {
        slug: "fruit_double_wins",
        name: "Fruit Double Wins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/ghost_huntin": {
        slug: "ghost_huntin",
        name: "Ghost Huntin",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits": {
        slug: "hot_joker_fruits",
        name: "Hot Joker Fruits",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_hold_and_win": {
        slug: "hot_joker_fruits_hold_and_win",
        name: "Hot Joker Fruits Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_scatter_pays": {
        slug: "hot_joker_fruits_scatter_pays",
        name: "Hot Joker Fruits Scatter Pays",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/hot_joker_fruits_stacks": {
        slug: "hot_joker_fruits_stacks",
        name: "Hot Joker Fruits Stacks",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/jokers_bar": {
        slug: "jokers_bar",
        name: "Joker's Bar",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/jokers_edge": {
        slug: "jokers_edge",
        name: "Joker's Edge",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/kings_relics": {
        slug: "kings_relics",
        name: "King's Relics",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/leprechaun_charms_hold_and_win": {
        slug: "leprechaun_charms_hold_and_win",
        name: "Leprechaun Charms Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/minted_coins": {
        slug: "minted_coins",
        name: "Minted Coins",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds": {
        slug: "prospector_wilds",
        name: "Prospector Wilds",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_get_lit": {
        slug: "prospector_wilds_get_lit",
        name: "Prospector Wilds: Get Lit!",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_gold_digga": {
        slug: "prospector_wilds_gold_digga",
        name: "Prospector Wilds: Gold Digga",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_hold_and_blitz": {
        slug: "prospector_wilds_hold_and_blitz",
        name: "Prospector Wilds Hold and Blitz",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_hold_and_win": {
        slug: "prospector_wilds_hold_and_win",
        name: "Prospector Wilds Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_megaways": {
        slug: "prospector_wilds_megaways",
        name: "Prospector Wilds Megaways",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_minecart_madness": {
        slug: "prospector_wilds_minecart_madness",
        name: "Prospector Wilds Minecart Madness",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/prospector_wilds_wild_carts": {
        slug: "prospector_wilds_wild_carts",
        name: "Prospector Wilds: Wild Carts",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/solar_nova_hold_and_win": {
        slug: "solar_nova_hold_and_win",
        name: "Solar Nova Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/super_upgrade_joker": {
        slug: "super_upgrade_joker",
        name: "Super Upgrade Joker",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/sweet_candy_cash": {
        slug: "sweet_candy_cash",
        name: "Sweet Candy Cash",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "prospectgaming/waikiki_hold_and_win": {
        slug: "waikiki_hold_and_win",
        name: "Waikiki Hold and Win",
        provider: "ProspectGaming",
        providerSlug: "prospectgaming"
    },
    "quickspin/adventures_beyond_wonderland_magical_maze": {
        slug: "adventures_beyond_wonderland_magical_maze",
        name: "Adventures Beyond Wonderland Magical Maze",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/arcane_gems": {
        slug: "arcane_gems",
        name: "Arcane Gems",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ark_of_mystery": {
        slug: "ark_of_mystery",
        name: "Ark of Mystery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/artemis_vs_medusa": {
        slug: "artemis_vs_medusa",
        name: "Artemis vs Medusa",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/azticons_chaos_clusters": {
        slug: "azticons_chaos_clusters",
        name: "Azticons Chaos Clusters",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf": {
        slug: "big_bad_wolf",
        name: "Big Bad Wolf",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_christmas_special": {
        slug: "big_bad_wolf_christmas_special",
        name: "Big Bad Wolf Christmas Special",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_megaways": {
        slug: "big_bad_wolf_megaways",
        name: "Big Bad Wolf Megaways",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bad_wolf_pigs_of_steel": {
        slug: "big_bad_wolf_pigs_of_steel",
        name: "Big Bad Wolf Pigs of Steel",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/big_bot_crew": {
        slug: "big_bot_crew",
        name: "Big Bot Crew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/blue_fortune": {
        slug: "blue_fortune",
        name: "Blue Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/book_of_duat": {
        slug: "book_of_duat",
        name: "Book of Duat",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/book_of_yuletide": {
        slug: "book_of_yuletide",
        name: "Book of Yuletide",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brawlers_bar_cash_collect": {
        slug: "brawlers_bar_cash_collect",
        name: "Brawlers Bar Cash Collect",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brawlers_brew": {
        slug: "brawlers_brew",
        name: "Brawlers Brew",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/brooklyn_bootleggers": {
        slug: "brooklyn_bootleggers",
        name: "Brooklyn Bootleggers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cabin_crashers": {
        slug: "cabin_crashers",
        name: "Cabin Crashers",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/candy_glyph": {
        slug: "candy_glyph",
        name: "Candy Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck": {
        slug: "cash_truck",
        name: "Cash Truck",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_2": {
        slug: "cash_truck_2",
        name: "Cash Truck 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_3_turbo": {
        slug: "cash_truck_3_turbo",
        name: "Cash Truck 3 Turbo",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_begins": {
        slug: "cash_truck_begins",
        name: "Cash Truck Begins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/cash_truck_xmas_delivery": {
        slug: "cash_truck_xmas_delivery",
        name: "Cash Truck Xmas Delivery",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crown_of_valor": {
        slug: "crown_of_valor",
        name: "Crown of Valor",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crystal_prince": {
        slug: "crystal_prince",
        name: "Crystal Prince",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/crystal_queen": {
        slug: "crystal_queen",
        name: "Crystal Queen",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/diamond_duke": {
        slug: "diamond_duke",
        name: "Diamond Duke",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dinosaur_rage": {
        slug: "dinosaur_rage",
        name: "Dinosaur Rage",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/divine_dreams": {
        slug: "divine_dreams",
        name: "Divine Dreams",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dragon_chase": {
        slug: "dragon_chase",
        name: "Dragon Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dragon_shrine": {
        slug: "dragon_shrine",
        name: "Dragon Shrine",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/durian_dynamite": {
        slug: "durian_dynamite",
        name: "Durian Dynamite",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/dwarfs_gone_wild": {
        slug: "dwarfs_gone_wild",
        name: "Dwarfs Gone Wild",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/eastern_emeralds": {
        slug: "eastern_emeralds",
        name: "Eastern Emeralds",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/epic_fish_adventure": {
        slug: "epic_fish_adventure",
        name: "Epic Fish Adventure",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/epic_fish_marlin_madness": {
        slug: "epic_fish_marlin_madness",
        name: "Epic Fish Marlin Madness",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/fairy_gate": {
        slug: "fairy_gate",
        name: "Fairy Gate",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/feasting_fox": {
        slug: "feasting_fox",
        name: "Feasting Fox",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/fire_tale": {
        slug: "fire_tale",
        name: "Fire Tale",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/genies_touch": {
        slug: "genies_touch",
        name: "Genies Touch",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ghost_glyph": {
        slug: "ghost_glyph",
        name: "Ghost Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/gloria_invicta": {
        slug: "gloria_invicta",
        name: "Gloria Invicta",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph": {
        slug: "golden_glyph",
        name: "Golden Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph_2": {
        slug: "golden_glyph_2",
        name: "Golden Glyph 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/golden_glyph_3": {
        slug: "golden_glyph_3",
        name: "Golden Glyph 3",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/goldilocks": {
        slug: "goldilocks",
        name: "Goldilocks",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/guardian_of_athens": {
        slug: "guardian_of_athens",
        name: "Guardian of athens",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hall_of_the_mountain_king": {
        slug: "hall_of_the_mountain_king",
        name: "Hall of the Mountain King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hammer_of_vulcan": {
        slug: "hammer_of_vulcan",
        name: "Hammer of Vulcan",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hidden_valley_120": {
        slug: "hidden_valley_120",
        name: "Hidden Valley 120",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/high_street_heist": {
        slug: "high_street_heist",
        name: "High Street Heist",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/honeylocks_pots": {
        slug: "honeylocks_pots",
        name: "Honeylocks Pots",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/hot_sync": {
        slug: "hot_sync",
        name: "Hot Sync",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ivan_and_the_immortal_king": {
        slug: "ivan_and_the_immortal_king",
        name: "Ivan and the Immortal King",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/joker_strike": {
        slug: "joker_strike",
        name: "Joker Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/king_colossus": {
        slug: "king_colossus",
        name: "King Colossus",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/leprechaun_hills": {
        slug: "leprechaun_hills",
        name: "Leprechaun Hills",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/loco_the_monkey": {
        slug: "loco_the_monkey",
        name: "Loco The Monkey",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/mayana": {
        slug: "mayana",
        name: "Mayana",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/midas_coins": {
        slug: "midas_coins",
        name: "Midas Coins",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/mighty_arthur": {
        slug: "mighty_arthur",
        name: "Mighty Arthur",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/neros_fortune": {
        slug: "neros_fortune",
        name: "Nero's Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/northern_sky": {
        slug: "northern_sky",
        name: "Northern Sky",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/panthers_reign": {
        slug: "panthers_reign",
        name: "Panthers Reign",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pearl_o_plinko": {
        slug: "pearl_o_plinko",
        name: "Pearl O Plinko",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pearl_o_plinko_mermaid": {
        slug: "pearl_o_plinko_mermaid",
        name: "Pearl O Plinko Mermaid",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/phoenix_sun": {
        slug: "phoenix_sun",
        name: "Phoenix Sun",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pied_piper": {
        slug: "pied_piper",
        name: "Pied Piper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pineapple_crush": {
        slug: "pineapple_crush",
        name: "Pineapple Crush",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/pirates_charm": {
        slug: "pirates_charm",
        name: "Pirate's Charm",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/polar_paws": {
        slug: "polar_paws",
        name: "Polar Paws",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/prime_zone": {
        slug: "prime_zone",
        name: "Prime Zone",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/rapunzels_tower": {
        slug: "rapunzels_tower",
        name: "Rapunzel's Tower",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/razortooth": {
        slug: "razortooth",
        name: "Razortooth",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/reel_nightmare": {
        slug: "reel_nightmare",
        name: "Reel Nightmare",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/reno_7s": {
        slug: "reno_7s",
        name: "Reno 7's",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/robbits_94": {
        slug: "robbits_94",
        name: "Robbits 94",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune": {
        slug: "sakura_fortune",
        name: "Sakura Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune_2": {
        slug: "sakura_fortune_2",
        name: "Sakura Fortune 2",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sakura_fortune_epic_bloom": {
        slug: "sakura_fortune_epic_bloom",
        name: "Sakura Fortune Epic Bloom",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/scepter_of_anubis": {
        slug: "scepter_of_anubis",
        name: "Scepter of Anubis",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/second_strike": {
        slug: "second_strike",
        name: "Second Strike",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sevens_high": {
        slug: "sevens_high",
        name: "Sevens High",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sevens_high_ultra": {
        slug: "sevens_high_ultra",
        name: "Sevens High Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/shields_of_lambda": {
        slug: "shields_of_lambda",
        name: "Shields of Lambda",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sinbad": {
        slug: "sinbad",
        name: "Sinbad",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/skulls_up": {
        slug: "skulls_up",
        name: "Skulls UP!",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/slugger_time": {
        slug: "slugger_time",
        name: "Slugger Time",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/spinions": {
        slug: "spinions",
        name: "Spinions",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/spinions_xmas_party": {
        slug: "spinions_xmas_party",
        name: "Spinions x-mas party",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits": {
        slug: "sticky_bandits",
        name: "Sticky Bandits",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_3_most_wanted": {
        slug: "sticky_bandits_3_most_wanted",
        name: "Sticky Bandits 3 Most Wanted",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_thunder_rail": {
        slug: "sticky_bandits_thunder_rail",
        name: "Sticky Bandits Thunder Rail",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_trail_of_blood": {
        slug: "sticky_bandits_trail_of_blood",
        name: "Sticky Bandits Trail of Blood",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_unchained": {
        slug: "sticky_bandits_unchained",
        name: "Sticky Bandits Unchained",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/sticky_bandits_wild_return": {
        slug: "sticky_bandits_wild_return",
        name: "Sticky Bandits: Wild return",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tales_of_dr_dolittle": {
        slug: "tales_of_dr_dolittle",
        name: "Tales of Dr. dolittle",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/temple_of_paw": {
        slug: "temple_of_paw",
        name: "Temple of Paw",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_grand": {
        slug: "the_grand",
        name: "The Grand",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_grim_reaper": {
        slug: "the_grim_reaper",
        name: "The Grim Reaper",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/the_wild_chase": {
        slug: "the_wild_chase",
        name: "The Wild Chase",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/ticket_to_the_stars": {
        slug: "ticket_to_the_stars",
        name: "Ticket to the stars",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tigers_glory": {
        slug: "tigers_glory",
        name: "Tiger's Glory",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/tigers_glory_ultra": {
        slug: "tigers_glory_ultra",
        name: "Tiger's Glory Ultra",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/treasure_island": {
        slug: "treasure_island",
        name: "Treasure Island",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/vampire_senpai": {
        slug: "vampire_senpai",
        name: "Vampire Senpai",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/volcano_riches": {
        slug: "volcano_riches",
        name: "Volcano Riches",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/warp_wreckers_power_glyph": {
        slug: "warp_wreckers_power_glyph",
        name: "Warp Wreckers Power Glyph",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_beans": {
        slug: "wild_beans",
        name: "Wild Beans",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_cauldron": {
        slug: "wild_cauldron",
        name: "Wild Cauldron",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_chase_tokyo_go": {
        slug: "wild_chase_tokyo_go",
        name: "Wild Chase: Tokyo Go",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_harlequin": {
        slug: "wild_harlequin",
        name: "Wild Harlequin",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_luchador": {
        slug: "wild_luchador",
        name: "Wild Luchador",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wild_tome_of_the_woods": {
        slug: "wild_tome_of_the_woods",
        name: "Wild Tome of the Woods",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "quickspin/wins_of_fortune": {
        slug: "wins_of_fortune",
        name: "Wins of Fortune",
        provider: "Quickspin",
        providerSlug: "quickspin"
    },
    "ready-play-gaming/2_can_party_reel_triple": {
        slug: "2_can_party_reel_triple",
        name: "2 Can Party Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/20000_leagues": {
        slug: "20000_leagues",
        name: "20000 Leagues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/african_rhino": {
        slug: "african_rhino",
        name: "African Rhino",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/blazn_buffalo": {
        slug: "blazn_buffalo",
        name: "Blazn Buffalo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/blazn_buffalo_reel_crash": {
        slug: "blazn_buffalo_reel_crash",
        name: "Blaz’n Buffalo Reel Crash",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/blazn_buffalo_super_reels": {
        slug: "blazn_buffalo_super_reels",
        name: "Blazn Buffalo Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/cosmonaut": {
        slug: "cosmonaut",
        name: "Cosmonaut",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/dance_of_the_dead": {
        slug: "dance_of_the_dead",
        name: "Dance Of The Dead",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars": {
        slug: "deep_sea_dollars",
        name: "Deep Sea Dollars",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars_reel_bingo": {
        slug: "deep_sea_dollars_reel_bingo",
        name: "Deep Sea Dollars Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_sea_dollars_reel_triple": {
        slug: "deep_sea_dollars_reel_triple",
        name: "Deep Sea Dollars Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/deep_seas_dollars_super_reels": {
        slug: "deep_seas_dollars_super_reels",
        name: "Deep Seas Dollars Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/dolphin_bay": {
        slug: "dolphin_bay",
        name: "Dolphin Bay",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/fast_fortune": {
        slug: "fast_fortune",
        name: "Fast Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_diggin": {
        slug: "gold_diggin",
        name: "Gold Diggin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_diggin_super_spinner": {
        slug: "gold_diggin_super_spinner",
        name: "Gold Diggin’ Super Spinner",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/gold_train": {
        slug: "gold_train",
        name: "Gold Train",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/golden_elephant": {
        slug: "golden_elephant",
        name: "Golden Elephant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/golden_sabre": {
        slug: "golden_sabre",
        name: "Golden Sabre",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/happy_lucky": {
        slug: "happy_lucky",
        name: "Happy Lucky",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/its_alive": {
        slug: "its_alive",
        name: "It's Alive",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jack_and_the_giant": {
        slug: "jack_and_the_giant",
        name: "Jack and the Giant",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jackpot_hits": {
        slug: "jackpot_hits",
        name: "Jackpot Hits",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_reel_triple": {
        slug: "jungle_fever_reel_triple",
        name: "Jungle Fever Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_super_reels": {
        slug: "jungle_fever_super_reels",
        name: "Jungle Fever Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_fever_v2_reel_bingo": {
        slug: "jungle_fever_v2_reel_bingo",
        name: "Jungle Fever V2 Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_hunt": {
        slug: "jungle_hunt",
        name: "Jungle Hunt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/jungle_jive_v2_snakes_and_ladders": {
        slug: "jungle_jive_v2_snakes_and_ladders",
        name: "Jungle Jive V2 Snakes and Ladders",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lobster_pots": {
        slug: "lobster_pots",
        name: "Lobster Pots",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lost_in_the_wild_reel_bingo": {
        slug: "lost_in_the_wild_reel_bingo",
        name: "Lost in the Wild Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/lucky_turtle": {
        slug: "lucky_turtle",
        name: "Lucky Turtle",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/master_of_elements": {
        slug: "master_of_elements",
        name: "Master Of Elements",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_medusa": {
        slug: "mighty_medusa",
        name: "Mighty Medusa",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_zeus_reel_triple": {
        slug: "mighty_zeus_reel_triple",
        name: "Mighty Zeus Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/mighty_zeus_super_reels": {
        slug: "mighty_zeus_super_reels",
        name: "Mighty Zeus Super Reels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/montezumas_quest": {
        slug: "montezumas_quest",
        name: "Montezumas Quest",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/moonlight_panda": {
        slug: "moonlight_panda",
        name: "Moonlight Panda",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/more_candy": {
        slug: "more_candy",
        name: "More Candy",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/navajo_legend": {
        slug: "navajo_legend",
        name: "Navajo Legend",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/night_in_egypt": {
        slug: "night_in_egypt",
        name: "Night in Egypt",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/poco_loco_hot_hot_chili_climb": {
        slug: "poco_loco_hot_hot_chili_climb",
        name: "Poco Loco Hot Hot Chili Climb",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/power_pets": {
        slug: "power_pets",
        name: "Power Pets",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/pyramids_of_cash_reel_bingo": {
        slug: "pyramids_of_cash_reel_bingo",
        name: "Pyramids Of Cash Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/pyramids_of_gold": {
        slug: "pyramids_of_gold",
        name: "Pyramids of Gold",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/raiders_of_the_sea": {
        slug: "raiders_of_the_sea",
        name: "Raiders of the Sea",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_rb": {
        slug: "ready_yeti_go_rb",
        name: "Ready Yeti Go RB",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_reel_bingo": {
        slug: "ready_yeti_go_reel_bingo",
        name: "Ready Yeti Go Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_go_respin": {
        slug: "ready_yeti_go_respin",
        name: "Ready Yeti Go Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_respin": {
        slug: "ready_yeti_respin",
        name: "Ready Yeti Respin",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/ready_yeti_respin_chasing_cheddar": {
        slug: "ready_yeti_respin_chasing_cheddar",
        name: "Ready Yeti Respin Chasing Cheddar",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/reels_2_riches": {
        slug: "reels_2_riches",
        name: "Reels 2 Riches",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/reels_2_riches_reel_triple": {
        slug: "reels_2_riches_reel_triple",
        name: "Reels 2 Riches Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/rise_of_the_pharaohs": {
        slug: "rise_of_the_pharaohs",
        name: "Rise of the Pharaohs",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/river_n_blues": {
        slug: "river_n_blues",
        name: "River n' Blues",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/road_trip": {
        slug: "road_trip",
        name: "Road Trip",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/romeo_and_juliet": {
        slug: "romeo_and_juliet",
        name: "Romeo and Juliet",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/royal_dragon": {
        slug: "royal_dragon",
        name: "Royal Dragon",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sinbads_fortune": {
        slug: "sinbads_fortune",
        name: "Sinbad's Fortune",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/siren_of_the_deep": {
        slug: "siren_of_the_deep",
        name: "Siren of the Deep",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sky_pirates": {
        slug: "sky_pirates",
        name: "Sky Pirates",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/spin_carnival": {
        slug: "spin_carnival",
        name: "Spin Carnival",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/sticky_feet_reel_bingo": {
        slug: "sticky_feet_reel_bingo",
        name: "Sticky Feet Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/tarzan": {
        slug: "tarzan",
        name: "Tarzan",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/tarzan_super_spinner": {
        slug: "tarzan_super_spinner",
        name: "Tarzan Super Spinner",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_awakening": {
        slug: "the_awakening",
        name: "The Awakening",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_big_five": {
        slug: "the_big_five",
        name: "The Big Five",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_last_dynasty": {
        slug: "the_last_dynasty",
        name: "The Last Dynasty",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/the_lost_idol_v2": {
        slug: "the_lost_idol_v2",
        name: "The Lost Idol V2",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/thundering_hearts": {
        slug: "thundering_hearts",
        name: "Thundering Hearts",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/tiki_bar_reel_bingo": {
        slug: "tiki_bar_reel_bingo",
        name: "Tiki Bar Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/two_can_party_superreels": {
        slug: "two_can_party_superreels",
        name: "Two Can Party SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/unicorn_dreams": {
        slug: "unicorn_dreams",
        name: "Unicorn Dreams",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/way_of_the_tiger": {
        slug: "way_of_the_tiger",
        name: "Way of the Tiger",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion": {
        slug: "wild_lion",
        name: "Wild Lion",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_reel_bingo": {
        slug: "wild_lion_reel_bingo",
        name: "Wild Lion Reel Bingo",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_reel_triple": {
        slug: "wild_lion_reel_triple",
        name: "Wild Lion Reel Triple",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wild_lion_superreels": {
        slug: "wild_lion_superreels",
        name: "Wild Lion SuperReels",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/winning_bull": {
        slug: "winning_bull",
        name: "Winning Bull",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "ready-play-gaming/wolf_pack": {
        slug: "wolf_pack",
        name: "Wolf Pack",
        provider: "Ready Play Gaming",
        providerSlug: "ready-play-gaming"
    },
    "reelplay/10000_wonders_10k_ways": {
        slug: "10000_wonders_10k_ways",
        name: "10,000 Wonders 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders_big_bang": {
        slug: "10000_wonders_big_bang",
        name: "10000 Wonders Big Bang",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/10000_wonders_multimax": {
        slug: "10000_wonders_multimax",
        name: "10000 Wonders Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/24k_gold_jailbreak": {
        slug: "24k_gold_jailbreak",
        name: "24K Gold Jailbreak",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/24k_gold_shamrock_on": {
        slug: "24k_gold_shamrock_on",
        name: "24K Gold Shamrock On",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/3_wonders_grillmaster_grizzly": {
        slug: "3_wonders_grillmaster_grizzly",
        name: "3 Wonders Grillmaster Grizzly",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/3_wonders_new_year_carnival": {
        slug: "3_wonders_new_year_carnival",
        name: "3 Wonders New Year Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/3_wonders_robin_hood": {
        slug: "3_wonders_robin_hood",
        name: "3 Wonders Robin Hood",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/american_outlaws_multimax": {
        slug: "american_outlaws_multimax",
        name: "American Outlaws Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/armageddon_10k_ways": {
        slug: "armageddon_10k_ways",
        name: "Armageddon 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/atlantis_megaways": {
        slug: "atlantis_megaways",
        name: "Atlantis Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/aztec_gigablox": {
        slug: "aztec_gigablox",
        name: "Aztec Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_barn_bucks": {
        slug: "big_barn_bucks",
        name: "Big Barn Bucks",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_bandits_megaways": {
        slug: "big_bucks_bandits_megaways",
        name: "Big Bucks Bandits Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_bison_10k_ways": {
        slug: "big_bucks_bison_10k_ways",
        name: "Big Bucks Bison 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/big_bucks_buffalo_gigablox": {
        slug: "big_bucks_buffalo_gigablox",
        name: "Big Bucks Buffalo Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/bucks_and_doe_10k_ways": {
        slug: "bucks_and_doe_10k_ways",
        name: "Bucks and Doe 10k Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/buster_hammer_carnival": {
        slug: "buster_hammer_carnival",
        name: "Buster Hammer Carnival",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/castle_cash_megaways": {
        slug: "castle_cash_megaways",
        name: "Castle Cash Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/dolphin_hot_1": {
        slug: "dolphin_hot_1",
        name: "Dolphin Hot 1",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/dragons_vs_gigablox": {
        slug: "dragons_vs_gigablox",
        name: "Dragons vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/excalibur_vs_gigablox": {
        slug: "excalibur_vs_gigablox",
        name: "Excalibur vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/frankenstein_wild_surge": {
        slug: "frankenstein_wild_surge",
        name: "Frankenstein Wild Surge",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/fruit_combinator": {
        slug: "fruit_combinator",
        name: "Fruit Combinator",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/fruit_gemz_splitz": {
        slug: "fruit_gemz_splitz",
        name: "Fruit Gemz Splitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/giga_bass_gigablox": {
        slug: "giga_bass_gigablox",
        name: "Giga Bass GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/goblin_grand": {
        slug: "goblin_grand",
        name: "Goblin Grand",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/goblins_bargain_multimax": {
        slug: "goblins_bargain_multimax",
        name: "Goblin's Bargain MultiMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gods_vs_gigablox": {
        slug: "gods_vs_gigablox",
        name: "Gods VS Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/gold_is_all_mine_10k_ways": {
        slug: "gold_is_all_mine_10k_ways",
        name: "Gold is All Mine 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/good_knight_fortune": {
        slug: "good_knight_fortune",
        name: "Good Knight Fortune",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hercules_10k_ways": {
        slug: "hercules_10k_ways",
        name: "Hercules 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hyper_respins": {
        slug: "hyper_respins",
        name: "Hyper Respins",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_10k_ways": {
        slug: "hypernova_10k_ways",
        name: "Hypernova 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/hypernova_megaways": {
        slug: "hypernova_megaways",
        name: "Hypernova Megaways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/joker_super_reels": {
        slug: "joker_super_reels",
        name: "Joker Super Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/king_arthur_10k_ways": {
        slug: "king_arthur_10k_ways",
        name: "King Arthur 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lady_merlin_multimax": {
        slug: "lady_merlin_multimax",
        name: "Lady Merlin Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/legend_of_dragon_wins_doublemax": {
        slug: "legend_of_dragon_wins_doublemax",
        name: "Legend of Dragon Wins Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lions_gigablox": {
        slug: "lions_gigablox",
        name: "Lions GigaBlox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/lucky_lady_leprechaun": {
        slug: "lucky_lady_leprechaun",
        name: "Lucky Lady Leprechaun",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mega_money_machine": {
        slug: "mega_money_machine",
        name: "Mega Money Machine",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mega_pearl_gigablox": {
        slug: "mega_pearl_gigablox",
        name: "Mega Pearl Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/monsters_vs_gigablox": {
        slug: "monsters_vs_gigablox",
        name: "Monsters vs Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mow_money": {
        slug: "mow_money",
        name: "Mow Money",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mow_money_multimax": {
        slug: "mow_money_multimax",
        name: "Mow Money Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/mystic_dolphin_charge_up": {
        slug: "mystic_dolphin_charge_up",
        name: "Mystic Dolphin Charge Up",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/nile_mystery_doublemax": {
        slug: "nile_mystery_doublemax",
        name: "Nile Mystery Doublemax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/odin_infinity_reels": {
        slug: "odin_infinity_reels",
        name: "Odin Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/odin_lightning_blitz": {
        slug: "odin_lightning_blitz",
        name: "Odin Lightning Blitz",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/orcas_wild_bonanza": {
        slug: "orcas_wild_bonanza",
        name: "Orca's Wild Bonanza",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pay_pig_10k_ways": {
        slug: "pay_pig_10k_ways",
        name: "Pay Pig 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pearl_reef_gigablox_multimax": {
        slug: "pearl_reef_gigablox_multimax",
        name: "Pearl Reef Gigablox Multimax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/pillage_the_village_10k_ways": {
        slug: "pillage_the_village_10k_ways",
        name: "Pillage The Village 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/primal_hunter_gigablox": {
        slug: "primal_hunter_gigablox",
        name: "Primal Hunter Gigablox",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/ramesses_gold_10k_ways": {
        slug: "ramesses_gold_10k_ways",
        name: "Ramesses Gold 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/shamrock_money_pot_10k_ways": {
        slug: "shamrock_money_pot_10k_ways",
        name: "Shamrock Money Pot 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/skylantis_2_wild_fight": {
        slug: "skylantis_2_wild_fight",
        name: "Skylantis 2 Wild Fight",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/the_good_farmer": {
        slug: "the_good_farmer",
        name: "The Good Farmer",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/the_wild_drifter": {
        slug: "the_wild_drifter",
        name: "The Wild Drifter",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/thor_infinity_reels": {
        slug: "thor_infinity_reels",
        name: "Thor Infinity Reels",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/tiger_doublemax": {
        slug: "tiger_doublemax",
        name: "Tiger DoubleMax",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/troy_superways": {
        slug: "troy_superways",
        name: "Troy Superways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/tsai_shen_10k_ways": {
        slug: "tsai_shen_10k_ways",
        name: "Tsai Shen 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/what_the_fruit": {
        slug: "what_the_fruit",
        name: "What the Fruit",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/wild_storm_legionnaire": {
        slug: "wild_storm_legionnaire",
        name: "Wild Storm Legionnaire",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reelplay/wizbang_brawl_10k_ways": {
        slug: "wizbang_brawl_10k_ways",
        name: "WizBang Brawl 10K Ways",
        provider: "ReelPlay",
        providerSlug: "reelplay"
    },
    "reflex-gaming/2_fast_2_fruity": {
        slug: "2_fast_2_fruity",
        name: "2 Fast 2 Fruity",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/5_clans": {
        slug: "5_clans",
        name: "5 Clans",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/8_balls_of_fire": {
        slug: "8_balls_of_fire",
        name: "8 Balls of Fire",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/8_balls_of_fire_blazing_bounty": {
        slug: "8_balls_of_fire_blazing_bounty",
        name: "8 Balls of Fire Blazing Bounty",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/anubis_ii_doublemax": {
        slug: "anubis_ii_doublemax",
        name: "Anubis II Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/bank_of_blarney_tophit": {
        slug: "bank_of_blarney_tophit",
        name: "Bank of Blarney TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_christmas_catch": {
        slug: "big_game_fishing_christmas_catch",
        name: "Big Game Fishing Christmas Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_golden_catch": {
        slug: "big_game_fishing_golden_catch",
        name: "Big Game Fishing Golden Catch",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_rapid_riches": {
        slug: "big_game_fishing_rapid_riches",
        name: "Big Game Fishing Rapid Riches",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/big_game_fishing_tophit": {
        slug: "big_game_fishing_tophit",
        name: "Big Game Fishing TopHit",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/bison_wilds_doublemax": {
        slug: "bison_wilds_doublemax",
        name: "Bison Wilds Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/book_of_blarney_gigablox": {
        slug: "book_of_blarney_gigablox",
        name: "Book of Blarney Gigablox",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/candy_crazed_pandas_double_max": {
        slug: "candy_crazed_pandas_double_max",
        name: "Candy Crazed Pandas Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/dead_lucky_duomax": {
        slug: "dead_lucky_duomax",
        name: "Dead Lucky DuoMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/desparate_dawgs": {
        slug: "desparate_dawgs",
        name: "Desparate Dawgs",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/diamond_miner_duomax": {
        slug: "diamond_miner_duomax",
        name: "Diamond Miner Duomax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/double_fruit_frenzy_doublemax": {
        slug: "double_fruit_frenzy_doublemax",
        name: "Double Fruit Frenzy Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/dublin_up_pots_o_gold_double_max": {
        slug: "dublin_up_pots_o_gold_double_max",
        name: "Dublin Up Pots O' Gold Double Max",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/fast_fruits_doublemax": {
        slug: "fast_fruits_doublemax",
        name: "Fast Fruits Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/get_kraken": {
        slug: "get_kraken",
        name: "Get Kraken",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/hells_hogs_2_squealin_wheels": {
        slug: "hells_hogs_2_squealin_wheels",
        name: "Hell's Hogs 2 Squealin' Wheels",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/hot_diggity_dog_fortune_map": {
        slug: "hot_diggity_dog_fortune_map",
        name: "Hot Diggity Dog Fortune Map",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/jacks_beanstalk_bonanza": {
        slug: "jacks_beanstalk_bonanza",
        name: "Jack's Beanstalk Bonanza",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/paddys_pool_party": {
        slug: "paddys_pool_party",
        name: "Paddy's Pool Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/piggies_prize_party": {
        slug: "piggies_prize_party",
        name: "Piggies Prize Party",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/purrfect_potions": {
        slug: "purrfect_potions",
        name: "Purrfect Potions",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/redbeards_rum_runners_doublemax": {
        slug: "redbeards_rum_runners_doublemax",
        name: "Redbeards Rum Runners Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/secret_of_anubis_doublemax": {
        slug: "secret_of_anubis_doublemax",
        name: "Secret of Anubis Doublemax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/secrets_of_the_golden_temple": {
        slug: "secrets_of_the_golden_temple",
        name: "Secrets of the Golden Temple",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/sidewinder_doublemax": {
        slug: "sidewinder_doublemax",
        name: "Sidewinder DoubleMax",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/sidewinder_xtra_power": {
        slug: "sidewinder_xtra_power",
        name: "Sidewinder Xtra Power",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "reflex-gaming/thors_hammer_time": {
        slug: "thors_hammer_time",
        name: "Thor's Hammer Time",
        provider: "Reflex Gaming",
        providerSlug: "reflex-gaming"
    },
    "relax-gaming/agroculture": {
        slug: "agroculture",
        name: "AgroCulture",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/ancient_tumble": {
        slug: "ancient_tumble",
        name: "Ancient Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/atlantis_crush": {
        slug: "atlantis_crush",
        name: "Atlantis Crush",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/attila_the_hun": {
        slug: "attila_the_hun",
        name: "Attila The Hun",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/aura_god": {
        slug: "aura_god",
        name: "Aura God",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/aussies_vs_emus": {
        slug: "aussies_vs_emus",
        name: "Aussies vs Emus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bacon_bankroll": {
        slug: "bacon_bankroll",
        name: "Bacon Bankroll",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/banana_town": {
        slug: "banana_town",
        name: "Banana Town",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/beast_gains": {
        slug: "beast_gains",
        name: "Beast Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/beast_mode": {
        slug: "beast_mode",
        name: "Beast Mode",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/beellionaires": {
        slug: "beellionaires",
        name: "Beellionaires",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bill_and_coin": {
        slug: "bill_and_coin",
        name: "Bill & Coin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bill_and_coin_2": {
        slug: "bill_and_coin_2",
        name: "Bill and Coin 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blackjack_6_decks": {
        slug: "blackjack_6_decks",
        name: "Blackjack 6 Decks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blackjack_neo": {
        slug: "blackjack_neo",
        name: "Blackjack Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/blender_blitz": {
        slug: "blender_blitz",
        name: "Blender Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bone_raiders": {
        slug: "bone_raiders",
        name: "Bone Raiders",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bonsai_dragon_blitz": {
        slug: "bonsai_dragon_blitz",
        name: "Bonsai Dragon Blitz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/book_of": {
        slug: "book_of",
        name: "Book of",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/book_of_power": {
        slug: "book_of_power",
        name: "Book of Power",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/bounty_county": {
        slug: "bounty_county",
        name: "Bounty County",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/camelot_cash": {
        slug: "camelot_cash",
        name: "Camelot Cash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cash_in_transit": {
        slug: "cash_in_transit",
        name: "Cash in Transit",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/caveman_bob": {
        slug: "caveman_bob",
        name: "Caveman Bob",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/chip_spin": {
        slug: "chip_spin",
        name: "Chip Spin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cloudforge": {
        slug: "cloudforge",
        name: "Cloudforge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cluster_tumble": {
        slug: "cluster_tumble",
        name: "Cluster Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cod_of_thunder": {
        slug: "cod_of_thunder",
        name: "Cod of Thunder",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/conquer_babylon": {
        slug: "conquer_babylon",
        name: "Conquer Babylon",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/cowabunga": {
        slug: "cowabunga",
        name: "Cowabunga",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dead_mans_trail": {
        slug: "dead_mans_trail",
        name: "Dead Man's Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dead_riders_trail": {
        slug: "dead_riders_trail",
        name: "Dead Riders Trail",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/deep_descent": {
        slug: "deep_descent",
        name: "Deep Descent",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/diamonds": {
        slug: "diamonds",
        name: "Diamonds",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/dragons_awakening": {
        slug: "dragons_awakening",
        name: "Dragons' Awakening",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/emeralds_infinity_reels": {
        slug: "emeralds_infinity_reels",
        name: "Emerald's Infinity Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/epic_dreams": {
        slug: "epic_dreams",
        name: "Epic Dreams",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/epic_joker": {
        slug: "epic_joker",
        name: "Epic Joker",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/erik_the_red": {
        slug: "erik_the_red",
        name: "Erik the Red",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/fangs_inferno": {
        slug: "fangs_inferno",
        name: "Fang's Inferno",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/feather_fury": {
        slug: "feather_fury",
        name: "Feather Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/firewins_factory": {
        slug: "firewins_factory",
        name: "FireWins Factory",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/fly_cat": {
        slug: "fly_cat",
        name: "Fly Cat$",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/franks_diner": {
        slug: "franks_diner",
        name: "Frank's Diner",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/freaked_out_fish": {
        slug: "freaked_out_fish",
        name: "Freaked Out Fish",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/frequent_flyer": {
        slug: "frequent_flyer",
        name: "Frequent Flyer",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/galactic_racers": {
        slug: "galactic_racers",
        name: "Galactic Racers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/giants_and_sheep": {
        slug: "giants_and_sheep",
        name: "Giants and Sheep",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/grim_the_splitter": {
        slug: "grim_the_splitter",
        name: "Grim The Splitter",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/groovy_knights": {
        slug: "groovy_knights",
        name: "Groovy Knights",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/guitar_quest": {
        slug: "guitar_quest",
        name: "Guitar Quest",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hazakura_ways": {
        slug: "hazakura_ways",
        name: "Hazakura Ways",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/helios_fury": {
        slug: "helios_fury",
        name: "Helios' Fury",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hellcatraz": {
        slug: "hellcatraz",
        name: "Hellcatraz",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hellcatraz_2": {
        slug: "hellcatraz_2",
        name: "Hellcatraz 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/heroes_gathering": {
        slug: "heroes_gathering",
        name: "Heroes Gathering",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hex": {
        slug: "hex",
        name: "Hex",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/horror_hotel": {
        slug: "horror_hotel",
        name: "Horror Hotel",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/hot_rod_racers": {
        slug: "hot_rod_racers",
        name: "Hot Rod Racers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/ignite_the_night": {
        slug: "ignite_the_night",
        name: "Ignite the Night",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/immortal_5": {
        slug: "immortal_5",
        name: "Immortal 5",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/iron_bank": {
        slug: "iron_bank",
        name: "Iron Bank",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/iron_bank_2": {
        slug: "iron_bank_2",
        name: "Iron Bank 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/its_time": {
        slug: "its_time",
        name: "It's Time",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/joker_split": {
        slug: "joker_split",
        name: "Joker Split",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jumbo_juicy": {
        slug: "jumbo_juicy",
        name: "Jumbo Juicy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jupiters_choice": {
        slug: "jupiters_choice",
        name: "Jupiters Choice",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/jurassic_party": {
        slug: "jurassic_party",
        name: "Jurassic Party",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/king_of_kings": {
        slug: "king_of_kings",
        name: "King of Kings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/kluster_krystals_megaclusters": {
        slug: "kluster_krystals_megaclusters",
        name: "Kluster Krystals MegaClusters",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/krakens_cove": {
        slug: "krakens_cove",
        name: "Kraken's Cove",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/la_fiesta": {
        slug: "la_fiesta",
        name: "La Fiesta",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/legend_of_odysseus": {
        slug: "legend_of_odysseus",
        name: "Legend of Odysseus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/lets_get_ready_to_rumble": {
        slug: "lets_get_ready_to_rumble",
        name: "Let's Get Ready to Rumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/lure_of_fortune": {
        slug: "lure_of_fortune",
        name: "Lure of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/magawa_vs_mines": {
        slug: "magawa_vs_mines",
        name: "Magawa vs Mines",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/marching_legions": {
        slug: "marching_legions",
        name: "Marching Legions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/masked_treasures": {
        slug: "masked_treasures",
        name: "Masked Treasures",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_flip": {
        slug: "mega_flip",
        name: "Mega Flip",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_heist": {
        slug: "mega_heist",
        name: "Mega Heist",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_masks": {
        slug: "mega_masks",
        name: "Mega Masks",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mega_mine": {
        slug: "mega_mine",
        name: "Mega Mine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/midnight_marauder": {
        slug: "midnight_marauder",
        name: "Midnight Marauder",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/midnight_marauder_clusterbreaker": {
        slug: "midnight_marauder_clusterbreaker",
        name: "Midnight Marauder ClusterBreaker",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart": {
        slug: "money_cart",
        name: "Money Cart",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart_2": {
        slug: "money_cart_2",
        name: "Money Cart 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart_3": {
        slug: "money_cart_3",
        name: "Money Cart 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_cart_4": {
        slug: "money_cart_4",
        name: "Money Cart 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_plane": {
        slug: "money_plane",
        name: "Money Plane",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_sleigh": {
        slug: "money_sleigh",
        name: "Money Sleigh",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train": {
        slug: "money_train",
        name: "Money Train",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_2": {
        slug: "money_train_2",
        name: "Money Train 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_3": {
        slug: "money_train_3",
        name: "Money Train 3",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_4": {
        slug: "money_train_4",
        name: "Money Train 4",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_5": {
        slug: "money_train_5",
        name: "Money Train 5",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/money_train_origins": {
        slug: "money_train_origins",
        name: "Money Train Origins",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/monkey_gods_of_the_inca": {
        slug: "monkey_gods_of_the_inca",
        name: "Monkey Gods of the Inca",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/multiplier_odyssey": {
        slug: "multiplier_odyssey",
        name: "Multiplier Odyssey",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/mystic_multipliers": {
        slug: "mystic_multipliers",
        name: "Mystic Multipliers",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/napoleon_vs_rabbits": {
        slug: "napoleon_vs_rabbits",
        name: "Napoleon vs Rabbits",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/necromancers_gate": {
        slug: "necromancers_gate",
        name: "Necromancer's Gate",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/neko_night": {
        slug: "neko_night",
        name: "Neko Night",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/net_gains": {
        slug: "net_gains",
        name: "Net Gains",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/nugget_ridge": {
        slug: "nugget_ridge",
        name: "Nugget Ridge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/olympus_7s": {
        slug: "olympus_7s",
        name: "Olympus 7s",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/pharaohs_last_wish": {
        slug: "pharaohs_last_wish",
        name: "Pharaoh's Last Wish",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/pinata_popper": {
        slug: "pinata_popper",
        name: "Pinata Popper",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/plunderland": {
        slug: "plunderland",
        name: "Plunderland",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/powerspin": {
        slug: "powerspin",
        name: "Powerspin",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/purrrminator": {
        slug: "purrrminator",
        name: "Purrrminator",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/quackin_reels": {
        slug: "quackin_reels",
        name: "Quackin Reels",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/ramses_revenge": {
        slug: "ramses_revenge",
        name: "Ramses Revenge",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/roulette_neo": {
        slug: "roulette_neo",
        name: "Roulette Neo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sails_of_fortune": {
        slug: "sails_of_fortune",
        name: "Sails of Fortune",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/santas_stack": {
        slug: "santas_stack",
        name: "Santa's Stack",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/shark_wash": {
        slug: "shark_wash",
        name: "Shark Wash",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sloth_tumble": {
        slug: "sloth_tumble",
        name: "Sloth Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/snake_arena": {
        slug: "snake_arena",
        name: "Snake Arena",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/snake_arena_2": {
        slug: "snake_arena_2",
        name: "Snake Arena 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/snakes_gold": {
        slug: "snakes_gold",
        name: "Snakes Gold",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/space_miners": {
        slug: "space_miners",
        name: "Space Miners",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/spirit_of_the_beast": {
        slug: "spirit_of_the_beast",
        name: "Spirit of the Beast",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/st_louis_1904": {
        slug: "st_louis_1904",
        name: "St Louis 1904",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sultan_spins": {
        slug: "sultan_spins",
        name: "Sultan Spins",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/sweetopia_royale": {
        slug: "sweetopia_royale",
        name: "Sweetopia Royale",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/templar_tumble": {
        slug: "templar_tumble",
        name: "Templar Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/templar_tumble_2": {
        slug: "templar_tumble_2",
        name: "Templar Tumble 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/temple_tumble_megaways": {
        slug: "temple_tumble_megaways",
        name: "Temple Tumble MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby": {
        slug: "the_great_pigsby",
        name: "The Great Pigsby",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby_megapays": {
        slug: "the_great_pigsby_megapays",
        name: "The Great Pigsby Megapays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_great_pigsby_megaways": {
        slug: "the_great_pigsby_megaways",
        name: "The Great Pigsby MegaWays",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/the_tumbles": {
        slug: "the_tumbles",
        name: "The Tumbles",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tiger_kingdom": {
        slug: "tiger_kingdom",
        name: "Tiger Kingdom",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tiger_shrine": {
        slug: "tiger_shrine",
        name: "Tiger Shrine",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/titan_strike": {
        slug: "titan_strike",
        name: "Titan Strike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tnt_tumble": {
        slug: "tnt_tumble",
        name: "TNT Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/top_dawg": {
        slug: "top_dawg",
        name: "Top Dawg$",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/torii_tumble": {
        slug: "torii_tumble",
        name: "Torii Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/totem_guardians": {
        slug: "totem_guardians",
        name: "Totem Guardians",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/tower_tumble": {
        slug: "tower_tumble",
        name: "Tower Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/treasure_tumble": {
        slug: "treasure_tumble",
        name: "Treasure Tumble",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/trolls_gold": {
        slug: "trolls_gold",
        name: "Troll's Gold",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/volatile_vikings": {
        slug: "volatile_vikings",
        name: "Volatile Vikings",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/volatile_vikings_2": {
        slug: "volatile_vikings_2",
        name: "Volatile Vikings 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_chapo": {
        slug: "wild_chapo",
        name: "Wild Chapo",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_chapo_2": {
        slug: "wild_chapo_2",
        name: "Wild Chapo 2",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_hike": {
        slug: "wild_hike",
        name: "Wild Hike",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wild_yield": {
        slug: "wild_yield",
        name: "Wild Yield",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/wildchemy": {
        slug: "wildchemy",
        name: "Wildchemy",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/winter_champions": {
        slug: "winter_champions",
        name: "Winter Champions",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/world_class_kick_off": {
        slug: "world_class_kick_off",
        name: "World Class Kick Off",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "relax-gaming/zombie_circus": {
        slug: "zombie_circus",
        name: "Zombie Circus",
        provider: "Relax Gaming",
        providerSlug: "relax-gaming"
    },
    "rogue-gaming/121_gigawatts": {
        slug: "121_gigawatts",
        name: "1.21 Gigawatts",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/3_wonders_ny_carnival": {
        slug: "3_wonders_ny_carnival",
        name: "3 Wonders NY Carnival",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/3_wonders_underworld": {
        slug: "3_wonders_underworld",
        name: "3 Wonders Underworld",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/777_lucky_blaze": {
        slug: "777_lucky_blaze",
        name: "777 Lucky Blaze",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/777_wealth": {
        slug: "777_wealth",
        name: "777 Wealth",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/ace_ventura": {
        slug: "ace_ventura",
        name: "Ace Ventura",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/american_respin_94": {
        slug: "american_respin_94",
        name: "American Respin 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/avalanche_rainblox": {
        slug: "avalanche_rainblox",
        name: "Avalanche Rainblox",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bad_influencers": {
        slug: "bad_influencers",
        name: "Bad Influencers",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bank_of_riches": {
        slug: "bank_of_riches",
        name: "Bank of Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bank_run": {
        slug: "bank_run",
        name: "Bank Run",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_boom_blitz": {
        slug: "big_boom_blitz",
        name: "Big Boom Blitz",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_bounty_boom": {
        slug: "big_bounty_boom",
        name: "Big Bounty Boom",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_buffalo_bonanza": {
        slug: "big_buffalo_bonanza",
        name: "Big Buffalo Bonanza",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_river_fishing": {
        slug: "big_river_fishing",
        name: "Big River Fishing",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/big_top_terror": {
        slug: "big_top_terror",
        name: "Big Top Terror",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/billy_west_wild_hunt": {
        slug: "billy_west_wild_hunt",
        name: "Billy West Wild Hunt",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/blazing_fire_balls_spin_win": {
        slug: "blazing_fire_balls_spin_win",
        name: "Blazing Fire Balls Spin Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/blazing_fire_pots": {
        slug: "blazing_fire_pots",
        name: "Blazing Fire Pots",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bling_kong": {
        slug: "bling_kong",
        name: "Bling Kong",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/book_of_chickens": {
        slug: "book_of_chickens",
        name: "Book of Chickens",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/book_of_eternity_94": {
        slug: "book_of_eternity_94",
        name: "Book of Eternity 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bright_star": {
        slug: "bright_star",
        name: "Bright Star",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/bubble_bucks": {
        slug: "bubble_bucks",
        name: "Bubble Bucks",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/caichen_triple_blossom": {
        slug: "caichen_triple_blossom",
        name: "Caichen Triple Blossom",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/catch_a_wave": {
        slug: "catch_a_wave",
        name: "Catch a Wave",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/chaos_coins": {
        slug: "chaos_coins",
        name: "Chaos Coins",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/charlies_angel": {
        slug: "charlies_angel",
        name: "Charlies Angel",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/christmas_combo": {
        slug: "christmas_combo",
        name: "Christmas Combo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/cloverland_riches": {
        slug: "cloverland_riches",
        name: "Cloverland Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/coin_siege": {
        slug: "coin_siege",
        name: "Coin Siege",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/combo_drop": {
        slug: "combo_drop",
        name: "Combo Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_gunslinger": {
        slug: "dan_marino_gunslinger",
        name: "Dan Marino Gunslinger",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_hail_mary": {
        slug: "dan_marino_hail_mary",
        name: "Dan Marino Hail Mary",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_keno": {
        slug: "dan_marino_keno",
        name: "Dan Marino Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dan_marino_perfect_pass": {
        slug: "dan_marino_perfect_pass",
        name: "Dan Marino Perfect Pass",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/davy_jones_locker_with_tsunami_reels": {
        slug: "davy_jones_locker_with_tsunami_reels",
        name: "Davy Jones Locker with Tsunami Reels",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/deadly_west": {
        slug: "deadly_west",
        name: "Deadly West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/deep_treasure_gold": {
        slug: "deep_treasure_gold",
        name: "Deep Treasure Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/derby_dash": {
        slug: "derby_dash",
        name: "Derby Dash",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/devils_kitchen": {
        slug: "devils_kitchen",
        name: "Devil's Kitchen",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/diamond_multiplier_respin": {
        slug: "diamond_multiplier_respin",
        name: "Diamond Multiplier Respin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/dragon_and_dragons": {
        slug: "dragon_and_dragons",
        name: "Dragon and Dragons",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/epic_phoenix": {
        slug: "epic_phoenix",
        name: "Epic Phoenix",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/family_feud": {
        slug: "family_feud",
        name: "Family Feud",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/farmyard_fortunes_94": {
        slug: "farmyard_fortunes_94",
        name: "Farmyard Fortunes 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fate_of_the_gods": {
        slug: "fate_of_the_gods",
        name: "Fate of The Gods",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fever_las_vegas": {
        slug: "fever_las_vegas",
        name: "Fever Las Vegas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fireworks_of_fortune": {
        slug: "fireworks_of_fortune",
        name: "Fireworks of Fortune",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/football_rush": {
        slug: "football_rush",
        name: "Football Rush",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/fujisan": {
        slug: "fujisan",
        name: "Fujisan",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/gemstones_cascade": {
        slug: "gemstones_cascade",
        name: "Gemstones Cascade",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/ghetto_gold": {
        slug: "ghetto_gold",
        name: "Ghetto Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/godfather_megaways": {
        slug: "godfather_megaways",
        name: "Godfather Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/gold_n_spin": {
        slug: "gold_n_spin",
        name: "Gold n Spin",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/gold_runner": {
        slug: "gold_runner",
        name: "Gold Runner",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/golden_koi": {
        slug: "golden_koi",
        name: "Golden Koi",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happily_ever_after": {
        slug: "happily_ever_after",
        name: "Happily Ever After",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happily_ever_after_once_upon_a_multiplier": {
        slug: "happily_ever_after_once_upon_a_multiplier",
        name: "Happily Ever After Once Upon a Multiplier",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/happy_holidays": {
        slug: "happy_holidays",
        name: "Happy Holidays",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/howling_inferno_3pots": {
        slug: "howling_inferno_3pots",
        name: "Howling Inferno 3Pots",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/howling_inferno_hold_and_win_3x3": {
        slug: "howling_inferno_hold_and_win_3x3",
        name: "Howling Inferno Hold and Win 3x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/howling_inferno_hold_and_win_5x3": {
        slug: "howling_inferno_hold_and_win_5x3",
        name: "Howling Inferno Hold and Win 5x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/hyperbars": {
        slug: "hyperbars",
        name: "Hyperbars",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/keno_multiplay": {
        slug: "keno_multiplay",
        name: "Keno Multiplay",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/king_kerching": {
        slug: "king_kerching",
        name: "King Kerching",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/legacy_of_anubis": {
        slug: "legacy_of_anubis",
        name: "Legacy of Anubis",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/looters": {
        slug: "looters",
        name: "Looters",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_8_keno": {
        slug: "lucky_8_keno",
        name: "Lucky 8 Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_bonus_draw_keno": {
        slug: "lucky_bonus_draw_keno",
        name: "Lucky Bonus Draw Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/lucky_star_keno": {
        slug: "lucky_star_keno",
        name: "Lucky Star Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mafioso": {
        slug: "mafioso",
        name: "Mafioso",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mayan_riches_prophecy_of_gold": {
        slug: "mayan_riches_prophecy_of_gold",
        name: "Mayan Riches Prophecy of Gold",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mayan_temple_riches": {
        slug: "mayan_temple_riches",
        name: "Mayan Temple Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mega_laser_kitty_cubes": {
        slug: "mega_laser_kitty_cubes",
        name: "Mega Laser Kitty Cubes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/merge_hold_and_drop": {
        slug: "merge_hold_and_drop",
        name: "Merge Hold and Drop",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/merlins_beard": {
        slug: "merlins_beard",
        name: "Merlin's Beard",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/merlins_mixtures": {
        slug: "merlins_mixtures",
        name: "Merlin's Mixtures",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/moosey_money": {
        slug: "moosey_money",
        name: "Moosey Money",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/mystic_magic": {
        slug: "mystic_magic",
        name: "Mystic Magic",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/neon_wildfire": {
        slug: "neon_wildfire",
        name: "Neon Wildfire",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/overdrive": {
        slug: "overdrive",
        name: "Overdrive",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/pay_dirt": {
        slug: "pay_dirt",
        name: "Pay Dirt",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/picture_this_cute_christmas": {
        slug: "picture_this_cute_christmas",
        name: "Picture This Cute Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/picture_this_xxmas": {
        slug: "picture_this_xxmas",
        name: "Picture This XXmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_bank_riches": {
        slug: "piggy_bank_riches",
        name: "Piggy Bank Riches",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_bank_run_shriek_streak": {
        slug: "piggy_bank_run_shriek_streak",
        name: "Piggy Bank Run Shriek Streak",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/piggy_plunder": {
        slug: "piggy_plunder",
        name: "Piggy Plunder",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/power_strike_hyper_hits": {
        slug: "power_strike_hyper_hits",
        name: "Power Strike Hyper Hits",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/powerups": {
        slug: "powerups",
        name: "Power-ups",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/punk_rocks": {
        slug: "punk_rocks",
        name: "Punk Rocks",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/quarterback_blitz": {
        slug: "quarterback_blitz",
        name: "Quarterback Blitz",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rainbow_falls": {
        slug: "rainbow_falls",
        name: "Rainbow Falls",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rainbow_run_with_run_amok": {
        slug: "rainbow_run_with_run_amok",
        name: "Rainbow Run with Run Amok",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rambo": {
        slug: "rambo",
        name: "Rambo",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/rave_up": {
        slug: "rave_up",
        name: "Rave UP",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/reign_of_maximus_94": {
        slug: "reign_of_maximus_94",
        name: "Reign of Maximus 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/riches_of_olympus": {
        slug: "riches_of_olympus",
        name: "Riches of Olympus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/runaway_train": {
        slug: "runaway_train",
        name: "Runaway Train",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/smash_street_wilds": {
        slug: "smash_street_wilds",
        name: "Smash Street Wilds",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong": {
        slug: "stacking_kong",
        name: "StacKING Kong",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong_bonus": {
        slug: "stacking_kong_bonus",
        name: "Stacking Kong Bonus",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stacking_kong_bonus_christmas": {
        slug: "stacking_kong_bonus_christmas",
        name: "StacKing Kong Bonus Christmas",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/stadium_megaways": {
        slug: "stadium_megaways",
        name: "Stadium Megaways",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/super_charged_fruits": {
        slug: "super_charged_fruits",
        name: "Super Charged Fruits",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/the_secret_of_amun_ra": {
        slug: "the_secret_of_amun_ra",
        name: "The Secret of Amun Ra",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/the_vigilantes": {
        slug: "the_vigilantes",
        name: "The Vigilantes",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/three_fortune_wishes_94": {
        slug: "three_fortune_wishes_94",
        name: "Three Fortune Wishes 94",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/titan_clash": {
        slug: "titan_clash",
        name: "Titan Clash",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/tntina": {
        slug: "tntina",
        name: "TNTina",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_fire_pots_hold_and_win": {
        slug: "triple_fire_pots_hold_and_win",
        name: "Triple Fire Pots Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_hit_gold_mine_5x3": {
        slug: "triple_hit_gold_mine_5x3",
        name: "Triple Hit Gold Mine 5x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_hit_gold_mine_hold_and_win": {
        slug: "triple_hit_gold_mine_hold_and_win",
        name: "Triple Hit Gold Mine Hold and Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/triple_snack_attack": {
        slug: "triple_snack_attack",
        name: "Triple Snack Attack",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/vegas_triple_play_spin_n_win": {
        slug: "vegas_triple_play_spin_n_win",
        name: "Vegas Triple Play Spin n Win",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/werewolf_inferno_3_pots": {
        slug: "werewolf_inferno_3_pots",
        name: "Werewolf Inferno 3 Pots",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/werewolf_inferno_hold_and_win_5x3": {
        slug: "werewolf_inferno_hold_and_win_5x3",
        name: "Werewolf Inferno Hold and Win 5x3",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_millionaires_life": {
        slug: "wheel_big_winner_millionaires_life",
        name: "Wheel Big Winner Millionaires Life",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_power_tower": {
        slug: "wheel_big_winner_power_tower",
        name: "Wheel Big Winner Power Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wheel_big_winner_red_hot_spins": {
        slug: "wheel_big_winner_red_hot_spins",
        name: "Wheel Big Winner Red Hot Spins",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wild_reel_royale": {
        slug: "wild_reel_royale",
        name: "Wild Reel Royale",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wild_whopper": {
        slug: "wild_whopper",
        name: "Wild Whopper",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wildfire_west": {
        slug: "wildfire_west",
        name: "Wildfire West",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/wolf_diamond": {
        slug: "wolf_diamond",
        name: "Wolf Diamond",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/xtra_ball_keno": {
        slug: "xtra_ball_keno",
        name: "Xtra Ball Keno",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rogue-gaming/zeus_thunder_tower": {
        slug: "zeus_thunder_tower",
        name: "Zeus Thunder Tower",
        provider: "Rogue Gaming",
        providerSlug: "rogue-gaming"
    },
    "rubyplay/adventures_of_lil_red": {
        slug: "adventures_of_lil_red",
        name: "Adventures of Li'l Red",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/african_cats": {
        slug: "african_cats",
        name: "African Cats",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/alice_and_the_mad_respin_party": {
        slug: "alice_and_the_mad_respin_party",
        name: "Alice and the Mad Respin Party",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/alice_in_the_wild": {
        slug: "alice_in_the_wild",
        name: "Alice in the Wild",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/ancient_pharaoh": {
        slug: "ancient_pharaoh",
        name: "Ancient Pharaoh",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/arabian_secret": {
        slug: "arabian_secret",
        name: "Arabian Secret",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/arcane_beauties": {
        slug: "arcane_beauties",
        name: "Arcane Beauties",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/bamboo_fortune": {
        slug: "bamboo_fortune",
        name: "Bamboo Fortune",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/blazing_tiger": {
        slug: "blazing_tiger",
        name: "Blazing Tiger",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/book_of_8_riches": {
        slug: "book_of_8_riches",
        name: "Book of 8 Riches",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/book_of_riches": {
        slug: "book_of_riches",
        name: "Book of Riches",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/book_of_riches_deluxe": {
        slug: "book_of_riches_deluxe",
        name: "Book of Riches Deluxe",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/book_of_riches_deluxe_chapter_2": {
        slug: "book_of_riches_deluxe_chapter_2",
        name: "Book of Riches Deluxe: Chapter 2",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/book_of_riches_deluxe_chapter_2_se": {
        slug: "book_of_riches_deluxe_chapter_2_se",
        name: "Book of Riches Deluxe Chapter 2 SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/brilliant_gems": {
        slug: "brilliant_gems",
        name: "Brilliant Gems",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/bufon_fortuna": {
        slug: "bufon_fortuna",
        name: "Bufon Fortuna",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/bufon_fortuna_deluxe": {
        slug: "bufon_fortuna_deluxe",
        name: "Bufon Fortuna Deluxe",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/bull_fever": {
        slug: "bull_fever",
        name: "Bull Fever",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/cache_rush": {
        slug: "cache_rush",
        name: "Cache Rush",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/christmas_fortune": {
        slug: "christmas_fortune",
        name: "Christmas Fortune",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/clovers_of_luck": {
        slug: "clovers_of_luck",
        name: "Clovers of Luck",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/clovers_of_luck_2": {
        slug: "clovers_of_luck_2",
        name: "Clovers of Luck 2",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dawn_of_the_incas": {
        slug: "dawn_of_the_incas",
        name: "Dawn of the Incas",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_777": {
        slug: "diamond_explosion_777",
        name: "Diamond Explosion 777",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_7s": {
        slug: "diamond_explosion_7s",
        name: "Diamond Explosion 7s",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_7s_se": {
        slug: "diamond_explosion_7s_se",
        name: "Diamond Explosion 7s SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_christmas_tango": {
        slug: "diamond_explosion_christmas_tango",
        name: "Diamond Explosion Christmas Tango",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_patriots": {
        slug: "diamond_explosion_patriots",
        name: "Diamond Explosion Patriots",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/diamond_explosion_sweet_love": {
        slug: "diamond_explosion_sweet_love",
        name: "Diamond Explosion Sweet Love",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dr_frankenstein": {
        slug: "dr_frankenstein",
        name: "Dr. Frankenstein",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dragon_8s_25x": {
        slug: "dragon_8s_25x",
        name: "Dragon 8s 25x",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dragon_ladies": {
        slug: "dragon_ladies",
        name: "Dragon Ladies",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dragon_prophecy": {
        slug: "dragon_prophecy",
        name: "Dragon Prophecy",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/dragoness": {
        slug: "dragoness",
        name: "Dragoness",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/egyptian_sun": {
        slug: "egyptian_sun",
        name: "Egyptian Sun",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/egyptian_sun_se": {
        slug: "egyptian_sun_se",
        name: "Egyptian Sun SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/elephant_stampede": {
        slug: "elephant_stampede",
        name: "Elephant Stampede",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/elephant_stampede_se": {
        slug: "elephant_stampede_se",
        name: "Elephant Stampede SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/enter_the_vault": {
        slug: "enter_the_vault",
        name: "Enter the Vault",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/feliz_dia_de_los_muertos": {
        slug: "feliz_dia_de_los_muertos",
        name: "Feliz Dia de los Muertos",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/frankenstein_triple_volt": {
        slug: "frankenstein_triple_volt",
        name: "Frankenstein Triple Volt",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/fu_double_luck_diamond_explosion": {
        slug: "fu_double_luck_diamond_explosion",
        name: "Fu Double Luck Diamond Explosion",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/gallantry": {
        slug: "gallantry",
        name: "Gallantry",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_bunny": {
        slug: "giga_match_bunny",
        name: "Giga Match Bunny",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_egypt": {
        slug: "giga_match_egypt",
        name: "Giga Match Egypt",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_fruits": {
        slug: "giga_match_fruits",
        name: "Giga Match Fruits",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_gems": {
        slug: "giga_match_gems",
        name: "Giga Match Gems",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_mahjong": {
        slug: "giga_match_mahjong",
        name: "Giga Match Mahjong",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_moolah": {
        slug: "giga_match_moolah",
        name: "Giga Match Moolah",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_north_pole": {
        slug: "giga_match_north_pole",
        name: "Giga Match North Pole",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_phantasmal": {
        slug: "giga_match_phantasmal",
        name: "Giga Match Phantasmal",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/giga_match_sugar_skull": {
        slug: "giga_match_sugar_skull",
        name: "Giga Match Sugar Skull",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_fruit": {
        slug: "go_high_fruit",
        name: "Go High Fruit",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_gallina": {
        slug: "go_high_gallina",
        name: "Go High Gallina",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_gone_fishing": {
        slug: "go_high_gone_fishing",
        name: "Go High Gone Fishing",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_harvest": {
        slug: "go_high_harvest",
        name: "Go High Harvest",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_joker": {
        slug: "go_high_joker",
        name: "Go High Joker",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_olympus": {
        slug: "go_high_olympus",
        name: "Go High Olympus",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_panda": {
        slug: "go_high_panda",
        name: "Go High Panda",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_puppy_love": {
        slug: "go_high_puppy_love",
        name: "Go High Puppy Love",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/go_high_safari": {
        slug: "go_high_safari",
        name: "Go High Safari",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/golden_forge": {
        slug: "golden_forge",
        name: "Golden Forge",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/grand_express_action_class": {
        slug: "grand_express_action_class",
        name: "Grand Express Action Class",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/grand_express_diamond_class": {
        slug: "grand_express_diamond_class",
        name: "Grand Express Diamond Class",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/grand_express_fiesta": {
        slug: "grand_express_fiesta",
        name: "Grand Express Fiesta",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/grand_mariachi": {
        slug: "grand_mariachi",
        name: "Grand Mariachi",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/gummy_giga_match": {
        slug: "gummy_giga_match",
        name: "Gummy Giga Match",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/he_he_yang": {
        slug: "he_he_yang",
        name: "He He Yang",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/hot_and_heavy": {
        slug: "hot_and_heavy",
        name: "Hot and Heavy",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_empress": {
        slug: "immortal_empress",
        name: "Immortal Empress",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_3_fates": {
        slug: "immortal_ways_3_fates",
        name: "Immortal Ways 3 Fates",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_88_charms": {
        slug: "immortal_ways_88_charms",
        name: "Immortal Ways 88 Charms",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_buffalo": {
        slug: "immortal_ways_buffalo",
        name: "Immortal Ways Buffalo",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_buffalo_se": {
        slug: "immortal_ways_buffalo_se",
        name: "Immortal Ways Buffalo SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_champions": {
        slug: "immortal_ways_champions",
        name: "Immortal Ways Champions",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_cleopatra": {
        slug: "immortal_ways_cleopatra",
        name: "Immortal Ways Cleopatra",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_diamonds": {
        slug: "immortal_ways_diamonds",
        name: "Immortal Ways Diamonds",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_gallina_harvest": {
        slug: "immortal_ways_gallina_harvest",
        name: "Immortal Ways Gallina Harvest",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_heart_to_heart": {
        slug: "immortal_ways_heart_to_heart",
        name: "Immortal Ways Heart to Heart",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_lady_moon": {
        slug: "immortal_ways_lady_moon",
        name: "Immortal Ways Lady Moon",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_luva": {
        slug: "immortal_ways_luva",
        name: "Immortal Ways Luva",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_magic_gems": {
        slug: "immortal_ways_magic_gems",
        name: "Immortal Ways Magic Gems",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_pinata": {
        slug: "immortal_ways_pinata",
        name: "Immortal Ways Pinata",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_spooktacular": {
        slug: "immortal_ways_spooktacular",
        name: "Immortal Ways Spooktacular",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_sweet_coin": {
        slug: "immortal_ways_sweet_coin",
        name: "Immortal Ways Sweet Coin",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/immortal_ways_volcano": {
        slug: "immortal_ways_volcano",
        name: "Immortal Ways Volcano",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_3_buffalo": {
        slug: "j_mania_3_buffalo",
        name: "J Mania 3 Buffalo",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_chili_champs": {
        slug: "j_mania_chili_champs",
        name: "J Mania Chili Champs",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_diamonds": {
        slug: "j_mania_diamonds",
        name: "J Mania Diamonds",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_goal_nations": {
        slug: "j_mania_goal_nations",
        name: "J Mania Goal Nations",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_golden_eggs": {
        slug: "j_mania_golden_eggs",
        name: "J Mania Golden Eggs",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_hot_asses": {
        slug: "j_mania_hot_asses",
        name: "J Mania Hot Asses",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_loco_habanero": {
        slug: "j_mania_loco_habanero",
        name: "J Mania Loco Habanero",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_lucky_pyggs": {
        slug: "j_mania_lucky_pyggs",
        name: "J Mania Lucky Pyggs",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_maniac": {
        slug: "j_mania_maniac",
        name: "J Mania Maniac",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_triple_jam": {
        slug: "j_mania_triple_jam",
        name: "J Mania Triple Jam",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/j_mania_turkey_chef": {
        slug: "j_mania_turkey_chef",
        name: "J Mania Turkey Chef",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/lady_phoenix": {
        slug: "lady_phoenix",
        name: "Lady Phoenix",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/loco_habanero": {
        slug: "loco_habanero",
        name: "Loco Habanero",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/macau_beauties": {
        slug: "macau_beauties",
        name: "Macau Beauties",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_bearhaus": {
        slug: "mad_hit_bearhaus",
        name: "Mad Hit Bearhaus",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_devil": {
        slug: "mad_hit_devil",
        name: "Mad Hit Devil",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_diamonds": {
        slug: "mad_hit_diamonds",
        name: "Mad Hit Diamonds",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_diamonds_deluxe": {
        slug: "mad_hit_diamonds_deluxe",
        name: "Mad Hit Diamonds Deluxe",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_diamonds_extreme": {
        slug: "mad_hit_diamonds_extreme",
        name: "Mad Hit Diamonds Extreme",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_easter_eggsplosion_94": {
        slug: "mad_hit_easter_eggsplosion_94",
        name: "Mad Hit Easter Eggsplosion 94",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_full_steam": {
        slug: "mad_hit_full_steam",
        name: "Mad Hit Full Steam",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_gold": {
        slug: "mad_hit_gold",
        name: "Mad Hit Gold",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_gorillatron": {
        slug: "mad_hit_gorillatron",
        name: "Mad Hit Gorillatron",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_hidden_cities": {
        slug: "mad_hit_hidden_cities",
        name: "Mad Hit Hidden Cities",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_ho_ho_hot_pudding": {
        slug: "mad_hit_ho_ho_hot_pudding",
        name: "Mad Hit Ho Ho Hot Pudding",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_jokester": {
        slug: "mad_hit_jokester",
        name: "Mad Hit Jokester",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_marlin_bonanza": {
        slug: "mad_hit_marlin_bonanza",
        name: "Mad Hit Marlin Bonanza",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_mr_coin": {
        slug: "mad_hit_mr_coin",
        name: "Mad Hit Mr Coin",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_oasis": {
        slug: "mad_hit_oasis",
        name: "Mad Hit Oasis",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_savannah": {
        slug: "mad_hit_savannah",
        name: "Mad Hit Savannah",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_slippery_soap": {
        slug: "mad_hit_slippery_soap",
        name: "Mad Hit Slippery Soap",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_supernova": {
        slug: "mad_hit_supernova",
        name: "Mad Hit Supernova",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_wild_alice": {
        slug: "mad_hit_wild_alice",
        name: "Mad Hit Wild Alice",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mad_hit_wild_alice_easter": {
        slug: "mad_hit_wild_alice_easter",
        name: "Mad Hit Wild Alice Easter",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/madame_luck": {
        slug: "madame_luck",
        name: "Madame Luck",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/match_blitz_scatter_shock_94": {
        slug: "match_blitz_scatter_shock_94",
        name: "Match Blitz Scatter Shock 94",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mayan_blaze": {
        slug: "mayan_blaze",
        name: "Mayan Blaze",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mayan_cache": {
        slug: "mayan_cache",
        name: "Mayan Cache",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/medusa_money": {
        slug: "medusa_money",
        name: "Medusa Money",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/more_dragon_ladies": {
        slug: "more_dragon_ladies",
        name: "More Dragon Ladies",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/mucho_loco_habanero": {
        slug: "mucho_loco_habanero",
        name: "Mucho Loco Habanero",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/native_spirit": {
        slug: "native_spirit",
        name: "Native Spirit",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/new_year_happiness": {
        slug: "new_year_happiness",
        name: "New Year Happiness",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/new_year_rising": {
        slug: "new_year_rising",
        name: "New Year Rising",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/piggy_gold": {
        slug: "piggy_gold",
        name: "Piggy Gold",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/pirates_booty": {
        slug: "pirates_booty",
        name: "Pirate's Booty",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/prince_of_riches": {
        slug: "prince_of_riches",
        name: "Prince of Riches",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/prosperity_blessing": {
        slug: "prosperity_blessing",
        name: "Prosperity Blessing",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/prosperity_journey": {
        slug: "prosperity_journey",
        name: "Prosperity Journey",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/quest_of_gods": {
        slug: "quest_of_gods",
        name: "Quest Of Gods",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/reel_allstars": {
        slug: "reel_allstars",
        name: "Reel All-Stars",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rio_pleasures": {
        slug: "rio_pleasures",
        name: "Rio Pleasures",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rockin_gorilla": {
        slug: "rockin_gorilla",
        name: "Rockin' Gorilla",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/roman_legend": {
        slug: "roman_legend",
        name: "Roman Legend",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/royal_griffin": {
        slug: "royal_griffin",
        name: "Royal Griffin",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rush_fever_7s_deluxe": {
        slug: "rush_fever_7s_deluxe",
        name: "Rush Fever 7s Deluxe",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rush_fever_7s_deluxe_se": {
        slug: "rush_fever_7s_deluxe_se",
        name: "Rush Fever 7s Deluxe SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rush_fever_catchem_all": {
        slug: "rush_fever_catchem_all",
        name: "Rush Fever Catch'em All",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/rush_fever_soda_pop": {
        slug: "rush_fever_soda_pop",
        name: "Rush Fever Soda Pop",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/savage_lion": {
        slug: "savage_lion",
        name: "Savage Lion",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/shake_shake_christmas": {
        slug: "shake_shake_christmas",
        name: "Shake Shake Christmas",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/shake_shake_leprechaun": {
        slug: "shake_shake_leprechaun",
        name: "Shake Shake Leprechaun",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/shake_shake_money_tree": {
        slug: "shake_shake_money_tree",
        name: "Shake Shake Money Tree",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/sheerluck": {
        slug: "sheerluck",
        name: "Sheerluck",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/silver_and_gold_mine": {
        slug: "silver_and_gold_mine",
        name: "Silver and Gold Mine",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/stampede_rush_speedy_santa": {
        slug: "stampede_rush_speedy_santa",
        name: "Stampede Rush Speedy Santa",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/stampede_rush_trident": {
        slug: "stampede_rush_trident",
        name: "Stampede Rush Trident",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/stampede_rush_wicked": {
        slug: "stampede_rush_wicked",
        name: "Stampede Rush Wicked",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/sugar_rush_fever": {
        slug: "sugar_rush_fever",
        name: "Sugar Rush Fever",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/sun_of_ra": {
        slug: "sun_of_ra",
        name: "Sun of Ra",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/ten_ton_ways_goldfish": {
        slug: "ten_ton_ways_goldfish",
        name: "Ten Ton Ways Goldfish",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/ten_ton_ways_luck": {
        slug: "ten_ton_ways_luck",
        name: "Ten Ton Ways Luck",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/ten_ton_ways_odins_gift": {
        slug: "ten_ton_ways_odins_gift",
        name: "Ten Ton Ways Odin's Gift",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/ten_ton_ways_stampede": {
        slug: "ten_ton_ways_stampede",
        name: "Ten Ton Ways Stampede",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/tiki_blaze": {
        slug: "tiki_blaze",
        name: "Tiki Blaze",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/true_wild": {
        slug: "true_wild",
        name: "True Wild",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/vegas_hotties": {
        slug: "vegas_hotties",
        name: "Vegas Hotties",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/vegas_no_limit_wins": {
        slug: "vegas_no_limit_wins",
        name: "Vegas No Limit Wins",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/vegas_no_limit_wins_se": {
        slug: "vegas_no_limit_wins_se",
        name: "Vegas No Limit Wins SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/vegas_repeat_wins": {
        slug: "vegas_repeat_wins",
        name: "Vegas Repeat Wins",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/viking_crusade": {
        slug: "viking_crusade",
        name: "Viking Crusade",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/volcano_rising": {
        slug: "volcano_rising",
        name: "Volcano Rising",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/volcano_rising_se": {
        slug: "volcano_rising_se",
        name: "Volcano Rising SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/wild_thirst": {
        slug: "wild_thirst",
        name: "Wild Thirst",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/wizards_spell": {
        slug: "wizards_spell",
        name: "Wizard's Spell",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/wolf_haven": {
        slug: "wolf_haven",
        name: "Wolf Haven",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/zapotec_gold": {
        slug: "zapotec_gold",
        name: "ZapOtec Gold",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/zeus_rush_fever": {
        slug: "zeus_rush_fever",
        name: "Zeus Rush Fever",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/zeus_rush_fever_deluxe": {
        slug: "zeus_rush_fever_deluxe",
        name: "Zeus Rush Fever Deluxe",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "rubyplay/zeus_rush_fever_deluxe_se": {
        slug: "zeus_rush_fever_deluxe_se",
        name: "Zeus Rush Fever Deluxe SE",
        provider: "Rubyplay",
        providerSlug: "rubyplay"
    },
    "sgaming/3_diamond_vegas_94": {
        slug: "3_diamond_vegas_94",
        name: "3 Diamond Vegas 94",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/3_mystic_masks": {
        slug: "3_mystic_masks",
        name: "3 Mystic Masks",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/3_pigs_bacon_bankroll": {
        slug: "3_pigs_bacon_bankroll",
        name: "3 Pigs Bacon Bankroll",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/3_secret_safes": {
        slug: "3_secret_safes",
        name: "3 Secret Safes",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/7_lemon_crush": {
        slug: "7_lemon_crush",
        name: "7 Lemon Crush",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/777s_above": {
        slug: "777s_above",
        name: "777s Above",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/age_of_pharaohs": {
        slug: "age_of_pharaohs",
        name: "Age of Pharaohs",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/all_your_favourites": {
        slug: "all_your_favourites",
        name: "All Your Favourites",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/barnyard_bash_chicken_chase": {
        slug: "barnyard_bash_chicken_chase",
        name: "Barnyard Bash Chicken Chase",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/barnyard_bash_eggstreme": {
        slug: "barnyard_bash_eggstreme",
        name: "Barnyard Bash: Eggstreme",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/big_bad_bounty": {
        slug: "big_bad_bounty",
        name: "Big Bad Bounty",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/big_bad_bounty_reloaded_94": {
        slug: "big_bad_bounty_reloaded_94",
        name: "Big Bad Bounty Reloaded 94",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/big_top_bonus": {
        slug: "big_top_bonus",
        name: "Big Top Bonus",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/bubble_gum_bonanza": {
        slug: "bubble_gum_bonanza",
        name: "Bubble Gum Bonanza",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/captain_jacks_chests": {
        slug: "captain_jacks_chests",
        name: "Captain Jack's Chests",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/captain_jacks_curse": {
        slug: "captain_jacks_curse",
        name: "Captain Jacks Curse",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/captain_jacks_revenge": {
        slug: "captain_jacks_revenge",
        name: "Captain Jacks Revenge",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/captain_jacks_voyage": {
        slug: "captain_jacks_voyage",
        name: "Captain Jack's Voyage",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/carp_quest": {
        slug: "carp_quest",
        name: "Carp Quest",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/castle_smash": {
        slug: "castle_smash",
        name: "Castle Smash",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/cat_and_mouse_collect": {
        slug: "cat_and_mouse_collect",
        name: "Cat and Mouse: Collect",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/catch_the_robbers_coin_grab": {
        slug: "catch_the_robbers_coin_grab",
        name: "Catch The Robbers Coin Grab",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/catch_the_robbers_the_getaway": {
        slug: "catch_the_robbers_the_getaway",
        name: "Catch the Robbers: The Getaway",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/catfish_amazon_extreme": {
        slug: "catfish_amazon_extreme",
        name: "Catfish Amazon Extreme",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/catfish_combo": {
        slug: "catfish_combo",
        name: "Catfish Combo",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/celtic_combo_coin_grab": {
        slug: "celtic_combo_coin_grab",
        name: "Celtic Combo Coin Grab",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/chests_ahoy": {
        slug: "chests_ahoy",
        name: "Chests Ahoy",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/devils_draw": {
        slug: "devils_draw",
        name: "Devil's Draw",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/faithful_fortunes": {
        slug: "faithful_fortunes",
        name: "Faithful Fortunes",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/fishermans_fortune": {
        slug: "fishermans_fortune",
        name: "Fisherman's Fortune",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/goats_gold": {
        slug: "goats_gold",
        name: "Goat's Gold",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/gold_blast_bonanza": {
        slug: "gold_blast_bonanza",
        name: "Gold Blast Bonanza",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/goldipots_and_the_3_bears": {
        slug: "goldipots_and_the_3_bears",
        name: "Goldipots and the 3 Bears",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/lemon_squeezy": {
        slug: "lemon_squeezy",
        name: "Lemon Squeezy",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/looting_leprechaun": {
        slug: "looting_leprechaun",
        name: "Looting Leprechaun",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/lucky_claw_prize_pick": {
        slug: "lucky_claw_prize_pick",
        name: "Lucky Claw: Prize Pick",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/mystery_pots_ogold_coin_grab": {
        slug: "mystery_pots_ogold_coin_grab",
        name: "Mystery Pots O'Gold Coin Grab",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/paddys_potion": {
        slug: "paddys_potion",
        name: "Paddys Potion",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/pengwins_ice_spicy": {
        slug: "pengwins_ice_spicy",
        name: "PengWins Ice Spicy",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/phoenix_fireburst": {
        slug: "phoenix_fireburst",
        name: "Phoenix Fireburst",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/piggy_stash_smash": {
        slug: "piggy_stash_smash",
        name: "Piggy Stash Smash",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/rainbow_fever_94": {
        slug: "rainbow_fever_94",
        name: "Rainbow Fever 94",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/rainbow_river": {
        slug: "rainbow_river",
        name: "Rainbow River",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/safari_riches_zebra_wins": {
        slug: "safari_riches_zebra_wins",
        name: "Safari Riches: Zebra Wins",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/scarab_surge": {
        slug: "scarab_surge",
        name: "Scarab Surge",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/shake_the_money_tree_ii": {
        slug: "shake_the_money_tree_ii",
        name: "Shake the Money Tree II",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/show_me_the_vault": {
        slug: "show_me_the_vault",
        name: "Show Me The Vault",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/sundown_shootout": {
        slug: "sundown_shootout",
        name: "Sundown Shootout",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/sweet_streak": {
        slug: "sweet_streak",
        name: "Sweet Streak",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/the_3_pigs_christmas_cracker": {
        slug: "the_3_pigs_christmas_cracker",
        name: "The 3 Pigs: Christmas Cracker",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/the_3_pigs_of_wolf_street": {
        slug: "the_3_pigs_of_wolf_street",
        name: "The 3 Pigs of Wolf Street",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/the_spice_is_right": {
        slug: "the_spice_is_right",
        name: "The Spice is Right",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/the_spice_is_right_hold_n_win": {
        slug: "the_spice_is_right_hold_n_win",
        name: "The Spice is Right Hold n Win",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/tomb_of_anubis": {
        slug: "tomb_of_anubis",
        name: "Tomb of Anubis",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/triple_777_jackpot": {
        slug: "triple_777_jackpot",
        name: "Triple 777 Jackpot",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/triple_777_jackpot_magic_wheels": {
        slug: "triple_777_jackpot_magic_wheels",
        name: "Triple 777 Jackpot Magic Wheels",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/wild_wow_vegas": {
        slug: "wild_wow_vegas",
        name: "Wild Wow Vegas",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/will_it_ring_bonus_booster": {
        slug: "will_it_ring_bonus_booster",
        name: "Will it Ring Bonus Booster",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/will_it_ring_box_breaker": {
        slug: "will_it_ring_box_breaker",
        name: "Will It Ring: Box Breaker",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/will_it_ring_deal_breaker": {
        slug: "will_it_ring_deal_breaker",
        name: "Will It Ring Deal Breaker",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "sgaming/zeus_almighty": {
        slug: "zeus_almighty",
        name: "Zeus Almighty",
        provider: "SGaming",
        providerSlug: "sgaming"
    },
    "shadylady/black_friday": {
        slug: "black_friday",
        name: "Black Friday",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/brainwashed": {
        slug: "brainwashed",
        name: "Brainwashed",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/devils_finger": {
        slug: "devils_finger",
        name: "Devils Finger",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/laced": {
        slug: "laced",
        name: "Laced",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/mortal_bromance": {
        slug: "mortal_bromance",
        name: "Mortal Bromance",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/nuukd": {
        slug: "nuukd",
        name: "NUUKD",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/office_party": {
        slug: "office_party",
        name: "Office Party",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/oops": {
        slug: "oops",
        name: "Oops",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/orphan_organ": {
        slug: "orphan_organ",
        name: "Orphan Organ",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/pissed": {
        slug: "pissed",
        name: "Pissed",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/preach_tv": {
        slug: "preach_tv",
        name: "Preach TV",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/sew": {
        slug: "sew",
        name: "Sew",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/sheeple": {
        slug: "sheeple",
        name: "Sheeple",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/suck": {
        slug: "suck",
        name: "Suck",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/trap_tower": {
        slug: "trap_tower",
        name: "Trap Tower",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "shadylady/truth": {
        slug: "truth",
        name: "Truth",
        provider: "Shadylady",
        providerSlug: "shadylady"
    },
    "skillex/jackpot_pin_ball": {
        slug: "jackpot_pin_ball",
        name: "Jackpot Pin ball",
        provider: "Skillex",
        providerSlug: "skillex"
    },
    "skillex/ninja_fortune": {
        slug: "ninja_fortune",
        name: "Ninja Fortune",
        provider: "Skillex",
        providerSlug: "skillex"
    },
    "skywind-live/skywind_live_atom_roulette": {
        slug: "skywind_live_atom_roulette",
        name: "Skywind Live Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_blue_atom_roulette": {
        slug: "skywind_live_blue_atom_roulette",
        name: "Skywind Live Blue Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_blue_roulette": {
        slug: "skywind_live_blue_roulette",
        name: "Skywind Live Blue Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_green_atom_roulette": {
        slug: "skywind_live_green_atom_roulette",
        name: "Skywind Live Green Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_green_roulette": {
        slug: "skywind_live_green_roulette",
        name: "Skywind Live Green Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_jokers_show": {
        slug: "skywind_live_jokers_show",
        name: "Skywind Live Joker's Show",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_lobby": {
        slug: "skywind_live_lobby",
        name: "Skywind Live Lobby",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_red_atom_roulette": {
        slug: "skywind_live_red_atom_roulette",
        name: "Skywind Live Red Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_red_roulette": {
        slug: "skywind_live_red_roulette",
        name: "Skywind Live Red Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_roulette_a03": {
        slug: "skywind_live_roulette_a03",
        name: "Skywind Live Roulette A03",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_rush_atom_roulette": {
        slug: "skywind_live_rush_atom_roulette",
        name: "Skywind Live Rush Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_rush_roulette": {
        slug: "skywind_live_rush_roulette",
        name: "Skywind Live Rush Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_yellow_atom_roulette": {
        slug: "skywind_live_yellow_atom_roulette",
        name: "Skywind Live Yellow Atom Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind-live/skywind_live_yellow_roulette": {
        slug: "skywind_live_yellow_roulette",
        name: "Skywind Live Yellow Roulette",
        provider: "Skywind Live",
        providerSlug: "skywind-live"
    },
    "skywind/8_tigers_gold_megaways": {
        slug: "8_tigers_gold_megaways",
        name: "8 Tigers Gold MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/8_treasures_1_queen": {
        slug: "8_treasures_1_queen",
        name: "8 Treasures 1 Queen",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/88_shi_fu": {
        slug: "88_shi_fu",
        name: "88 Shi fu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/9_sons_1_king": {
        slug: "9_sons_1_king",
        name: "9 Sons, 1 King",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/alive_megaways": {
        slug: "alive_megaways",
        name: "Alive! MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/amazon_lady": {
        slug: "amazon_lady",
        name: "Amazon Lady",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/asian_fantasy": {
        slug: "asian_fantasy",
        name: "Asian Fantasy",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/aztec_reel": {
        slug: "aztec_reel",
        name: "Aztec Reel",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_buffalo": {
        slug: "big_buffalo",
        name: "Big Buffalo",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_buffalo_badlands": {
        slug: "big_buffalo_badlands",
        name: "Big Buffalo Badlands",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_buffalo_megaways": {
        slug: "big_buffalo_megaways",
        name: "Big Buffalo MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_green_wilds": {
        slug: "big_green_wilds",
        name: "Big Green Wilds",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_lion": {
        slug: "big_lion",
        name: "Big Lion",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/big_top_bonanza_megaways": {
        slug: "big_top_bonanza_megaways",
        name: "Big Top Bonanza MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/book_of_gems_megaways": {
        slug: "book_of_gems_megaways",
        name: "Book of Gems MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/buffalo_lightning": {
        slug: "buffalo_lightning",
        name: "Buffalo Lightning",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/butterfly_moon": {
        slug: "butterfly_moon",
        name: "Butterfly Moon",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/cai_shen_lai_le": {
        slug: "cai_shen_lai_le",
        name: "Cai Shen Lai Le",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/cai_shen_ye": {
        slug: "cai_shen_ye",
        name: "Cai Shen Ye",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/cash_mine": {
        slug: "cash_mine",
        name: "Cash Mine",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/celestial_beauty": {
        slug: "celestial_beauty",
        name: "Celestial Beauty",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/celtic_princess": {
        slug: "celtic_princess",
        name: "Celtic Princess",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/chaoji_888": {
        slug: "chaoji_888",
        name: "Chaoji 888",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/chicken_grande": {
        slug: "chicken_grande",
        name: "Chicken Grande",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/chilli_festival": {
        slug: "chilli_festival",
        name: "Chilli Festival",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/chois_travelling_show": {
        slug: "chois_travelling_show",
        name: "Chois Travelling Show",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/christmas_luck": {
        slug: "christmas_luck",
        name: "Christmas Luck",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/crash_royale": {
        slug: "crash_royale",
        name: "Crash Royale",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/crazy_chicken": {
        slug: "crazy_chicken",
        name: "Crazy Chicken",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/crouching_tiger": {
        slug: "crouching_tiger",
        name: "Crouching Tiger",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/da_block_94": {
        slug: "da_block_94",
        name: "Da Block 94",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/da_hei_ci_fu": {
        slug: "da_hei_ci_fu",
        name: "Da Hei Ci Fu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/da_lan_deluxe": {
        slug: "da_lan_deluxe",
        name: "Da Lan Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/da_lan_deluxe_jackpot": {
        slug: "da_lan_deluxe_jackpot",
        name: "Da Lan Deluxe Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/da_mao_zhao_cai_money_cat": {
        slug: "da_mao_zhao_cai_money_cat",
        name: "Da Mao Zhao Cai: Money Cat",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/dance_with_the_devil": {
        slug: "dance_with_the_devil",
        name: "Dance with the Devil",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/dead_mans_bullet": {
        slug: "dead_mans_bullet",
        name: "Dead Man's Bullet",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/deadly_gangster": {
        slug: "deadly_gangster",
        name: "Deadly Gangster",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/disco_mania_megaways_merge": {
        slug: "disco_mania_megaways_merge",
        name: "Disco Mania MegaWays Merge",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/double_bonus": {
        slug: "double_bonus",
        name: "Double Bonus",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/double_jungle": {
        slug: "double_jungle",
        name: "Double Jungle",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/double_scatter_7s": {
        slug: "double_scatter_7s",
        name: "Double Scatter 7's",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/dragon_riches": {
        slug: "dragon_riches",
        name: "Dragon Riches",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/egypt_cash": {
        slug: "egypt_cash",
        name: "Egypt Cash",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/egypt_spin": {
        slug: "egypt_spin",
        name: "Egypt Spin",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/electric_chip": {
        slug: "electric_chip",
        name: "Electric Chip",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/electric_chip_extreme": {
        slug: "electric_chip_extreme",
        name: "Electric Chip Extreme",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/european_roulette": {
        slug: "european_roulette",
        name: "European Roulette",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/explosion": {
        slug: "explosion",
        name: "Explosion",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/extreme_paw": {
        slug: "extreme_paw",
        name: "Extreme Paw",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/feng_kuang_ma_jiang": {
        slug: "feng_kuang_ma_jiang",
        name: "Feng Kuang Ma Jiang",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fire_festival": {
        slug: "fire_festival",
        name: "Fire Festival",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fire_reel": {
        slug: "fire_reel",
        name: "Fire Reel",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fire_reel_deluxe": {
        slug: "fire_reel_deluxe",
        name: "Fire Reel Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/firehawk_flames": {
        slug: "firehawk_flames",
        name: "Firehawk Flames",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fish_cashpot_deluxe": {
        slug: "fish_cashpot_deluxe",
        name: "Fish Cashpot Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fish_prawn_crab": {
        slug: "fish_prawn_crab",
        name: "Fish Prawn Crab",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fishermans_fury_bonanza": {
        slug: "fishermans_fury_bonanza",
        name: "Fisherman's Fury Bonanza",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/five_tiger_generals": {
        slug: "five_tiger_generals",
        name: "Five Tiger Generals",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/flaming_jaguar": {
        slug: "flaming_jaguar",
        name: "Flaming Jaguar",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/flaming_jaguar_no_pjp": {
        slug: "flaming_jaguar_no_pjp",
        name: "Flaming Jaguar No PJP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/flaming_phoenix": {
        slug: "flaming_phoenix",
        name: "Flaming Phoenix",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/forest_fruit_magic": {
        slug: "forest_fruit_magic",
        name: "Forest Fruit Magic",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fortune_lions": {
        slug: "fortune_lions",
        name: "Fortune Lions",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fortunes_rising": {
        slug: "fortunes_rising",
        name: "Fortunes Rising",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fruitopolis": {
        slug: "fruitopolis",
        name: "Fruitopolis",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fruity_girl": {
        slug: "fruity_girl",
        name: "Fruity Girl",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fu_bao_bao": {
        slug: "fu_bao_bao",
        name: "Fu Bao Bao",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fu_shou_qi_tian": {
        slug: "fu_shou_qi_tian",
        name: "Fu Shou Qi Tian",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/fury_festival": {
        slug: "fury_festival",
        name: "Fury Festival",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/gem_queen": {
        slug: "gem_queen",
        name: "Gem Queen",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/gem_queen_jackpot": {
        slug: "gem_queen_jackpot",
        name: "Gem Queen Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/gem_temple": {
        slug: "gem_temple",
        name: "Gem Temple",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/genie_mega_reels": {
        slug: "genie_mega_reels",
        name: "Genie Mega Reels",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/genie_shot": {
        slug: "genie_shot",
        name: "Genie Shot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/go_goal": {
        slug: "go_goal",
        name: "GO GOAL",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/go_gold": {
        slug: "go_gold",
        name: "Go Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/god_of_lightning": {
        slug: "god_of_lightning",
        name: "God of Lightning",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/goddess_of_8_directions": {
        slug: "goddess_of_8_directions",
        name: "Goddess of 8 Directions",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/gold_shot": {
        slug: "gold_shot",
        name: "Gold Shot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/golden_garden": {
        slug: "golden_garden",
        name: "Golden Garden",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/green_and_wild": {
        slug: "green_and_wild",
        name: "Green and Wild",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/halloween_luck": {
        slug: "halloween_luck",
        name: "Halloween Luck",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/hao_shi_cheng_shuang": {
        slug: "hao_shi_cheng_shuang",
        name: "Hao Shi Cheng Shuang",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/heart_2_heart": {
        slug: "heart_2_heart",
        name: "Heart 2 Heart",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/hearts_and_dragons": {
        slug: "hearts_and_dragons",
        name: "Hearts and Dragons",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/heavenly_gold": {
        slug: "heavenly_gold",
        name: "Heavenly Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/heavenly_phoenix": {
        slug: "heavenly_phoenix",
        name: "Heavenly Phoenix",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/heavenly_ruler": {
        slug: "heavenly_ruler",
        name: "Heavenly Ruler",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/huan_le_cai_shen": {
        slug: "huan_le_cai_shen",
        name: "Huan Le Cai Shen",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/inca_gems": {
        slug: "inca_gems",
        name: "Inca Gems",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/inca_jackpot": {
        slug: "inca_jackpot",
        name: "Inca Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jaguar_gold": {
        slug: "jaguar_gold",
        name: "Jaguar Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jesters_book_of_gold": {
        slug: "jesters_book_of_gold",
        name: "Jester's Book of Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ji_xiang_long": {
        slug: "ji_xiang_long",
        name: "Ji Xiang Long",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jin_dynasty": {
        slug: "jin_dynasty",
        name: "Jin Dynasty",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jin_qian_wa": {
        slug: "jin_qian_wa",
        name: "Jin Qian Wa",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jin_qian_wa_jackpot": {
        slug: "jin_qian_wa_jackpot",
        name: "Jin Qian Wa Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jogo_do_bicho_bingo": {
        slug: "jogo_do_bicho_bingo",
        name: "Jogo do Bicho Bingo",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/joker_multi_win": {
        slug: "joker_multi_win",
        name: "Joker Multi Win",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jokers_luck": {
        slug: "jokers_luck",
        name: "Joker's Luck",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jokers_luck_deluxe": {
        slug: "jokers_luck_deluxe",
        name: "Joker's Luck Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jokers_luck_gems": {
        slug: "jokers_luck_gems",
        name: "Joker's Luck Gems",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jokers_luck_respin": {
        slug: "jokers_luck_respin",
        name: "Joker's Luck Respin",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/jokers_pyromania": {
        slug: "jokers_pyromania",
        name: "Joker's Pyromania",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/judge_and_jury_megaways": {
        slug: "judge_and_jury_megaways",
        name: "Judge and Jury MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ku_xuan_cai_shen": {
        slug: "ku_xuan_cai_shen",
        name: "Ku Xuan Cai Shen",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/legendary_dragons": {
        slug: "legendary_dragons",
        name: "Legendary Dragons",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/lightning_of_olympus": {
        slug: "lightning_of_olympus",
        name: "Lightning of Olympus",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/liu_fu_shou": {
        slug: "liu_fu_shou",
        name: "Liu Fu Shou",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/long_long_long": {
        slug: "long_long_long",
        name: "Long Long Long",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/lucky_chan_chu": {
        slug: "lucky_chan_chu",
        name: "Lucky Chan Chu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/lucky_fisherman": {
        slug: "lucky_fisherman",
        name: "Lucky Fisherman",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/lucky_jungle": {
        slug: "lucky_jungle",
        name: "Lucky Jungle",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/machine_gun_nellie": {
        slug: "machine_gun_nellie",
        name: "Machine Gun Nellie",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/mahjong_jinpai": {
        slug: "mahjong_jinpai",
        name: "Mahjong Jinpai",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/mammoth_gold": {
        slug: "mammoth_gold",
        name: "Mammoth Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/max_chance_and_the_safari_secrets": {
        slug: "max_chance_and_the_safari_secrets",
        name: "Max Chance and the Safari Secrets",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/maya_jackpot": {
        slug: "maya_jackpot",
        name: "Maya Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/maya_millions": {
        slug: "maya_millions",
        name: "Maya Millions",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/medusa_dark_ages": {
        slug: "medusa_dark_ages",
        name: "Medusa Dark Ages",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/mega_bear": {
        slug: "mega_bear",
        name: "Mega Bear",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/mega_bear_no_pjp": {
        slug: "mega_bear_no_pjp",
        name: "Mega Bear No PJP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/mermaid_beauty": {
        slug: "mermaid_beauty",
        name: "Mermaid Beauty",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/metal_reel": {
        slug: "metal_reel",
        name: "Metal Reel",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/middle_shot": {
        slug: "middle_shot",
        name: "Middle Shot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/middle_shot_deluxe": {
        slug: "middle_shot_deluxe",
        name: "Middle Shot Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/monkey_pays": {
        slug: "monkey_pays",
        name: "Monkey Pays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/nordic_winnings": {
        slug: "nordic_winnings",
        name: "Nordic Winnings",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/nunchucks_chicken": {
        slug: "nunchucks_chicken",
        name: "Nunchucks Chicken",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ocean_gems_bonanza": {
        slug: "ocean_gems_bonanza",
        name: "Ocean Gems Bonanza",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/panda_hold_and_spin": {
        slug: "panda_hold_and_spin",
        name: "Panda Hold and Spin",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/panda_hold_and_spin_no_pjp": {
        slug: "panda_hold_and_spin_no_pjp",
        name: "Panda Hold and Spin No PJP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/phoenix_queen": {
        slug: "phoenix_queen",
        name: "Phoenix Queen",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/piata_smash": {
        slug: "piata_smash",
        name: "Piñata Smash",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/pirate_blimey": {
        slug: "pirate_blimey",
        name: "Pirate Blimey",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/pirate_empress": {
        slug: "pirate_empress",
        name: "Pirate Empress",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/pot_shot": {
        slug: "pot_shot",
        name: "Pot Shot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/queen_of_wands": {
        slug: "queen_of_wands",
        name: "Queen of Wands",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/queztal_quest": {
        slug: "queztal_quest",
        name: "Queztal Quest",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/rain_balls": {
        slug: "rain_balls",
        name: "Rain Balls",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ramesses_fortune": {
        slug: "ramesses_fortune",
        name: "Ramesses Fortune",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/respin_king": {
        slug: "respin_king",
        name: "Respin King",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/respin_mania": {
        slug: "respin_mania",
        name: "Respin Mania",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/respin_mania_mega_reels": {
        slug: "respin_mania_mega_reels",
        name: "Respin Mania Mega Reels",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/respin_mania_megaways": {
        slug: "respin_mania_megaways",
        name: "Respin Mania Megaways",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/respin_mania_wu_shi_jackpot": {
        slug: "respin_mania_wu_shi_jackpot",
        name: "Respin Mania Wu Shi Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/riverboat_reel": {
        slug: "riverboat_reel",
        name: "Riverboat Reel",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/royal_rings": {
        slug: "royal_rings",
        name: "Royal Rings",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ruby_pearl": {
        slug: "ruby_pearl",
        name: "Ruby Pearl",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/samurai": {
        slug: "samurai",
        name: "Samur.A.I",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/san_fu": {
        slug: "san_fu",
        name: "San Fu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shaolin_showdown": {
        slug: "shaolin_showdown",
        name: "Shaolin Showdown",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shen_long_bao_shi": {
        slug: "shen_long_bao_shi",
        name: "Shen Long Bao Shi",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shen_long_bao_shi_jackpot": {
        slug: "shen_long_bao_shi_jackpot",
        name: "Shen Long Bao Shi Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shen_qi_jiu_long": {
        slug: "shen_qi_jiu_long",
        name: "Shen Qi Jiu Long",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sheng_cai_you_dao": {
        slug: "sheng_cai_you_dao",
        name: "Sheng Cai You Dao",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shui_guo_cai_fu": {
        slug: "shui_guo_cai_fu",
        name: "Shui Guo Cai Fu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/shui_guo_cai_fu_jackpot": {
        slug: "shui_guo_cai_fu_jackpot",
        name: "Shui Guo Cai Fu Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/si_ling": {
        slug: "si_ling",
        name: "Si Ling",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/si_ling_jackpot": {
        slug: "si_ling_jackpot",
        name: "Si Ling Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/si_ling_megaways": {
        slug: "si_ling_megaways",
        name: "Si Ling MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/si_mei": {
        slug: "si_mei",
        name: "Si Mei",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/si_mei_jackpot": {
        slug: "si_mei_jackpot",
        name: "Si Mei Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sky_piggies": {
        slug: "sky_piggies",
        name: "Sky Piggies",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/snatchxcash": {
        slug: "snatchxcash",
        name: "SnatchXCash",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/soccer_joker": {
        slug: "soccer_joker",
        name: "Soccer Joker",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/song_cai_tong_zi": {
        slug: "song_cai_tong_zi",
        name: "Song Cai Tong Zi",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sticky_sevens_megaways": {
        slug: "sticky_sevens_megaways",
        name: "Sticky Sevens MegaWays",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sugar_bonanza_deluxe": {
        slug: "sugar_bonanza_deluxe",
        name: "Sugar Bonanza Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sugar_land": {
        slug: "sugar_land",
        name: "Sugar Land",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sugar_sands": {
        slug: "sugar_sands",
        name: "Sugar Sands",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sugar_snow": {
        slug: "sugar_snow",
        name: "Sugar Snow",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/sunny_stacks": {
        slug: "sunny_stacks",
        name: "Sunny Stacks",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_elephant": {
        slug: "super_elephant",
        name: "Super Elephant",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion": {
        slug: "super_lion",
        name: "Super Lion",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_bonanza": {
        slug: "super_lion_bonanza",
        name: "Super Lion Bonanza",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_bonanza_no_pjp": {
        slug: "super_lion_bonanza_no_pjp",
        name: "Super Lion Bonanza No PJP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_megaways": {
        slug: "super_lion_megaways",
        name: "Super Lion Megaways",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_megaways_no_jp": {
        slug: "super_lion_megaways_no_jp",
        name: "Super Lion Megaways no JP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_njp": {
        slug: "super_lion_njp",
        name: "Super Lion NJP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_xmas": {
        slug: "super_lion_xmas",
        name: "Super Lion Xmas​",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_lion_xmas_no_jp": {
        slug: "super_lion_xmas_no_jp",
        name: "Super Lion Xmas​ No JP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_sombrero": {
        slug: "super_sombrero",
        name: "Super Sombrero",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_tiger": {
        slug: "super_tiger",
        name: "Super Tiger",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_tiger_no_jp": {
        slug: "super_tiger_no_jp",
        name: "Super Tiger no JP",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/super_wolf": {
        slug: "super_wolf",
        name: "Super Wolf",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/tale_of_two_dragons": {
        slug: "tale_of_two_dragons",
        name: "Tale of Two Dragons",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/tale_of_two_dragons_jackpot": {
        slug: "tale_of_two_dragons_jackpot",
        name: "Tale of Two Dragons Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/teller_of_tales": {
        slug: "teller_of_tales",
        name: "Teller of Tales",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/the_pearl_game": {
        slug: "the_pearl_game",
        name: "The Pearl Game",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/the_reel_macau": {
        slug: "the_reel_macau",
        name: "The Reel Macau",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/the_ripper": {
        slug: "the_ripper",
        name: "The Ripper",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/three_card_brag": {
        slug: "three_card_brag",
        name: "Three Card Brag",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/tiki_bee_bar": {
        slug: "tiki_bee_bar",
        name: "Tiki Bee Bar",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/tiki_secret": {
        slug: "tiki_secret",
        name: "Tiki Secret",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/toucan_wild": {
        slug: "toucan_wild",
        name: "Toucan Wild",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/triple_monkey": {
        slug: "triple_monkey",
        name: "Triple Monkey",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/twin_fruits": {
        slug: "twin_fruits",
        name: "Twin Fruits",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/two_powerful_dragons": {
        slug: "two_powerful_dragons",
        name: "Two Powerful Dragons",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/vinci_la_gallina_grande": {
        slug: "vinci_la_gallina_grande",
        name: "Vinci la Gallina Grande",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/viva_fruit_vegas": {
        slug: "viva_fruit_vegas",
        name: "Viva Fruit Vegas",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/warriors_gold": {
        slug: "warriors_gold",
        name: "Warriors Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/water_reel": {
        slug: "water_reel",
        name: "Water Reel",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/water_reel_deluxe": {
        slug: "water_reel_deluxe",
        name: "Water Reel Deluxe",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/west_shot": {
        slug: "west_shot",
        name: "West Shot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wicked_777": {
        slug: "wicked_777",
        name: "Wicked 777",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wicked_dice": {
        slug: "wicked_dice",
        name: "Wicked Dice",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wicked_hot": {
        slug: "wicked_hot",
        name: "Wicked Hot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wild_five": {
        slug: "wild_five",
        name: "Wild Five",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wild_moose_bonanza": {
        slug: "wild_moose_bonanza",
        name: "Wild Moose Bonanza",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wild_wild_cash_out": {
        slug: "wild_wild_cash_out",
        name: "Wild Wild Cash Out",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/witchin_winnin": {
        slug: "witchin_winnin",
        name: "Witchin' Winnin'",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/world_cup_gold": {
        slug: "world_cup_gold",
        name: "World Cup Gold",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wu_fu_wa_wa": {
        slug: "wu_fu_wa_wa",
        name: "Wu Fu Wa Wa",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/wu_kong_shadowbound": {
        slug: "wu_kong_shadowbound",
        name: "Wu Kong Shadowbound",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/xiao_wu_kong": {
        slug: "xiao_wu_kong",
        name: "Xiao Wu Kong",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/xing_yun_bian_lian": {
        slug: "xing_yun_bian_lian",
        name: "Xing Yun Bian Lian",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/xuan_wu": {
        slug: "xuan_wu",
        name: "Xuan Wu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/ying_xiong_lu_bu": {
        slug: "ying_xiong_lu_bu",
        name: "Ying Xiong Lu Bu",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/zeus_kingdom_of_riches": {
        slug: "zeus_kingdom_of_riches",
        name: "Zeus Kingdom of Riches",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/zhao_cai_tong_zi": {
        slug: "zhao_cai_tong_zi",
        name: "Zhao Cai Tong Zi",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "skywind/zhao_cai_tong_zi_jackpot": {
        slug: "zhao_cai_tong_zi_jackpot",
        name: "Zhao Cai Tong Zi Jackpot",
        provider: "Skywind",
        providerSlug: "skywind"
    },
    "slot-factory/3_golden_wishes": {
        slug: "3_golden_wishes",
        name: "3 Golden Wishes",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/a_slice_of_the_prizes": {
        slug: "a_slice_of_the_prizes",
        name: "A Slice of the Prizes",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/amity_ville": {
        slug: "amity_ville",
        name: "Amity Ville",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/anchors_away": {
        slug: "anchors_away",
        name: "Anchors Away",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/arena_of_rome": {
        slug: "arena_of_rome",
        name: "Arena of Rome",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/arkham_fear": {
        slug: "arkham_fear",
        name: "Arkham Fear",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/aztec_flame": {
        slug: "aztec_flame",
        name: "Aztec Flame",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/banished_souls": {
        slug: "banished_souls",
        name: "Banished Souls",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bewitcher": {
        slug: "bewitcher",
        name: "BeWitcher",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/big_buddha_bags": {
        slug: "big_buddha_bags",
        name: "Big Buddha Bags",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/big_green_wilds": {
        slug: "big_green_wilds",
        name: "Big Green Wilds",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/big_irish_bucks": {
        slug: "big_irish_bucks",
        name: "Big Irish Bucks",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/big_money_vegas": {
        slug: "big_money_vegas",
        name: "Big Money Vegas",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bingo_blitzer": {
        slug: "bingo_blitzer",
        name: "Bingo Blitzer",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bloomin_bonus": {
        slug: "bloomin_bonus",
        name: "Bloomin Bonus",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bolts_of_zeus": {
        slug: "bolts_of_zeus",
        name: "Bolts Of Zeus",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/booty_ahoy": {
        slug: "booty_ahoy",
        name: "Booty Ahoy",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/britains_got_winners": {
        slug: "britains_got_winners",
        name: "Britain's Got Winners",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bronco_bucks": {
        slug: "bronco_bucks",
        name: "Bronco Bucks",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/bushtucker_bonanza": {
        slug: "bushtucker_bonanza",
        name: "Bushtucker Bonanza",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/cai_shen_jin": {
        slug: "cai_shen_jin",
        name: "Cai Shen Jin",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/captains_coins": {
        slug: "captains_coins",
        name: "Captain's Coins",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/catch_me_a_winner": {
        slug: "catch_me_a_winner",
        name: "Catch me a Winner",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/chicago_boss": {
        slug: "chicago_boss",
        name: "Chicago Boss",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/chilli_king": {
        slug: "chilli_king",
        name: "Chilli King",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/chilli_party": {
        slug: "chilli_party",
        name: "Chilli Party",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/cleopatras_steps": {
        slug: "cleopatras_steps",
        name: "Cleopatra's Steps",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/cocktail_hour": {
        slug: "cocktail_hour",
        name: "Cocktail Hour",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/da_vincis_machine": {
        slug: "da_vincis_machine",
        name: "Da Vinci's Machine",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/devil_joker_slots": {
        slug: "devil_joker_slots",
        name: "Devil Joker Slots",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/doom_lord": {
        slug: "doom_lord",
        name: "Doom Lord",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/double_take": {
        slug: "double_take",
        name: "Double Take",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/dream_genie": {
        slug: "dream_genie",
        name: "Dream Genie",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/egyptian_mystery": {
        slug: "egyptian_mystery",
        name: "Egyptian Mystery",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/egyptian_queens": {
        slug: "egyptian_queens",
        name: "Egyptian Queens",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/exciting_vikings": {
        slug: "exciting_vikings",
        name: "Exciting Vikings",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/fishin_for_wins": {
        slug: "fishin_for_wins",
        name: "Fishin For Wins",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/fishin_for_wins_megaways": {
        slug: "fishin_for_wins_megaways",
        name: "Fishin for Wins Megaways",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/flamin_casino": {
        slug: "flamin_casino",
        name: "Flamin Casino",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/foxtrot": {
        slug: "foxtrot",
        name: "Foxtrot",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/frozen_stiff": {
        slug: "frozen_stiff",
        name: "Frozen Stiff",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/fruits_and_beyond": {
        slug: "fruits_and_beyond",
        name: "Fruits And Beyond",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/gem_fire": {
        slug: "gem_fire",
        name: "Gem Fire",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/golden_rings": {
        slug: "golden_rings",
        name: "Golden Rings",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/golden_road": {
        slug: "golden_road",
        name: "Golden Road",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/gone_to_the_dogs": {
        slug: "gone_to_the_dogs",
        name: "Gone to the Dogs",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/grab_a_bite": {
        slug: "grab_a_bite",
        name: "Grab a Bite",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/grow_on_trees_megaways": {
        slug: "grow_on_trees_megaways",
        name: "Grow on Trees Megaways",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/guardians_of_fortune": {
        slug: "guardians_of_fortune",
        name: "Guardians of Fortune",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/harlequin_wins": {
        slug: "harlequin_wins",
        name: "Harlequin Wins",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/home_run_deluxe": {
        slug: "home_run_deluxe",
        name: "Home Run Deluxe",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/hook_line_and_poker": {
        slug: "hook_line_and_poker",
        name: "Hook Line and Poker",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/hooked_on_a_winner": {
        slug: "hooked_on_a_winner",
        name: "Hooked on a Winner",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/hot_chips": {
        slug: "hot_chips",
        name: "Hot Chips",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/howl_at_the_moon": {
        slug: "howl_at_the_moon",
        name: "Howl at the Moon",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/in_the_bullseye": {
        slug: "in_the_bullseye",
        name: "In The Bullseye",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/irish_prizes": {
        slug: "irish_prizes",
        name: "Irish Prizes",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/juiced_fruits": {
        slug: "juiced_fruits",
        name: "Juiced Fruits",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/kellys_magic_7s": {
        slug: "kellys_magic_7s",
        name: "Kelly's Magic 7's",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/king_in_red": {
        slug: "king_in_red",
        name: "King in Red",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/king_shamrock": {
        slug: "king_shamrock",
        name: "King Shamrock",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/kings_vaults": {
        slug: "kings_vaults",
        name: "King's Vaults",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/koi_koi": {
        slug: "koi_koi",
        name: "Koi Koi",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/legends_luck": {
        slug: "legends_luck",
        name: "Legend's Luck",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/levelled_up": {
        slug: "levelled_up",
        name: "Levelled Up",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/lock_and_key": {
        slug: "lock_and_key",
        name: "Lock and Key",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/magic_coin_slots": {
        slug: "magic_coin_slots",
        name: "Magic Coin Slots",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/magic_treasure_tree": {
        slug: "magic_treasure_tree",
        name: "Magic Treasure Tree",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/masks_of_medusa": {
        slug: "masks_of_medusa",
        name: "Masks of Medusa",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mayan_power": {
        slug: "mayan_power",
        name: "Mayan Power",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_cube": {
        slug: "mega_cube",
        name: "Mega Cube",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_gorilla": {
        slug: "mega_gorilla",
        name: "Mega Gorilla",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_magic_lamps": {
        slug: "mega_magic_lamps",
        name: "Mega Magic Lamps",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_monkeys": {
        slug: "mega_monkeys",
        name: "Mega Monkeys",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_mr_monster": {
        slug: "mega_mr_monster",
        name: "Mega Mr Monster",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_pots_o_gold": {
        slug: "mega_pots_o_gold",
        name: "Mega Pots O' Gold",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mega_trail": {
        slug: "mega_trail",
        name: "Mega Trail",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mer_money": {
        slug: "mer_money",
        name: "Mer Money",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mighty_khan": {
        slug: "mighty_khan",
        name: "Mighty Khan",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/mikey_o_mania": {
        slug: "mikey_o_mania",
        name: "Mikey O' Mania",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/money_grows_on_trees": {
        slug: "money_grows_on_trees",
        name: "Money Grows On Trees",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/one_step_beyond": {
        slug: "one_step_beyond",
        name: "One Step Beyond",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/pearl_prizes": {
        slug: "pearl_prizes",
        name: "Pearl Prizes",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/poppin_party": {
        slug: "poppin_party",
        name: "Poppin' Party",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/pots_o_gold_bonanza": {
        slug: "pots_o_gold_bonanza",
        name: "Pots O' Gold Bonanza",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/power_core": {
        slug: "power_core",
        name: "Power Core",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/power_lines": {
        slug: "power_lines",
        name: "Power Lines",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/prize_pot_picks": {
        slug: "prize_pot_picks",
        name: "Prize Pot Picks",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/prize_pots_ogold": {
        slug: "prize_pots_ogold",
        name: "Prize Pots O'Gold",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/queen_of_spins": {
        slug: "queen_of_spins",
        name: "Queen of Spins",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/queen_of_the_east": {
        slug: "queen_of_the_east",
        name: "Queen of the East",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/queen_of_the_night": {
        slug: "queen_of_the_night",
        name: "Queen of the night",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/queens_of_avalon": {
        slug: "queens_of_avalon",
        name: "Queens of Avalon",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/race_to_the_top": {
        slug: "race_to_the_top",
        name: "Race To The Top",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/red_devil_reel": {
        slug: "red_devil_reel",
        name: "Red Devil Reel",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/red_hot_prizes": {
        slug: "red_hot_prizes",
        name: "Red Hot Prizes",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/reel_fruity_bingo": {
        slug: "reel_fruity_bingo",
        name: "Reel Fruity Bingo",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/royal_joker_slots": {
        slug: "royal_joker_slots",
        name: "Royal Joker Slots",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/secret_stars": {
        slug: "secret_stars",
        name: "Secret Stars",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/shield_of_egypt": {
        slug: "shield_of_egypt",
        name: "Shield of Egypt",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/slash_bros": {
        slug: "slash_bros",
        name: "Slash Bros",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/slot_factory": {
        slug: "slot_factory",
        name: "Slot Factory",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/snatch_the_cash": {
        slug: "snatch_the_cash",
        name: "Snatch the Cash",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/so_many_wilds": {
        slug: "so_many_wilds",
        name: "So Many Wilds",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/spinnerwinner": {
        slug: "spinnerwinner",
        name: "SpinnerWinner",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/square_up": {
        slug: "square_up",
        name: "Square Up",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/steps_to_heaven": {
        slug: "steps_to_heaven",
        name: "Steps to Heaven",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/stunning_7": {
        slug: "stunning_7",
        name: "Stunning 7",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/summer_spins": {
        slug: "summer_spins",
        name: "Summer Spins",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/sunken_riches": {
        slug: "sunken_riches",
        name: "Sunken Riches",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/tales_of_sleepy_hollow": {
        slug: "tales_of_sleepy_hollow",
        name: "Tales of Sleepy Hollow",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/thai_garden": {
        slug: "thai_garden",
        name: "Thai Garden",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/thats_norse": {
        slug: "thats_norse",
        name: "That's Norse",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_captains_quest": {
        slug: "the_captains_quest",
        name: "The Captain's Quest",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_gamblers_arms": {
        slug: "the_gamblers_arms",
        name: "The Gamblers Arms",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_hunter_club": {
        slug: "the_hunter_club",
        name: "The Hunter Club",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_magic_of_cleopatra": {
        slug: "the_magic_of_cleopatra",
        name: "The Magic of Cleopatra",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_magic_river": {
        slug: "the_magic_river",
        name: "The Magic River",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_minotaur": {
        slug: "the_minotaur",
        name: "The Minotaur",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_o_tooles_feud": {
        slug: "the_o_tooles_feud",
        name: "The O Tooles Feud",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_otooles_feud": {
        slug: "the_otooles_feud",
        name: "The O'Tooles Feud",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/the_secret_forest": {
        slug: "the_secret_forest",
        name: "The Secret Forest",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/tower_power": {
        slug: "tower_power",
        name: "Tower Power",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/treasure_of_the_sands": {
        slug: "treasure_of_the_sands",
        name: "Treasure of the Sands",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/treasure_trove": {
        slug: "treasure_trove",
        name: "Treasure Trove",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/where_the_wilds_are": {
        slug: "where_the_wilds_are",
        name: "Where the Wilds Are",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_cleopatra": {
        slug: "wild_cleopatra",
        name: "Wild Cleopatra",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_dealer": {
        slug: "wild_dealer",
        name: "Wild Dealer ",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_dog": {
        slug: "wild_dog",
        name: "Wild Dog",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_eagle_gold": {
        slug: "wild_eagle_gold",
        name: "Wild Eagle Gold",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_sands": {
        slug: "wild_sands",
        name: "Wild Sands",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_slinger": {
        slug: "wild_slinger",
        name: "Wild Slinger",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wild_volcano": {
        slug: "wild_volcano",
        name: "Wild Volcano",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wins_and_wheels": {
        slug: "wins_and_wheels",
        name: "Wins and Wheels",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/witch_queen": {
        slug: "witch_queen",
        name: "Witch Queen",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/wizard_winfall": {
        slug: "wizard_winfall",
        name: "Wizard Winfall",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slot-factory/zodiac_zen": {
        slug: "zodiac_zen",
        name: "Zodiac Zen",
        provider: "Slot Factory",
        providerSlug: "slot-factory"
    },
    "slotmill/brew_brothers": {
        slug: "brew_brothers",
        name: "Brew Brothers",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/brew_brothers_xmas_brew": {
        slug: "brew_brothers_xmas_brew",
        name: "Brew Brothers Xmas Brew",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/carnival_joker_fortune_frenzy": {
        slug: "carnival_joker_fortune_frenzy",
        name: "Carnival Joker Fortune Frenzy",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/cash_pandas": {
        slug: "cash_pandas",
        name: "Cash Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/chilli_bandits": {
        slug: "chilli_bandits",
        name: "Chilli Bandits",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coin_quest": {
        slug: "coin_quest",
        name: "Coin Quest",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coin_quest_2": {
        slug: "coin_quest_2",
        name: "Coin Quest 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/coins_and_cannons": {
        slug: "coins_and_cannons",
        name: "Coins and Cannons",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/crazy_crops": {
        slug: "crazy_crops",
        name: "Crazy Crops",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/dark_forge": {
        slug: "dark_forge",
        name: "Dark Forge",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/dead_mans_crew": {
        slug: "dead_mans_crew",
        name: "Dead Man's Crew",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/dead_mans_drop": {
        slug: "dead_mans_drop",
        name: "Dead Man's Drop",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/demons_gate": {
        slug: "demons_gate",
        name: "Demon's Gate",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/drunken_sailors": {
        slug: "drunken_sailors",
        name: "Drunken Sailors",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emberfall": {
        slug: "emberfall",
        name: "Emberfall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emberfall_40k": {
        slug: "emberfall_40k",
        name: "Emberfall 40K",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/emperors_rise": {
        slug: "emperors_rise",
        name: "Emperor's Rise",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/eternal_dawn": {
        slug: "eternal_dawn",
        name: "Eternal Dawn",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/eternal_dusk": {
        slug: "eternal_dusk",
        name: "Eternal Dusk",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/fortune_pandas": {
        slug: "fortune_pandas",
        name: "Fortune Pandas",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/fruit_smash": {
        slug: "fruit_smash",
        name: "Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/gem_rush": {
        slug: "gem_rush",
        name: "Gem Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/gods_of_glory": {
        slug: "gods_of_glory",
        name: "Gods of Glory",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/golden_scrolls": {
        slug: "golden_scrolls",
        name: "Golden Scrolls",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/king_of_the_streets": {
        slug: "king_of_the_streets",
        name: "King of the Streets",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/last_man_standing": {
        slug: "last_man_standing",
        name: "Last Man Standing",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucky_lucifer": {
        slug: "lucky_lucifer",
        name: "Lucky Lucifer",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_crimson_diamond": {
        slug: "lucy_luck_and_the_crimson_diamond",
        name: "Lucy Luck and the Crimson Diamond",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_quest_for_coins": {
        slug: "lucy_luck_and_the_quest_for_coins",
        name: "Lucy Luck and the Quest for Coins",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/lucy_luck_and_the_temple_of_mysteries": {
        slug: "lucy_luck_and_the_temple_of_mysteries",
        name: "Lucy Luck and the Temple of Mysteries",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/merlins_fortune": {
        slug: "merlins_fortune",
        name: "Merlin's Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/money_jar": {
        slug: "money_jar",
        name: "Money Jar",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/money_jar_2": {
        slug: "money_jar_2",
        name: "Money Jar 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/neon_dreams": {
        slug: "neon_dreams",
        name: "Neon Dreams",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/outlaws": {
        slug: "outlaws",
        name: "Outlaws",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/raging_riches": {
        slug: "raging_riches",
        name: "Raging Riches",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ragnarok": {
        slug: "ragnarok",
        name: "Ragnarok",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ragnarok_40k": {
        slug: "ragnarok_40k",
        name: "Ragnarok 40k",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ragnarok_gold": {
        slug: "ragnarok_gold",
        name: "Ragnarok Gold",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/rainbow_rush": {
        slug: "rainbow_rush",
        name: "Rainbow Rush",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/reel_rampage": {
        slug: "reel_rampage",
        name: "Reel Rampage",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sands_of_eternity": {
        slug: "sands_of_eternity",
        name: "Sands of Eternity",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sands_of_eternity_2": {
        slug: "sands_of_eternity_2",
        name: "Sands of Eternity 2",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/season_of_fortune": {
        slug: "season_of_fortune",
        name: "Season of Fortune",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/shadow_of_dominion": {
        slug: "shadow_of_dominion",
        name: "Shadow of Dominion",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/shark_frenzy": {
        slug: "shark_frenzy",
        name: "Shark Frenzy",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/starspell": {
        slug: "starspell",
        name: "StarSpell",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/super_fruit_smash": {
        slug: "super_fruit_smash",
        name: "Super Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/sweet_spotz": {
        slug: "sweet_spotz",
        name: "Sweet Spotz",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/the_big_hit": {
        slug: "the_big_hit",
        name: "The Big Hit",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/three_samurai": {
        slug: "three_samurai",
        name: "Three Samurai",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/thunder_wheel": {
        slug: "thunder_wheel",
        name: "Thunder Wheel",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/tiki_thunder": {
        slug: "tiki_thunder",
        name: "Tiki Thunder",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/tyrants_fall": {
        slug: "tyrants_fall",
        name: "Tyrant's Fall",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/ultra_fruit_smash": {
        slug: "ultra_fruit_smash",
        name: "Ultra Fruit Smash",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/vegas_gold": {
        slug: "vegas_gold",
        name: "Vegas Gold",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/vikings_creed": {
        slug: "vikings_creed",
        name: "Vikings Creed",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/wild_bison_stampede": {
        slug: "wild_bison_stampede",
        name: "Wild Bison Stampede",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/wildfire": {
        slug: "wildfire",
        name: "Wildfire",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotmill/wildhalla": {
        slug: "wildhalla",
        name: "Wildhalla",
        provider: "Slotmill",
        providerSlug: "slotmill"
    },
    "slotopia/arctic_spins": {
        slug: "arctic_spins",
        name: "Arctic Spins",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/blazing_fireballs": {
        slug: "blazing_fireballs",
        name: "Blazing Fireballs",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/blazing_lucky_sevens": {
        slug: "blazing_lucky_sevens",
        name: "Blazing Lucky Sevens",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/book_of_plenty": {
        slug: "book_of_plenty",
        name: "Book of Plenty",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/book_of_reels": {
        slug: "book_of_reels",
        name: "Book of Reels",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/book_of_reels_hold_and_win": {
        slug: "book_of_reels_hold_and_win",
        name: "Book of Reels Hold and Win",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/caliente_de_chili": {
        slug: "caliente_de_chili",
        name: "Caliente de Chili",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/candy_luck": {
        slug: "candy_luck",
        name: "Candy Luck",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/christmas_wonders": {
        slug: "christmas_wonders",
        name: "Christmas Wonders",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/coin_forge": {
        slug: "coin_forge",
        name: "Coin Forge",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/coin_forge_bonus_buy": {
        slug: "coin_forge_bonus_buy",
        name: "Coin Forge Bonus Buy",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/coin_forge_magnetic": {
        slug: "coin_forge_magnetic",
        name: "Coin Forge Magnetic",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/coin_galactic": {
        slug: "coin_galactic",
        name: "Coin Galactic",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/coin_meteor": {
        slug: "coin_meteor",
        name: "Coin Meteor",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/desert_secret_treasures": {
        slug: "desert_secret_treasures",
        name: "Desert Secret Treasures",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/diamonds_expand": {
        slug: "diamonds_expand",
        name: "Diamonds Expand",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/diamonds_hunt": {
        slug: "diamonds_hunt",
        name: "Diamonds Hunt",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/double_up_machine": {
        slug: "double_up_machine",
        name: "Double Up Machine",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/double_up_respin": {
        slug: "double_up_respin",
        name: "Double Up Respin",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/dragon_balls": {
        slug: "dragon_balls",
        name: "Dragon Balls",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/dragons_fireworks": {
        slug: "dragons_fireworks",
        name: "Dragon's Fireworks",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fishing_mania": {
        slug: "fishing_mania",
        name: "Fishing Mania",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fruit_fantasy_100": {
        slug: "fruit_fantasy_100",
        name: "Fruit Fantasy 100",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fruit_fantasy_40": {
        slug: "fruit_fantasy_40",
        name: "Fruit Fantasy 40",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fruit_fantasy_hold_and_win": {
        slug: "fruit_fantasy_hold_and_win",
        name: "Fruit Fantasy Hold and Win",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fruitful_harvest": {
        slug: "fruitful_harvest",
        name: "Fruitful Harvest",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/fun_fair_fruits_100": {
        slug: "fun_fair_fruits_100",
        name: "Fun Fair Fruits 100",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/green_hat_magic": {
        slug: "green_hat_magic",
        name: "Green Hat Magic",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/green_hat_tale": {
        slug: "green_hat_tale",
        name: "Green Hat Tale",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/hellfire_joker": {
        slug: "hellfire_joker",
        name: "Hellfire Joker",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/hellfire_peppers": {
        slug: "hellfire_peppers",
        name: "Hellfire Peppers",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/hot_prize_paradise": {
        slug: "hot_prize_paradise",
        name: "Hot Prize Paradise",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/immortal_treasures": {
        slug: "immortal_treasures",
        name: "Immortal Treasures",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/jaguars_mystic_ways": {
        slug: "jaguars_mystic_ways",
        name: "Jaguar's Mystic Ways",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/jewel_jester": {
        slug: "jewel_jester",
        name: "Jewel Jester",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/joker_juicer_6": {
        slug: "joker_juicer_6",
        name: "Joker Juicer 6",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/jokers_invasion": {
        slug: "jokers_invasion",
        name: "Jokers Invasion",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/juicy_triple_bonus": {
        slug: "juicy_triple_bonus",
        name: "Juicy Triple Bonus",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/lucky_fruit_spins": {
        slug: "lucky_fruit_spins",
        name: "Lucky Fruit Spins",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/lucky_fruit_spins_bonus_buy": {
        slug: "lucky_fruit_spins_bonus_buy",
        name: "Lucky Fruit Spins Bonus Buy",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_diamonds_hunt": {
        slug: "mega_diamonds_hunt",
        name: "Mega Diamonds Hunt",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_fishing_mania": {
        slug: "mega_fishing_mania",
        name: "Mega Fishing Mania",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_fruit_100": {
        slug: "mega_fruit_100",
        name: "Mega Fruit 100",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_fruit_20": {
        slug: "mega_fruit_20",
        name: "Mega Fruit 20",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_fruit_40": {
        slug: "mega_fruit_40",
        name: "Mega Fruit 40",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_juicer_5": {
        slug: "mega_juicer_5",
        name: "Mega Juicer 5",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mega_juicer_6": {
        slug: "mega_juicer_6",
        name: "Mega Juicer 6",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/mystic_pot_treasures": {
        slug: "mystic_pot_treasures",
        name: "Mystic Pot Treasures",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/pepper_mania": {
        slug: "pepper_mania",
        name: "Pepper Mania",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/pyro_joker_ultimate": {
        slug: "pyro_joker_ultimate",
        name: "Pyro Joker Ultimate",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/reel_hit": {
        slug: "reel_hit",
        name: "Reel Hit",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/sizzling_777_classic": {
        slug: "sizzling_777_classic",
        name: "Sizzling 777 Classic",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/sizzling_sevens": {
        slug: "sizzling_sevens",
        name: "Sizzling Sevens",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/sizzling_sevens_hold_and_win": {
        slug: "sizzling_sevens_hold_and_win",
        name: "Sizzling Sevens Hold and Win",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/sizzling_sevens_special": {
        slug: "sizzling_sevens_special",
        name: "Sizzling Sevens Special",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/sizzling_super_sevens": {
        slug: "sizzling_super_sevens",
        name: "Sizzling Super Sevens",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/super_sizzling_ways": {
        slug: "super_sizzling_ways",
        name: "Super Sizzling Ways",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/the_greatest_treasures": {
        slug: "the_greatest_treasures",
        name: "The Greatest Treasures",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/the_joker_show": {
        slug: "the_joker_show",
        name: "The Joker Show",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/thunder_wilds": {
        slug: "thunder_wilds",
        name: "Thunder Wilds",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/ultra_coin_magnetic_bonus_buy": {
        slug: "ultra_coin_magnetic_bonus_buy",
        name: "Ultra Coin Magnetic Bonus Buy",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/ultra_hot_joker": {
        slug: "ultra_hot_joker",
        name: "Ultra Hot Joker",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/ultra_hot_sevens": {
        slug: "ultra_hot_sevens",
        name: "Ultra Hot Sevens",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/wild_double_up": {
        slug: "wild_double_up",
        name: "Wild Double Up",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "slotopia/yappy_scrappy": {
        slug: "yappy_scrappy",
        name: "Yappy Scrappy",
        provider: "Slotopia",
        providerSlug: "slotopia"
    },
    "solvited/gold_fever": {
        slug: "gold_fever",
        name: "Gold Fever",
        provider: "Solvited",
        providerSlug: "solvited"
    },
    "speedytomatoes/aces_6000_powerpoker": {
        slug: "aces_6000_powerpoker",
        name: "Aces 6000 Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/deuces_wild_powerpoker": {
        slug: "deuces_wild_powerpoker",
        name: "Deuces Wild Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/double_joker_side_bet_powerpoker": {
        slug: "double_joker_side_bet_powerpoker",
        name: "Double Joker Side Bet Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/jacks_or_better_4000_powerpoker": {
        slug: "jacks_or_better_4000_powerpoker",
        name: "Jacks or Better 4000 Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/joker_poker_powerpoker": {
        slug: "joker_poker_powerpoker",
        name: "Joker Poker Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/kansas_city_lowball_powerpoker": {
        slug: "kansas_city_lowball_powerpoker",
        name: "Kansas City Lowball Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/kings_and_queens_side_bet_powerpoker": {
        slug: "kings_and_queens_side_bet_powerpoker",
        name: "Kings and Queens Side Bet Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/louisiana_double_powerpoker": {
        slug: "louisiana_double_powerpoker",
        name: "Louisiana Double Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/nines_or_better_triple_win_powerpoker": {
        slug: "nines_or_better_triple_win_powerpoker",
        name: "Nines or Better Triple Win Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "speedytomatoes/tens_or_better_sidebet_powerpoker": {
        slug: "tens_or_better_sidebet_powerpoker",
        name: "Tens or Better SideBet Powerpoker",
        provider: "Speedytomatoes",
        providerSlug: "speedytomatoes"
    },
    "storm-gaming/alchemy": {
        slug: "alchemy",
        name: "Alchemy",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/arto_and_the_seven_deadly_spins_megaways": {
        slug: "arto_and_the_seven_deadly_spins_megaways",
        name: "Arto and the Seven Deadly Spins MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/lucky_money": {
        slug: "lucky_money",
        name: "Lucky Money",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/megaways_mob": {
        slug: "megaways_mob",
        name: "MegaWays Mob",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/payday_megaways": {
        slug: "payday_megaways",
        name: "Payday MegaWays",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "storm-gaming/ticket_to_fortune": {
        slug: "ticket_to_fortune",
        name: "Ticket To Fortune",
        provider: "Storm Gaming",
        providerSlug: "storm-gaming"
    },
    "sweepnow/sweepnow_loader": {
        slug: "sweepnow_loader",
        name: "SweepNow Loader",
        provider: "Sweepnow",
        providerSlug: "sweepnow"
    },
    "taparoo/cash_volt_taparoo": {
        slug: "cash_volt_taparoo",
        name: "Cash Volt Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "taparoo/dragons_luck_taparoo": {
        slug: "dragons_luck_taparoo",
        name: "Dragon's Luck Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "taparoo/great_pyramid_taparoo": {
        slug: "great_pyramid_taparoo",
        name: "Great Pyramid Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "taparoo/mystery_fruit_taparoo": {
        slug: "mystery_fruit_taparoo",
        name: "Mystery Fruit Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "taparoo/rainbow_jackpots_taparoo": {
        slug: "rainbow_jackpots_taparoo",
        name: "Rainbow Jackpots Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "taparoo/starburst_taparoo": {
        slug: "starburst_taparoo",
        name: "Starburst Tap-A-Roo",
        provider: "Taparoo",
        providerSlug: "taparoo"
    },
    "thunderkick/12_bolts_of_thunder": {
        slug: "12_bolts_of_thunder",
        name: "12 Bolts of Thunder",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/1429_uncharted_seas": {
        slug: "1429_uncharted_seas",
        name: "1429 Uncharted Seas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/3_wildos": {
        slug: "3_wildos",
        name: "3 Wildos",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/alice_time_rift": {
        slug: "alice_time_rift",
        name: "Alice: Time Rift",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/arcader": {
        slug: "arcader",
        name: "Arcader",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/archie_ologgins_and_the_enchanted_masks": {
        slug: "archie_ologgins_and_the_enchanted_masks",
        name: "Archie O'Loggins and the Enchanted Masks",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/babushkas": {
        slug: "babushkas",
        name: "Babushkas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/barbershop_uncut": {
        slug: "barbershop_uncut",
        name: "Barbershop: Uncut",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/baron_bloodmore_and_the_crimson_castle": {
        slug: "baron_bloodmore_and_the_crimson_castle",
        name: "Baron Bloodmore and the Crimson Castle",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/bass_hunter": {
        slug: "bass_hunter",
        name: "Bass Hunter",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_cerberus_inferno": {
        slug: "beat_the_beast_cerberus_inferno",
        name: "Beat the Beast: Cerberus' Inferno",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_dragons_wrath": {
        slug: "beat_the_beast_dragons_wrath",
        name: "Beat the Beast: Dragon's Wrath",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_griffins_gold": {
        slug: "beat_the_beast_griffins_gold",
        name: "Beat the Beast: Griffin's Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_griffins_gold_reborn": {
        slug: "beat_the_beast_griffins_gold_reborn",
        name: "Beat the Beast: Griffin's Gold Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_krakens_lair": {
        slug: "beat_the_beast_krakens_lair",
        name: "Beat the Beast: Kraken's Lair",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/beat_the_beast_quetzalcoatls_trial": {
        slug: "beat_the_beast_quetzalcoatls_trial",
        name: "Beat the Beast: Quetzalcoatl's Trial",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/big_fin_bay": {
        slug: "big_fin_bay",
        name: "Big Fin Bay",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/birds_on_a_wire": {
        slug: "birds_on_a_wire",
        name: "Birds On A Wire",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/bjorn": {
        slug: "bjorn",
        name: "Bjorn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/bones_and_bounty": {
        slug: "bones_and_bounty",
        name: "Bones and Bounty",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/bork_the_berzerker_hack_n_slash_edition": {
        slug: "bork_the_berzerker_hack_n_slash_edition",
        name: "Bork The Berzerker Hack 'N' Slash Edition",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/carnival_queen": {
        slug: "carnival_queen",
        name: "Carnival Queen",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/carnival_queen_2": {
        slug: "carnival_queen_2",
        name: "Carnival Queen 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/carnival_queen_reborn": {
        slug: "carnival_queen_reborn",
        name: "Carnival Queen Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/cosmic_voyager": {
        slug: "cosmic_voyager",
        name: "Cosmic Voyager",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/crystal_quest_arcane_tower": {
        slug: "crystal_quest_arcane_tower",
        name: "Crystal Quest: Arcane Tower",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/crystal_quest_deep_jungle": {
        slug: "crystal_quest_deep_jungle",
        name: "Crystal Quest: Deep Jungle",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/crystal_quest_frostlands": {
        slug: "crystal_quest_frostlands",
        name: "Crystal Quest: Frostlands",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/dionysus_golden_feast": {
        slug: "dionysus_golden_feast",
        name: "Dionysus Golden Feast",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/divine_lotus": {
        slug: "divine_lotus",
        name: "Divine Lotus",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/dragon_horn": {
        slug: "dragon_horn",
        name: "Dragon Horn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/eager_beavers": {
        slug: "eager_beavers",
        name: "Eager Beavers",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/esqueleto_explosivo": {
        slug: "esqueleto_explosivo",
        name: "Esqueleto Explosivo",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/esqueleto_explosivo_2": {
        slug: "esqueleto_explosivo_2",
        name: "Esqueleto Explosivo 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/esqueleto_explosivo_2_reborn": {
        slug: "esqueleto_explosivo_2_reborn",
        name: "Esqueleto Explosivo 2 Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/esqueleto_explosivo_3": {
        slug: "esqueleto_explosivo_3",
        name: "Esqueleto Explosivo 3",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/esqueleto_explosivo_feliz_navidead": {
        slug: "esqueleto_explosivo_feliz_navidead",
        name: "Esqueleto Explosivo Feliz Navidead",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/flame_busters": {
        slug: "flame_busters",
        name: "Flame Busters",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/flux": {
        slug: "flux",
        name: "Flux",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/fortune_cats": {
        slug: "fortune_cats",
        name: "Fortune Cats",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/frog_grog": {
        slug: "frog_grog",
        name: "Frog Grog",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/fruit_warp": {
        slug: "fruit_warp",
        name: "Fruit Warp",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/full_moon_romance": {
        slug: "full_moon_romance",
        name: "Full Moon Romance",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/gods_of_rock": {
        slug: "gods_of_rock",
        name: "Gods of Rock!",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/gods_of_rock_reborn": {
        slug: "gods_of_rock_reborn",
        name: "Gods of Rock! Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/grand_melee": {
        slug: "grand_melee",
        name: "Grand Melee",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/hammerblaze": {
        slug: "hammerblaze",
        name: "Hammerblaze",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/heads_will_roll": {
        slug: "heads_will_roll",
        name: "Heads Will Roll",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/hellapenos": {
        slug: "hellapenos",
        name: "Hellapenos",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/hot_potato": {
        slug: "hot_potato",
        name: "Hot Potato",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/hot_potato_battleground": {
        slug: "hot_potato_battleground",
        name: "Hot Potato Battleground",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/hot_turkey": {
        slug: "hot_turkey",
        name: "Hot Turkey",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/jaguar_temple": {
        slug: "jaguar_temple",
        name: "Jaguar Temple",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/jiggly_cash": {
        slug: "jiggly_cash",
        name: "Jiggly Cash",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/jin_chans_pond_of_riches": {
        slug: "jin_chans_pond_of_riches",
        name: "Jin Chan's Pond of Riches",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/king_of_the_party": {
        slug: "king_of_the_party",
        name: "King of the Party",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/lava_lava": {
        slug: "lava_lava",
        name: "Lava Lava",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/lost_city_of_the_djinn": {
        slug: "lost_city_of_the_djinn",
        name: "Lost City of the Djinn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/luchadora": {
        slug: "luchadora",
        name: "Luchadora",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/magicious": {
        slug: "magicious",
        name: "Magicious",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/mejuicea": {
        slug: "mejuicea",
        name: "MeJUICEa",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch": {
        slug: "midas_golden_touch",
        name: "Midas Golden Touch",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch_2": {
        slug: "midas_golden_touch_2",
        name: "Midas Golden Touch 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch_3": {
        slug: "midas_golden_touch_3",
        name: "Midas Golden Touch 3",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch_christmas_edition": {
        slug: "midas_golden_touch_christmas_edition",
        name: "Midas Golden Touch Christmas Edition",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch_reborn": {
        slug: "midas_golden_touch_reborn",
        name: "Midas Golden Touch Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/midas_golden_touch_thunder_pots": {
        slug: "midas_golden_touch_thunder_pots",
        name: "Midas Golden Touch: Thunder Pots",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/milk_the_cow": {
        slug: "milk_the_cow",
        name: "Milk the Cow",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/not_enough_kittens": {
        slug: "not_enough_kittens",
        name: "Not Enough Kittens",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/odins_gamble": {
        slug: "odins_gamble",
        name: "Odin's Gamble",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/odins_gamble_reborn": {
        slug: "odins_gamble_reborn",
        name: "Odins Gamble Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pans_arcadia": {
        slug: "pans_arcadia",
        name: "Pan's Arcadia",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/phoenix_paradise": {
        slug: "phoenix_paradise",
        name: "Phoenix Paradise",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pink_elephants": {
        slug: "pink_elephants",
        name: "Pink Elephants",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pink_elephants_2": {
        slug: "pink_elephants_2",
        name: "Pink Elephants 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pink_elephants_2_reborn": {
        slug: "pink_elephants_2_reborn",
        name: "Pink Elephants 2 Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pink_elephants_trinity": {
        slug: "pink_elephants_trinity",
        name: "Pink Elephants Trinity",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pyramyth": {
        slug: "pyramyth",
        name: "Pyramyth",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/pyramyth_reborn": {
        slug: "pyramyth_reborn",
        name: "Pyramyth Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/ravens_eye": {
        slug: "ravens_eye",
        name: "Raven's Eye",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/rex_the_hunt": {
        slug: "rex_the_hunt",
        name: "Rex the Hunt",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/riders_of_the_storm": {
        slug: "riders_of_the_storm",
        name: "Riders of the Storm",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/rocket_fellas_inc": {
        slug: "rocket_fellas_inc",
        name: "Rocket Fellas Inc",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/second_thunder": {
        slug: "second_thunder",
        name: "Second Thunder",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/serpentico_smash": {
        slug: "serpentico_smash",
        name: "Serpentico Smash",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/shifting_seas": {
        slug: "shifting_seas",
        name: "Shifting Seas",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/spectra": {
        slug: "spectra",
        name: "Spectra",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/split_happens": {
        slug: "split_happens",
        name: "Split Happens",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/sunset_delight": {
        slug: "sunset_delight",
        name: "Sunset Delight",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/sword_of_arthur": {
        slug: "sword_of_arthur",
        name: "Sword of Arthur",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/sword_of_khans": {
        slug: "sword_of_khans",
        name: "Sword of Khans",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/sword_of_khans_reborn": {
        slug: "sword_of_khans_reborn",
        name: "Sword of Khans Reborn",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/sword_of_shoguns": {
        slug: "sword_of_shoguns",
        name: "Sword of Shoguns",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/temple_of_akhet": {
        slug: "temple_of_akhet",
        name: "Temple of Akhet",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_falcon_huntress": {
        slug: "the_falcon_huntress",
        name: "The Falcon Huntress",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_golden_pot_and_pints": {
        slug: "the_golden_pot_and_pints",
        name: "The Golden Pot and Pints",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_gunman_of_goldwood": {
        slug: "the_gunman_of_goldwood",
        name: "The Gunman of Goldwood",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_rift": {
        slug: "the_rift",
        name: "The Rift",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_wildos": {
        slug: "the_wildos",
        name: "The Wildos",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/the_wildos_2": {
        slug: "the_wildos_2",
        name: "The Wildos 2",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/tiger_rush": {
        slug: "tiger_rush",
        name: "Tiger Rush",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/toki_time": {
        slug: "toki_time",
        name: "Toki Time",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/triple_christmas_gold": {
        slug: "triple_christmas_gold",
        name: "Triple Christmas Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/triple_royal_gold": {
        slug: "triple_royal_gold",
        name: "Triple Royal Gold",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/turning_totems": {
        slug: "turning_totems",
        name: "Turning Totems",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/tutan_khaboom": {
        slug: "tutan_khaboom",
        name: "Tutan Kha-boom",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/ways_of_athena": {
        slug: "ways_of_athena",
        name: "Ways of Athena",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/well_of_wonders": {
        slug: "well_of_wonders",
        name: "Well of Wonders",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/wild_heist_at_peacock_manor": {
        slug: "wild_heist_at_peacock_manor",
        name: "Wild Heist at Peacock Manor",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/xterminate": {
        slug: "xterminate",
        name: "Xterminate",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/yeti_battle_of_greenhat_peak": {
        slug: "yeti_battle_of_greenhat_peak",
        name: "Yeti Battle of Greenhat peak",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/zap_attack": {
        slug: "zap_attack",
        name: "Zap Attack!",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "thunderkick/zoom": {
        slug: "zoom",
        name: "Zoom",
        provider: "Thunderkick",
        providerSlug: "thunderkick"
    },
    "tomhorn/243_chili": {
        slug: "243_chili",
        name: "243 Chili",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_christmas_fruits": {
        slug: "243_christmas_fruits",
        name: "243 Christmas Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_crystal_fruits": {
        slug: "243_crystal_fruits",
        name: "243 Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_crystal_fruits_reversed": {
        slug: "243_crystal_fruits_reversed",
        name: "243 Crystal Fruits Reversed",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_fire_n_diamonds": {
        slug: "243_fire_n_diamonds",
        name: "243 Fire n Diamonds",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/243_zeus_fruits": {
        slug: "243_zeus_fruits",
        name: "243 Zeus Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/3_mermaids": {
        slug: "3_mermaids",
        name: "3 Mermaids",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/3_ribbon_pots": {
        slug: "3_ribbon_pots",
        name: "3 Ribbon Pots",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/3_street_sevens": {
        slug: "3_street_sevens",
        name: "3 Street Sevens",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_creepy_circus": {
        slug: "81_creepy_circus",
        name: "81 Creepy Circus",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_frutas_grandes": {
        slug: "81_frutas_grandes",
        name: "81 Frutas Grandes",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_frutas_grandes_vip": {
        slug: "81_frutas_grandes_vip",
        name: "81 Frutas Grandes VIP",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/81_joker_x": {
        slug: "81_joker_x",
        name: "81 Joker X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/aarupolis": {
        slug: "aarupolis",
        name: "Aarupolis",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/akne_fruits": {
        slug: "akne_fruits",
        name: "Akne Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/alien_sea_turtles_vs_humans": {
        slug: "alien_sea_turtles_vs_humans",
        name: "Alien Sea Turtles vs Humans",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/bank_wagon_heist": {
        slug: "bank_wagon_heist",
        name: "Bank Wagon Heist",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/beast_coinz": {
        slug: "beast_coinz",
        name: "Beast Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/beastie_bux": {
        slug: "beastie_bux",
        name: "Beastie Bux",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/biggy_winnie_feat_the_rich_one": {
        slug: "biggy_winnie_feat_the_rich_one",
        name: "Biggy Winnie feat The Rich One",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/bison_vs_buffalo": {
        slug: "bison_vs_buffalo",
        name: "Bison vs Buffalo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/black_mummy": {
        slug: "black_mummy",
        name: "Black Mummy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/blackbeards_quest": {
        slug: "blackbeards_quest",
        name: "Blackbeard's Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_cleo": {
        slug: "book_of_cleo",
        name: "Book of Cleo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_crystal_fruits": {
        slug: "book_of_crystal_fruits",
        name: "Book of Crystal Fruits",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_darius": {
        slug: "book_of_darius",
        name: "Book of Darius",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_spells": {
        slug: "book_of_spells",
        name: "Book of Spells",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/book_of_vampires": {
        slug: "book_of_vampires",
        name: "Book of Vampires",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/candy_coinz": {
        slug: "candy_coinz",
        name: "Candy Coinz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/cricket_mania": {
        slug: "cricket_mania",
        name: "Cricket Mania",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/crowns_legacy": {
        slug: "crowns_legacy",
        name: "Crown's Legacy",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/crystal_fruits_bonanza": {
        slug: "crystal_fruits_bonanza",
        name: "Crystal Fruits Bonanza",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/diamond_hill": {
        slug: "diamond_hill",
        name: "Diamond Hill",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/don_juans_peppers": {
        slug: "don_juans_peppers",
        name: "Don Juan's Peppers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_egg": {
        slug: "dragon_egg",
        name: "Dragon Egg",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_riches": {
        slug: "dragon_riches",
        name: "Dragon Riches",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/dragon_vs_phoenix": {
        slug: "dragon_vs_phoenix",
        name: "Dragon VS Phoenix",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/feng_fu": {
        slug: "feng_fu",
        name: "Feng Fu",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/firenhot": {
        slug: "firenhot",
        name: "Fire'n'Hot",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/flaming_fruit": {
        slug: "flaming_fruit",
        name: "Flaming Fruit",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/fluxberry": {
        slug: "fluxberry",
        name: "Fluxberry",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/frozen_queen": {
        slug: "frozen_queen",
        name: "Frozen Queen",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/fruits_go_pop": {
        slug: "fruits_go_pop",
        name: "Fruits Go Pop!",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/frutopia": {
        slug: "frutopia",
        name: "Frutopia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/geishas_fan": {
        slug: "geishas_fan",
        name: "Geisha's Fan",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/gizas_portals": {
        slug: "gizas_portals",
        name: "Giza's Portals",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/gold_x": {
        slug: "gold_x",
        name: "Gold X",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hawaii_fever": {
        slug: "hawaii_fever",
        name: "Hawaii Fever",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hook_the_fortune": {
        slug: "hook_the_fortune",
        name: "Hook the Fortune",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hot_blizzard": {
        slug: "hot_blizzard",
        name: "Hot Blizzard",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hot_blizzard_deluxe": {
        slug: "hot_blizzard_deluxe",
        name: "Hot Blizzard Deluxe",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/hotnfruity": {
        slug: "hotnfruity",
        name: "Hot'n'Fruity",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/incas_treasure": {
        slug: "incas_treasure",
        name: "Inca's Treasure",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/joker_reelz": {
        slug: "joker_reelz",
        name: "Joker Reelz",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/kongo_bongo": {
        slug: "kongo_bongo",
        name: "Kongo Bongo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/la_tomatina": {
        slug: "la_tomatina",
        name: "La Tomatina",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/lucky_scarab": {
        slug: "lucky_scarab",
        name: "Lucky Scarab",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/majestic_coins": {
        slug: "majestic_coins",
        name: "Majestic Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/majestic_coins_extreme": {
        slug: "majestic_coins_extreme",
        name: "Majestic Coins Extreme",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/mine_mine_quest": {
        slug: "mine_mine_quest",
        name: "Mine Mine Quest",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/money_bunny_show": {
        slug: "money_bunny_show",
        name: "Money Bunny Show",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/monkey_27": {
        slug: "monkey_27",
        name: "Monkey 27",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/monster_madness": {
        slug: "monster_madness",
        name: "Monster Madness",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pandas_run": {
        slug: "pandas_run",
        name: "Pandas Run",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pantera_rica": {
        slug: "pantera_rica",
        name: "Pantera Rica",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pengwins": {
        slug: "pengwins",
        name: "PengWins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/piggy_bank_heist": {
        slug: "piggy_bank_heist",
        name: "Piggy Bank Heist",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pirate_coins": {
        slug: "pirate_coins",
        name: "Pirate Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/pirates_parrot": {
        slug: "pirates_parrot",
        name: "Pirate's Parrot",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/reborn_of_zeus_3000": {
        slug: "reborn_of_zeus_3000",
        name: "Reborn of Zeus 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/red_head_bounty": {
        slug: "red_head_bounty",
        name: "Red Head Bounty",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/rot_stormo": {
        slug: "rot_stormo",
        name: "Rot Stormo",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/royal_ruby_featurestorm": {
        slug: "royal_ruby_featurestorm",
        name: "Royal Ruby FeatureStorm",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/santa_yetti": {
        slug: "santa_yetti",
        name: "Santa Yetti",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/savannah_king": {
        slug: "savannah_king",
        name: "Savannah King",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/shaolins_tiger": {
        slug: "shaolins_tiger",
        name: "Shaolin's Tiger",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sherlock_a_scandal_in_bohemia": {
        slug: "sherlock_a_scandal_in_bohemia",
        name: "Sherlock: A Scandal in Bohemia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sizable_win": {
        slug: "sizable_win",
        name: "Sizable Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sky_barons": {
        slug: "sky_barons",
        name: "Sky Barons",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/space_jammers": {
        slug: "space_jammers",
        name: "Space Jammers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/spinball": {
        slug: "spinball",
        name: "Spinball",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sweet_crush": {
        slug: "sweet_crush",
        name: "Sweet Crush",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/sweet_gold_3000": {
        slug: "sweet_gold_3000",
        name: "Sweet Gold 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/tao_tree_coins": {
        slug: "tao_tree_coins",
        name: "Tao Tree Coins",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/the_cup": {
        slug: "the_cup",
        name: "The Cup",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/the_secret_of_ba": {
        slug: "the_secret_of_ba",
        name: "The Secret of BA",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/thor_candy_storm_3000": {
        slug: "thor_candy_storm_3000",
        name: "Thor Candy Storm 3000",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/thrones_of_persia": {
        slug: "thrones_of_persia",
        name: "Thrones of Persia",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_joker": {
        slug: "triple_joker",
        name: "Triple Joker",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_thunder": {
        slug: "triple_thunder",
        name: "Triple Thunder",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/triple_up": {
        slug: "triple_up",
        name: "Triple Up",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wheel_of_luck_hold_and_win": {
        slug: "wheel_of_luck_hold_and_win",
        name: "Wheel of Luck Hold and Win",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_mirage": {
        slug: "wild_mirage",
        name: "Wild Mirage",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_skyfire": {
        slug: "wild_skyfire",
        name: "Wild Skyfire",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_tribe_wall": {
        slug: "wild_tribe_wall",
        name: "Wild Tribe Wall",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wild_weather": {
        slug: "wild_weather",
        name: "Wild Weather",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/wolf_sierra": {
        slug: "wolf_sierra",
        name: "Wolf Sierra",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "tomhorn/zeus_diving_multipliers": {
        slug: "zeus_diving_multipliers",
        name: "Zeus Diving Multipliers",
        provider: "TomHorn",
        providerSlug: "tomhorn"
    },
    "topspin/3_cards": {
        slug: "3_cards",
        name: "3 Cards",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/3_cards_diwali_special": {
        slug: "3_cards_diwali_special",
        name: "3 Cards Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/airavat_the_white_elephant": {
        slug: "airavat_the_white_elephant",
        name: "Airavat The White Elephant",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/airavat_white_elephant_scratch": {
        slug: "airavat_white_elephant_scratch",
        name: "Airavat White Elephant Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/angel_ascend_crash": {
        slug: "angel_ascend_crash",
        name: "Angel Ascend Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/bhanumatis_magic_box": {
        slug: "bhanumatis_magic_box",
        name: "Bhanumatis Magic Box",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/bhanumatis_magic_box_mine": {
        slug: "bhanumatis_magic_box_mine",
        name: "Bhanumati's Magic Box Mine",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/big_cats_of_india": {
        slug: "big_cats_of_india",
        name: "Big Cats of India",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/crown_flag": {
        slug: "crown_flag",
        name: "Crown Flag",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/divine_fruits": {
        slug: "divine_fruits",
        name: "Divine Fruits",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/end_of_us_zombie_respin": {
        slug: "end_of_us_zombie_respin",
        name: "End of Us Zombie Respin",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/ftv_night_club": {
        slug: "ftv_night_club",
        name: "FTV Night Club",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/gold_silver_diamond": {
        slug: "gold_silver_diamond",
        name: "Gold Silver Diamond",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/golden_egg": {
        slug: "golden_egg",
        name: "Golden Egg",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/holi_hai": {
        slug: "holi_hai",
        name: "Holi Hai",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/indian_fortune": {
        slug: "indian_fortune",
        name: "Indian Fortune",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/jhandi_munda": {
        slug: "jhandi_munda",
        name: "Jhandi Munda",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/jungle_jango": {
        slug: "jungle_jango",
        name: "Jungle Jango",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/kaboom": {
        slug: "kaboom",
        name: "Kaboom",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/kohinoor": {
        slug: "kohinoor",
        name: "Koh-i-noor",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/love_goa": {
        slug: "love_goa",
        name: "Love Goa",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/maharaja_and_the_vampire": {
        slug: "maharaja_and_the_vampire",
        name: "Maharaja and the Vampire",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/mahjong_dragon_tower": {
        slug: "mahjong_dragon_tower",
        name: "Mahjong Dragon Tower",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/ninja_chacha": {
        slug: "ninja_chacha",
        name: "Ninja Chacha",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/oceans_secret": {
        slug: "oceans_secret",
        name: "Ocean's Secret",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/pandavas": {
        slug: "pandavas",
        name: "Pandavas",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/paper_plane_crash": {
        slug: "paper_plane_crash",
        name: "Paper Plane Crash",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/power_play": {
        slug: "power_play",
        name: "Power Play",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/raja_mantri_chor_sipahi": {
        slug: "raja_mantri_chor_sipahi",
        name: "Raja Mantri Chor Sipahi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/rock_paper_scissors": {
        slug: "rock_paper_scissors",
        name: "Rock Paper Scissors",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/saanp_seedhi": {
        slug: "saanp_seedhi",
        name: "Saanp Seedhi",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/snake_and_ladder": {
        slug: "snake_and_ladder",
        name: "Snake and Ladder",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/street_ratz_the_heist": {
        slug: "street_ratz_the_heist",
        name: "Street Ratz The Heist",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer": {
        slug: "super_sixer",
        name: "Super Sixer",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer_classic_scratch": {
        slug: "super_sixer_classic_scratch",
        name: "Super Sixer Classic Scratch",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer_mines": {
        slug: "super_sixer_mines",
        name: "Super Sixer Mines",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/super_sixer_xtreme": {
        slug: "super_sixer_xtreme",
        name: "Super Sixer Xtreme",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/sweet_shop": {
        slug: "sweet_shop",
        name: "Sweet Shop",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/sweetello": {
        slug: "sweetello",
        name: "Sweetello",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/teen_patti_diwali_special": {
        slug: "teen_patti_diwali_special",
        name: "Teen Patti Diwali Special",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/thief_in_the_palace": {
        slug: "thief_in_the_palace",
        name: "Thief In The Palace",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "topspin/vikram_aur_betaal": {
        slug: "vikram_aur_betaal",
        name: "Vikram Aur Betaal",
        provider: "Topspin",
        providerSlug: "topspin"
    },
    "trigger/alice_in_winderland": {
        slug: "alice_in_winderland",
        name: "Alice in Winderland",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/beanstalk_grows_wild": {
        slug: "beanstalk_grows_wild",
        name: "Beanstalk Grows Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/beanstalk_grows_wild_2": {
        slug: "beanstalk_grows_wild_2",
        name: "Beanstalk Grows Wild 2",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/miners_combo": {
        slug: "miners_combo",
        name: "Miners Combo",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/mister_payman": {
        slug: "mister_payman",
        name: "Mister Payman",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/princess_pea_and_royal_wild": {
        slug: "princess_pea_and_royal_wild",
        name: "Princess, Pea and Royal Wild",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/robin_in_the_hood": {
        slug: "robin_in_the_hood",
        name: "Robin in the Hood",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "trigger/santas_secret_party": {
        slug: "santas_secret_party",
        name: "Santa's Secret Party",
        provider: "Trigger",
        providerSlug: "trigger"
    },
    "turbogames/1tap_mines": {
        slug: "1tap_mines",
        name: "1Tap Mines",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/aero": {
        slug: "aero",
        name: "Aero",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/ballandball": {
        slug: "ballandball",
        name: "Ball&Ball",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/balloon_doggo": {
        slug: "balloon_doggo",
        name: "Balloon Doggo",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/book_of_mines": {
        slug: "book_of_mines",
        name: "Book of Mines",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/bubbles": {
        slug: "bubbles",
        name: "Bubbles",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/catanza": {
        slug: "catanza",
        name: "Catanza",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/chicken_goal": {
        slug: "chicken_goal",
        name: "Chicken Goal",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/chicken_pirate_route": {
        slug: "chicken_pirate_route",
        name: "Chicken Pirate Route",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/chicken_route": {
        slug: "chicken_route",
        name: "Chicken Route",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/chicken_route_rococo": {
        slug: "chicken_route_rococo",
        name: "Chicken Route: Ro-co-co",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/crashx": {
        slug: "crashx",
        name: "CrashX",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/crashx_football_edition": {
        slug: "crashx_football_edition",
        name: "CrashX Football Edition",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/cricket_boom": {
        slug: "cricket_boom",
        name: "Cricket Boom",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/crystal_poker": {
        slug: "crystal_poker",
        name: "Crystal Poker",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/dice_twice": {
        slug: "dice_twice",
        name: "Dice Twice",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/donny_king": {
        slug: "donny_king",
        name: "Donny King",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/double_roll": {
        slug: "double_roll",
        name: "Double Roll",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/fast_fielder": {
        slug: "fast_fielder",
        name: "Fast Fielder",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/fruit_towers": {
        slug: "fruit_towers",
        name: "Fruit Towers",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/fury_stairs": {
        slug: "fury_stairs",
        name: "Fury Stairs",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/hamsta": {
        slug: "hamsta",
        name: "Hamsta",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/hilo": {
        slug: "hilo",
        name: "HiLo",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/jewel_clicker": {
        slug: "jewel_clicker",
        name: "Jewel Clicker",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/limbo_rider": {
        slug: "limbo_rider",
        name: "Limbo Rider",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/mines": {
        slug: "mines",
        name: "Mines",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/mysteco": {
        slug: "mysteco",
        name: "Mysteco",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/pumped_x": {
        slug: "pumped_x",
        name: "Pumped X",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/rings_of_olympus": {
        slug: "rings_of_olympus",
        name: "Rings of Olympus",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/spin_strike": {
        slug: "spin_strike",
        name: "Spin Strike",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/tapinata": {
        slug: "tapinata",
        name: "Tapinata",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/teen_patti_2020": {
        slug: "teen_patti_2020",
        name: "Teen Patti 20-20",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/towers": {
        slug: "towers",
        name: "Towers",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/turbo_keno": {
        slug: "turbo_keno",
        name: "Turbo Keno",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/turbo_mines": {
        slug: "turbo_mines",
        name: "Turbo Mines",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/turbo_plinko": {
        slug: "turbo_plinko",
        name: "Turbo Plinko",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex": {
        slug: "vortex",
        name: "Vortex",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_2": {
        slug: "vortex_2",
        name: "Vortex 2",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_aero": {
        slug: "vortex_aero",
        name: "Vortex Aero",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_halloween": {
        slug: "vortex_halloween",
        name: "Vortex Halloween",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_power_kick": {
        slug: "vortex_power_kick",
        name: "Vortex Power Kick",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_powerplay": {
        slug: "vortex_powerplay",
        name: "Vortex Powerplay",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/vortex_safari": {
        slug: "vortex_safari",
        name: "Vortex Safari",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "turbogames/wicket_blast": {
        slug: "wicket_blast",
        name: "Wicket Blast",
        provider: "Turbogames",
        providerSlug: "turbogames"
    },
    "twainsport/twainsport_247_tbasket": {
        slug: "twainsport_247_tbasket",
        name: "TwainSport 24/7 T-Basket",
        provider: "TwainSport",
        providerSlug: "twainsport"
    },
    "twainsport/twainsport_247_tkick": {
        slug: "twainsport_247_tkick",
        name: "TwainSport 24/7 T-Kick",
        provider: "TwainSport",
        providerSlug: "twainsport"
    },
    "twainsport/twainsport_lobby": {
        slug: "twainsport_lobby",
        name: "TwainSport Lobby",
        provider: "TwainSport",
        providerSlug: "twainsport"
    },
    "updown/updown": {
        slug: "updown",
        name: "UpDown",
        provider: "Updown",
        providerSlug: "updown"
    },
    "uroc/barneys_mine_hold_for_gold_3x3": {
        slug: "barneys_mine_hold_for_gold_3x3",
        name: "Barneys Mine Hold for Gold 3x3",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/deadmans_gambit": {
        slug: "deadmans_gambit",
        name: "Deadmans Gambit",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/dodo_temple": {
        slug: "dodo_temple",
        name: "Dodo Temple",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/dragon_blaze": {
        slug: "dragon_blaze",
        name: "Dragon Blaze",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/drunken_master": {
        slug: "drunken_master",
        name: "Drunken Master",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/gaze_of_medusa": {
        slug: "gaze_of_medusa",
        name: "Gaze of Medusa",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/harvest_of_the_damned": {
        slug: "harvest_of_the_damned",
        name: "Harvest of the Damned",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/hooked_for_gold": {
        slug: "hooked_for_gold",
        name: "Hooked for Gold",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/krampus_and_the_crystal_box": {
        slug: "krampus_and_the_crystal_box",
        name: "Krampus and the Crystal Box",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/miami_blaze_hfg_5x3": {
        slug: "miami_blaze_hfg_5x3",
        name: "Miami Blaze HFG 5x3",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/mission_penguin_collectrock": {
        slug: "mission_penguin_collectrock",
        name: "Mission Penguin CollectRock",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/spirit_of_the_buffalo": {
        slug: "spirit_of_the_buffalo",
        name: "Spirit of the Buffalo",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/tyr_warriors_hfg_5x3": {
        slug: "tyr_warriors_hfg_5x3",
        name: "Tyr Warriors HFG 5x3",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/victory_sunday_collectrock": {
        slug: "victory_sunday_collectrock",
        name: "Victory Sunday CollectRock",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "uroc/winter_wonder_workshop": {
        slug: "winter_wonder_workshop",
        name: "Winter Wonder Workshop",
        provider: "Uroc",
        providerSlug: "uroc"
    },
    "wazdan/12_bells": {
        slug: "12_bells",
        name: "12 Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/12_coins": {
        slug: "12_coins",
        name: "12 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/12_coins_grand_diamond_edition": {
        slug: "12_coins_grand_diamond_edition",
        name: "12 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/12_coins_grand_gold_edition": {
        slug: "12_coins_grand_gold_edition",
        name: "12 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/12_coins_grand_platinum_edition": {
        slug: "12_coins_grand_platinum_edition",
        name: "12 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins": {
        slug: "15_coins",
        name: "15 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins_grand_diamond_edition": {
        slug: "15_coins_grand_diamond_edition",
        name: "15 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins_grand_gold_edition": {
        slug: "15_coins_grand_gold_edition",
        name: "15 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/15_coins_grand_platinum_edition": {
        slug: "15_coins_grand_platinum_edition",
        name: "15 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins": {
        slug: "16_coins",
        name: "16 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_grand_gold_edition": {
        slug: "16_coins_grand_gold_edition",
        name: "16 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_grand_platinum_edition": {
        slug: "16_coins_grand_platinum_edition",
        name: "16 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/16_coins_x5000": {
        slug: "16_coins_x5000",
        name: "16 Coins x5000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/20_coins": {
        slug: "20_coins",
        name: "20 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/20_coins_grand_gold_edition": {
        slug: "20_coins_grand_gold_edition",
        name: "20 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/24_coins": {
        slug: "24_coins",
        name: "24 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/25_coins": {
        slug: "25_coins",
        name: "25 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/25_coins_grand_gold_edition": {
        slug: "25_coins_grand_gold_edition",
        name: "25 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/25_coins_x3000": {
        slug: "25_coins_x3000",
        name: "25 Coins x3000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/30_coins": {
        slug: "30_coins",
        name: "30 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/30_coins_grand_gold_edition": {
        slug: "30_coins_grand_gold_edition",
        name: "30 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/36_coins": {
        slug: "36_coins",
        name: "36 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/36_coins_grand_gold_edition": {
        slug: "36_coins_grand_gold_edition",
        name: "36 Coins Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_balls": {
        slug: "9_balls",
        name: "9 Balls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_bells": {
        slug: "9_bells",
        name: "9 Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_burning_dragons": {
        slug: "9_burning_dragons",
        name: "9 Burning Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_burning_stars": {
        slug: "9_burning_stars",
        name: "9 Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins": {
        slug: "9_coins",
        name: "9 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_1000_edition": {
        slug: "9_coins_1000_edition",
        name: "9 Coins 1000 Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_extremely_light": {
        slug: "9_coins_extremely_light",
        name: "9 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_diamond_edition": {
        slug: "9_coins_grand_diamond_edition",
        name: "9 Coins Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_gold_edition": {
        slug: "9_coins_grand_gold_edition",
        name: "9 Coins: Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_coins_grand_platinum_edition": {
        slug: "9_coins_grand_platinum_edition",
        name: "9 Coins Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_lions": {
        slug: "9_lions",
        name: "9 Lions",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_lions_hold_the_jackpot": {
        slug: "9_lions_hold_the_jackpot",
        name: "9 Lions Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/9_tigers": {
        slug: "9_tigers",
        name: "9 Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/american_gold_poker": {
        slug: "american_gold_poker",
        name: "American Gold Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/american_poker_gold": {
        slug: "american_poker_gold",
        name: "American Poker Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/american_poker_v": {
        slug: "american_poker_v",
        name: "American Poker V",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/arcade": {
        slug: "arcade",
        name: "Arcade",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/back_to_70s": {
        slug: "back_to_70s",
        name: "Back to 70's",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/back_to_the_70s": {
        slug: "back_to_the_70s",
        name: "Back to the 70's",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bars_and_7s": {
        slug: "bars_and_7s",
        name: "BARs and 7s",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/barsand7s": {
        slug: "barsand7s",
        name: "BARsand7s",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beach_party": {
        slug: "beach_party",
        name: "Beach Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beach_party_hot": {
        slug: "beach_party_hot",
        name: "Beach Party Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/beauty_fruity": {
        slug: "beauty_fruity",
        name: "Beauty Fruity",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bell_wizard": {
        slug: "bell_wizard",
        name: "Bell Wizard",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bells_of_fortune": {
        slug: "bells_of_fortune",
        name: "Bells of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_hawk": {
        slug: "black_hawk",
        name: "Black Hawk",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_hawk_deluxe": {
        slug: "black_hawk_deluxe",
        name: "Black Hawk Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_horse": {
        slug: "black_horse",
        name: "Black Horse",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_horse_cash_out": {
        slug: "black_horse_cash_out",
        name: "Black Horse Cash Out",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/black_horse_deluxe": {
        slug: "black_horse_deluxe",
        name: "Black Horse Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/book_of_faith": {
        slug: "book_of_faith",
        name: "Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/bumba_meu_boi_coin": {
        slug: "bumba_meu_boi_coin",
        name: "Bumba Meu Boi Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_reels": {
        slug: "burning_reels",
        name: "Burning Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_stars": {
        slug: "burning_stars",
        name: "Burning Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_stars_3": {
        slug: "burning_stars_3",
        name: "Burning Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_sun": {
        slug: "burning_sun",
        name: "Burning Sun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/burning_sun_extremely_light": {
        slug: "burning_sun_extremely_light",
        name: "Burning Sun Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/butterfly_lovers": {
        slug: "butterfly_lovers",
        name: "Butterfly Lovers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/captain_shark": {
        slug: "captain_shark",
        name: "Captain Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/carribean_beach_poker": {
        slug: "carribean_beach_poker",
        name: "Carribean Beach Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cash_grotto": {
        slug: "cash_grotto",
        name: "Cash Grotto",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/casino_roulette": {
        slug: "casino_roulette",
        name: "Casino Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/choco_reels": {
        slug: "choco_reels",
        name: "Choco Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/clover_lady": {
        slug: "clover_lady",
        name: "Clover Lady",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/colin_the_cat": {
        slug: "colin_the_cat",
        name: "Colin The Cat",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/corrida_romance": {
        slug: "corrida_romance",
        name: "Corrida Romance",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/corrida_romance_deluxe": {
        slug: "corrida_romance_deluxe",
        name: "Corrida Romance Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/crazy_cars": {
        slug: "crazy_cars",
        name: "Crazy Cars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/criss_cross_81": {
        slug: "criss_cross_81",
        name: "Criss Cross 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cube_mania": {
        slug: "cube_mania",
        name: "Cube Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/cube_mania_deluxe": {
        slug: "cube_mania_deluxe",
        name: "Cube Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/demon_jack_27": {
        slug: "demon_jack_27",
        name: "Demon Jack 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dino_reels_81": {
        slug: "dino_reels_81",
        name: "Dino Reels 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/double_tigers": {
        slug: "double_tigers",
        name: "Double Tigers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/draculas_castle": {
        slug: "draculas_castle",
        name: "Dracula's Castle",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dragons_lucky_8": {
        slug: "dragons_lucky_8",
        name: "Dragons Lucky 8",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/dwarfs_fortune": {
        slug: "dwarfs_fortune",
        name: "Dwarfs Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/easter_coins": {
        slug: "easter_coins",
        name: "Easter Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/eggs_of_fortune": {
        slug: "eggs_of_fortune",
        name: "Eggs of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/extra_bingo": {
        slug: "extra_bingo",
        name: "Extra Bingo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play": {
        slug: "fenix_play",
        name: "Fenix Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_27": {
        slug: "fenix_play_27",
        name: "Fenix Play 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_27_deluxe": {
        slug: "fenix_play_27_deluxe",
        name: "Fenix Play 27 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fenix_play_deluxe": {
        slug: "fenix_play_deluxe",
        name: "Fenix Play Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fire_bird": {
        slug: "fire_bird",
        name: "Fire Bird",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fishermans_luck": {
        slug: "fishermans_luck",
        name: "Fisherman's Luck",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/football_mania": {
        slug: "football_mania",
        name: "Football Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/football_mania_deluxe": {
        slug: "football_mania_deluxe",
        name: "Football Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fortune_reels": {
        slug: "fortune_reels",
        name: "Fortune Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruit_fiesta": {
        slug: "fruit_fiesta",
        name: "Fruit Fiesta",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruit_mania": {
        slug: "fruit_mania",
        name: "Fruit Mania",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruit_mania_deluxe": {
        slug: "fruit_mania_deluxe",
        name: "Fruit Mania Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/fruits_go_bananas": {
        slug: "fruits_go_bananas",
        name: "Fruits Go Bananas",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/gem_splitter": {
        slug: "gem_splitter",
        name: "Gem Splitter",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/gold_roulette": {
        slug: "gold_roulette",
        name: "Gold Roulette",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/golden_sphinx": {
        slug: "golden_sphinx",
        name: "Golden Sphinx",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/good_luck_40": {
        slug: "good_luck_40",
        name: "Good Luck 40",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/great_book_of_magic": {
        slug: "great_book_of_magic",
        name: "Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/great_book_of_magic_deluxe": {
        slug: "great_book_of_magic_deluxe",
        name: "Great Book of Magic Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/haunted_coins_x1000": {
        slug: "haunted_coins_x1000",
        name: "Haunted Coins x1000",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/haunted_hospital": {
        slug: "haunted_hospital",
        name: "Haunted Hospital",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highschool_manga": {
        slug: "highschool_manga",
        name: "Highschool Manga",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highway_to_hell": {
        slug: "highway_to_hell",
        name: "Highway To Hell",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/highway_to_hell_deluxe": {
        slug: "highway_to_hell_deluxe",
        name: "Highway to Hell Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_777": {
        slug: "hot_777",
        name: "Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_777_deluxe": {
        slug: "hot_777_deluxe",
        name: "Hot 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_party": {
        slug: "hot_party",
        name: "Hot Party",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_party_deluxe": {
        slug: "hot_party_deluxe",
        name: "Hot Party Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out": {
        slug: "hot_slot_777_cash_out",
        name: "Hot Slot: 777 Cash Out",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_extremely_light": {
        slug: "hot_slot_777_cash_out_extremely_light",
        name: "Hot Slot: 777 Cash Out Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_diamond_edition": {
        slug: "hot_slot_777_cash_out_grand_diamond_edition",
        name: "Hot Slot: 777 Cash Out Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_gold_edition": {
        slug: "hot_slot_777_cash_out_grand_gold_edition",
        name: "Hot Slot: 777 Cash Out Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_cash_out_grand_platinum_edition": {
        slug: "hot_slot_777_cash_out_grand_platinum_edition",
        name: "Hot Slot: 777 Cash Out Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_coins": {
        slug: "hot_slot_777_coins",
        name: "Hot Slot: 777 Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_coins_extremely_light": {
        slug: "hot_slot_777_coins_extremely_light",
        name: "Hot Slot 777 Coins Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_crown": {
        slug: "hot_slot_777_crown",
        name: "Hot Slot: 777 Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_crown_extremely_light": {
        slug: "hot_slot_777_crown_extremely_light",
        name: "Hot Slot: 777 Crown Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_diamond_crown": {
        slug: "hot_slot_777_diamond_crown",
        name: "Hot Slot 777 Diamond Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_hold_the_jackpot": {
        slug: "hot_slot_777_hold_the_jackpot",
        name: "Hot Slot 777 Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_platinum_crown": {
        slug: "hot_slot_777_platinum_crown",
        name: "Hot Slot 777 Platinum Crown",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_rubies": {
        slug: "hot_slot_777_rubies",
        name: "Hot Slot: 777 Rubies",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_rubies_extremely_light": {
        slug: "hot_slot_777_rubies_extremely_light",
        name: "Hot Slot: 777 Rubies Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_stars": {
        slug: "hot_slot_777_stars",
        name: "Hot Slot: 777 Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_777_stars_extremely_light": {
        slug: "hot_slot_777_stars_extremely_light",
        name: "Hot Slot: 777 Stars Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_diamond_coins": {
        slug: "hot_slot_diamond_coins",
        name: "Hot Slot Diamond Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_great_book_of_magic": {
        slug: "hot_slot_great_book_of_magic",
        name: "Hot Slot: Great Book of Magic",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_magic_bombs": {
        slug: "hot_slot_magic_bombs",
        name: "Hot Slot: Magic Bombs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_magic_pearls": {
        slug: "hot_slot_magic_pearls",
        name: "Hot Slot: Magic Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_mystery_jackpot_joker": {
        slug: "hot_slot_mystery_jackpot_joker",
        name: "Hot Slot: Mystery Jackpot Joker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot_platinum_coins": {
        slug: "hot_slot_platinum_coins",
        name: "Hot Slot Platinum Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hot_slot777_hold_the_jackpot": {
        slug: "hot_slot777_hold_the_jackpot",
        name: "Hot Slot:777 Hold the Jackpot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/hungry_shark": {
        slug: "hungry_shark",
        name: "Hungry Shark",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/in_the_forest": {
        slug: "in_the_forest",
        name: "In the Forest",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/infinity_hero": {
        slug: "infinity_hero",
        name: "Infinity Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jack_on_hold": {
        slug: "jack_on_hold",
        name: "Jack on Hold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jackpot_builders": {
        slug: "jackpot_builders",
        name: "Jackpot Builders",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jacks_ride": {
        slug: "jacks_ride",
        name: "Jack's Ride",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jelly_reels": {
        slug: "jelly_reels",
        name: "Jelly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/joker_explosion": {
        slug: "joker_explosion",
        name: "Joker Explosion",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/joker_poker": {
        slug: "joker_poker",
        name: "Joker Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/juicy_reels": {
        slug: "juicy_reels",
        name: "Juicy Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/jumping_fruits": {
        slug: "jumping_fruits",
        name: "Jumping Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/kickoff": {
        slug: "kickoff",
        name: "KickOff",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/larry_the_leprechaun": {
        slug: "larry_the_leprechaun",
        name: "Larry the Leprechaun",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/los_muertos": {
        slug: "los_muertos",
        name: "Los Muertos",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/los_muertos_ii": {
        slug: "los_muertos_ii",
        name: "Los Muertos II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lost_treasure": {
        slug: "lost_treasure",
        name: "Lost Treasure",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_9": {
        slug: "lucky_9",
        name: "Lucky 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_fish": {
        slug: "lucky_fish",
        name: "Lucky Fish",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_fortune": {
        slug: "lucky_fortune",
        name: "Lucky Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_queen": {
        slug: "lucky_queen",
        name: "Lucky Queen",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/lucky_reels": {
        slug: "lucky_reels",
        name: "Lucky Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_eggs": {
        slug: "magic_eggs",
        name: "Magic Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruit_cherries": {
        slug: "magic_fruit_cherries",
        name: "Magic Fruit: Cherries",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruit_dice": {
        slug: "magic_fruit_dice",
        name: "Magic Fruit Dice",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruit_oranges": {
        slug: "magic_fruit_oranges",
        name: "Magic Fruit$: Oranges",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits": {
        slug: "magic_fruits",
        name: "Magic Fruits",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_27": {
        slug: "magic_fruits_27",
        name: "Magic Fruits 27",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_4": {
        slug: "magic_fruits_4",
        name: "Magic Fruits 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_4_deluxe": {
        slug: "magic_fruits_4_deluxe",
        name: "Magic Fruits 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_81": {
        slug: "magic_fruits_81",
        name: "Magic Fruits 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_deluxe": {
        slug: "magic_fruits_deluxe",
        name: "Magic Fruits Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_dice": {
        slug: "magic_fruits_dice",
        name: "Magic Fruits Dice",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_fruits_oranges": {
        slug: "magic_fruits_oranges",
        name: "Magic Fruits Oranges",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot": {
        slug: "magic_hot",
        name: "Magic Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot_4": {
        slug: "magic_hot_4",
        name: "Magic Hot 4",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_hot_4_deluxe": {
        slug: "magic_hot_4_deluxe",
        name: "Magic Hot 4 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_of_the_ring": {
        slug: "magic_of_the_ring",
        name: "Magic of The Ring",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_of_the_ring_deluxe": {
        slug: "magic_of_the_ring_deluxe",
        name: "Magic of the Ring Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_poker": {
        slug: "magic_poker",
        name: "Magic Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_spins": {
        slug: "magic_spins",
        name: "Magic Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars": {
        slug: "magic_stars",
        name: "Magic Stars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_3": {
        slug: "magic_stars_3",
        name: "Magic Stars 3",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_5": {
        slug: "magic_stars_5",
        name: "Magic Stars 5",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_6": {
        slug: "magic_stars_6",
        name: "Magic Stars 6",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_stars_9": {
        slug: "magic_stars_9",
        name: "Magic Stars 9",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_target": {
        slug: "magic_target",
        name: "Magic Target",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/magic_target_deluxe": {
        slug: "magic_target_deluxe",
        name: "Magic Target Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mayan_ritual": {
        slug: "mayan_ritual",
        name: "Mayan Ritual",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/miami_beach": {
        slug: "miami_beach",
        name: "Miami Beach",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/midnight_in_tokyo": {
        slug: "midnight_in_tokyo",
        name: "Midnight in Tokyo",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_crown_empire_of_gold": {
        slug: "mighty_crown_empire_of_gold",
        name: "Mighty Crown: Empire of Gold",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_crown_legacy_of_mars": {
        slug: "mighty_crown_legacy_of_mars",
        name: "Mighty Crown Legacy of Mars",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_fish_blue_marlin": {
        slug: "mighty_fish_blue_marlin",
        name: "Mighty Fish: Blue Marlin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_hot_777": {
        slug: "mighty_hot_777",
        name: "Mighty Hot 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_hot_amazonia": {
        slug: "mighty_hot_amazonia",
        name: "Mighty Hot: Amazonia",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_crowns": {
        slug: "mighty_symbols_crowns",
        name: "Mighty Symbols Crowns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_diamonds": {
        slug: "mighty_symbols_diamonds",
        name: "Mighty Symbols Diamonds",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_jokers": {
        slug: "mighty_symbols_jokers",
        name: "Mighty Symbols: Jokers",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_symbols_sevens": {
        slug: "mighty_symbols_sevens",
        name: "Mighty Symbols: Sevens",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_gorilla": {
        slug: "mighty_wild_gorilla",
        name: "Mighty Wild Gorilla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_jaguar": {
        slug: "mighty_wild_jaguar",
        name: "Mighty Wild Jaguar",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther": {
        slug: "mighty_wild_panther",
        name: "Mighty Wild: Panther",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_diamond_edition": {
        slug: "mighty_wild_panther_grand_diamond_edition",
        name: "Mighty Wild: Panther Grand Diamond Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_gold_edition": {
        slug: "mighty_wild_panther_grand_gold_edition",
        name: "Mighty Wild Panther Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mighty_wild_panther_grand_platinum_edition": {
        slug: "mighty_wild_panther_grand_platinum_edition",
        name: "Mighty Wild: Panther Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/moon_of_fortune": {
        slug: "moon_of_fortune",
        name: "Moon of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_jack": {
        slug: "mystery_jack",
        name: "Mystery Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_jack_deluxe": {
        slug: "mystery_jack_deluxe",
        name: "Mystery Jack Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_kindom_mystery_bells": {
        slug: "mystery_kindom_mystery_bells",
        name: "Mystery Kindom: Mystery Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/mystery_kingdom_mystery_bells": {
        slug: "mystery_kingdom_mystery_bells",
        name: "Mystery Kingdom Mystery Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/neon_city": {
        slug: "neon_city",
        name: "Neon City",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/night_club_81": {
        slug: "night_club_81",
        name: "Night Club 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/one_coin": {
        slug: "one_coin",
        name: "One Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/one_coins": {
        slug: "one_coins",
        name: "One Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/ox_coin": {
        slug: "ox_coin",
        name: "Ox Coin",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_god_medusa_extremely_light": {
        slug: "power_of_god_medusa_extremely_light",
        name: "Power of God: Medusa Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_egypt": {
        slug: "power_of_gods_egypt",
        name: "Power of Gods: Egypt",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_hades": {
        slug: "power_of_gods_hades",
        name: "Power of Gods: Hades",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_medusa": {
        slug: "power_of_gods_medusa",
        name: "Power of Gods: Medusa",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_medusa_extremely_light": {
        slug: "power_of_gods_medusa_extremely_light",
        name: "Power of Gods: Medusa Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_the_pantheon": {
        slug: "power_of_gods_the_pantheon",
        name: "Power of Gods: The Pantheon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_valhalla": {
        slug: "power_of_gods_valhalla",
        name: "Power of Gods: Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_gods_valhalla_extremely_light": {
        slug: "power_of_gods_valhalla_extremely_light",
        name: "Power of Gods: Valhalla Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/power_of_sun_svarog": {
        slug: "power_of_sun_svarog",
        name: "Power of Sun: Svarog",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/prosperity_pearls": {
        slug: "prosperity_pearls",
        name: "Prosperity Pearls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/prosperity_reels": {
        slug: "prosperity_reels",
        name: "Prosperity Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/reel_hero": {
        slug: "reel_hero",
        name: "Reel Hero",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/reel_joke": {
        slug: "reel_joke",
        name: "Reel Joke",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/relic_hunters_and_the_book_of_faith": {
        slug: "relic_hunters_and_the_book_of_faith",
        name: "Relic Hunters and the Book of Faith",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/santas_gift_frenzy": {
        slug: "santas_gift_frenzy",
        name: "Santa's Gift Frenzy",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/santas_gifts_frenzy": {
        slug: "santas_gifts_frenzy",
        name: "Santa's Gifts Frenzy",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sic_bo_dragons": {
        slug: "sic_bo_dragons",
        name: "Sic Bo Dragons",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_777": {
        slug: "sizzling_777",
        name: "Sizzling 777",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_777_deluxe": {
        slug: "sizzling_777_deluxe",
        name: "Sizzling 777 Deluxe",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_bells": {
        slug: "sizzling_bells",
        name: "Sizzling Bells",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs": {
        slug: "sizzling_eggs",
        name: "Sizzling Eggs",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_extremely_light": {
        slug: "sizzling_eggs_extremely_light",
        name: "Sizzling Eggs Extremely Light",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_grand_gold_edition": {
        slug: "sizzling_eggs_grand_gold_edition",
        name: "Sizzling Eggs Grand Gold Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_eggs_grand_platinum_edition": {
        slug: "sizzling_eggs_grand_platinum_edition",
        name: "Sizzling Eggs Grand Platinum Edition",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_kindom_bison": {
        slug: "sizzling_kindom_bison",
        name: "Sizzling Kindom: Bison",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_kingdom_bison": {
        slug: "sizzling_kingdom_bison",
        name: "Sizzling Kingdom Bison",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sizzling_moon": {
        slug: "sizzling_moon",
        name: "Sizzling Moon",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/slot_jam": {
        slug: "slot_jam",
        name: "Slot Jam",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sonic_reels": {
        slug: "sonic_reels",
        name: "Sonic Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/space_gem": {
        slug: "space_gem",
        name: "Space Gem",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/space_spins": {
        slug: "space_spins",
        name: "Space Spins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/spectrum": {
        slug: "spectrum",
        name: "Spectrum",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/sun_of_fortune": {
        slug: "sun_of_fortune",
        name: "Sun of Fortune",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/super_hot": {
        slug: "super_hot",
        name: "Super Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/telly_reels": {
        slug: "telly_reels",
        name: "Telly Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/three_cards": {
        slug: "three_cards",
        name: "Three Cards",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/throne_of_elements_platinum": {
        slug: "throne_of_elements_platinum",
        name: "Throne of Elements: Platinum",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/triple_star": {
        slug: "triple_star",
        name: "Triple Star",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/turbo_play": {
        slug: "turbo_play",
        name: "Turbo Play",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/turbo_poker": {
        slug: "turbo_poker",
        name: "Turbo Poker",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/unicorn_reels": {
        slug: "unicorn_reels",
        name: "Unicorn Reels",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/valentines_coins": {
        slug: "valentines_coins",
        name: "Valentine's Coins",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/valhalla": {
        slug: "valhalla",
        name: "Valhalla",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_hot": {
        slug: "vegas_hot",
        name: "Vegas Hot",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_hot_81": {
        slug: "vegas_hot_81",
        name: "Vegas Hot 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/vegas_reels_ii": {
        slug: "vegas_reels_ii",
        name: "Vegas Reels II",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/welcome_to_hell_81": {
        slug: "welcome_to_hell_81",
        name: "Welcome to Hell 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_girls": {
        slug: "wild_girls",
        name: "Wild Girls",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_guns": {
        slug: "wild_guns",
        name: "Wild Guns",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_jack": {
        slug: "wild_jack",
        name: "Wild Jack",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/wild_jack_81": {
        slug: "wild_jack_81",
        name: "Wild Jack 81",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wazdan/win_and_replay": {
        slug: "win_and_replay",
        name: "Win and Replay",
        provider: "Wazdan",
        providerSlug: "wazdan"
    },
    "wickedgames/astro": {
        slug: "astro",
        name: "Astro",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/big_black_cock": {
        slug: "big_black_cock",
        name: "Big Black Cock",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/blazin_quinn": {
        slug: "blazin_quinn",
        name: "Blazin' Quinn",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/book_of_arabia": {
        slug: "book_of_arabia",
        name: "Book of Arabia",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/cred": {
        slug: "cred",
        name: "Cred",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/cupids_crush": {
        slug: "cupids_crush",
        name: "Cupid's Crush",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/diner_dogs": {
        slug: "diner_dogs",
        name: "Diner Dogs",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/dragon_trail": {
        slug: "dragon_trail",
        name: "Dragon Trail",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/enriched": {
        slug: "enriched",
        name: "Enriched",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/eye_of_gods": {
        slug: "eye_of_gods",
        name: "Eye of Gods",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/fawkes": {
        slug: "fawkes",
        name: "Fawkes",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/hamsterdam": {
        slug: "hamsterdam",
        name: "Hamsterdam",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/holly": {
        slug: "holly",
        name: "Holly",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/ivy": {
        slug: "ivy",
        name: "Ivy",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/jack": {
        slug: "jack",
        name: "Jack",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/last_call": {
        slug: "last_call",
        name: "Last Call",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/loaded_sack": {
        slug: "loaded_sack",
        name: "Loaded Sack",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/lucked": {
        slug: "lucked",
        name: "Lucked",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/nitro_100": {
        slug: "nitro_100",
        name: "Nitro 100",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/overdose": {
        slug: "overdose",
        name: "Overdose",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/synchro": {
        slug: "synchro",
        name: "Synchro",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "wickedgames/transformers": {
        slug: "transformers",
        name: "Transformers",
        provider: "Wickedgames",
        providerSlug: "wickedgames"
    },
    "winfast/battle_dwarf": {
        slug: "battle_dwarf",
        name: "Battle Dwarf",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/battle_dwarf_2": {
        slug: "battle_dwarf_2",
        name: "Battle Dwarf 2",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/battle_dwarf_xmas": {
        slug: "battle_dwarf_xmas",
        name: "Battle Dwarf Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/beyond_dice": {
        slug: "beyond_dice",
        name: "Beyond Dice",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dragons_pot": {
        slug: "dragons_pot",
        name: "Dragon's Pot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dragons_win_multiplier": {
        slug: "dragons_win_multiplier",
        name: "Dragon's Win Multiplier",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold": {
        slug: "dreams_of_gold",
        name: "Dreams of Gold",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold_delight": {
        slug: "dreams_of_gold_delight",
        name: "Dreams of Gold Delight",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/dreams_of_gold_jackpot": {
        slug: "dreams_of_gold_jackpot",
        name: "Dreams of Gold Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/engeki_rising_x50": {
        slug: "engeki_rising_x50",
        name: "Engeki Rising x50",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_diva": {
        slug: "hawaiian_diva",
        name: "Hawaiian Diva",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream": {
        slug: "hawaiian_dream",
        name: "Hawaiian Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream_gold": {
        slug: "hawaiian_dream_gold",
        name: "Hawaiian Dream GOLD",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hawaiian_dream_jackpot": {
        slug: "hawaiian_dream_jackpot",
        name: "Hawaiian Dream Jackpot",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/hikaru_super_live_bazooka": {
        slug: "hikaru_super_live_bazooka",
        name: "Hikaru Super Live BAZOOKA",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/mighty_wins": {
        slug: "mighty_wins",
        name: "Mighty Wins",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/million_tree": {
        slug: "million_tree",
        name: "Million Tree",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/mummy_princess": {
        slug: "mummy_princess",
        name: "Mummy Princess",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/oiran_dream": {
        slug: "oiran_dream",
        name: "Oiran Dream",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/oiran_dream_xmas": {
        slug: "oiran_dream_xmas",
        name: "Oiran Dream Xmas",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/pyramid_rising_x33": {
        slug: "pyramid_rising_x33",
        name: "Pyramid Rising x33",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/raigeki_rising_x30": {
        slug: "raigeki_rising_x30",
        name: "Raigeki Rising x30",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/star_treasure": {
        slug: "star_treasure",
        name: "Star Treasure",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "winfast/wild_west_angel_rodeo": {
        slug: "wild_west_angel_rodeo",
        name: "Wild West Angel Rodeo",
        provider: "Winfast",
        providerSlug: "winfast"
    },
    "woahlabs/chest_chase": {
        slug: "chest_chase",
        name: "Chest Chase",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/crash_football": {
        slug: "crash_football",
        name: "Crash Football",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/crash_joker": {
        slug: "crash_joker",
        name: "Crash Joker",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/crash_jokers": {
        slug: "crash_jokers",
        name: "Crash Jokers",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/dice_dash": {
        slug: "dice_dash",
        name: "Dice Dash",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/joker_bus_ride": {
        slug: "joker_bus_ride",
        name: "Joker Bus Ride",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/plinko_football": {
        slug: "plinko_football",
        name: "Plinko Football",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/plinko_poker": {
        slug: "plinko_poker",
        name: "Plinko Poker",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "woahlabs/poker_mines": {
        slug: "poker_mines",
        name: "Poker Mines",
        provider: "Woahlabs",
        providerSlug: "woahlabs"
    },
    "yggdrasil-gaming/3_gladiators_vs_caesar": {
        slug: "3_gladiators_vs_caesar",
        name: "3 Gladiators vs Caesar",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/3_piggies_of_bank_lockem_loadem": {
        slug: "3_piggies_of_bank_lockem_loadem",
        name: "3 Piggies of Bank Lock'em Load'em",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/3021_ad_the_bounty_hunter_gigablox": {
        slug: "3021_ad_the_bounty_hunter_gigablox",
        name: "3021 AD The Bounty Hunter Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/4_foxx_crew_wild_energy_multimax": {
        slug: "4_foxx_crew_wild_energy_multimax",
        name: "4 Foxx Crew Wild Energy Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/777_volt_gigablox": {
        slug: "777_volt_gigablox",
        name: "777 Volt Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/age_of_asgard": {
        slug: "age_of_asgard",
        name: "Age of Asgard",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/alchymedes": {
        slug: "alchymedes",
        name: "Alchymedes",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/aldos_journey": {
        slug: "aldos_journey",
        name: "Aldo's Journey",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/aphrodite_goes_wild_rushingwilds": {
        slug: "aphrodite_goes_wild_rushingwilds",
        name: "Aphrodite Goes Wild Rushingwilds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/arthurs_fortune": {
        slug: "arthurs_fortune",
        name: "Arthur's Fortune",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/atlantean_gigarise": {
        slug: "atlantean_gigarise",
        name: "Atlantean Gigarise",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/avatars_gateway_guardians": {
        slug: "avatars_gateway_guardians",
        name: "Avatars: Gateway Guardians",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/badger_miners": {
        slug: "badger_miners",
        name: "Badger Miners",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/baron_samedi": {
        slug: "baron_samedi",
        name: "Baron Samedi",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/beasty_blox_gigablox": {
        slug: "beasty_blox_gigablox",
        name: "Beasty Blox Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/beauty_and_the_beast": {
        slug: "beauty_and_the_beast",
        name: "Beauty and the Beast",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/bicicleta": {
        slug: "bicicleta",
        name: "Bicicleta",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/big_blox": {
        slug: "big_blox",
        name: "Big Blox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/blood_moon_wilds": {
        slug: "blood_moon_wilds",
        name: "Blood Moon Wilds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/bloody_pesos": {
        slug: "bloody_pesos",
        name: "Bloody Pesos",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/bob_marlin_goes_deep": {
        slug: "bob_marlin_goes_deep",
        name: "Bob Marlin Goes Deep",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/bob_marlin_goes_splashing_wild_fight_rushing_wilds": {
        slug: "bob_marlin_goes_splashing_wild_fight_rushing_wilds",
        name: "Bob Marlin Goes Splashing Wild Fight Rushing WIlds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/boilin_pots": {
        slug: "boilin_pots",
        name: "Boilin' Pots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/brazil_bomba_mobile": {
        slug: "brazil_bomba_mobile",
        name: "Brazil Bomba Mobile",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/buffalo_freedom_doublemax": {
        slug: "buffalo_freedom_doublemax",
        name: "Buffalo Freedom Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/calavera_crush": {
        slug: "calavera_crush",
        name: "Calavera Crush",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/candyfinity": {
        slug: "candyfinity",
        name: "Candyfinity",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/cannonade": {
        slug: "cannonade",
        name: "Cannonade!",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/carol_of_the_elves": {
        slug: "carol_of_the_elves",
        name: "Carol of The Elves",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/casino_zeppelin_reloaded": {
        slug: "casino_zeppelin_reloaded",
        name: "Casino Zeppelin Reloaded",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/cazino_cosmos": {
        slug: "cazino_cosmos",
        name: "Cazino Cosmos",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/cazino_zeppelin": {
        slug: "cazino_zeppelin",
        name: "Cazino Zeppelin",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/champion_of_the_underworld": {
        slug: "champion_of_the_underworld",
        name: "Champion of the Underworld",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/champions_of_rome": {
        slug: "champions_of_rome",
        name: "Champions of Rome",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/chibeasties": {
        slug: "chibeasties",
        name: "Chibeasties",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/christmas_plaza_doublemax": {
        slug: "christmas_plaza_doublemax",
        name: "Christmas Plaza Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/coocoo_cashoo": {
        slug: "coocoo_cashoo",
        name: "CooCoo Cashoo",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/dark_vortex": {
        slug: "dark_vortex",
        name: "Dark Vortex",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/defenders_of_mystica": {
        slug: "defenders_of_mystica",
        name: "Defenders of Mystica",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/devour_the_weak": {
        slug: "devour_the_weak",
        name: "Devour the Weak",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/dick_the_farmer": {
        slug: "dick_the_farmer",
        name: "Dick the Farmer",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/double_dragons": {
        slug: "double_dragons",
        name: "Double Dragons",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/dr_fortuno": {
        slug: "dr_fortuno",
        name: "Dr Fortuno",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/dwarf_mine": {
        slug: "dwarf_mine",
        name: "Dwarf Mine",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/easter_island": {
        slug: "easter_island",
        name: "Easter Island",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/easter_island_2": {
        slug: "easter_island_2",
        name: "Easter Island 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/eforce": {
        slug: "eforce",
        name: "E-Force",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/elysian_jackpots": {
        slug: "elysian_jackpots",
        name: "Elysian Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/fatzs_diner": {
        slug: "fatzs_diner",
        name: "Fatz's Diner",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/firekick_multimax": {
        slug: "firekick_multimax",
        name: "Firekick! Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/florageddon": {
        slug: "florageddon",
        name: "Florageddon",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/football_glory": {
        slug: "football_glory",
        name: "Football Glory",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/frost_queen_jackpots": {
        slug: "frost_queen_jackpots",
        name: "Frost Queen Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/fruitoids": {
        slug: "fruitoids",
        name: "Fruitoids",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/gator_gold_deluxe_gigablox": {
        slug: "gator_gold_deluxe_gigablox",
        name: "Gator Gold Deluxe Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/gator_gold_gigablox": {
        slug: "gator_gold_gigablox",
        name: "Gator Gold Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/gem_rocks": {
        slug: "gem_rocks",
        name: "Gem Rocks",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/gemstone_jam": {
        slug: "gemstone_jam",
        name: "Gemstone Jam",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/giga_zombies_giga_blox": {
        slug: "giga_zombies_giga_blox",
        name: "Giga Zombies Giga Blox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/giganimals_gigablox": {
        slug: "giganimals_gigablox",
        name: "Giganimals Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/goals_of_olympus_boltlock": {
        slug: "goals_of_olympus_boltlock",
        name: "Goals of Olympus BoltLock",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/gold_frontier_jackpots_fastpot5": {
        slug: "gold_frontier_jackpots_fastpot5",
        name: "Gold frontier Jackpots FastPot5",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_chip_roulette": {
        slug: "golden_chip_roulette",
        name: "Golden Chip Roulette",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_fish_tank": {
        slug: "golden_fish_tank",
        name: "Golden Fish Tank",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_fish_tank_2_gigablox": {
        slug: "golden_fish_tank_2_gigablox",
        name: "Golden Fish Tank 2 Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_fish_tank_party": {
        slug: "golden_fish_tank_party",
        name: "Golden Fish Tank Party",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_fishtank": {
        slug: "golden_fishtank",
        name: "Golden Fishtank",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/golden_gorgon": {
        slug: "golden_gorgon",
        name: "Golden Gorgon",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/hades": {
        slug: "hades",
        name: "Hades",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/hanzos_dojo": {
        slug: "hanzos_dojo",
        name: "Hanzo's Dojo",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/holmes_and_the_stolen_stones": {
        slug: "holmes_and_the_stolen_stones",
        name: "Holmes and the Stolen Stones",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/hyperburst": {
        slug: "hyperburst",
        name: "Hyperburst",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/incinerator": {
        slug: "incinerator",
        name: "Incinerator",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/jackpot_express": {
        slug: "jackpot_express",
        name: "Jackpot Express",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/jackpot_raiders": {
        slug: "jackpot_raiders",
        name: "Jackpot Raiders",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/jellycious_doublemax": {
        slug: "jellycious_doublemax",
        name: "Jellycious Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/jungle_books": {
        slug: "jungle_books",
        name: "Jungle Books",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/legend_of_the_golden_monkey": {
        slug: "legend_of_the_golden_monkey",
        name: "Legend of the Golden Monkey",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/lightning_joker": {
        slug: "lightning_joker",
        name: "Lightning Joker",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/lucha_maniacs": {
        slug: "lucha_maniacs",
        name: "Lucha Maniacs",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/lucky_apocalypse_gigablox": {
        slug: "lucky_apocalypse_gigablox",
        name: "Lucky Apocalypse Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/lucky_neko": {
        slug: "lucky_neko",
        name: "Lucky Neko",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/lucky_ryan_gigablox": {
        slug: "lucky_ryan_gigablox",
        name: "Lucky Ryan Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/max_elements_gigablox": {
        slug: "max_elements_gigablox",
        name: "Max Elements Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/mexomax_multimax": {
        slug: "mexomax_multimax",
        name: "MexoMax! Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/monkeys_go_bananas": {
        slug: "monkeys_go_bananas",
        name: "Monkeys Go Bananas",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/multifly": {
        slug: "multifly",
        name: "Multifly",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/multifly_2_multimax": {
        slug: "multifly_2_multimax",
        name: "Multifly! 2 Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/neon_rush_splitz": {
        slug: "neon_rush_splitz",
        name: "Neon Rush Splitz",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/neon_villains_doublemax": {
        slug: "neon_villains_doublemax",
        name: "Neon Villains Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/nice_catch_2": {
        slug: "nice_catch_2",
        name: "Nice Catch 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/nice_catch_doublemax": {
        slug: "nice_catch_doublemax",
        name: "Nice Catch Doublemax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/nirvana": {
        slug: "nirvana",
        name: "Nirvana",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/notredame_tales_gigablox": {
        slug: "notredame_tales_gigablox",
        name: "NotreDame Tales GigaBlox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/of_sabers_and_monsters_wildfight": {
        slug: "of_sabers_and_monsters_wildfight",
        name: "Of Sabers and Monsters WildFight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/orient_express": {
        slug: "orient_express",
        name: "Orient Express",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/ozwins_jackpots": {
        slug: "ozwins_jackpots",
        name: "Ozwins Jackpots",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/penguin_city": {
        slug: "penguin_city",
        name: "Penguin City",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/pirates_2_mutiny": {
        slug: "pirates_2_mutiny",
        name: "Pirates 2: Mutiny",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/pirates_smugglers_paradise": {
        slug: "pirates_smugglers_paradise",
        name: "Pirates: Smugglers Paradise",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/pumpkin_smash": {
        slug: "pumpkin_smash",
        name: "Pumpkin Smash",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/pushy_cats": {
        slug: "pushy_cats",
        name: "Pushy Cats",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/ragnaravens_wildenergy": {
        slug: "ragnaravens_wildenergy",
        name: "RagnaRavens WildEnergy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/ragnawolves_wildenergy": {
        slug: "ragnawolves_wildenergy",
        name: "Ragnawolves WildEnergy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/rainbow_ryan": {
        slug: "rainbow_ryan",
        name: "Rainbow Ryan",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/rainbow_ryan_2": {
        slug: "rainbow_ryan_2",
        name: "Rainbow Ryan 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/raptor_2": {
        slug: "raptor_2",
        name: "Raptor 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/raptor_doublemax": {
        slug: "raptor_doublemax",
        name: "Raptor DoubleMax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/reel_desire": {
        slug: "reel_desire",
        name: "Reel Desire",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/rise_of_the_valkyrie": {
        slug: "rise_of_the_valkyrie",
        name: "Rise Of The Valkyrie",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/rock_star_santa_multimax": {
        slug: "rock_star_santa_multimax",
        name: "Rock Star Santa Multimax",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/sahara_nights": {
        slug: "sahara_nights",
        name: "Sahara Nights",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/seasons": {
        slug: "seasons",
        name: "Seasons",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/spina_colada": {
        slug: "spina_colada",
        name: "Spina Colada",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/starfire_fortunes_tophit": {
        slug: "starfire_fortunes_tophit",
        name: "Starfire Fortunes TopHit",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/suncatcher_gigablox": {
        slug: "suncatcher_gigablox",
        name: "Suncatcher Gigablox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/sunny_shores": {
        slug: "sunny_shores",
        name: "Sunny Shores",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/syncronite": {
        slug: "syncronite",
        name: "Syncronite",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/temple_stacks_splitz": {
        slug: "temple_stacks_splitz",
        name: "Temple Stacks: Splitz",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/the_one_armed_bandit": {
        slug: "the_one_armed_bandit",
        name: "The One Armed Bandit",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/the_royal_family": {
        slug: "the_royal_family",
        name: "The Royal Family",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/thunder_of_thor": {
        slug: "thunder_of_thor",
        name: "Thunder of Thor",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/timber_trail_treasures": {
        slug: "timber_trail_treasures",
        name: "Timber Trail Treasures",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/time_travel_tigers": {
        slug: "time_travel_tigers",
        name: "Time Travel Tigers",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/trickstar_spins": {
        slug: "trickstar_spins",
        name: "Trickstar Spins",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/trolls_bridge": {
        slug: "trolls_bridge",
        name: "Trolls Bridge",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/turbo_gold_deluxe_gigablox": {
        slug: "turbo_gold_deluxe_gigablox",
        name: "Turbo Gold Deluxe GigaBlox",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/tutstwister": {
        slug: "tutstwister",
        name: "TutsTwister",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/valley_of_the_dead_only_wins_boltlock": {
        slug: "valley_of_the_dead_only_wins_boltlock",
        name: "Valley of the Dead Only Wins BoltLock",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/valley_of_the_gods": {
        slug: "valley_of_the_gods",
        name: "Valley of the Gods",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/valley_of_the_gods_2": {
        slug: "valley_of_the_gods_2",
        name: "Valley of the Gods 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vampire_riches": {
        slug: "vampire_riches",
        name: "Vampire Riches",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vault_of_fortune": {
        slug: "vault_of_fortune",
        name: "Vault of Fortune",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_berzerk": {
        slug: "vikings_go_berzerk",
        name: "Vikings go Berzerk",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_berzerk_reloaded": {
        slug: "vikings_go_berzerk_reloaded",
        name: "Vikings go Berzerk: Reloaded",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_to_egypt_wild_fight": {
        slug: "vikings_go_to_egypt_wild_fight",
        name: "Vikings go to Egypt Wild Fight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_to_hell": {
        slug: "vikings_go_to_hell",
        name: "Vikings go to Hell",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_to_hollywood_wild_fight_rushing_wilds": {
        slug: "vikings_go_to_hollywood_wild_fight_rushing_wilds",
        name: "Vikings Go To Hollywood Wild Fight Rushing Wilds",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_to_valhalla": {
        slug: "vikings_go_to_valhalla",
        name: "Vikings go to Valhalla",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_to_vegas_wild_fight": {
        slug: "vikings_go_to_vegas_wild_fight",
        name: "Vikings go to Vegas Wild Fight",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/vikings_go_wild": {
        slug: "vikings_go_wild",
        name: "Vikings go Wild",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/wild_robo_factory": {
        slug: "wild_robo_factory",
        name: "Wild Robo Factory",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/wild_stack_frenzy": {
        slug: "wild_stack_frenzy",
        name: "Wild Stack Frenzy",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/wilhelm_tell": {
        slug: "wilhelm_tell",
        name: "Wilhelm Tell",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/winterberries": {
        slug: "winterberries",
        name: "Winterberries",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/winterberries_2": {
        slug: "winterberries_2",
        name: "Winterberries 2",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/wolf_hunters": {
        slug: "wolf_hunters",
        name: "Wolf Hunters",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/yokozuna_clash": {
        slug: "yokozuna_clash",
        name: "Yokozuna Clash",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
    "yggdrasil-gaming/your_own_island": {
        slug: "your_own_island",
        name: "Your Own Island",
        provider: "Yggdrasil Gaming",
        providerSlug: "yggdrasil-gaming"
    },
};
